(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4547],{

/***/ 71623:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-left.6e32dfa9.svg","height":17,"width":10});

/***/ }),

/***/ 29157:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-right.bd9ef851.svg","height":17,"width":10});

/***/ }),

/***/ 12522:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/back-top-arrow.62e44c63.svg","height":20,"width":12});

/***/ }),

/***/ 27644:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/cart-icon-empty.02db72e9.svg","height":20,"width":26});

/***/ }),

/***/ 8327:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-filter.e8101cbe.svg","height":17,"width":17});

/***/ }),

/***/ 80779:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/down-arrow.058783e1.svg","height":9,"width":16});

/***/ }),

/***/ 91883:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/download-dark-gray.44fffa51.svg","height":16,"width":14});

/***/ }),

/***/ 24495:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/filter.df2e3489.svg","height":14,"width":21});

/***/ }),

/***/ 8909:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/grid-off.7efb787f.svg","height":17,"width":17});

/***/ }),

/***/ 7520:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/grid-on.72b9c8b7.svg","height":17,"width":17});

/***/ }),

/***/ 30402:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/print.9f8da7b0.svg","height":17,"width":17});

/***/ }),

/***/ 66773:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/share.c1bcda3a.svg","height":17,"width":14});

/***/ }),

/***/ 29875:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wish.b0a7483e.svg","height":14,"width":15});

/***/ }),

/***/ 62084:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wishlist-gray-filled.091dca10.svg","height":20,"width":23});

/***/ }),

/***/ 3939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AemGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/Shared/ContainerComponent.jsx




const ContainerComponent = (param)=>{
    let { children , extraProps , item , count  } = param;
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const timeOut = setTimeout(()=>{
            var ref;
            var ref1;
            const hashValue = (ref1 = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("#")[1]) !== null && ref1 !== void 0 ? ref1 : "";
            if (hashValue) {
                var ref2;
                var ref3;
                const element = (ref3 = document.querySelector("[id='".concat(hashValue, "']"))) !== null && ref3 !== void 0 ? ref3 : {};
                var ref4;
                const offsetTop = (ref4 = element === null || element === void 0 ? void 0 : (ref2 = element.parentNode) === null || ref2 === void 0 ? void 0 : ref2.offsetTop) !== null && ref4 !== void 0 ? ref4 : 0;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        }, 1000);
        return ()=>{
            clearTimeout(timeOut);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-container".concat((extraProps === null || extraProps === void 0 ? void 0 : extraProps.fragment) === constants.FRAGMENT_TYPES.HEADER && (extraProps === null || extraProps === void 0 ? void 0 : extraProps.hasGlobalNavigation) && count === 0 ? " desk-header-height" : ""),
        id: item === null || item === void 0 ? void 0 : item.containerId,
        children: children
    });
};
/* harmony default export */ var Shared_ContainerComponent = (ContainerComponent);

;// CONCATENATED MODULE: ./src/components/AemGridColumn.jsx







const AemGridColumn = (props)=>{
    const { data , itemKey , count , eventHandler , containerId , ...extraProps } = props;
    const Element = modules/* default.Element */.ZP.Element;
    const scrollElementCondition = (item, key)=>{
        return (data === null || data === void 0 ? void 0 : data.columnClassNames) && (data === null || data === void 0 ? void 0 : data.columnClassNames[key]) && !(0,utils/* isTeaser */.j$)(item) && !(0,utils/* isBreadcrumb */.Z3)(item) && !(0,utils/* isCarousel */.C2)(item) && !(0,utils/* isAemForm */.np)(item) && !(0,utils/* isProductAccordion */.eq)(item) && !(0,utils/* isVideo */.Wv)(item) && !(0,utils/* isImage */.Or)(item) && !(0,utils/* isInPageSearch */.L8)(item) && !(0,utils/* isText */.Gs)(item) && !(0,utils/* isShopTheRoomCard */.ck)(item) && !(0,utils/* isProductcardV3 */.DN)(item);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: scrollElementCondition(item, key),
                    wrapper: (children)=>{
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Element, {
                            className: "".concat((0,utils/* isImageV3 */.EE)(item) ? "image-v3 image" : "").concat((0,utils/* isContainer */.Nm)(item) ? constants.staticClasses.CONTAINER : "").concat((item === null || item === void 0 ? void 0 : item.appliedCssClassNames) && ((0,utils/* isContainer */.Nm)(item) || (0,utils/* isTab */.wR)(item)) ? " ".concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNames) : "").concat((item === null || item === void 0 ? void 0 : item.appliedCssClassNamesCustom) ? " ".concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNamesCustom) : "").concat((0,utils/* isSlick */.bd)(item) ? "carousel-slick carousel ".concat((ref = item["carouselComponentProperties"]) === null || ref === void 0 ? void 0 : ref.appliedCssClassNames, " ") : "").concat((data === null || data === void 0 ? void 0 : data.columnClassNames[key]) ? !(0,utils/* isSlick */.bd)(item) ? " ".concat(data === null || data === void 0 ? void 0 : data.columnClassNames[key], " ") : "" : "").concat((0,utils/* isSpacer */.MW)(item) ? "spacer separator" : "", " ").concat((0,utils/* isTab */.wR)(item) ? "tabs" : "").concat((0,utils/* isList */.nq)(item) ? "list" : ""),
                            children: children
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                        condition: (0,utils/* isContainer */.Nm)(item) && key !== constants.COMPONENT_TYPES.ROOT_CONTAINER,
                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_ContainerComponent, {
                                item: item,
                                extraProps: extraProps,
                                count: count,
                                children: children
                            }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                            fullData: data[":items"] && data[":items"],
                            data: item,
                            itemKey: key ? key : itemKey,
                            count: count + 1,
                            containerId: (item === null || item === void 0 ? void 0 : item.containerId) || containerId,
                            eventHandler: eventHandler,
                            ...extraProps
                        })
                    })
                })
            }, item.id ? item.id : index);
        })
    });
};
/* harmony default export */ var components_AemGridColumn = (AemGridColumn);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
;// CONCATENATED MODULE: ./src/components/Shared/BrandSwitcher/analytics.js

const addDataLayerOnClick = function() {
    let datalayerPageName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", item = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const eventInfo = {
        clickInternalLinks: "".concat(item.linkToNewTab ? "false" : "true"),
        internalLinkPosition: "global header",
        internalLinkZoneName: "".concat(datalayerPageName).concat(datalayerPageName ? ":" : "", "global header"),
        internalLinkURL: "".concat((ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", "")),
        internalLinkName: "brand sync:".concat(item.brandName.toLowerCase()),
        eventName: "brand sync",
        internalLinkType: "global header:navigation",
        eventType: "click",
        eventAction: "brand sync"
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
};

;// CONCATENATED MODULE: ./src/components/Shared/BrandSwitcher/index.jsx



const BrandSwitcher = (props)=>{
    const { data , datalayerPageName  } = props;
    const handleOnClick = (e, item)=>{
        var ref;
        addDataLayerOnClick(datalayerPageName, item);
        window.open((ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""), "".concat((0,helper/* convertStringToBoolean */.mUs)(item.linkToNewTab) ? "_blank" : "_self"), item.linkRef ? "noreferrer" : "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "brand-switcher ".concat(datalayerPageName === "checkout" ? "checkout-brand" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-nav-panel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "gbh-nav navbar navbar-xpand-sm navbar-dark justify-content-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "gbh-nav__list navbar-nav",
                    children: data.items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "gbh-nav__item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "gbh-data-layer gbh-nav--link ".concat(item.highlight && item.highlight === "true" ? "gbh-nav__link--active" : ""),
                                "aria-label": "".concat(item.brandName, ". Go to ").concat(item.brandName, "'s Home Page"),
                                onClick: (e)=>handleOnClick(e, item),
                                children: item.brandName
                            })
                        }, "brand-".concat(index)))
                })
            })
        })
    });
};
/* harmony default export */ var Shared_BrandSwitcher = (BrandSwitcher);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/utils/location.js
var utils_location = __webpack_require__(78800);
// EXTERNAL MODULE: ./src/store/features/locationSlice.js
var locationSlice = __webpack_require__(13644);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
;// CONCATENATED MODULE: ./public/icons/left-arrow-white.svg
/* harmony default export */ var left_arrow_white = ({"src":"/_next/static/media/left-arrow-white.9ff895f4.svg","height":17,"width":10});
// EXTERNAL MODULE: ./src/components/FindStoreUtilNav/v1/index.module.scss
var index_module = __webpack_require__(43457);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/core/Modal/ZipCodeInfoModal.jsx
var ZipCodeInfoModal = __webpack_require__(4801);
// EXTERNAL MODULE: ./components/core/AutoSuggestion/v1/AutoSuggestion.jsx
var AutoSuggestion = __webpack_require__(36130);
// EXTERNAL MODULE: ./src/components/FindStoreUtilNav/analytics.js
var analytics = __webpack_require__(38224);
// EXTERNAL MODULE: ./src/components/FindStore/v1/api.js
var api = __webpack_require__(75058);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
;// CONCATENATED MODULE: ./components/FindStoreUtilNav/v1/FindStoreUtilNav.view.jsx























const configInitialState = {
    browseAllStoreUrl: "",
    brand: "",
    findStores: ""
};
const FindStoreUtilNavView = (props)=>{
    var ref;
    const { findAStoreActive  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const [zipCodeValue, setZipcodeValue] = (0,react.useState)("");
    const [isSubmit, setIsSubmit] = (0,react.useState)(false);
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [configState, setConfigState] = (0,react.useState)(configInitialState);
    const [browseAllStoreUrl, setbrowseAllStoreUrl] = (0,react.useState)("");
    const [myStoreUrl, setMyStoreUrl] = (0,react.useState)("/");
    const [optionList, setOptionList] = (0,react.useState)([]);
    const [allowSubmitOnEnter, setAllowSubmitOnEnter] = (0,react.useState)(true);
    const { utilityStoreDetails , utilityData , nearestUtilityData , myStoreId , eventHandler: { callbacks: { toggleFindAStore =()=>{} , closeMenu =()=>{}  }  }  } = props;
    const [infoModalErrror, setInfoModalErrror] = (0,react.useState)({});
    const [infoModal, setInfoModal] = (0,react.useState)();
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const { general  } = config;
            var _allStoresPagePath;
            const url = await (0,utils_location/* getShortenedUrl */.Pp)((_allStoresPagePath = general.allStoresPagePath) !== null && _allStoresPagePath !== void 0 ? _allStoresPagePath : "/");
            const findStores = get_default()(config, "apiEndPointData.findStores", "");
            const brand = get_default()(config, "general.siteName", "");
            setConfigState({
                browseAllStoreUrl: url,
                findStores,
                brand
            });
            localStorage.getItem("currentZipCode") && setZipcodeValue(localStorage.getItem("currentZipCode"));
            setbrowseAllStoreUrl(url);
        }).catch((err)=>console.log(err));
        props.getUtilityGeolocation();
    }, []);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
        if (isSubmit === true) {
            props.redirect(zipCodeValue);
        }
    }, [
        isSubmit
    ]);
    (0,react.useEffect)(()=>{
        if (zipCodeValue.length > 2) {
            fetchListOfCities();
        }
    }, [
        zipCodeValue
    ]);
    (0,react.useEffect)(()=>{
        if (myStoreId === "0") {
            nearestStoreAddress();
        } else {
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        }
    }, [
        zipCodeValue,
        myStoreId,
        configState
    ]);
    const nearestStoreAddress = async ()=>{
        const { findStores , brand  } = configState;
        if (findStores && brand) {
            const nearestStore = await (0,api/* getFindAStoresResult */.R)(findStores, zipCodeValue, brand, 100, 1, "kohler store", 1);
            let utilityData = {};
            if (nearestStore !== undefined) {
                var ref;
                var ref1;
                const nearestStoreData = (ref1 = nearestStore === null || nearestStore === void 0 ? void 0 : (ref = nearestStore.data) === null || ref === void 0 ? void 0 : ref.info[0]) !== null && ref1 !== void 0 ? ref1 : {};
                var ref2;
                utilityData = {
                    ...nearestStoreData,
                    EntityID: (ref2 = nearestStoreData === null || nearestStoreData === void 0 ? void 0 : nearestStoreData.BPnumber) !== null && ref2 !== void 0 ? ref2 : null
                };
            }
            dispatch((0,locationSlice/* setNearestStoreAddress */.rM)(utilityData));
        }
    };
    const fetchListOfCities = async ()=>{
        const { findStores , brand  } = configState;
        const responseData = await (0,helper/* getCityList */.vzx)(findStores, brand, zipCodeValue);
        const { data: { d: { results =[]  } = {}  } = {}  } = responseData;
        const cities = results.map((city)=>city.Locality);
        setOptionList([
            ...new Set(cities)
        ]);
    };
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(utilityStoreDetails) && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber)) {
            (0,utils_location/* getShortenedUrl */.Pp)(utilityStoreDetails[utilityData.BPnumber]).then((myStoreUrl)=>{
                setMyStoreUrl(myStoreUrl);
            });
        }
    }, [
        utilityStoreDetails,
        utilityData
    ]);
    const handleChange = (value)=>{
        setZipcodeValue(value);
    };
    const getGeoLocation = ()=>{
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            var _zipcode;
            setZipcodeValue((_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "");
            (0,analytics/* headerFindStoreUseLocationAnalytics */.P)({
                eventStatus: "success"
            });
        }).catch((param)=>{
            let { cause  } = param;
            setInfoModalErrror(cause !== null && cause !== void 0 ? cause : {});
            setInfoModal(true);
            var ref;
            (0,analytics/* headerFindStoreUseLocationAnalytics */.P)({
                errorMessage: (ref = cause === null || cause === void 0 ? void 0 : cause.message) !== null && ref !== void 0 ? ref : "",
                staticTexts,
                eventStatus: "failure"
            });
        });
    };
    const onSubmit = async ()=>{
        let valid = true;
        const zipCodeErrObj = {
            show: false,
            message: ""
        };
        const { staticTexts: { validZipcode  }  } = props;
        const isValid = await (0,utils_location/* validateField */.OP)("zipCodeNumeric", zipCodeValue);
        if (isValid && zipCodeValue.length < 5) {
            dispatch((0,locationSlice/* setUtilityLocation */.NL)({
                utilityLocation: zipCodeValue
            }));
            zipCodeErrObj.show = true;
            zipCodeErrObj.message = validZipcode;
            valid = false;
        }
        if (valid) {
            setIsSubmit(true);
            toggleFindAStore();
            closeMenu();
        }
        if (findAStoreActive) {
            dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
        }
        setZipCodeError({
            ...zipCodeErrObj
        });
        (0,analytics/* addFindStoreAnalytics */.c)(zipCodeValue, zipCodeErrObj);
    };
    const getStoreAnalytics = (action)=>{
        var ref;
        const href = utilityStoreDetails && utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] ? utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] : "/";
        const internalLinkName = action === "unset as my store" ? "unset as preferred store" : "store details";
        return JSON.stringify({
            eventAction: "find a store:utility nav​:" + action,
            eventName: "find a store:utility nav​:" + action,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:" + ((ref = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName) + ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine) + (!isEmpty_default()(utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) : "") + ", " + (0,helper/* formatPhoneNumber */.unW)(utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone)) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL: action === "view store details" ? href.indexOf("http") === -1 ? window.location.origin + href : href : "n/a",
            clickInternalLinks: "true"
        });
    };
    const viewStoreAnalytics = getStoreAnalytics("view store details");
    const unsetMyStoreAnalytics = getStoreAnalytics("unset as my store");
    const { staticTexts  } = props;
    const locationName = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName : nearestUtilityData === null || nearestUtilityData === void 0 ? void 0 : nearestUtilityData.LocationName;
    const openUntil = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.OpenUntil) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.OpenUntil : nearestUtilityData === null || nearestUtilityData === void 0 ? void 0 : nearestUtilityData.OpenUntil;
    const addressLine = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine : nearestUtilityData === null || nearestUtilityData === void 0 ? void 0 : nearestUtilityData.AddressLine;
    const addressLine2 = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2 : nearestUtilityData === null || nearestUtilityData === void 0 ? void 0 : nearestUtilityData.AddressLine2;
    const locality = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.Locality) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.Locality : nearestUtilityData === null || nearestUtilityData === void 0 ? void 0 : nearestUtilityData.Locality;
    const adminDistrict = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AdminDistrict) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.AdminDistrict : nearestUtilityData === null || nearestUtilityData === void 0 ? void 0 : nearestUtilityData.AdminDistrict;
    const postalCode = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.PostalCode) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.PostalCode : nearestUtilityData === null || nearestUtilityData === void 0 ? void 0 : nearestUtilityData.PostalCode;
    const phone = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone : nearestUtilityData === null || nearestUtilityData === void 0 ? void 0 : nearestUtilityData.Phone;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).findAStoreUtilNavWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-find-a-store ".concat(props.active ? "active" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "findstore-util-nav".concat(isSubmit ? "__activeMap" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                        handleModalClose: ()=>{
                            setInfoModal(false);
                        },
                        show: infoModal,
                        data: infoModalErrror,
                        labelledBy: "Geo-Location-error-message",
                        className: "message-modal",
                        staticTexts: staticTexts,
                        dataLayerPosition: "global header"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "findstore-util-nav__container findstore-util-nav__show-container",
                            children: [
                                lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "findstore-util-nav__mobile-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            role: "button",
                                            tabIndex: "0",
                                            src: close_white/* default.src */.Z.src,
                                            alt: staticTexts.close,
                                            className: "findstore-util-nav__close",
                                            onClick: ()=>{
                                                toggleFindAStore(), closeMenu();
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "findstore-util-nav__menu",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: left_arrow_white.src,
                                                    alt: staticTexts.leftArrow
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    role: "button",
                                                    onClick: ()=>toggleFindAStore(),
                                                    children: staticTexts.menu
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "findstore-util-nav__content ".concat(!isEmpty_default()(utilityData) && "findstore-util-nav__content-text"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "container kf-react-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row ml-0 mr-0",
                                            children: [
                                                !isEmpty_default()(utilityData) && !isEmpty_default()(utilityData.EntityID) || !isEmpty_default()(nearestUtilityData) && !isEmpty_default()(nearestUtilityData.EntityID) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-lg-7 findstore-util-nav__access-utility-container",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "col-12 col-lg-7 findstore-util-nav__supply-section",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__store",
                                                                        children: myStoreId !== "0" ? staticTexts.myStoreText : staticTexts.closestStore
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__signStore",
                                                                        children: locationName
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "col-12 col-lg-5 findstore-util-nav__address-container",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: openUntil
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: addressLine
                                                                            }),
                                                                            !isEmpty_default()(addressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: addressLine2
                                                                            }) : "",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: locality + ", " + adminDistrict + " " + postalCode
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: (0,helper/* formatPhoneNumber */.unW)(phone)
                                                                    }),
                                                                    myStoreUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: myStoreUrl,
                                                                        className: "findstore-util-nav__view-store-detail gbh-data-layer",
                                                                        "data-gbh-data-layer": viewStoreAnalytics,
                                                                        onClick: ()=>{
                                                                            lib/* isMobile */.tq ? closeMenu() : "";
                                                                        },
                                                                        children: lib/* isMobile */.tq ? staticTexts.storeDetail : staticTexts.viewStoreDetail
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                        analyticsData: unsetMyStoreAnalytics,
                                                                        checked: myStoreId === utilityData.EntityID ? true : false,
                                                                        value: myStoreId === utilityData.EntityID ? staticTexts.myStore : staticTexts.setAsMyStore,
                                                                        id: "findstore-util-nav__my-store",
                                                                        onChange: (e)=>props.handleUtilityStoreCheck(e.target.checked ? utilityData.EntityID : 0)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12 col-lg-6 findstore-util-nav__search-utility-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__location-content",
                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(staticTexts.locationDescription)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__zipcode-content",
                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(staticTexts.zipCodeContent)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12 findstore-util-nav__loc-search-container ".concat(!isEmpty_default()(utilityData) || !isEmpty_default()(nearestUtilityData) ? "col-lg-5" : "col-lg-6"),
                                                    children: [
                                                        (!isEmpty_default()(utilityData) || !isEmpty_default()(nearestUtilityData)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "findstore-util-nav__not-your-store",
                                                            children: staticTexts.NotYourStore + "?"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classnames_default()({
                                                                "findstore-util-nav__input-container": true,
                                                                "findstore-util-nav__input-container-text": !isEmpty_default()(utilityData) || !isEmpty_default()(nearestUtilityData),
                                                                "findstore-util-nav__input-disabled-state": !zipCodeValue
                                                            }),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion/* default */.Z, {
                                                                    placeholderLabel: staticTexts.enterCityStateZip,
                                                                    selectedValue: zipCodeValue,
                                                                    handleChange: (selectedVal)=>handleChange(selectedVal),
                                                                    handleSelect: (selectedVal)=>handleChange(selectedVal),
                                                                    optionList: optionList,
                                                                    borderValue: "bottom",
                                                                    allowSubmitOnEnter: allowSubmitOnEnter,
                                                                    onEnterKeyPress: ()=>onSubmit()
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: "findstore-util-nav__submit",
                                                                    onClick: ()=>onSubmit(),
                                                                    disabled: zipCodeValue.length < 3,
                                                                    "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.ariaLabel) === null || ref === void 0 ? void 0 : ref.submit,
                                                                    children: staticTexts.submit
                                                                })
                                                            ]
                                                        }),
                                                        zipCodeError.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__zipcode-error",
                                                            children: zipCodeError.message
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "findstore-util-nav__link-container ".concat((!isEmpty_default()(utilityData) || !isEmpty_default()(nearestUtilityData)) && "findstore-util-nav__link-container-text"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "findstore-util-nav__location-link-container",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__location-link",
                                                                        "aria-label": staticTexts.useLocation,
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        onClick: getGeoLocation,
                                                                        children: staticTexts.useLocation
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "findstore-util-nav__view-link-container",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        label: staticTexts.viewAllStore,
                                                                        size: "large",
                                                                        type: "ghost",
                                                                        role: "link",
                                                                        tag: "anchor",
                                                                        target: staticTexts.isNewTab && "_blank",
                                                                        rel: staticTexts.isNewTab ? "noopener" : "",
                                                                        "aria-label": staticTexts.viewAllStore,
                                                                        className: "findstore-util-nav__view-store-link ".concat(lib/* isMobile */.tq ? "view-all-stores-mobile" : "", " gbh-data-layer"),
                                                                        useDefaultClass: true,
                                                                        "data-gbh-data-layer": '{"eventAction":"find a store:utility nav:view all stores","eventName":"find a store:utility nav:view all stores","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view all stores","internalLinkPosition":"find a store","internalLinkType":"find a store:navigation","internalLinkZoneName":"find a store:utility nav","internalLinkURL":"'.concat(browseAllStoreUrl, '","clickInternalLinks":"true"}'),
                                                                        to: browseAllStoreUrl
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
FindStoreUtilNavView.defaultProps = {
    staticTexts: {}
};
FindStoreUtilNavView.propTypes = {
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var FindStoreUtilNav_view = (FindStoreUtilNavView);

// EXTERNAL MODULE: ./src/components/FindStoreUtilNav/v1/localization.js
var localization = __webpack_require__(50288);
;// CONCATENATED MODULE: ./components/FindStoreUtilNav/v1/FindStoreUtilNav.jsx













const FindStoreUtilNav = (param)=>{
    let { show , active , eventHandler  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { utilityStoreDetails , nearestUtilityData , utilityData , userCity , myStoreId  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    var ref;
    const initialState = {
        userCity: "",
        utilityLocation: "",
        utilityData: {},
        utilityStoreDetails: {},
        findStores: "",
        reverseGeo: "",
        myStoreId: (ref = localStorage.getItem("myStoreId")) !== null && ref !== void 0 ? ref : 0,
        siteName: "",
        findStoreUrl: "",
        utilityStoreDetailsUrl: ""
    };
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const router = (0,next_router.useRouter)();
    const [staticTexts, setStaticTexts] = (0,react.useState)({});
    const [state, setState] = (0,react.useState)(initialState);
    (0,react.useEffect)(()=>{
        setStaticTexts((0,localization/* getTranslations */.F)(t));
        setInitalState();
    }, []);
    (0,react.useEffect)(()=>{
        if (state.myStoreId !== 0) getUtilityDataById();
        else if (state.userCity !== "") getUtilityDataByDistance();
    }, [
        state.utilityLocation,
        state.userCity
    ]);
    (0,react.useEffect)(()=>{
        setState((prevState)=>{
            if (prevState.myStoreId !== myStoreId) {
                localStorage.setItem("myStoreId", myStoreId);
                return {
                    ...prevState,
                    utilityStoreId: myStoreId
                };
            } else return prevState;
        });
        getUtilityDataById();
    }, [
        state.myStoreId,
        myStoreId
    ]);
    (0,react.useEffect)(()=>{
        if (state.utilityStoreDetailsUrl != "") setUtilityStoreDetailsUrl();
    }, [
        state.utilityStoreDetailsUrl
    ]);
    const setInitalState = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        getFindStoreUrl(config).then((url)=>{
            setState({
                ...state,
                findStores: get_default()(config, "apiEndPointData.findStores", ""),
                reverseGeo: get_default()(config, "apiEndPointData.reverseGeo", ""),
                siteName: get_default()(config, "general.siteName", ""),
                utilityStoreDetailsUrl: get_default()(config, "general.storeDetailsServletPath"),
                findStoreUrl: url
            });
        });
    };
    const getFindStoreUrl = async (config)=>{
        const findStoreUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.findStorePagePath", ""));
        return findStoreUrl;
    };
    const setUtilityStoreDetailsUrl = async ()=>{
        const utilityStoreDetails = await (0,utils_location/* getUtilityStoreDetails */.BO)(state);
        dispatch((0,locationSlice/* setUtilityStoreDetails */.Hm)(utilityStoreDetails));
        setState({
            ...state,
            utilityStoreDetails
        });
    };
    const getUtilityDataByDistance = async ()=>{
        const utilityData = await (0,utils_location/* getStoreDataByDistance */.zO)(state);
        dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        setState({
            ...state,
            utilityData
        });
    };
    const getUtilityDataById = async ()=>{
        var ref;
        const utilityData = await (0,utils_location/* getStoreDataById */.e)({
            ...state,
            myStoreId: (ref = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("myStoreId")) !== null && ref !== void 0 ? ref : 0
        });
        dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        setState({
            ...state,
            utilityData
        });
    };
    const getUtilityGeolocation = function() {
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            var _zipcode, _city;
            const details = {
                utilityLocation: (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "",
                userCity: (_city = getLocation.city) !== null && _city !== void 0 ? _city : ""
            };
            dispatch((0,locationSlice/* setCityLocation */.OX)(details));
            setState({
                ...state,
                ...details
            });
        }).catch((err)=>{
            (0,helper/* getMyLocationByUserIP */.SAL)().then((getLocation)=>{
                var _zipcode, _city;
                const details = {
                    utilityLocation: (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "",
                    userCity: (_city = getLocation.city) !== null && _city !== void 0 ? _city : ""
                };
                dispatch((0,locationSlice/* setCityLocation */.OX)(details));
                setState({
                    ...state,
                    ...details
                });
            }).catch((error)=>{
                console.log(error);
            });
        });
    };
    const handleUtilityStoreCheck = (entity)=>{
        localStorage.setItem("myStoreId", entity);
        dispatch((0,locationSlice/* setMyStore */.h9)(entity));
        setState({
            ...state,
            myStoreId: entity
        });
    };
    const redirect = (zipCodeValue)=>{
        var ref;
        window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.assign("".concat(window.location.origin + findStoreUrl + "?q=" + zipCodeValue));
    };
    const { findStoreUrl  } = state;
    if (!show) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindStoreUtilNav_view, {
        staticTexts: staticTexts,
        getUtilityGeolocation: getUtilityGeolocation,
        redirect: (zipCodeValue)=>redirect(zipCodeValue),
        redirectUrl: (0,utils_location/* getShortenedUrl */.Pp)(findStoreUrl),
        handleUtilityStoreCheck: (entity)=>handleUtilityStoreCheck(entity),
        active: active,
        utilityStoreDetails: utilityStoreDetails,
        utilityData: utilityData,
        nearestUtilityData: nearestUtilityData,
        userCity: userCity,
        myStoreId: myStoreId === 0 ? initialState.myStoreId : myStoreId,
        eventHandler: eventHandler
    });
};
/* harmony default export */ var v1_FindStoreUtilNav = (FindStoreUtilNav);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
;// CONCATENATED MODULE: ./src/hooks/useWindowDimensions.js



/**
 *
 * @return {{width, height}}
 */ const useWindowDimensions_useWindowDimensions = ()=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [windowDimensions, setWindowDimensions] = (0,react.useState)({
        winWidth: 0,
        winHeight: 0
    });
    (0,react.useEffect)(()=>{
        if (isSsr) {
            return;
        }
        const { innerWidth: width , innerHeight: height  } = window;
        /**
     * Set window dimensions on resize
     */ const handleResize = debounce_default()(()=>{
            setWindowDimensions({
                winWidth: width,
                winHeight: height
            });
        }, 300);
        if (!isSsr) {
            setWindowDimensions({
                winWidth: width,
                winHeight: height
            });
            window.addEventListener("resize", handleResize);
        }
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        isSsr
    ]);
    return windowDimensions;
};
/* harmony default export */ var hooks_useWindowDimensions = (useWindowDimensions_useWindowDimensions);

;// CONCATENATED MODULE: ./src/components/Default/AuthUtilityNav/v1/AuthUtilityNav.view/index.jsx








const MegaMenu = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8069).then(__webpack_require__.bind(__webpack_require__, 58069)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(58069)
            ]
    },
    suspense: true
});
const AuthUtilityNavView = (props)=>{
    const avatarIcon = "/icons/avatar.svg";
    const rightArrow = "/icons/right-white.svg";
    const { active , i18n , userMenuFragment , guestMenuFragment , isLoggedIn , logout , toggleAuthNav , setAuthNav , onAuthMenuClick  } = props;
    const { user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { winWidth  } = hooks_useWindowDimensions();
    const styleClass = classnames_default()({
        "auth-nav": true,
        "auth-nav--active": active
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    const onClickSignIn = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const onClickSignUp = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: 1
        }));
    };
    const showMenuNav = ()=>{
        toggleAuthNav();
    };
    const signInEventInfo = JSON.stringify({
        eventName: "sign in start",
        eventAction: "sign in start",
        internalLinkName: "sign in start",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "global header",
        internalLinkURL: "n/a",
        internalLinkPosition: "global header sign in start",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    const signedInEventInfo = JSON.stringify({
        eventName: "global header:your kohler account",
        eventAction: "global header:your kohler account",
        internalLinkName: "your kohler account",
        internalLinkType: "global header: welcome back to your kohler",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "navigation",
        internalLinkURL: "n/a",
        internalLinkPosition: "global header:my account",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styleClass,
        "aria-expanded": active,
        children: [
            winWidth <= 1200 ? isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    tabIndex: "0",
                    "aria-label": "".concat(i18n.hi, " ").concat((0,helper/* capitalizeFirstName */.MyB)(user === null || user === void 0 ? void 0 : user.firstName)),
                    role: "button",
                    className: "auth-nav__sign-in-mobile",
                    onClick: ()=>{
                        toggleAuthNav();
                        onAuthMenuClick(!active);
                        setAuthNav(!active);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            name: "avatarIcon",
                            src: avatarIcon,
                            alt: i18n.signIn,
                            className: "gbh-data-layer auth-nav__sign-in-avatar",
                            "data-gbh-data-layer": signInEventInfo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            name: "loggedInUser",
                            className: "auth-nav__user",
                            children: [
                                i18n.hi,
                                ", ",
                                (0,helper/* capitalizeFirstName */.MyB)(user === null || user === void 0 ? void 0 : user.firstName)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: rightArrow,
                            alt: i18n.rightArrowAlt,
                            className: "auth-nav__sign-in-right-arrow"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: "Loading...",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu, {
                    userMenuFragment: userMenuFragment,
                    guestMenuFragment: guestMenuFragment,
                    isLoggedIn: isLoggedIn,
                    i18n: i18n,
                    user: user,
                    logout: logout,
                    toggleAuthNav: toggleAuthNav,
                    active: active,
                    handleSignin: onClickSignIn,
                    handleCreateAccount: onClickSignUp
                })
            }) : isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                tabIndex: "0",
                role: "button",
                "aria-label": active ? "".concat(i18n.user, " ").concat(i18n.expanded) : "".concat(i18n.user, " ").concat(i18n.collapsed),
                name: "loggedInUser",
                className: "auth-nav__user gbh-data-layer",
                onClick: showMenuNav,
                "data-gbh-data-layer": signedInEventInfo,
                children: [
                    i18n.hi,
                    ", ",
                    (0,helper/* capitalizeFirstName */.MyB)(user === null || user === void 0 ? void 0 : user.firstName)
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                tabIndex: "0",
                role: "button",
                name: "avatarIcon",
                "aria-label": active ? "".concat(i18n.signIn, " ").concat(i18n.expanded) : "".concat(i18n.signIn, " ").concat(i18n.collapsed),
                src: avatarIcon,
                alt: i18n.signIn,
                onClick: showMenuNav,
                className: "gbh-data-layer",
                "data-gbh-data-layer": signInEventInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "auth-nav__menu ".concat(isLoggedIn ? "auth-nav__menu-expand" : "", " ").concat(active ? "auth-nav__menu-open" : ""),
                "aria-hidden": !active,
                children: active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: "Loading...",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu, {
                        userMenuFragment: userMenuFragment,
                        guestMenuFragment: guestMenuFragment,
                        isLoggedIn: isLoggedIn,
                        i18n: i18n,
                        user: user,
                        logout: logout,
                        toggleAuthNav: toggleAuthNav,
                        handleSignin: onClickSignIn,
                        handleCreateAccount: onClickSignUp,
                        onAuthMenuClick: onAuthMenuClick
                    })
                }) : null
            })
        ]
    });
};
AuthUtilityNavView.displayName = "AuthUtilityNavView";
/* harmony default export */ var AuthUtilityNav_view = (AuthUtilityNavView);

// EXTERNAL MODULE: ./src/i18n/useAuthUtilityNavi18n.js
var useAuthUtilityNavi18n = __webpack_require__(1056);
// EXTERNAL MODULE: ./src/components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.module.scss
var AuthUtilityNav_index_module = __webpack_require__(62156);
var AuthUtilityNav_index_module_default = /*#__PURE__*/__webpack_require__.n(AuthUtilityNav_index_module);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./src/components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.jsx










// import useOnClickOutside from "@/hooks/useOnClickOutside"

const AuthUtilityNav = (props)=>{
    const { show , active , toggleAuthNav , setAuthNav , onAuthMenuClick  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const authNavMenuRef = (0,react.useRef)(null);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { guestMenuFragment , userMenuFragment  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    // useOnClickOutside(authNavMenuRef, toggleAuthNav)
    (0,react.useEffect)(()=>{
        if (show || lib/* isMobile */.tq) {
            (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
                const userFragment = get_default()(CONFIG, "general.signInFragment", "");
                const guestFragment = get_default()(CONFIG, "general.signUpFragment", "");
                const guestMenuPayload = {
                    reload: false,
                    path: guestFragment,
                    fragmentName: "guestMenuFragment"
                };
                dispatch((0,genericSlice/* getAuthMenuFragment */.T8)(guestMenuPayload));
                const userMenuPayload = {
                    reload: false,
                    path: userFragment,
                    fragmentName: "userMenuFragment"
                };
                dispatch((0,genericSlice/* getAuthMenuFragment */.T8)(userMenuPayload));
            });
        }
    }, [
        show
    ]);
    const staticTexts = (0,useAuthUtilityNavi18n/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "listitem",
        className: "auth-widget auth-widget__menu ".concat((AuthUtilityNav_index_module_default()).authUtilityNavWrapper),
        ref: authNavMenuRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthUtilityNav_view, {
            show: show,
            active: active,
            toggleAuthNav: toggleAuthNav,
            i18n: staticTexts,
            userMenuFragment: userMenuFragment,
            guestMenuFragment: guestMenuFragment,
            isLoggedIn: isAuth,
            logout: ()=>dispatch((0,authSlice/* logout */.kS)()),
            setAuthNav: setAuthNav,
            onAuthMenuClick: onAuthMenuClick
        })
    });
};
/* harmony default export */ var v1_AuthUtilityNav = (AuthUtilityNav);

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./src/components/Default/CountryUtilNav/v1/CountryUtilNavLink.jsx


const CountryUtilNavLink_CountryUtilNavLink = (props)=>{
    const { languageLink , language , countryName , languageAbbreviation , isMobile , datalayerPageName  } = props;
    return /*#__PURE__*/ _jsx("a", {
        href: languageLink,
        "aria-label": "".concat(countryName, " ").concat(language),
        className: "gbh-data-layer lang ".concat(isMobile && "mobile"),
        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"languageselector","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat(languageLink, '","internalLinkName":"language select:').concat(isMobile ? language.toLowerCase() : languageAbbreviation.toLowerCase(), '","eventName":"language selector","internalLinkType":"homepage:navigation","eventType":"language selector","eventAction":"language selector"}'),
        rel: "noreferrer",
        children: isMobile ? language : languageAbbreviation
    });
};
/* harmony default export */ var v1_CountryUtilNavLink = ((/* unused pure expression or super */ null && (CountryUtilNavLink_CountryUtilNavLink)));

;// CONCATENATED MODULE: ./src/components/Default/CountryUtilNav/v1/CountryUtilNavLinks.jsx



const CountryUtilNavLinks_CountryUtilNavLinks = (props)=>{
    const { languageLink , language , countryName , languageAbbreviation , datalayerPageName  } = props;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("li", {
            children: [
                /*#__PURE__*/ _jsx(CountryUtilNavLink, {
                    languageLink: languageLink,
                    language: language,
                    countryName: countryName,
                    languageAbbreviation: languageAbbreviation,
                    isMobile: false,
                    datalayerPageName: datalayerPageName
                }),
                /*#__PURE__*/ _jsx(CountryUtilNavLink, {
                    languageLink: languageLink,
                    language: language,
                    countryName: countryName,
                    languageAbbreviation: languageAbbreviation,
                    isMobile: true,
                    datalayerPageName: datalayerPageName
                })
            ]
        })
    });
};
/* harmony default export */ var v1_CountryUtilNavLinks = ((/* unused pure expression or super */ null && (CountryUtilNavLinks_CountryUtilNavLinks)));

;// CONCATENATED MODULE: ./src/components/Default/CountryUtilNav/v1/CountryUtilContainer.jsx





const CountryUtilContainer_CountryUtilContainer = (props)=>{
    const { countryarea , activeTab , title , description , countryselectorItems , datalayerPageName  } = props;
    const { winWidth  } = useWindowDimensions();
    const [expanded, setExpanded] = useState([]);
    const handleExpand = (url, country)=>{
        if (!url) {
            if (expanded.includes(country)) {
                const exp = [
                    ...expanded
                ].filter((item)=>item !== country);
                setExpanded(exp);
            } else {
                const exp1 = [
                    ...expanded
                ];
                exp1.push(country);
                setExpanded(exp1);
            }
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        id: countryarea,
        className: "gbh-tab__content ".concat(activeTab === countryarea ? "gbh-tab__content--active" : "", " "),
        children: /*#__PURE__*/ _jsx("div", {
            className: "container",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-12 col-lg-4 left d-none d-lg-block",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                dangerouslySetInnerHTML: {
                                    __html: DOMPurify.sanitize(description)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-12 col-lg-8 right",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "col-lg-12 col-12 p-0",
                                children: /*#__PURE__*/ _jsx("ul", {
                                    className: "gbh-tab__list",
                                    role: "list",
                                    children: countryselectorItems && countryselectorItems.map(function(item, index) {
                                        var ref;
                                        if (!item.country) return null;
                                        return /*#__PURE__*/ _jsxs("li", {
                                            role: "listitem",
                                            className: "".concat(item.country).concat(winWidth <= 1200 && !item.countryLink ? " arrowdropdown" : ""),
                                            children: [
                                                /*#__PURE__*/ _jsxs("a", {
                                                    href: (ref = item.countryLink) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                    className: "gbh-data-layer gbh-tab__item--link",
                                                    role: "link",
                                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"n/a","internalLinkName":"country select:').concat(item.countryName.toLowerCase(), '","eventName":"country selector","internalLinkType":"homepage:navigation","eventType":"country selector","eventAction":"country selector"}'),
                                                    "aria-current": "page",
                                                    onClick: ()=>handleExpand(item.countryLink, item.country),
                                                    children: [
                                                        item.countryName,
                                                        " "
                                                    ]
                                                }),
                                                (item.languageOneAbbreviation || item.languageTwoAbbreviation || item.languageThreeAbbreviation) && /*#__PURE__*/ _jsxs("ul", {
                                                    style: expanded.includes(item.country) ? {
                                                        display: "block"
                                                    } : {},
                                                    children: [
                                                        item.languageOneAbbreviation && /*#__PURE__*/ _jsx(CountryUtilNavLinks, {
                                                            languageLink: item.languageOneLink,
                                                            language: item.languageOne,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageOneAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        }),
                                                        item.languageTwoAbbreviation && /*#__PURE__*/ _jsx(CountryUtilNavLinks, {
                                                            languageLink: item.languageTwoLink,
                                                            language: item.languageTwo,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageTwoAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        }),
                                                        item.languageThreeAbbreviation && /*#__PURE__*/ _jsx(CountryUtilNavLinks, {
                                                            languageLink: item.languageThreeLink,
                                                            language: item.languageThree,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageThreeAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "".concat(item.country, "+").concat(index));
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_CountryUtilContainer = ((/* unused pure expression or super */ null && (CountryUtilContainer_CountryUtilContainer)));

;// CONCATENATED MODULE: ./src/components/Default/CountryUtilNav/v1/CountryUtilNavTabLink.jsx


const CountryUtilNavTabLink_CountryUtilNavTabLink = (props)=>{
    const { activeTab , countryArea , onclickVal , countryAreaValue  } = props;
    return /*#__PURE__*/ _jsx("li", {
        onClick: ()=>{
            onclickVal(countryArea);
        },
        "data-tab": countryArea,
        role: "tab",
        tabIndex: "0",
        "data-region": "#".concat(countryArea),
        "aria-label": countryArea,
        className: "gbh-tabs__tab ".concat(activeTab === countryArea ? "gbh-tabs__tab--active" : ""),
        "data-testid": "countrySelectorSection_tabLink",
        children: countryAreaValue
    });
};
/* harmony default export */ var v1_CountryUtilNavTabLink = ((/* unused pure expression or super */ null && (CountryUtilNavTabLink_CountryUtilNavTabLink)));

;// CONCATENATED MODULE: ./src/components/Default/CountryUtilNav/v1/CountryUtilNav.jsx






const CountryUtilNav = (props)=>{
    const { show , active , toggleCountryNav , eventHandler , countryselector , datalayerPageName  } = props;
    const { callbacks: { setRegionNav =()=>console.log("Event Not Defined")  }  } = eventHandler;
    const { winWidth  } = useWindowDimensions();
    const [activeTab, setActiveTab] = useState("");
    const addCountrySelectorAnalytics = (type)=>{
        let eventInfo;
        if (type === "Americas") {
            eventInfo = getAmericaTabEventInfo(type);
        } else if (type === "Africa") {
            eventInfo = getAfricaTabEventInfo(type);
        } else if (type === "Asia") {
            eventInfo = getAsiaTabEventInfo(type);
        } else if (type === "Australasia") {
            eventInfo = getAustralasiaTabEventInfo(type);
        } else if (type === "Middle East") {
            eventInfo = getMiddleEastTabEventInfo(type);
        } else if (type === "Europe") {
            eventInfo = getEuropeTabEventInfo(type);
        }
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const getAmericaTabEventInfo = (type)=>{
        if (type === "Americas") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:americas",
                eventName: "country select:americas",
                eventType: "navigation",
                internalLinkName: "americas",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAfricaTabEventInfo = (type)=>{
        if (type === "Africa") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:africa",
                eventName: "country select:africa",
                eventType: "navigation",
                internalLinkName: "africa",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAsiaTabEventInfo = (type)=>{
        if (type === "Asia") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:asia",
                eventName: "country select:asia",
                eventType: "navigation",
                internalLinkName: "asia",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAustralasiaTabEventInfo = (type)=>{
        if (type === "Australasia") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:australasia",
                eventName: "country select:australasia",
                eventType: "navigation",
                internalLinkName: "australasia",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getMiddleEastTabEventInfo = (type)=>{
        if (type === "Middle East") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:middle east",
                eventName: "country select:middle east",
                eventType: "navigation",
                internalLinkName: "middle east",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getEuropeTabEventInfo = (type)=>{
        if (type === "Europe") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:europe",
                eventName: "country select:europe",
                eventType: "navigation",
                internalLinkName: "europe",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    useEffect(()=>{
        if (winWidth <= 1200) {
            setActiveTab("");
        } else {
            setActiveTab("america");
        }
    }, [
        winWidth
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.countrySelectorMain,
        "data-testid": "countrySelectorSection",
        children: /*#__PURE__*/ _jsxs("div", {
            id: "gbh_utheader",
            className: "gbh-countryselector ".concat(active ? "active" : ""),
            style: show ? {
                left: 0,
                display: "block"
            } : {
                display: "block"
            },
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "gbh-tab",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            role: "button",
                            className: "gbh-hamber-menu gbh-close icon-Close-Medium"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            role: "button",
                            tabIndex: "0",
                            "data-testid": "countrySelectorSection_menu",
                            className: "gbh-close-btn d-block d-lg-none pl-4 mb-2",
                            onClick: ()=>{
                                toggleCountryNav(), setRegionNav(false);
                            },
                            children: "Menu"
                        }),
                        /*#__PURE__*/ _jsxs("ul", {
                            role: "tablist",
                            "aria-multiselectable": "false",
                            className: "tablist",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "selection-bar"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Americas"),
                                    children: /*#__PURE__*/ _jsx(CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "america",
                                        countryAreaValue: "Americas",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Africa"),
                                    children: /*#__PURE__*/ _jsx(CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "africa",
                                        countryAreaValue: "Africa",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Asia"),
                                    children: /*#__PURE__*/ _jsx(CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "asia",
                                        countryAreaValue: "Asia",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Australasia"),
                                    children: /*#__PURE__*/ _jsx(CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "australia",
                                        countryAreaValue: "Australasia",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Middle East"),
                                    children: /*#__PURE__*/ _jsx(CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "middleEast",
                                        countryAreaValue: "Middle East",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Europe"),
                                    children: /*#__PURE__*/ _jsx(CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "europe",
                                        countryAreaValue: "Europe",
                                        onclickVal: setActiveTab
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "gbh-tab__panels",
                    style: winWidth <= 1200 && activeTab ? {
                        display: "block"
                    } : {},
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            role: "button",
                            className: "gbh-hamber-menu gbh-close icon-Close-Medium"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            role: "button",
                            tabIndex: "0",
                            className: "gbh-back-btn d-block d-lg-none pl-4 mb-2",
                            onClick: ()=>setActiveTab(""),
                            children: "Region"
                        }),
                        /*#__PURE__*/ _jsx(CountryUtilContainer, {
                            countryarea: "america",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.americasItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ _jsx(CountryUtilContainer, {
                            countryarea: "africa",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.africaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ _jsx(CountryUtilContainer, {
                            countryarea: "asia",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.asiaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ _jsx(CountryUtilContainer, {
                            countryarea: "australia",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.oceaniaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ _jsx(CountryUtilContainer, {
                            countryarea: "middleEast",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.middleEastItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ _jsx(CountryUtilContainer, {
                            countryarea: "europe",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.europeItems,
                            datalayerPageName: datalayerPageName
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_CountryUtilNav = ((/* unused pure expression or super */ null && (CountryUtilNav)));

// EXTERNAL MODULE: ./src/components/Shared/MiniCart/v1/MiniCart.jsx + 3 modules
var MiniCart = __webpack_require__(99878);
// EXTERNAL MODULE: ./src/components/Shared/index.module.scss
var Shared_index_module = __webpack_require__(24707);
var Shared_index_module_default = /*#__PURE__*/__webpack_require__.n(Shared_index_module);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(5702);
// EXTERNAL MODULE: ./src/components/Shared/UtilityWidgets/v1/UtilityWidgets.module.scss
var UtilityWidgets_module = __webpack_require__(36064);
var UtilityWidgets_module_default = /*#__PURE__*/__webpack_require__.n(UtilityWidgets_module);
;// CONCATENATED MODULE: ./components/Shared/UtilityNavHeader.jsx
















const UtilityNavHeader = (param)=>{
    let { data , eventHandler  } = param;
    const router = (0,next_router.useRouter)();
    const { store: { store: { zipCodeContent =""  } = {}  } = {}  } = data;
    const { store: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  } , callbacks: { setRegionNav =()=>console.log("Event Not Defined") , setAuthNav =()=>console.log("Event Not Defined")  }  } = eventHandler;
    const [currentPagePath, setCurrentPagePath] = (0,react.useState)("/");
    (0,react.useEffect)(()=>{
        if (router.locale && router.pathname) {
            setCurrentPagePath("/" + router.locale + router.asPath);
        }
    }, []);
    const { winWidth  } = hooks_useWindowDimensions();
    const { datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [findAStoreShow, setFindAStoreShow] = (0,react.useState)(false);
    const [findAStoreActive, setFindAStoreActive] = (0,react.useState)(false);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { favorites  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const [authNavShow, setAuthNavShow] = (0,react.useState)(false);
    const [authNavActive, setAuthNavActive] = (0,react.useState)(false);
    const [favoritesPage, setFavoritesPage] = (0,react.useState)([]);
    const [countryNavShow, setCountryNavShow] = (0,react.useState)(false);
    const [countryNavActive, setCountryNavActive] = (0,react.useState)(false);
    eventHandler.callbacks.toggleFindAStore = ()=>{
        setFindAStoreActive(false);
    };
    (0,react.useEffect)(()=>{
        if (findAStoreShow) {
            setFindAStoreActive(true);
        }
        if (authNavShow) {
            setAuthNavActive(true);
        }
        if (countryNavShow) {
            setCountryNavActive(true);
        }
    }, [
        findAStoreShow,
        authNavShow,
        countryNavShow
    ]);
    (0,react.useEffect)(()=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* getFavorites */._l)()).unwrap().then((rsp)=>{
                if (rsp && rsp !== null) {
                    setFavoritesPage(rsp.lineItems);
                } else {
                    setFavoritesPage([]);
                }
            });
        }
    }, [
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if ((favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.length) > 0) {
            setFavoritesPage(favorites === null || favorites === void 0 ? void 0 : favorites.lineItems);
        } else {
            setFavoritesPage([]);
        }
    }, [
        favorites
    ]);
    (0,react.useEffect)(()=>{
        if (!findAStoreActive) {
            setTimeout(()=>{
                setFindAStoreShow(false);
            }, 1000);
        }
        if (!authNavActive) {
            setTimeout(()=>{
                setAuthNavShow(false);
            }, 1000);
        }
        if (!countryNavActive) {
            if (winWidth <= 1200) {
                setCountryNavShow(false);
            } else {
                setTimeout(()=>{
                    setCountryNavShow(false);
                }, 1000);
            }
        }
    }, [
        findAStoreActive,
        authNavActive,
        countryNavActive
    ]);
    const toggleFindAStore = ()=>{
        if (!findAStoreShow) {
            setFindAStoreShow(true);
            (0,helper/* toggeleBodyScroll */.wA4)(true);
        } else {
            setFindAStoreActive(false);
            (0,helper/* toggeleBodyScroll */.wA4)(false);
        }
    };
    (0,react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isUserIconClick = event.target.closest(".auth-nav--active img");
            const isUserNavItemClick = event.target.closest(".auth-nav--active .auth-nav__user");
            if (authNavShow && !isUserIconClick && !isUserNavItemClick) {
                setAuthNavShow(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
        };
    }, [
        authNavShow
    ]);
    (0,react.useEffect)(()=>{
        const styleEle = document.querySelector(".auth-nav");
        const backStyleElement = document.querySelector(".ann-sacks-main-menu.header-container.ann-sacks-tab-bar>.cmp-container");
        const closeIconElement = document.querySelector(".icon-close-medium.icon-close");
        const findStoreElement = document.querySelector(".gbh-nav__findStore>a");
        if (authNavShow) {
            var ref, ref1, ref2;
            styleEle.classList.add("auth-nav--active");
            backStyleElement === null || backStyleElement === void 0 ? void 0 : (ref = backStyleElement.classList) === null || ref === void 0 ? void 0 : ref.add("auth-nav-header");
            closeIconElement === null || closeIconElement === void 0 ? void 0 : (ref1 = closeIconElement.classList) === null || ref1 === void 0 ? void 0 : ref1.add("auth-nav-icon");
            findStoreElement === null || findStoreElement === void 0 ? void 0 : (ref2 = findStoreElement.classList) === null || ref2 === void 0 ? void 0 : ref2.add("auth-nav-icon");
        } else {
            var ref3, ref4, ref5;
            styleEle.classList.remove("auth-nav--active");
            backStyleElement === null || backStyleElement === void 0 ? void 0 : (ref3 = backStyleElement.classList) === null || ref3 === void 0 ? void 0 : ref3.remove("auth-nav-header");
            closeIconElement === null || closeIconElement === void 0 ? void 0 : (ref4 = closeIconElement.classList) === null || ref4 === void 0 ? void 0 : ref4.remove("auth-nav-icon");
            findStoreElement === null || findStoreElement === void 0 ? void 0 : (ref5 = findStoreElement.classList) === null || ref5 === void 0 ? void 0 : ref5.remove("auth-nav-icon");
        }
    }, [
        authNavShow
    ]);
    const toggleAuthNav = ()=>{
        if (!authNavShow) {
            setAuthNavShow(true);
            (0,helper/* toggeleBodyScroll */.wA4)(true);
        } else {
            setAuthNavActive(false);
            (0,helper/* toggeleBodyScroll */.wA4)(false);
        }
    };
    const toggleCountryNav = ()=>{
        if (!countryNavActive) {
            setCountryNavShow(true);
            (0,helper/* toggeleBodyScroll */.wA4)(true);
        } else {
            setCountryNavActive(false);
            (0,helper/* toggeleBodyScroll */.wA4)(false);
        }
    };
    const clickEvent = (e)=>{
        if (!(0,helper/* isElementExcluded */.G_Z)(e, [
            "header-container",
            "modal-popup",
            "auth-modal"
        ])) {
            setAuthNavActive(false);
            setFindAStoreActive(false);
            setCountryNavActive(false);
            (0,helper/* toggeleBodyScroll */.wA4)(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (findAStoreActive) {
            setAuthNavActive(false);
            setCountryNavActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        findAStoreActive
    ]);
    (0,react.useEffect)(()=>{
        if (authNavActive) {
            setFindAStoreActive(false);
            setCountryNavActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        authNavActive
    ]);
    (0,react.useEffect)(()=>{
        if (countryNavActive) {
            setAuthNavActive(false);
            setFindAStoreActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        countryNavActive
    ]);
    const style = {
        display: "list-item"
    };
    const displayNone = {
        display: "none"
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    const onClickSignIn = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const onAuthMenuClick = (payload)=>{
        setAuthNavActive(payload);
        setAuthNav(payload);
    };
    // const [loadUtilityWidgets, setloadUtilityWidgets] = useState(true)
    // useEffect(() => {
    //   const timer = setTimeout(() => {
    //     setloadUtilityWidgets(false)
    //   }, 5000)
    //   return () => clearTimeout(timer)
    // }, [])
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Shared_index_module_default()).utilityNavHeaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitynavheader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-utility-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "gbh-utility-navbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "gbh-nav__findStore",
                                ...isOpen && !mainCategoryActive && !isRegionOpen && !isAuthNavOpen ? {
                                    style: style
                                } : {},
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: "0",
                                        "aria-live": "polite",
                                        "aria-labelledby": "find-ada",
                                        className: "gbh-data-layer gbh-nav__findStore--link cmp-find-place",
                                        onClick: ()=>toggleFindAStore(),
                                        "data-gbh-data-layer": '{"eventAction":"find a showroom","eventName":"find a showroom","eventType":"find a showroom","internalLinkName":"find a showroom","internalLinkPosition":"find a showroom","internalLinkType":"global header:navigation","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                        children: "Find a Showroom"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindStoreUtilNav, {
                                        show: findAStoreShow,
                                        active: findAStoreActive,
                                        eventHandler: eventHandler,
                                        zipCodeContent: zipCodeContent
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                id: "country-ada",
                                style: displayNone,
                                children: [
                                    "Country Selector",
                                    " ",
                                    "United States" || (0),
                                    " -",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__signin",
                                ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                    style: style
                                } : {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (UtilityWidgets_module_default()).utilityWidgetsWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "list",
                                        className: "utility-widgets utility-widgets__brand-switcher",
                                        style: {
                                            display: "flex"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AuthUtilityNav, {
                                                show: authNavShow,
                                                active: authNavActive,
                                                toggleAuthNav: toggleAuthNav,
                                                setAuthNav: setAuthNav,
                                                onAuthMenuClick: onAuthMenuClick
                                            }),
                                            winWidth > 1200 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "listitem",
                                                        className: "wishlist-widget",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: isAuth ? "/my-account/my-favorites" : "#",
                                                            "aria-label": "View your wishlist",
                                                            className: "gbh-data-layer",
                                                            "data-gbh-data-layer": '{"eventName":"wishlist icon","eventAction":"wishlist icon","internalLinkName":"wishlist","internalLinkType":"global header:wishlist","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header wishlist","eventMsg":"n/a","eventStatus":"n/a"}',
                                                            onClick: !isAuth && onClickSignIn,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                alt: "View your wishlist",
                                                                "aria-hidden": "true",
                                                                role: "presentation",
                                                                src: favoritesPage && favoritesPage.length > 0 ? "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTUgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbi9XaXNobGlzdDwvdGl0bGU+CiAgICA8ZyBpZD0iQjEtQ29tcGFyZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikljb24vV2lzaGxpc3QiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAtOC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPHBhdGggZD0iTTguMTQwNjA3MTQsOS42ODg0ODE5NyBMNy41MDEsMTAuMzM0IEw2Ljg2MTU5MzY5LDkuNjg4NDgxOTcgQzUuMjkyNDIzNTIsOC4xMDM4MzkzNCAyLjc0NjI0NDc5LDguMTAzODM5MzQgMS4xNzcwNzQ2Myw5LjY4ODQ4MTk3IEMtMC4zNDg3ODE5NTgsMTEuMjI5MzgzOSAtMC4zOTYyNTE5NTksMTMuNzE4NTgzNCAxLjA2NDMyMjM2LDE1LjI5NzA0NDIgTDEuMTcwNzE4NTIsMTUuNDA4NTcwNyBMNy41MDExMTM0NCwyMS44MDE1MDMzIEwxMy44MDg0ODM5LDE1LjQzMjE5OTggTDEzLjkxNTE4NzgsMTUuMzIxMTQwOCBDMTUuMzk1NTk2OCwxMy43MjE3MTI1IDE1LjM1Mzk3MDMsMTEuMjMyNDAxIDEzLjgyNTEyNjIsOS42ODg0ODE5NyBDMTIuMjU1OTU2LDguMTAzODM5MzQgOS43MDk3NzczMSw4LjEwMzgzOTM0IDguMTQwNjA3MTQsOS42ODg0ODE5NyBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+" : "data:image/svg+xml;base64,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"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "listitem",
                                                        className: "cart-indicator-widget",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart/* default */.Z, {
                                                            eventHandler: eventHandler,
                                                            source: "from desk"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_UtilityNavHeader = (UtilityNavHeader);

// EXTERNAL MODULE: ./public/icons/cart-icon-empty.svg
var cart_icon_empty = __webpack_require__(27644);
;// CONCATENATED MODULE: ./src/components/Shared/BrandHeaderFiller.jsx
/* provided dependency */ var process = __webpack_require__(83454);




const BrandHeaderFiller = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Shared_index_module_default()).utilityNavHeaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitynavheader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-utility-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "gbh-utility-navbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__findStore",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-live": "polite",
                                    "aria-labelledby": "find-ada",
                                    className: "gbh-nav__findStore--link cmp-find-place",
                                    children: process.env.NEXT_PUBLIC_FIND_STORE_LABEL || "Find a Store"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__region region_arrowdropdown",
                                id: "United States" || 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-labelledby": "country-ada",
                                    "aria-expanded": "false",
                                    className: "gbh-nav__region--link active-country ",
                                    children: [
                                        "United States" || 0,
                                        " -",
                                        " ",
                                        "EN" || 0
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__signin",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "UtilityWidgets_utilityWidgetsWrapper__Wz0ZS",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "list",
                                        className: "utility-widgets utility-widgets__brand-switcher",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "auth-widget auth-widget__menu AuthUtilityNav_authUtilityNavWrapper__iJgYU",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "auth-nav",
                                                    "aria-expanded": "false",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            tabIndex: 0,
                                                            role: "button",
                                                            name: "avatarIcon",
                                                            "aria-label": "Sign In Collapsed",
                                                            src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMTkgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+U2lnbiBJbiBJY29uPC90aXRsZT4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTmF2aWdhdGlvbi9EZXNrdG9wL1V0aWxpdHktQmFyL0xvZ2dlZC1PdXQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzkxLjAwMDAwMCwgLTEzLjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0iVXRpbGl0eS1MaW5rcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTExOC4wMDAwMDAsIDguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iU2lnbi1Jbi1JY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNzEuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNiwxNy41IEMxOC40MTQyNzMzLDE3LjUgMjAuMzg0NDg5MSwxOS40MDEyMzY1IDIwLjQ5NTEwMiwyMS43ODgxNjQzIEwyMC41LDIyIEwyMC41LDI1IEwxOS41LDI1IEwxOS41LDIyIEMxOS41LDIwLjEzMTQzNjYgMTguMDM1NzIyNCwxOC42MDQ4NzM2IDE2LjE5MjAzNTIsMTguNTA1MTc4OSBMMTYsMTguNSBMNywxOC41IEM1LjEzMTQzNjYsMTguNSAzLjYwNDg3MzU1LDE5Ljk2NDI3NzYgMy41MDUxNzg4NiwyMS44MDc5NjQ4IEwzLjUsMjIgTDMuNSwyNSBMMi41LDI1IEwyLjUsMjIgQzIuNSwxOS41ODU3MjY3IDQuNDAxMjM2NTIsMTcuNjE1NTEwOSA2Ljc4ODE2NDMsMTcuNTA0ODk4IEw3LDE3LjUgTDE2LDE3LjUgWiBNMTEuNSw1LjUgQzE0LjI2MTQyMzcsNS41IDE2LjUsNy43Mzg1NzYyNSAxNi41LDEwLjUgQzE2LjUsMTMuMjYxNDIzNyAxNC4yNjE0MjM3LDE1LjUgMTEuNSwxNS41IEM4LjczODU3NjI1LDE1LjUgNi41LDEzLjI2MTQyMzcgNi41LDEwLjUgQzYuNSw3LjczODU3NjI1IDguNzM4NTc2MjUsNS41IDExLjUsNS41IFogTTExLjUsNi41IEM5LjI5MDg2MSw2LjUgNy41LDguMjkwODYxIDcuNSwxMC41IEM3LjUsMTIuNzA5MTM5IDkuMjkwODYxLDE0LjUgMTEuNSwxNC41IEMxMy43MDkxMzksMTQuNSAxNS41LDEyLjcwOTEzOSAxNS41LDEwLjUgQzE1LjUsOC4yOTA4NjEgMTMuNzA5MTM5LDYuNSAxMS41LDYuNSBaIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPiA=",
                                                            alt: "Sign In"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "auth-nav__menu ",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "wishlist-widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    "aria-label": "View your wishlist",
                                                    className: "gbh-data-layer",
                                                    href: "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        alt: "View your wishlist",
                                                        "aria-hidden": "true",
                                                        role: "presentation",
                                                        src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTRweCIgdmlld0JveD0iMCAwIDE1IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5JY29uL1dpc2hsaXN0PC90aXRsZT4NCiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJCdXR0b24vSW1hZ2UtSWNvbnMvV2lzaGxpc3QtRW1wdHkvRGFyay1HcmF5LUJHIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiI+DQogICAgICAgICAgICA8ZyBpZD0iSWNvbi9XaXNobGlzdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDAwMDAwLCAzLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjE0MDYwNzE0LDkuNjg4NDgxOTcgTDcuNTAxLDEwLjMzNCBMNi44NjE1OTM2OSw5LjY4ODQ4MTk3IEM1LjI5MjQyMzUyLDguMTAzODM5MzQgMi43NDYyNDQ3OSw4LjEwMzgzOTM0IDEuMTc3MDc0NjMsOS42ODg0ODE5NyBDLTAuMzQ4NzgxOTU4LDExLjIyOTM4MzkgLTAuMzk2MjUxOTU5LDEzLjcxODU4MzQgMS4wNjQzMjIzNiwxNS4yOTcwNDQyIEwxLjE3MDcxODUyLDE1LjQwODU3MDcgTDcuNTAxMTEzNDQsMjEuODAxNTAzMyBMMTMuODA4NDgzOSwxNS40MzIxOTk4IEwxMy45MTUxODc4LDE1LjMyMTE0MDggQzE1LjM5NTU5NjgsMTMuNzIxNzEyNSAxNS4zNTM5NzAzLDExLjIzMjQwMSAxMy44MjUxMjYyLDkuNjg4NDgxOTcgQzEyLjI1NTk1Niw4LjEwMzgzOTM0IDkuNzA5Nzc3MzEsOC4xMDM4MzkzNCA4LjE0MDYwNzE0LDkuNjg4NDgxOTcgWiBNMTMuMTE0NTU4OSwxMC4zOTIxMTEzIEMxNC4yNjY2NjkyLDExLjU1NTU4MTYgMTQuMjk4MTAyMiwxMy40MzUzMTE1IDEzLjE4NzU0NTEsMTQuNjM1MjQ1MyBMMTMuMDkyNTIwMiwxNC43MzQxMDUzIEw3LjUwMSwyMC4zOCBMMS44ODc2NDE4OSwxNC43MTE0NzgzIEwxLjc5Mjk1NDA5LDE0LjYxMjE4MzEgQzAuNzAxOTMzNDQxLDEzLjQzMzAxMzYgMC43Mzc3ODAxMDEsMTEuNTUzMzExIDEuODg3NjQxODksMTAuMzkyMTExMyBDMy4wNjU1MDk0NSw5LjIwMjYyOTU4IDQuOTczMTU4ODcsOS4yMDI2Mjk1OCA2LjE1MTAyNjQyLDEwLjM5MjExMTMgTDcuNTAxMTAwNDIsMTEuNzU1NDk3NCBMOC44NTExNzQ0MSwxMC4zOTIxMTEzIEMxMC4wMjkwNDIsOS4yMDI2Mjk1OCAxMS45MzY2OTE0LDkuMjAyNjI5NTggMTMuMTE0NTU4OSwxMC4zOTIxMTEzIFoiIGlkPSJQYXRoIj48L3BhdGg+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4="
                                                    })
                                                })
                                            }),
                                            process.env.NEXT_PUBLIC_DISABLE_CART_ICON === "true" ? "" : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "cart-indicator-widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cart-indicator false",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        "aria-label": "View your cart containing 0 item",
                                                        role: "link",
                                                        className: "gbh-data-layer",
                                                        href: "/en/cart",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: cart_icon_empty/* default.src */.Z.src,
                                                            alt: "Cart"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_BrandHeaderFiller = (BrandHeaderFiller);

;// CONCATENATED MODULE: ./src/components/Shared/CheckoutUtilityNavheader.jsx


const CheckoutUtilityNavHeader = (param)=>{
    let { data , eventHandler  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            role: "listitem",
            className: "cart-indicator-widget__checkout",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart/* default */.Z, {
                checkoutPage: data === null || data === void 0 ? void 0 : data.linkCart,
                eventHandler: eventHandler,
                source: "from desk"
            })
        })
    });
};
/* harmony default export */ var CheckoutUtilityNavheader = (CheckoutUtilityNavHeader);

;// CONCATENATED MODULE: ./src/components/Shared/BrandHeader.jsx









const BrandHeader = (props)=>{
    const { data , eventHandler  } = props;
    const { datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const isSsr = (0,useIsSsr/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            if (key === "brand_switcher" || key === "brand_switcher_copy") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandSwitcher, {
                    data: item,
                    datalayerPageName: datalayerPageName
                }, key);
            }
            if (key === "utilitynavheader" || key === "utilitynavheader_v2") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandHeaderFiller, {}) : key === "utilitynavheader_v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutUtilityNavheader, {
                        data: item,
                        eventHandler: eventHandler
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_UtilityNavHeader, {
                        data: item,
                        eventHandler: eventHandler
                    })
                }, key);
            }
            return null;
        })
    });
};
/* harmony default export */ var Shared_BrandHeader = (BrandHeader);

;// CONCATENATED MODULE: ./public/icons/BLOK_LOGO.svg
/* harmony default export */ var BLOK_LOGO = ({"src":"/_next/static/media/BLOK_LOGO.00edf835.svg","height":35,"width":115});
;// CONCATENATED MODULE: ./src/components/Shared/HeaderNavLogo.jsx





const HeaderNavLogo = (props)=>{
    var ref, ref1;
    const { data ={} , columnClassNames ="" , eventHandler: { store: { brandLogoImg =""  } = {} , callbacks: { setBrandLogoImg =()=>console.log("Event Not Defined") , toggleMenu =()=>console.log("Event Not Defined")  }  }  } = props;
    const { dataLayer ={} , id =""  } = data;
    const dataLayerImage = (ref = dataLayer[id]) === null || ref === void 0 ? void 0 : ref.image;
    (0,react.useEffect)(()=>{
        if (dataLayerImage) {
            const brandLogoPath = dataLayerImage["repo:path"];
            brandLogoPath && setBrandLogoImg(constants.authorBaseUrl + brandLogoPath);
        }
    }, [
        dataLayerImage
    ]);
    (0,react.useEffect)(()=>{
        setBrandLogoImg(BLOK_LOGO === null || BLOK_LOGO === void 0 ? void 0 : BLOK_LOGO.src);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "gbh-hamber-menu icon-Hamburger",
                tabIndex: "0",
                "aria-label": "Hamburger-menu",
                role: "button",
                onClick: toggleMenu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp cmp-image ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: data === null || data === void 0 ? void 0 : (ref1 = data.link) === null || ref1 === void 0 ? void 0 : ref1.split("/content/annsacks/us/en").join("").replace(".html", ""),
                    title: data === null || data === void 0 ? void 0 : data.alt,
                    className: "cmp-image--link",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: brandLogoImg && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(brandLogoImg),
                            alt: data === null || data === void 0 ? void 0 : data.alt
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_HeaderNavLogo = (HeaderNavLogo);

;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/Description.jsx





const Description = (props)=>{
    const { linkURL ="" , linkURLRef ="" , linkNewTab ="" , description ="" , mainTitle ="" , componentPosition =null , componentLinkType =null , pageType: serverPageType = "" , linkDescription =false , general ={} , expandText ="" , collapseText ="" , disableExpandCollapse =""  } = props;
    const [shortenedLinkUrl, setShortenedLinkUrl] = (0,react.useState)("");
    const [pageType, setPageType] = (0,react.useState)(serverPageType);
    const [target, setTarget] = (0,react.useState)("");
    const [details, setDetails] = (0,react.useState)(description);
    const [isPdp, setIsPdp] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        window.expandText = expandText;
        window.collapseText = collapseText;
        window.disableExpandCollapse = disableExpandCollapse;
    }, [
        expandText,
        collapseText,
        disableExpandCollapse
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        const pageInfoDetails = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.getState("page");
        if (serverPageType !== (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref1 = pageInfoDetails.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.contentType) && (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref2 = pageInfoDetails.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.contentType) === "pdp") {
            var ref3;
            setPageType(pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref3 = pageInfoDetails.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.contentType);
            setIsPdp(true);
        }
    }, []);
    const internalLinkPositionNotPdp = "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser");
    const internalLinkTypeNotPdp = "".concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase());
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(general)) {
            if (linkURL) {
                setShortenedLinkUrl((0,helper/* getShortenedUrlwithGeneral */.vu1)(linkURL, general));
            }
            if (description) {
                setDetails((0,helper/* getShortenedUrlwithGeneral */.vu1)(description, general));
            }
        }
    }, [
        linkURL,
        description,
        general
    ]);
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react.useEffect)(()=>{
        if (linkNewTab) {
            setTarget("_blank");
        } else {
            setTarget("_self");
        }
    }, [
        linkNewTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__description",
        "data-gbh-data-layer": '{"clickInternalLinks":"'.concat(target === "_blank" ? "false" : "true", '","internalLinkPosition": "').concat(isPdp ? pageType.toLowerCase() : internalLinkPositionNotPdp, '","internalLinkZoneName": "').concat(mainTitle ? "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(mainTitle) : "teaser", '","internalLinkURL":"').concat(linkURL, '","internalLinkName":"').concat((0,helper/* sanitizeTextArticle */.pkm)(description.toLowerCase()), '","eventName":"').concat(pageType.toLowerCase(), ":").concat(mainTitle, ':rm","internalLinkType":"').concat(isPdp ? "".concat(pageType.toLowerCase(), ":teaser") : internalLinkTypeNotPdp, '","eventType": "').concat(isPdp ? "navigation" : "teaser", '","eventMsg":"n/a","eventStatus":"n/a","eventAction":"').concat(pageType.toLowerCase(), ":").concat(mainTitle, ':rm"}'),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
            condition: linkDescription,
            wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: shortenedLinkUrl,
                    rel: linkURLRef ? "noreferrer" : "",
                    target: target,
                    children: children
                }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: (0,helper/* sanitizeInnerHtml */.KD0)(details)
            })
        })
    });
};
/* harmony default export */ var v1_Description = (Description);

// EXTERNAL MODULE: ./constants/regex.js
var regex = __webpack_require__(49139);
;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/analytics.js


const getEventInfo = function() {
    let pageType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", mainTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventLabel = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", eventType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", zone = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", parseJson = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    const zoneName = zone ? zone === null || zone === void 0 ? void 0 : zone.replace(regex/* SPECIAL_CHAR_REGEX */.FU, " ") : "zone";
    let internalLinkType = "";
    if (eventLabel === "print") {
        internalLinkType = "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":print");
    } else {
        internalLinkType = "".concat(dataLayerLinkType);
    }
    const internalLinkZoneName = zone ? "".concat(pageType.toLowerCase(), ":").concat(zoneName) : "teaser";
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
        internalLinkZoneName,
        internalLinkURL: "n/a",
        internalLinkName: "".concat(eventLabel),
        eventName: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share")),
        internalLinkType: internalLinkType,
        eventType: eventType,
        eventAction: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share"))
    };
    if (parseJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addDatalayerShare = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "{}", isPdp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = JSON.parse(data);
    const dataLayerObj = {
        event: "cmp:click",
        page,
        eventInfo
    };
    if (isPdp) {
        const { productInfo  } = page;
        dataLayerObj["productInfo"] = productInfo;
    }
    window.adobeDataLayer.push(dataLayerObj);
};
const getDownloadEventInfo = function() {
    let downLoadLink = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", pageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", componentPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    let eventInfo = {};
    if (downLoadLink) {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "".concat(downLoadLink),
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":download"),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    } else {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "n/a",
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(dataLayerLinkType),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    }
    return JSON.stringify(eventInfo);
};
const getTitleEventInfo = function() {
    let linkNewTab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", linkURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", pageType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", componentLinkType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    return '{"clickInternalLinks":"'.concat(linkNewTab ? "false" : "true", '","internalLinkPosition":"').concat(componentPosition ? componentPosition : "teaser", '","internalLinkZoneName":"teaser","internalLinkURL":"').concat(linkURL, '","internalLinkName":"').concat(mainTitle.toLowerCase(), '","eventName":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '","internalLinkType":"').concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase(), '","eventType":"teaser","eventAction":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '"}');
};
const addTeaserActionAnalytics = (param)=>{
    let { newTab , pageType , componentPosition , videoTitle , link , text , eventName: eventNameDatalayer , dataLayerLinkType , eventAction: eventActionDataLayer , productCategory , productCollectionsName , productRoom , datalayerPageType , mainTitle , componentInfo =""  } = param;
    let eventAction = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) || "zone", ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
    let eventName = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((eventNameDatalayer === null || eventNameDatalayer === void 0 ? void 0 : eventNameDatalayer.toLowerCase()) || "zone", ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
    let internalLinkZoneName = "".concat(videoTitle || pageType.toLowerCase() === "plp" || pageType.toLowerCase() === "press-kit" ? "".concat(pageType.toLowerCase(), ":").concat(pageType.toLowerCase() === "press-kit" ? "press-release" : "hero banner") : "teaser");
    let internalLinkPosition = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser");
    let internalLinkType = "".concat(videoTitle ? "".concat(pageType.toLowerCase(), ":").concat(videoTitle) : dataLayerLinkType);
    if (dataLayerLinkType.includes("social impact")) {
        eventName = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        eventAction = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        internalLinkZoneName = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")));
    }
    if (datalayerPageType.includes("locations")) {
        pageType = "locations:kohler stores";
        eventName = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        eventAction = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        internalLinkZoneName = pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase();
        internalLinkPosition = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":teaser");
        internalLinkType = "".concat(pageType.toLowerCase(), ":").concat(mainTitle);
    }
    const eventInfo = {
        clickInternalLinks: (link === null || link === void 0 ? void 0 : link.startsWith("/")) || (link === null || link === void 0 ? void 0 : link.startsWith("#")) || (link === null || link === void 0 ? void 0 : link.includes(window.location.hostname)) ? "true" : "false",
        internalLinkPosition,
        internalLinkZoneName,
        internalLinkURL: link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper/* removeAndCleanLink */.xEh)(link)) : "n/a",
        internalLinkName: "".concat(!text ? "explore more arrow" : text.toLowerCase()),
        eventName,
        internalLinkType,
        eventType: "teaser",
        eventAction,
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    const customDataLayer = {
        componentInfo: JSON.parse(componentInfo),
        productInfo: {
            productCategory: productCategory || "n/a",
            productCollectionsName: productCollectionsName || "n/a",
            productRoom: productRoom || "n/a"
        }
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click", {}, customDataLayer);
};

;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/Action.jsx











const Action = (props)=>{
    const { primaryCTA ="" , secondaryCTA ="" , playVideoCTA ="" , videoTitle ="" , mainTitle ="" , link ="" , text ="" , newTab ="" , urlRef ="" , id ="" , pageType ="" , linkAll ="" , componentPosition =null , eventName =null , eventAction =null , dataLayerLinkType ="".concat(pageType, ":").concat(mainTitle) , productCategory =null , productCollectionsName =null , productRoom =null , propertiesPageType ="" , playVideoCTAcb =()=>"" , index =0 , activeIndex =0 , setActive =()=>"" , item , bannerIndex =-1  } = props;
    const { scroll , findAPro , installationServices  } = constants.DEFAULT_SCROLL;
    const [general, setGeneral] = (0,react.useState)(null);
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageType: datalayerPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [actionLink, setActionLink] = (0,react.useState)("");
    const [target, setTarget] = (0,react.useState)("");
    const [loginRegisterCallback, setLoginRegisterCallback] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (loginRegisterCallback && isAuth && router.pathname.includes(constants.MY_ACCOUNT_PATH)) {
            handleOnLinkClick(loginRegisterCallback);
        }
    }, [
        loginRegisterCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(link) && !isEmpty_default()(general)) {
            const actLink = (0,helper/* getShortenedUrlwithGeneral */.vu1)(link, general);
            setActionLink(actLink);
        }
    }, [
        link,
        general
    ]);
    const handleLogin = (e)=>{
        if (router.pathname.includes(constants.MY_ACCOUNT_PATH)) {
            e.preventDefault();
            e.stopPropagation();
            window.loginRegisterCallback = ()=>{
                setLoginRegisterCallback(e);
                if (actionLink) router.push(actionLink);
            };
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
        } else {
            handleOnLinkClick();
        }
    };
    const handleOnLinkClick = (event)=>{
        return propertiesPageType == "modalWindow" && playVideoCTA ? playVideoCTAcb(event) : undefined;
    };
    const handleOnClick = (event)=>{
        var ref;
        var ref1;
        const actionLink = (ref1 = event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.getAttribute("href")) !== null && ref1 !== void 0 ? ref1 : "";
        if (actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#KPN")) {
            event.preventDefault();
            const link1 = actionLink.split("::");
            const id = link1[0];
            const url = link1[1];
            if (link1) {
                dispatch((0,authSlice/* setHideCustomerSignupCTA */.n$)(true));
                if (id === null || id === void 0 ? void 0 : id.includes("signIn")) {
                    window.KPNSignIn = true;
                    (0,helper/* isAuthenticated */.$8e)(url, 0, true);
                } else if (id === null || id === void 0 ? void 0 : id.includes("createAccount")) {
                    window.KPNSignIn = false;
                    (0,helper/* isAuthenticated */.$8e)(url, 1, true);
                } else {
                    (0,helper/* isAuthenticated */.$8e)(url);
                }
            }
        }
        const currentIndex = Number(event.target.getAttribute("data-index")) || 0;
        const componentInfo = event.target.getAttribute("data-gbh-component");
        setActive(currentIndex);
        if (event.target.getAttribute("href").startsWith("#") && Object.values(constants.MORE_OPTIONS).includes(event.target.text)) {
            exploreMoreScroll(event);
        } else if (router.pathname.includes(constants.MY_ACCOUNT_PATH) && !isAuth) {
            handleLogin(event);
        } else {
            handleOnLinkClick(event);
        }
        addTeaserActionAnalytics({
            newTab,
            pageType,
            componentPosition,
            videoTitle,
            link,
            text,
            eventName,
            dataLayerLinkType,
            eventAction,
            productCategory,
            productCollectionsName,
            productRoom,
            datalayerPageType,
            mainTitle,
            componentInfo
        });
    };
    // global explore more scroll
    const exploreMoreScroll = (e)=>{
        e.preventDefault();
        const hash = e.target.hash;
        if (hash === "") return;
        const element = document.querySelector(hash);
        if (!element) return;
        const offsetTop = (0,helper/* getOffsetTop */.oJS)(element) - (hash === constants.FIND_A_PRO_HASH ? findAPro : hash === constants.INSTALLATION_SERVICES_HASH ? installationServices : scroll);
        window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
        });
    };
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react.useEffect)(()=>{
        if (newTab === false || newTab === "false") {
            setTarget("_self");
        } else {
            setTarget("_blank");
        }
    }, [
        newTab
    ]);
    const getComponentMessage = function() {
        let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if (message && bannerIndex > -1) {
            const obj = JSON.parse(message);
            obj.componentInfo.componentMessage = "".concat(obj.componentInfo.componentMessage).concat(bannerIndex + 1);
            return JSON.stringify(obj);
        }
    };
    if (!linkAll) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "cmp-teaser__action-link ".concat((0,helper/* convertStringToBoolean */.mUs)(primaryCTA) ? "gbh-primary-button " : "").concat((0,helper/* convertStringToBoolean */.mUs)(secondaryCTA) ? "gbh-secondary-button " : "").concat(propertiesPageType === "modalWindow" && playVideoCTA ? "video-play-button " : "", " ").concat(index === activeIndex ? "active" : ""),
            role: "button",
            "aria-describedby": id,
            href: actionLink,
            "aria-label": text,
            target: target,
            rel: urlRef ? "noreferrer" : "",
            onClick: handleOnClick,
            "data-index": index,
            "data-gbh-component": getComponentMessage(item === null || item === void 0 ? void 0 : item.componentInfos),
            children: text
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__action-link ".concat((0,helper/* convertStringToBoolean */.mUs)(primaryCTA) ? "gbh-primary-button " : "").concat((0,helper/* convertStringToBoolean */.mUs)(secondaryCTA) ? "gbh-secondary-button " : "").concat(pageType == "modalWindow" && playVideoCTA ? "video-play-button " : ""),
        role: "button",
        "aria-describedby": id || "",
        rel: urlRef ? "noreferrer" : "",
        "aria-label": text,
        children: text
    });
};
/* harmony default export */ var v1_Action = (Action);

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Teaser.jsx











const Teaser = (props)=>{
    var ref;
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const { data: { id ="" , appliedCssClassNamesCustom ="" , linkURLRef =false , linkAll =false , description ="" , mainTitle ="" , pageType ="" , linkURL ="" , caption ="" , actions =[] , imageURLWithoutCrop ="" , smartCrops =[] , imageResource: { assetID ="" , pretitle: preTitle = ""  } = {}  } = {} , fullData ={} , categoryName  } = props;
    const [parentActionLink, setParentActionLink] = (0,react.useState)(linkURL);
    const [componentGroup, setComponentGroup] = (0,react.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react.useState)("");
    const [general, setGeneral] = (0,react.useState)(null);
    const [item, setItem] = (0,react.useState)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const imageURL = (smartCrops === null || smartCrops === void 0 ? void 0 : smartCrops.length) && smartCrops[0].imageURL;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (assetID) {
            const dynamicId = (0,helper/* createIdFromString */.ZT_)(assetID);
            setDynamicId(dynamicId);
        } else {
            const dynamicId1 = (0,helper/* createIdFromString */.ZT_)(Math.floor(Math.random() * 100000) + "");
            setDynamicId(dynamicId1);
        }
    }, [
        assetID
    ]);
    (0,react.useEffect)(()=>{
        if (linkURL) {
            (0,helper/* getShortenedUrl */.Ppy)(linkURL).then((res)=>{
                setParentActionLink(res);
            });
        }
    }, [
        linkURL
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.TEASER);
            }) && appliedCssClassNamesCustom.includes("hero-banner-article-top") && !appliedCssClassNamesCustom.includes("hero-banner-article-bottom") && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("hero-banner-top-only paddingbasedbreadcrum"))) {
                setColumnClassNames((className)=>className += "hero-banner-top-only paddingbasedbreadcrum");
            } else if ((componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.TEASER);
            }) || appliedCssClassNamesCustom.includes("sticky-pagescroll-nav")) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cmp-container",
                style: {
                    position: "static"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "teaser_v3 teaser annsacks-navigation-teaser link-active",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cmp-image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cmp-image",
                                                children: !isSsr && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "fluidimage cmp-image__image",
                                                    src: imageURLWithoutCrop || (smartCrops === null || smartCrops === void 0 ? void 0 : (ref = smartCrops[0]) === null || ref === void 0 ? void 0 : ref.imageURL),
                                                    alt: caption,
                                                    itemProp: "contentUrl"
                                                })
                                            })
                                        })
                                    })
                                }),
                                description && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cmp-teaser__content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                                            linkURLRef: linkURLRef,
                                            description: description
                                        }),
                                        actions && (actions === null || actions === void 0 ? void 0 : actions.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cmp-teaser__action-container",
                                            children: actions.map((action, index)=>{
                                                const { url ="" , text ="" , newTab ="" , urlRef =""  } = action;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                                    link: url,
                                                    text: text,
                                                    newTab: (0,helper/* convertStringToBoolean */.mUs)(newTab),
                                                    urlRef: urlRef,
                                                    id: id,
                                                    pageType: pageType,
                                                    linkAll: (0,helper/* convertStringToBoolean */.mUs)(!linkAll),
                                                    mainTitle: mainTitle
                                                }, "teaser-action-".concat(index + 1, "-").concat((0,helper/* randomWholeNumber */.qJY)(250, 499)));
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cmp-img-caption",
                        dangerouslySetInnerHTML: {
                            __html: browser_default().sanitize(caption)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ann-mob-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "nav-link",
                    "aria-hidden": "false",
                    href: linkURL.replace(general === null || general === void 0 ? void 0 : general.shortendPagePath, "").replace(".html", ""),
                    rel: "noreferrer",
                    "aria-selected": "true",
                    role: "tab",
                    tabIndex: "0",
                    "data-gbh-clickable": "true",
                    children: categoryName
                })
            })
        ]
    });
};
/* harmony default export */ var v1_Teaser = (Teaser);

// EXTERNAL MODULE: ./src/components/core/Image/DynamicImage.jsx
var DynamicImage = __webpack_require__(96702);
;// CONCATENATED MODULE: ./components/Default/Teaser/v2/Action.jsx











const Action_Action = (props)=>{
    const { primaryCTA ="" , secondaryCTA ="" , playVideoCTA ="" , videoTitle ="" , mainTitle ="" , link ="" , text ="" , newTab ="" , urlRef ="" , id ="" , pageType ="" , linkAll ="" , componentPosition =null , eventName =null , eventAction =null , dataLayerLinkType ="".concat(pageType, ":").concat(mainTitle) , productCategory =null , productCollectionsName =null , productRoom =null , propertiesPageType ="" , playVideoCTAcb =()=>"" , index =0 , activeIndex =0 , setActive =()=>"" , item , bannerIndex =-1  } = props;
    const { scroll , findAPro , installationServices  } = constants.DEFAULT_SCROLL;
    const [general, setGeneral] = (0,react.useState)(null);
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageType: datalayerPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [actionLink, setActionLink] = (0,react.useState)("");
    const [target, setTarget] = (0,react.useState)("");
    const [loginRegisterCallback, setLoginRegisterCallback] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (loginRegisterCallback && isAuth && router.pathname.includes(constants.MY_ACCOUNT_PATH)) {
            handleOnLinkClick(loginRegisterCallback);
        }
    }, [
        loginRegisterCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(link) && !isEmpty_default()(general)) {
            const actLink = (0,helper/* getShortenedUrlwithGeneral */.vu1)(link, general);
            setActionLink(actLink);
        }
    }, [
        link,
        general
    ]);
    const handleLogin = (e)=>{
        if (router.pathname.includes(constants.MY_ACCOUNT_PATH)) {
            e.preventDefault();
            e.stopPropagation();
            window.loginRegisterCallback = ()=>{
                setLoginRegisterCallback(e);
                if (actionLink) router.push(actionLink);
            };
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
        } else {
            handleOnLinkClick();
        }
    };
    const handleOnLinkClick = (event)=>{
        return propertiesPageType == "modalWindow" && playVideoCTA ? playVideoCTAcb(event) : undefined;
    };
    const handleOnClick = (event)=>{
        var ref;
        var ref1;
        const actionLink = (ref1 = event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.getAttribute("href")) !== null && ref1 !== void 0 ? ref1 : "";
        if (actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#KPN")) {
            event.preventDefault();
            const link1 = actionLink.split("::");
            const id = link1[0];
            const url = link1[1];
            if (link1) {
                dispatch((0,authSlice/* setHideCustomerSignupCTA */.n$)(true));
                if (id === null || id === void 0 ? void 0 : id.includes("signIn")) {
                    window.KPNSignIn = true;
                    (0,helper/* isAuthenticated */.$8e)(url, 0, true);
                } else if (id === null || id === void 0 ? void 0 : id.includes("createAccount")) {
                    window.KPNSignIn = false;
                    (0,helper/* isAuthenticated */.$8e)(url, 1, true);
                } else {
                    (0,helper/* isAuthenticated */.$8e)(url);
                }
            }
        }
        const currentIndex = Number(event.target.getAttribute("data-index")) || 0;
        const componentInfo = event.target.getAttribute("data-gbh-component");
        setActive(currentIndex);
        if (event.target.getAttribute("href").startsWith("#") && Object.values(constants.MORE_OPTIONS).includes(event.target.text)) {
            exploreMoreScroll(event);
        } else if (router.pathname.includes(constants.MY_ACCOUNT_PATH) && !isAuth) {
            handleLogin(event);
        } else {
            handleOnLinkClick(event);
        }
        addTeaserActionAnalytics({
            newTab,
            pageType,
            componentPosition,
            videoTitle,
            link,
            text,
            eventName,
            dataLayerLinkType,
            eventAction,
            productCategory,
            productCollectionsName,
            productRoom,
            datalayerPageType,
            mainTitle,
            componentInfo
        });
    };
    // global explore more scroll
    const exploreMoreScroll = (e)=>{
        e.preventDefault();
        const hash = e.target.hash;
        if (hash === "") return;
        const element = document.querySelector(hash);
        if (!element) return;
        const offsetTop = (0,helper/* getOffsetTop */.oJS)(element) - (hash === constants.FIND_A_PRO_HASH ? findAPro : hash === constants.INSTALLATION_SERVICES_HASH ? installationServices : scroll);
        window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
        });
    };
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react.useEffect)(()=>{
        if (newTab === false || newTab === "false") {
            setTarget("_self");
        } else {
            setTarget("_blank");
        }
    }, [
        newTab
    ]);
    const getComponentMessage = function() {
        let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if (message && bannerIndex > -1) {
            const obj = JSON.parse(message);
            obj.componentInfo.componentMessage = "".concat(obj.componentInfo.componentMessage).concat(bannerIndex + 1);
            return JSON.stringify(obj);
        }
    };
    if (!linkAll) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "cmp-teaser__action-link ".concat((0,helper/* convertStringToBoolean */.mUs)(primaryCTA) ? "gbh-primary-button " : "").concat((0,helper/* convertStringToBoolean */.mUs)(secondaryCTA) ? "gbh-secondary-button " : "").concat(propertiesPageType === "modalWindow" && playVideoCTA ? "video-play-button " : "", " ").concat(index === activeIndex ? "active" : ""),
            "aria-describedby": id,
            href: actionLink,
            "aria-label": "".concat(text, " ").concat((props === null || props === void 0 ? void 0 : props.mainTitle) ? "About" + " " + (props === null || props === void 0 ? void 0 : props.mainTitle) : ""),
            target: target,
            rel: urlRef ? "noreferrer" : "",
            onClick: handleOnClick,
            "data-index": index,
            "data-gbh-component": getComponentMessage(item === null || item === void 0 ? void 0 : item.componentInfos),
            children: text
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__action-link ".concat((0,helper/* convertStringToBoolean */.mUs)(primaryCTA) ? "gbh-primary-button " : "").concat((0,helper/* convertStringToBoolean */.mUs)(secondaryCTA) ? "gbh-secondary-button " : "").concat(pageType == "modalWindow" && playVideoCTA ? "video-play-button " : ""),
        role: "button",
        "aria-describedby": id || "",
        rel: urlRef ? "noreferrer" : "",
        "aria-label": text,
        children: text
    });
};
/* harmony default export */ var v2_Action = (Action_Action);

;// CONCATENATED MODULE: ./src/components/core/Image/ImagePlaceHolder.jsx


const ImagePlaceHolder = (param)=>{
    let { assetID =""  } = param;
    if (!assetID) return null;
    const imgPlaceholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: imgPlaceholder,
        "data-src": imgPlaceholder,
        "data-mode": "smartcrop",
        alt: "Image Placeholder",
        className: "fluidimage cmp-image__image image-placeholder"
    });
};
/* harmony default export */ var Image_ImagePlaceHolder = (ImagePlaceHolder);

// EXTERNAL MODULE: ./src/i18n/useSearchi18n.js
var useSearchi18n = __webpack_require__(31090);
// EXTERNAL MODULE: ./constants/api.js
var constants_api = __webpack_require__(73350);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/FavouritesUtility.jsx










const FavouritesUtility = (param)=>{
    let { title ="" , assetID ="" , imageServerUrl ="" , alt ="" , containerId: zone = ""  } = param;
    let isTriggered = false;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [isFavourite, setIsFavourite] = (0,react.useState)(false);
    const [pageUrl, setPageUrl] = (0,react.useState)("");
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const favEle = (0,react.useRef)(null);
    const { favorites: favoritesLabel , favSuccessMsg , favErrorMsg , removeItem  } = (0,useSearchi18n/* default */.Z)({});
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { favorites: { id  } = {} , isLoginFavouriteCallback: { isCallBack =false , callBackAssetID =""  }  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const dataUrl = assetID ? "".concat(imageServerUrl).concat(assetID) : "";
    (0,react.useEffect)(()=>{
        // en is hardcoaded for Fav action to take palce as global config is configured in that location
        const url = "/en".concat(window.location.pathname.split(".")[0]);
        setPageUrl(url);
    }, []);
    const { toaster: { content  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    (0,react.useEffect)(()=>{
        if (content) {
            setToasterMessage();
        }
    }, [
        content
    ]);
    (0,react.useEffect)(()=>{
        if (!isTriggered && isCallBack && isAuth && id && callBackAssetID === assetID) {
            isTriggered = true;
            dispatch((0,favoritesSlice/* setLoginFavouriteCallback */.x9)({
                isCallBack: false,
                callBackAssetID: ""
            }));
            onFavClick({});
        }
    }, [
        isCallBack,
        callBackAssetID,
        isAuth,
        id
    ]);
    const setToasterMessage = async ()=>{
        const { successMessage =constants.ADD_TO_FAVORITES_MSG , unfavoriteSuccessMessage =constants.REMOVE_FROM_FAVORITES_MSG  } = content;
        setToasterContent({
            successMessage: await (0,utils_location/* getShortenedUrl */.Pp)(successMessage),
            unfavoriteSuccessMessage: await (0,utils_location/* getShortenedUrl */.Pp)(unfavoriteSuccessMessage)
        });
    };
    const onFavClick = (event)=>{
        (event === null || event === void 0 ? void 0 : event.preventDefault) && (event === null || event === void 0 ? void 0 : event.preventDefault());
        (event === null || event === void 0 ? void 0 : event.stopPropagation) && (event === null || event === void 0 ? void 0 : event.stopPropagation());
        let payload = {};
        const id = favEle.current.getAttribute("data-id");
        window.zoneName = zone;
        window.internalLinkType = title;
        if (!isAuth) {
            handleLogin();
            return;
        }
        // For images
        if (assetID) {
            payload = getPayload({
                type: "image"
            });
            if (!id) {
                postData(payload);
            }
        } else {
            Promise.all([
                (0,constants_api/* aemAxiosInstance */.Gb)({
                    url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(pageUrl).concat(constants.ARTICLE_CONTENT_END_POINT)
                    }
                }),
                (0,constants_api/* aemAxiosInstance */.Gb)({
                    url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(pageUrl).concat(constants.ARTICLE_IMG_END_POINT)
                    }
                })
            ]).then((response)=>{
                const [{ data  } = {}, { data: { fileReference  } = {}  }] = response;
                payload = getPayload({
                    type: "article",
                    content: data,
                    thumbnail: fileReference
                });
                if (!id) {
                    postData(payload);
                }
            }).catch((error)=>{
                // eslint disable next-line no-console
                console.error(error);
            });
        }
        if (id) {
            dispatch((0,favoritesSlice/* removeItems */.Er)({
                ids: [
                    id
                ],
                section: payload === null || payload === void 0 ? void 0 : payload.section,
                imageName: payload === null || payload === void 0 ? void 0 : payload.imageName,
                isDataLayerNeeded: true
            })).unwrap().then((response)=>{
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: toasterContent.unfavoriteSuccessMessage || removeItem,
                    isVisible: true
                }));
                favEle.current.removeAttribute("data-id");
                favEle.current.classList.remove("favorite-filled");
            }).catch((error)=>{
                // eslint disable next-line no-console
                console.error(error);
            });
            return;
        }
    };
    const postData = (payload)=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* addMedia */.rA)(payload));
        } else {
            handleLogin();
        }
    };
    const getPayload = (param)=>{
        let { type , content , thumbnail  } = param;
        const payload = {
            type,
            content,
            thumbnail,
            successCallback,
            errorCallback,
            section: zone
        };
        if (type === "image") {
            payload["name"] = alt;
            payload["url"] = dataUrl;
            payload["section"] = "main content area";
            payload["imageName"] = assetID.includes("/") ? "".concat(assetID.split("/").at(1)).toLowerCase() : "".concat(assetID).toLowerCase();
        } else if (type === "article") {
            payload["caption"] = title;
            payload["name"] = content["jcr:title"];
            payload["description"] = content["searchDescription"];
            payload["articleType"] = content["eyeBrowText"];
            payload["thumbnail"] = thumbnail;
            payload["url"] = window.location.href;
        }
        return payload;
    };
    const handleLogin = ()=>{
        dispatch((0,favoritesSlice/* setLoginFavouriteCallback */.x9)({
            isCallBack: true,
            callBackAssetID: assetID
        }));
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const successCallback = ()=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: toasterContent.successMessage || favSuccessMsg,
            isVisible: true
        }));
        setIsFavourite(true);
    };
    const errorCallback = ()=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: favErrorMsg,
            isVisible: true
        }));
        setIsFavourite(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "favorite fav-trigger ".concat(isFavourite ? "favorite-filled" : ""),
        "aria-label": "favorite",
        "data-asset": assetID,
        "data-url": dataUrl,
        "data-title": alt,
        "data-internal-link-type": title,
        ref: favEle,
        onClick: (event)=>onFavClick(event),
        children: [
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: favoritesLabel
            })
        ]
    });
};
/* harmony default export */ var v1_FavouritesUtility = (FavouritesUtility);

// EXTERNAL MODULE: ./src/components/Shared/ProductSocialShare/v1/ProductSocialShare.jsx
var ProductSocialShare = __webpack_require__(11059);
;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/ShareUtility.jsx








const ShareUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , dataLayerLinkType ="" , containerId: zone = ""  } = param;
    const [showShare, setShowShare] = (0,react.useState)(false);
    const [pageUrl, setPageUrl] = (0,react.useState)("");
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { share  } = (0,useSearchi18n/* default */.Z)({});
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (pageIsInteractive) setPageUrl(window.location.href);
    }, [
        pageIsInteractive
    ]);
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowShare(!showShare);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const { pageInfo: { contentType  }  } = getState && getState("page") || {};
        let eventInfo = getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative");
        const isPdp = contentType === "pdp";
        if (isPdp) {
            const { internalLinkType , internalLinkZoneName , internalLinkURL  } = getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative", zone, true);
            const eventInfoObj = {
                clickInternalLinks: "true",
                eventAction: "pdp:product details:zone:share",
                eventName: "pdp:product details:zone:share",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "share",
                internalLinkPosition: "pdp",
                internalLinkType: "pdp:".concat(internalLinkType.split(":")[1] || ""),
                internalLinkZoneName: "pdp:".concat(internalLinkZoneName.split(":")[1] || ""),
                internalLinkURL: internalLinkURL || "n/a"
            };
            eventInfo = JSON.stringify(eventInfoObj);
        }
        addDatalayerShare(eventInfo, isPdp);
    };
    return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "share share-trigger",
                "aria-label": "share",
                tabIndex: "0",
                onClick: handleShare,
                children: [
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: share
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "share-cmp",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSocialShare/* default */.Z, {
                        showModal: showShare,
                        url: pageUrl,
                        onClose: ()=>setShowShare(false),
                        disableInstagram: true,
                        analyticData: getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative", zone, true)
                    })
                })
            })
        ]
    }) : null;
};
/* harmony default export */ var v1_ShareUtility = (ShareUtility);

;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/PrintUtility.jsx




const PrintUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , mainTitle =""  } = param;
    const { print  } = (0,useSearchi18n/* default */.Z)({});
    const handlePrint = ()=>{
        window.print();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        class: "print",
        onClick: ()=>handlePrint(),
        tabIndex: "0",
        "data-gbh-data-layer": getEventInfo(pageType, componentPosition, mainTitle, "print", "", "teaser"),
        "data-gbh-clickable": "true",
        children: [
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: print
            })
        ]
    });
};
/* harmony default export */ var v1_PrintUtility = (PrintUtility);

;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/DownloadUtility.jsx






const DownloadUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , dataLayerLinkType ="" , downLoadLink =null , mainTitle =""  } = param;
    const { download , downloading , downloadSuccess , downloadFailure  } = (0,useSearchi18n/* default */.Z)({});
    const [downloadUrl, setUrl] = (0,react.useState)("");
    const [loading, setLoading] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (downLoadLink) {
            updateUrl();
        }
    }, [
        downLoadLink
    ]);
    const updateUrl = async ()=>{
        const url = await (0,helper/* getShortenedUrl */.Ppy)(downLoadLink);
        setUrl("".concat(constants.authorBaseUrl).concat(url));
    };
    const downloadHandle = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        const getDownloadUrl = downloadUrl ? downloadUrl : window.location.href;
        setLoading(true);
        (0,helper/* downloadArticle */.vIr)(getDownloadUrl, event, callBack, downloadSuccess, downloadFailure);
    };
    const callBack = ()=>{
        setLoading(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "download",
        "aria-label": "download",
        tabIndex: "0",
        children: downLoadLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: downLoadLink,
            className: "download-trigger",
            "data-gbh-data-layer": getDownloadEventInfo(downLoadLink, pageType, componentPosition, mainTitle, dataLayerLinkType),
            "data-gbh-clickable": "true",
            onClick: downloadHandle,
            children: [
                "\xa0",
                loading ? downloading : download
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "download-trigger",
                    "data-gbh-data-layer": getDownloadEventInfo(downLoadLink, pageType, componentPosition, mainTitle, dataLayerLinkType),
                    "data-gbh-clickable": "true",
                    onClick: downloadHandle,
                    children: loading ? downloading : download
                })
            ]
        })
    });
};
/* harmony default export */ var v1_DownloadUtility = (DownloadUtility);

;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/Utilities.jsx







const Utilities = (param)=>{
    let { utilities =[] , title ="" , assetID ="" , imageServerUrl ="" , alt ="" , pageType ="" , dataLayerLinkType ="" , mainTitle ="" , downLoadLink ="" , containerId =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__icons",
        children: utilities.map((item, index)=>{
            switch(item === null || item === void 0 ? void 0 : item.utilitiesType){
                case constants.UTILITY_CONSTANTS.FAVOURITES:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FavouritesUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        containerId: containerId
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.SHARE:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ShareUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        containerId: containerId
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.PRINT:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PrintUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        mainTitle: mainTitle
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.DOWNLOAD:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_DownloadUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        mainTitle: mainTitle,
                        downLoadLink: downLoadLink
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                default:
                    return null;
            }
        })
    });
};
/* harmony default export */ var v1_Utilities = (Utilities);

;// CONCATENATED MODULE: ./components/Default/Teaser/v2/Teaser.jsx

















const Teaser_Teaser = (props)=>{
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data: { id ="" , appliedCssClassNamesCustom ="" , linkURLRef =false , linkNewTab =false , linkAll =false , linkTitle =false , linkImage =false , title ="" , description ="" , enableFav =false , enableShare =false , mainTitle ="" , componentPosition ="" , pageType ="" , linkDescription ="" , linkURL ="" , caption ="" , datalayerLinkName ="" , componentLinkType ="" , eventName ="" , eventAction ="" , actions =[] , downLoadLink =null , expandText ="" , collapseText ="" , disableExpandCollapse ="" , imageResource: { imageServerUrl: imgUrl = "" , imageserverurl ="" , assetID ="" , pretitle: preTitle = "" , urlModifiers ="" , alt =""  } = {} , utilities =[] , utilitiesEnabled =false , dataLayerLinkType =""  } = {} , fullData ={} , showEmptyPlaceholder =false , maxHeight ="" , containerId =""  } = props;
    // fix for image server url missing issue - AS-11175, we will use fallback image server url here
    const imageServerUrl = imgUrl || imageserverurl;
    const [parentActionLink, setParentActionLink] = (0,react.useState)(linkURL);
    const [componentGroup, setComponentGroup] = (0,react.useState)([]);
    const [appliedCssClassNamesCustoms, setAppliedCssClassNamesCustoms] = (0,react.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react.useState)("");
    const [general, setGeneral] = (0,react.useState)(null);
    const [innerCaption, setInnerCaption] = (0,react.useState)(false);
    const [isInsideImage, setIsInsideImage] = (0,react.useState)(false);
    const [activeIndex, setActive] = (0,react.useState)(0);
    const [isFullBleedImageHoverContent, setisFullBleedImageHoverContent] = (0,react.useState)(false);
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [selectedTitle, setSelectedTitle] = (0,react.useState)(null);
    const [selectedImage, setSelectedImage] = (0,react.useState)(null);
    const shouldRenderFirstActionInDescription = appliedCssClassNamesCustom === null || appliedCssClassNamesCustom === void 0 ? void 0 : appliedCssClassNamesCustom.includes("blog-text-hero");
    const openModal = (title, url)=>{
        document.body.style.overflow = "hidden";
        setSelectedTitle(title);
        setSelectedImage(url);
        setShowModal(true);
    };
    const closeModal = ()=>{
        document.body.style.overflow = "unset";
        setSelectedTitle(null);
        setSelectedImage(null);
        setShowModal(false);
    };
    const isCaptionOnly = Boolean(title || description || (actions === null || actions === void 0 ? void 0 : actions.length) || preTitle || assetID || !showEmptyPlaceholder);
    (0,react.useEffect)(()=>{
        if (appliedCssClassNamesCustom === null || appliedCssClassNamesCustom === void 0 ? void 0 : appliedCssClassNamesCustom.includes("full-bleed-image-hover-content")) {
            setisFullBleedImageHoverContent(true);
        }
    }, [
        appliedCssClassNamesCustom
    ]);
    const containerIdName = containerId ? containerId.replace(/-/g, " ") : "zone";
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (assetID) {
            const dynamicId = (0,helper/* createIdFromString */.ZT_)(assetID);
            setDynamicId(dynamicId);
        } else {
            const dynamicId1 = (0,helper/* createIdFromString */.ZT_)((0,helper/* getRandom */.sZz)() + "");
            setDynamicId(dynamicId1);
        }
    }, [
        assetID
    ]);
    (0,react.useEffect)(()=>{
        if (linkURL) {
            (0,helper/* getShortenedUrl */.Ppy)(linkURL).then((res)=>{
                setParentActionLink(res);
            });
        }
    }, [
        linkURL
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setAppliedCssClassNamesCustoms((appliedCssClassNamesCustom)=>[
                        ...appliedCssClassNamesCustom,
                        fullData[key]["appliedCssClassNamesCustom"]
                    ]);
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react.useEffect)(()=>{
        let classNameCustom = "";
        if (componentGroup.length > 0) {
            if (componentGroup.findIndex((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.TEASER);
            }) > -1 && appliedCssClassNamesCustoms.findIndex((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes("hero-banner-article-top");
            }) > -1 && appliedCssClassNamesCustoms.findIndex((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes("hero-banner-article-bottom");
            }) === -1) {
                if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("hero-banner-top-only"))) {
                    classNameCustom += " hero-banner-top-only ";
                }
                if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("paddingbasedbreadcrum")) && componentGroup.findIndex((a)=>{
                    return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
                }) > -1) {
                    classNameCustom += " paddingbasedbreadcrum ";
                }
                if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("without-breadcrumb")) && componentGroup.findIndex((a)=>{
                    return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
                }) === -1) {
                    classNameCustom += " without-breadcrumb ";
                }
            }
        }
        setColumnClassNames((className)=>className += classNameCustom);
    }, [
        componentGroup
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            if (constants.TEASER_CAPTION_CLASSES_LIST.some((classNames)=>{
                return classNames.split(" ").every((className)=>{
                    var ref;
                    return (ref = appliedCssClassNamesCustom === null || appliedCssClassNamesCustom === void 0 ? void 0 : appliedCssClassNamesCustom.trim()) === null || ref === void 0 ? void 0 : ref.includes(className);
                });
            })) {
                setInnerCaption(true);
            }
        }
    }, [
        isSsr,
        pageIsInteractive
    ]);
    (0,react.useEffect)(()=>{
        if (appliedCssClassNamesCustom) {
            checkUtilityPosition();
        }
    }, [
        appliedCssClassNamesCustom
    ]);
    const checkUtilityPosition = ()=>{
        let isInsideImage = false;
        constants.TEASER_CLASSES.forEach((item)=>{
            isInsideImage = appliedCssClassNamesCustom.includes(item);
            if (isInsideImage) {
                setIsInsideImage(isInsideImage);
                return;
            }
        });
    };
    const getDataLayerLinkType = ()=>{
        if (mainTitle || title) {
            return "".concat(pageType, ":").concat(mainTitle || title);
        }
        return dataLayerLinkType;
    };
    const addDataLayer = (link)=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const { pageInfo: { contentType , pageUrl  } , productInfo  } = page;
        if (contentType === "pdp") {
            var ref;
            const eventInfo = {
                eventAction: "pdp:product details:".concat(eventAction || mainTitle),
                eventName: "pdp:product details:".concat(eventName || mainTitle),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(datalayerLinkName),
                internalLinkPosition: "pdp",
                internalLinkType: "pdp:teaser",
                internalLinkZoneName: "pdp:".concat(fullData === null || fullData === void 0 ? void 0 : (ref = fullData.teaser) === null || ref === void 0 ? void 0 : ref.mainTitle),
                internalLinkURL: "".concat(link || pageUrl || "n/a"),
                clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
            };
            const dataLayerObj = {
                event: "cmp:click",
                page,
                eventInfo,
                productInfo
            };
            window.adobeDataLayer.push(dataLayerObj);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "teaser_v2 teaser ".concat(appliedCssClassNamesCustom ? appliedCssClassNamesCustom : "").concat(columnClassNames),
        children: [
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cmp-teaser landscape-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "landscape-modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "s7responsiveContainer cmp-teaser__image",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                                    className: "teaser-pop-up-image",
                                    imgUrl: selectedImage,
                                    alt: "teaser-pop-up-image",
                                    "area-label": "teaser-pop-up-image",
                                    "aria-description": "image of teaser"
                                })
                            }),
                            selectedTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cmp-teaser__title",
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(title)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-modal",
                        onClick: closeModal
                    })
                ]
            }),
            isCaptionOnly ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-teaser",
                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat(linkNewTab ? "false" : "true", '","internalLinkPosition":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"teaser","internalLinkURL":"').concat(linkURL, '","internalLinkName":"').concat(datalayerLinkName, '","eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(containerIdName, ":").concat(eventName || datalayerLinkName || "rm", '","internalLinkType":"').concat(pageType, ":").concat(componentLinkType || mainTitle, '","eventType":"teaser","eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(containerIdName, ":").concat(eventAction || datalayerLinkName || "rm", '"}'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(utils/* ConditionalWrapper */.M2, {
                    condition: linkAll,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: parentActionLink,
                            target: linkNewTab ? "_blank" : "_self",
                            "data-gbh-clickable": "true",
                            rel: "noreferrer",
                            onClick: ()=>addDataLayer(parentActionLink),
                            children: children
                        }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cq-dd-image cmp-teaser__image",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "s7dm-dynamic-media cmp-image",
                                    children: [
                                        appliedCssClassNamesCustom.trim() === "moodboard-landscape-teaser" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "s7responsiveContainer cmp-teaser__image cmp-image__image",
                                            onClick: ()=>openModal(title, "".concat(imageServerUrl).concat(assetID)),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                                                condition: linkImage,
                                                wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: parentActionLink,
                                                        target: linkNewTab ? "_blank" : "_self",
                                                        "data-gbh-clickable": "true",
                                                        rel: "noreferrer",
                                                        children: children
                                                    }),
                                                children: !isSsr ? assetID || showEmptyPlaceholder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                                                    // style={
                                                    //   maxHeight && showEmptyPlaceholder && !assetID
                                                    //     ? { maxHeight }
                                                    //     : {}
                                                    // }
                                                    className: "fluidimage cmp-image__image",
                                                    imgUrl: "".concat(assetID ? "".concat(imageServerUrl).concat(assetID) : constants.EMPTY_PIXEL),
                                                    alt: "",
                                                    itemProp: "contentUrl",
                                                    uniqueId: dynamicId,
                                                    urlModifiers: urlModifiers
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_ImagePlaceHolder, {
                                                    assetID: assetID
                                                }) : null
                                            })
                                        }),
                                        appliedCssClassNamesCustom.trim() !== "moodboard-landscape-teaser" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "s7responsiveContainer cmp-teaser__image cmp-image__image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                                                condition: linkImage,
                                                wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: parentActionLink,
                                                        target: linkNewTab ? "_blank" : "_self",
                                                        "data-gbh-clickable": "true",
                                                        rel: "noreferrer",
                                                        children: children
                                                    }),
                                                children: !isSsr ? assetID || showEmptyPlaceholder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                                                    style: maxHeight && showEmptyPlaceholder && !assetID ? {
                                                        maxHeight
                                                    } : {},
                                                    className: "fluidimage cmp-image__image",
                                                    imgUrl: "".concat(assetID ? "".concat(imageServerUrl).concat(assetID) : constants.EMPTY_PIXEL),
                                                    alt: "",
                                                    itemProp: "contentUrl",
                                                    uniqueId: dynamicId,
                                                    urlModifiers: urlModifiers
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_ImagePlaceHolder, {
                                                    assetID: assetID
                                                }) : null
                                            })
                                        })
                                    ]
                                }),
                                isInsideImage && utilitiesEnabled && (utilities === null || utilities === void 0 ? void 0 : utilities.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Utilities, {
                                    utilities: utilities,
                                    title: title,
                                    assetID: assetID,
                                    imageServerUrl: imageServerUrl,
                                    alt: alt,
                                    pageType: pageType,
                                    dataLayerLinkType: getDataLayerLinkType(),
                                    mainTitle: mainTitle,
                                    downLoadLink: downLoadLink,
                                    containerId: containerId
                                }) : null,
                                caption ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-img-caption",
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(caption)
                                }) : null
                            ]
                        }),
                        title || description || enableFav || enableShare || actions && actions.length || preTitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__content",
                            children: [
                                preTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-teaser__pretitle",
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(preTitle)
                                }) : null,
                                title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-teaser__title",
                                    id: id,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                                        condition: linkTitle,
                                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: linkURL,
                                                rel: linkURLRef ? "noreferrer" : "",
                                                target: linkNewTab ? "_blank" : "_self",
                                                "data-gbh-data-layer": getTitleEventInfo(linkNewTab, componentPosition, linkURL, mainTitle, pageType, componentLinkType),
                                                "data-gbh-clickable": "true",
                                                children: children
                                            }),
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(title)
                                    })
                                }) : null,
                                isFullBleedImageHoverContent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "hover-content-organized",
                                    children: [
                                        description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                                            linkURLRef: linkURLRef,
                                            general: general,
                                            linkNewTab: linkNewTab,
                                            description: description,
                                            mainTitle: mainTitle,
                                            componentPosition: componentPosition,
                                            pageType: pageType,
                                            linkDescription: linkDescription,
                                            expandText: expandText,
                                            collapseText: collapseText,
                                            disableExpandCollapse: disableExpandCollapse
                                        }) : null,
                                        actions && (actions === null || actions === void 0 ? void 0 : actions.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cmp-teaser__action-container",
                                            children: actions.map((action, index)=>{
                                                const { playVideoCTA =false , primaryCTA =false , secondaryCTA =false , url ="" , title ="" , newTab ="" , urlRef =""  } = action;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_Action, {
                                                    playVideoCTA: (0,helper/* convertStringToBoolean */.mUs)(playVideoCTA),
                                                    primaryCTA: (0,helper/* convertStringToBoolean */.mUs)(primaryCTA),
                                                    secondaryCTA: (0,helper/* convertStringToBoolean */.mUs)(secondaryCTA),
                                                    link: url,
                                                    text: title,
                                                    newTab: (0,helper/* convertStringToBoolean */.mUs)(newTab),
                                                    urlRef: urlRef,
                                                    id: id,
                                                    dataLayerLinkType: dataLayerLinkType,
                                                    pageType: pageType,
                                                    linkAll: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                                                    mainTitle: mainTitle,
                                                    index: index,
                                                    activeIndex: activeIndex,
                                                    setActive: setActive
                                                }, "teaser-action-".concat(index + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                                            })
                                        }) : null,
                                        " "
                                    ]
                                }) : null,
                                description && !isFullBleedImageHoverContent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cmp-teaser__description-action",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                                            linkURLRef: linkURLRef,
                                            general: general,
                                            linkNewTab: linkNewTab,
                                            description: description,
                                            mainTitle: mainTitle,
                                            componentPosition: componentPosition,
                                            pageType: pageType,
                                            linkDescription: linkDescription,
                                            expandText: expandText,
                                            collapseText: collapseText,
                                            disableExpandCollapse: disableExpandCollapse
                                        }),
                                        shouldRenderFirstActionInDescription && !isFullBleedImageHoverContent && actions && (actions === null || actions === void 0 ? void 0 : actions.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_Action, {
                                            playVideoCTA: (0,helper/* convertStringToBoolean */.mUs)(actions[0].playVideoCTA),
                                            primaryCTA: (0,helper/* convertStringToBoolean */.mUs)(actions[0].primaryCTA),
                                            secondaryCTA: (0,helper/* convertStringToBoolean */.mUs)(actions[0].secondaryCTA),
                                            link: actions[0].url,
                                            text: actions[0].title,
                                            newTab: (0,helper/* convertStringToBoolean */.mUs)(actions[0].newTab),
                                            urlRef: actions[0].urlRef,
                                            id: id,
                                            dataLayerLinkType: dataLayerLinkType,
                                            pageType: pageType,
                                            linkAll: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                                            mainTitle: mainTitle,
                                            index: 0,
                                            activeIndex: activeIndex,
                                            setActive: setActive
                                        }, "teaser-action-description-".concat((0,helper/* getRandom */.sZz)())) : null
                                    ]
                                }) : null,
                                actions && !isFullBleedImageHoverContent && (actions === null || actions === void 0 ? void 0 : actions.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-teaser__action-container",
                                    children: actions.map((action, index)=>{
                                        if (shouldRenderFirstActionInDescription && index === 0) {
                                            return null;
                                        }
                                        const { playVideoCTA =false , primaryCTA =false , secondaryCTA =false , url ="" , title ="" , newTab ="" , urlRef =""  } = action;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_Action, {
                                            playVideoCTA: (0,helper/* convertStringToBoolean */.mUs)(playVideoCTA),
                                            primaryCTA: (0,helper/* convertStringToBoolean */.mUs)(primaryCTA),
                                            secondaryCTA: (0,helper/* convertStringToBoolean */.mUs)(secondaryCTA),
                                            link: url,
                                            text: title,
                                            newTab: (0,helper/* convertStringToBoolean */.mUs)(newTab),
                                            urlRef: urlRef,
                                            id: id,
                                            dataLayerLinkType: dataLayerLinkType,
                                            pageType: pageType,
                                            linkAll: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                                            mainTitle: mainTitle,
                                            index: index,
                                            activeIndex: activeIndex,
                                            setActive: setActive
                                        }, "teaser-action-".concat(index + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                                    })
                                }) : null,
                                !isInsideImage && utilitiesEnabled && (utilities === null || utilities === void 0 ? void 0 : utilities.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Utilities, {
                                    utilities: utilities,
                                    title: title,
                                    assetID: assetID,
                                    imageServerUrl: imageServerUrl,
                                    alt: alt,
                                    pageType: pageType,
                                    dataLayerLinkType: getDataLayerLinkType(),
                                    mainTitle: mainTitle,
                                    downLoadLink: downLoadLink,
                                    containerId: containerId
                                }) : null
                            ]
                        }) : null
                    ]
                })
            }) : null,
            innerCaption ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-img-caption",
                children: (0,helper/* sanitizeInnerHtml */.KD0)(caption)
            }) : null
        ]
    });
};
/* harmony default export */ var v2_Teaser = (Teaser_Teaser);

;// CONCATENATED MODULE: ./components/Shared/ProductsNavTab.jsx









const ProductsNavTab = (props)=>{
    const { navOpen , selectedTab , setTab , productNavigationItems , eventHandler: { store: { isOpen  }  } , datalayerPageName , hideMobImages , data , isTabOpen  } = props;
    const [isMainTeaserOpen, setIsMainTeaserOpen] = (0,react.useState)(isTabOpen);
    const [isMenuNavOpen, setIsMenuNavOpen] = (0,react.useState)(isTabOpen);
    const handleTeaserOpen = ()=>{
        setIsMainTeaserOpen(false);
        setTab("");
        document.body.style.overflow = "";
    };
    (0,react.useEffect)(()=>{
        setIsMainTeaserOpen(isTabOpen);
        setIsMenuNavOpen(isTabOpen);
        const htmlElement = document.documentElement;
        if (isTabOpen) {
            document.body.style.overflow = "hidden";
            document.body.classList.add("gbh-of-scroll");
            htmlElement.classList.add("menu-open");
        } else {
            document.body.style.overflow = "";
            document.body.classList.remove("gbh-of-scroll");
        }
        return ()=>{
            document.body.style.overflow = "";
            htmlElement.classList.remove("menu-open");
        };
    }, [
        isTabOpen
    ]);
    (0,react.useEffect)(()=>{
        return ()=>{
            setTab("");
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (!isOpen) {
            setTab("");
        }
    }, [
        isOpen
    ]);
    const [activeMainCategory, setActiveMainCategory] = (0,react.useState)("");
    const dispatch = (0,es/* useDispatch */.I0)();
    const toggleMenu = ()=>{
        const gbhNavFindStoreEle = document.querySelector(".gbh-nav__findStore");
        const hideAuthWidgetEle = document.querySelector(".utility-widgets.utility-widgets__brand-switcher");
        setIsMenuNavOpen(false);
        setTab("");
        document.getElementById("main-scroll-close").style.display = "block";
        document.getElementById("scroll-close").style.display = "none";
        if (hideAuthWidgetEle && gbhNavFindStoreEle && hideAuthWidgetEle.style.display === "none") {
            hideAuthWidgetEle.style.display = "flex";
            gbhNavFindStoreEle.style.display = "block";
        }
    };
    const onHoverMainCategory = (name)=>{
        setActiveMainCategory(name);
    };
    const categoryNodeNameCheck = function(data, categoryNodeName) {
        let categoryName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        if (data) {
            const itemsOrder = data[":itemsOrder"];
            return itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((itemOrder, idx)=>{
                const items = data[":items"][itemOrder];
                if (itemOrder === categoryNodeName) {
                    const key = "teaser-categoryNodeNameCheck-".concat(idx);
                    const results = (0,utils/* recursiveDataFunction */.Qe)(items, constants.COMPONENT_TYPES.TEASER);
                    if ((0,utils/* isTeaserV2 */.wX)(results[0])) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_Teaser, {
                            data: results[0]
                        }, key);
                    } else if ((0,utils/* isTeaser */.j$)(results[0])) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
                            data: results[0],
                            categoryName: categoryName
                        }, key);
                    } else return categoryNodeNameCheck(items, categoryNodeName, categoryName);
                } else return categoryNodeNameCheck(items, categoryNodeName, categoryName);
            });
        }
    };
    (0,react.useEffect)(()=>{
        const isOrderSamplePresent = document.querySelectorAll(".order-button.button");
        const isAppointmentPresent = document.querySelectorAll(".appointment-button.button");
        const gbhNavFindStoreEle = document.querySelector(".gbh-nav__findStore");
        const cmpTabsTabListEles = document.querySelectorAll(".cmp-tabs__tab");
        if (isOpen && cmpTabsTabListEles.length) {
            cmpTabsTabListEles.forEach((el)=>el.classList.remove("cmp-tabs__tabpanel--active"));
        }
        const buttonMenuLinkEles = document.querySelectorAll(".kf-react-button.button.cmp-button.large");
        const tabEles = document.querySelectorAll(".cmp-tabs__tab");
        if (buttonMenuLinkEles.length && tabEles.length && isOpen && isMenuNavOpen) {
            buttonMenuLinkEles.forEach((buttonMenuLinkEle)=>{
                buttonMenuLinkEle.style.display = "block";
            });
            tabEles.forEach((tabEle)=>{
                tabEle.style.display = "block";
            });
            isOrderSamplePresent[0] ? isOrderSamplePresent[0].style.display = "none" : null;
            isAppointmentPresent[0] ? isAppointmentPresent[0].style.display = "none" : null;
        }
        const hideAuthWidgetEle = document.querySelector(".utility-widgets.utility-widgets__brand-switcher");
        const isStickyEle = document.querySelector(".is-sticky-load");
        if (!isMenuNavOpen && isOpen) {
            buttonMenuLinkEles.forEach((buttonMenuLinkEle)=>{
                buttonMenuLinkEle.style.display = "block";
            });
            tabEles.forEach((tabEle)=>{
                tabEle.style.display = "block";
            });
            hideAuthWidgetEle.style.display = "flex";
            gbhNavFindStoreEle.style.display = "block";
        }
        if (isOpen) {
            hideAuthWidgetEle.style.display = "none";
            gbhNavFindStoreEle.style.display = "none";
        }
        if (isMenuNavOpen && isStickyEle) {
            isStickyEle.style.display = "none";
        }
    }, [
        isOpen,
        isMenuNavOpen
    ]);
    const closeToggleMenu = ()=>{
        document.querySelectorAll(".ann-sacks-tab-bar, .auth-widget__menu").forEach((a)=>a.style.display = "none");
        document.getElementById("main-scroll-close").style.display = "block";
        const hideAuthWidgetEle = document.querySelector(".utility-widgets.utility-widgets__brand-switcher");
        if (hideAuthWidgetEle) {
            hideAuthWidgetEle.style.display = "flex";
        }
        dispatch((0,genericSlice/* closeMenu */.Wj)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(constants.staticClasses.CONTAINER),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "globalnavigation aem-GridColumn aem-GridColumn--default--12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "gbh-product-menu\n               ".concat(hideMobImages ? "hide-mobile-images" : "", "\n              ").concat(isMainTeaserOpen && isMenuNavOpen ? "open" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "gbh-pro-menu__inner",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        id: "scroll-close",
                                        className: "icon-close-medium icon-close ",
                                        onClick: closeToggleMenu
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "flex-column gbh-pro-menu__list nav",
                                        role: "tablist",
                                        "aria-label": "list of 6",
                                        tabIndex: "0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "gbh-mob-back-btn",
                                                onClick: toggleMenu,
                                                children: "Menu"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "global-menu-selected",
                                                children: selectedTab
                                            }),
                                            productNavigationItems && productNavigationItems.map((item, index)=>{
                                                const key = "productNavigation-".concat(index);
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "nav-item",
                                                    "data-tab": item === null || item === void 0 ? void 0 : item.categoryName,
                                                    role: "tab",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        onMouseOver: ()=>{
                                                            return onHoverMainCategory(item === null || item === void 0 ? void 0 : item.categoryName);
                                                        },
                                                        className: "gbh-data-layer nav-link ".concat((item === null || item === void 0 ? void 0 : item.categoryName) === activeMainCategory ? "link-active" : ""),
                                                        "aria-hidden": "false",
                                                        "aria-label": item === null || item === void 0 ? void 0 : item.categoryName,
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"","internalLinkName":"products > ').concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase(), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                        "data-hover": "tab",
                                                        "data-target": "#submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                        "aria-controls": "submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                        rel: "noreferrer",
                                                        role: "tab",
                                                        tabIndex: "0",
                                                        href: !(item === null || item === void 0 ? void 0 : item.categoryLinkRef) && (item === null || item === void 0 ? void 0 : item.categoryLink) ? (0,helper/* removeAndCleanLink */.xEh)(item === null || item === void 0 ? void 0 : item.categoryLink) : null,
                                                        "aria-selected": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                        "aria-expanded": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                        children: item === null || item === void 0 ? void 0 : item.categoryName
                                                    })
                                                }, key);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tab-content gbh-pro-menu__cont",
                                        children: productNavigationItems && productNavigationItems.map((mainCategory, i)=>{
                                            const key = "mainCategory-".concat(i);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tab-pane fade ".concat((mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName) === activeMainCategory ? "active show" : ""),
                                                role: "tabpanel",
                                                "aria-labelledby": mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName,
                                                children: data && categoryNodeNameCheck(data, mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryNodeName, mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName)
                                            }, key);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "gbh-promenu-close-btn icon-Close-Large",
                                        "aria-label": "close",
                                        role: "button",
                                        tabIndex: "0",
                                        onClick: ()=>handleTeaserOpen()
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "productbg ".concat(navOpen === "Products" ? "open" : "")
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Shared_ProductsNavTab = (ProductsNavTab);

;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs.jsx






const HeaderNavTabs = (props)=>{
    const { data , isTabOpen , eventHandler , eventHandler: { store: { isOpen  }  } , selectedTab , setTab  } = props;
    const { pageIsInteractive , datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [productNavigationItems, setProductNavigationItems] = (0,react.useState)(null);
    const [hideMobImages, setHideMobImages] = (0,react.useState)(false);
    const [navOpen, setNavOpen] = (0,react.useState)("");
    const [showMobileImages, setShowMobileImages] = (0,react.useState)(true);
    const dataRecursion = (0,react.useCallback)((data)=>{
        const { mainNavigation , categoryItems , hideMobileImages  } = data;
        if (data && mainNavigation === "Products") {
            setProductNavigationItems(categoryItems);
            setHideMobImages(hideMobileImages);
        }
        if (data && data[":itemsOrder"]) {
            data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                return dataRecursion(item);
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (lib/* isMobile */.tq && hideMobImages) {
            setShowMobileImages(false);
        } else {
            setShowMobileImages(true);
        }
    }, [
        hideMobImages,
        lib/* isMobile */.tq
    ]);
    (0,react.useEffect)(()=>{
        dataRecursion(data);
    }, [
        data,
        dataRecursion
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: pageIsInteractive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_ProductsNavTab, {
            productNavigationItems: productNavigationItems,
            navOpen: navOpen,
            setNavOpen: (data)=>setNavOpen(data),
            isOpen: isOpen,
            eventHandler: eventHandler,
            datalayerPageName: datalayerPageName,
            selectedTab: selectedTab,
            hideMobImages: hideMobImages,
            showMobileImages: showMobileImages,
            data: data,
            isTabOpen: isTabOpen,
            setTab: setTab
        })
    });
};
/* harmony default export */ var Shared_HeaderNavTabs = (HeaderNavTabs);

// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.jsx
var UtilityWidgets = __webpack_require__(55938);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./src/components/Shared/HeaderNavTabs/index.module.scss
var HeaderNavTabs_index_module = __webpack_require__(12133);
var HeaderNavTabs_index_module_default = /*#__PURE__*/__webpack_require__.n(HeaderNavTabs_index_module);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/index.js
var HeaderNavTabs_analytics = __webpack_require__(24897);
// EXTERNAL MODULE: ./src/components/core/SmartCropImage/index.jsx
var SmartCropImage = __webpack_require__(97729);
// EXTERNAL MODULE: ./src/hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83839);
;// CONCATENATED MODULE: ./src/components/Shared/HeaderNavTabs/HeaderNavTabsV3.jsx










const HeaderNavTabsV3 = (props)=>{
    var ref;
    const { data , columnClassNames ="" , eventHandler: { store: { isOpen  } , callbacks: { // eslint-disable-next-line no-console
    toggleMenu =()=>console.log("Event Not Defined") , // eslint-disable-next-line no-console
    setMainCategory =()=>console.log("Event Not Defined")  }  }  } = props;
    const caretimg = "/icons/bold.svg";
    const externalicon = "/icons/externalicon.svg";
    const caretimgWhite = "/icons/bold-white.svg";
    const externalIconWhite = "/icons/external link.svg";
    const [navOpen, setNavOpen] = (0,react.useState)("");
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const [selectedTab, setTab] = (0,react.useState)("");
    const [darkThemeFlag, setDarkThemeFlag] = (0,react.useState)(false);
    const menuVisible = (0,react.useRef)(0);
    const dataRecursion = (0,react.useCallback)((data)=>{
        if (data && data[":itemsOrder"]) {
            data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                return dataRecursion(item);
            });
        }
    }, []);
    const onClickNav = (data)=>{
        if (data) {
            if (selectedTab !== data["cq:panelTitle"]) {
                setTab(data["cq:panelTitle"]);
            }
            if (navOpen !== data["cq:panelTitle"]) {
                setNavOpen(data["cq:panelTitle"]);
                if (!lib/* isMobile */.tq) {
                    setNavOpen(data["cq:panelTitle"]);
                }
                setMainCategory({
                    item: data["cq:panelTitle"]
                });
                menuVisible.current = 1;
                (0,helper/* preventBodyScrollTab */.aCP)(true);
                addHeaderNavTabAnalytics(data);
            }
        }
    };
    const handleMouseLeave = ()=>{
        setNavOpen("");
        setTab("");
        setMainCategory({
            item: ""
        });
        menuVisible.current = 0;
        (0,helper/* preventBodyScrollTab */.aCP)(false);
    };
    const addHeaderNavTabAnalytics = (data)=>{
        var ref, ref1, ref2;
        const eventInfo = {
            eventAction: "global header:".concat((ref = data["cq:panelTitle"]) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            eventName: "global header:".concat((ref1 = data["cq:panelTitle"]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
            eventType: "tab",
            internalLinkName: (ref2 = data["cq:panelTitle"]) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(),
            internalLinkPosition: "global header",
            internalLinkType: "global navigation",
            internalLinkZoneName: "global header",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click");
    };
    const onMenuClickEvent = (e)=>{
        var ref, ref1, ref2, ref3, ref4;
        if (((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("gbh-pro-menu__inner")) || (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : ref2.closest(".gbh-pro-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref3 = e.target) === null || ref3 === void 0 ? void 0 : ref3.closest(".gbh-full-w-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref4 = e.target) === null || ref4 === void 0 ? void 0 : ref4.closest(".cmp-tabs__tablist")) === null && !lib/* isMobile */.tq) && menuVisible.current) {
            setNavOpen("");
            setTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper/* preventBodyScrollTab */.aCP)(false);
        }
    };
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        if (document === null || document === void 0 ? void 0 : (ref = document.getElementsByTagName) === null || ref === void 0 ? void 0 : (ref1 = ref.call(document, "body")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.className) === null || ref3 === void 0 ? void 0 : ref3.includes("nav-dark-theme")) {
            setDarkThemeFlag(true);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (navOpen) {
            document.addEventListener("click", onMenuClickEvent);
        } else {
            document.removeEventListener("click", onMenuClickEvent);
        }
        return ()=>document.removeEventListener("click", onMenuClickEvent);
    }, [
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        dataRecursion(data);
    }, [
        data,
        dataRecursion
    ]);
    const getInternalLinkURLS = (url)=>{
        if (true) {
            return (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) || url === null ? false : true;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "HEADER ID",
        className: (HeaderNavTabs_index_module_default()).headerNavV3Wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tabs ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "gbh-global-tab", " ").concat(columnClassNames ? columnClassNames : "", " ").concat(isOpen ? "open" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cmp-tabs ".concat(darkThemeFlag ? "dark-theme" : "light-theme"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "gbh-hamber-menu gbh-close icon-Close-Medium",
                        "aria-label": "close button",
                        tabIndex: "0",
                        onClick: ()=>{
                            toggleMenu();
                            onClickNav({
                                "cq:panelTitle": navOpen
                            });
                            (0,HeaderNavTabs_analytics/* addAnalyticsOnClose */.hJ)();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        onMouseLeave: ()=>handleMouseLeave(),
                        role: "tablist",
                        className: "cmp-tabs__tablist",
                        "aria-multiselectable": "false",
                        onMouseOver: (event)=>{
                            onClickNav(data[":items"][event.target.id]);
                        },
                        children: [
                            data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                                const item = data[":items"][key];
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    id: key,
                                    role: "tab",
                                    className: "cmp-tabs__tab ".concat(selectedTab == item["cq:panelTitle"] ? "cmp-tabs__tab--active" : ""),
                                    tabIndex: "0",
                                    children: item["cq:panelTitle"]
                                }, "navItem-".concat(index));
                            }),
                            (data === null || data === void 0 ? void 0 : data.mainTabId) && Object.keys(data === null || data === void 0 ? void 0 : data.mainTabId).map((key, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    role: "tab",
                                    className: "cmp-tabs__tab",
                                    tabIndex: "0",
                                    children: key
                                }, "navItem-".concat(index));
                            }),
                            data[":itemsOrder"] ? (ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.map((key, index)=>{
                                const element = {
                                    ...data[":items"]
                                }[key];
                                if (element) {
                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
                                    const item = ((ref = element[":items"]) === null || ref === void 0 ? void 0 : ref.globalnavigation) || ((ref1 = element[":items"]) === null || ref1 === void 0 ? void 0 : ref1.globalnavigation_v3);
                                    const menuType = item === null || item === void 0 ? void 0 : item.navigationMenuType;
                                    var ref26, ref27;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        role: "tabpanel",
                                        tabIndex: "-1",
                                        className: "cmp-tabs__tabpanel ".concat(navOpen === element["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat(constants.staticClasses.CONTAINER),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cmp-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "globalnavigation aem-GridColumn aem-GridColumn--default--11",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "gbh-full-w-menu",
                                                                onMouseLeave: handleMouseLeave,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "bg-dim",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__inner",
                                                                        id: "Mouse id",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "gbh-full-max-width",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "menu-container ".concat(darkThemeFlag ? "dark-theme" : "light-theme", " ").concat(menuType),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "gbh-full-w-menu__left-cont ".concat(menuType),
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "gbh-full-w-menu__left-cont__top",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "levelZero",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                                                    className: "nav flex-column gbh-full-w-menu__left-cont__menu-list",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                                            className: "gbh-mob-back-btn",
                                                                                                            children: "Menu"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                            className: "level-one-container",
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                                className: "level-one-sub-container",
                                                                                                                children: [
                                                                                                                    (item === null || item === void 0 ? void 0 : item.navTitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                        className: "group-title",
                                                                                                                        children: item === null || item === void 0 ? void 0 : item.navTitle
                                                                                                                    }) : null,
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                        className: "level-one-nav-multi",
                                                                                                                        children: item === null || item === void 0 ? void 0 : (ref2 = item.levelOneNavMulti) === null || ref2 === void 0 ? void 0 : ref2.map((navItem, index)=>{
                                                                                                                            var ref, ref1;
                                                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                                className: "levelTwoMapping ".concat(menuType + ((item === null || item === void 0 ? void 0 : (ref = item.levelOneNavMulti) === null || ref === void 0 ? void 0 : ref.length) === 1 ? "-one-col" : "")),
                                                                                                                                children: navItem === null || navItem === void 0 ? void 0 : (ref1 = navItem.levelTwoNavMulti) === null || ref1 === void 0 ? void 0 : ref1.map((levelTwo, index)=>{
                                                                                                                                    var ref, ref1, ref2, ref3, ref4;
                                                                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                                                                        className: (levelTwo === null || levelTwo === void 0 ? void 0 : (ref = levelTwo.groupTitle) === null || ref === void 0 ? void 0 : ref.includes("carrot-icon")) ? "carot-title" : "",
                                                                                                                                        children: [
                                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                                                                className: "menu-item-tiles",
                                                                                                                                                children: [
                                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                                                                        className: "menuItems ".concat(menuType, " ").concat((levelTwo === null || levelTwo === void 0 ? void 0 : (ref1 = levelTwo.groupTitle) === null || ref1 === void 0 ? void 0 : ref1.includes("carrot-icon")) ? "carot-icon" : ""),
                                                                                                                                                        href: levelTwo === null || levelTwo === void 0 ? void 0 : (ref2 = levelTwo.groupLink) === null || ref2 === void 0 ? void 0 : ref2.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                                                                                                        dangerouslySetInnerHTML: {
                                                                                                                                                            __html: browser_default().sanitize(levelTwo === null || levelTwo === void 0 ? void 0 : levelTwo.groupTitle)
                                                                                                                                                        }
                                                                                                                                                    }),
                                                                                                                                                    (levelTwo === null || levelTwo === void 0 ? void 0 : (ref3 = levelTwo.groupTitle) === null || ref3 === void 0 ? void 0 : ref3.includes("carrot-icon")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                                                        className: "navigation-img",
                                                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                                                            src: darkThemeFlag ? caretimgWhite : caretimg,
                                                                                                                                                            alt: "caret-icon"
                                                                                                                                                        })
                                                                                                                                                    }) : null,
                                                                                                                                                    getInternalLinkURLS(levelTwo === null || levelTwo === void 0 ? void 0 : levelTwo.groupLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                                                        className: "navigation-external-img",
                                                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                                                            src: darkThemeFlag ? externalIconWhite : externalicon,
                                                                                                                                                            alt: "external-icon"
                                                                                                                                                        })
                                                                                                                                                    }) : null
                                                                                                                                                ]
                                                                                                                                            }),
                                                                                                                                            levelTwo === null || levelTwo === void 0 ? void 0 : (ref4 = levelTwo.levelThreeNavMulti) === null || ref4 === void 0 ? void 0 : ref4.map((columnItems, index)=>{
                                                                                                                                                var ref;
                                                                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                                                                    className: "nav-item",
                                                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                                                                                        href: columnItems === null || columnItems === void 0 ? void 0 : (ref = columnItems.link) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                                                                                                        children: [
                                                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                                                                className: "menu-labels",
                                                                                                                                                                dangerouslySetInnerHTML: {
                                                                                                                                                                    __html: browser_default().sanitize(columnItems.label)
                                                                                                                                                                }
                                                                                                                                                            }),
                                                                                                                                                            getInternalLinkURLS(columnItems === null || columnItems === void 0 ? void 0 : columnItems.link) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                                                                className: "navigation-external-img",
                                                                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                                                                    src: darkThemeFlag ? externalIconWhite : externalicon,
                                                                                                                                                                    alt: "external-icon"
                                                                                                                                                                })
                                                                                                                                                            }) : null
                                                                                                                                                        ]
                                                                                                                                                    })
                                                                                                                                                }, "navItem-".concat(index));
                                                                                                                                            })
                                                                                                                                        ]
                                                                                                                                    }, navItem + index);
                                                                                                                                })
                                                                                                                            }, navItem + index);
                                                                                                                        })
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "gbh-full-w-menu__right-img",
                                                                                        children: [
                                                                                            (item === null || item === void 0 ? void 0 : (ref3 = item.multiCTA) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "right-img-cta",
                                                                                                children: item === null || item === void 0 ? void 0 : (ref4 = item.multiCTA) === null || ref4 === void 0 ? void 0 : ref4.map((ctaItem, index)=>{
                                                                                                    var ref;
                                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                                                                                        className: "multicta",
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                            className: "navigationcta",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                    className: "ctalable",
                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                                        rel: "noreferrer",
                                                                                                                        target: (ctaItem === null || ctaItem === void 0 ? void 0 : ctaItem.newTabCTA) ? "_blank" : "_self",
                                                                                                                        href: ctaItem === null || ctaItem === void 0 ? void 0 : (ref = ctaItem.ctaLink) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                            dangerouslySetInnerHTML: {
                                                                                                                                __html: browser_default().sanitize(ctaItem.ctaLabel)
                                                                                                                            }
                                                                                                                        })
                                                                                                                    })
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                    className: "cta-img",
                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                        src: darkThemeFlag ? caretimgWhite : caretimg,
                                                                                                                        alt: "caret-icon"
                                                                                                                    })
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    }, "navItem-".concat(index));
                                                                                                })
                                                                                            }) : null,
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "block-images ".concat(menuType),
                                                                                                children: [
                                                                                                    (item === null || item === void 0 ? void 0 : item.firstImagesblock) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        className: "".concat(element === null || element === void 0 ? void 0 : element.appliedCssClassNames, " ").concat(menuType),
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                                style: {
                                                                                                                    cursor: "pointer"
                                                                                                                },
                                                                                                                target: (item === null || item === void 0 ? void 0 : (ref5 = item.firstImagesblock) === null || ref5 === void 0 ? void 0 : ref5.newTabFirstImage) ? "_blank" : "_self",
                                                                                                                href: item === null || item === void 0 ? void 0 : (ref6 = item.firstImagesblock) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.firstImageLink) === null || ref7 === void 0 ? void 0 : ref7.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                                                                rel: "noreferrer",
                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                                                                                                    url: item === null || item === void 0 ? void 0 : (ref8 = item.firstImagesblock) === null || ref8 === void 0 ? void 0 : ref8.firstImageFileReference,
                                                                                                                    className: "cmp-image__image",
                                                                                                                    smartCrop: smartCrop,
                                                                                                                    altText: (ref26 = item === null || item === void 0 ? void 0 : (ref9 = item.firstImagesblock) === null || ref9 === void 0 ? void 0 : ref9.altText) !== null && ref26 !== void 0 ? ref26 : ""
                                                                                                                })
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                dangerouslySetInnerHTML: {
                                                                                                                    __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : (ref10 = item.firstImagesblock) === null || ref10 === void 0 ? void 0 : ref10.firstImageTitle)
                                                                                                                }
                                                                                                            }),
                                                                                                            (item === null || item === void 0 ? void 0 : (ref11 = item.firstImagesblock) === null || ref11 === void 0 ? void 0 : ref11.ctaLink) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                                className: "image-cta",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                        className: "div-of-cta",
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                                            href: item === null || item === void 0 ? void 0 : (ref12 = item.firstImagesblock) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.ctaLink) === null || ref13 === void 0 ? void 0 : ref13.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                                                                            dangerouslySetInnerHTML: {
                                                                                                                                __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : (ref14 = item.firstImagesblock) === null || ref14 === void 0 ? void 0 : ref14.ctaLabel)
                                                                                                                            }
                                                                                                                        })
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                        className: "cta-link-caret",
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                            src: darkThemeFlag ? caretimgWhite : caretimg,
                                                                                                                            alt: "caret-icon"
                                                                                                                        })
                                                                                                                    })
                                                                                                                ]
                                                                                                            }) : null
                                                                                                        ]
                                                                                                    }) : null,
                                                                                                    (item === null || item === void 0 ? void 0 : item.secondImagesblock) && (item === null || item === void 0 ? void 0 : (ref15 = item.levelOneNavMulti) === null || ref15 === void 0 ? void 0 : ref15.length) < 3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        className: "".concat(element === null || element === void 0 ? void 0 : element.appliedCssClassNames, " ").concat(menuType),
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                                style: {
                                                                                                                    cursor: "pointer"
                                                                                                                },
                                                                                                                target: (item === null || item === void 0 ? void 0 : (ref16 = item.secondImagesblock) === null || ref16 === void 0 ? void 0 : ref16.newTabSecondImage) ? "_blank" : "_self",
                                                                                                                href: item === null || item === void 0 ? void 0 : (ref17 = item.secondImagesblock) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.secondImageLink) === null || ref18 === void 0 ? void 0 : ref18.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                                                                rel: "noreferrer",
                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                                                                                                    url: item === null || item === void 0 ? void 0 : (ref19 = item.secondImagesblock) === null || ref19 === void 0 ? void 0 : ref19.secondImageFileReference,
                                                                                                                    className: "cmp-image__image",
                                                                                                                    smartCrop: smartCrop,
                                                                                                                    altText: (ref27 = item === null || item === void 0 ? void 0 : (ref20 = item.secondImagesblock) === null || ref20 === void 0 ? void 0 : ref20.altText) !== null && ref27 !== void 0 ? ref27 : ""
                                                                                                                })
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                dangerouslySetInnerHTML: {
                                                                                                                    __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : (ref21 = item.secondImagesblock) === null || ref21 === void 0 ? void 0 : ref21.secondImageTitle)
                                                                                                                }
                                                                                                            }),
                                                                                                            (item === null || item === void 0 ? void 0 : (ref22 = item.secondImagesblock) === null || ref22 === void 0 ? void 0 : ref22.ctaLink) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                                className: "image-cta",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                        className: "div-of-cta",
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                                            href: item === null || item === void 0 ? void 0 : (ref23 = item.secondImagesblock) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.ctaLink) === null || ref24 === void 0 ? void 0 : ref24.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                                                                            dangerouslySetInnerHTML: {
                                                                                                                                __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : (ref25 = item.secondImagesblock) === null || ref25 === void 0 ? void 0 : ref25.ctaLabel)
                                                                                                                            }
                                                                                                                        })
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                        className: "cta-link-caret",
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                            src: darkThemeFlag ? caretimgWhite : caretimg,
                                                                                                                            alt: "caret-icon"
                                                                                                                        })
                                                                                                                    })
                                                                                                                ]
                                                                                                            }) : null
                                                                                                        ]
                                                                                                    }) : null
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "productbg"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    }, "navTabs-".concat(index));
                                }
                            }) : null
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var HeaderNavTabs_HeaderNavTabsV3 = (HeaderNavTabsV3);

;// CONCATENATED MODULE: ./src/components/Shared/HeaderNav.jsx












const HeaderNav = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { menu: { isOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data ={} , eventHandler , v3 =false  } = props;
    const toggleMenu = ()=>{
        isOpen ? dispatch((0,genericSlice/* closeMenu */.Wj)()) : dispatch((0,genericSlice/* openMenu */.qn)());
    };
    const [scrollDir, setScrollDir] = (0,react.useState)("scrolling down");
    const [lastScrollY, setLastScrollY] = (0,react.useState)(0);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const threshold = 0;
        let lastScrollY = window.pageYOffset;
        let ticking = false;
        const updateScrollDir = ()=>{
            const scrollY = window.pageYOffset;
            if (Math.abs(scrollY - lastScrollY) < threshold) {
                ticking = false;
                return;
            }
            if (!document.body.classList.contains("gbh-of-scroll")) setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
            lastScrollY = scrollY > 0 ? scrollY : 1;
            ticking = false;
            setLastScrollY(lastScrollY);
        };
        const onScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }
        };
        const onScrollThrottle = throttle_default()(onScroll, 1000);
        if ((router === null || router === void 0 ? void 0 : router.pathname) !== "/checkout") {
            window.removeEventListener("scroll", onScrollThrottle);
            window.addEventListener("scroll", onScrollThrottle);
        }
        return ()=>window.removeEventListener("scroll", onScrollThrottle);
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        if (scrollDir === "scrolling down") {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", "nav-down", "nav-up");
            (0,utils/* alterClass */.bU)("sticky-plp-listing", "nav-down", "nav-up");
            (0,utils/* alterClass */.bU)("sticky-pdp-page", "nav-down", "nav-up");
        } else if (scrollDir === "scrolling up") {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", "nav-up", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-plp-listing", "nav-up", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-pdp-page", "nav-up", "nav-down");
        } else return;
    }, [
        scrollDir,
        lastScrollY
    ]);
    (0,react.useEffect)(()=>{
        if (lastScrollY < 200) {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", null, "nav-down");
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", null, "nav-up");
        }
    }, [
        lastScrollY,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(data === null || data === void 0 ? void 0 : data.gridClassNames),
        children: data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            if (key.includes("image")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavLogo, {
                    data: item,
                    columnClassNames: "".concat(data.columnClassNames[key]),
                    eventHandler: eventHandler
                }, "logo-".concat(index));
            }
            if (key === "tabs") {
                if (v3) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavTabs_HeaderNavTabsV3, {
                        data: item,
                        columnClassNames: "".concat(data === null || data === void 0 ? void 0 : (ref = data.columnClassNames) === null || ref === void 0 ? void 0 : ref.key),
                        isOpen: isOpen,
                        toggleMenu: toggleMenu,
                        eventHandler: eventHandler
                    }, "tabs-".concat(index));
                } else {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavTabs, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        isOpen: isOpen,
                        toggleMenu: toggleMenu,
                        eventHandler: eventHandler
                    }, "tabs-".concat(index));
                }
            }
            if (key === "utilitywidgets") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityWidgets/* default */.Z, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        eventHandler: eventHandler
                    }) : null
                }, "utilitywidgets-".concat(index));
            }
            return null;
        })
    });
};
/* harmony default export */ var Shared_HeaderNav = (HeaderNav);

;// CONCATENATED MODULE: ./components/Shared/analytics.js

const addLogoDatalayer = (url, title)=>{
    var ref;
    const brandName = (ref = title === null || title === void 0 ? void 0 : title.replace(" ", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    const eventInfo = {
        eventAction: "header ".concat(brandName, " logo"),
        eventName: "header ".concat(brandName, " logo"),
        eventType: "click",
        internalLinkName: "header ".concat(brandName, " logo"),
        internalLinkPosition: "global header",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        internalLinkURL: url || "n/a",
        clickInternalLinks: "true"
    };
    return JSON.stringify(eventInfo);
};
const addNavTabDatalayer = async (params)=>{
    const { title , url  } = params;
    const eventInfo = {
        eventAction: "global header:".concat(title),
        eventName: "global header:".concat(title),
        eventType: "navigation",
        internalLinkName: "".concat(title),
        internalLinkPosition: "global header",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        internalLinkURL: "".concat(window.location.origin).concat(await (0,utils_location/* getShortenedUrl */.Pp)(url)) || "n/a",
        clickInternalLinks: "true"
    };
    const page = window.adobeDataLayer.getState("page");
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};

;// CONCATENATED MODULE: ./components/Shared/BrandLogo.jsx








const BrandLogo = (props)=>{
    var ref;
    const { data , columnClassNames , eventHandler: { store: { brandLogoImg =""  } = {} , callbacks: { setBrandLogoImg =()=>console.log("Event Not Defined")  }  }  } = props;
    const { menu: { isOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const toggleMenu = ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        const hideAuthWidgetEle = document.querySelector(".utility-widgets.utility-widgets__brand-switcher");
        if (hideAuthWidgetEle && hideAuthWidgetEle.style.display === "none") {
            hideAuthWidgetEle.style.display = "flex";
        }
        isOpen ? (dispatch((0,genericSlice/* closeMenu */.Wj)()), (ref = document.querySelector(".page", ".basicpage")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("gbh-of-scroll"), (ref2 = document.querySelector(".ann-sacks-main-menu.header-container.ann-sacks-tab-bar")) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.classList) === null || ref3 === void 0 ? void 0 : ref3.remove("ann-sacks-tab-menu", "button-format")) : (dispatch((0,genericSlice/* openMenu */.qn)()), (ref4 = document.querySelector(".ann-sacks-main-menu.ann-sacks-tab-bar > div:first-child")) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.classList) === null || ref5 === void 0 ? void 0 : ref5.add("icon-close-medium", "icon-Close-Medium", "icon-close"), (ref6 = document.querySelector(".page", ".basicpage")) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.classList) === null || ref7 === void 0 ? void 0 : ref7.add("gbh-of-scroll"), (ref8 = document.querySelector(".ann-sacks-main-menu.header-container.ann-sacks-tab-bar")) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.classList) === null || ref9 === void 0 ? void 0 : ref9.add("ann-sacks-tab-menu", "button-format"));
    };
    (0,react.useEffect)(()=>{
        var ref;
        if ((data === null || data === void 0 ? void 0 : data.dataLayer[data === null || data === void 0 ? void 0 : data.id]) && ((ref = data === null || data === void 0 ? void 0 : data.dataLayer[data === null || data === void 0 ? void 0 : data.id]) === null || ref === void 0 ? void 0 : ref.image)) {
            var ref1;
            const brandLogoPath = (ref1 = data === null || data === void 0 ? void 0 : data.dataLayer[data === null || data === void 0 ? void 0 : data.id]) === null || ref1 === void 0 ? void 0 : ref1.image["repo:path"];
            brandLogoPath && setBrandLogoImg(constants.authorBaseUrl + brandLogoPath);
        }
    }, [
        data
    ]);
    const logoUrlPath = (data === null || data === void 0 ? void 0 : (ref = data.link) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", "")) || "https://annsacks.kohler.com";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                id: "main-scroll-close",
                className: "gbh-hamber-menu icon-Hamburger ".concat(isOpen ? "icon-close-medium icon-close" : ""),
                tabIndex: "0",
                "aria-label": "Hamburger-menu",
                role: "button",
                onClick: toggleMenu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp cmp-image ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: logoUrlPath,
                    title: data === null || data === void 0 ? void 0 : data.alt,
                    className: "cmp-image--link gbh-data-layer",
                    "data-gbh-data-layer": addLogoDatalayer(logoUrlPath, data === null || data === void 0 ? void 0 : data.alt),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: brandLogoImg && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(brandLogoImg),
                            height: BLOK_LOGO.height,
                            width: BLOK_LOGO.width,
                            alt: data === null || data === void 0 ? void 0 : data.alt
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_BrandLogo = (BrandLogo);

;// CONCATENATED MODULE: ./components/Shared/LogoHeader.jsx










const LogoHeader = (props)=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { data , eventHandler  } = props;
    const [bpNumber, setBpNumber] = (0,react.useState)("");
    const [findStoreUtilityDetails, setFindStoreUtilityDetails] = (0,react.useState)(null);
    const shortendPagePath = "/content/annsacks/us/en";
    const getStoreUrl = (bpNumber, link)=>{
        const shortUrl = shortendPagePath !== null && shortendPagePath !== void 0 ? shortendPagePath : "";
        const htmlRegExp = new RegExp(".html", "g");
        const shortUrlRegEx = new RegExp(shortUrl, "g");
        if (bpNumber && bpNumber !== "0") {
            const bpNumberProcessed = findStoreUtilityDetails[bpNumber];
            const htmlRemovedUrl = "".concat(bpNumberProcessed === null || bpNumberProcessed === void 0 ? void 0 : bpNumberProcessed.replace(htmlRegExp, ""));
            return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
        } else if (link) {
            const htmlRemovedUrl1 = "".concat(link.replace(htmlRegExp, ""));
            return "".concat(htmlRemovedUrl1 === null || htmlRemovedUrl1 === void 0 ? void 0 : htmlRemovedUrl1.replace(shortUrlRegEx, ""));
        }
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            if (bpNumber) {
                const utilityStoreDetailsUrl = get_default()(config, "general.storeDetailsServletPath", "");
                (0,utils_location/* getUtilityStoreDetails */.BO)({
                    utilityStoreDetailsUrl
                }).then((res)=>{
                    if (res) {
                        setFindStoreUtilityDetails(res);
                    }
                });
            }
        });
    }, [
        bpNumber
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        setBpNumber((ref = localStorage.getItem("myStoreId")) !== null && ref !== void 0 ? ref : "");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            if (key.includes("image")) {
                const imageKey = "logo-".concat(index);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandLogo, {
                            data: item,
                            columnClassNames: "".concat(data.columnClassNames[key]),
                            eventHandler: eventHandler
                        }),
                        !isSsr && /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityWidgets/* default */.Z, {
                            data: item,
                            columnClassNames: "".concat(data.columnClassNames[key]),
                            eventHandler: eventHandler
                        })
                    ]
                }, imageKey);
            }
            if (key.includes("button")) {
                const { text , appliedCssClassNames , link  } = item;
                const buttonKey = "button-".concat(index);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(appliedCssClassNames, " button"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        label: text,
                        className: "cmp-button",
                        tag: "anchor",
                        type: "-",
                        to: (text === null || text === void 0 ? void 0 : text.includes("Request")) && bpNumber && bpNumber !== "0" && findStoreUtilityDetails ? getStoreUrl(bpNumber, null) : getStoreUrl(null, link),
                        size: "-",
                        useDefaultClass: false,
                        onClick: ()=>{
                            addNavTabDatalayer({
                                title: text.toLowerCase(),
                                url: link
                            });
                        }
                    })
                }, buttonKey);
            }
            if (key.includes("utilitywidgets")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityWidgets/* default */.Z, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        eventHandler: eventHandler
                    }) : null
                }, "utilitywidgets-".concat(index));
            }
            return null;
        })
    });
};
/* harmony default export */ var Shared_LogoHeader = (LogoHeader);

;// CONCATENATED MODULE: ./src/components/Default/Video/videoAnalytics.js


let analyticsTimer;
const pushClickEvent = (eventInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    if (isEmpty_default()(page)) {
        analyticsTimer = setTimeout(()=>pushClickEvent(eventInfo), 500);
        return;
    }
    if (analyticsTimer) {
        clearTimeout(analyticsTimer);
    }
    Object.keys(eventInfo).forEach((key)=>{
        if (eventInfo[key].includes(":rm")) {
            let _eventInfo$key;
            eventInfo[key] = (_eventInfo$key = eventInfo[key]) === null || _eventInfo$key === void 0 ? void 0 : _eventInfo$key.replace(/:rm/g, "");
        }
    });
    if (eventInfo) {
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo: eventInfo,
            page: page
        });
    }
};
const getComponentZone = (element)=>{
    const container = (0,utils/* closest */.oq)(element, (el)=>el.className === "cmp-container");
    const zoneName = container.getAttribute("id");
    if (zoneName) {
        return zoneName.toLowerCase().replaceAll("-", " ");
    } else {
        return "";
    }
};
const shareVideoDatalayer = (eventPageType, componentZone, componentLinkType, videoTitle)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventTypeTittle = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType;
    const eventtitle = eventTypeTittle === "locations" ? "location:kohler stores" : eventPageType;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":share"),
        eventMsg: "n/a",
        eventName: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":share"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "share",
        internalLinkPosition: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase()),
        internalLinkType: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":share"),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":").concat(videoTitle)
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const playVideoDatalayer = (element, video, setFavVideoIdCb, videoModalClose)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const container = (0,utils/* closest */.oq)(element, (el)=>el.className.includes("cmp-teaser__image"));
    const nearestDatalayerAttribute = container === null || container === void 0 ? void 0 : container.getAttribute("data-gbh-data-layer");
    const videoIdAttribute = video;
    const jsonObject = JSON.parse(nearestDatalayerAttribute.replaceAll(/(\r\n|\n|\r)/gm, ""));
    if ((page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType) === "locations") {
        const pageType = "locations:kohler stores";
        jsonObject["internalLinkZoneName"] = pageType + ":" + getComponentZone(element);
        jsonObject["eventName"] = pageType + ":" + getComponentZone(element);
        jsonObject["internalLinkType"] = pageType + ":" + getComponentZone(element);
        jsonObject["internalLinkPosition"] = pageType + ":" + "teaser";
    } else {
        jsonObject["internalLinkZoneName"] = window.eventPageType + ":" + getComponentZone(element);
        jsonObject["eventName"] = jsonObject["eventName"].replaceAll("zoneForVideo", getComponentZone(element));
    }
    // splitting video id from URL
    const splitVideoId = decodeURI(videoIdAttribute).split("PAWEB/")[1];
    if (videoIdAttribute && undefined !== splitVideoId && null !== splitVideoId) {
        jsonObject["videoId"] = splitVideoId.toLowerCase();
        const favVideoId = splitVideoId.toLowerCase();
        setFavVideoIdCb && setFavVideoIdCb(favVideoId);
    }
    // condition to check when the video ends
    if (videoModalClose) {
        const { eventName =""  } = jsonObject;
        const closeEvent = "".concat(eventName, ":close");
        const videoJsonObject = {
            ...jsonObject,
            eventAction: closeEvent,
            eventName: closeEvent,
            internalLinkName: "close"
        };
        pushClickEvent(videoJsonObject);
    } else {
        if (element.ended) {
            jsonObject["internalLinkName"] = "video complete";
            jsonObject["eventName"] = jsonObject["eventAction"] = jsonObject["eventName"] + ":" + "video complete";
        } else {
            jsonObject["eventName"] = jsonObject["eventAction"] = jsonObject["eventName"] + ":" + "video play";
        }
        pushClickEvent(jsonObject);
    }
};

;// CONCATENATED MODULE: ./src/hooks/useScreenOrientation.js



/**
 *
 * @return {String}
 */ const useScreenOrientation = ()=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [orientation, setOrientation] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const getOrientation = ()=>{
            var ref, ref1;
            return (ref = window.screen) === null || ref === void 0 ? void 0 : (ref1 = ref.orientation) === null || ref1 === void 0 ? void 0 : ref1.type;
        };
        setOrientation(getOrientation());
        const updateOrientation = debounce_default()(()=>{
            setOrientation(getOrientation());
        }, 300);
        if (!isSsr) {
            window.addEventListener("resize", updateOrientation);
        }
        return ()=>{
            window.removeEventListener("resize", updateOrientation);
        };
    }, [
        isSsr
    ]);
    return orientation;
};
/* harmony default export */ var hooks_useScreenOrientation = (useScreenOrientation);

// EXTERNAL MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(18357);
// EXTERNAL MODULE: ./src/utils/helper.js + 1 modules
var utils_helper = __webpack_require__(13360);
;// CONCATENATED MODULE: ./src/utils/videoHelper.js



const onVolumeChange = (ref)=>{
    if (ref) {
        const { muted , volume  } = ref;
        if (volume == 0 && muted) {
            ref.setAttribute("volume", 1);
            ref.setAttribute("muted", false);
        }
    }
};
// will not work as the element is stacked behind. existing code also have same behavior
const onClickHeroVideo = (event, ref)=>{
    event.preventDefault();
    (ref === null || ref === void 0 ? void 0 : ref.paused) ? ref === null || ref === void 0 ? void 0 : ref.play() : ref === null || ref === void 0 ? void 0 : ref.pause();
};
const onVideoInteraction = (action, cbVideoPlayed, cbVideoPlaying, ref, video, autoPlay, setFavVideoIdCb)=>{
    cbVideoPlayed();
    if (action === constants.VIDEO_EVENTS.PLAY) {
        cbVideoPlaying(true);
        if (!autoPlay) {
            playVideoDatalayer(ref, video, setFavVideoIdCb);
        }
    }
    if (action === constants.VIDEO_EVENTS.PAUSE) {
        cbVideoPlaying(false);
    }
    if (action === constants.VIDEO_EVENTS.ENDED) {
        if (!autoPlay) {
            playVideoDatalayer(ref, video, setFavVideoIdCb);
        }
        ref.play();
    }
};
const onPlayVideoInModal = (event, pageType, videoContainerRef, videoRef)=>{
    if (pageType == "modalWindow") {
        var ref;
        event.preventDefault();
        if (videoContainerRef && !(videoContainerRef === null || videoContainerRef === void 0 ? void 0 : (ref = videoContainerRef.classList) === null || ref === void 0 ? void 0 : ref.contains("open-video-module"))) {
            videoContainerRef.classList.add("open-video-module");
            document.body.classList.add("modal-open");
            videoRef === null || videoRef === void 0 ? void 0 : videoRef.play();
        }
    }
};
const onPlayVideo = function() {
    let videoRef = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callbackFunction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{}, videoDesktopPoster = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", videoMobilePoster = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", video = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", isVideoPlaying = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (videoRef === null || videoRef === void 0 ? void 0 : videoRef.paused) {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.play();
    } else {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.pause();
    }
    if (video) {
        const callbackResponse = (videoRef === null || videoRef === void 0 ? void 0 : videoRef.paused) ? true : false;
        callbackFunction && callbackFunction(callbackResponse);
    } else if (videoDesktopPoster || videoMobilePoster) {
        const callbackResponse1 = !isVideoPlaying;
        callbackFunction && callbackFunction(callbackResponse1);
    }
};
const onVideoPopupClose = (videoContainerRef, videoRef, video)=>{
    videoContainerRef.classList.remove("open-video-module");
    document.body.classList.remove("modal-open");
    videoRef === null || videoRef === void 0 ? void 0 : videoRef.pause();
    playVideoDatalayer(videoRef, video, null, true);
};
const onShareVideo = (e, shareVideoCallback, eventPageType, componentZone, componentLinkType, videoTitle)=>{
    shareVideoCallback && shareVideoCallback();
    if (window.shareSrcElement === undefined || window.shareSrcElement === null) {
        window.shareSrcElement = e.target.children[0];
    }
    shareVideoDatalayer(eventPageType, componentZone, componentLinkType, videoTitle);
};
const onFavVideo = function(event) {
    let asset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", caption = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", videoname = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", favVideoId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", favRef = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {}, toasterContent = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : {};
    const { successMessage ="" , unfavoriteSuccessMessage =""  } = toasterContent;
    let _$$closest;
    const id = event.target.getAttribute("data-id");
    const sharedZoneName = (_$$closest = $(void 0).closest(".cmp-container")) === null || _$$closest === void 0 ? void 0 : _$$closest.attr("id");
    if (id) {
        (0,utils_helper.removeFavorites)([
            id
        ], favRef, unfavoriteSuccessMessage);
    } else {
        const assetUrl = asset;
        let _assetUrl;
        const url1 = (_assetUrl = assetUrl) !== null && _assetUrl !== void 0 && _assetUrl.startsWith("/") ? window.location.origin + assetUrl : assetUrl;
        (0,utils_helper.addMediaToFavorites)("video", title, url1, successMessage, "", caption, sharedZoneName, videoname, favVideoId);
    }
};
const onPlayInspireVideo = function() {
    let inpageVideo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, inspireVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, closeBtnRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    inpageVideo === null || inpageVideo === void 0 ? void 0 : inpageVideo.pause();
    document.body.classList.add("modal-open");
    inspireVideo.style.display = "block";
    inspireVideo === null || inspireVideo === void 0 ? void 0 : inspireVideo.play();
    inspireVideo.muted = false;
    closeBtnRef.style.display = "block";
};
const onPlayInspireVideoClose = function() {
    let inpageVideo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, inspireVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, closeBtnRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    inspireVideo === null || inspireVideo === void 0 ? void 0 : inspireVideo.pause();
    document.body.classList.remove("modal-open");
    inspireVideo.muted = true;
    inspireVideo.style.display = "none";
    inpageVideo === null || inpageVideo === void 0 ? void 0 : inpageVideo.play();
    closeBtnRef.style.display = "none";
};
const onVideoMute = (iconref, ref)=>{
    if (ref) {
        const { muted  } = ref;
        if (muted) {
            iconref.innerHTML = '<i class="icon-Mute"></i>';
            ref.muted = false;
        } else {
            iconref.innerHTML = '<i class="icon-Un-Mute"></i>';
            ref.muted = true;
        }
    }
};

// EXTERNAL MODULE: ./src/components/cart/OrderSummary/SocialShare.jsx
var SocialShare = __webpack_require__(738);
;// CONCATENATED MODULE: ./components/Default/Video/v1/Video.jsx

















const Video = (props)=>{
    var ref;
    const { data: { videoTitle ="" , videoMobile ="" , videoMobileLandscape ="" , videoMobilePoster ="" , videoDesktopPoster ="" , videoDesktop ="" , muteEnableAutoPlay ="false" , hideEnableAutoPlay ="false" , alt ="" , appliedCssClassNames ="" , items =[] , teaserProperties: { title ="" , description ="" , linkURLRef =false , linkCTA ="" , linkNewTab =false , videoPosterMobileLandscape ="" , controlType ="" , pageType ="" , componentPosition ="" , componentZone ="" , componentLinkType ="" , playsAboveFold ="false" , eventName ="" , dynamicTabName ="" , eventAction ="" , caption ="" , pretitle ="" , actionsEnabled =false , actions =[] , linkAll =false , dataLayerLinkType ="" , mainTitle ="" , enableFav =false , enableShare =false , linkDescription =false , propertiesPageType =""  } = {}  } = {}  } = props;
    const { eventPageType , toaster: { content  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { winWidth  } = hooks_useWindowDimensions();
    const screenOrientation = hooks_useScreenOrientation();
    const [video, setVideo] = (0,react.useState)("");
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const [videoPlayed, setVideoPlayed] = (0,react.useState)(false);
    const [isVideoPlaying, setIsVideoPlaying] = (0,react.useState)(false);
    const [showSocialShare, setShowSocialShare] = (0,react.useState)(false);
    const [interactionState, setInteractionState] = (0,react.useState)("");
    const { ref: inViewRef , inView  } = (0,dist/* useInView */.YD)({
        threshold: 0.5
    });
    const videoContainerRef = (0,react.useRef)(null);
    const videoRef = (0,react.useRef)(null);
    const muteIconRef = (0,react.useRef)(null);
    const favEle = (0,react.useRef)(null);
    const [general, setGeneral] = (0,react.useState)(null);
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const [brandName, setBrandName] = (0,react.useState)(null);
    const [flagState, setFlagState] = (0,react.useState)({
        flag25: false,
        flag75: false,
        flag50: false
    });
    const getVideoId = (video)=>{
        var ref, ref1;
        return (ref1 = (ref = decodeURI(video)) === null || ref === void 0 ? void 0 : ref.split("PAWEB/")[1]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            var ref;
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
            setBrandName(config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.lwAppName);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (videoTitle) {
            const dynamicId = (0,helper/* createIdFromString */.ZT_)(videoTitle);
            setDynamicId(dynamicId);
        }
    }, [
        videoTitle
    ]);
    (0,react.useEffect)(()=>{
        if (content) {
            setToasterMessage();
        }
    }, [
        content
    ]);
    const onTimeUpdate = (event)=>{
        const videoDuration = videoRef.current.duration;
        const percent25 = Math.floor(videoDuration * 0.25);
        const percent50 = Math.floor(videoDuration * 0.5);
        const percent75 = Math.floor(videoDuration * 0.75);
        const progressTime = Math.floor(videoRef.current.currentTime);
        if (percent75 <= progressTime && flagState.flag75 === false) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag75: true
                }));
            addVideoDataLayer(75);
        } else if (percent50 <= progressTime && flagState.flag50 === false) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag50: true
                }));
            addVideoDataLayer(50);
        } else if (percent25 <= progressTime && flagState.flag25 === false) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag25: true
                }));
            addVideoDataLayer(25);
        }
    };
    const addVideoDataLayer = (percentViewed)=>{
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(percentViewed, "% video viewed"),
            eventMsg: "n/a",
            eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(percentViewed, "% video viewed"),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "".concat(percentViewed, "% video viewed"),
            internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase()),
            videoId: "".concat(getVideoId(video)),
            videoName: "".concat(videoTitle || componentLinkType.toLowerCase() || "hero video")
        };
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const setToasterMessage = async ()=>{
        const { successMessage , unfavoriteSuccessMessage  } = content;
        setToasterContent({
            successMessage: await (0,utils_location/* getShortenedUrl */.Pp)(successMessage),
            unfavoriteSuccessMessage: await (0,utils_location/* getShortenedUrl */.Pp)(unfavoriteSuccessMessage)
        });
    };
    const setVideoSource = (0,react.useCallback)(()=>{
        if (winWidth > 1023) {
            setVideo(videoDesktop);
        } else {
            if (screenOrientation === null || screenOrientation === void 0 ? void 0 : screenOrientation.includes("landscape")) {
                setVideo(videoMobileLandscape);
            } else {
                setVideo(videoMobile);
            }
        }
    }, [
        videoMobile,
        videoMobileLandscape,
        videoDesktop,
        screenOrientation,
        winWidth
    ]);
    (0,react.useEffect)(()=>{
        if (inView) {
            setVideoSource();
            if ((0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay) || videoPlayed && interactionState === constants.VIDEO_EVENTS.PLAY) {
                var ref;
                videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
            }
        } else {
            var ref1;
            videoRef === null || videoRef === void 0 ? void 0 : (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
        }
    }, [
        setVideoSource,
        inView
    ]);
    (0,react.useEffect)(()=>{
        if (isVideoPlaying) setVideoPlayed(true);
    }, [
        isVideoPlaying
    ]);
    const eventActionTabName = dynamicTabName || "zoneForVideo";
    const eventActionName = "".concat(dynamicTabName || "rm", ":video:rm");
    const [favVideoId, setFavVideoId] = (0,react.useState)("");
    const analyticEventData = {
        clickInternalLinks: true,
        internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
        internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser"),
        internalLinkURL: "n/a",
        internalLinkName: "n/a",
        eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        eventType: "informative",
        eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        videoName: "".concat(videoTitle || componentLinkType.toLowerCase() || "hero video"),
        videoId: "".concat(getVideoId(video))
    };
    const checkVideoTitle = videoTitle || componentLinkType.toLowerCase() || "hero video";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "video teaser ".concat(appliedCssClassNames),
        ref: inViewRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-teaser".concat(controlType == "customControl" ? " gbh-custom-control" : "").concat(propertiesPageType == "modalWindow" ? " gbh-model-window" : "").concat((0,helper/* convertStringToBoolean */.mUs)(hideEnableAutoPlay) ? " gbh-hide-mute" : ""),
            ref: videoContainerRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__image video_poster_height".concat(videoPlayed ? " video-played" : ""),
                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ':\'hero banner\' ","internalLinkURL":"n/a","internalLinkName":"video play","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '",\n             "internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle ? videoTitle : componentLinkType.toLowerCase() || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '","videoName":"').concat(videoTitle || componentLinkType.toLowerCase() || "hero video", '"}'),
                    style: showSocialShare ? {
                        overflow: "visible"
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "gbh-play-video desktop".concat(isVideoPlaying ? " active" : ""),
                            onClick: (event)=>{
                                return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            children: !(hideEnableAutoPlay === "true") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "playinside desktop",
                                id: "videoinnerbtn-".concat(dynamicId),
                                "aria-label": "play video",
                                onClick: ()=>{
                                    return onPlayVideo(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, (res)=>{
                                        setIsVideoPlaying(res);
                                        setInteractionState(res ? constants.VIDEO_EVENTS.PAUSE : constants.VIDEO_EVENTS.PLAY);
                                    }, videoDesktopPoster, videoMobilePoster, video, isVideoPlaying);
                                }
                            }) : null
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            className: "poster-img",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:1025)",
                                    srcSet: "".concat(videoDesktopPoster)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:640px) and (max-width:1024px)",
                                    srcSet: "".concat(videoPosterMobileLandscape)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width:639px)",
                                    srcSet: "".concat(videoMobilePoster)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(videoDesktopPoster),
                                    alt: "",
                                    className: "desktop-poster"
                                })
                            ]
                        }),
                        video && /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            ref: videoRef,
                            id: "video-desktop-".concat(dynamicId),
                            width: "100%",
                            muted: (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay),
                            autoPlay: (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay),
                            loop: (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay),
                            playsInline: true,
                            preload: "metadata",
                            onLoadedData: ()=>{
                                (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay) ? playVideoDatalayer(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (id)=>setFavVideoId(id)) : {};
                            },
                            className: "hero-video videoelement".concat((0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay) ? " muted" : "").concat((0,helper/* convertStringToBoolean */.mUs)(playsAboveFold) ? "" : " lazy-video"),
                            onVolumeChange: ()=>{
                                return onVolumeChange(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            onClick: (event)=>{
                                return onClickHeroVideo(event, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            ...controlType === "defaultControl" && !(0,helper/* convertStringToBoolean */.mUs)(hideEnableAutoPlay) ? {
                                controls: true
                            } : {},
                            onPlay: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.PLAY, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay), (id)=>setFavVideoId(id));
                            },
                            onPause: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.PAUSE, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay));
                            },
                            onEnded: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.ENDED, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay));
                            },
                            onTimeUpdate: onTimeUpdate,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: video,
                                    type: "video/mp4"
                                }),
                                items.map((transcript, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("track", {
                                        label: transcript === null || transcript === void 0 ? void 0 : transcript.languageLabel,
                                        kind: "subtitles",
                                        srcLang: transcript === null || transcript === void 0 ? void 0 : transcript.languageCode,
                                        src: transcript === null || transcript === void 0 ? void 0 : transcript.transcriptSrcPath,
                                        default: (items === null || items === void 0 ? void 0 : items.length) ? true : false
                                    }, "video-track-".concat(dynamicId, "-").concat(index));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-img-caption",
                            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser", '","internalLinkURL":"n/a","internalLinkName":"n/a","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventName || eventActionName, '","internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle || componentLinkType || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventAction || eventActionName, '"}'),
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(caption)
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "vidio_popup_close_button",
                            onClick: ()=>{
                                return onVideoPopupClose(videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                role: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: "\xd7"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            ref: muteIconRef,
                            className: "hero-mute-icon",
                            onClick: ()=>{
                                return onVideoMute(muteIconRef === null || muteIconRef === void 0 ? void 0 : muteIconRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            children: (videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.muted) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "icon-Un-Mute"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "icon-Mute"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__content",
                    children: [
                        pretitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__pretitle",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(pretitle)
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__title",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(title)
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                            general: general,
                            linkURL: linkCTA,
                            linkURLRef: linkURLRef,
                            linkNewTab: linkNewTab,
                            description: description,
                            mainTitle: mainTitle,
                            componentPosition: componentPosition,
                            componentLinkType: componentLinkType,
                            pageType: pageType,
                            linkDescription: linkDescription
                        }),
                        actionsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__action-container",
                            children: actions.map((action, index)=>{
                                const { playVideoCTA =false , primaryCTA =false , secondaryCTA =false , url ="" , title ="" , newTab ="" , urlRef =""  } = action;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                    primaryCTA: (0,helper/* convertStringToBoolean */.mUs)(primaryCTA),
                                    secondaryCTA: (0,helper/* convertStringToBoolean */.mUs)(secondaryCTA),
                                    playVideoCTA: (0,helper/* convertStringToBoolean */.mUs)(playVideoCTA),
                                    link: url,
                                    text: title,
                                    newTab: (0,helper/* convertStringToBoolean */.mUs)(newTab),
                                    urlRef: urlRef,
                                    id: dynamicId,
                                    pageType: pageType,
                                    videoTitle: videoTitle,
                                    linkAll: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                                    mainTitle: mainTitle,
                                    dataLayerLinkType: dataLayerLinkType,
                                    eventName: eventName,
                                    eventAction: eventAction,
                                    componentPosition: componentPosition,
                                    propertiesPageType: propertiesPageType,
                                    playVideoCTAcb: (event)=>{
                                        return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                                    }
                                }, "video-action-".concat(index + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                            })
                        }),
                        (enableFav || enableShare) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__icons",
                            children: [
                                enableFav && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: favEle,
                                    className: "favorite fav-video-trigger",
                                    tabIndex: "0",
                                    "data-asset": videoDesktop,
                                    "data-url": videoDesktop,
                                    onClick: (event)=>onFavVideo(event, videoDesktop, alt, componentLinkType || caption, videoTitle || componentLinkType.toLowerCase() || "hero video", checkVideoTitle, favVideoId, favEle, toasterContent)
                                }),
                                enableShare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "share share-video-trigger",
                                    tabIndex: "0",
                                    "aria-label": "share",
                                    onClick: (e)=>onShareVideo(e, ()=>setShowSocialShare(!showSocialShare), eventPageType, componentZone, componentLinkType, videoTitle),
                                    children: showSocialShare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "share-cmp",
                                        style: {
                                            display: "block"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                            analyticEventData: analyticEventData,
                                            componentProp: {
                                                assetUrl: videoDesktop
                                            },
                                            enableDownload: false,
                                            videoComp: true
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_Video = (/*#__PURE__*/react.memo(Video));

// EXTERNAL MODULE: ./node_modules/overlayscrollbars-react/dist/overlayscrollbars-react.esm.js
var overlayscrollbars_react_esm = __webpack_require__(1861);
;// CONCATENATED MODULE: ./src/components/Default/Carousel/v1/CarouselFiller.jsx



const CarouselFiller = (param)=>{
    let { itemsOrder =[] , items =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-carousel__whole",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-carousel__content",
            children: itemsOrder.map((itemOrder, i)=>{
                const item = items[itemOrder];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-carousel__item".concat(i === 0 ? " cmp-carousel__item--active" : ""),
                    role: "tabpanel",
                    "aria-label": "Slide ".concat(i + 1, " of ").concat(itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
                        data: item
                    })
                }, "carousel-".concat(i));
            })
        })
    });
};
/* harmony default export */ var v1_CarouselFiller = (CarouselFiller);

;// CONCATENATED MODULE: ./src/components/Default/Carousel/v1/Carousel.jsx










const Carousel = (props)=>{
    const { data: { carouselComponentProperties: { appliedCssClassNames ="" , ":itemsOrder": itemsOrder = [] , ":items": items = [] , autoplay =false  } = {} , bodytitle ="" , texttitle ="" , description ="" , showSlideIndicators =true , slidertype =""  } = {} , fullData ={}  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [isOverlayScrollbar, setIsOverlayScrollbar] = (0,react.useState)(false);
    const [componentGroup, setComponentGroup] = (0,react.useState)([]);
    const [customClassNames, setCustomClassNames] = (0,react.useState)("");
    const [cmpCarouselCustomClass, setCmpCarouselCustomClass] = (0,react.useState)("");
    const [activeBanner, setActiveBanner] = (0,react.useState)(0);
    const scrollOptions = {
        className: "os-theme-dark cmp-carousel__whole",
        style: "height:auto",
        scrollbars: {
            visibility: "auto",
            autoHide: "never"
        }
    };
    const showCarouselText = bodytitle || texttitle || description;
    const scrollerRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (scrollerRef.current) {
            setTimeout(()=>{
                document.querySelectorAll(".carousel-bottom-scroll").forEach((scrollDiv, index)=>{
                    let heightToSet = 0;
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".cmp-carousel__content").forEach((scrollDivContent, index)=>{
                        if (scrollDivContent && heightToSet < (scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight)) {
                            heightToSet = scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight;
                        }
                    });
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".os-content-glue").forEach((scrollDivglu, index)=>{
                        if (scrollDivglu && heightToSet > 0) {
                            scrollDivglu.style.height = heightToSet + "px";
                        }
                    });
                });
            }, 2000);
        }
    }, [
        scrollerRef.current
    ]);
    (0,react.useEffect)(()=>{
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-bottom-scroll")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-btm-scroll-title-small"))) {
            setIsOverlayScrollbar(true);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react.useEffect)(()=>{
        itemsOrder.forEach((key, i)=>{
            var ref;
            const item = items[key];
            if ((item === null || item === void 0 ? void 0 : (ref = item.appliedCssClassNamesCustom) === null || ref === void 0 ? void 0 : ref.includes("hero-banner-des-medium-center")) && i === 0 && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("center-double-btn"))) {
                setCustomClassNames((className)=>className += " center-double-btn");
            }
        });
    }, [
        itemsOrder
    ]);
    (0,react.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.CAROUSEL);
            }) && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("breadcrums-withcarosel paddingbasedbreadcrum"))) {
                setCustomClassNames((className)=>className += " breadcrums-withcarosel paddingbasedbreadcrum");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.CAROUSEL);
            }) && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setCustomClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    (0,react.useEffect)(()=>{
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-btm-scroll-title-small")) && !(cmpCarouselCustomClass === null || cmpCarouselCustomClass === void 0 ? void 0 : cmpCarouselCustomClass.includes("carousel-btm-scroll-title-small"))) {
            setCmpCarouselCustomClass((className)=>className += " slide-scrollbar");
        }
    }, [
        appliedCssClassNames
    ]);
    const getNextBanner = ()=>{
        const nextBanner = activeBanner + 1;
        if (nextBanner < itemsOrder.length) {
            setActiveBanner(nextBanner);
        } else {
            setActiveBanner(0);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "carousel ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(customClassNames),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-carousel".concat(cmpCarouselCustomClass),
            children: [
                showCarouselText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-carousel-text",
                    children: [
                        bodytitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__pretitle",
                            role: "heading",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(bodytitle)
                            }
                        }) : null,
                        texttitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__title",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(texttitle)
                            }
                        }) : null,
                        description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__description",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(description)
                            }
                        }) : null
                    ]
                }) : null,
                !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: isOverlayScrollbar,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(overlayscrollbars_react_esm/* OverlayScrollbarsComponent */.E, {
                            options: scrollOptions,
                            ref: scrollerRef,
                            defer: true,
                            children: children
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cmp-carousel__content",
                        children: [
                            itemsOrder && itemsOrder.map((key, i)=>{
                                const item = items[key];
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__item".concat(i === activeBanner ? " cmp-carousel__item--active" : ""),
                                    role: "tabpanel",
                                    "aria-label": "Slide ".concat(i + 1, " of ").concat(itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                                        data: item
                                    })
                                }, "carousel-".concat(i));
                            }),
                            (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cmp-carousel__actions",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--previous",
                                        type: "button",
                                        "aria-label": "Previous",
                                        "data-cmp-hook-carousel": "previous",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Previous"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--next",
                                        type: "button",
                                        "aria-label": "Next",
                                        "data-cmp-hook-carousel": "next",
                                        onClick: getNextBanner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Next"
                                            })
                                        ]
                                    }),
                                    autoplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--pause",
                                        type: "button",
                                        "aria-label": "Pause",
                                        "data-cmp-hook-carousel": "pause",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Pause"
                                            })
                                        ]
                                    }),
                                    autoplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--play cmp-carousel__action--disabled",
                                        type: "button",
                                        "aria-label": "Play",
                                        "data-cmp-hook-carousel": "play",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Play"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (slidertype === "slideindicator" || showSlideIndicators) && /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                className: "".concat(slidertype === "slideindicator" || showSlideIndicators ? "cmp-carousel__indicators" : "cmp-carousel__hyphen"),
                                role: "tablist",
                                "aria-label": "Choose a slide to display",
                                "data-cmp-hook-carousel": "indicators",
                                children: itemsOrder && (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length) > 1 && itemsOrder.map((key, i, arr)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "cmp-carousel__indicator".concat(i === 0 ? " cmp-carousel__indicator--active" : ""),
                                        role: "tab",
                                        "aria-label": "Slide ".concat(i + 1),
                                        "data-cmp-hook-carousel": "indicator",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__indicator--activeNum",
                                                children: i + 1
                                            }),
                                            "/ ".concat(arr === null || arr === void 0 ? void 0 : arr.length)
                                        ]
                                    }, "carousel-".concat(i));
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CarouselFiller, {
                    itemsOrder: itemsOrder,
                    items: items
                })
            ]
        })
    });
};
/* harmony default export */ var v1_Carousel = (Carousel);

;// CONCATENATED MODULE: ./components/Shared/MainFooter.jsx




const MainFooter = (props)=>{
    const { data , columnClassNames  } = props;
    const mainFooterClassName = columnClassNames || "";
    const [gbhExpand, setGbhExpand] = (0,react.useState)([]);
    const handleGbhExpand = (key)=>{
        if (!gbhExpand.includes(key)) {
            const newGbhExpand = [
                ...gbhExpand
            ];
            newGbhExpand.push(key);
            setGbhExpand(newGbhExpand);
        } else {
            const newGbhExpand1 = [
                ...gbhExpand
            ];
            const idx = gbhExpand.indexOf(key);
            newGbhExpand1.splice(idx, 1);
            setGbhExpand(newGbhExpand1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(mainFooterClassName, " ").concat((Shared_index_module_default()).mainFooterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "gbh-footer-main-nav main-footer",
                "aria-label": "Footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "gbh-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleOne,
                                role: "list",
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationOne) == "descriptionOne" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleOne
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "gbh-find-store",
                                                role: "listitem",
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescOne)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationOne) == "linksOne" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(gbhExpand.includes("linksOne") ? "gbh-expand" : ""),
                                                    role: "heading",
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksOne"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleOne)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !gbhExpand.includes("linksOne") ? {
                                                        display: "none"
                                                    } : {},
                                                    children: data === null || data === void 0 ? void 0 : data.items.map((item, index)=>{
                                                        var ref, ref1, ref2, ref3, ref4;
                                                        const gbhFooterMainNavLinkKey = "gbh-footer-main-nav-link-".concat(index);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "gbh-data-layer",
                                                                    href: item === null || item === void 0 ? void 0 : (ref = item.brandLinkOne) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                    "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameOne).concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? " external link opens in a new tab" : ""),
                                                                    target: "".concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? "_blank" : "_self"),
                                                                    rel: "noreferrer",
                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleOne.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandLinkOne) === null || ref1 === void 0 ? void 0 : ref1.split("/content/annsacks/us/en").join("").replace(".html", ""), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameOne) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref3 = item.brandNameOne) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref4 = item.brandNameOne) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '"}'),
                                                                    children: item === null || item === void 0 ? void 0 : item.brandNameOne
                                                                })
                                                            })
                                                        }, gbhFooterMainNavLinkKey);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleTwo,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationTwo) == "descriptionTwo" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "footer-inner-head",
                                                role: "heading",
                                                "aria-level": "2",
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleTwo
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescTwo)
                                                }
                                            })
                                        ]
                                    }),
                                    data.radioNavigationTwo == "linksTwo" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(gbhExpand.includes("linksTwo") ? "gbh-expand" : ""),
                                                    role: "heading",
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksTwo"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleTwo)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !gbhExpand.includes("linksTwo") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsOne.length) > 4 ? "odd-even" : "",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsOne.map((item, index)=>{
                                                        var ref, ref1, ref2, ref3, ref4;
                                                        const linksOneKey = "linksOne-".concat(index);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "gbh-data-layer",
                                                                    href: item === null || item === void 0 ? void 0 : (ref = item.brandLinkTwo) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                    target: (item === null || item === void 0 ? void 0 : item.newTabTwo) ? "_blank" : "",
                                                                    rel: "noreferrer",
                                                                    "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameTwo).concat((item === null || item === void 0 ? void 0 : item.newTabTwo) ? " external link opens in a new tab" : ""),
                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabTwo) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleTwo.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandLinkTwo) === null || ref1 === void 0 ? void 0 : ref1.split("/content/annsacks/us/en").join("").replace(".html", ""), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameTwo) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '", "eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref3 = item.brandNameTwo) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '", "internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref4 = item.brandNameTwo) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '"}'),
                                                                    children: item === null || item === void 0 ? void 0 : item.brandNameTwo
                                                                })
                                                            })
                                                        }, linksOneKey);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleThree,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.descriptionThree) == "descriptionThree" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleThree
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescThree)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationThree) == "linksThree" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(gbhExpand.includes("linksThree") ? "gbh-expand" : ""),
                                                    role: "heading",
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksThree"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleThree)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !gbhExpand.includes("linksThree") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsTwo.length) > 4 ? "odd-even" : "",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsTwo.map((item, index)=>{
                                                        var ref, ref1, ref2, ref3, ref4;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "gbh-data-layer",
                                                                    href: item === null || item === void 0 ? void 0 : (ref = item.brandLinkThree) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                    target: (item === null || item === void 0 ? void 0 : item.newTabThree) ? "_blank" : "",
                                                                    rel: "noreferrer",
                                                                    "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameThree).concat((item === null || item === void 0 ? void 0 : item.newTabThree) ? " external link opens in a new tab" : ""),
                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabThree) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleThree.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandLinkThree) === null || ref1 === void 0 ? void 0 : ref1.split("/content/annsacks/us/en").join("").replace(".html", ""), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameThree) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref3 = item.brandNameThree) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref4 = item.brandNameThree) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '"}'),
                                                                    children: item === null || item === void 0 ? void 0 : item.brandNameThree
                                                                })
                                                            })
                                                        }, "linksTwo-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleFour,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationFour) == "descriptionFour" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleFour
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescFour)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationFour) == "linksFour" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(gbhExpand.includes("linksFour") ? "gbh-expand" : ""),
                                                    role: "heading",
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksFour"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleFour)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !gbhExpand.includes("linksFour") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsThree.length) > 4 ? "odd-even" : "",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsThree.map((item, index)=>{
                                                        var ref, ref1, ref2, ref3, ref4;
                                                        const linksThreeKey = "linksThree-".concat(index);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                href: item === null || item === void 0 ? void 0 : (ref = item.brandLinkFour) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                target: (item === null || item === void 0 ? void 0 : item.newTabFour) ? "_blank" : "",
                                                                rel: "noreferrer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameFour).concat((item === null || item === void 0 ? void 0 : item.newTabFour) ? " external link opens in a new tab" : ""),
                                                                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabFour) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleFour.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandLinkFour) === null || ref1 === void 0 ? void 0 : ref1.split("/content/annsacks/us/en").join("").replace(".html", ""), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameFour) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref3 = item.brandNameFour) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref4 = item.brandNameFour) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '"}'),
                                                                children: item === null || item === void 0 ? void 0 : item.brandNameFour
                                                            })
                                                        }, linksThreeKey);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleFive,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationFive) == "descriptionFive" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleFive
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleFive)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationFive) == "linksFive" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(gbhExpand.includes("linksFive") ? "gbh-expand" : ""),
                                                    role: "heading",
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksFive"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleFive)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !gbhExpand.includes("linksFive") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsFour.length) > 4 ? "odd-even" : "",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsFour.map((item, index)=>{
                                                        var ref, ref1, ref2, ref3, ref4;
                                                        const linksFourKey = "linksFour-".concat(index);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                href: item === null || item === void 0 ? void 0 : (ref = item.brandLinkFive) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                                target: (item === null || item === void 0 ? void 0 : item.newTabFive) ? "_blank" : "",
                                                                rel: "noreferrer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameFive).concat((item === null || item === void 0 ? void 0 : item.newTabFive) ? " external link opens in a new tab" : ""),
                                                                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabFive) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleFive.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandLinkFive) === null || ref1 === void 0 ? void 0 : ref1.split("/content/annsacks/us/en").join("").replace(".html", ""), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameFive) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref3 = item.brandNameFive) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref4 = item.brandNameFive) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '"}'),
                                                                children: item === null || item === void 0 ? void 0 : item.brandNameFive
                                                            })
                                                        }, linksFourKey);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_MainFooter = (MainFooter);

// EXTERNAL MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(15740);
// EXTERNAL MODULE: ./src/components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(2583);
;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/SubscribeInfoModal.jsx






const SubscribeInfoModal = (props)=>{
    var ref, ref1, ref2;
    const { show , handleModalClose , homePagePath , className , staticTexts , modalContent  } = props;
    const { getReady , signupSuccess  } = staticTexts;
    const enableCta = modalContent.modalContent.enableCta;
    const closeLabel = modalContent.modalContent.ctaLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
        showModal: show,
        onModalClose: handleModalClose,
        modalTitle: getReady !== null && getReady !== void 0 ? getReady : "",
        describedBy: "newsletter-description",
        labelledBy: "newsletter-title",
        className: "".concat(className || "", " newsletter"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "newsletter",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "newsletter__content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "newsletter__thanks test-class",
                        id: "newsletter-title",
                        children: !isEmpty_default()(modalContent) ? (0,helper/* sanitizeInnerHtml */.KD0)(modalContent === null || modalContent === void 0 ? void 0 : (ref = modalContent.modalContent) === null || ref === void 0 ? void 0 : ref.title) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(getReady)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "newsletter__success",
                        id: "newsletter-description",
                        children: !isEmpty_default()(modalContent) ? (0,helper/* sanitizeInnerHtml */.KD0)(modalContent === null || modalContent === void 0 ? void 0 : (ref1 = modalContent.modalContent) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.description) === null || ref2 === void 0 ? void 0 : ref2.split("/content/annsacks/us/en").join("").replace(".html", "")) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(signupSuccess)
                        })
                    }),
                    enableCta && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleModalClose,
                        type: "black",
                        role: "button",
                        to: homePagePath,
                        className: "kf-react-button button large black",
                        label: closeLabel
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var NewsletterFooter_SubscribeInfoModal = (SubscribeInfoModal);

// EXTERNAL MODULE: ./src/components/Shared/NewsletterFooter/index.module.scss
var NewsletterFooter_index_module = __webpack_require__(59980);
var NewsletterFooter_index_module_default = /*#__PURE__*/__webpack_require__.n(NewsletterFooter_index_module);
;// CONCATENATED MODULE: ./src/components/Shared/NewsletterFooter/localization.js
const getTranslations = (t)=>{
    return {
        thanks: t("kf.newsletter.label.thanks"),
        getReady: t("kf.newsletter.label.getReady"),
        signupSuccess: t("kf.newsletter.label.signupSuccess"),
        signUp: t("kf.newsletter.label.signUp"),
        getStarted: t("kf.newsletter.label.getStarted"),
        enterEmail: t("kf.newsletter.label.enterEmail"),
        validEmail: t("kf.newsletter.label.validEmail"),
        genError: t("kf.error.message.genericError"),
        alreadySubscribed: t("kf.newsletter.label.alreadySubscribed"),
        submissionComplete: t("kf.newsletter.label.submissionComplete"),
        submissionCompleteMsg: t("kf.newsletter.label.submissionCompleteMsg"),
        signUpNewsletter: t("kf.newsletter.label.signUpNewsletter"),
        privacyPolicy: t("kf.newsletter.label.privacyPolicy")
    };
};

// EXTERNAL MODULE: ./src/components/Shared/NewsletterFooter/newsLetterBody.js
var newsLetterBody = __webpack_require__(81506);
;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/NewsletterFooter.jsx















const NewsletterFooter = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const [validationError, setValidationError] = (0,react.useState)("");
    const [email, setEmail] = (0,react.useState)("");
    const [captchaActive, setCaptchaActive] = (0,react.useState)(false);
    const submitButton = (0,react.useRef)(null);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [staticTexts, setStaticTexts] = (0,react.useState)({});
    const [siteName, setSiteName] = (0,react.useState)("");
    const [language, setLanguage] = (0,react.useState)("en");
    const [homePagePath, setHomePagePath] = (0,react.useState)("/");
    const [isShowModal, setIsShowModal] = (0,react.useState)(false);
    const [isResetForm, setIsResetForm] = (0,react.useState)(false);
    const [isAlreadyExist, setIsAlreadyExist] = (0,react.useState)(false);
    const [leadGenPageUrl, setLeadGenPageUrl] = (0,react.useState)(null);
    const { subscribeModal  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const newLetterInputref = (0,react.useRef)(null);
    const { data , columnClassNames  } = props;
    const addNewsletterSignupAnalytics = (status, message)=>{
        if (window.adobeDataLayer) {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const eventInfo = {
                "@type": (siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase()) + "/components/newslettersignin",
                eventMsg: message || "n/a",
                eventStatus: status,
                clickInternalLinks: "true",
                internalLinkPosition: "newslettersignin",
                internalLinkZoneName: "global footer",
                internalLinkURL: "n/a",
                internalLinkName: "newsletter submit",
                eventName: "newsletter submit",
                internalLinkType: "global footer:submit",
                eventType: "click",
                eventAction: "newsletter submit"
            };
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo: eventInfo,
                page: page
            });
        }
    };
    const subModalAnalytics = (msg, hreflink)=>{
        if (window.adobeDataLayer) {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const eventInfo = {
                eventMsg: "n/a",
                eventStatus: "n/a",
                clickInternalLinks: "true",
                internalLinkPosition: "newsletter:signin complete",
                internalLinkZoneName: "newsletter submit:get ready",
                internalLinkURL: hreflink ? msg + hreflink : "n/a",
                internalLinkName: msg,
                eventName: "newsletter submit:get ready:".concat(msg),
                internalLinkType: "newsletter submit:get ready",
                eventType: "navigation",
                eventAction: "newsletter submit:get ready:".concat(msg)
            };
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo: eventInfo,
                page: page
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (isResetForm) setEmail("");
        if (isAlreadyExist) setValidationError(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alreadySubscribed);
    }, [
        isResetForm,
        isAlreadyExist
    ]);
    (0,react.useEffect)(()=>{
        setCaptchaActive(false);
        setStaticTexts(getTranslations(t));
        setInitalData();
    }, []);
    const handleModalClose = ()=>{
        subModalAnalytics("close");
        setIsShowModal(false);
    };
    const handleModalMsg = (hreflink)=>{
        subModalAnalytics("".concat(siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(), ".com"), hreflink);
    };
    const setInitalData = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        setSiteName(get_default()(config, "general.siteName", ""));
        setLanguage(get_default()(config, "internationalization.language", "en"));
        setHomePagePath(await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.homepageUrl", "/")));
        if (data === null || data === void 0 ? void 0 : data.leadGenCtalink) {
            setLeadGenPageUrl(await (0,helper/* getShortenedUrl */.Ppy)(data === null || data === void 0 ? void 0 : data.leadGenCtalink, true));
        }
    };
    const getSubscriptionData = (email)=>{
        const body = (0,newsLetterBody/* default */.Z)(siteName, email, language);
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res.success) {
                constants_api/* apim.post */.TH.post(constants.emailSubscribeEndPoint, body, {
                    params: {
                        brand: siteName
                    }
                }).then((response)=>{
                    if (response && response.data) {
                        var _resultMessages;
                        const isSuccess = (_resultMessages = response.data.resultMessages) !== null && _resultMessages !== void 0 ? _resultMessages : [];
                        if (isSuccess) {
                            setIsShowModal(true);
                            setIsResetForm(true);
                        }
                        setEmail("");
                        addNewsletterSignupAnalytics("success");
                    } else {
                        addNewsletterSignupAnalytics("failure", "news letter subscription api: error occured while fetching data from get url property");
                    // log.error(
                    //   "News letter subscription API: Error occured while fetching data from Get URL Property"
                    // )
                    }
                }).catch((err)=>{
                    var ref, ref1;
                    if (((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error) === "Email address already subscribed") {
                        setIsAlreadyExist(true);
                        addNewsletterSignupAnalytics("failure", staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alreadySubscribed.toLowerCase());
                    } else {
                        console.log(staticTexts.genError);
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: staticTexts.genError,
                            isVisible: true
                        }));
                        addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
                    }
                });
            } else {
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: staticTexts.genError,
                    isVisible: true
                }));
                addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
            }
        }).catch(()=>{
            dispatch((0,genericSlice/* showToast */.CF)({
                message: staticTexts.genError,
                isVisible: true
            }));
            addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
        });
    };
    const onSubmit = async ()=>{
        if (email === "" || email == null || (email === null || email === void 0 ? void 0 : email.length) == 0) {
            var ref;
            setValidationError(staticTexts.enterEmail);
            newLetterInputref === null || newLetterInputref === void 0 ? void 0 : (ref = newLetterInputref.current) === null || ref === void 0 ? void 0 : ref.focus();
            addNewsletterSignupAnalytics("failure", staticTexts.enterEmail.toLowerCase());
        }
        if ((email === null || email === void 0 ? void 0 : email.length) > 0) {
            const isValid = await (0,helper/* validateField */.OP$)("email", email);
            if (!isValid) {
                var ref1;
                addNewsletterSignupAnalytics("failure", staticTexts.enterEmail.toLowerCase());
                setValidationError(staticTexts.validEmail);
                newLetterInputref === null || newLetterInputref === void 0 ? void 0 : (ref1 = newLetterInputref.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
            } else {
                setValidationError("");
                if (leadGenPageUrl) {
                    window.location.href = "".concat(leadGenPageUrl, "?email=").concat(email);
                } else {
                    getSubscriptionData(email);
                }
            }
        }
        handleFocus();
    };
    const handleFocus = ()=>{
        // removing focus
        submitButton.current.blur();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(columnClassNames ? columnClassNames : "", " ").concat((NewsletterFooter_index_module_default()).wrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "gbh-footer-newsletter-nav",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "gbh-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "gbh-footer-news-letter",
                                    "aria-label": data === null || data === void 0 ? void 0 : data.title,
                                    role: "list",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: data === null || data === void 0 ? void 0 : data.title
                                        }),
                                        (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.description),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "form-group newsletter-form-group",
                                            role: "listitem",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "newsletter_input",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        ref: newLetterInputref,
                                                        className: "form-control",
                                                        type: "email",
                                                        "aria-label": data === null || data === void 0 ? void 0 : data.placeholder,
                                                        placeholder: data === null || data === void 0 ? void 0 : data.placeholder,
                                                        maxLength: "60",
                                                        id: "newsletter_input",
                                                        onChange: (e)=>setEmail(e.target.value),
                                                        value: email,
                                                        "data-testid": "newsletter-input",
                                                        "aria-invalid": !!validationError,
                                                        "aria-describedby": "subsribe-mail-error",
                                                        autoComplete: "email"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.submit) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    "aria-label": "Submit button. Tap or click here to subscribe for Koher newsletter to receive news and promotions.",
                                                    className: "btn btn-secondary ".concat(email.length ? "active-btn" : ""),
                                                    id: "newsletter_submit",
                                                    onClick: ()=>onSubmit(),
                                                    ref: submitButton,
                                                    "data-testid": "newsletter-submit",
                                                    children: data === null || data === void 0 ? void 0 : data.submit
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            role: "listitem",
                                            className: "subsribe-error-container",
                                            children: validationError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                id: "subsribe-mail-error",
                                                role: "alert",
                                                "aria-live": "assertive",
                                                "data-testid": "email-error",
                                                children: (0,helper/* sanitizeDOMString */.TRt)(validationError)
                                            })
                                        })
                                    ]
                                })
                            }),
                            captchaActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterFooter_SubscribeInfoModal, {
                show: isShowModal,
                handleModalClose: handleModalClose,
                handleModalMsg: handleModalMsg,
                staticTexts: staticTexts,
                homePagePath: homePagePath,
                className: (NewsletterFooter_index_module_default()).wrapper,
                setEmail: setEmail,
                modalContent: subscribeModal
            })
        ]
    });
};
/* harmony default export */ var NewsletterFooter_NewsletterFooter = (NewsletterFooter);

;// CONCATENATED MODULE: ./components/Shared/AdditionalFooter.jsx






const AdditionalFooter = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
    const { data , columnClassNames  } = props;
    const additionalFooterClassName = columnClassNames || "";
    const router = (0,next_router.useRouter)();
    const [location, setLocation] = (0,react.useState)("");
    const [docTitle, setDocTitle] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const sanitizedLocation = browser_default().sanitize(window.location.href);
        setLocation(sanitizedLocation);
        setDocTitle(document.title);
    }, [
        router.pathname
    ]);
    // To resolve hydration error added the below code
    // This will be true only on the client-side after hydration
    const isClient = "object" !== "undefined";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(additionalFooterClassName, " ").concat((Shared_index_module_default()).additionalFooterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "additional-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "gbh-footer-add-nav",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "gbh-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "gbh-footer-add-panel",
                            children: [
                                (data === null || data === void 0 ? void 0 : (ref = data.appliedCssClassNames) === null || ref === void 0 ? void 0 : ref.includes("additional-footer-social-link")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "gbh-footer-nav__links",
                                    children: data === null || data === void 0 ? void 0 : (ref1 = data.items) === null || ref1 === void 0 ? void 0 : ref1.map((item, index)=>{
                                        var ref, ref1, ref2, ref3, ref4;
                                        const additionalfooteritem = "additionalfooteritem-".concat(index);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                id: item === null || item === void 0 ? void 0 : item.idLabel,
                                                className: isClient ? item === null || item === void 0 ? void 0 : item.classLabel : "",
                                                "aria-label": item.linkLabel,
                                                target: item.newTab ? "_blank" : "_self",
                                                href: (ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                rel: "noreferrer",
                                                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTab) ? "false" : "true", '","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"').concat(item === null || item === void 0 ? void 0 : (ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.split("/content/annsacks/us/en").join("").replace(".html", ""), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref2 = item.linkLabel) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","eventName":"global footer:').concat(item === null || item === void 0 ? void 0 : (ref3 = item.linkLabel) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer menu-2","eventAction":"global footer:').concat(item === null || item === void 0 ? void 0 : (ref4 = item.linkLabel) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '"}'),
                                                children: item.linkLabel
                                            })
                                        }, additionalfooteritem);
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "gbh-footer-nav__links",
                                    children: data === null || data === void 0 ? void 0 : (ref2 = data.items) === null || ref2 === void 0 ? void 0 : ref2.map((item, index)=>{
                                        var ref, ref1, ref2, ref3, ref4;
                                        const additionalfooteritem = "additionalfooteritem-".concat(index);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                id: item === null || item === void 0 ? void 0 : item.idLabel,
                                                className: isClient ? item === null || item === void 0 ? void 0 : item.classLabel : "",
                                                "aria-label": item.linkLabel,
                                                target: item.newTab ? "_blank" : "_self",
                                                href: (ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", ""),
                                                rel: "noreferrer",
                                                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTab) ? "false" : "true", '","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"').concat(item === null || item === void 0 ? void 0 : (ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.split("/content/annsacks/us/en").join("").replace(".html", ""), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref2 = item.linkLabel) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","eventName":"global footer:').concat(item === null || item === void 0 ? void 0 : (ref3 = item.linkLabel) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer menu-2","eventAction":"global footer:').concat(item === null || item === void 0 ? void 0 : (ref4 = item.linkLabel) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '"}'),
                                                children: item.linkLabel
                                            })
                                        }, additionalfooteritem);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "social-link-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "gbh-social__links",
                                            children: [
                                                (data === null || data === void 0 ? void 0 : data.email) == "email" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "gbh-social__email",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        className: "gbh-data-layer",
                                                        "aria-label": "Email corporate page opens in a new tab",
                                                        href: "mailto:?body=".concat(location, "&subject=").concat(docTitle),
                                                        rel: "noreferrer noopener",
                                                        title: data.linkLabelEmail,
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkEmail, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref3 = data.linkLabelEmail) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref4 = data.linkLabelEmail) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '","internalLinkType":"global footer:"navigation","eventType":"social icon","eventAction":"social media:').concat(data === null || data === void 0 ? void 0 : (ref5 = data.linkLabelEmail) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase(), '"}')
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.facebook) == "facebook" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "gbh-social__facebook",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        "aria-label": "Facebook corporate page opens in a new tab",
                                                        href: data.linkFacebook,
                                                        rel: "noreferrer noopener",
                                                        title: data === null || data === void 0 ? void 0 : data.linkLabelFacebook,
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkFacebook, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref6 = data.linkLabelFacebook) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref7 = data.linkLabelFacebook) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media:').concat(data === null || data === void 0 ? void 0 : (ref8 = data.linkLabelFacebook) === null || ref8 === void 0 ? void 0 : ref8.toLowerCase(), '"}'),
                                                        className: "gbh-data-layer"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.instagram) == "instagram" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "gbh-social__insta",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        "aria-label": "Instagram corporate page opens in a new tab",
                                                        href: data.linkInstagram,
                                                        rel: "noreferrer noopener",
                                                        title: data.linkLabelInstagram,
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkInstagram, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref9 = data.linkLabelInstagram) === null || ref9 === void 0 ? void 0 : ref9.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref10 = data.linkLabelInstagram) === null || ref10 === void 0 ? void 0 : ref10.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media:').concat(data === null || data === void 0 ? void 0 : (ref11 = data.linkLabelInstagram) === null || ref11 === void 0 ? void 0 : ref11.toLowerCase(), '"}'),
                                                        className: "gbh-data-layer"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.twitter) == "twitter" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "gbh-social__twitter",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        "aria-label": "Twitter corporate page opens in a new tab",
                                                        href: data.linkTwitter,
                                                        rel: "noreferrer noopener",
                                                        title: data.linkLabelTwitter,
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkTwitter, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref12 = data.linkLabelTwitter) === null || ref12 === void 0 ? void 0 : ref12.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref13 = data.linkLabelTwitter) === null || ref13 === void 0 ? void 0 : ref13.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media:').concat(data === null || data === void 0 ? void 0 : (ref14 = data.linkLabelTwitter) === null || ref14 === void 0 ? void 0 : ref14.toLowerCase(), '"}'),
                                                        className: "gbh-data-layer"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.pinterest) == "pinterest" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "gbh-social__pintrest",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        "aria-label": "Pinterest corporate page opens in a new tab",
                                                        href: data.linkPinterest,
                                                        rel: "noreferrer noopener",
                                                        title: data.linkLabelPinterest,
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkPinterest, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref15 = data.linkLabelPinterest) === null || ref15 === void 0 ? void 0 : ref15.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref16 = data.linkLabelPinterest) === null || ref16 === void 0 ? void 0 : ref16.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media:').concat(data === null || data === void 0 ? void 0 : (ref17 = data.linkLabelPinterest) === null || ref17 === void 0 ? void 0 : ref17.toLowerCase(), '"}'),
                                                        className: "gbh-data-layer"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.youtube) == "youtube" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "gbh-social__youtube",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        "aria-label": "Youtube corporate page opens in a new tab",
                                                        href: data.linkYoutube,
                                                        rel: "noreferrer noopener",
                                                        title: data.linkLabelYoutube,
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkYoutube, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref18 = data.linkLabelYoutube) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref19 = data.linkLabelYoutube) === null || ref19 === void 0 ? void 0 : ref19.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media:').concat(data === null || data === void 0 ? void 0 : (ref20 = data.linkLabelYoutube) === null || ref20 === void 0 ? void 0 : ref20.toLowerCase(), '"}'),
                                                        className: "gbh-data-layer"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.houzz) == "houzz" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "gbh-social__houzz",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        "aria-label": "Houzz corporate page opens in a new tab",
                                                        href: data.linkHouzz,
                                                        rel: "noreferrer noopener",
                                                        title: data.linkLabelHouzz,
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkHouzz, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref21 = data.linkLabelHouzz) === null || ref21 === void 0 ? void 0 : ref21.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref22 = data.linkLabelHouzz) === null || ref22 === void 0 ? void 0 : ref22.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media:').concat(data === null || data === void 0 ? void 0 : (ref23 = data.linkLabelHouzz) === null || ref23 === void 0 ? void 0 : ref23.toLowerCase(), '"}'),
                                                        className: "gbh-data-layer"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.linkedin) == "linkedin" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "gbh-social__linkedin",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        "aria-label": "Linkedin corporate page opens in a new tab",
                                                        href: data.linkLinkedin,
                                                        rel: "noreferrer noopener",
                                                        title: data.linkLabelLinkedin,
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkLinkedin, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref24 = data.linkLabelLinkedin) === null || ref24 === void 0 ? void 0 : ref24.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref25 = data.linkLabelLinkedin) === null || ref25 === void 0 ? void 0 : ref25.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media:').concat(data === null || data === void 0 ? void 0 : (ref26 = data.linkLabelLinkedin) === null || ref26 === void 0 ? void 0 : ref26.toLowerCase(), '"}'),
                                                        className: "gbh-data-layer"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.tiktok) == "tiktok" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "gbh-social__tiktok",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        "aria-label": "Tiktok corporate page opens in a new tab",
                                                        href: data.linkTiktok,
                                                        rel: "noreferrer noopener",
                                                        title: data.linkLabelTiktok,
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkTiktok, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref27 = data.linkLabelTiktok) === null || ref27 === void 0 ? void 0 : ref27.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref28 = data.linkLabelTiktok) === null || ref28 === void 0 ? void 0 : ref28.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media:').concat(data === null || data === void 0 ? void 0 : (ref29 = data.linkLabelTiktok) === null || ref29 === void 0 ? void 0 : ref29.toLowerCase(), '"}'),
                                                        className: "gbh-data-layer"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "gbh-copy__rights",
                                            children: data.copyright
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_AdditionalFooter = (AdditionalFooter);
AdditionalFooter.defaultProps = {
    data: [],
    columnClassNames: ""
};
AdditionalFooter.propTypes = {
    data: (prop_types_default()).array,
    columnClassNames: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/components/Default/Text/v1/Text.jsx



const Text = (props)=>{
    const [dataVal, setDataVal] = (0,react.useState)("");
    const { data: { text ="" , appliedCssClassNames ="" , richText =false , id =""  } = {}  } = props;
    const removeHtmlExtension = async ()=>{
        const newData = await (0,helper/* getShortenedUrl */.Ppy)(text);
        setDataVal(newData.replace('href=""', 'href="/"'));
    };
    (0,react.useEffect)(()=>{
        if (richText) {
            removeHtmlExtension();
        }
    }, [
        richText
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        children: richText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: id,
            className: "cmp-text",
            children: (0,helper/* sanitizeInnerHtml */.KD0)(dataVal)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-text",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "cmp-text__paragraph",
                "aria-label": text,
                children: text
            })
        })
    });
};
/* harmony default export */ var v1_Text = (Text);

// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input = __webpack_require__(27222);
;// CONCATENATED MODULE: ./components/Default/Image/v1/DynamicImage.jsx




const DynamicImage_DynamicImage = (param)=>{
    let { imgUrl ="" , alt ="" , className ="" , uniqueId ="" , urlModifiers ="" , ...restProps } = param;
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const cropedImage = (0,react.useRef)(null);
    const imgPlaceholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const isScene7Img = imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("scene7");
    const [bgColorImage, setBgColorImage] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (!isSsr && smartCrop.scriptStatus && isScene7Img && window.s7responsiveImage) {
            smartCrop.applySmartCrop(cropedImage.current);
        }
    }, [
        smartCrop.scriptStatus,
        imgUrl,
        uniqueId,
        isSsr
    ]);
    (0,react.useEffect)(()=>{
        if (urlModifiers && imgUrl) {
            setBgColorImage((imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("?")) ? "".concat(imgUrl, "&").concat(urlModifiers) : "".concat(imgUrl, "?").concat(urlModifiers));
        }
    }, [
        imgUrl,
        urlModifiers
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        ref: cropedImage,
        src: imgPlaceholder,
        "data-src": urlModifiers ? bgColorImage : imgUrl,
        "data-mode": "smartcrop",
        alt: alt,
        className: className,
        ...restProps
    }, uniqueId);
};
/* harmony default export */ var v1_DynamicImage = (DynamicImage_DynamicImage);

;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/analytics.js
const addNewsletterSignupAnalytics = function(siteName, status, message) {
    let internalLink = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (window.adobeDataLayer) {
        const { adobeDataLayer: { getState  } = {}  } = window;
        const eventInfo = {
            "@type": (siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase()) + "/components/newslettersignin",
            eventMsg: message || "n/a",
            eventStatus: status,
            clickInternalLinks: "".concat(internalLink),
            internalLinkPosition: "newslettersignin",
            internalLinkZoneName: "global footer",
            internalLinkURL: "n/a",
            internalLinkName: "newsletter submit",
            eventName: "newsletter submit",
            internalLinkType: "global footer:submit",
            eventType: "click",
            eventAction: "newsletter submit"
        };
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo: eventInfo,
            page: page
        });
    }
};
const subModalAnalytics = function(msg, hreflink) {
    let internalLink = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (window.adobeDataLayer) {
        const { adobeDataLayer: { getState  } = {}  } = window;
        const eventInfo = {
            eventMsg: "n/a",
            eventStatus: "n/a",
            clickInternalLinks: "".concat(internalLink),
            internalLinkPosition: "newsletter:signin complete",
            internalLinkZoneName: "newsletter submit:get ready",
            internalLinkURL: hreflink ? msg + hreflink : "n/a",
            internalLinkName: msg,
            eventName: "newsletter submit:get ready:".concat(msg),
            internalLinkType: "newsletter submit:get ready",
            eventType: "navigation",
            eventAction: "newsletter submit:get ready:".concat(msg)
        };
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo: eventInfo,
            page: page
        });
    }
};

;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/NewsLetterPopUp.jsx
"use client";



















const DELAY = 10000 // 10 seconds
;
const COOLDOWN = 48 * 60 * 60 * 1000 // 48 hours
;
const CLEARENCE = 90 * 24 * 60 * 60 * 1000 // 90 Days
;
const STORAGE_KEY_LAST_COLSED_TIME = "newsletter_modal_last_closed_time";
const STORAGE_KEY_ALREADY_SUBCRIBED = "newsletter_modal_already_subcribed";
const FOCUSABLE_ELEMENTS_SELECTOR = 'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, object, embed, [contenteditable="true"], [tabindex]:not([tabindex="-1"])';
const DIALOG_IDS = {
    signupTitle: "newsletter-signup-title",
    signupDescription: "newsletter-signup-description",
    successTitle: "newsletter-signup-success-title",
    successDescription: "newsletter-signup-success-description",
    email: "newsletter-popup-email",
    emailError: "newsletter-popup-email-error",
    emailHint: "newsletter-popup-email-hint",
    formStatus: "newsletter-popup-form-status"
};
function NewsLetterPopUp(props) {
    const dispatch = (0,es/* useDispatch */.I0)();
    const newLetterPopupInputref = (0,react.useRef)(null);
    const submitButton = (0,react.useRef)(null);
    const modalContentRef = (0,react.useRef)(null);
    const successModalContentRef = (0,react.useRef)(null);
    const previousFocusedElementRef = (0,react.useRef)(null);
    const newsletterTimerRef = (0,react.useRef)(null);
    const [validationError, setValidationError] = (0,react.useState)("");
    const [openNewsLetter, setOpenNewsLetter] = (0,react.useState)(false);
    const [hasShownNewsletter, setHasShownNewsletter] = (0,react.useState)(false);
    const [leadGenPageUrl, setLeadGenPageUrl] = (0,react.useState)(null);
    const [siteName, setSiteName] = (0,react.useState)("");
    const [language, setLanguage] = (0,react.useState)("en");
    const [isAlreadyExist, setIsAlreadyExist] = (0,react.useState)(false);
    const [isResetForm, setIsResetForm] = (0,react.useState)(false);
    const [successModel, setSuccessModel] = (0,react.useState)(false);
    const [staticTexts, setStaticTexts] = (0,react.useState)({});
    const [submissionStatus, setSubmissionStatus] = (0,react.useState)("");
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { innerClass , parentClass , data  } = props;
    const { submit , postSubmitDescription , imagePath , description , placeholder , title , imageVariationEnabled , postSubmitTitle  } = data || {};
    const [email, setEmail] = (0,react.useState)("");
    const { authModal: { show: isAuthOpen  }  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const isModalOpen = openNewsLetter || successModel;
    const emailLabel = placeholder || "Email address";
    const emailDescribedBy = [
        DIALOG_IDS.emailHint,
        validationError ? DIALOG_IDS.emailError : "",
        submissionStatus ? DIALOG_IDS.formStatus : ""
    ].filter(Boolean).join(" ");
    const getFocusableElements = (0,react.useCallback)((modalElement)=>{
        if (!modalElement) {
            return [];
        }
        return [
            ...modalElement.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR)
        ].filter((element)=>!element.hasAttribute("disabled") && element.getAttribute("aria-hidden") !== "true");
    }, []);
    const getActiveModalElement = (0,react.useCallback)(()=>{
        if (openNewsLetter) {
            return modalContentRef.current;
        }
        if (successModel) {
            return successModalContentRef.current;
        }
        return null;
    }, [
        openNewsLetter,
        successModel
    ]);
    const handleNewsLetterSignUp = async ()=>{
        setSubmissionStatus("");
        if (email === "" || email == null || (email === null || email === void 0 ? void 0 : email.length) === 0 || (email === null || email === void 0 ? void 0 : email.length) > 60) {
            var ref;
            setValidationError(staticTexts.enterEmail);
            newLetterPopupInputref === null || newLetterPopupInputref === void 0 ? void 0 : (ref = newLetterPopupInputref.current) === null || ref === void 0 ? void 0 : ref.focus();
            return;
        }
        if ((email === null || email === void 0 ? void 0 : email.length) > 0) {
            const isValid = await (0,helper/* validateField */.OP$)("email", email);
            if (!isValid) {
                var ref1;
                setValidationError(staticTexts.validEmail);
                newLetterPopupInputref === null || newLetterPopupInputref === void 0 ? void 0 : (ref1 = newLetterPopupInputref.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
                return;
            } else {
                setValidationError("");
                if (leadGenPageUrl) {
                    window.location.href = "".concat(leadGenPageUrl, "?email=").concat(email);
                    return;
                } else {
                    getSubscriptionData(email);
                }
            }
        }
    };
    const getSubscriptionData = (email)=>{
        const body = (0,newsLetterBody/* default */.Z)(siteName, email, language);
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res.success) {
                constants_api/* apim.post */.TH.post(constants.emailSubscribeEndPoint, body, {
                    params: {
                        brand: siteName
                    }
                }).then((response)=>{
                    if (response && response.data) {
                        var _resultMessages;
                        const isSuccess = (_resultMessages = response.data.resultMessages) !== null && _resultMessages !== void 0 ? _resultMessages : [];
                        if (isSuccess) {
                            // Code to handle success
                            setOpenNewsLetter(false);
                            setSuccessModel(true);
                            setIsResetForm(true);
                            setSubmissionStatus(staticTexts.submissionCompleteMsg || "");
                            localStorage.setItem(STORAGE_KEY_ALREADY_SUBCRIBED, true);
                            localStorage.setItem(STORAGE_KEY_LAST_COLSED_TIME, Date.now().toString());
                        }
                        setEmail("");
                        addNewsletterSignupAnalytics(siteName, "success", "", false);
                    } else {
                        addNewsletterSignupAnalytics(siteName, "failure", "news letter subscription api: error occured while fetching data from get url property", false);
                    }
                }).catch((err)=>{
                    var ref, ref1;
                    if (((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error) === "Email address already subscribed") {
                        setIsAlreadyExist(true);
                        setValidationError(staticTexts.alreadySubscribed);
                        setSubmissionStatus("");
                        localStorage.setItem(STORAGE_KEY_ALREADY_SUBCRIBED, true);
                        localStorage.setItem(STORAGE_KEY_LAST_COLSED_TIME, Date.now().toString());
                        addNewsletterSignupAnalytics(siteName, "failure", staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alreadySubscribed.toLowerCase(), false);
                    } else {
                        //  HANDLE OTHER ERRORS
                        setSubmissionStatus(staticTexts.genError);
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: staticTexts.genError,
                            isVisible: true
                        }));
                        addNewsletterSignupAnalytics(siteName, "failure", staticTexts.genError.toLowerCase(), false);
                    }
                });
            } else {
                setSubmissionStatus(staticTexts.genError);
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: staticTexts.genError,
                    isVisible: true
                }));
                addNewsletterSignupAnalytics(siteName, "failure", staticTexts.genError.toLowerCase(), false);
            }
        }).catch(()=>{
            setSubmissionStatus(staticTexts.genError);
            dispatch((0,genericSlice/* showToast */.CF)({
                message: staticTexts.genError,
                isVisible: true
            }));
            addNewsletterSignupAnalytics(siteName, "failure", staticTexts.genError.toLowerCase(), false);
        });
    };
    const onClose = (0,react.useCallback)(()=>{
        subModalAnalytics("close", "", false);
        setOpenNewsLetter(false);
        setSuccessModel(false);
        setSubmissionStatus("");
        localStorage.setItem(STORAGE_KEY_LAST_COLSED_TIME, Date.now().toString());
    }, []);
    const setInitalData = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        setSiteName(get_default()(config, "general.siteName", ""));
        setLanguage(get_default()(config, "internationalization.language", "en"));
    };
    (0,react.useEffect)(()=>{
        setStaticTexts(getTranslations(t));
        setInitalData();
    }, [
        t
    ]);
    (0,react.useEffect)(()=>{
        const canShowNewsletter = ()=>{
            if (hasShownNewsletter || isAuthOpen) {
                return false;
            }
            const lastClosed = localStorage.getItem(STORAGE_KEY_LAST_COLSED_TIME);
            const alreadySubcribed = localStorage.getItem(STORAGE_KEY_ALREADY_SUBCRIBED);
            if (alreadySubcribed && alreadySubcribed === "true") {
                // code to check storage clearence after 90 days
                const now = Date.now();
                const diff = now - parseInt(lastClosed, 10);
                if (CLEARENCE < diff) {
                    localStorage.removeItem(STORAGE_KEY_ALREADY_SUBCRIBED);
                    localStorage.removeItem(STORAGE_KEY_LAST_COLSED_TIME);
                }
                return false;
            }
            // If modal was closed before, enforce 48-hour cooldown
            if (lastClosed) {
                const now1 = Date.now();
                const diff1 = now1 - parseInt(lastClosed, 10);
                if (diff1 < COOLDOWN) {
                    return false;
                }
            }
            return true;
        };
        clearTimeout(newsletterTimerRef.current);
        newsletterTimerRef.current = null;
        if (!canShowNewsletter()) {
            if (isAuthOpen) {
                setOpenNewsLetter(false);
            }
            return undefined;
        }
        newsletterTimerRef.current = setTimeout(()=>{
            setHasShownNewsletter(true);
            setOpenNewsLetter(true);
        }, DELAY);
        return ()=>{
            clearTimeout(newsletterTimerRef.current);
            newsletterTimerRef.current = null;
        };
    }, [
        hasShownNewsletter,
        isAuthOpen
    ]);
    (0,react.useEffect)(()=>{
        if (isModalOpen) {
            document.body.classList.add("scroll-lock", "modal-open");
        } else {
            document.body.classList.remove("scroll-lock", "modal-open");
        }
        return ()=>{
            document.body.classList.remove("scroll-lock", "modal-open");
        };
    }, [
        isModalOpen
    ]);
    (0,react.useEffect)(()=>{
        if (isResetForm) setEmail("");
        if (isAlreadyExist) setValidationError(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alreadySubscribed);
    }, [
        isResetForm,
        isAlreadyExist
    ]);
    (0,react.useEffect)(()=>{
        if (!openNewsLetter) {
            setValidationError("");
            setSubmissionStatus("");
            setIsAlreadyExist(false);
        }
    }, [
        openNewsLetter
    ]);
    const handleFormSubmit = (e)=>{
        e.preventDefault();
        handleNewsLetterSignUp();
    };
    (0,react.useEffect)(()=>{
        if (!isModalOpen) {
            if (previousFocusedElementRef.current instanceof HTMLElement) {
                previousFocusedElementRef.current.focus();
            }
            previousFocusedElementRef.current = null;
            return undefined;
        }
        if (!(previousFocusedElementRef.current instanceof HTMLElement)) {
            previousFocusedElementRef.current = document.activeElement;
        }
        if (openNewsLetter) {
            var ref;
            newLetterPopupInputref === null || newLetterPopupInputref === void 0 ? void 0 : (ref = newLetterPopupInputref.current) === null || ref === void 0 ? void 0 : ref.focus();
            return undefined;
        }
        const activeModalElement = getActiveModalElement();
        const [firstFocusableElement] = getFocusableElements(activeModalElement);
        if (firstFocusableElement instanceof HTMLElement) {
            firstFocusableElement.focus();
        } else if (activeModalElement instanceof HTMLElement) {
            activeModalElement.focus();
        }
        return undefined;
    }, [
        getActiveModalElement,
        getFocusableElements,
        isModalOpen
    ]);
    (0,react.useEffect)(()=>{
        if (!isModalOpen) {
            return undefined;
        }
        const handleKeyDown = (e)=>{
            if (e.key === "Escape") {
                onClose();
                return;
            }
            if (e.key !== "Tab") {
                return;
            }
            const activeModalElement = getActiveModalElement();
            const focusableElements = getFocusableElements(activeModalElement);
            if (focusableElements.length === 0) {
                e.preventDefault();
                activeModalElement === null || activeModalElement === void 0 ? void 0 : activeModalElement.focus();
                return;
            }
            const firstFocusableElement = focusableElements[0];
            const lastFocusableElement = focusableElements[focusableElements.length - 1];
            const activeElement = document.activeElement;
            if (e.shiftKey && activeElement === firstFocusableElement) {
                e.preventDefault();
                lastFocusableElement.focus();
            } else if (!e.shiftKey && activeElement === lastFocusableElement) {
                e.preventDefault();
                firstFocusableElement.focus();
            } else if (!(activeModalElement === null || activeModalElement === void 0 ? void 0 : activeModalElement.contains(activeElement))) {
                e.preventDefault();
                firstFocusableElement.focus();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        getActiveModalElement,
        getFocusableElements,
        isModalOpen,
        onClose
    ]);
    if (isAuthOpen) {
        return null;
    }
    if (!data) {
        return null;
    }
    if (!openNewsLetter) {
        if (successModel) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: onClose,
                className: parentClass,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: successModalContentRef,
                    onClick: (e)=>e.stopPropagation(),
                    className: "".concat(innerClass, " success-popup"),
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": DIALOG_IDS.successTitle,
                    "aria-describedby": DIALOG_IDS.successDescription,
                    tabIndex: -1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: onClose,
                            className: "close-button",
                            "aria-label": "Close newsletter signup modal",
                            type: "button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/newsletter-close.svg",
                                alt: "",
                                "aria-hidden": "true"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "newsletter-popup_content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "newsletter-popup-header succes-error",
                                    id: DIALOG_IDS.successTitle,
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(postSubmitTitle)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "newsletter-popup-message succes-error",
                                    id: DIALOG_IDS.successDescription,
                                    role: "status",
                                    "aria-live": "polite",
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(postSubmitDescription)
                                })
                            ]
                        })
                    ]
                })
            });
        } else {
            return null;
        }
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: onClose,
            className: parentClass,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: modalContentRef,
                onClick: (e)=>e.stopPropagation(),
                className: innerClass,
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": DIALOG_IDS.signupTitle,
                "aria-describedby": DIALOG_IDS.signupDescription,
                tabIndex: -1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: onClose,
                        className: "close-button",
                        "aria-label": "Close newsletter signup modal",
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/newsletter-close.svg",
                            alt: "",
                            "aria-hidden": "true"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "newsletter-popup_box",
                        children: [
                            imageVariationEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "newsletter-popup_image",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_DynamicImage, {
                                    className: "teaser-pop-up-image",
                                    imgUrl: imagePath,
                                    alt: "",
                                    "aria-hidden": "true"
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "newsletter-popup_content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "newsletter-popup-header",
                                        id: DIALOG_IDS.signupTitle,
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(title)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        id: DIALOG_IDS.signupDescription,
                                        className: "sr-only",
                                        children: "Newsletter signup form. Enter your email address to subscribe."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        id: DIALOG_IDS.emailHint,
                                        className: "sr-only",
                                        children: [
                                            emailLabel,
                                            " is required."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: DIALOG_IDS.formStatus,
                                        className: "sr-only",
                                        "aria-live": "polite",
                                        children: (0,helper/* sanitizeDOMString */.TRt)(submissionStatus)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        className: "newsletter-popup-form",
                                        onSubmit: handleFormSubmit,
                                        noValidate: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                id: DIALOG_IDS.email,
                                                ref: newLetterPopupInputref,
                                                type: "email",
                                                value: email,
                                                maxLength: 60,
                                                placeholder: placeholder,
                                                label: emailLabel,
                                                name: "email",
                                                autoComplete: "email",
                                                onChange: (e)=>{
                                                    const { value  } = e.target;
                                                    setEmail(value);
                                                    if (validationError) {
                                                        setValidationError("");
                                                    }
                                                    if (submissionStatus) {
                                                        setSubmissionStatus("");
                                                    }
                                                },
                                                showError: false,
                                                errorMessage: "",
                                                onBlur: ()=>{},
                                                required: true,
                                                ariaRequried: true,
                                                "aria-invalid": validationError ? "true" : "false",
                                                "aria-describedby": emailDescribedBy,
                                                className: validationError ? "email-error" : "email"
                                            }),
                                            validationError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "subsribe-error-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    id: DIALOG_IDS.emailError,
                                                    role: "alert",
                                                    "aria-live": "assertive",
                                                    "data-testid": "email-error",
                                                    children: (0,helper/* sanitizeDOMString */.TRt)(validationError)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                ref: submitButton,
                                                customClass: "newsletter-popup-signup gbh-data-layer",
                                                type: "signup",
                                                label: submit,
                                                ariaLabel: submit || "Sign up for newsletter",
                                                role: "button",
                                                flexible: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "newsletter-popup-policy",
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(description)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
NewsLetterPopUp.protoTypes = {
    innerClass: (prop_types_default()).string,
    parentClass: (prop_types_default()).string,
    data: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./components/Shared/Footer.jsx











const SitewideWarning = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4707).then(__webpack_require__.bind(__webpack_require__, 64707)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(64707)
            ]
    },
    ssr: false
});
const Footer = (props)=>{
    const { data  } = props;
    const { siteWideWarning  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"].map((key, index)=>{
            var ref;
            const item = data[":items"][key];
            if (key === null || key === void 0 ? void 0 : key.includes("mainfooter")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_MainFooter, {
                            data: item,
                            columnClassNames: "".concat(key, " ").concat(data.columnClassNames[key])
                        }, "".concat(key, "-").concat(index)),
                        (siteWideWarning === null || siteWideWarning === void 0 ? void 0 : siteWideWarning.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SitewideWarning, {
                            isRendered: siteWideWarning.isRendered,
                            siteWideWarning: siteWideWarning === null || siteWideWarning === void 0 ? void 0 : siteWideWarning.content
                        }, "".concat(key, "-").concat(index, "-SitewideWarning"))
                    ]
                }, "".concat(key, "-").concat(index));
            }
            if (key.includes("newsletterpopup")) {
                const popupBackgroundClassNames = [
                    "bg-warm-gray-light",
                    "bg-white"
                ].filter((className)=>{
                    var ref, ref1;
                    return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.appliedCssClassNames) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref1 === void 0 ? void 0 : ref1.includes(className);
                }).join(" ");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsLetterPopUp, {
                    parentClass: "newsletter-popup",
                    innerClass: "newsletter-popup-main ".concat(popupBackgroundClassNames).trim(),
                    data: item
                }, "".concat(key, "-").concat(index));
            }
            if (key.includes("newslettersignin")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterFooter_NewsletterFooter, {
                    data: item,
                    columnClassNames: "".concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
            if (key.includes("additionalfooter")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_AdditionalFooter, {
                    data: item,
                    columnClassNames: "".concat(data[":items"][key]["appliedCssClassNames"], " ").concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
            if ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(constants.COMPONENT_TYPES.TEXT)) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Text, {
                    data: item,
                    columnClassNames: "".concat(data[":items"][key]["appliedCssClassNames"], " ").concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
        })
    });
};
/* harmony default export */ var Shared_Footer = (Footer);

// EXTERNAL MODULE: ./src/components/HelpSupport/v1/index.module.scss
var v1_index_module = __webpack_require__(18476);
var v1_index_module_default = /*#__PURE__*/__webpack_require__.n(v1_index_module);
;// CONCATENATED MODULE: ./src/components/HelpSupport/v1/HelpSupport.jsx





const HelpSupport = (param)=>{
    let { data  } = param;
    const { helpTitle ="" , helpDescription ="" , chatTitle ="" , chatDescription ="" , chatLink ="" , chatLinkRef =false , contactTitle ="" , contactDescription ="" , prodSupportTitle ="" , prodSupportDescription ="" , prodSupportItems =[] , chatText ="" , contactItems =[] , pageName ="" , enableChat =false  } = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (v1_index_module_default()).helpSupportWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "help-support ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "gbh-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "help-support-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "help-support-left-title",
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(helpTitle)
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "help-support-left-description",
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(helpDescription)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "help-support-right",
                        children: [
                            chatTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(chatTitle)
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(chatDescription)
                                        }
                                    }),
                                    chatLink && enableChat && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: (0,helper/* removeAndCleanLink */.xEh)(chatLink),
                                        target: chatLinkRef ? "_blank" : "_self",
                                        rel: "noopener noreferrer",
                                        "data-gbh-data-layer": '{"clickInternalLinks":"'.concat(!chatLinkRef, '","internalLinkPosition":"help support","internalLinkZoneName":"').concat(pageName, ':help and support","internalLinkURL":"').concat((0,helper/* removeAndCleanLink */.xEh)(chatLink), '","internalLinkName":"').concat(chatTitle, '","eventName":"').concat(pageName, ":help and support:").concat(chatTitle, '","internalLinkType":"').concat(pageName, ':navigation","eventType":"help support","eventAction":"').concat(pageName, ":help and support:").concat(chatTitle, '"}'),
                                        className: "gbh-data-layer",
                                        children: chatText
                                    })
                                ]
                            }),
                            contactTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(contactTitle)
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(contactDescription)
                                        }
                                    }),
                                    contactItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "contact-number",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: contactItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "tel:".concat(item.phoneNumber),
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"help support","internalLinkZoneName":"'.concat(pageName, ':help and support","internalLinkURL":"tel:').concat(item.phoneNumber, '","internalLinkName":"').concat(item.phoneNumber, '","eventName":"').concat(pageName, ":help and support:").concat(item.phoneNumber, '","internalLinkType":"').concat(pageName, ':call our team","eventType":"help support","eventAction":"').concat(pageName, ":help and support:").concat(item.phoneNumber, '"}'),
                                                        className: "gbh-data-layer",
                                                        children: item.phoneNumber
                                                    })
                                                }, "".concat(item.phoneNumber, "+").concat(index)))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    prodSupportTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(prodSupportTitle)
                                        }
                                    }),
                                    prodSupportDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize((0,helper/* removeAndCleanLink */.xEh)(prodSupportDescription))
                                        }
                                    }),
                                    prodSupportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "support-links",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: prodSupportItems.map((item)=>{
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                    className: item.isDisplayButton ? "chat-button" : "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: (0,helper/* removeAndCleanLink */.xEh)(item === null || item === void 0 ? void 0 : item.linkProdSup),
                                                        target: item.isNewTabProd ? "_blank" : "_self",
                                                        rel: "noopener noreferrer",
                                                        "data-gbh-data-layer": '{"clickInternalLinks": "'.concat(item.isNewTabProd ? "false" : "true", '", "internalLinkPosition": "help support", "internalLinkZoneName": "').concat(pageName, ':help and support", "internalLinkURL": "').concat((0,helper/* removeAndCleanLink */.xEh)(item === null || item === void 0 ? void 0 : item.linkProdSup), '", "internalLinkName": "').concat(item.labelProdSup, '", "eventName": "').concat(pageName, ":help and support:").concat(item.labelProdSup, '", "internalLinkType": "').concat(pageName, ':product support", "eventType": "help support", "eventAction": "').concat(pageName, ":help and support:").concat(item.labelProdSup, '"}'),
                                                        className: "gbh-data-layer",
                                                        children: item.labelProdSup
                                                    })
                                                }, item.labelProdSup);
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_HelpSupport = (HelpSupport);

// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
;// CONCATENATED MODULE: ./components/Default/Tab.jsx










const Tab = (props)=>{
    const { menu: { isOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data ={} , itemKey ="" , ...extraProps } = props;
    const [selectedTab, setTab] = (0,react.useState)(isOpen && "");
    const [isHeaderTab, setisHeaderTab] = (0,react.useState)(false);
    const tabElement = (0,react.useRef)();
    const onClickTab = (data)=>{
        props === null || props === void 0 ? void 0 : props.addHeaderNavTabAnalytics(data);
        if (selectedTab !== data["cq:panelTitle"]) {
            setTab(data["cq:panelTitle"]);
        } else setTab("");
    };
    (0,react.useEffect)(()=>{
        if (props.data.appliedCssClassNames === "ann-main-nav") {
            setisHeaderTab(true);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (props.data.appliedCssClassNames === "vertical-tabs" && data[":itemsOrder"] && data[":itemsOrder"][0]) {
            let tabData = data[":items"][data[":itemsOrder"][0]];
            if (selectedTab !== tabData["cq:panelTitle"]) {
                setTab(tabData["cq:panelTitle"]);
            } else setTab("");
        }
        if (data && data.appliedCssClassNames && data.appliedCssClassNames !== "ann-main-nav" && data.activeItem) {
            if (data[":itemsOrder"] && data[":itemsOrder"].includes(data.activeItem)) {
                let selectedTab1 = data[":items"][data.activeItem];
                setTab(selectedTab1["cq:panelTitle"]);
            }
        }
    }, [
        data
    ]);
    if (isHeaderTab) {
        var _appliedCssClassNames;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tabs ".concat((_appliedCssClassNames = props.data.appliedCssClassNames) !== null && _appliedCssClassNames !== void 0 ? _appliedCssClassNames : "", " ").concat(isOpen ? "open" : "", " "),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cmp-tabs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                        role: "tablist",
                        className: "cmp-tabs__tablist",
                        "aria-multiselectable": "false",
                        ref: tabElement,
                        children: data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                            const item = data[":items"][key];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab ".concat(selectedTab == item["cq:panelTitle"] ? "cmp-tabs__tab--active" : ""),
                                tabIndex: "0",
                                id: item["cq:panelTitle"],
                                onClick: ()=>onClickTab(item),
                                children: item["cq:panelTitle"]
                            }, item["cq:panelTitle"]);
                        })
                    }),
                    data[":itemsOrder"] && ((selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.length) > 0 || !lib/* isMobile */.tq) && data[":itemsOrder"].map((key, index)=>{
                        const item = data[":items"][key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "tabpanel",
                            className: "cmp-tabs__tabpanel ".concat(selectedTab == item["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : ""),
                            "aria-label": item["cq:panelTitle"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavTabs, {
                                selectedTab: selectedTab,
                                setTab: setTab,
                                data: item,
                                isTabOpen: selectedTab == item["cq:panelTitle"],
                                toggleMenu: ()=>{},
                                eventHandler: {
                                    store: {
                                        isOpen
                                    }
                                }
                            })
                        }, "navItem-".concat(index));
                    })
                ]
            })
        });
    } else {
        var _appliedCssClassNames1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tabs ".concat((_appliedCssClassNames1 = props.data.appliedCssClassNames) !== null && _appliedCssClassNames1 !== void 0 ? _appliedCssClassNames1 : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cmp-tabs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                        role: "tablist",
                        className: "cmp-tabs__tablist",
                        "aria-multiselectable": "false",
                        ref: tabElement,
                        children: data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                            const item = data[":items"][key];
                            const { id =""  } = item;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab ".concat(selectedTab == item["cq:panelTitle"] ? "cmp-tabs__tab--active" : ""),
                                tabIndex: "0",
                                id: item["cq:panelTitle"],
                                onClick: ()=>onClickTab(item),
                                children: item["cq:panelTitle"]
                            }, item["cq:panelTitle"]);
                        })
                    }),
                    data[":itemsOrder"] && ((selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.length) > 0 || !lib/* isMobile */.tq) && data[":itemsOrder"].map((key, index)=>{
                        var ref;
                        const item = data[":items"][key];
                        const { id =""  } = item;
                        // set for rerendering child component when nested tabs are present for recalculating the active indicator
                        const hasNestedTab = (ref = item[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.some((childKey)=>{
                            const obj = item[":items"][childKey];
                            return (0,utils/* isTab */.wR)(obj);
                        });
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "tabpanel",
                            className: "cmp-tabs__tabpanel ".concat(selectedTab == item["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : ""),
                            "aria-label": item["cq:panelTitle"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                                condition: (0,utils/* isContainer */.Nm)(item),
                                wrapper: (children)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(lib/* isMobile */.tq ? "".concat(selectedTab == item["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : "") : "".concat((0,utils/* isContainer */.Nm)(item) ? constants.staticClasses === null || constants.staticClasses === void 0 ? void 0 : constants.staticClasses.CONTAINER : "", " ").concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNames), " "),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cmp-container",
                                            children: (item === null || item === void 0 ? void 0 : item.gridClassNames) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: item === null || item === void 0 ? void 0 : item.gridClassNames,
                                                children: children
                                            }) : {
                                                children
                                            }
                                        })
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                                    ...hasNestedTab ? {
                                        key: selectedTab
                                    } : {},
                                    data: item,
                                    containerId: id,
                                    itemKey: key ? key : itemKey,
                                    ...extraProps
                                })
                            })
                        }, "navItem-".concat(index));
                    })
                ]
            })
        });
    }
};
/* harmony default export */ var Default_Tab = (Tab);

;// CONCATENATED MODULE: ./components/Shared/Embed.jsx








const Embed = (props)=>{
    const { data: { script ="" , matterportUrl ="" , visualIcon =false , html ="" , etype =""  } = {}  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const [stylesVal, setStylesVal] = (0,react.useState)([]);
    const [reloadStyles, setReloadStyles] = (0,react.useState)(false);
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const etypeUppercase = etype === null || etype === void 0 ? void 0 : etype.toUpperCase();
    const datalayerRef = (0,react.useRef)();
    const servicesClick = (e)=>{
        const { target: { href ="" , textContent =""  } = {}  } = e;
        datalayerForCookie(textContent, href);
        window.open(href);
    };
    const datalayerForCookie = (text, url)=>{
        const textCont = (0,helper/* sanitizeTextForAnalytics */.T68)(text);
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "legal:cookie policy:".concat(textCont),
            eventMsg: "n/a",
            eventName: "legal:cookie policy:".concat(textCont),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "".concat(textCont),
            internalLinkPosition: "kohler:legal:cookie policy",
            internalLinkType: "kohler:legal:cookie policy:one trust",
            internalLinkURL: url,
            internalLinkZoneName: "kohler:legal:cookie policy:".concat(textCont)
        };
        (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click");
    };
    (0,react.useEffect)(()=>{
        let elements = document.querySelectorAll(".embeddedServiceHelpButton");
        elements.forEach((element, index)=>{
            if (index > 0) {
                element.style.display = "none";
            }
        });
    });
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            const { styles =[]  } = (0,helper/* isEmbeddedStyles */.fM6)(script);
            setStylesVal(styles);
            if (!reloadStyles) {
                // This is to make sure any 3rdParty Component loaded to the page will get styles applied after loading
                setTimeout(function() {
                    setReloadStyles(true);
                    dispatch((0,genericSlice/* toggleSiteWideWarning */.jy)());
                }, 3000);
            }
        }
    }, [
        isSsr,
        pageIsInteractive,
        reloadStyles
    ]);
    (0,react.useEffect)(()=>{
        if (datalayerRef === null || datalayerRef === void 0 ? void 0 : datalayerRef.current) {
            var ref;
            datalayerRef === null || datalayerRef === void 0 ? void 0 : (ref = datalayerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                if ((item === null || item === void 0 ? void 0 : item.getAttribute("listener")) !== "true") {
                    item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                        servicesClick(e);
                    });
                }
            });
        }
        return ()=>{
            var ref;
            datalayerRef === null || datalayerRef === void 0 ? void 0 : (ref = datalayerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.removeEventListener("click", servicesClick);
            });
        };
    }, [
        isSsr
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: datalayerRef,
        children: [
            html && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "embed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-embed",
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                })
            }),
            script && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "embed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-embed",
                    dangerouslySetInnerHTML: {
                        __html: script
                    }
                })
            }),
            !isSsr && visualIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-visual-icons",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "gbh-visual-icon-area",
                    tabIndex: "0",
                    role: "button",
                    "aria-label": constants.VISUALICON_ARIA_LABEL
                })
            }),
            stylesVal.map((style, i)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        id: "embedStyle-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()),
                        children: style
                    })
                }, "embedStyle-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal fade virtual-tour-popup",
                tabIndex: "-1",
                role: "dialog",
                "aria-labelledby": constants.MATTERPORT_ARIA_LABEL,
                "aria-hidden": "true",
                "data-keyboard": "false",
                "data-backdrop": "static",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-dialog",
                    role: "document",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-content",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "close",
                                    "data-dismiss": "modal",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "\xd7"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    src: matterportUrl,
                                    title: "",
                                    style: {
                                        width: "100%",
                                        height: "800px",
                                        border: "0"
                                    },
                                    allowFullScreen: true
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_Embed = (Embed);

;// CONCATENATED MODULE: ./src/components/Default/Spacer/v1/Spacer.jsx

const Spacer = (param)=>{
    let { data  } = param;
    const { backgroundColor ="" , desktopHeight ="" , ipadHeight ="" , mobileHeight =""  } = data;
    const toCssUnit = (value)=>typeof value === "number" ? "".concat(value, "px") : value || undefined;
    const style = {
        backgroundColor,
        color: backgroundColor,
        "--spacer-desktop-height": toCssUnit(desktopHeight),
        "--spacer-ipad-height": toCssUnit(ipadHeight),
        "--spacer-mobile-height": toCssUnit(mobileHeight)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-separator",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
            className: "cmp-separator__horizontal-rule",
            style: style
        })
    });
};
/* harmony default export */ var v1_Spacer = (Spacer);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/components/Default/PromoBanner/v1/index.module.scss
var PromoBanner_v1_index_module = __webpack_require__(76610);
var PromoBanner_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(PromoBanner_v1_index_module);
;// CONCATENATED MODULE: ./components/Default/PromoBanner/v1/PromoBanner.jsx









const PromoBanner = (param)=>{
    let { data ={} , properties ={}  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const getShowArrowIndication = (defaultValue)=>{
        return (data === null || data === void 0 ? void 0 : data.showArrowIndication) === undefined ? defaultValue : data.showArrowIndication === true;
    };
    const showArrowIndication = getShowArrowIndication(true);
    const promoBannerSettings = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: showArrowIndication,
        infinite: true,
        centerMode: false
    };
    const { eventPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const setPromoModal = (data)=>{
        dispatch((0,genericSlice/* showPromoModal */.Wv)(data));
        (0,helper/* preventBodyScroll */.MVu)(true);
    };
    const [bannerIndex, setBannerIndex] = (0,react.useState)(0);
    const getComponentMessage = (message, index)=>{
        if (message && index > -1) {
            const obj = JSON.parse(message);
            obj.componentInfo.componentMessage = "".concat(obj.componentInfo.componentMessage).concat(index + 1);
            return JSON.stringify(obj);
        }
    };
    const afterChangeHandler = (currentIndex)=>{
        setBannerIndex(currentIndex);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PromoBanner_v1_index_module_default()).promoBannerWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "carousel-slick carousel ".concat(data === null || data === void 0 ? void 0 : (ref = data.carouselComponentProperties) === null || ref === void 0 ? void 0 : ref.appliedCssClassNames),
            role: "group",
            "aria-label": data["carouselComponentProperties"]["accessibilityLabel"] || undefined,
            "aria-roledescription": "carousel",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType, ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentPosition) ? properties.componentPosition : "carousel", '","internalLinkZoneName":"').concat(data === null || data === void 0 ? void 0 : (ref1 = data.pageName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentZone) ? properties.componentZone : "carousel", '","internalLinkURL":"n/a","internalLinkName":"carousel:rm","eventName":"').concat(data === null || data === void 0 ? void 0 : (ref2 = data.pageName) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","internalLinkType":"').concat((properties === null || properties === void 0 ? void 0 : properties.componentLinkType) ? properties.componentLinkType : "navigation", '","eventType":"carousel","eventAction":"').concat(data === null || data === void 0 ? void 0 : (ref3 = data.pageName) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '"}'),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-carousel cmp-carousel-slick ",
                role: "group",
                "aria-label": data["carouselComponentProperties"]["accessibilityLabel"] || undefined,
                "aria-roledescription": "carousel",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                    ...promoBannerSettings,
                    className: "cmp-carousel-slick__content single-slider",
                    afterChange: afterChangeHandler,
                    variableWidth: true,
                    children: data["carouselComponentProperties"][":itemsOrder"] && ((ref4 = data["carouselComponentProperties"][":itemsOrder"]) === null || ref4 === void 0 ? void 0 : ref4.map((key, index, arr)=>{
                        var ref;
                        const item = data["carouselComponentProperties"][":items"][key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "promo-banner promo-banner-message",
                                style: {
                                    visibility: "visible"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cmp-promo__description",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                marginRight: "1px"
                                            },
                                            dangerouslySetInnerHTML: {
                                                __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : item.description)
                                            }
                                        }),
                                        (item === null || item === void 0 ? void 0 : item.actionsEnabled) && (item === null || item === void 0 ? void 0 : (ref = item.actionItems) === null || ref === void 0 ? void 0 : ref.map((action, index)=>{
                                            var ref;
                                            return action.enablePopup ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                onClick: ()=>setPromoModal({
                                                        show: true,
                                                        modalContent: {
                                                            banner: item,
                                                            item: action,
                                                            count: index
                                                        }
                                                    }),
                                                "data-toggle": "modal",
                                                "data-target": "#".concat(item === null || item === void 0 ? void 0 : item.promoId, "-").concat(index),
                                                className: "cmp-promo__action-link btn promo-banner-fragment",
                                                rel: "".concat(action.linkRef ? "noreferrer" : ""),
                                                "data-gbh-component": getComponentMessage(item === null || item === void 0 ? void 0 : item.componentInfos, bannerIndex),
                                                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(item === null || item === void 0 ? void 0 : (ref = item.pageType) === null || ref === void 0 ? void 0 : ref.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentPosition) ? properties.componentPosition : "promo banner", '","internalLinkZoneName":"').concat(item === null || item === void 0 ? void 0 : item.pageType.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentZone) ? properties.componentZone : "global header", '","internalLinkURL":"n/a","internalLinkName":"').concat(action === null || action === void 0 ? void 0 : action.text, '","eventName":"').concat(action === null || action === void 0 ? void 0 : action.text.toLowerCase(), '","internalLinkType":"').concat((properties === null || properties === void 0 ? void 0 : properties.componentLinkType) ? properties.componentLinkType : "navigation", '","eventType":"promo banner","eventAction":"').concat(action === null || action === void 0 ? void 0 : action.text.toLowerCase(), '"}'),
                                                "data-gbh-clickable": true,
                                                children: action === null || action === void 0 ? void 0 : action.text
                                            }, "#".concat(item === null || item === void 0 ? void 0 : item.promoId, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                                item: item,
                                                ...action,
                                                link: (action === null || action === void 0 ? void 0 : action.link) || (action === null || action === void 0 ? void 0 : action.ctaLink),
                                                newTab: action === null || action === void 0 ? void 0 : action.isNewTab,
                                                bannerIndex: bannerIndex
                                            }, "promo-banner-action-".concat(bannerIndex + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                                        }))
                                    ]
                                })
                            })
                        }, (item === null || item === void 0 ? void 0 : item.id) ? item === null || item === void 0 ? void 0 : item.id : "cmp-promo-banner-".concat(index, "-").concat((0,helper/* getRandom */.sZz)()));
                    }))
                })
            })
        })
    });
};
/* harmony default export */ var v1_PromoBanner = (PromoBanner);

;// CONCATENATED MODULE: ./src/components/Default/AemForm.jsx






const AemForm = (props)=>{
    var ref;
    const { data: { formPath , submitType , thankyouMessage , useiframe , enableFocusOnFirstField , thankyouConfig  }  } = props;
    const [innerHtmlToSet, setInnerHtmlToSet] = (0,react.useState)("");
    const [formScripts, setFormScripts] = (0,react.useState)(null);
    const [noOfScripts, setNoOfScripts] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        (0,constants_api/* aemAxiosInstance */.Gb)({
            url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: formPath + ".html"
            }
        }).then((res)=>{
            const scriptsList = [];
            let innerHTML = res.data;
            if ((location === null || location === void 0 ? void 0 : location.hostname) === "localhost") {
                innerHTML = innerHTML.split('rel="stylesheet" href="').join('rel="stylesheet" href="'.concat(constants.authorBaseUrl));
                innerHTML = innerHTML.split('<script src="').join('<script src="'.concat(constants.authorBaseUrl));
            }
            const doc = new DOMParser().parseFromString(innerHTML, "text/html");
            (0,helper/* extractScriptsFromDOM */.CZn)(doc, (item)=>scriptsList.push(item));
            setFormScripts(scriptsList);
            setInnerHtmlToSet(doc);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "aemFormInitialLoadJavascript",
                "data-nscript": "afterInteractive",
                children: 'const onAemFormScriptLoad = evnt => {\n    const formApp = evnt.detail.formApp\n    formApp.initializeAEMForm({\n      form: "true",\n      submitType: "'.concat(submitType, '",\n      thankyouConfig: "').concat(thankyouConfig, '",\n      thankyouMessage: "').concat(encodeURI(thankyouMessage), '",\n      thankyouPage: "",\n      useIframe: "').concat(useiframe, '",\n      height: "auto",\n      aemFormComponentPath: "aemform",\n      enableFocusOnFirstField: "').concat(enableFocusOnFirstField, '",\n    })\n    // remove the event listener after completion\n    window.removeEventListener("aemform-onscript-load", onAemFormScriptLoad)\n  };\n  window.addEventListener("aemform-onscript-load", onAemFormScriptLoad);')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "/js/formapp.js"
            }),
            formScripts && formScripts.map((script, i)=>{
                if (!script.innerHTML && noOfScripts === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: script.src,
                    id: "aemform-src-script-".concat(i),
                    onReady: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    onError: ()=>{
                        setNoOfScripts(i + 1);
                    }
                }, "aemform-src-script-".concat(i));
                if (script.innerHTML && noOfScripts === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "aemform-innerscript-".concat(i),
                    onReady: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    onError: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    children: "".concat(script.innerHTML)
                }, "aemform-innerscript-".concat(i));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aemform aem-genericForm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "aemformcontainer",
                    "data-form-page-path": formPath,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: innerHtmlToSet === null || innerHtmlToSet === void 0 ? void 0 : (ref = innerHtmlToSet.documentElement) === null || ref === void 0 ? void 0 : ref.innerHTML
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Default_AemForm = (AemForm);

// EXTERNAL MODULE: ./components/productCard/v1/ProductCard.view.jsx
var ProductCard_view = __webpack_require__(27221);
// EXTERNAL MODULE: ./src/components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(85721);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./src/components/productCard/v1/analytics.js
var v1_analytics = __webpack_require__(41740);
// EXTERNAL MODULE: ./src/components/productCard/v1/productCardHelper.js
var productCardHelper = __webpack_require__(15011);
// EXTERNAL MODULE: ./src/components/productCard/v1/index.module.scss
var productCard_v1_index_module = __webpack_require__(49696);
var productCard_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(productCard_v1_index_module);
;// CONCATENATED MODULE: ./src/components/productCard/v1/ProductCardService.jsx


















const ProductCardService = (props)=>{
    const { staticTexts ={} , imagePosition ="" , narrativeDescription , productFeatures =[] , productCategory ="" , badgeVal ="" , currencySign ="" , isNearestValueUpdated =Boolean , resetNearestValueUpdateFlag =()=>{} , cart ={} , price =Number , skuId ="" , images ="" , userZipCode ="" , slug ="" , getZipCode =()=>{} , customerBrand ="" , name: servicePlanName = ""  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [isNearest, setIsNearest] = (0,react.useState)(false);
    const [isNotNearestError, setIsNotNearestError] = (0,react.useState)(false);
    const [isCheckAvailability, setIsCheckAvailability] = (0,react.useState)(true);
    const [checkZipCode, setCheckZipCode] = (0,react.useState)("");
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const [findaProLandingPagePath, setFindaProLandingPagePath] = (0,react.useState)("");
    const [siteName, setSiteName] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
            const { general  } = CONFIG;
            var ref;
            (0,helper/* getShortenedUrl */.Ppy)((ref = general === null || general === void 0 ? void 0 : general.findaProLandingPagePath) !== null && ref !== void 0 ? ref : "/").then((url)=>{
                setFindaProLandingPagePath(url);
            });
            var ref1;
            (0,helper/* getShortenedUrl */.Ppy)((ref1 = general === null || general === void 0 ? void 0 : general.cartLandingPagePath) !== null && ref1 !== void 0 ? ref1 : "/").then((url)=>{
                setCartUrl(url);
            });
            setSiteName((general === null || general === void 0 ? void 0 : general.siteName) ? general.siteName[0] : "");
        });
    }, []);
    const showToaster = (msg)=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: msg,
            isVisible: true
        }));
    };
    const { altTextForServiceImg ="" , virtualService ="" , virtualTooltip ="" , nearestInPerson ="" , nearestService ="" , change ="" , zipCode ="" , eligibleZipCodeSuccess ="" , eligibleZipCodeError ="" , discountPercentage ="" , off ="" , yourCart , itemAdded , itemsAdded , zipcodeEmptyError ="" , zipodeEmptyError ="" , validZipcode ="" , search =""  } = staticTexts;
    const installServices = productCategory === "Install Services";
    const designServices = productCategory === "Design Services";
    (0,react.useEffect)(()=>{
        if (isNearestValueUpdated && resetNearestValueUpdateFlag) {
            resetNearestValueUpdateFlag();
            if (!isNearest) {
                addZipcodeAnalytics("failure", eligibleZipCodeError.toLowerCase());
            } else {
                addZipcodeAnalytics("success");
            }
        }
    }, [
        isNearestValueUpdated
    ]);
    let discountedPrice = props.discountedPrice;
    let discountPercent = props.discountPercent;
    let discountType = "";
    if ((cart === null || cart === void 0 ? void 0 : cart.lineItems) && cart.lineItems.length > 0) {
        cart.lineItems.filter((item)=>item.productSlug["en-US"] === slug).map((product)=>{
            if (product.discountedPrice) {
                discountedPrice = (Number(get_default()(product.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
                discountType = get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.type", "");
                discountPercent = discountType === "absolute" ? Number(get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
            }
            if (discountPercent === 0) {
                discountedPrice = Number(get_default()(product.price, "discounted.value.centAmount", 0) / 100).toFixed(2);
                discountType = get_default()(product.price, "discounted.discount.obj.value.type", "");
                discountPercent = discountType === "absolute" ? Number(get_default()(product.price, "discounted.discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(product.price, "discounted.discount.obj.value.permyriad", 0)) / 100;
            }
        });
    }
    const productPrice = discountPercent > 0 ? discountedPrice : price;
    if (discountType === "") {
        var ref;
        discountType = badgeVal && ((ref = badgeVal === null || badgeVal === void 0 ? void 0 : badgeVal.split(" ")) === null || ref === void 0 ? void 0 : ref.includes("Percent")) ? "relative" : "absolute";
    }
    const getSaleOffer = "<p class='offer-percent'>".concat(discountType === "relative" ? discountPercent + discountPercentage : currencySign + discountPercent + "<span class='offer-percent-text'>" + off + "</span>", "</p>");
    const productAnalyticsData = {
        desc: productFeatures ? (0,helper/* sanitizeTextForAnalytics */.T68)(productFeatures.join(". ")) : "n/a",
        discountPrice: discountPercent > 0 ? discountedPrice : 0,
        discountPriceState: discountPercent > 0 ? "percentOff|" + discountPercent : "regular price",
        unitPrice: price,
        category: (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory),
        color: "n/a",
        sku: skuId,
        name: (0,helper/* sanitizeTextForAnalytics */.T68)(props.name),
        image: images,
        customerFacingSKU: props.customerFacingSKU || (siteName ? siteName[0] + "-" + skuId : ""),
        skuInitials: props.customerFacingSKU ? props.customerFacingSKU.split("-")[0] + "-" : siteName ? siteName[0] + "-" : "",
        discountName: badgeVal,
        superSku: false,
        selectedColor: "n/a",
        productSaleable: true
    };
    const { desc ="n/a" , unitPrice =0 , discountPriceState , category , color , customerFacingSKU , name , discountName  } = productAnalyticsData;
    const serviceName = productCategory === "Design Services" ? "bathroom design services" : (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory);
    let globalDiscount = props.globalDiscount;
    const { productCouponCode , productCoupondiscount , globalDiscountNames , globalDiscountValues  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
        cart: cart,
        sku: skuId
    });
    let globalOffer = [
        discountName
    ];
    if ((globalDiscountNames === null || globalDiscountNames === void 0 ? void 0 : globalDiscountNames.length) && globalDiscountValues) {
        globalOffer = [
            discountName,
            ...globalDiscountNames
        ];
        globalDiscount += globalDiscountValues;
    }
    const productInfo = {
        description: desc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((price - globalDiscount).toFixed(2)) : 0,
        globalOffer: globalOffer.join("|") || "n/a",
        globalDiscount: globalDiscount ? Number(globalDiscount.toFixed(2)) : 0,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountPriceState,
        productBasePrice: Number(unitPrice) || "n/a",
        productCategory: category || "n/a",
        productColor: color || "n/a",
        productCoupondiscount: productCoupondiscount || 0,
        productCouponCode: productCouponCode.join("|") || "n/a",
        productID: customerFacingSKU || "n/a",
        productName: name || desc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "service" || 0,
        productSalePrice: Number(productPrice),
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: name || "n/a",
        quantity: quantity || "n/a",
        defaultImageName: productAnalyticsData.image || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: category || "n/a",
        productBrand: siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(),
        itemType: "service" || 0
    };
    const getToasterMsg = (msg)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                msg,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: cartUrl,
                    children: yourCart
                }),
                "."
            ]
        });
    const handleCallback = (res, msg)=>{
        if (productCategory === "Install Services") {
            const eventInfoObj = getEventInfoObject("add to cart");
            const { status , message ="n/a"  } = res;
            eventInfoObj.eventStatus = status === 200 ? "success" : "failure";
            if (status !== 200) {
                eventInfoObj.eventMsg = message ? (0,helper/* sanitizeTextForAnalytics */.T68)(message) : "n/a";
            }
            (0,v1_analytics/* callInstallServiceAddToCartAnalytics */.gA)({
                resInfo: res,
                eventInfoObj,
                productInfo,
                cartID: cart === null || cart === void 0 ? void 0 : cart.id
            });
        }
        if (productCategory === "Design Services") {
            (0,v1_analytics/* callDesignServicesAddToCartAnalytics */.__)(res, productInfo, serviceName, cart === null || cart === void 0 ? void 0 : cart.id);
        }
        if (lib/* isMobile */.tq) showToaster(getToasterMsg(msg));
    };
    const addtoCart = (items)=>{
        let totalAdded = 0;
        items.forEach((item)=>totalAdded += item.quantity);
        const msg = totalAdded === 1 ? "".concat(totalAdded, " ").concat(itemAdded, " ") : "".concat(totalAdded, " ").concat(itemsAdded, " ");
        (0,productCardHelper/* productCardAddToCart */.x)([
            ...items
        ], true, "", (res)=>handleCallback(res, msg), false);
    };
    const handleAddToCart = ()=>{
        if (productCategory === "Design Services") {
            addtoCart([
                {
                    sku: skuId,
                    quantity: quantity,
                    brand: customerBrand
                }
            ]);
        } else {
            if (!isEmpty_default()(userZipCode)) {
                addtoCart([
                    {
                        sku: skuId,
                        quantity: quantity,
                        userZipCode: userZipCode,
                        brand: customerBrand
                    }
                ]);
            }
        }
    };
    const handleChange = async (qty)=>{
        if (qty && qty !== 0) {
            setQuantity(qty);
        }
    };
    const handleCheckAvailability = async ()=>{
        setZipCodeError({
            show: false,
            message: ""
        });
        let valid = true;
        let errorMessage = "";
        if (isEmpty_default()(checkZipCode)) {
            setZipCodeError({
                show: true,
                message: zipcodeEmptyError
            });
            valid = false;
            errorMessage = zipodeEmptyError.toLowerCase();
        } else if (!(0,helper/* validateField */.OP$)("zipcode", checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
            valid = false;
            errorMessage = validZipcode === null || validZipcode === void 0 ? void 0 : validZipcode.toLowerCase();
        } else if (!await (0,utils_location/* validateZip */.$8)(checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
            valid = false;
            errorMessage = validZipcode === null || validZipcode === void 0 ? void 0 : validZipcode.toLowerCase();
        }
        if (valid) {
            getZipCode(checkZipCode, true, callBackZipCode);
        } else {
            addZipcodeAnalytics("failure", errorMessage);
        }
    };
    const handleChangeZipCode = (e)=>{
        const { value  } = e.target;
        if ((0,helper/* validateField */.OP$)("zipCodeNumeric", value) || value === "") {
            setCheckZipCode(value);
        }
        setIsNotNearestError(false);
        setZipCodeError({
            show: false,
            message: ""
        });
    };
    const zipCodeCheck = ()=>{
        if (!(0,helper/* validateField */.OP$)("zipcode", checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
        } else {
            setZipCodeError({
                show: false,
                message: ""
            });
        }
    };
    const getEventInfoObject = (eventNameText, buttonName)=>{
        return {
            clickInternalLinks: "true",
            eventAction: "installation services:install service:" + eventNameText,
            eventName: "installation services:install service:" + eventNameText,
            eventType: "navigation",
            internalLinkName: buttonName !== null && buttonName !== void 0 ? buttonName : eventNameText,
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkPosition: "find installation services",
            internalLinkType: "installation services:" + (eventNameText !== "check availability" || !checkZipCode ? "navigation" : checkZipCode),
            internalLinkURL: eventNameText === "find a pro" ? ((findaProLandingPagePath === null || findaProLandingPagePath === void 0 ? void 0 : findaProLandingPagePath.indexOf("http")) === -1 ? window.location.origin : "") + findaProLandingPagePath : "n/a",
            internalLinkZoneName: "installation services:" + productAnalyticsData.name
        };
    };
    const addZipcodeAnalytics = (status, message)=>{
        const eventInfoObj = getEventInfoObject("check availability", "search");
        eventInfoObj.eventMsg = message || "n/a";
        eventInfoObj.eventStatus = status;
        (0,v1_analytics/* callInstallServiceAddToCartAnalytics */.gA)({
            resInfo: {},
            productInfo,
            eventInfoObj,
            cartID: cart === null || cart === void 0 ? void 0 : cart.id
        });
    };
    const callBackZipCode = (isServiceAvailable)=>{
        setIsNearest(isServiceAvailable);
        setIsNotNearestError(!isServiceAvailable);
        setIsCheckAvailability(!isServiceAvailable);
        if (isServiceAvailable) sessionStorage.setItem("verifiedZip", checkZipCode);
    };
    (0,react.useEffect)(()=>{
        const isVerifiedZip = sessionStorage.getItem("verifiedZip");
        if (isVerifiedZip) {
            setIsNearest(true);
            setIsNotNearestError(false);
            setIsCheckAvailability(false);
            setCheckZipCode(isVerifiedZip);
        }
    }, []);
    const handleClickChangeBtn = ()=>{
        setIsCheckAvailability(true);
        setIsNearest(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (productCard_v1_index_module_default()).productCardWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-card-service",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "kf-react-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row ml-0 mr-0 no-gutters",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col product-card-service__details \n                  ".concat(imagePosition === "left" ? " product-card-service__details-align" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(productCategory === "Install Services" ? "product-card-service__details-header" : "product-card-service__service-install"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        className: "product-card-service__name",
                                                        children: servicePlanName
                                                    }),
                                                    productCategory === "Install Services" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "product-card-service__desc",
                                                        children: narrativeDescription
                                                    }) : null,
                                                    productCategory === "Design Services" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-card-service__virtual-list",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: productFeatures.map((list, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: list
                                                                }, index))
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-card-service__img-container \n                              ".concat(imagePosition === "left" ? " product-card-service__img-container-align" : "", " \n                              mobile-landscape-image"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: images,
                                                    className: "product-card-service__img",
                                                    alt: altTextForServiceImg
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-card-service__virtual-service \n                          ".concat(productCategory ? " product-card-service__virtual-service-zip" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-card-service__eligible-service",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "left",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "product-card-service__eligible-service-txt",
                                                                    children: designServices ? virtualService : isNearest ? nearestInPerson : nearestService
                                                                }),
                                                                isNearest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "product-card-service__zipcode",
                                                                            children: checkZipCode
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            tabIndex: "0",
                                                                            role: "link",
                                                                            className: "product-card-service__eligible-service-edit gbh-data-layer",
                                                                            "data-gbh-data-layer": JSON.stringify(getEventInfoObject("edit", "change")),
                                                                            "data-gbh-data-layer-custom": JSON.stringify({
                                                                                productInfo
                                                                            }),
                                                                            onClick: handleClickChangeBtn,
                                                                            children: [
                                                                                " ",
                                                                                change
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-card-service__price",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    className: "product-card-service__price-value",
                                                                    value: productPrice,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                }),
                                                                discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "product-card-service__discount-price",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "product-card-service__offer-price",
                                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(getSaleOffer)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                            className: "strike-through-price",
                                                                            value: price,
                                                                            displayType: "text",
                                                                            thousandSeparator: true,
                                                                            prefix: currencySign,
                                                                            decimalScale: 2,
                                                                            fixedDecimalScale: true
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                isCheckAvailability && installServices ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-card-service__zipcode-availability",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                    id: "zipCode-".concat((0,helper/* getRandom */.sZz)()),
                                                                    type: "text",
                                                                    maxLength: 60,
                                                                    placeholder: "".concat(zipCode),
                                                                    label: "".concat(zipCode),
                                                                    value: checkZipCode,
                                                                    customClass: "".concat(zipCodeError.show ? "product-card-service__zipcode-input-error" : ""),
                                                                    onKeyDown: (e)=>e.key === "Enter" && handleCheckAvailability(),
                                                                    onChange: handleChangeZipCode,
                                                                    onBlur: zipCodeCheck
                                                                }),
                                                                checkZipCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    role: "button",
                                                                    className: "product-card-service__check-availability-cta",
                                                                    label: search,
                                                                    size: "small",
                                                                    type: " ",
                                                                    disabled: checkZipCode.length < 5,
                                                                    onClick: handleCheckAvailability
                                                                }) : null
                                                            ]
                                                        }),
                                                        zipCodeError.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "product-card-service__zipcode-error",
                                                            children: zipCodeError.message
                                                        })
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-card-service__eligible-service-container",
                                                    children: [
                                                        isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "product-card-service__eligible-service-message",
                                                            children: designServices ? virtualTooltip : eligibleZipCodeSuccess
                                                        }) : null,
                                                        isNotNearestError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "error",
                                                            children: [
                                                                eligibleZipCodeError,
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: findaProLandingPagePath,
                                                                    className: "product-card-service__find-a-pro gbh-data-layer",
                                                                    "data-gbh-data-layer": JSON.stringify(getEventInfoObject("find a pro")),
                                                                    "data-gbh-data-layer-custom": JSON.stringify({
                                                                        productInfo
                                                                    }),
                                                                    children: staticTexts.findaPro
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-card-service__price-and-cart",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-card-service__cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cartAction mx-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "quantity-selector-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                                            doNotRequiredAnalyticsData: true,
                                                            productData: productAnalyticsData,
                                                            value: quantity,
                                                            onChange: handleChange,
                                                            isPDPQuantitySelector: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "add-to-cart-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            role: "button",
                                                            label: staticTexts.addToCart,
                                                            onClick: handleAddToCart,
                                                            size: "large",
                                                            type: "primary",
                                                            flexible: true,
                                                            disabled: productCategory !== "Design Services" ? !isNearest : false
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card-service__img-container ".concat(imagePosition === "left" ? " product-card-service__img-container-align" : "", " product-card-service-main-image"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: images,
                                className: "product-card-service__img",
                                alt: altTextForServiceImg
                            })
                        })
                    ]
                })
            })
        })
    });
};
ProductCardService.defaultProps = {
    newTab: false,
    staticTexts: {}
};
ProductCardService.propTypes = {
    newTab: (prop_types_default()).bool,
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var v1_ProductCardService = (ProductCardService);

;// CONCATENATED MODULE: ./src/i18n/useProductCardi18n.js

const useProductCardi18n = (param)=>{
    let { componentProps  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        color: t("kf.productcard.color"),
        colors: t("kf.productcard.colors"),
        altText: t("kf.productCard.altText"),
        altTextForServiceImg: t("kf.productCard.altTextForServiceImg"),
        virtualService: t("kf.productCard.virtualService"),
        virtualTooltip: t("kf.productCard.virtualTooltip"),
        addToCart: t("kf.productCard.addToCart"),
        toolTipAlt: t("kf.productCard.toolTipAlt"),
        nearestService: t("kf.productCard.nearestService"),
        nearestInPerson: t("kf.productCard.nearestInPerson"),
        edit: t("kf.productCard.edit"),
        eligibleZipCodeSuccess: t("kf.productCard.eligibleZipCodeSuccess"),
        eligibleZipCodeError: t("kf.productCard.eligibleZipCodeError"),
        zipcode: t("kf.productCard.zipcode"),
        findaPro: t("kf.productCard.findaPro"),
        checkAvailability: t("kf.productCard.checkAvailability"),
        maxInventory: t("kf.productCard.maxInventory"),
        itemsAdded: t("kf.productCard.itemsAdded"),
        itemAdded: t("kf.productCard.itemAdded"),
        yourCart: t("kf.productCard.yourCart"),
        zipcodeEmptyError: t("kf.productCard.zipcodeEmptyError"),
        validZipcode: t("kf.productCard.validZipcode"),
        ariaLabel: {
            color: t("kf.productCard.aria.colors"),
            tooltip: t("kf.productCard.aria.tooltip"),
            editZip: t("kf.productCard.aria.label.editZip"),
            findPro: t("kf.productCard.aria.label.findPro")
        },
        discountPercentage: t("kf.productCard.discountPercentage"),
        off: t("kf.productCard.off"),
        lfLabel: t("annsacks.pdpTrimCalculator.label.LF"),
        sfLabel: t("annsacks.pdpTrimCalculator.label.SF"),
        eaLabel: t("annsacks.pdpTrimCalculator.label.EA"),
        eaBoxLabel: t("annsacks.pdpTrimCalculator.label.Box"),
        boxLabel: t("annsacks.pdpProductSummary.label.perBox"),
        recentlyViewedColor: t("kf.productcard.color"),
        recentlyViewedColors: t("kf.productcard.colors")
    };
    return i18n;
};
/* harmony default export */ var i18n_useProductCardi18n = (useProductCardi18n);

// EXTERNAL MODULE: ./src/store/features/cartSlice.js
var cartSlice = __webpack_require__(64925);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./components/productCard/v1/ProductCard.jsx

















const ProductCard = (props)=>{
    const { data: authorData , data: { presetConfigs  } , singleSku , product =null , analyticsData , newTab =false  } = props;
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const state = {
        productSkuId: authorData.type === "productSku" ? get_default()(authorData, "productSkuId", "") : get_default()(authorData, "serviceSkuId", ""),
        newTab: get_default()(authorData, "newTab", false),
        skuType: get_default()(authorData, "type", ""),
        imagePosition: get_default()(authorData, "imagePosition", ""),
        jsonFileUrl: get_default()(authorData, "jsonFilePath", ""),
        swatchUrl: authorData.swatchUrl
    };
    const [productDetailData, setProductDetailData] = (0,react.useState)(product !== null && product !== void 0 ? product : {});
    const [userZipCode, setUserZipCode] = (0,react.useState)("");
    const [isNearest, setIsNearest] = (0,react.useState)(false);
    const [isNearestValueUpdated, setIsNearestValueUpdated] = (0,react.useState)(false);
    const [zipCodeData, setZipCodeData] = (0,react.useState)([]);
    const [info, setInfo] = (0,react.useState)({});
    const [general, setGeneral] = (0,react.useState)();
    const staticTexts = i18n_useProductCardi18n({});
    const persona = (0,helper/* getUserPersona */.shu)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            var ref;
            var ref1;
            const brandName = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "";
            const language = get_default()(config, "internationalization.language", "en");
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            (0,constants_api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: state.jsonFileUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    var _zipcode;
                    setZipCodeData((_zipcode = response.data.zipcode) !== null && _zipcode !== void 0 ? _zipcode : []);
                }
            }).catch((err)=>{
                console.error("Failed to get compare attributes JSON file", err);
            });
            const info = {
                locale: locale,
                language: language,
                currencySign: currencySign,
                currencyCode: currencyCode,
                brandName: brandName,
                lwAppName
            };
            setInfo(info);
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!(product === null || product === void 0 ? void 0 : product.id)) {
            try {
                if (!isEmpty_default()(info)) {
                    (0,helper/* fetchFromSku */.Q8Y)(state.productSkuId, info.lwAppName, info.language, singleSku).then((res)=>{
                        if (res && res.data) {
                            const productData = get_default()(res.data, "response.docs[0]", {});
                            setProductDetailData(productData);
                        }
                    });
                }
            } catch (error) {
                console.error(error);
            }
            getUserLocation();
        }
    }, [
        info
    ]);
    (0,react.useEffect)(()=>{
        if (product === null || product === void 0 ? void 0 : product.id) {
            setProductDetailData(product);
        }
    }, [
        product
    ]);
    const getUserLocation = ()=>{
        (0,helper/* getLocationByCookies */.ngN)().then((getLocation)=>{
            var _zipcode;
            const userZipCode = (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "";
            checkUserZipCode(userZipCode);
        });
    };
    const checkUserZipCode = function(userZipCodeVal, callBack) {
        let needAnalytics = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        const newCodes = [];
        zipCodeData.map((codes)=>{
            Object.keys(codes).forEach((key)=>{
                newCodes.push(codes[key].includes(userZipCodeVal));
            });
        });
        const isNearest = newCodes.find((result)=>result === true) ? true : false;
        setIsNearest(isNearest);
        setIsNearestValueUpdated(needAnalytics);
        callBack && callBack(isNearest);
    };
    const getZipCode = function(zipCodeVal) {
        let needAnalytics = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setUserZipCode(zipCodeVal);
        checkUserZipCode(zipCodeVal, needAnalytics);
    };
    const productCardProps = {};
    productCardProps.presetConfigs = presetConfigs !== null && presetConfigs !== void 0 ? presetConfigs : "";
    var _swatchUrl;
    productCardProps.swatchUrl = (_swatchUrl = state.swatchUrl) !== null && _swatchUrl !== void 0 ? _swatchUrl : "";
    if (productDetailData) {
        // get product images
        if (productDetailData["modifiedproductImageVariantImages.url_ss"]) {
            var ref;
            const imageStrig = (ref = productDetailData["modifiedproductImageVariantImages.url_ss"]) === null || ref === void 0 ? void 0 : ref.split("|");
            productCardProps.images = imageStrig.length ? imageStrig[imageStrig.length - 1] : "";
        } else if (singleSku && productDetailData["productImages.labelWithUrl_ss"]) {
            var ref1;
            var ref2;
            productCardProps.images = (ref2 = (ref1 = productDetailData["productImages.labelWithUrl_ss"].filter((val)=>val.includes(state.productSkuId))[0]) === null || ref1 === void 0 ? void 0 : ref1.split("|")[5]) !== null && ref2 !== void 0 ? ref2 : "";
        } else if (productDetailData["productImages.url_ss"]) {
            var ref3;
            productCardProps.images = (ref3 = productDetailData["productImages.url_ss"][0]) !== null && ref3 !== void 0 ? ref3 : "";
        } else {
            productCardProps.images = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
        }
        // get product colors
        if (productDetailData["Color.SKU.Details_ss"]) {
            var ref4;
            const colors = (ref4 = productDetailData["Color.SKU.Details_ss"]) !== null && ref4 !== void 0 ? ref4 : [];
            productCardProps.colors = colors.filter((item)=>{
                const color = item.split("|");
                return color[4] === "false" || Date.parse(color[4]) > Date.now();
            });
        } else {
            productCardProps.colors = [
                ""
            ];
        }
        var ref5;
        // get product web features
        productCardProps.productFeatures = (ref5 = productDetailData["ProductWebFeatures_ss"]) !== null && ref5 !== void 0 ? ref5 : [];
        productCardProps.currencySign = info.currencySign;
        productCardProps.productCategory = get_default()(productDetailData, "Product_Category", "");
        productCardProps.name = get_default()(productDetailData, "productName_s", "");
        productCardProps.stockBadge = get_default()(productDetailData, "SKUAnnSacksNonStock_b", undefined);
        productCardProps.noBadge_b = get_default()(productDetailData, "noBadge_b", false);
        productCardProps.brandName = get_default()(productDetailData, "ProductBrandName_s", "") || get_default()(productDetailData, "RegionBrandName_s", "");
        productCardProps.description = get_default()(productDetailData, "title_s", "");
        productCardProps.narrativeDescription = get_default()(productDetailData, "ProductNarrativeDescription_s", "");
        productCardProps.price = get_default()(productDetailData, "priceList.".concat(persona, ".price_d"), 0);
        productCardProps.discountedPrice = get_default()(productDetailData, "priceList.".concat(persona, ".finalPrice_d"), 0);
        productCardProps.discountPercent = parseInt(get_default()(productDetailData, "priceList.".concat(persona, ".saleOffer_s"), 0));
        productCardProps.slug = get_default()(productDetailData, "slug_s", "");
        productCardProps.customerBrand = get_default()(productDetailData, "CustomerFacingBrand_s", "");
        let tempColorDetails = get_default()(productDetailData, "Color.SKU.Details_ss", null);
        if (tempColorDetails) {
            if (typeof tempColorDetails !== "string" && tempColorDetails[0]) {
                tempColorDetails = tempColorDetails[0];
            }
            productCardProps.customerFacingSKU = tempColorDetails.split("|")[5] || "";
        }
        productCardProps.badgeVal = get_default()(productDetailData, "priceList.".concat(persona, ".saleOffer_s"), "");
        productCardProps.globalDiscount = productCardProps.price - get_default()(productDetailData, "priceList.".concat(persona, ".finalPrice_d"), productCardProps.price);
        const productUOM = productDetailData["RegionAltUOM_s"];
        const eaLabel = [
            constants.FIELD_BY_BOX,
            constants.MOSAIC_BY_BOX,
            constants.TRIM_BY_BOX
        ].includes(get_default()(productDetailData, "ItemCharacteristic.TYPE.CharacteristicDescriptionUpperCase_s", "")) ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.eaBoxLabel : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.eaLabel;
        const priceTypeMap = {
            ft2: "/".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sfLabel),
            ft: "/".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.lfLabel),
            ea: "/".concat(eaLabel)
        };
        productCardProps.priceType = priceTypeMap[productUOM === null || productUOM === void 0 ? void 0 : productUOM.toLowerCase()] || "";
    }
    const resetNearestValueUpdateFlag = ()=>{
        setIsNearestValueUpdated(false);
    };
    return state.skuType !== "productSku" && !isEmpty_default()(state.productSkuId) && !isEmpty_default()(productCardProps) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCardService, {
        ...productCardProps,
        imagePosition: state.imagePosition,
        newTab: state.newTab,
        staticTexts: staticTexts,
        currencySign: info.currencySign,
        userZipCode: userZipCode,
        isNearest: isNearest,
        skuId: state.productSkuId,
        getZipCode: getZipCode,
        resetNearestValueUpdateFlag: resetNearestValueUpdateFlag,
        isNearestValueUpdated: isNearestValueUpdated,
        cart: cart
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_view/* default */.Z, {
        ...productCardProps,
        product: productCardProps,
        i18n: staticTexts,
        currencySign: info.currencySign,
        presetConfigs: presetConfigs,
        title: productCardProps === null || productCardProps === void 0 ? void 0 : productCardProps.brandName,
        skuId: state.productSkuId,
        general: general,
        analyticsData: analyticsData,
        newTab: newTab
    });
};
/* harmony default export */ var v1_ProductCard = (ProductCard);

// EXTERNAL MODULE: ./src/components/productCard/v3/ProductCard.jsx
var v3_ProductCard = __webpack_require__(79349);
;// CONCATENATED MODULE: ./src/components/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    var ref, ref1, ref2;
    if (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : (ref1 = type.subCategory1) === null || ref1 === void 0 ? void 0 : ref1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : (ref2 = type.subCategory1) === null || ref2 === void 0 ? void 0 : ref2.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref3;
    return (ref3 = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref3 !== void 0 ? ref3 : "";
};
const getAnalyticsEventInfo = ()=>{
    var ref;
    const type = window.adobeDataLayer.length ? window.adobeDataLayer[0]["page"]["category"] : {};
    const eventFor = getEventFor(type);
    const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:close" : "".concat(eventFor, ":close");
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "".concat(eventFor, ":modal:where do i find my product model number:close"),
        eventName: "".concat(eventFor, ":modal:where do i find my product model number:close"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
        internalLinkType,
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
    });
};
const productInfoNextEventInfo = ()=>{
    ;
    '{"eventAction":"my account:register non kohler products:product information:next","eventName":"my account:register non kohler products:product information:next","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"next","internalLinkPosition":"register products","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:register non kohler products:product information","internalLinkURL":"n/a","clickInternalLinks":"true"}';
};


;// CONCATENATED MODULE: ./src/components/FindingModelNumber/v1/FindingModelNumber.jsx











const FindingModelNumber = (param)=>{
    let { authorData ={}  } = param;
    var ref;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { FindingModelModal: { show: isShowModelNumberModal  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [findingModelData, setFindingModelData] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        document.querySelectorAll('a[href="#FindingModelNumber"]').forEach((el)=>{
            el.addEventListener("click", showFindingModelPopupHandler);
        });
        findModelNumber();
        return ()=>{
            document.querySelectorAll('a[href="#FindingModelNumber"]').forEach((el)=>{
                el.removeEventListener("click", showFindingModelPopupHandler);
            });
        };
    }, []);
    const showFindingModelPopupHandler = (e)=>{
        e.preventDefault();
        dispatch((0,genericSlice/* showFindingModelPopup */.RS)());
    };
    const findModelNumber = ()=>{
        if (!isEmpty_default()(authorData.findModelNumber)) {
            (0,constants_api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: authorData.findModelNumber
                }
            }).then((response)=>{
                if (response && response.data) {
                    var _data;
                    setFindingModelData((_data = response.data) !== null && _data !== void 0 ? _data : {});
                } else {
                    console.error("Finding a model number: Error occured while fetching data from Get URL Property");
                }
            }).catch((err)=>console.error(err));
        }
    };
    const compareWidth = (a, b)=>{
        if (Number(a.width) > Number(b.width)) return -1;
        if (Number(a.width) < Number(b.width)) return 1;
        return 0;
    };
    var ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "finding-model-number",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
            StickCloseButton: true,
            closeButtonAnalytics: getAnalyticsEventInfo(),
            needAnalyticsOnContentsLink: true,
            onModalClose: ()=>dispatch((0,genericSlice/* hideFindingModelPopup */._W)()),
            showModal: isShowModelNumberModal,
            children: !isEmpty_default()(findingModelData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            children: !isEmpty_default()(findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.title) ? (0,helper/* sanitizeText */.oOy)(findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.title) : ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-explanation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.assetPath) ? findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.assetPath : findingModelData === null || findingModelData === void 0 ? void 0 : (ref = findingModelData.smartcrop) === null || ref === void 0 ? void 0 : ref.sort(compareWidth),
                            width: "80%",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "finding-model-number__content ".concat((findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.style) === "des-bg-off-white" ? "finding-model-number__content-bg" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "description",
                                children: (0,helper/* sanitizeInnerHtml */.KD0)((ref1 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.description) !== null && ref1 !== void 0 ? ref1 : "")
                            }),
                            (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLinkText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "signUp-text",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": productInfoNextEventInfo(),
                                    type: "black",
                                    label: (ref2 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLinkText) !== null && ref2 !== void 0 ? ref2 : "",
                                    to: (ref3 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLink) !== null && ref3 !== void 0 ? ref3 : "",
                                    target: (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.newTabLink) === "true" ? "_blank" : "_self"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_FindingModelNumber = (FindingModelNumber);

;// CONCATENATED MODULE: ./components/Shared/BrandNav.jsx












const BrandNav = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { menu: { isOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data , eventHandler  } = props;
    const toggleMenu = ()=>{
        isOpen ? dispatch((0,genericSlice/* closeMenu */.Wj)()) : dispatch((0,genericSlice/* openMenu */.qn)());
    };
    const [scrollDir, setScrollDir] = (0,react.useState)("scrolling down");
    const [lastScrollY, setLastScrollY] = (0,react.useState)(0);
    const router = (0,next_router.useRouter)();
    const { material  } = router.query;
    (0,react.useEffect)(()=>{
        const threshold = 0;
        let lastScrollY = window.pageYOffset;
        let ticking = false;
        const updateScrollDir = ()=>{
            const scrollY = window.pageYOffset;
            if (Math.abs(scrollY - lastScrollY) < threshold) {
                ticking = false;
                return;
            }
            if (!document.body.classList.contains("gbh-of-scroll")) setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
            lastScrollY = scrollY > 0 ? scrollY : 1;
            ticking = false;
            setLastScrollY(lastScrollY);
        };
        const onScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }
        };
        const onScrollThrottle = throttle_default()(onScroll, 1000);
        if ((router === null || router === void 0 ? void 0 : router.pathname) !== "/checkout") {
            window.removeEventListener("scroll", onScrollThrottle);
            window.addEventListener("scroll", onScrollThrottle);
        }
        return ()=>window.removeEventListener("scroll", onScrollThrottle);
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        if (scrollDir === "scrolling down") {
            (0,utils/* alterClass */.bU)("ann-sacks-tab-bar", "nav-down", "nav-up");
            (0,utils/* alterClass */.bU)("sticky", "nav-down", "nav-up");
            if (window.innerWidth < 1200) {
                (0,utils/* alterClass */.bU)("ann-sacks-logobar", "nav-down", "nav-up");
            }
        } else if (scrollDir === "scrolling up") {
            (0,utils/* alterClass */.bU)("ann-sacks-tab-bar", "nav-up", "nav-down");
            (0,utils/* alterClass */.bU)("sticky", "nav-up", "nav-down");
            if (window.innerWidth < 1200) {
                (0,utils/* alterClass */.bU)("ann-sacks-logobar", "nav-up", "nav-down");
            }
        } else return;
    }, [
        scrollDir,
        lastScrollY
    ]);
    (0,react.useEffect)(()=>{
        if (lastScrollY < 200) {
            (0,utils/* alterClass */.bU)("ann-sacks-tab-bar", null, "nav-down");
            (0,utils/* alterClass */.bU)("ann-sacks-tab-bar", null, "nav-up");
            (0,utils/* alterClass */.bU)("sticky", null, "nav-up");
            (0,utils/* alterClass */.bU)("sticky", null, "nav-down");
            if (window.innerWidth < 1200) {
                (0,utils/* alterClass */.bU)("ann-sacks-logobar", null, "nav-up");
                (0,utils/* alterClass */.bU)("ann-sacks-logobar", null, "nav-down");
            }
        }
    }, [
        lastScrollY,
        router
    ]);
    (0,react.useEffect)(()=>{
        const annsacksTabBarEles = document.querySelectorAll(".ann-sacks-main-menu.ann-sacks-tab-bar");
        const menuBtns = document.querySelectorAll(".gbh-hamber-menu.icon-Hamburger");
        const isOrderSamplePresent = document.querySelectorAll(".order-button.button");
        const isAppointmentPresent = document.querySelectorAll(".appointment-button.button");
        const gbhNavFindStoreEle = document.querySelector(".gbh-nav__findStore");
        const liElems = [].filter.call(menuBtns, function(el) {
            const style = window.getComputedStyle(el);
            return style.display !== "none";
        });
        if (liElems.length && !isOpen && annsacksTabBarEles.length && isOrderSamplePresent.length && isAppointmentPresent && gbhNavFindStoreEle) {
            annsacksTabBarEles[0].style.display = "none";
            isOrderSamplePresent[0].style.display = "none";
            isAppointmentPresent[0].style.display = "none";
            gbhNavFindStoreEle.style.display = "none";
            document.body.style.overflow = "";
        }
        if (isOpen && annsacksTabBarEles.length && isOrderSamplePresent.length && isAppointmentPresent && gbhNavFindStoreEle) {
            document.body.style.overflow = "hidden";
            isOrderSamplePresent[0].style.display = "block";
            isAppointmentPresent[0].style.display = "block";
            annsacksTabBarEles[0].style.display = "block";
            gbhNavFindStoreEle.style.display = "block";
        }
        const isStickyEle = document.querySelector(".is-sticky-load");
        if (isOpen && isStickyEle) {
            isStickyEle.style.display = "none";
        }
        const socialShare = document.querySelector(".social-share");
        if (isOpen && socialShare) {
            socialShare.style.zIndex = 0;
        } else if (!isOpen && socialShare) {
            socialShare.style.zIndex = 9;
        }
    }, [
        isOpen
    ]);
    const addHeaderNavTabAnalytics = (data)=>{
        const eventInfo = {
            eventAction: "global header:".concat(data["cq:panelTitle"].toLowerCase()),
            eventName: "global header:".concat(data["cq:panelTitle"].toLowerCase()),
            eventType: "tab",
            internalLinkName: data["cq:panelTitle"].toLowerCase(),
            internalLinkPosition: "global header",
            internalLinkType: "global header:navigation",
            internalLinkZoneName: "global header",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const handleCloseMenu = ()=>{
        var ref;
        // close menu on navigation
        isOpen && ((ref = document.getElementById("main-scroll-close")) === null || ref === void 0 ? void 0 : ref.click());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "custom-icon-close-medium",
                onClick: handleCloseMenu
            }),
            data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                if (key.includes("button")) {
                    const { text , appliedCssClassNames , link  } = item;
                    const navRedirectLink = link === null || link === void 0 ? void 0 : link.split("/content/annsacks/us/en").join("").replace(".html", "");
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        label: text,
                        parentClass: appliedCssClassNames,
                        className: "cmp-button ".concat((material === null || material === void 0 ? void 0 : material.toLowerCase().split(" ").join("")) === (text === null || text === void 0 ? void 0 : text.toLowerCase().split(" ").join("")) ? "cmp-button-active" : ""),
                        tag: "link",
                        type: "type",
                        to: navRedirectLink,
                        useDefaultClass: false,
                        onClick: ()=>{
                            handleCloseMenu();
                            addNavTabDatalayer({
                                title: text.toLowerCase(),
                                url: navRedirectLink
                            });
                        }
                    }, "button-".concat(index));
                }
                if (key.includes("tabs")) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default_Tab, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        isOpen: isOpen,
                        toggleMenu: toggleMenu,
                        eventHandler: eventHandler,
                        addHeaderNavTabAnalytics: addHeaderNavTabAnalytics
                    }, "tabs-".concat(index));
                }
                if (key === "utilitywidgets") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityWidgets/* default */.Z, {
                            data: item,
                            columnClassNames: "".concat(data.columnClassNames[key]),
                            eventHandler: eventHandler
                        }) : null
                    }, "utilitywidgets-".concat(index));
                }
                return null;
            })
        ]
    });
};
/* harmony default export */ var Shared_BrandNav = (BrandNav);

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(67421);
;// CONCATENATED MODULE: ./components/Blog/BlogList/v1/utils.js


const getArticles = async (param)=>{
    let { query , fls , category , title  } = param;
    var ref;
    const CONFIG = (0,constants_config/* getConfig */.i)();
    const brandName = (ref = CONFIG.general) === null || ref === void 0 ? void 0 : ref.siteName;
    const { rows =30 , start =0  } = query;
    try {
        const params = {
            fl: fls.join(","),
            q: "*:*",
            rows: rows,
            start: start,
            collections: "annsacks",
            profilename: "profile_annsacks_PLP_Blogs"
        };
        if (category) {
            params.fq = 'category_ss:("'.concat(category.trim(), '")');
        }
        if (title) {
            params.fq = 'title_t:("'.concat(title, '")');
        }
        const { data  } = await constants_api/* apim.get */.TH.get("/search/plp", {
            params
        });
        const payload = {};
        if (data.response) {
            payload.data = data.response.docs;
            payload.total = data.response.numFound;
        }
        return payload;
    } catch (err) {
        console.error(err);
        return err;
    }
};
const fl = [
    "id",
    "url_s",
    "thumbNailImage_s",
    "pageTitle_s",
    "releaseDate_dt"
];

;// CONCATENATED MODULE: ./components/Default/Image/v1/Image.jsx



const Image = (props)=>{
    const { data: { id: uniqueId = "" , alt ="" , src: imgUrl = "" , imageComponentProperties ={
        src: "",
        alt: ""
    } , enableNoImage =false , title , appliedCssClassNames  } = {}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "image ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        id: "image",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "eaem-bounding-div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cmp-image",
                children: [
                    !enableNoImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_DynamicImage, {
                        uniqueId,
                        imgUrl: imgUrl || imageComponentProperties.src,
                        alt: alt || imageComponentProperties.alt,
                        className: "cmp-image__image transition"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                        alt: "image coming soon",
                        className: "no-image"
                    }),
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "cmp-image__title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: title
                        })
                    }) : ""
                ]
            })
        })
    });
};
/* harmony default export */ var v1_Image = (Image);

;// CONCATENATED MODULE: ./components/Blog/BlogList/v1/articleCard/ArticleCard.jsx



const ArticleCard = (param)=>{
    let { data ={} , eyebrowText ="" , staticText ={} , getLatestReadArticleAnalytics =()=>{}  } = param;
    const { pageTitle_s ="" , releaseDate_dt ="" , thumbNailImage_s ="" , url_s =""  } = data;
    const formatDate = (dt)=>{
        if (dt) {
            const date = new Date(dt);
            return "".concat(date.getDate(), " ").concat(date.toLocaleString("default", {
                month: "short"
            }), " ").concat(date.getFullYear());
        }
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "articleCard",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "eyebrow",
                        children: eyebrowText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "title",
                        children: pageTitle_s
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "desc",
                        children: formatDate(releaseDate_dt)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: url_s,
                className: "cta",
                "aria-label": "".concat(staticText.readArticleText, " ").concat(pageTitle_s),
                onClick: getLatestReadArticleAnalytics,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "ctaText",
                    children: staticText.readArticleText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "article-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Image, {
                    data: {
                        src: thumbNailImage_s,
                        alt: pageTitle_s,
                        enableNoImage: !thumbNailImage_s
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var articleCard_ArticleCard = (ArticleCard);

// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
;// CONCATENATED MODULE: ./components/Blog/BlogCarousel/v1/analytics.js

const blogCarouselEventInfo = function() {
    let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", linkUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", linkName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", type = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    category = category ? (0,helper/* sanitizeTextForAnalytics */.T68)(category) : "";
    name = name ? (0,helper/* sanitizeTextForAnalytics */.T68)(name) : "";
    linkName = linkName ? (0,helper/* sanitizeTextForAnalytics */.T68)(linkName) : "";
    type = type ? (0,helper/* sanitizeTextForAnalytics */.T68)(type) : "";
    let blogCategory = category && category === "how tos" ? "how to's" : category;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "blog landing:".concat(blogCategory, ":").concat(name),
        eventName: "blog landing:".concat(blogCategory, ":").concat(name),
        eventType: "navigation",
        internalLinkName: linkName ? linkName : name,
        internalLinkPosition: "blogs landing",
        internalLinkType: "blog landing:".concat(type ? type : "navigation"),
        internalLinkZoneName: "blog landing:".concat(blogCategory),
        internalLinkURL: linkUrl ? linkUrl.indexOf("http") === -1 ? window.location.origin + linkUrl : linkUrl : "n/a"
    };
    return eventInfo;
};
const blogCarouselAnalytics = function() {
    let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", linkUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", linkName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", type = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = blogCarouselEventInfo(category, name, linkUrl, linkName, type);
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};


;// CONCATENATED MODULE: ./i18n/useBlogPosti18n.js

const useBlogPosti18n = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        backToTop: t("kf.plp.label.backToTop"),
        readArticleText: t("kf.plp.label.readArticle"),
        loadMore: t("kf.plp.label.loadMore"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        items: t("kf.plp.label.items"),
        mostPopular: t("kf.plp.label.mostPopular")
    };
    return i18n;
};
/* harmony default export */ var i18n_useBlogPosti18n = (useBlogPosti18n);

;// CONCATENATED MODULE: ./components/Blog/BlogCarousel/v1/BlogCarousel.jsx











const BlogCarousel = (param)=>{
    let { data  } = param;
    const { latestTitle , newTab , sectionTitle , tagSelect , type , ctaLink , ctaText , maxArticle , popularTitle  } = data;
    const [general, setGeneral] = (0,react.useState)();
    const carouselRef = (0,react.useRef)(null);
    const [width] = (0,useWindowResize/* default */.Z)();
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    (0,react.useEffect)(()=>{
        if (type !== "latestPopular") {
            (0,helper/* initOverlayScrollbar */.CGR)(carouselRef);
            (0,helper/* addScrollCss */.WOj)(carouselRef, ".os-scrollbar-visible", "os-host-overflow-x");
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (type !== "latestPopular") {
            (0,helper/* addScrollCss */.WOj)(carouselRef, ".os-scrollbar-visible", "os-host-overflow-x");
        }
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general  } = await (0,constants_config/* getConfig */.i)();
            setGeneral(general);
        };
        configFn();
    }, []);
    const [popularData, setPopularData] = (0,react.useState)();
    const [articleList, setArticlesList] = (0,react.useState)([]);
    const { readArticleText  } = i18n_useBlogPosti18n();
    const staticText = {
        backToTop: t("kf.blog.listing.backToTop"),
        readArticleText
    };
    const requestQuery = {
        query: {
            rows: maxArticle
        },
        fls: [
            "id",
            "url_s",
            "thumbNailImage_s",
            "pageTitle_s",
            "releaseDate_dt"
        ],
        category: tagSelect
    };
    const latestQuery = {
        query: {
            rows: 3
        },
        fls: [
            "id",
            "url_s",
            "thumbNailImage_s",
            "pageTitle_s",
            "releaseDate_dt",
            "category_ss"
        ]
    };
    const popularQuery = {
        query: {
            rows: 5
        },
        fls: [
            "url_s",
            "pageTitle_s"
        ],
        category: "Popular"
    };
    const fetchArticles = async ()=>{
        var ref;
        const res = await getArticles(type === "latestPopular" ? latestQuery : requestQuery);
        if (type === "latestPopular") {
            const res1 = await getArticles(popularQuery);
            setPopularData(res1.data || []);
        }
        const limit = type === "latestPopular" ? maxArticle !== null && maxArticle !== void 0 ? maxArticle : 2 : maxArticle !== null && maxArticle !== void 0 ? maxArticle : 10;
        setArticlesList(((ref = res.data) === null || ref === void 0 ? void 0 : ref.slice(0, Number(limit))) || []);
    };
    (0,react.useEffect)(()=>{
        fetchArticles();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            className: "blog-carousel",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "blog-carousel__header blog-react-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "blog-carousel__title",
                            children: (0,helper/* sanitizeText */.oOy)(type === "latestPopular" ? latestTitle : sectionTitle)
                        }),
                        type !== "latestPopular" && width > 767 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            className: "blog-carousel__view-all",
                            href: (0,helper/* getShortenedUrlwithGeneral */.vu1)(ctaLink, general),
                            target: newTab ? "_blank" : "_self",
                            onClick: ()=>blogCarouselAnalytics(sectionTitle, ctaText, ctaLink),
                            "aria-label": "".concat(type === "latestPopular" ? latestTitle : sectionTitle, " ").concat(ctaText),
                            rel: "noreferrer",
                            children: ctaText
                        }) : null
                    ]
                }),
                type === "latestPopular" && window.innerWidth < 1024 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "most-popular-section top",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            id: "popular-title-mobile",
                            className: "most-popular-title",
                            children: popularTitle ? (0,helper/* sanitizeText */.oOy)(popularTitle) : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            role: "listbox",
                            "aria-labelledby": "popular-title-mobile",
                            className: "blog-listing-inner-content",
                            children: popularData === null || popularData === void 0 ? void 0 : popularData.map((item)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "links-section",
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: item.url_s,
                                        className: "most-popular-link",
                                        onClick: ()=>blogCarouselAnalytics(popularTitle, "blog navigation", item.url_s, item.pageTitle_s),
                                        children: item.pageTitle_s
                                    })
                                }, item.id);
                            })
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "blog-carousel__content ".concat(type === "latestPopular" ? "blog-react-container latestPopular" : ""),
                    ref: carouselRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "blog-carousel__slider",
                            role: "listbox",
                            children: articleList === null || articleList === void 0 ? void 0 : articleList.map((item)=>{
                                var ref;
                                var ref1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "article-card-wrapper ".concat(type === "latestPopular" ? "" : "remove-mr"),
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(articleCard_ArticleCard, {
                                        data: item,
                                        eyebrowText: (ref1 = (ref = item["category_ss"]) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : tagSelect,
                                        staticText: staticText,
                                        getLatestReadArticleAnalytics: ()=>{
                                            var ref;
                                            return blogCarouselAnalytics(type === "latestPopular" ? latestTitle : sectionTitle, staticText.readArticleText, item.url_s, "", "".concat(((ref = item["category_ss"]) === null || ref === void 0 ? void 0 : ref[0]) || tagSelect, ":").concat(item.pageTitle_s));
                                        }
                                    })
                                }, item.id);
                            })
                        }),
                        type === "latestPopular" && window.innerWidth > 1023 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "most-popular-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    id: "popular-title-desktop",
                                    className: "most-popular-title",
                                    children: popularTitle ? (0,helper/* sanitizeText */.oOy)(popularTitle) : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    role: "listbox",
                                    "aria-labelledby": "popular-title-desktop",
                                    children: popularData === null || popularData === void 0 ? void 0 : popularData.map((item)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            role: "listitem",
                                            className: "links-section",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: item.url_s,
                                                onClick: ()=>blogCarouselAnalytics(popularTitle, "blog navigation", item.url_s, item.pageTitle_s),
                                                className: "most-popular-link",
                                                children: item.pageTitle_s
                                            })
                                        }, item.id);
                                    })
                                })
                            ]
                        }) : null
                    ]
                }),
                type !== "latestPopular" && width < 767 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "blog-carousel__view-all-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: (0,helper/* getShortenedUrlwithGeneral */.vu1)(ctaLink, general),
                        target: newTab ? "_blank" : "_self",
                        rel: "noreferrer",
                        onClick: ()=>blogCarouselAnalytics(sectionTitle, ctaText, ctaLink),
                        children: ctaText
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var v1_BlogCarousel = (BlogCarousel);

;// CONCATENATED MODULE: ./components/Blog/BlogList/v1/BlogPageLoader.jsx


const BlogPageLoader = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "blog-list blog-react-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "blog-list-header shimmer shimmer-loading__headerTitle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "blog-list-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "blog-list-content height-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "blog-list-tile-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blog-list-tile-card",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "blog-list-tile shimmer height-300"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-half"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-full"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blog-list-tile-card",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "blog-list-tile shimmer height-300"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-half"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-full"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blog-list-tile-card",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "blog-list-tile shimmer height-300"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-half"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-full"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blog-list-tile-card",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "blog-list-tile shimmer height-300"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-half"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-full"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blog-list-tile-card",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "blog-list-tile shimmer height-300"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-half"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-full"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blog-list-tile-card",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "blog-list-tile shimmer height-300"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-half"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer shimmer-loading__para width-full"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v1_BlogPageLoader = (BlogPageLoader);

// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/ProductsPerPage/index.jsx
var ProductsPerPage = __webpack_require__(93575);
// EXTERNAL MODULE: ./public/icons/back-top-arrow.svg
var back_top_arrow = __webpack_require__(12522);
;// CONCATENATED MODULE: ./components/Blog/BlogList/v1/backToTop/BackToTop.jsx




const BackToTop = (param)=>{
    let { text ="" , customClass ="" , analyticsData =()=>{}  } = param;
    const handleBackToTop = (event)=>{
        if (event.keyCode === 13) {
            var ref;
            (ref = document.getElementsByClassName("cmp-image--link")[1]) === null || ref === void 0 ? void 0 : ref.focus();
        }
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: classnames_default()("back-to-top", "gbh-data-layer", customClass !== null && customClass !== void 0 ? customClass : null),
        onClick: handleBackToTop,
        onKeyDown: handleBackToTop,
        "data-gbh-data-layer": analyticsData,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()("back-to-top-text"),
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                role: "presentation",
                src: back_top_arrow/* default */.Z === null || back_top_arrow/* default */.Z === void 0 ? void 0 : back_top_arrow/* default.src */.Z.src,
                alt: text,
                className: classnames_default()("back-to-top-image")
            })
        ]
    });
};
/* harmony default export */ var backToTop_BackToTop = (BackToTop);

;// CONCATENATED MODULE: ./components/Blog/BlogList/v1/analytics.js

const bloglistingEventInfo = function() {
    let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", linkUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", linkName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", type = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    category = category ? (0,helper/* sanitizeTextForAnalytics */.T68)(category) : "";
    name = name ? (0,helper/* sanitizeTextForAnalytics */.T68)(name) : "";
    linkName = linkName ? (0,helper/* sanitizeTextForAnalytics */.T68)(linkName) : "";
    type = type ? (0,helper/* sanitizeTextForAnalytics */.T68)(type) : "";
    let blogCategory = category && category === "how tos" ? "how to's" : category;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "blog listing:".concat(blogCategory, ":main content area:").concat(name),
        eventName: "blog listing:".concat(blogCategory, ":main content area:").concat(name),
        eventType: "navigation",
        internalLinkName: linkName ? linkName : name,
        internalLinkPosition: "blogs listing",
        internalLinkType: "blog listing:".concat(type ? "".concat(blogCategory, ":").concat(type) : "navigation"),
        internalLinkZoneName: "blog listing:".concat(blogCategory, ":main content area"),
        internalLinkURL: linkUrl ? linkUrl.indexOf("http") === -1 ? window.location.origin + linkUrl : linkUrl : "n/a"
    };
    return JSON.stringify(eventInfo);
};
const blogListingAnalytics = function() {
    let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", linkUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = bloglistingEventInfo(category, name, linkUrl, "", type);
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo: JSON.parse(eventInfo),
        page
    });
};
const blogListingBtnAnalytics = function() {
    let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return bloglistingEventInfo(category, name);
};
const blogListingPaginationAnalytics = function() {
    let limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", textAll = arguments.length > 1 ? arguments[1] : void 0, all = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, pos = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", selectedTab = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    limit = limit + "";
    let pageCount = !all ? limit : textAll;
    return bloglistingEventInfo(selectedTab, "pagination", "", "view ".concat(pageCount));
};


;// CONCATENATED MODULE: ./components/Blog/BlogList/v1/BlogList.jsx













const BlogListing = (param)=>{
    let { data: authorData  } = param;
    const [articlesList, setArticlesList] = (0,react.useState)([]);
    const [totalResult, setTotalResult] = (0,react.useState)(0);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [isInitialLoad, setIsInitialLoad] = (0,react.useState)(true);
    const prevPaginationState = (0,react.useRef)();
    const [paginationState, setPaginationState] = (0,react.useState)({
        rows: 30,
        start: 0
    });
    const { rows , start  } = paginationState;
    const { all , backToTop , loadMore , readArticleText , view , items  } = i18n_useBlogPosti18n();
    const [width] = (0,useWindowResize/* default */.Z)();
    const { tagSelect  } = authorData;
    const staticText = {
        all,
        backToTop,
        loadMore,
        readArticleText,
        view,
        items
    };
    (0,react.useEffect)(()=>{
        setIsInitialLoad(true);
        fetchArticles(false, true);
    }, []);
    (0,react.useEffect)(()=>{
        if (prevPaginationState === null || prevPaginationState === void 0 ? void 0 : prevPaginationState.current) {
            var ref;
            if (paginationState.start > (prevPaginationState === null || prevPaginationState === void 0 ? void 0 : (ref = prevPaginationState.current) === null || ref === void 0 ? void 0 : ref.start)) {
                fetchArticles(true);
            } else {
                fetchArticles();
            }
        }
        prevPaginationState.current = paginationState;
    }, [
        paginationState
    ]);
    const fetchArticles = async function(update) {
        let isSsr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setIsLoading(true);
        const query = {
            query: {
                rows: paginationState.rows,
                start: paginationState.start
            },
            fls: fl,
            category: tagSelect
        };
        const res = await getArticles(query);
        setArticlesList(update ? [
            ...articlesList,
            ...res.data
        ] : res.data);
        setTotalResult(res.total);
        setIsLoading(false);
        setIsInitialLoad(false);
    };
    const handleRows = (rows)=>{
        setPaginationState({
            rows,
            start: 0
        });
        setRowsSession(rows);
        setIsInitialLoad(true);
    };
    const setRowsSession = (rows)=>{
        if (sessionStorage.blogRows) {
            const rowStorage = JSON.parse(sessionStorage.blogRows);
            rowStorage[window.location.pathname] = rows;
            sessionStorage.blogRows = JSON.stringify(rowStorage);
        } else {
            sessionStorage.blogRows = JSON.stringify({
                [window.location.pathname]: rows
            });
        }
    };
    const handleLoadMore = ()=>{
        setRowsSession(start + rows + rows);
        setPaginationState((state)=>({
                ...state,
                start: start + rows
            }));
    };
    if (isInitialLoad) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_BlogPageLoader, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: classnames_default()("blog-listing mira-react-container", {
            "is-blog-loading": isLoading
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "blog-listing-inner-content",
                role: "listbox",
                children: articlesList === null || articlesList === void 0 ? void 0 : articlesList.map((item, i)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "article-card-wrapper",
                        role: "listitem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(articleCard_ArticleCard, {
                            no: i,
                            data: item,
                            eyebrowText: tagSelect,
                            staticText: staticText,
                            getLatestReadArticleAnalytics: ()=>blogListingAnalytics(tagSelect, staticText.readArticleText, item.url_s, item.pageTitle_s)
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "blog-listing-bottom-content",
                children: [
                    totalResult > (articlesList === null || articlesList === void 0 ? void 0 : articlesList.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        customClass: "blog-listing-load-more gbh-data-layer",
                        type: "load-more",
                        label: staticText.loadMore,
                        onClick: handleLoadMore,
                        analyticsData: blogListingBtnAnalytics(tagSelect, staticText.loadMore),
                        role: "button",
                        flexible: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "blog-listing-pagination-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "blog-listing-pagination",
                                children: totalResult > 30 && totalResult > (articlesList === null || articlesList === void 0 ? void 0 : articlesList.length) && width > 1023 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsPerPage/* default */.Z, {
                                        page: "blog",
                                        curRows: rows + start,
                                        data: constants.PRODUCTS_PER_PAGE,
                                        totalResults: totalResult,
                                        texts: staticText,
                                        onChange: handleRows,
                                        selectedTab: tagSelect
                                    })
                                })
                            }),
                            (articlesList === null || articlesList === void 0 ? void 0 : articlesList.length) > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(backToTop_BackToTop, {
                                customClass: "gbh-data-layer",
                                analyticsData: blogListingBtnAnalytics(tagSelect, staticText.backToTop),
                                text: staticText.backToTop
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogList = (BlogListing);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
;// CONCATENATED MODULE: ./i18n/useCarouselSlicki18n.js

const useCarouselSlicki18n = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        emptyCarouselListMsg: t("kf.carousel.label.emptyCarouselListMsg")
    };
    return i18n;
};
/* harmony default export */ var i18n_useCarouselSlicki18n = (useCarouselSlicki18n);

;// CONCATENATED MODULE: ./components/CarouselSlick/v1/Arrow.jsx

const Arrow = (props)=>{
    const { className ="" , style ="" , onClick =()=>{} , label ="" , topPosition =0 , addAnalyticsForArrows =()=>{}  } = props;
    const clickHandler = (e, label)=>{
        onClick && onClick(e);
        addAnalyticsForArrows(label);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: className,
        type: "button",
        "aria-label": label,
        style: {
            ...style,
            top: topPosition ? topPosition : ""
        },
        onClick: (e)=>clickHandler(e, label)
    });
};
/* harmony default export */ var v1_Arrow = (Arrow);

;// CONCATENATED MODULE: ./components/CarouselSlick/v1/SlickSettings.js
// import Arrow from "@/components/Default/CarouselSlick/v1/Arrow"


const doubleFeatureContentCardSettings = {
    dots: false,
    infinite: true,
    fade: true,
    autoplay: false,
    cssEase: "ease-in-out",
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false
};
const singleSliderSettings = function(cb, topPosition, autoplay, autoplaySpeed) {
    let options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    const isOptionsOnlyCall = typeof cb === "object" && cb !== null && topPosition === undefined;
    const resolvedCb = isOptionsOnlyCall ? undefined : cb;
    const resolvedTopPosition = isOptionsOnlyCall ? undefined : topPosition;
    const resolvedAutoplay = isOptionsOnlyCall ? undefined : autoplay;
    const resolvedAutoplaySpeed = isOptionsOnlyCall ? undefined : autoplaySpeed;
    const { addAnalyticsForArrows , afterChangeCb =()=>{} , showArrowIndication =true  } = isOptionsOnlyCall ? cb : options;
    return {
        autoplay: resolvedAutoplay,
        autoplaySpeed: resolvedAutoplaySpeed,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: showArrowIndication,
        infinite: true,
        centerMode: false,
        beforeChange: (_, current)=>typeof resolvedCb === "function" ? resolvedCb(current + 1, current) : undefined,
        afterChange: (a, b)=>typeof afterChangeCb === "function" ? afterChangeCb(a, b) : undefined,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Arrow, {
            label: "Next",
            topPosition: resolvedTopPosition,
            addAnalyticsForArrows: addAnalyticsForArrows
        }),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Arrow, {
            label: "Previous",
            topPosition: resolvedTopPosition,
            addAnalyticsForArrows: addAnalyticsForArrows
        })
    };
};

;// CONCATENATED MODULE: ./src/components/Default/CarouselSlick/v1/AnalyticCarouselSlick.js
const getDataLayerValues = function(isSSR) {
    let pageName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", link = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", linkName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    if (!isSSR && window) {
        var ref;
        const dataLayer = (ref = window === null || window === void 0 ? void 0 : window.adobeDataLayer) !== null && ref !== void 0 ? ref : {};
        var _page;
        const page = (_page = dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.getState().page) !== null && _page !== void 0 ? _page : {};
        if (Object.keys(page).length) {
            const eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(pageName, ":").concat(title.toLowerCase(), ":").concat(linkName.toLowerCase()),
                eventMsg: "n/a",
                eventName: "".concat(pageName, ":").concat(title.toLowerCase(), ":").concat(linkName.toLowerCase()),
                eventStatus: "n/a",
                eventType: "teaser",
                internalLinkName: "".concat(linkName.toLowerCase()),
                internalLinkPosition: "".concat(title.toLowerCase()),
                internalLinkType: "".concat(pageName, ":").concat(linkName.toLowerCase()),
                internalLinkURL: "".concat(link),
                internalLinkZoneName: "".concat(pageName, ":").concat(title.toLowerCase())
            };
            return JSON.stringify(eventInfo);
        }
    }
    return "";
};

;// CONCATENATED MODULE: ./components/Default/Image/v1/FaqBanner.jsx







const FaqBanner = (props)=>{
    const { data: { id: uniqueId = "" , alt ="" , src: imgUrl = "" , imageComponentProperties ={
        src: "",
        alt: ""
    } , title , description , appliedCssClassNames , imageResource ={
        imageserverurl: "",
        imageServerUrl: "",
        assetID: ""
    } , actions  } = {}  } = props;
    const { imageServerUrl ="" , imageserverurl ="" , assetID =""  } = imageResource || {};
    const imageBaseUrl = imageServerUrl || imageserverurl;
    const hasImage = Boolean(imageBaseUrl && assetID);
    const imageUrl = (imageBaseUrl === null || imageBaseUrl === void 0 ? void 0 : imageBaseUrl.endsWith("/")) ? "".concat(imageBaseUrl).concat(assetID) : "".concat(imageBaseUrl, "/").concat(assetID);
    const [general, setGeneral] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general  } = await (0,constants_config/* getConfig */.i)();
            setGeneral(general);
        };
        if (hasImage) {
            configFn();
        }
    }, [
        hasImage
    ]);
    if (!hasImage) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "image ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        id: "image",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "eaem-bounding-div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "faq-banner-image",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "faq-image_resource",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_DynamicImage, {
                            uniqueId,
                            imgUrl: imageUrl,
                            alt: alt || imageComponentProperties.alt,
                            className: "faq-image__image transition"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "faq-banner-image_details",
                        children: [
                            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "faq-banner-image__title",
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(title)
                                }
                            }) : "",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "faq-banner-image__description_pannel",
                                children: [
                                    description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "faq-banner-image__description_text",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(description)
                                        }
                                    }) : "",
                                    actions && actions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "faq-banner-image__description_buttons",
                                        children: actions.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (0,helper/* getShortenedUrlwithGeneral */.vu1)(item.url, general),
                                                    underline: true,
                                                    className: "faq-banner-image__description_button",
                                                    target: item.newTab ? "_blank" : "_self",
                                                    rel: "noreferrer",
                                                    children: item.title
                                                })
                                            }, item.id || index))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_FaqBanner = (FaqBanner);

;// CONCATENATED MODULE: ./components/CarouselSlick/v1/CarouselSlick.jsx






















const CarouselSlick = (props)=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { data , data: { carouselComponentProperties: { id ="" , autoplay =false , delay =constants["default"].SLICK.DEFAULT_DELAY , appliedCssClassNames ="" , ":itemsOrder": itemsOrder = [] , ":items": items = [] , accessibilityLabel =""  } = {} , pageName ="" , datalayerTitleText ="" , componentLinkType ="" , link: linkUrl = "" , componentPosition ="" , linkAll =false , isNewTab =false , bodytitle ="" , texttitle ="" , description ="" , actionsEnabled =false , text ="" , showSlideIndicators =false , showArrowIndication , ctaLable =""  } = {} , fullData ={}  } = props;
    const { emptyCarouselListMsg  } = i18n_useCarouselSlicki18n();
    const { winWidth  } = hooks_useWindowDimensions();
    const getShowArrowIndication = (defaultValue)=>showArrowIndication === undefined ? defaultValue : showArrowIndication === true;
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const sliderDelay = 1500;
    const [slickSettings, setSlickSettings] = (0,react.useState)({});
    const [productCardWidth, setProductCardWidth] = (0,react.useState)();
    const [cardIndex, setCardIndex] = (0,react.useState)(0);
    const [sliderKey, setSliderKey] = (0,react.useState)("");
    const [cardCount, setCardCount] = (0,react.useState)(0);
    const [isDoubleFeatureContentCard, setIsDoubleFeatureContentCard] = (0,react.useState)(false);
    const [isSingleSlider, setIsSingleSlider] = (0,react.useState)(false);
    const [isSingleItemsSlider, setIsSingleItemsSlider] = (0,react.useState)(false);
    const [isSingleSlideCarousel, setIsSingleSlideCarousel] = (0,react.useState)(false);
    const [isFeatureContentSlider, setIsFeatureContentSlider] = (0,react.useState)(false);
    const [isInspiredThemeCarouselSlider, setIsInspiredThemeCarouselSlider] = (0,react.useState)(false);
    const [isContentThreeUp, setIsContentThreeUp] = (0,react.useState)(false);
    const [isContentFourUp, setIsContentFourUp] = (0,react.useState)(false);
    const [isContentFiveUp, setIsContentFiveUp] = (0,react.useState)(false);
    const [isProduct, setIsProduct] = (0,react.useState)(false);
    const [isProductcard, setIsProductCard] = (0,react.useState)(false);
    const [isProductSlider, setIsProductSlider] = (0,react.useState)(false);
    const [isLargeCollection, setIsLargeCollection] = (0,react.useState)(false);
    const [isStickySlider, setIsStickySlider] = (0,react.useState)(false);
    const [isFeatureContent, setIsFeatureContent] = (0,react.useState)(false);
    const [isFullbleedHover, setIsFullbleedHover] = (0,react.useState)(false);
    const [activeSlide, setActiveSlide] = (0,react.useState)(1);
    const [link, setLink] = (0,react.useState)(linkUrl);
    const carouselHeaderInfoRef = (0,react.useRef)(null);
    const sliderRef = (0,react.useRef)(null);
    const [topContentHeight, setTopContentHeight] = (0,react.useState)(0);
    const [sliderImageHeight, setSliderImageHeight] = (0,react.useState)(0);
    const [countHeight, setCountHeight] = (0,react.useState)(0);
    const [arrowHeight, setArrowHeight] = (0,react.useState)(0);
    const [sliderRerenderKey, setSliderRerenderKey] = (0,react.useState)("");
    const [finalProducts, setFinalProducts] = (0,react.useState)([]);
    const [finalSkuOrder, setFinalSkuOrder] = (0,react.useState)([]);
    let dynamicMediaTimer;
    const appendDotsHelper = (dots)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "slick-dots",
            children: react.Children.map(dots, (dot, idx)=>{
                const isActive = typeof dot.props.className === "string" && dot.props.className.includes("slick-active");
                const child = dot.props.children;
                const inner = /*#__PURE__*/ react.isValidElement(child) ? /*#__PURE__*/ react.cloneElement(child, {
                    role: child.type === "button" ? undefined : "button",
                    type: child.type === "button" ? "button" : undefined,
                    "aria-current": isActive ? "true" : "false",
                    "aria-label": "Go to slide ".concat(idx + 1)
                }) : child;
                return /*#__PURE__*/ react.cloneElement(dot, {
                    children: inner
                });
            })
        });
    const getImageHeight = (list)=>{
        if (dynamicMediaTimer) {
            clearTimeout(dynamicMediaTimer);
            dynamicMediaTimer = undefined;
        }
        // using query selector as s7responsiveImage is invoking functions on real dom elements ans was unable to get updated data using useRef
        const teaserImages = list.querySelectorAll(".slick-active .teaser .cmp-teaser__image .cmp-image");
        var ref;
        const teaserImageComponent = (ref = teaserImages[0]) !== null && ref !== void 0 ? ref : null;
        let teaserImage = null;
        if (teaserImageComponent) {
            teaserImage = teaserImageComponent.querySelector("img");
        }
        let imageUrl = null;
        if (teaserImage) {
            imageUrl = teaserImage === null || teaserImage === void 0 ? void 0 : teaserImage.currentSrc;
        }
        if (!window.s7responsiveImage || !imageUrl || imageUrl && imageUrl.startsWith("data:")) {
            dynamicMediaTimer = setTimeout(()=>getImageHeight(list), 200);
            return;
        }
        const imageHeight = teaserImageComponent === null || teaserImageComponent === void 0 ? void 0 : teaserImageComponent.offsetHeight;
        if (imageHeight) setSliderImageHeight(imageHeight);
    };
    (0,react.useEffect)(()=>{
        if (isProduct) {
            let skuids = Object.values(items).map((product)=>product.productSkuId);
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                const language = get_default()(config, "internationalization.language", "en");
                const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
                let data = await (0,helper/* fetchFromSkuIds */.BTY)(skuids, lwAppName, language);
                if (data) {
                    const productData = get_default()(data, "response.docs", {});
                    setFinalProducts(productData);
                    let availableSkus = productData.map((product)=>product.sku_s);
                    let availableSkus1 = skuids.filter((sku)=>availableSkus.includes(sku));
                    let filteredItemOrder = itemsOrder.filter((key)=>availableSkus1.includes(items[key].productSkuId));
                    setFinalSkuOrder(filteredItemOrder);
                    if (sliderRef) {
                        var ref;
                        (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(0);
                    }
                }
            });
        }
    }, [
        isProduct,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        const { current: { offsetHeight =0  } = {}  } = carouselHeaderInfoRef;
        if (offsetHeight > 0) {
            setTopContentHeight(offsetHeight);
        }
    }, [
        carouselHeaderInfoRef
    ]);
    (0,react.useEffect)(()=>{
        const { current: { innerSlider: { list  }  } = {}  } = sliderRef;
        if (list && sliderRerenderKey) {
            getImageHeight(list);
        }
        if (isProduct && sliderRef) {
            var ref;
            (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(0);
        }
    }, [
        sliderRef,
        sliderRerenderKey
    ]);
    (0,react.useEffect)(()=>{
        const countHeight = parseInt(topContentHeight) + parseInt(sliderImageHeight) + constants["default"].SLICK.COUNT_OFFSET;
        setCountHeight(countHeight);
        if (winWidth <= 1023) {
            const arrowHeight = parseInt(sliderImageHeight) + constants["default"].SLICK.ARROW_OFFSET;
            setArrowHeight(arrowHeight);
        }
    }, [
        topContentHeight,
        sliderImageHeight
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData) && isDoubleFeatureContentCard) {
            const cardCount = Object.keys(fullData).length - 1;
            setCardCount(cardCount);
            Object.keys(fullData).forEach((key, index)=>{
                if (isEqual_default()(fullData[key], data)) {
                    setCardIndex(index + 1);
                }
            });
        }
    }, [
        fullData,
        isDoubleFeatureContentCard
    ]);
    (0,react.useEffect)(()=>{
        let timer;
        if (isDoubleFeatureContentCard) {
            if (cardIndex > 0 && cardCount > 0) {
                const delay = 1500 * (cardIndex - 1);
                timer = setTimeout(()=>{
                    setSlickSettings(()=>({
                            ...doubleFeatureContentCardSettings,
                            autoplay: true,
                            speed: 2 * sliderDelay,
                            autoplaySpeed: cardCount * sliderDelay
                        }));
                    setSliderKey(cardIndex);
                }, delay);
            }
        }
        return ()=>{
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [
        cardIndex,
        cardCount,
        isDoubleFeatureContentCard
    ]);
    (0,react.useEffect)(()=>{
        if (isSingleSlider) {
            const shouldShowArrows = getShowArrowIndication(false);
            const settings = singleSliderSettings(setActiveSlide, arrowHeight, autoplay, delay, {
                showArrowIndication: shouldShowArrows
            });
            const slickSettings = ()=>({
                    ...settings,
                    ...isSingleSlider ? {
                        infinite: false,
                        arrows: shouldShowArrows,
                        centerMode: false,
                        dots: true,
                        appendDots: appendDotsHelper,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false
                    } : {},
                    centerMode: winWidth >= 640,
                    dots: true,
                    appendDots: appendDotsHelper
                });
            setSlickSettings(slickSettings());
        }
        if (isSingleSlideCarousel) {
            const shouldShowArrows1 = getShowArrowIndication(true);
            const settings1 = singleSliderSettings(setActiveSlide, arrowHeight, autoplay, delay, {
                showArrowIndication: shouldShowArrows1
            });
            const slickSettings1 = ()=>({
                    ...settings1,
                    ...isSingleSlideCarousel ? {
                        infinite: false,
                        arrows: shouldShowArrows1,
                        centerMode: false,
                        dots: true,
                        appendDots: appendDotsHelper,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        centerPadding: 0
                    } : {},
                    centerMode: winWidth >= 640,
                    dots: true,
                    appendDots: appendDotsHelper
                });
            setSlickSettings(slickSettings1());
        }
        if (isSingleItemsSlider) {
            const shouldShowArrows2 = getShowArrowIndication(true);
            const settings2 = singleSliderSettings(setActiveSlide, arrowHeight, autoplay, delay, {
                showArrowIndication: shouldShowArrows2
            });
            const slickSettings2 = ()=>({
                    ...settings2,
                    ...isSingleItemsSlider ? {
                        infinite: false,
                        centerPadding: winWidth > 1600 ? winWidth / 16 :  true ? 18 : 0,
                        arrows: shouldShowArrows2,
                        centerMode: false,
                        dots: true,
                        appendDots: appendDotsHelper,
                        slidesToShow: winWidth > 1140 ? 1.2 : winWidth > 640 ? 2 : 1,
                        slidesToScroll: 1,
                        autoplay: false
                    } : {},
                    centerMode: winWidth >= 640,
                    dots: true,
                    appendDots: appendDotsHelper
                });
            setSlickSettings(slickSettings2());
        }
        if (isFeatureContentSlider) {
            const shouldShowArrows3 = getShowArrowIndication(true);
            const settings3 = singleSliderSettings(setActiveSlide, arrowHeight, autoplay, delay, {
                showArrowIndication: shouldShowArrows3
            });
            const slickSettings3 = ()=>({
                    ...settings3,
                    ...isFeatureContentSlider ? {
                        infinite: false,
                        centerPadding: 0,
                        arrows: shouldShowArrows3,
                        centerMode: true,
                        dots: true,
                        appendDots: appendDotsHelper,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        adaptiveHeight: false
                    } : {},
                    centerMode: winWidth >= 640,
                    dots: true,
                    appendDots: appendDotsHelper
                });
            setSlickSettings(slickSettings3());
        }
        if (isInspiredThemeCarouselSlider) {
            const shouldShowArrows4 = getShowArrowIndication(false);
            const settings4 = singleSliderSettings({
                showArrowIndication: shouldShowArrows4
            });
            const slickSettings4 = ()=>({
                    ...settings4,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    dots: true,
                    appendDots: appendDotsHelper,
                    arrows: shouldShowArrows4,
                    slidesToShow: winWidth > 1140 ? 3 : winWidth > 640 ? 2 : 1,
                    slidesToScroll: 1,
                    centerMode: false
                });
            setSlickSettings(slickSettings4());
        }
        if (isContentThreeUp) {
            const shouldShowArrows5 = getShowArrowIndication(false);
            const settings5 = singleSliderSettings({
                showArrowIndication: shouldShowArrows5
            });
            const slickSettings5 = ()=>({
                    ...settings5,
                    infinite: false,
                    slidesToShow: winWidth >= 1024 ? 3 : winWidth >= 561 ? 2 : 1,
                    slidesToScroll: 1,
                    arrows: shouldShowArrows5,
                    dots: true,
                    centerMode: false,
                    appendDots: appendDotsHelper
                });
            setSlickSettings(slickSettings5());
        }
        if (isContentFourUp) {
            const shouldShowArrows6 = getShowArrowIndication(false);
            const settings6 = singleSliderSettings({
                showArrowIndication: shouldShowArrows6
            });
            const slickSettings6 = ()=>({
                    ...settings6,
                    infinite: false,
                    slidesToShow: winWidth >= 1024 ? 4 : winWidth >= 561 ? 2 : 1,
                    slidesToScroll: 1,
                    arrows: shouldShowArrows6,
                    dots: true,
                    appendDots: appendDotsHelper,
                    centerMode: false,
                    centerPadding: 0
                });
            setSlickSettings(slickSettings6());
        }
        if (isContentFiveUp) {
            const shouldShowArrows7 = getShowArrowIndication(false);
            const settings7 = singleSliderSettings({
                showArrowIndication: shouldShowArrows7
            });
            const slickSettings7 = ()=>({
                    ...settings7,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    infinite: false,
                    slidesToScroll: 1,
                    arrows: shouldShowArrows7,
                    dots: true,
                    appendDots: appendDotsHelper,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    infinite: false,
                    slidesToShow: winWidth >= 1024 ? 4 : winWidth >= 561 ? 2 : 1,
                    slidesToScroll: 1,
                    arrow: false,
                    centerMode: false
                });
            setSlickSettings(slickSettings7());
        }
        if (isProduct) {
            const shouldShowArrows8 = getShowArrowIndication(false);
            const settings8 = singleSliderSettings({
                showArrowIndication: shouldShowArrows8
            });
            const slickSettings8 = ()=>({
                    ...settings8,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    infinite: false,
                    slidesToShow: winWidth >= 1024 ? 3 : winWidth >= 561 ? 4 : winWidth >= 200 ? 2 : 1,
                    slidesToScroll: 1,
                    arrows: shouldShowArrows8,
                    dots: true,
                    appendDots: appendDotsHelper,
                    centerMode: false,
                    variableWidth: winWidth >= 1024
                });
            setSlickSettings(slickSettings8());
        }
        if (isProductcard) {
            const shouldShowArrows9 = getShowArrowIndication(false);
            const settings9 = singleSliderSettings({
                showArrowIndication: shouldShowArrows9
            });
            const slickSettings9 = ()=>({
                    ...settings9,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    infinite: false,
                    slidesToShow: winWidth >= 1024 ? 3 : winWidth >= 561 ? 2 : 1,
                    slidesToScroll: 1,
                    arrows: shouldShowArrows9,
                    dots: true,
                    appendDots: appendDotsHelper,
                    centerMode: false
                });
            setSlickSettings(slickSettings9());
        }
        if (isProductSlider) {
            const shouldShowArrows10 = getShowArrowIndication(false);
            const settings10 = singleSliderSettings({
                showArrowIndication: shouldShowArrows10
            });
            const slickSettings10 = ()=>({
                    ...settings10,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    infinite: false,
                    slidesToShow: winWidth >= 1024 ? 3 : winWidth >= 561 ? 2 : 1,
                    slidesToScroll: 1,
                    arrows: shouldShowArrows10,
                    dots: true,
                    appendDots: appendDotsHelper,
                    centerMode: false
                });
            setSlickSettings(slickSettings10());
        }
        if (isLargeCollection) {
            const shouldShowArrows11 = getShowArrowIndication(false);
            const settings11 = singleSliderSettings(setActiveSlide, arrowHeight, autoplay, delay, {
                showArrowIndication: shouldShowArrows11
            });
            const slickSettings11 = ()=>({
                    ...settings11,
                    ...isLargeCollection ? {
                        infinite: false,
                        arrows: shouldShowArrows11,
                        centerMode: false,
                        dots: true,
                        appendDots: appendDotsHelper,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        centerPadding: winWidth > 1025 ? winWidth / 12 :  true ? winWidth / 12 : 0
                    } : {},
                    centerMode: winWidth >= 640,
                    dots: true,
                    appendDots: appendDotsHelper
                });
            setSlickSettings(slickSettings11());
        }
        if (isStickySlider) {
            const shouldShowArrows12 = getShowArrowIndication(true);
            const settings12 = singleSliderSettings(setActiveSlide, arrowHeight, autoplay, delay, {
                showArrowIndication: shouldShowArrows12
            });
            const slickSettings12 = ()=>({
                    ...settings12,
                    ...isStickySlider ? {
                        infinite: false,
                        centerPadding: 0,
                        arrows: shouldShowArrows12,
                        centerMode: true,
                        dots: true,
                        appendDots: appendDotsHelper,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        adaptiveHeight: false,
                        centerPadding: 0
                    } : {},
                    centerMode: winWidth >= 640,
                    dots: true,
                    appendDots: appendDotsHelper
                });
            setSlickSettings(slickSettings12());
        }
        if (isFeatureContent) {
            const shouldShowArrows13 = getShowArrowIndication(false);
            const settings13 = singleSliderSettings(setActiveSlide, arrowHeight, autoplay, delay, {
                showArrowIndication: shouldShowArrows13
            });
            const slickSettings13 = ()=>({
                    ...settings13,
                    ...isFeatureContent ? {
                        infinite: false,
                        arrows: shouldShowArrows13,
                        centerMode: false,
                        dots: true,
                        appendDots: appendDotsHelper,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        centerPadding: winWidth > 1025 ? winWidth / 7 :  true ? winWidth / 12 : 0
                    } : {},
                    centerMode: winWidth >= 640,
                    dots: true,
                    appendDots: appendDotsHelper
                });
            setSlickSettings(slickSettings13());
        }
        if (isFullbleedHover) {
            const shouldShowArrows14 = getShowArrowIndication(false);
            const settings14 = singleSliderSettings(setActiveSlide, arrowHeight, autoplay, delay, {
                showArrowIndication: shouldShowArrows14
            });
            const slickSettings14 = ()=>({
                    ...settings14,
                    ...isFullbleedHover ? {
                        infinite: false,
                        arrows: shouldShowArrows14,
                        centerMode: false,
                        dots: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        centerPadding: winWidth > 1025 ? winWidth / 8 :  true ? winWidth / 16 : 0
                    } : {},
                    centerMode: winWidth >= 640,
                    dots: true,
                    appendDots: appendDotsHelper
                });
            setSlickSettings(slickSettings14());
        }
    }, [
        isSingleSlider,
        isSingleSlideCarousel,
        isSingleItemsSlider,
        isFeatureContentSlider,
        isInspiredThemeCarouselSlider,
        isContentFourUp,
        arrowHeight,
        winWidth,
        isContentThreeUp,
        isContentFourUp,
        isContentFiveUp,
        isProduct,
        isProductSlider,
        isProductcard,
        isLargeCollection,
        isFeatureContent,
        isFullbleedHover,
        autoplay,
        delay,
        showArrowIndication
    ]);
    (0,react.useEffect)(()=>{
        if (isProduct) {
            winWidth >= 1024 ? setProductCardWidth("".concat(Math.floor(winWidth / 100 * 30).toString(), "px")) : setProductCardWidth("100%");
        }
    }, [
        winWidth
    ]);
    (0,react.useEffect)(()=>{
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("two-column-layout")) {
            setIsDoubleFeatureContentCard(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("feature-collection-carousel")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("room-inspiration-carousel"))) {
            setIsSingleSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("large-collection-photo-carousel")) {
            setIsLargeCollection(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-navigation-with-arrows")) {
            setIsSingleSlideCarousel(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-text-left-overlap")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("full-bleed-image-hover"))) {
            setIsSingleItemsSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("featured-content-carousel")) {
            setIsFeatureContentSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("sticky-content-center")) {
            setIsStickySlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-featured-content")) {
            setIsFeatureContent(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("full-bleed-second-image")) {
            setIsFullbleedHover(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("inspired-theme-carousel")) {
            setIsInspiredThemeCarouselSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("content-three-up")) {
            setIsContentThreeUp(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("content-four-up")) {
            setIsContentFourUp(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("content-five-up")) {
            setIsContentFiveUp(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("inspired-theme-carousel")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("content-three-up"))) {
            setIsInspiredThemeCarouselSlider(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-header-info")) && (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-swipe-scroll")) && !(appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("manual-product-slider-carousel"))) {
            setIsProduct(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-swipe-scroll")) && (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-header-content"))) {
            setIsProductCard(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("content-four-up")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("inspiration-module-carousel"))) {
            setIsContentFourUp(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-header-info")) && (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-swipe-scroll")) && (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("manual-product-slider-carousel"))) {
            setIsProductSlider(true);
        }
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (linkUrl) {
            (0,helper/* getShortenedUrl */.Ppy)(linkUrl).then((res)=>{
                setLink(res);
            });
        }
    }, [
        linkUrl
    ]);
    (0,react.useEffect)(()=>{
        let key = "slider-default";
        if (sliderKey) {
            key = "slider-".concat(sliderKey);
        }
        if (isSingleItemsSlider || isSingleSlider || isSingleSlideCarousel || isFeatureContentSlider || isInspiredThemeCarouselSlider || isProductSlider || isLargeCollection || isStickySlider || isFeatureContent || isFullbleedHover) {
            key = "slider-".concat(id ? id : appliedCssClassNames);
        }
        setSliderRerenderKey(key);
    }, [
        sliderKey,
        isSingleItemsSlider,
        isSingleSlider,
        isSingleSlideCarousel,
        isFeatureContentSlider,
        isInspiredThemeCarouselSlider,
        isProductSlider,
        isLargeCollection,
        isStickySlider,
        isFeatureContent,
        isFullbleedHover
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-carousel cmp-carousel-slick",
            role: "group",
            "aria-label": accessibilityLabel || undefined,
            "aria-roledescription": "carousel",
            "data-gbh-data-layer": '{"eventName":"'.concat(pageName, ':carousel:interaction","eventAction":"').concat(pageName, ':carousel:interaction","internalLinkName":"carousel:').concat(datalayerTitleText || "rm", '","internalLinkType":"').concat(pageName, ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || datalayerTitleText || "rm", '","internalLinkZoneName":"').concat(pageName, ':carousel","clickInternalLinks":"true","eventType":"carousel","internalLinkURL":"').concat(link, '","internalLinkPosition":"').concat(pageName, ":").concat(componentPosition || "carousel", '"}'),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                condition: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                wrapper: (children)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                        href: link,
                        "data-gbh-data-layer": '{"eventName":"'.concat(pageName, ':carousel:interaction","eventAction":"').concat(pageName, ':carousel:interaction","internalLinkName":"carousel:').concat(datalayerTitleText || "rm", '","internalLinkType":"').concat(pageName, ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || datalayerTitleText || "rm", '","internalLinkZoneName":"').concat(pageName, ':carousel","clickInternalLinks":"true","eventType":"carousel","internalLinkURL":"').concat(link, '","internalLinkPosition":"').concat(pageName, ":").concat(componentPosition || "carousel", '"}'),
                        "data-gbh-clickable": "true",
                        target: "".concat((0,helper/* convertStringToBoolean */.mUs)(isNewTab) ? "_blank" : "_self"),
                        children: children
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "carousel-header-info",
                            ref: carouselHeaderInfoRef,
                            children: [
                                bodytitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__pretitle",
                                    dangerouslySetInnerHTML: {
                                        __html: bodytitle
                                    }
                                }),
                                texttitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__title",
                                    dangerouslySetInnerHTML: {
                                        __html: texttitle
                                    }
                                }),
                                description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__description",
                                    dangerouslySetInnerHTML: {
                                        __html: description
                                    }
                                }),
                                ctaLable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__action-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        dangerouslySetInnerHTML: {
                                            __html: ctaLable
                                        },
                                        href: link,
                                        className: "cmp-carousel__action-link",
                                        target: "".concat((0,helper/* convertStringToBoolean */.mUs)(isNewTab) ? "_blank" : "_self")
                                    })
                                }),
                                (0,helper/* convertStringToBoolean */.mUs)(actionsEnabled) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cmp-carousel__action-container",
                                    children: [
                                        !(0,helper/* convertStringToBoolean */.mUs)(linkAll) && link && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: link,
                                            className: "cmp-carousel__action-link",
                                            target: "".concat((0,helper/* convertStringToBoolean */.mUs)(isNewTab) ? "_blank" : "_self"),
                                            "data-gbh-data-layer": getDataLayerValues(isSsr, pageName, link, (0,helper/* sanitizeTextArticle */.pkm)(texttitle), (0,helper/* sanitizeTextArticle */.pkm)(text)),
                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(text)
                                        }),
                                        ((0,helper/* convertStringToBoolean */.mUs)(linkAll) || !link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cmp-carousel__action-link",
                                            dangerouslySetInnerHTML: {
                                                __html: browser_default().sanitize(text)
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        isProduct || isProductcard && !isProductSlider ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                finalSkuOrder.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__description",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: emptyCarouselListMsg
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                    ...slickSettings,
                                    className: "cmp-carousel-slick__content",
                                    ref: sliderRef,
                                    children: finalSkuOrder === null || finalSkuOrder === void 0 ? void 0 : finalSkuOrder.map((key, index, arr)=>{
                                        const item = items[key];
                                        const product = finalProducts.filter((product)=>product.sku_s === item.productSkuId)[0];
                                        var ref;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    width: "".concat(productCardWidth)
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCard, {
                                                    data: item,
                                                    product: product,
                                                    showEmptyPlaceholder: showSlideIndicators,
                                                    maxHeight: sliderImageHeight,
                                                    singleSku: true
                                                })
                                            })
                                        }, (ref = item === null || item === void 0 ? void 0 : item.id) !== null && ref !== void 0 ? ref : "cpm-carousel-".concat(index, "-").concat((0,helper/* getRandom */.sZz)()));
                                    })
                                }, "".concat(sliderRerenderKey))
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                            ...slickSettings,
                            className: "cmp-carousel-slick__content",
                            ref: sliderRef,
                            children: itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((key, index, arr)=>{
                                const item = items[key];
                                const isFaqBannerItem = (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("single-slide-carousel")) && (item === null || item === void 0 ? void 0 : item[":type"]) === "annsacks/components/image";
                                var ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        isSingleSlider || isLargeCollection || isDoubleFeatureContentCard && !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Image, {
                                            data: item
                                        }) : null,
                                        isFaqBannerItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FaqBanner, {
                                            data: item
                                        }) : null,
                                        isSingleItemsSlider || isSingleSlider || isSingleSlideCarousel || isFeatureContentSlider || isInspiredThemeCarouselSlider || isContentThreeUp || isContentFourUp || isContentFiveUp || isProductSlider || isStickySlider || isFeatureContent || isFullbleedHover ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_Teaser, {
                                            data: item,
                                            showEmptyPlaceholder: showSlideIndicators,
                                            maxHeight: sliderImageHeight
                                        }) : null,
                                        isProduct || isProductcard && !isProductSlider ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                width: "".concat(productCardWidth)
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCard, {
                                                data: item,
                                                showEmptyPlaceholder: showSlideIndicators,
                                                maxHeight: sliderImageHeight,
                                                singleSku: true
                                            })
                                        }) : null
                                    ]
                                }, (ref = item === null || item === void 0 ? void 0 : item.id) !== null && ref !== void 0 ? ref : "cpm-carousel-".concat(index, "-").concat((0,helper/* getRandom */.sZz)()));
                            })
                        }, "".concat(sliderRerenderKey))
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var v1_CarouselSlick = (CarouselSlick);

;// CONCATENATED MODULE: ./components/ManualPdp/PdpProgressiveLoader.jsx


const PdpProgressiveLoader = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "progressive-loader",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "progressive-loader__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row progressive-loader__filter-row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 progressive-loader__filter-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "progressive-loader__filter-heading"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row progressive-loader__filter-contents",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 progressive-loader__filter-contents-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-1 col-lg-1 col-md-1 progressive-loader__filter-details-block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "progressive-loader__filter-contents-heading"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "progressive-loader__filter-contents-share"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6 col-lg-6 col-md-6 progressive-loader__plp-contents-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "progressive-loader__plp-products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "progressive-loader__plp-products-image"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-5 col-lg-5 col-md-5 progressive-loader__plp-details-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "progressive-loader__plp-products-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "progressive-loader__plp-products-details-image1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "progressive-loader__plp-products-details-image2"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ManualPdp_PdpProgressiveLoader = (PdpProgressiveLoader);

// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./components/ManualPdp/AsProductSummary.jsx




const ProductSummary = (props)=>{
    const productSummaryData = props.productSummaryDetails;
    const navigateCTA = (url, newTab)=>{
        if (newTab) {
            window.open(url, "_blank", "noopener,noreferrer");
        } else {
            window.location = url;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-12 product-summary__product-summary-block p-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-summary",
                id: "product-summary-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-summary__title",
                        children: productSummaryData === null || productSummaryData === void 0 ? void 0 : productSummaryData.eyebrowText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-summary__desc",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-summary__desc",
                            children: (0,html_react_parser/* default */.ZP)(productSummaryData.title)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-summary__details",
                        children: (0,html_react_parser/* default */.ZP)(productSummaryData === null || productSummaryData === void 0 ? void 0 : productSummaryData.description)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: ()=>navigateCTA(productSummaryData.ctaLink, productSummaryData.newTab),
                        type: "ghost",
                        role: "button",
                        size: "small",
                        label: productSummaryData === null || productSummaryData === void 0 ? void 0 : productSummaryData.ctaLabel
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var AsProductSummary = (ProductSummary);

// EXTERNAL MODULE: ./public/icons/arrow-left.svg
var arrow_left = __webpack_require__(71623);
// EXTERNAL MODULE: ./public/icons/arrow-right.svg
var arrow_right = __webpack_require__(29157);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./components/ManualPdp/ImageGalleryHorizontal.jsx











const ImageGalleryHorizontal = (props)=>{
    const [scene7AccountName, setScene7AccountName] = (0,react.useState)("");
    const [swatchUrl, setSwatchUrl] = (0,react.useState)("");
    let { productInfo , presetConfigObject ={} , imageClickCounter , updateImageClickCounter  } = props;
    let imageListLength = props.data.length;
    const [select, setSelected] = (0,react.useState)(0);
    const viewMoreLink = imageListLength > 10 ? true : false;
    const imageList = props.isPopup ? props.data : props.data.slice(0, 10);
    const showArrowFlag = imageListLength > 20 && !lib/* isMobile */.tq ? true : false;
    const showSliderArrow = imageListLength > 3 && !lib/* isMobile */.tq ? true : false;
    const [width] = (0,useWindowResize/* default */.Z)();
    let resourceCredits = props && props.productGalleryLabel && props.productGalleryLabel.resourceCredit_s && props.productGalleryLabel.resourceCredit_s.match("http") == null ? props.productGalleryLabel.resourceCredit_s : "";
    const handleChange = function(element, id, type) {
        let resourceCredits = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
        const getOverAllImage = document.querySelectorAll("#".concat(props.galleryStackId));
        const defImageOffset = getOverAllImage[0].childNodes[0].offsetLeft;
        const eleOffset = getOverAllImage[0].childNodes[element].offsetLeft;
        const scrollValue = eleOffset - defImageOffset;
        let isAlreadyChecked = false;
        if (select === element) {
            isAlreadyChecked = true;
        }
        slideView(scrollValue, element);
        if (window.adobeDataLayer && !isAlreadyChecked) {
            if (!id && imageList[element]) {
                // find matching if from imageList
                id = imageList[element].assetId || imageList[element].url;
            }
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const eventInfo = getEventInfo(type, id);
            const pI = productInfo ? JSON.parse(productInfo).productInfo : null;
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo,
                productInfo: pI
            });
            updateImageClickCounter && updateImageClickCounter();
        }
        if (resourceCredits !== "") {
            let resourceCreditsTxt = resourceCredits && resourceCredits.match("http") == null ? resourceCredits : "";
            document.querySelector(".image-reel__photo-credit").innerHTML = resourceCreditsTxt;
        }
    };
    const getEventInfo = (type, id)=>{
        const eventInfo = {
            eventAction: "pdp:modal:gallery:".concat(type || "image or video"),
            eventName: "pdp:modal:gallery:".concat(type || "image or video"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type || id,
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:".concat(type || "navigation"),
            internalLinkZoneName: "pdp:modal:gallery",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        if (imageClickCounter && type !== "carousel") {
            eventInfo.imageSequence = imageClickCounter + 1;
        }
        return eventInfo;
    };
    function slideView(scrollValue, ele) {
        const getImageView = document.getElementById("".concat(props.galleryStackId));
        window.isCustomScroll = true;
        getImageView.scrollTo({
            top: 0,
            left: "".concat(scrollValue),
            behavior: "smooth"
        });
        setSelected(ele);
    }
    const onScroll = lodash_debounce_default()(()=>{
        if (!window.isCustomScroll) {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const eventInfo = getEventInfo("carousel");
            const pI = productInfo ? JSON.parse(productInfo).productInfo : null;
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo,
                productInfo: pI
            });
        } else {
            window.isCustomScroll = false;
        }
    }, 2000);
    (0,react.useEffect)(()=>{
        const getImageView = document.getElementById("".concat(props.galleryStackId));
        getImageView.removeEventListener("scroll", onScroll);
        getImageView.addEventListener("scroll", onScroll, {
            passive: true
        });
        (0,constants_config/* getConfig */.i)().then((config)=>{
            if (config.general) {
                const { general: { scene7AccountName ="" , swatchUrl =""  }  } = config;
                setScene7AccountName(scene7AccountName);
                setSwatchUrl(swatchUrl);
            }
        });
        return ()=>{
            delete window.isCustomScroll;
            getImageView && getImageView.removeEventListener("scroll", onScroll);
        };
    }, [
        imageListLength
    ]);
    const handleImageUrl = (imgUrl)=>{
        const asset = imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.split("/").pop();
        const assetId = asset === null || asset === void 0 ? void 0 : asset.split(".");
        const presetConfig = JSON.parse(props === null || props === void 0 ? void 0 : props.presetConfig);
        return (0,helper/* getPresetUrl */.v$f)(width, swatchUrl, assetId[0], presetConfig, scene7AccountName);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "image-gallery",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "image-gallery__stack",
                        children: [
                            props.badge && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-gallery__badge",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "product-gallery__new",
                                    children: props.badge
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "image-gallery__image-stack-view",
                                id: props.galleryStackId,
                                children: imageList.map((element, i)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        id: i,
                                        className: "image-gallery__image-stack-list",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            onError: (e)=>e.target.src = image_missing/* default */.Z,
                                            src: handleImageUrl(element.galleryImage),
                                            alt: element.altText,
                                            onClick: ()=>{
                                                handleChange(i, element.galleryImage);
                                            }
                                        })
                                    }, i);
                                })
                            }),
                            showSliderArrow && imageList.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: select === 0 ? "previous-image" : "previous-image-dark",
                                        onClick: ()=>{
                                            let pos = select > 0 ? select - 1 : select;
                                            handleChange(pos);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: select === imageList.length - 1 ? "next-image" : "next-image-dark",
                                        onClick: ()=>{
                                            let position = imageList.length - 1 > select ? select + 1 : select;
                                            handleChange(position);
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "image-gallery__thumb",
                        children: [
                            showArrowFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_left/* default */.Z,
                                    alt: "leftArrow",
                                    className: "image-gallery__left-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "image-gallery__image-thumb-view",
                                id: "image-gallery__image-thumb-view",
                                children: [
                                    imageList.map((element, i)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            className: "image-gallery__image-thumb-list",
                                            id: "image-gallery__image-thumb-list",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "image-gallery_".concat(select === i ? "_image-thumbSelected" : "_image-thumb"),
                                                onClick: ()=>{
                                                    (props === null || props === void 0 ? void 0 : props.enablePresets) ? handleChange(i, element.assetId || element.url, "", element === null || element === void 0 ? void 0 : element.resourceCredits) : handleChange(i, element.assetId || element.url);
                                                },
                                                onKeyPress: (event)=>{
                                                    if (event.key === "Enter") (props === null || props === void 0 ? void 0 : props.enablePresets) ? handleChange(i, element.assetId || element.url, "", element === null || element === void 0 ? void 0 : element.resourceCredits) : handleChange(i, element.assetId || element.url);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    role: "button",
                                                    onError: (e)=>e.target.src = image_missing/* default */.Z,
                                                    src: element.galleryImage,
                                                    alt: element.altText,
                                                    tabIndex: 0
                                                })
                                            })
                                        }, i);
                                    }),
                                    !props.isPopup && viewMoreLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "image-gallery__image-thumb-list",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            role: "button",
                                            tabIndex: 0,
                                            className: "image-gallery__link-more viewmore-mobile",
                                            onClick: ()=>props.handlePopup(),
                                            children: props.staticTexts.viewMore
                                        })
                                    })
                                ]
                            }),
                            showArrowFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_right/* default */.Z,
                                    alt: "rightArrow",
                                    className: "image-gallery__right-arrow"
                                })
                            })
                        ]
                    })
                ]
            }),
            resourceCredits && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "image-reel__photo-credit",
                children: resourceCredits
            })
        ]
    });
};
ImageGalleryHorizontal.defaultProps = {
    data: [],
    staticTexts: {},
    productInfo: "",
    imageClickCounter: 0
};
ImageGalleryHorizontal.propTypes = {
    data: prop_types_default().arrayOf((prop_types_default()).any).isRequired,
    staticTexts: (prop_types_default()).object,
    productInfo: (prop_types_default()).string,
    imageClickCounter: (prop_types_default()).number,
    updateImageClickCounter: (prop_types_default()).func
};
/* harmony default export */ var ManualPdp_ImageGalleryHorizontal = (ImageGalleryHorizontal);

// EXTERNAL MODULE: ./public/icons/down-arrow.svg
var down_arrow = __webpack_require__(80779);
;// CONCATENATED MODULE: ./components/ManualPdp/AsProductGalleryViewer.jsx








const AsProductGalleryViewer = (props)=>{
    var ref;
    const [width] = (0,useWindowResize/* default */.Z)();
    let imageListLength = props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.length;
    const viewMoreLink = imageListLength > 3 ? true : false;
    const [selectedItem, setSelectedItem] = (0,react.useState)(0);
    const [swatchUrl, setSwatchUrl] = (0,react.useState)("");
    const [scene7AccountName, setScene7AccountName] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            if (config.general) {
                const { general: { scene7AccountName ="" , swatchUrl =""  }  } = config;
                setScene7AccountName(scene7AccountName);
                setSwatchUrl(swatchUrl);
            }
        });
    }, [
        imageListLength
    ]);
    const handleImageUrl = ()=>{
        var ref;
        const presetConfig = JSON.parse(props === null || props === void 0 ? void 0 : props.presetConfig);
        const asset = (ref = props.data[selectedItem].galleryImage) === null || ref === void 0 ? void 0 : ref.split("/").pop();
        const assetId = asset === null || asset === void 0 ? void 0 : asset.split(".");
        if ((assetId === null || assetId === void 0 ? void 0 : assetId.length) > 1) {
            return (0,helper/* getPresetUrl */.v$f)(width, swatchUrl, assetId[0], presetConfig, scene7AccountName);
        } else {
            return (0,helper/* getPresetUrl */.v$f)(width, swatchUrl, asset, presetConfig, scene7AccountName);
        }
    };
    (0,react.useLayoutEffect)(()=>{
        handleImageUrl();
    }, [
        width
    ]);
    const handleChange = function(index) {
        let resourceCredits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        setSelectedItem(index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "image-reel row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-reel__image-thumb-view col-2 no-print",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "pl-0 ml-0 image-reel__image-thumb-view-ul",
                        children: [
                            props.data && props.data.slice(0, 5).map((el, i)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "image-reel__image-list",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image-reel_".concat(selectedItem === i ? "_thumbSelected" : "_image-thumb"),
                                        onClick: ()=>{
                                            handleChange(i);
                                        },
                                        tabIndex: "0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            onError: (e)=>e.target.src = image_missing/* default */.Z,
                                            src: el.galleryImage,
                                            className: "img-fluid",
                                            alt: ""
                                        })
                                    })
                                }, i);
                            }),
                            viewMoreLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "image-reel__image-view",
                                onClick: ()=>props.handlePopup(),
                                tabIndex: "0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "image-reel__link-more gbh-data-layer",
                                        "data-gbh-data-layer": '{"eventAction":"pdp:product details:view gallery","eventName":"pdp:product details:view gallery","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view gallery","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                        children: props.staticTexts.viewLink
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: down_arrow/* default */.Z === null || down_arrow/* default */.Z === void 0 ? void 0 : down_arrow/* default.src */.Z.src,
                                        alt: "Images. Press enter key to view the gallery modal popup"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-reel__image-stack-view col-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "image-reel__image-stack-view-block",
                        children: [
                            props.badge && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-gallery__badge",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "product-gallery__new",
                                    children: props.badge
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pl-0 list-inline image-reel__image-stack-list",
                                children: props.data && props.data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    onError: (e)=>e.target.src = image_missing/* default */.Z,
                                    src: handleImageUrl(),
                                    alt: "",
                                    className: "".concat(selectedItem === 0 ? "image-reel__stack-list-image print" : "image-reel__stack-list-image no-print"),
                                    tabIndex: "0"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
AsProductGalleryViewer.defaultProps = {
    data: [],
    staticTexts: {}
};
AsProductGalleryViewer.propTypes = {
    data: prop_types_default().arrayOf((prop_types_default()).any).isRequired,
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var ManualPdp_AsProductGalleryViewer = (AsProductGalleryViewer);

;// CONCATENATED MODULE: ./components/ManualPdp/AsProductGallery.view.jsx







const AsProductGalleryView = (props)=>{
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [isMobileDevice, setIsMobileDevice] = (0,react.useState)(false);
    const [width] = (0,useWindowResize/* default */.Z)();
    (0,react.useEffect)(()=>{
        setIsMobileDevice(width < 840);
    }, [
        width
    ]);
    const handleModalPopup = ()=>{
        setShowModal(true);
        document.body.classList.add("image-gallery-modal-opened");
    };
    const onModalClose = ()=>{
        setShowModal(false);
        document.body.classList.remove("image-gallery-modal-opened");
        document.body.classList.remove("scroll-lock");
        (0,helper/* preventBodyScroll */.MVu)(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            isMobileDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-gallery",
                id: "imageGallery",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManualPdp_ImageGalleryHorizontal, {
                    ...props,
                    isPopup: false,
                    handlePopup: handleModalPopup,
                    galleryStackId: "image-gallery__image-stack-gallery",
                    showBadges: true,
                    showPhotoCredit: "1"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ManualPdp_AsProductGalleryViewer, {
                ...props,
                handlePopup: handleModalPopup
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                onModalClose: onModalClose,
                showModal: showModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-gallery-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManualPdp_ImageGalleryHorizontal, {
                        ...props,
                        isPopup: true,
                        galleryStackId: "image-gallery__image-stack-kohler"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var AsProductGallery_view = (AsProductGalleryView);

;// CONCATENATED MODULE: ./components/ManualPdp/index.jsx






function ManualPdp(props) {
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticTexts = {
        home: t("kf.global.label.home"),
        serviceParts: t("kf.pdp.label.serviceParts"),
        viewLink: t("kf.pdp.label.viewGallery")
    };
    if (Object.keys(props.data).length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ManualPdp_PdpProgressiveLoader, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "manualPdpSummary",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "page-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-details",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container kf-react-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "print-overview product-details__overview-block product-info",
                                    id: "product-details__overview-block",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-img-block product-details__image-gallery print-overview-left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AsProductGallery_view, {
                                                data: props.data.galleryImages,
                                                badge: props.data.badge,
                                                staticTexts: staticTexts,
                                                presetConfig: props.data.presetConfigs
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-info-block product-details__content-section print-overview-right",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AsProductSummary, {
                                                productSummaryDetails: props.data
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "clearfix"
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}
/* harmony default export */ var components_ManualPdp = (ManualPdp);

;// CONCATENATED MODULE: ./components/AsProductTabDetail/index.jsx




const PDPDetailsTab = (props)=>{
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const refsArray = props.data.tabDetails.map(()=>(0,react.useRef)(null));
    const tabNavRef = (0,react.useRef)(null);
    const onTab = (index)=>{
        setActiveIndex(index);
        const element = refsArray[index];
        tabNavRef.current.scrollTo({
            left: element.current.offsetLeft - 18,
            behavior: "smooth"
        });
    };
    if (props.data.tabDetails && props.data.tabDetails.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container responsivegrid",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "manualPdpTabs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "asproducttabdetail",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "page-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "wrapper",
                                id: "product-details-tab-details",
                                total: props.data.tabDetails.length,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "wrapper__tab-devider"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tabWrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tabNav",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    ref: tabNavRef,
                                                    children: props.data.tabDetails.map((item, index)=>{
                                                        let active = activeIndex === index;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            ref: refsArray[index],
                                                            role: "tab",
                                                            tabIndex: "0",
                                                            "aria-selected": activeIndex === index,
                                                            "aria-controls": "product-tabpanel-".concat(index),
                                                            className: active ? "active" : "",
                                                            onClick: ()=>onTab(index),
                                                            onKeyDown: (e)=>{
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    e.preventDefault();
                                                                    onTab(index);
                                                                }
                                                            },
                                                            children: item.tabTitle
                                                        }, "li-2-" + index);
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tabContent",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "width100",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: (0,html_react_parser/* default */.ZP)(props.data.tabDetails[activeIndex]["tabDescription"])
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        });
    } else {
        return null;
    }
};
/* harmony default export */ var AsProductTabDetail = ((0,dist_es/* withTranslation */.Zh)()(PDPDetailsTab));

// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var react_sticky_el_lib = __webpack_require__(75198);
var lib_default = /*#__PURE__*/__webpack_require__.n(react_sticky_el_lib);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var react_lazyload_lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
;// CONCATENATED MODULE: ./components/ProductList/v1/Sort.jsx






const Sort = (param)=>{
    let { texts , data , page , selectedtab , tabIndex =0 , isSearch , selectedSort , onChange  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const sortClass = classnames_default()({
        "sort": true,
        "sort--open": isOpen
    });
    const sortBtn = (0,react.useRef)(null);
    const pastServiceMenu = (0,react.useRef)(null);
    const sortByWrapper = (0,react.useRef)(null);
    const getAnalyticsData = function(item) {
        let needJson = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        let analyticsData = "";
        if (page === "search") {
            analyticsData = {
                eventAction: "search results:".concat(selectedtab, ":main content area:sort by"),
                eventName: "search results:".concat(selectedtab, ":main content area:sort by"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: item.name,
                internalLinkPosition: "search results",
                internalLinkType: "search results:sort by",
                internalLinkZoneName: "search results:".concat(selectedtab, ":main content area"),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (page === "technicalspecs") {
            analyticsData = {
                eventAction: "technical specs:main content area:sort by",
                eventName: "technical specs:main content area:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(item.name),
                internalLinkPosition: "tech specs",
                internalLinkType: "technical specs:sort by",
                internalLinkZoneName: "technical specs:main content area​",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (page === "favorites") {
            analyticsData = {
                eventAction: "my account:favorites:".concat(selectedtab, ":sort by"),
                eventName: "my account:favorites:".concat(selectedtab, ":sort by"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(item.name),
                internalLinkPosition: "favorites",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:favorites:".concat(selectedtab),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (page === "article") {
            analyticsData = {
                eventAction: "support:help and faq:article list​:sort by",
                eventName: "support:help and faq:article list​:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(item.name),
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:sort by",
                internalLinkZoneName: "support:help and faq:article list​​",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (page === "active-services") {
            analyticsData = {
                eventAction: "my account:services:active services​:sort by",
                eventName: "my account:services:active services​:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(item.name),
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:active services",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (page === "past-services") {
            analyticsData = {
                eventAction: "my account:services:past services​:sort by",
                eventName: "my account:services:past services​:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(item.name),
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:past services",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (page === "literature") {
            analyticsData = {
                eventAction: "literature:sort by",
                eventName: "literature:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(item.name),
                internalLinkPosition: "literature",
                internalLinkType: "literature:sort by",
                internalLinkZoneName: "literature:main content area",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (page === "press-release") {
            analyticsData = {
                eventAction: "press room:press releases:sort by",
                eventName: "press room:press releases:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(item.name),
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press releases:main content area",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (page === "press-kits") {
            analyticsData = {
                eventAction: "press room:press kits:sort by",
                eventName: "press room:press kits:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(item.name),
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press kits:main content area",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (page === "my products") {
            analyticsData = {
                eventAction: "my account:products:sort by filter",
                eventName: "my account:products:sort by filter",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(item.name),
                internalLinkPosition: "my account",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:products",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else {
            analyticsData = {
                eventAction: "plp sort by filter",
                eventName: "plp sort by filter",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(item.name),
                internalLinkPosition: "plp",
                internalLinkType: "plp:sort by",
                internalLinkZoneName: "plp:sort by filter",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        if (needJson) return analyticsData;
        return JSON.stringify(analyticsData);
    };
    window.addEventListener("click", function(e) {
        var ref;
        if (isOpen && !((ref = sortByWrapper.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) setIsOpen(false);
    });
    (0,react.useEffect)(()=>{
        if (isOpen) {
            pastServiceMenu.current.firstElementChild.focus();
        }
    }, [
        isOpen
    ]);
    const btnKeyDown = (e)=>{
        const { KEYCODE  } = constants["default"];
        switch(e.keyCode){
            case KEYCODE.ENTER:
                e.preventDefault();
                !isOpen ? pastServiceMenu.current.firstElementChild.focus() : "";
                setIsOpen(!isOpen);
                break;
            default:
                break;
        }
    };
    const handleKeyDown = (i, e)=>{
        e.preventDefault();
        const { KEYCODE  } = constants["default"];
        const ele = pastServiceMenu.current.childNodes;
        switch(e.keyCode){
            case KEYCODE.ESC:
                setIsOpen(false);
                break;
            case KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                if (i < data.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
            case KEYCODE.ENTER:
                ele[i].click();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: sortClass,
        ref: sortByWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                ref: sortBtn,
                className: "sort__toggle",
                tabIndex: tabIndex,
                "aria-label": isSearch ? selectedSort ? "".concat(selectedSort.name, " ").concat(texts.selected) : texts.sortByAria : selectedSort ? "".concat(texts.sort, " : ").concat(selectedSort.name, " ").concat(texts.selected) : texts.sortByAria,
                onClick: ()=>setIsOpen(!isOpen),
                onKeyDown: btnKeyDown,
                children: [
                    "".concat(texts.sort, " ").concat(selectedSort ? ": " + selectedSort.name : "Featured"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: arrow_up/* default */.Z === null || arrow_up/* default */.Z === void 0 ? void 0 : arrow_up/* default.src */.Z.src,
                        alt: "",
                        className: "sort__toggle-icon",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                ref: pastServiceMenu,
                className: "sort__drop-down",
                "aria-label": isOpen ? texts.sortbyExpanded : texts.sortbyClosed,
                children: data.map((item, i)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        id: "select-options-".concat(i),
                        role: "option",
                        tabIndex: "0",
                        "aria-selected": (item === null || item === void 0 ? void 0 : item.name) === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name),
                        className: "sort__item gbh-data-layer ".concat((item && item.name) === (selectedSort && (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name)) ? "active" : ""),
                        "data-gbh-data-layer": getAnalyticsData(item),
                        onClick: ()=>{
                            onChange(item);
                            setIsOpen(false);
                        },
                        onKeyDown: (e)=>handleKeyDown(i, e),
                        children: item.name
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var v1_Sort = ((0,lib/* withOrientationChange */.Qe)(Sort));

// EXTERNAL MODULE: ./src/components/core/Collapsible/index.js
var Collapsible = __webpack_require__(73394);
// EXTERNAL MODULE: ./public/icons/print.svg
var print = __webpack_require__(30402);
// EXTERNAL MODULE: ./public/icons/share.svg
var share = __webpack_require__(66773);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(24495);
// EXTERNAL MODULE: ./public/icons/close-filter.svg
var close_filter = __webpack_require__(8327);
// EXTERNAL MODULE: ./src/components/core/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(94593);
// EXTERNAL MODULE: ./components/SocialShare/v1/SocialShare.jsx + 1 modules
var v1_SocialShare = __webpack_require__(24636);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./src/components/FriendsAndFamily/v1/friendsAndFamilyHelper.js
var friendsAndFamilyHelper = __webpack_require__(91960);
// EXTERNAL MODULE: ./store/features/asPlpSlice.js
var asPlpSlice = __webpack_require__(29441);
;// CONCATENATED MODULE: ./components/ProductList/v1/Filter.jsx





















const Filter = (props)=>{
    var ref, ref1;
    const { sort ={} , showSort =false , onSortChange , texts ={} , selectedSort  } = props;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [showMore, setShowMore] = (0,react.useState)(false);
    const [collapse, setCollapse] = (0,react.useState)({});
    const [appliedFilters, setAppliedFilters] = (0,react.useState)([]);
    const plus = /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "plus",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-1 line"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line line-2"
            })
        ]
    });
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const filterFacets = (0,react.useRef)();
    const sortBy = (0,react.useRef)();
    const shareImg = (0,react.useRef)(null);
    const filterKeyValueParam = [
        "Yes",
        "No",
        "True",
        "False"
    ];
    const dispatch = (0,es/* useDispatch */.I0)();
    const selectedTab = props.type || "products";
    const testPageQueryparam = [
        "categoryParam",
        "sortParam"
    ];
    const formatFacetName = (name, filter)=>{
        let val = props.facetLabels && props.facetLabels[name.replace(/^\*{2}/, "")] ? props.facetLabels[name.replace(/^\*{2}/, "")] : name.replace(/\./g, "/").replace(/_/g, " ").replace(/^\*{2}/, "");
        if (filter) val += " - ".concat(filter);
        return val;
    };
    (0,react.useEffect)(()=>{
        setAppliedFilters([]);
    }, [
        props.categoryKey
    ]);
    (0,react.useEffect)(()=>{
        if (props === null || props === void 0 ? void 0 : props.clearShippingTabFilter) {
            clearAllFilters();
        }
    }, [
        props === null || props === void 0 ? void 0 : props.clearShippingTabFilter
    ]);
    (0,react.useEffect)(()=>{
        setCollapse({});
    }, [
        props === null || props === void 0 ? void 0 : props.category
    ]);
    (0,react.useEffect)(()=>{
        if (props.currFilters && props.currFilters.length > 0) {
            setAppliedFilters(props.currFilters);
        }
    }, [
        props.currFilters
    ]);
    (0,react.useEffect)(()=>{
        if (width < 992) {
            props.showFilter ? document.body.style.overflow = "hidden" : document.body.style.overflow = "visible";
        } else {
            document.body.style.overflow = "visible";
        }
        if (lib/* isMobile */.tq && width < 992 && props.showFilter && facets.length) {
            var ref, ref1;
            sortBy === null || sortBy === void 0 ? void 0 : (ref = sortBy.current) === null || ref === void 0 ? void 0 : (ref1 = ref.firstElementChild) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    }, [
        width,
        props.showFilter
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
    }, []);
    //delete unwanted facets
    let filterList = props.facets;
    delete filterList["New_Products"];
    delete filterList["Hide_Discontinued"];
    delete filterList["Products"];
    delete filterList["Inspiration"];
    delete filterList["Technical"];
    delete filterList["Parts"];
    delete filterList["Help"];
    delete filterList["Resource"];
    if (props.hidePriceRange) {
        delete filterList["Price_Range"];
    } else if (filterList["Price_Range"]) {
        filterList = {
            "Price_Range": filterList["Price_Range"],
            ...filterList
        };
    }
    filterList = (0,helper/* getAsUniqueFilter */.B_)(filterList);
    let facets = Object.entries(filterList).filter((facet)=>facet[1].length > 0);
    const getAppliedFiltersForAnalytics = (appliedFilters)=>{
        let filterArray = [];
        appliedFilters.forEach((filter)=>{
            filter.display.forEach((filtervalue)=>{
                filterArray.push("".concat(formatFacetName(filter.facet), ":").concat(filtervalue));
            });
        });
        return filterArray.length ? filterArray.join("|") : "";
    };
    const isSelected = (obj)=>{
        let facet = appliedFilters.find((filter)=>filter.facet === obj.facet);
        if (!facet) return false;
        return facet.display.includes(obj.display) ? true : false;
    };
    const handleFilter = (checked, obj, facets, appliedFilters)=>{
        let curFilters = cloneDeep_default()(appliedFilters);
        let facet = curFilters.find((filter)=>filter.facet === obj.facet);
        if (checked) {
            if (facet) {
                facet.value.push(obj.value.replace(/"/g, '\\"'));
                facet.display.push(obj.display);
            } else curFilters.push({
                facet: obj.facet,
                value: [
                    obj.value.replace(/"/g, '\\"')
                ],
                display: [
                    obj.display
                ]
            });
        } else {
            if ((obj === null || obj === void 0 ? void 0 : obj.facet) === "SKUAnnSacksNonStock_b" || (obj === null || obj === void 0 ? void 0 : obj.facet) === "-SKUAnnSacksNonStock_b") {
                clearAllFilters();
                return;
            }
            let index = facet.display.indexOf(obj.display);
            facet.value.splice(index, 1);
            facet.display.splice(index, 1);
            if (!facet.value.length) {
                curFilters = curFilters.filter((f)=>f.facet !== obj.facet);
            }
        }
        setAppliedFilters([
            ...curFilters
        ]);
        props.addToUrl && setUrlParams(curFilters);
        props.onFilter(curFilters);
        const eventInfo = getFilterOptionsAnalyticsData(obj, facets, appliedFilters);
        (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(JSON.parse(eventInfo));
        if (props.handleScroll) props.handleScroll();
    };
    const getAnalyticsData = (isUnchecked)=>{
        const hideDiscontinuedEventObj = {
            eventAction: "search results:technical:filters​:hide discontinued products",
            eventName: "search results:technical:filters​:hide discontinued products",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "hide discontinued products:".concat(isUnchecked ? "unchecked" : "checked"),
            internalLinkPosition: "search results",
            internalLinkType: "search results:checkbox",
            internalLinkZoneName: "search results:technical:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        return JSON.stringify(hideDiscontinuedEventObj);
    };
    const setUrlParams = (filters)=>{
        let query = "";
        if (filters.length > 0) {
            filters.forEach((filter, i)=>{
                var ref;
                const values = [
                    ...filter.value
                ];
                if (values.length !== 0 && filter.facet === "Price_Range" ? true : props.facetLabels[(ref = filter.facet) === null || ref === void 0 ? void 0 : ref.replace(/^\*{2}/, "")]) {
                    var ref1, ref2;
                    var ref3;
                    query += "".concat(filter.facet === "Price_Range" ? filter.facet : (ref3 = (ref2 = props.facetLabels[(ref1 = filter.facet) === null || ref1 === void 0 ? void 0 : ref1.replace(/^\*{2}/, "")]) === null || ref2 === void 0 ? void 0 : ref2.replaceAll(" ", "_")) !== null && ref3 !== void 0 ? ref3 : filter.facet, "=").concat(filter.facet === "Price_Range" ? filter.value : encodeURIComponent(values)).concat(i !== filters.length - 1 ? "&" : "");
                } else if ((filter === null || filter === void 0 ? void 0 : filter.facet) === "SKUAnnSacksNonStock_b") {
                    query += "Special_Order=true".concat(i !== filters.length - 1 ? "&" : "");
                } else if ((filter === null || filter === void 0 ? void 0 : filter.facet) === "-SKUAnnSacksNonStock_b") {
                    query += "Ready_to_Ship=true".concat(i !== filters.length - 1 ? "&" : "");
                }
            });
            if (window.location.pathname === constants.GENERIC_PLP_PAGE) {
                const url = new URL(window.location.href);
                const tmpquery = testPageQueryparam.map((key)=>url.searchParams.get(key) ? "".concat(key, "=").concat(url.searchParams.get(key)) : "").filter(Boolean).join("&");
                tmpquery.length > 0 && query.length > 0 ? query = "".concat(tmpquery, "&").concat(query) : tmpquery.length > 0 ? query = "".concat(tmpquery) : null;
                window.history.replaceState(window.location.pathname, document.title, query.toString().length === 0 ? window.location.pathname : "?".concat(query.toString()));
            } else {
                window.history.replaceState(window.location.pathname, document.title, query.toString().length === 0 ? window.location.pathname : "?".concat(query.toString()));
            }
            if (props.resetTitle) props.resetTitle();
        } else {
            clearAllFilters();
        }
    };
    const handleCollapse = (facet, state)=>{
        setCollapse((prevCollapse)=>({
                ...prevCollapse,
                [facet]: state
            }));
    };
    const clearAllFilters = ()=>{
        setAppliedFilters([]);
        dispatch((0,asPlpSlice/* resetShippingStatus */.K$)());
        props.onFilter([]);
        window.history.replaceState({}, document.title, window.location.pathname);
        if (props.resetTitle) props.resetTitle();
    };
    const handleShowMore = ()=>{
        if (showMore) {
            const newCollapseState = {};
            facets.forEach((facet, i)=>{
                if (i > 4) newCollapseState[facet[0]] = false;
            });
            setCollapse((prevCollapse)=>({
                    ...prevCollapse,
                    ...newCollapseState
                }));
        }
        setShowMore(!showMore);
    };
    (0,react.useEffect)(()=>{
        if (showMore) {
            var ref, ref1, ref2;
            ((ref = filterFacets.current) === null || ref === void 0 ? void 0 : ref.childNodes) && ((ref2 = (ref1 = filterFacets.current.childNodes[7]) === null || ref1 === void 0 ? void 0 : ref1.childNodes[0]) === null || ref2 === void 0 ? void 0 : ref2.focus());
        }
    }, [
        showMore
    ]);
    const formatPriceRange = (filter)=>{
        var ref, ref1;
        let values = filter.match(/\d+/g);
        return (props === null || props === void 0 ? void 0 : props.isAnnsacksPlp) ? "$".concat((ref = Number(values[0])) === null || ref === void 0 ? void 0 : ref.toLocaleString(), " - $").concat((ref1 = Number(values[1])) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString()) : "$".concat(values[0], " - $").concat(values[1]);
    };
    (0,react.useEffect)(()=>{
        if (lib/* isMobile */.tq && width < 992) {
            props.showFilter ? document.body.style.overflow = "hidden" : document.body.style.overflow = "visible";
        } else {
            document.body.style.overflow = "visible";
        }
        if (lib/* isMobile */.tq && width < 992 && props.showFilter && facets.length) {
            var ref, ref1;
            const filterCollapse = filterFacets.current.firstElementChild;
            filterCollapse === null || filterCollapse === void 0 ? void 0 : (ref = filterCollapse.firstElementChild) === null || ref === void 0 ? void 0 : (ref1 = ref.firstElementChild) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    }, [
        width,
        props.showFilter
    ]);
    const getAppliedFiltersForPlpAnalyticsData = (appliedFilters, facet, obj)=>{
        var ref;
        let dataLayerFilterArray = [];
        appliedFilters.forEach((filter)=>{
            filter.display.forEach((filtervalue)=>{
                dataLayerFilterArray.push("".concat(formatFacetName(filter.facet), ":").concat(filtervalue));
            });
        });
        let myIndex = dataLayerFilterArray.indexOf("".concat(formatFacetName(facet), ":").concat(obj));
        if (myIndex !== -1) {
            dataLayerFilterArray.splice(myIndex, 1);
        } else {
            dataLayerFilterArray.push("".concat(formatFacetName(facet), ":").concat(obj));
        }
        return dataLayerFilterArray.length ? (ref = dataLayerFilterArray.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "";
    };
    const getFilterOptionsAnalyticsData = (obj, facet, appliedFilters)=>{
        var ref;
        let plpFilterArrayData = getAppliedFiltersForPlpAnalyticsData(appliedFilters, facet[0], obj.display);
        const facetFormat = (ref = formatFacetName(facet[0])) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        const appliedOrRemoved = isSelected(obj) ? "removed" : "applied";
        let analyticsData = "";
        if (props.page === "search") {
            analyticsData = JSON.stringify({
                eventAction: "search results:".concat(selectedTab, ":filters ").concat(appliedOrRemoved),
                eventName: "search results:".concat(selectedTab, ":filters​ ").concat(appliedOrRemoved),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: obj.display,
                internalLinkPosition: "search results",
                internalLinkType: "search results:".concat(facetFormat),
                internalLinkZoneName: "search results:".concat(selectedTab, ":filters​"),
                internalLinkURL: "n/a",
                clickInternalLinks: "true",
                filterArray: plpFilterArrayData
            });
        } else if (props.page === "technicalspecs") {
            analyticsData = JSON.stringify({
                eventAction: "technical specs:filters​:".concat(appliedOrRemoved),
                eventName: "technical specs:filters​:".concat(appliedOrRemoved),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(obj.display, ":").concat(appliedOrRemoved),
                internalLinkPosition: "technical specs",
                internalLinkType: "technical specs:".concat(facetFormat),
                internalLinkZoneName: "technical specs:filters",
                internalLinkURL: "n/a",
                clickInternalLinks: "true",
                filterArray: plpFilterArrayData
            });
        } else if (props.page === "article") {
            const appliedOrRemoved1 = isSelected(obj) ? "removed" : "applied";
            analyticsData = JSON.stringify({
                eventAction: "support:help and faq:filters​:filter ".concat(appliedOrRemoved1),
                eventName: "support:help and faq:filters​:filter ".concat(appliedOrRemoved1),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(obj.display, ":").concat(appliedOrRemoved1),
                internalLinkPosition: "support:help and faq",
                internalLinkType: "support:help and faq:​".concat(facetFormat),
                internalLinkZoneName: "support:help and faq:filters​",
                internalLinkURL: "n/a",
                clickInternalLinks: "true",
                filterArray: plpFilterArrayData
            });
        } else if (props.page === "literature") {
            const appliedOrRemoved2 = isSelected(obj) ? "removed" : "applied";
            analyticsData = JSON.stringify({
                eventAction: "literature:filters:".concat(appliedOrRemoved2),
                eventName: "literature:filters​:".concat(appliedOrRemoved2),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(obj.display, ":").concat(appliedOrRemoved2),
                internalLinkPosition: "literature",
                internalLinkType: "literature:​".concat(facetFormat),
                internalLinkZoneName: "literature:filters​",
                internalLinkURL: "n/a",
                clickInternalLinks: "true",
                filterArray: plpFilterArrayData
            });
        } else {
            var ref1;
            analyticsData = JSON.stringify({
                eventAction: "plp filter ".concat(appliedOrRemoved),
                eventName: "plp filter ".concat(appliedOrRemoved),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: obj === null || obj === void 0 ? void 0 : (ref1 = obj.display) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(),
                internalLinkPosition: "plp",
                internalLinkType: "plp:".concat(facetFormat),
                internalLinkZoneName: "plp:filters",
                internalLinkURL: "n/a",
                clickInternalLinks: "true",
                filterArray: plpFilterArrayData
            });
        }
        return analyticsData;
    };
    const getShowMoreAnalyticsData = (showMoreFlag)=>{
        let analyticsData = "";
        if (props.page === "search") {
            const lessOrMore = showMoreFlag ? "less" : "more";
            analyticsData = JSON.stringify({
                eventAction: "search results:".concat(selectedTab, ":filters:show ").concat(lessOrMore, " filters"),
                eventName: "search results:".concat(selectedTab, ":filters:show ").concat(lessOrMore, " filters"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "show ".concat(lessOrMore, " filters"),
                internalLinkPosition: "search results",
                internalLinkType: "search results:show ".concat(lessOrMore),
                internalLinkZoneName: "search results:".concat(selectedTab, ":filters"),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        } else if (props.page === "technicalspecs") {
            analyticsData = '{"eventAction":"' + (showMoreFlag ? "technical specs:filters:show less filters​" : "technical specs:filters:show more filters​") + '","eventName":"' + (showMoreFlag ? "technical specs:filters:show less filters​" : "technical specs:filters:show more filters​") + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + (showMoreFlag ? "show less" : "show more") + ' filters","internalLinkPosition":"plp","internalLinkType":"technical specs:' + (showMoreFlag ? "show less" : "show more") + '","internalLinkZoneName":"technical specs:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        } else if (props.page === "article") {
            analyticsData = '{"eventAction":"' + (showMoreFlag ? "support:help and faq:filters​:show less filters" : "support:help and faq:filters​:show more filters") + '","eventName":"' + (showMoreFlag ? "support:help and faq:filters​:show less filters" : "support:help and faq:filters​:show more filters") + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + (showMoreFlag ? "show less" : "show more") + ' filters","internalLinkPosition":"support:help and faq","internalLinkType":"support:help and faq:navigation","internalLinkZoneName":"support:help and faq:filters​","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        } else {
            analyticsData = '{"eventAction":"' + (showMoreFlag ? "plp show less filter" : "plp filter show more") + '","eventName":"' + (showMoreFlag ? "plp show less filter" : "plp filter show more") + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + (showMoreFlag ? "show less" : "show more") + ' filters","internalLinkPosition":"plp","internalLinkType":"plp:' + (showMoreFlag ? "show less" : "show more") + '","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        }
        return analyticsData;
    };
    const getPrintOrShareEventInfo = (printOrShare)=>{
        let analyticsData = "";
        if (props.page === "search") {
            analyticsData = {
                eventAction: "search results:".concat(selectedTab, ":filters:").concat(printOrShare),
                eventName: "search results:".concat(selectedTab, ":filters:").concat(printOrShare),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: printOrShare,
                internalLinkPosition: "search results",
                internalLinkType: "search results:".concat(printOrShare),
                internalLinkZoneName: "search results:".concat(selectedTab, ":filters"),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (props.page === "technicalspecs") {
            analyticsData = {
                eventAction: "technical specs:filters:".concat(printOrShare),
                eventName: "technical specs:filters:".concat(printOrShare),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: printOrShare,
                internalLinkPosition: "tech specs",
                internalLinkType: "technical specs​:".concat(printOrShare),
                internalLinkZoneName: "technical specs:filters​",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else if (props.page === "literature") {
            analyticsData = {
                eventAction: "literature:filters:".concat(printOrShare),
                eventName: "literature:filters:".concat(printOrShare),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: printOrShare,
                internalLinkPosition: "literature",
                internalLinkType: "literature​:".concat(printOrShare),
                internalLinkZoneName: "literature:filters​",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        } else {
            analyticsData = {
                eventAction: "plp ".concat(printOrShare),
                eventName: "plp ".concat(printOrShare),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: printOrShare,
                internalLinkPosition: "plp",
                internalLinkType: "plp:".concat(printOrShare),
                internalLinkZoneName: "plp:filters",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        return JSON.stringify(analyticsData);
    };
    const getSocialShareAnalyticsData = ()=>{
        let analyticsData = "";
        if (props.page === "technicalspecs") {
            analyticsData = {
                eventAction: "technical specs:filters:share",
                eventName: "technical specs:filters:share",
                internalLinkPosition: "tech specs",
                internalLinkType: "technical specs​:share",
                internalLinkZoneName: "technical specs:filters"
            };
        } else if (props.page === "search") {
            analyticsData = {
                eventAction: "search results:".concat(selectedTab, ":filters:share"),
                eventName: "search results:".concat(selectedTab, ":filters:share"),
                internalLinkPosition: "search results",
                internalLinkType: "search results:share",
                internalLinkZoneName: "search results:".concat(selectedTab, ":filters")
            };
        } else if (props.page === "literature") {
            analyticsData = {
                eventAction: "literature:filters:share",
                eventName: "literature:filters:share",
                internalLinkPosition: "literature",
                internalLinkType: "literature​:share",
                internalLinkZoneName: "literature:filters"
            };
        } else {
            analyticsData = {
                eventAction: "plp share",
                eventName: "plp share",
                internalLinkPosition: "plp",
                internalLinkType: "plp:share",
                internalLinkZoneName: "plp:filters​"
            };
        }
        return analyticsData;
    };
    const getShowHideFilterOptionAnalyticsData = (collapse, facet)=>{
        const isCollapseOrExpand = "".concat(collapse[facet[0]] ? "expand" : "collapse");
        let analyticsData = {
            eventAction: "plp filter ".concat(isCollapseOrExpand),
            eventName: "plp filter ".concat(isCollapseOrExpand),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(isCollapseOrExpand),
            internalLinkPosition: "plp",
            internalLinkType: "plp:" + formatFacetName(facet[0]),
            internalLinkZoneName: "plp:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        if (props.page === "technicalspecs" || props.page === "article") {
            const type = props.page === "technicalspecs" ? "technical specs" : "support:help and faq";
            analyticsData = {
                eventAction: "".concat(type, ":filters:").concat(!collapse[facet[0]] ? "expand" : "collapse"),
                eventName: "".concat(type, ":filters:").concat(!collapse[facet[0]] ? "expand" : "collapse"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: !collapse[facet[0]] ? "expand" : "collapse",
                internalLinkPosition: type,
                internalLinkType: type + ":" + formatFacetName(facet[0]),
                internalLinkZoneName: type + ":filters",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        if (props.page === "search") {
            const sectionTab = props.type || "products";
            analyticsData = {
                eventAction: "search results:".concat(sectionTab, ":filters ").concat(!collapse[facet[0]] ? "expand" : "collapse"),
                eventName: "search results:".concat(sectionTab, ":filters ").concat(!collapse[facet[0]] ? "expand" : "collapse"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: !collapse[facet[0]] ? "expand" : "collapse",
                internalLinkPosition: "search results",
                internalLinkType: "search results:" + formatFacetName(facet[0]),
                internalLinkZoneName: "search results:".concat(sectionTab, ":filters"),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        if (props.page === "literature") {
            analyticsData = {
                eventAction: "literature:filters:".concat(!collapse[facet[0]] ? "expand" : "collapse"),
                eventName: "literature:filters:".concat(!collapse[facet[0]] ? "expand" : "collapse"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: !collapse[facet[0]] ? "expand" : "collapse",
                internalLinkPosition: "literature",
                internalLinkType: "literature:" + formatFacetName(facet[0]),
                internalLinkZoneName: "literature:filters",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        return JSON.stringify(analyticsData);
    };
    const getFilterCloseAnalyticsData = ()=>{
        let analyticsData = "";
        if (props.page === "article") {
            analyticsData = '{"eventAction":"support:help and faq:filters​:close","eventName":"support:help and faq:filters​:close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close(x)","internalLinkPosition":"support:help and faq","internalLinkType":"support:help and faq:close","internalLinkZoneName":"support:help and faq:filters​","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        } else {
            analyticsData = '{"eventAction":"plp filter close","eventName":"plp filter close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close","internalLinkPosition":"plp","internalLinkType":"plp:close","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        }
        return analyticsData;
    };
    const getFilterViewResultsAnalyticsData = ()=>{
        let analyticsData = "";
        if (props.page === "article") {
            analyticsData = '{"eventAction":"support:help and faq:filters​:view results","eventName":"support:help and faq:filters​:view results","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view results","internalLinkPosition":"support:help and faq","internalLinkType":"support:help and faq:navigation","internalLinkZoneName":"support:help and faq:filters​","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        } else {
            analyticsData = '{"eventAction":"plp filter view result","eventName":"plp filter view result","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view result","internalLinkPosition":"plp","internalLinkType":"plp:filters","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true","filterArray":"' + getAppliedFiltersForAnalytics(appliedFilters) + '"}';
        }
        return analyticsData;
    };
    const getFilterClearAllAnalyticsData = ()=>{
        const sectionTab = props.type || "products";
        let analyticsData = {
            eventAction: "plp clear all filter",
            eventName: "plp clear all filter",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "clear all",
            internalLinkPosition: "plp",
            internalLinkType: "plp:clear all",
            internalLinkZoneName: "plp:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        if (props.page === "article") {
            analyticsData = {
                eventAction: "support:help and faq:filters​:clear all",
                eventName: "support:help and faq:filters​:clear all",
                eventType: "informative",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "clear all",
                internalLinkPosition: "support:help and faq",
                internalLinkType: "support:help and faq:navigation",
                internalLinkZoneName: "support:help and faq:filters​​",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        if (props.page === "search") {
            analyticsData = {
                clickInternalLinks: "true",
                eventAction: "search results:".concat(sectionTab, ":clear all"),
                eventName: "search results:".concat(sectionTab, ":clear all"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "clear all",
                internalLinkPosition: "search results",
                internalLinkType: "search results:clear all",
                internalLinkURL: "n/a",
                internalLinkZoneName: "search results:".concat(sectionTab, ":filters")
            };
        }
        if (props.page === "technicalspecs") {
            analyticsData = {
                eventAction: "technical specs:filters:clear all​",
                eventName: "technical specs:filters:clear all​",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "clear all",
                internalLinkPosition: "technical specs",
                internalLinkType: "technical specs:clear all",
                internalLinkZoneName: "technical specs:filters",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        if (props.page === "literature") {
            analyticsData = {
                eventAction: "literature:filters:clear all​",
                eventName: "literature:filters:clear all​",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "clear all",
                internalLinkPosition: "literature",
                internalLinkType: "literature:clear all",
                internalLinkZoneName: "literature:filters",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        return JSON.stringify(analyticsData);
    };
    const getEventInfo = (value, appliedFilters, facet, filter)=>{
        let filterArrayList = getAppliedFiltersForPlpAnalyticsData(appliedFilters, facet.facet, filter);
        let type = "plp filter ";
        let internalLinkPosition = "plp";
        let internalValue = "plp";
        let internalLinkName = filter;
        if (props.page === "article") {
            type = "support:help and faq:filters:";
            internalLinkPosition = "support:help and faq";
            internalValue = "support:help and faq";
            internalLinkName = "".concat(filter, ":removed");
        } else if (props.page === "search") {
            type = "search results:".concat(selectedTab, ":filters ");
            internalLinkPosition = "search results";
            internalValue = "search results:".concat(selectedTab);
        } else if (props.page === "technicalspecs") {
            type = "technical specs:filters​:";
            internalLinkName = "".concat(filter, ":").concat(value);
            internalLinkPosition = "technical specs";
            internalValue = "technical specs";
        } else if (props.page === "literature") {
            type = "literature:filters​​:";
            internalLinkName = "".concat(filter, ":").concat(value);
            internalLinkPosition = "literature";
            internalValue = "literature";
        }
        return JSON.stringify({
            eventAction: "".concat(type).concat(value),
            eventName: "".concat(type).concat(value),
            eventType: "navigation",
            filterArray: filterArrayList,
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition,
            internalLinkType: "".concat(internalValue, ":").concat(formatFacetName(facet["facet"])),
            internalLinkZoneName: "".concat(internalValue, ":filters"),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        });
    };
    const printPlp = ()=>{
        (0,react_lazyload_lib/* forceVisible */.Iq)();
        setTimeout(()=>{
            window.print();
        }, 1250);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("filter", !showMore && "filter--show-less"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "filter__inner-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-list__controls filter__mobile-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-list__filter-toggle gbh-data-layer",
                                "data-gbh-data-layer": getFilterCloseAnalyticsData(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                        className: "product-list__filter-toggle-icon",
                                        alt: "Toggle Filter"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            props.texts.filterSort,
                                            " ",
                                            props.selectedFilterCount > 0 && " (".concat(props.selectedFilterCount, ")")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                tabIndex: "0",
                                role: "button",
                                src: close_filter/* default */.Z === null || close_filter/* default */.Z === void 0 ? void 0 : close_filter/* default.src */.Z.src,
                                className: "product-list__close-icon gbh-data-layer",
                                "data-gbh-data-layer": '{"eventAction":"plp filter close","eventName":"plp filter close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close","internalLinkPosition":"close","internalLinkType":"plp:close","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                alt: "Close Filter",
                                onClick: ()=>props.close(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__chips",
                        children: [
                            appliedFilters.map((facet)=>{
                                return facet.display.map((filter)=>{
                                    !testPageQueryparam.includes(facet["facet"]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "filter__chips-tag",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    filterKeyValueParam.includes(filter) ? formatFacetName(facet["facet"], filter) : filter
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: close_filter/* default */.Z === null || close_filter/* default */.Z === void 0 ? void 0 : close_filter/* default.src */.Z.src,
                                                tabIndex: "0",
                                                role: "button",
                                                "aria-label": "Remove filter ".concat(filterKeyValueParam.includes(filter) ? formatFacetName(facet["facet"], filter) : filter),
                                                className: "filter__chips-close-icon gbh-data-layer",
                                                onClick: ()=>handleFilter(false, {
                                                        facet: facet.facet,
                                                        display: filter
                                                    }, [
                                                        facet.facet,
                                                        filter
                                                    ], appliedFilters),
                                                "data-gbh-data-layer": getEventInfo("cancel", appliedFilters, facet, filter)
                                            })
                                        ]
                                    }, filter);
                                });
                            }),
                            appliedFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "filter__chips-clear-all gbh-data-layer",
                                tabIndex: "0",
                                role: "button",
                                "aria-label": "".concat(props.texts.clearAll, " ").concat(props.texts.filters),
                                "data-gbh-data-layer": getFilterClearAllAnalyticsData(),
                                onClick: clearAllFilters,
                                children: props.texts.clearAll
                            })
                        ]
                    }),
                    showSort && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "filter__mobile-sort",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            role: "radiogroup",
                            "aria-labelledby": "sortBy-radio",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    id: "sortBy-radio",
                                    className: "filter__mobile-sort-title",
                                    "aria-label": selectedSort ? "".concat(selectedSort.name, " ").concat(texts.selected) : texts.sortByAria,
                                    children: "".concat(texts.sort, " ").concat(selectedSort ? ": " + selectedSort.name : "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "radio-wrapper",
                                    ref: sortBy,
                                    children: sort.map((item, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                            id: "sort-by-".concat(item.name),
                                            name: "sort-by",
                                            value: item.name,
                                            checked: item.name === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name),
                                            onClick: ()=>onSortChange(item)
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: filterFacets,
                        role: "list",
                        children: facets.map((facet)=>{
                            let facetName = formatFacetName(facet[0]);
                            let facetCount = facet[1].length / 2;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "collapsible-outer",
                                role: "listitem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* default */.Z, {
                                    tabIndex: "0",
                                    open: Boolean(collapse[facet[0]]),
                                    onTriggerOpening: ()=>handleCollapse(facet[0], true),
                                    onTriggerClosing: ()=>handleCollapse(facet[0], false),
                                    openedClassName: "is-open",
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        // aria-label={props.t("kf.plp.ariaLabel.filterTitle", {facetName, facetCount})}
                                        "aria-expanded": collapse[facet[0]] ? true : false,
                                        className: "gbh-data-layer",
                                        "data-gbh-data-layer": getShowHideFilterOptionAnalyticsData(collapse, facet),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: facetName
                                            }),
                                            " ",
                                            plus
                                        ]
                                    }),
                                    transitionTime: 400,
                                    easing: "ease-in-out",
                                    children: collapse[facet[0]] && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            role: "list",
                                            className: "filter-list",
                                            children: facet[1].map((filter, i, arr)=>{
                                                if (i % 2 === 0) {
                                                    let displayText = null;
                                                    if (facet[0] === "Price_Range") {
                                                        displayText = formatPriceRange(filter);
                                                    }
                                                    let obj = {
                                                        facet: facet[0],
                                                        value: filter,
                                                        display: displayText !== null && displayText !== void 0 ? displayText : filter
                                                    };
                                                    return arr[i + 1] !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        role: "listitem",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            role: "checkbox",
                                                            "aria-checked": "false",
                                                            id: facet[0] + filter,
                                                            disabled: props.loading,
                                                            checkBoxAria: "".concat(obj.display, " (").concat(arr[i + 1], ") Selecting this checkbox will update the ").concat(obj.display, " ").concat(facetName, " products"),
                                                            tabIndex: collapse[facet[0]] ? 0 : -1,
                                                            value: "".concat(obj.display, " (").concat(arr[i + 1], ")"),
                                                            onChange: (e)=>handleFilter(e.target.checked, obj, facet, appliedFilters),
                                                            checked: isSelected(obj),
                                                            swatch: facet[0] === "ColorFinish_s" || facet[0] === "Color.Finish" || facet[0] === "Color" || facet[0] === "Finish" ? props.colors[filter] : null
                                                        }, filter)
                                                    }, i) : null;
                                                }
                                            })
                                        })
                                    })
                                })
                            }, facet[0]);
                        })
                    }),
                    (facets === null || facets === void 0 ? void 0 : facets.length) > 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "filter__show-more gbh-data-layer",
                        "aria-expanded": showMore,
                        "data-gbh-data-layer": getShowMoreAnalyticsData(!showMore),
                        onClick: handleShowMore,
                        children: showMore ? props.texts.showLess : props.texts.showMore
                    }) : "",
                    props.discontinuedCheck && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "filter__hide-discontinued",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                id: "discontinued",
                                onChange: (e)=>handleFilter(e.target.checked, {
                                        facet: "Hide_Discontinued",
                                        value: "true",
                                        display: props.texts.discontinuedText
                                    }),
                                checked: isSelected({
                                    facet: "Hide_Discontinued",
                                    value: "true",
                                    display: props.texts.discontinuedText
                                }),
                                value: props.texts.hideDiscontinued,
                                analyticsData: getAnalyticsData(isSelected({
                                    facet: "Hide_Discontinued",
                                    value: "true",
                                    display: props.texts.discontinuedText
                                }))
                            })
                        })
                    }),
                    props.page !== "article" && Boolean(props.isCurated) && (props.buyingGuideDescription || props.buyingGuideLink || props.buyingGuideFieldLabel) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__buying-guide d-none d-sm-none d-md-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: (0,friendsAndFamilyHelper/* entityToCharacter */.F)(props.buyingGuideDescription)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (0,helper/* getShortenedUrl */.Ppy)(props.buyingGuideLink),
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": '{"eventAction":"plp see the buying guide link","eventName":"plp see the buying guide link","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"see the buying guide","internalLinkPosition":"plp","internalLinkType":"plp:informative","internalLinkZoneName":"plp:filters","internalLinkURL":"' + props.buyingGuideLink + '","clickInternalLinks":"true"}',
                                target: props.newTab && "_blank",
                                children: props.buyingGuideFieldLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__print-and-share",
                        role: "list",
                        children: [
                            (props.displayPrint !== undefined ? props.displayPrint : true) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                tabIndex: "0",
                                role: "button",
                                "aria-label": props.texts.print,
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": getPrintOrShareEventInfo("print"),
                                onClick: ()=>printPlp(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: print/* default */.Z === null || print/* default */.Z === void 0 ? void 0 : print/* default.src */.Z.src,
                                        alt: "",
                                        role: "presentation"
                                    }),
                                    props.texts.print
                                ]
                            }),
                            (props.displayShare !== undefined ? props.displayShare : true) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                tabIndex: "0",
                                role: "button",
                                "aria-label": props.texts.share,
                                "aria-expanded": showSocialLink ? "true" : "false",
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": getPrintOrShareEventInfo("share"),
                                onClick: ()=>setShowSocialLink(!showSocialLink),
                                ref: shareImg,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: share/* default */.Z === null || share/* default */.Z === void 0 ? void 0 : share/* default.src */.Z.src,
                                        alt: "",
                                        role: "presentation"
                                    }),
                                    props.texts.share
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SocialShare/* default */.Z, {
                        showModal: showSocialLink,
                        id: "kf-plp-filter",
                        onClose: ()=>{
                            setShowSocialLink(false);
                            shareImg === null || shareImg === void 0 ? void 0 : shareImg.current.focus();
                        },
                        shareBtn: shareImg,
                        url: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.origin) + (window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.pathname),
                        analyticData: getSocialShareAnalyticsData(),
                        productName: props === null || props === void 0 ? void 0 : props.category
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "filter__buying-guide d-block d-sm-block d-md-none",
                children: [
                    Boolean(props.buyingGuideFieldLabel) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: props.buyingGuideDescription
                    }),
                    Boolean(props.buyingGuideDescription) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: (0,helper/* getShortenedUrl */.Ppy)(props.buyingGuideLink),
                        className: "gbh-data-layer",
                        "data-gbh-data-layer": '{"eventAction":"plp see the buying guide link","eventName":"plp see the buying guide link","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"see the buying guide","internalLinkPosition":"plp","internalLinkType":"plp:informative","internalLinkZoneName":"plp:filters","internalLinkURL":"' + props.buyingGuideLink + '","clickInternalLinks":"true"}',
                        target: props.newTab && "_blank",
                        children: props.buyingGuideFieldLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "filter__footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: classnames_default()("filter__apply gbh-data-layer"),
                    "data-gbh-data-layer": getFilterViewResultsAnalyticsData(),
                    onClick: ()=>props.close(false),
                    children: [
                        props.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "filter__apply-loader"
                        }),
                        "".concat(props.texts.view, " ").concat(props.texts.results, " (").concat(props.totalResults, ")")
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var v1_Filter = ((0,dist_es/* withTranslation */.Zh)()(Filter));

// EXTERNAL MODULE: ./components/core/Checkbox/index.module.scss
var Checkbox_index_module = __webpack_require__(43090);
var Checkbox_index_module_default = /*#__PURE__*/__webpack_require__.n(Checkbox_index_module);
// EXTERNAL MODULE: ./public/icons/checkbox-tick.svg
var checkbox_tick = __webpack_require__(78987);
;// CONCATENATED MODULE: ./components/core/Checkbox/index.jsx







const Checkbox_Checkbox = (props)=>{
    const [config, setConfig] = (0,react.useState)({});
    const { textClassName ="checkbox_default" , inline =false  } = props;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setConfig(config === null || config === void 0 ? void 0 : config.general);
        }).catch((err)=>console.log(err));
    }, []);
    const handleCheck = (e)=>{
        e.target.checked = !props.checked;
        if (e.keyCode === 32 || e.keyCode === 13) props.onChange(e);
    };
    var _tabIndex, _role, _checkBoxAria;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Checkbox_index_module_default()).checkboxWrapper).concat(inline ? " ".concat((Checkbox_index_module_default()).inlineCheckbox) : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            htmlFor: props.id,
            "aria-checked": props.checked,
            tabIndex: (_tabIndex = props.tabIndex) !== null && _tabIndex !== void 0 ? _tabIndex : 0,
            role: (_role = props.role) !== null && _role !== void 0 ? _role : "checkbox",
            "aria-label": (_checkBoxAria = props.checkBoxAria) !== null && _checkBoxAria !== void 0 ? _checkBoxAria : props.aria,
            className: classnames_default()({
                checkbox: true,
                "checkbox--swatch": props.swatch,
                "checkbox--black": props.type === "black"
            }),
            onKeyDown: handleCheck,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    "data-gbh-data-layer": props.analyticsData || null,
                    "data-gbh-data-layer-custom": props.analyticsDataCustom || null,
                    className: props.analyticsData ? "gbh-data-layer" : "",
                    type: "checkbox",
                    name: props.id,
                    id: props.id,
                    onChange: (e)=>props.onChange(e),
                    checked: props.checked,
                    disabled: props.disabled
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "checkbox__border",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "checkbox__marker",
                        children: (checkbox_tick/* default */.Z === null || checkbox_tick/* default */.Z === void 0 ? void 0 : checkbox_tick/* default.src */.Z.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "checkbox__marker-icon",
                            src: checkbox_tick/* default.src */.Z.src,
                            alt: ""
                        }) : null
                    })
                }),
                (config === null || config === void 0 ? void 0 : config.swatchUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "checkbox__swatch",
                    style: {
                        backgroundImage: 'url("'.concat(config === null || config === void 0 ? void 0 : config.swatchUrl).concat(props === null || props === void 0 ? void 0 : props.swatch, '?$PLPSwatch_Mobile50$")')
                    }
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: textClassName,
                    "aria-hidden": "true",
                    children: props.value
                })
            ]
        })
    });
};
/* harmony default export */ var core_Checkbox = (Checkbox_Checkbox);
Checkbox_Checkbox.protoTypes = {
    textClassName: (prop_types_default()).string,
    checked: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    tabIndex: (prop_types_default()).number,
    role: (prop_types_default()).string,
    checkBoxAria: (prop_types_default()).string,
    aria: (prop_types_default()).string,
    swatch: (prop_types_default()).string,
    type: (prop_types_default()).string,
    analyticsData: (prop_types_default()).object,
    analyticsDataCustom: (prop_types_default()).object,
    disabled: (prop_types_default()).bool,
    value: (prop_types_default()).bool,
    onChange: (prop_types_default()).func
};

// EXTERNAL MODULE: ./src/components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(45138);
// EXTERNAL MODULE: ./public/images/swatch-missing.jpeg
var swatch_missing = __webpack_require__(36562);
// EXTERNAL MODULE: ./public/icons/wish.svg
var wish = __webpack_require__(29875);
// EXTERNAL MODULE: ./public/icons/wishlist-gray-filled.svg
var wishlist_gray_filled = __webpack_require__(62084);
// EXTERNAL MODULE: ./store/features/asPdpSlice.js
var asPdpSlice = __webpack_require__(53367);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
;// CONCATENATED MODULE: ./components/ProductTile/v3/index.jsx




























const ProductTile = (props)=>{
    var ref, ref1, ref2, ref3;
    const { data , texts , lite , loading , addToCompare , removeFromCompare , highlightText ="" , hideCompare , currencySign , isGrouped , rowCols , presetConfigs ="{}" , isPartsDiagramLinkVisible =false , categoryData =[] , saleInfo  } = props;
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [showShare, setShowShare] = (0,react.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react.useState)("");
    const [onHover, setOnHover] = (0,react.useState)(false);
    const [hoverColor, setHoverColor] = (0,react.useState)("");
    var ref4;
    const sku = (ref4 = data["sku_s"]) !== null && ref4 !== void 0 ? ref4 : data["masterSKU_s"];
    const productCategory = get_default()(data, "Product_Category", "");
    const noBadge = get_default()(data, "noBadge_b", false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const persona = (0,helper/* getUserPersona */.shu)();
    var _swatchCount;
    const colorCount = (_swatchCount = props.swatchCount) !== null && _swatchCount !== void 0 ? _swatchCount : 7;
    const [width] = (0,useWindowResize/* default */.Z)();
    const cartData = (0,es/* useSelector */.v9)((state)=>state.cart.data);
    const [selectedColor, setSelectedColor] = (0,react.useState)({});
    const [priceTag, setPriceTag] = (0,react.useState)("");
    const [general, setGeneral] = (0,react.useState)();
    const [tileUrl, setTileUrl] = (0,react.useState)();
    const [swatchUrl, setSwatchUrl] = (0,react.useState)("");
    const { general: { lwAppName =""  } = {}  } = (0,constants_config/* getConfig */.i)() || {};
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [showSaleBadge, setShowSaleBadge] = (0,react.useState)(false);
    const { isAuth , access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { toaster ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { comparedProducts , category: compareCategory , isEnable , compareSectionData  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const [badgeTxt, setBadgeTxt] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (saleInfo) {
            let firstColorBadgeVal = getFirstColorBadgeVal();
            if (firstColorBadgeVal) {
                selSku = firstColorBadgeVal === null || firstColorBadgeVal === void 0 ? void 0 : firstColorBadgeVal.split("|")[0];
                firstSwatchColor = firstColorBadgeVal === null || firstColorBadgeVal === void 0 ? void 0 : firstColorBadgeVal.split("|")[0];
            }
        }
        badgeUpdate(selSku);
    }, [
        saleInfo
    ]);
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general  } = await (0,constants_config/* getConfig */.i)();
            const { swatchUrl =""  } = general !== null && general !== void 0 ? general : {};
            const finalSwatchUrl = (swatchUrl === null || swatchUrl === void 0 ? void 0 : swatchUrl.toString().includes("PAWEB")) ? swatchUrl.replace("PAWEB", general === null || general === void 0 ? void 0 : general.scene7AccountName) : swatchUrl;
            setGeneral(general);
            setSwatchUrl(finalSwatchUrl);
        };
        configFn();
    }, []);
    const badgeUpdate = function(skuParam) {
        if (saleInfo && (saleInfo === null || saleInfo === void 0 ? void 0 : saleInfo.length) > 0) {
            const selectedSkuSaleDetails = saleInfo === null || saleInfo === void 0 ? void 0 : saleInfo.find((saleDetail)=>{
                return (saleDetail === null || saleDetail === void 0 ? void 0 : saleDetail.split("|")[0]) === skuParam;
            });
            setShowSaleBadge((selectedSkuSaleDetails === null || selectedSkuSaleDetails === void 0 ? void 0 : selectedSkuSaleDetails.split("|")[1]) === "Yes");
        } else {
            setShowSaleBadge(false);
        }
    };
    const handleFavorite = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.preActiveElement = e.target;
        if (isFavorite === true) {
            var ref;
            (ref = props.favorites) === null || ref === void 0 ? void 0 : ref.map((fav)=>{
                if (fav.productId === data["ctId_s"]) {
                    if (!isAuth) {
                        handleLogin(e);
                    } else {
                        dispatch((0,favoritesSlice/* removeItems */.Er)({
                            ids: [
                                fav.id
                            ],
                            isDataLayerNeeded: false
                        })).unwrap().then(()=>{
                            var ref;
                            handleCallBack("success", texts.removeItem);
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: (0,helper/* getShortenedUrlwithGeneral */.vu1)((toaster === null || toaster === void 0 ? void 0 : (ref = toaster.content) === null || ref === void 0 ? void 0 : ref.unfavoriteSuccessMessage) || constants.REMOVE_FROM_FAVORITES_MSG, general) || texts.removeItem,
                                isVisible: true
                            }));
                        }).catch((err)=>{
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: texts.removeItemError,
                                isVisible: true
                            }));
                            handleCallBack("failure", texts.removeItemError);
                        });
                    }
                }
            });
        } else {
            if (!isAuth) {
                handleLogin(e);
            } else {
                dispatch((0,favoritesSlice/* addProduct */.gK)(sku)).unwrap().then(()=>{
                    var ref;
                    handleCallBack("success", texts.favSuccessMsg);
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: (0,helper/* getShortenedUrlwithGeneral */.vu1)((toaster === null || toaster === void 0 ? void 0 : (ref = toaster.content) === null || ref === void 0 ? void 0 : ref.successMessage) || constants.ADD_TO_FAVORITES_MSG, general) || texts.favSuccessMsg,
                        isVisible: true
                    }));
                }).catch((err)=>{
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: texts.favErrorMsg,
                        isVisible: true
                    }));
                    handleCallBack("failure", texts.favErrorMsg);
                });
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            handleFavorite(loginFavouriteCallback);
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    //check for product image
    let images = [];
    let productVariantImages = data["productImages.labelWithUrl_ss"];
    let setDefaultProductImage = "";
    let setHoverProductImage = "";
    const isSample = productCategory.toLowerCase() === "samples";
    if ((productVariantImages === null || productVariantImages === void 0 ? void 0 : productVariantImages.length) > 0) {
        let variantImages = productVariantImages.filter((img)=>sku === img.split("|")[0]);
        if (props.plpPage) {
            variantImages.find((img)=>{
                let imgDetails = img.split("|");
                if (imgDetails[2] === props.defaultImage) return setDefaultProductImage = imgDetails[1];
                else setDefaultProductImage = variantImages[0].split("|")[1];
            });
            productVariantImages.find((img)=>{
                let imgDetails = img.split("|");
                if (imgDetails[2] === props.hoverImage) return setHoverProductImage = imgDetails[1];
            });
        } else {
            productVariantImages.find((img)=>{
                let imgDetails = img.split("|");
                if (sku === imgDetails[0]) return setDefaultProductImage = imgDetails[1];
            });
        }
        images.push(setDefaultProductImage);
        if (props.plpPage) {
            if (setHoverProductImage !== "") {
                images.push(setHoverProductImage);
            }
        }
    } else {
        images = [
            "MissingImage"
        ];
    }
    // get variant image if color filters are applied
    let selColor = "";
    let variantPrice = 0;
    let variantDiscPrice = 0;
    if (props.mapImageToColor && props.currFilters) {
        const colorFilter = props.currFilters.find((q)=>q.facet === "Color.Finish" || q.facet === "Color" || q.facet === "Finish");
        const selColors = colorFilter === null || colorFilter === void 0 ? void 0 : colorFilter.value;
        if ((selColors === null || selColors === void 0 ? void 0 : selColors.length) > 0) {
            let selectedProductImage = "";
            var ref5;
            let i = (ref5 = (selColors === null || selColors === void 0 ? void 0 : selColors.length) - 1) !== null && ref5 !== void 0 ? ref5 : 0;
            while(!selectedProductImage && i >= 0){
                const colorName = selColors[i];
                if (data["Color.".concat(persona, ".Details_ss")]) {
                    var ref6, ref7;
                    var ref8;
                    const exactSKUDetails = (ref8 = (ref6 = data["Color.".concat(persona, ".Details_ss")].find((item)=>item.split("|")[1] === colorName)) === null || ref6 === void 0 ? void 0 : ref6.split("|")) !== null && ref8 !== void 0 ? ref8 : [];
                    selColor = selColors[i];
                    var ref9;
                    const productId = (ref9 = (ref7 = exactSKUDetails[5]) === null || ref7 === void 0 ? void 0 : ref7.split("?")[0].split("/").slice(-1)) !== null && ref9 !== void 0 ? ref9 : [];
                    var ref10;
                    selectedProductImage = (ref10 = productId[0]) !== null && ref10 !== void 0 ? ref10 : "";
                    var ref11;
                    variantPrice = (ref11 = exactSKUDetails[2]) !== null && ref11 !== void 0 ? ref11 : 0;
                    var ref12;
                    variantDiscPrice = (ref12 = exactSKUDetails[3]) !== null && ref12 !== void 0 ? ref12 : 0;
                }
                i--;
            }
            // Check this Line for AS-12309
            if (!selectedProductImage) selectedProductImage = "MissingImage";
            if (images[0] === images[1]) {
                images = [
                    selectedProductImage
                ];
            } else {
                images[0] = selectedProductImage;
            }
        }
    }
    let colors = [];
    if (data["Color.SKU.Details_ss"]) {
        colors = data["Color.SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                name: d[0],
                swatch: d[1],
                sku: d[2],
                isStock: d[3],
                isDiscontinued: d[4],
                customerFacingSKU: d[5] ? d[5] : d[2]
            };
        });
    }
    let selSku = "";
    let firstSwatchColor = "";
    const getFirstColorBadgeVal = ()=>{
        const saleBadgeRecord = saleInfo === null || saleInfo === void 0 ? void 0 : saleInfo.find((saleDetail)=>{
            return (saleDetail === null || saleDetail === void 0 ? void 0 : saleDetail.split("|")[1]) === "Yes";
        });
        return saleBadgeRecord;
    };
    if (props.mapImageToColor && selColor) {
        var ref13;
        var ref14;
        selSku = (ref14 = (ref13 = colors.find((item)=>item.name === selColor)) === null || ref13 === void 0 ? void 0 : ref13.sku) !== null && ref14 !== void 0 ? ref14 : "";
    } else {
        selSku = sku;
        firstSwatchColor = sku;
    }
    if (hoverColor) {
        var ref15, ref16, ref17, ref18, ref19;
        selSku = hoverColor;
        var ref20;
        const skuDetails = (ref20 = (ref16 = (ref15 = data["Color.".concat(persona, ".Details_ss")]) === null || ref15 === void 0 ? void 0 : ref15.find((item)=>{
            return item.split("|")[0] === (selSku === null || selSku === void 0 ? void 0 : selSku.sku);
        })) === null || ref16 === void 0 ? void 0 : ref16.split("|")) !== null && ref20 !== void 0 ? ref20 : [];
        var ref21;
        const skuDetailsImage = (ref21 = (ref18 = (ref17 = data["productImages.labelWithUrl_ss"]) === null || ref17 === void 0 ? void 0 : ref17.find((item)=>{
            return item.split("|")[0] === (selSku === null || selSku === void 0 ? void 0 : selSku.sku);
        })) === null || ref18 === void 0 ? void 0 : ref18.split("|")) !== null && ref21 !== void 0 ? ref21 : [];
        var ref22;
        const productId1 = (ref22 = (ref19 = skuDetailsImage[5]) === null || ref19 === void 0 ? void 0 : ref19.split("?")[0].split("/").slice(-1)) !== null && ref22 !== void 0 ? ref22 : [];
        var ref23;
        const selProdImage = (ref23 = productId1[0]) !== null && ref23 !== void 0 ? ref23 : "MissingImage";
        if (images[0] === images[1]) {
            images = [
                selProdImage
            ];
        } else {
            images[0] = selProdImage;
        }
        var ref24;
        variantPrice = (ref24 = skuDetails[2]) !== null && ref24 !== void 0 ? ref24 : 0;
        var ref25;
        variantDiscPrice = (ref25 = skuDetails[3]) !== null && ref25 !== void 0 ? ref25 : 0;
    }
    let InstallationWithoutSPPDFResource = data["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"];
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
    }, []);
    (0,react.useEffect)(()=>{
        const compareSku = selSku !== "" && (typeof selSku === "string" ? selSku : selSku === null || selSku === void 0 ? void 0 : selSku.sku);
        if (comparedProducts === null || comparedProducts === void 0 ? void 0 : comparedProducts.find((prod)=>prod.compareSku === compareSku)) setIsChecked(true);
        else setIsChecked(false);
    }, [
        comparedProducts,
        data
    ]);
    colors = colors.filter((item)=>item.isDiscontinued === "false" || Date.parse(item.isDiscontinued) > Date.now());
    let title = "";
    if (data["productName_s"]) {
        title = data["productName_s"];
    }
    const getDesignByTitle = ()=>{
        let productDesignerS = data["ProductDesigner_s"], productDesignerByText = "";
        if (productDesignerS && title.toLowerCase().indexOf(productDesignerS.toLowerCase()) === -1) {
            var ref;
            productDesignerByText = productDesignerS ? (props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.by) + " " + productDesignerS : "";
        }
        return productDesignerByText;
    };
    const getProductName = function() {
        let isFavPage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        // Used different fl for fetching the product names because for plp and favorite pages,
        // different api is being called i.e. for plp search/plp and for favorites search/full-catalog
        let productName;
        if (isFavPage) {
            productName = isGrouped ? get_default()(data, "Collapse_Title_s", "") : props.type === "parts" ? get_default()(data, "productName_s", "") : get_default()(data, "RegionBrandName_s", "") || get_default()(data, "Product_Title_s", "");
        } else {
            productName = isGrouped ? get_default()(data, "Collapse_Title_s", "") : props.type === "parts" ? get_default()(data, "productName_s", "") : get_default()(data, "productName_s", "") + getDesignByTitle();
        }
        return productName;
    };
    (0,react.useEffect)(()=>{
        setHoverColor("");
        setSelectedColor("");
    }, [
        props.currFilters,
        props.selectedSort
    ]);
    const tileTitle = get_default()(data, "Tile_Title", "");
    const productName = getProductName(props === null || props === void 0 ? void 0 : props.favPage);
    const description = isGrouped ? get_default()(data, "Collapse_Description_s", "") : get_default()(data, "ProductDescriptionProductShort_s", "");
    var _ProductLocalCategory_s;
    const category = data.Product_Category ? data.Product_Category : (_ProductLocalCategory_s = data.ProductLocalCategory_s) !== null && _ProductLocalCategory_s !== void 0 ? _ProductLocalCategory_s : "";
    const shipmentDate = get_default()(data, "RegionLaunchDate_dt", "");
    const isNewProduct = (0,helper/* showNewBadge */.ZTk)(shipmentDate);
    const badgeVal = get_default()(data, "priceList.".concat(persona, ".saleOffer_s"), "");
    let discountedPrice = get_default()(data, "priceList.".concat(persona, ".finalPrice_d"), 0);
    let finalPrice = get_default()(data, "priceList.".concat(persona, ".price_d"), 0);
    const price = get_default()(data, "priceStartingAt.".concat(persona, "_d"), 0);
    const exclusiveBadge = get_default()(data, "ProductExclusive_s", "");
    const isFavorite = ((ref = props.favorites) === null || ref === void 0 ? void 0 : ref.find((vl)=>vl.productId === data["ctId_s"])) ? true : false;
    const isDiscountedPrice = get_default()(data, "priceList.".concat(persona, ".discountedPrice_d"), 0);
    const detaultSelectedColor = colors.length ? (ref1 = colors[0]) === null || ref1 === void 0 ? void 0 : ref1.name : "";
    const defaultCustomerFacingSku = colors.length ? (ref2 = colors[0]) === null || ref2 === void 0 ? void 0 : ref2.customerFacingSKU : "";
    const defaultImage = images.length ? images[0] : "";
    const defaultProductIsInStock = colors.length ? colors[0].isStock === "true" || colors[0].isStock === true : false;
    const discountPercent = badgeVal && isDiscountedPrice ? 100 - Math.round(isDiscountedPrice / price * 100) : 0;
    const discountPriceState = badgeVal && isDiscountedPrice ? "percentOff|" + discountPercent : "regular price";
    const productIsRetail = get_default()(data, "ProductIsRetail", "") === "true" ? true : false;
    const isSuperSku = get_default()(data, "comboSKUAvailable_b", null) ? true : false;
    const discountAmount = discountPercent ? Number((price - isDiscountedPrice).toFixed(2)) : 0;
    const productSaleable = productIsRetail || !colors.length ? false : true;
    const productRoom = get_default()(data, "category1_s", "n/a");
    const productCollectionsName = get_default()(data, "ProductBrandNameDisplay_s", "n/a");
    const CharacteristicDescription = get_default()(data, "ItemCharacteristic.TYPE.CharacteristicDescriptionUpperCase_s", "");
    const RegionUOM = get_default()(data, "RegionAltUOM_s", "");
    let maxPrice = 0;
    let discountedMaxPrice = 0;
    if (isGrouped) {
        finalPrice = get_default()(data, "priceStartingAt.".concat(persona, "_d"), 0);
        maxPrice = get_default()(data, "max_price", 0);
        discountedPrice = get_default()(data, "discountedPriceStartingAt.".concat(persona, "_d"), 0);
        discountedMaxPrice = get_default()(data, "disc_max_price", 0);
    } else if (props.mapImageToColor && (selColor || hoverColor) && variantPrice > 0) {
        finalPrice = variantPrice;
        discountedPrice = variantDiscPrice;
    } else if (props.exactSKU) {
        const exactSKUDetails1 = data["Color.".concat(persona, ".Details_ss")] ? data["Color.".concat(persona, ".Details_ss")].find((item)=>item.split("|")[0] === sku).split("|") : [];
        var ref26;
        finalPrice = (ref26 = exactSKUDetails1[2]) !== null && ref26 !== void 0 ? ref26 : 0;
        var ref27;
        discountedPrice = (ref27 = exactSKUDetails1[3]) !== null && ref27 !== void 0 ? ref27 : 0;
    }
    const getTempType = function() {
        let str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return (0,helper/* getUnitType */.rYX)(str, texts, CharacteristicDescription);
    };
    (0,react.useEffect)(()=>{
        setPriceTag(getTempType(RegionUOM));
    });
    (0,react.useEffect)(()=>{
        let badgeList = [];
        if (showSaleBadge) badgeList.push(texts.sale);
        if (isNewProduct) badgeList.push(texts.new);
        if (exclusiveBadge && exclusiveBadge !== "") badgeList.push(texts.exclusive);
        setBadgeTxt(badgeList.join(" & "));
    }, [
        showSaleBadge
    ]);
    (0,react.useEffect)(()=>{
        const getPDPUrlFn = async ()=>{
            const tileUrlVal = await (0,helper/* getPDPUrl */.ir5)(category, data.slug_s);
            setTileUrl(tileUrlVal);
        };
        getPDPUrlFn();
    }, [
        data.slug_s
    ]);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-tile--loading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-image shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-title shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-description shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "loading-swatch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    })
                ]
            })
        ]
    });
    const colorSwatchDefaultImg = (e)=>{
        e.target.src = swatch_missing/* default */.Z === null || swatch_missing/* default */.Z === void 0 ? void 0 : swatch_missing/* default.src */.Z.src;
    };
    const hasCompareCategoryData = Array.isArray(categoryData) && categoryData.length > 0;
    const isCategoryMatchWithCompareJSON = categoryData === null || categoryData === void 0 ? void 0 : categoryData.some((item)=>{
        return (item === null || item === void 0 ? void 0 : item.category) === productCategory;
    });
    const handleCompare = (event, sku)=>{
        var ref, ref1, ref2;
        setIsChecked(!isChecked);
        if (event.target.checked) {
            if (comparedProducts.length < 4) {
                let variantFlag = false;
                const allVariantSkus = comparedProducts === null || comparedProducts === void 0 ? void 0 : comparedProducts.map((a)=>{
                    const variantSkus = a["variantList.sku_ss"] || [];
                    return [
                        ...variantSkus,
                        a.masterSKU_s || a.sku_s
                    ].filter(Boolean);
                }).flat();
                if (allVariantSkus === null || allVariantSkus === void 0 ? void 0 : allVariantSkus.includes(sku)) {
                    variantFlag = true;
                }
                if (hasCompareCategoryData && !isCategoryMatchWithCompareJSON) {
                    setErrorMessage(texts === null || texts === void 0 ? void 0 : texts.sameVariants);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    setIsChecked(false);
                    removeFromCompare(sku);
                } else if (compareCategory !== "" && compareCategory !== productCategory) {
                    setErrorMessage(texts.sameCategory);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    setIsChecked(false);
                    removeFromCompare(sku);
                } else if (variantFlag) {
                    setErrorMessage(texts === null || texts === void 0 ? void 0 : texts.sameVariants);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    setIsChecked(false);
                    removeFromCompare(sku);
                } else {
                    addToCompare(sku, data, general.lwAppName, persona, compareSectionData);
                }
            } else {
                setErrorMessage(texts.maxProduct);
                setTimeout(()=>{
                    setErrorMessage("");
                }, 2000);
                setIsChecked(false);
                removeFromCompare(sku);
            }
        } else {
            removeFromCompare(sku);
        }
        const eventInfo = JSON.parse(getEventInfo("compare"));
        const productInfo = (ref = JSON.parse(getProductInfo())) === null || ref === void 0 ? void 0 : ref.productInfo;
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page: window === null || window === void 0 ? void 0 : (ref1 = window.adobeDataLayer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getState) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, "page"),
            productInfo
        });
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const handleCallBack = (status, message)=>{
        var ref;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        let isForSample = false;
        if (page && (page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategory1)) {
            const { category: { subCategory1  }  } = page;
            isForSample = subCategory1.includes("samples");
        }
        const eventInfo = getEventInfo("favorite", null, true, isForSample);
        const productInfo = getProductInfo(null, true);
        eventInfo.eventStatus = status;
        eventInfo.eventMsg = (0,helper/* sanitizeTextForAnalytics */.T68)(message);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowShare(true);
    };
    const pageRedirectUrl = ((ref3 = props.type) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "parts" ? "".concat(tileUrl).concat(selSku ? "&skuId=" + (typeof selSku === "string" ? selSku : selSku === null || selSku === void 0 ? void 0 : selSku.sku) : "&skuId=" + sku) : "".concat(tileUrl).concat(selSku ? "?skuId=" + (typeof selSku === "string" ? selSku : selSku === null || selSku === void 0 ? void 0 : selSku.sku) : "");
    const redirectPDP = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        location.href = decodeURIComponent(pageRedirectUrl);
    };
    const setHover = ()=>{
        document.getElementById("kf-product-tile-wrapper-".concat(data["ctId_s"])).classList.add("--hover");
        setOnHover(true);
    };
    const removeHover = ()=>{
        document.getElementById("kf-product-tile-wrapper-".concat(data["ctId_s"])).classList.remove("--hover");
        setOnHover(false);
    };
    const presetConf = JSON.parse(presetConfigs);
    const getEventInfo = function(type, color) {
        let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isForSample = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        var ref, ref1;
        /**
     * type is default navigation, could be favorite or share
     * color is optional, could be selected color from plp or search page product
     * needsJSON returns either JSON or stringified value
     */ const isPartsDiagram = type === "parts diagram";
        const alternameType = type === "favorite" ? isFavorite ? "favorite remove" : "favorite add" : type === "compare" ? isChecked ? "compare remove" : "compare add" : "";
        const compareInternalLinkName = type === "compare" ? isChecked ? "remove compare" : "add to compare" : "";
        const pageSection = props.favPage && props.selectedtab ? "favorites" : "";
        var ref2;
        const selectedTab = (ref2 = props.favPage && props.selectedtab) !== null && ref2 !== void 0 ? ref2 : props === null || props === void 0 ? void 0 : (ref = props.selectedtab) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        const plpPrefix = isForSample ? "plp:sample" : "plp";
        const selectedTabForSearchResults = (props === null || props === void 0 ? void 0 : (ref1 = props.type) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "products";
        const colorSelection = color ? "color selection" : alternameType || (0,helper/* sanitizeTextForAnalytics */.T68)(type || productName + " " + description);
        const eventInfo = {
            eventAction: "".concat(pageSection ? "my account:" + pageSection + ":" : (props.plpPage ? plpPrefix : "search results") + (isForSample ? ":" : " ")).concat(isPartsDiagram ? "products:" : "product ").concat(alternameType || type || "navigation"),
            eventName: "".concat(pageSection ? "my account:" + pageSection + ":" : (props.plpPage ? plpPrefix : "search results") + (isForSample ? ":" : " ")).concat(isPartsDiagram ? "products:" : "product ").concat(alternameType || type || "navigation"),
            eventType: isForSample || type === "favorite" ? isPartsDiagram ? "navigation" : "wishlist save" : "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type === "compare" ? compareInternalLinkName : colorSelection,
            internalLinkPosition: selectedTab ? selectedTab : props.plpPage ? plpPrefix : "search results",
            internalLinkType: pageSection ? "my accounts:navigation" : "".concat(props.plpPage ? plpPrefix : "search results", ":").concat(type || (props.plpPage ? "navigation" : "product tiles")),
            internalLinkZoneName: selectedTab ? "my account:".concat(pageSection, ":").concat(selectedTab, ":main content area") : props.plpPage ? "".concat(plpPrefix, ":promo tiles") : "search results:".concat(selectedTabForSearchResults, ":main content area"),
            internalLinkURL: !type ? ((tileUrl === null || tileUrl === void 0 ? void 0 : tileUrl.indexOf("http")) === -1 ? window.location.origin : "") + tileUrl + (color ? "?skuId=" + color.sku : selSku ? "?skuId=" + selSku : "") : "n/a",
            clickInternalLinks: "true"
        };
        if (needsJSON) {
            eventInfo.custom = getProductInfo();
            return eventInfo;
        }
        return JSON.stringify(eventInfo);
    };
    const getProductInfo = function(color) {
        let needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref;
        const { productCouponCode , productCoupondiscount  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
            cart: cartData,
            sku: sku
        });
        const productInfo = {
            productInfo: {
                productBrand: general === null || general === void 0 ? void 0 : (ref = general.siteName) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                description: (0,helper/* sanitizeTextForAnalytics */.T68)(description) || "n/a",
                globalPromotionPrice: discountPercent && discountAmount ? Number((price - discountAmount).toFixed(2)) : price,
                priceState: discountPriceState,
                productBasePrice: price,
                productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(category) || "n/a",
                productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(color ? color.name : detaultSelectedColor) || "n/a",
                productID: (color ? color.customerFacingSKU : defaultCustomerFacingSku) || "n/a",
                productName: (0,helper/* sanitizeTextForAnalytics */.T68)(productName) || "n/a",
                productRoom: (0,helper/* sanitizeTextForAnalytics */.T68)(productRoom || category) || "n/a",
                productSalePrice: discountedPrice ? discountedPrice : price,
                productSaleable: productSaleable,
                productStatus: color ? color.isStock === "true" || color.isStock === true ? "in stock" : "out of stock" : defaultProductIsInStock ? "in stock" : "out of stock",
                productSuperSku: isSuperSku,
                productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(tileTitle) || "n/a",
                defaultImageName: defaultImage || "n/a",
                productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(productCollectionsName || category) || "n/a",
                globalOffer: badgeVal ? badgeVal : "n/a",
                globalDiscount: discountPercent ? discountAmount : "n/a",
                productPartnerBuyNow: productIsRetail,
                pdpType: "regular finished goods & service parts",
                productFindingMethod: "n/a",
                productCouponCode: productCouponCode.join("|") || "n/a",
                productCoupondiscount: productCoupondiscount,
                frequency: "n/a",
                isRecommended: "n/a",
                isSendNow: "n/a",
                isSubscription: "n/a",
                quantity: "n/a",
                ratings: "n/a",
                numberOfReviews: "n/a"
            }
        };
        if (needsJSON) {
            return productInfo.productInfo;
        }
        return JSON.stringify(productInfo);
    };
    const onSelectedColor = (e, sku, customerFacingSKU)=>{
        e.stopPropagation();
        setSelectedColor({
            sku: sku,
            customerFacingSKU: customerFacingSKU
        });
        badgeUpdate(sku);
    };
    const checkColorFocus = (e, colors, index)=>{
        const colorSlice = colors.slice(0, colorCount);
        if (e.key === "Tab" && colorSlice.length - 1 === index || e.shiftKey && e.key === "Tab" && index === 0) {
            setHoverColor(selectedColor !== null && selectedColor !== void 0 ? selectedColor : "");
        }
    };
    const handleOnClickPartsDiagramLink = (event)=>{
        event.preventDefault();
        props.handleOnClickPartsDiagramLink(data);
    };
    const getClickSignalPayload = ()=>{
        const userInfo = window.adobeDataLayer.getState("page.user.authStatus") === "anonymous" ? "guest" : window.adobeDataLayer.getState("page.user.commerceToolsID");
        const sTimeStamp = new Date().toISOString().split("T")[0] + "T" + new Date().toTimeString().split(" ")[0] + "Z";
        return [
            {
                params: {
                    query: highlightText !== null && highlightText !== void 0 ? highlightText : productCategory,
                    app_id: general.siteName.toLowerCase(),
                    doc_id: props.data.id,
                    fusion_query_id: props.fusionQueryId,
                    ctype: props.parent,
                    user_id: userInfo,
                    country: "USA",
                    region: "Northeast",
                    item_pos: props.index,
                    plc: productCategory,
                    sku_id: props.data.sku_s,
                    session_id: props === null || props === void 0 ? void 0 : props.sessionId,
                    count_i: "1",
                    url: window.location
                },
                id: "".concat(new Date().valueOf(), "_").concat(userInfo, "_").concat(sku, " "),
                timestamp: sTimeStamp,
                type: "click"
            }
        ];
    };
    const triggerClickSignal = async ()=>{
        const aSignalsPayload = getClickSignalPayload();
        await apim.post("/search/signals/".concat(general.siteName.toLowerCase()), aSignalsPayload);
    };
    const serviceParts = t("kf.search.serviceparts");
    const productTileClickHandler = ()=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = getEventInfo("", null, true);
        const productInfo = getProductInfo(null, true);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    let asProductDetailActionPayload = {};
    if (data) {
        var _sku_s, _slug_s;
        asProductDetailActionPayload = {
            sku: (_sku_s = data.sku_s) !== null && _sku_s !== void 0 ? _sku_s : " ",
            slug: (_slug_s = data.slug_s) !== null && _slug_s !== void 0 ? _slug_s : " ",
            response: data
        };
    }
    const availabilityLabel = (0,helper/* getAvailabilityLabel */.F3C)(get_default()(data, "SKUAnnSacksNonStock_b", ""), general);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "kf-product-tile-wrapper-".concat(data["ctId_s"]),
        className: "product-tile__wrapper wow animate__fadeInUp",
        onFocus: setHover,
        onBlur: removeHover,
        onMouseLeave: ()=>setShowShare(false),
        onMouseEnter: ()=>{
            dispatch((0,asPdpSlice/* setAsProductDetails */.Wf)(asProductDetailActionPayload));
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SocialShare/* default */.Z, {
                showModal: showShare,
                id: "kf-plp-tile-".concat(data["ctId_s"]),
                url: window.location.origin + tileUrl,
                onClose: ()=>setShowShare(false),
                analyticData: getEventInfo("share", null, true)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-tile__badge",
                    children: !isEmpty_default()(badgeTxt) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "product-tile__new",
                        children: badgeTxt
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "link",
                id: props.id,
                className: "product-tile__wrapper__card",
                "aria-label": productName,
                tabIndex: "0",
                onFocus: (e)=>e.stopPropagation(),
                onClick: redirectPDP,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()({
                        "product-tile": true,
                        "product-tile--lite": lite
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            tabIndex: "-1",
                            href: "".concat(tileUrl).concat((tileUrl === null || tileUrl === void 0 ? void 0 : tileUrl.includes("?type=part")) ? "&" : "?", "skuId=").concat(selSku !== "" ? typeof selSku === "string" ? selSku : selSku === null || selSku === void 0 ? void 0 : selSku.sku : sku),
                            onClick: (0,helper/* debounce */.DsO)(productTileClickHandler, 500),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-tile__image wow animate__fadeInUp",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: images.map((id, i)=>{
                                        const imgUrl = (0,utils/* getPresetUrl */.v$)(width, rowCols, swatchUrl, id, presetConf, i, productCategory);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            role: "presentation",
                                            src: imgUrl !== null && imgUrl !== void 0 ? imgUrl : "",
                                            className: images.length > 1 && i === 0 ? "product-tile__image--hover" : "product-tile__image-tile",
                                            alt: data.metaTitle_s,
                                            onError: (e)=>(0,utils/* onImageError */.Ac)(e, imgUrl ? imgUrl : "")
                                        }, i);
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-list-tile__details wow animate__fadeInUp",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-list-tile__details product-list-tile__compare-main",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: (0,helper/* debounce */.DsO)(productTileClickHandler, 500),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "aria-label": "".concat(colors.length).concat(texts.colorsLinkAria),
                                                className: "product-list-tile__colors",
                                                children: colors.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-list-tile__colors--swatch",
                                                    children: [
                                                        colors === null || colors === void 0 ? void 0 : colors.slice(0, colorCount).map((color, i)=>{
                                                            var ref;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                                                "data-gbh-data-layer": getEventInfo(null, color),
                                                                "data-gbh-data-layer-custom": getProductInfo(color),
                                                                onClick: (e)=>onSelectedColor(e, color.sku, color.customerFacingSKU),
                                                                role: "link",
                                                                tabIndex: "0",
                                                                "aria-label": "".concat(color.name, " color"),
                                                                "aria-hidden": onHover ? false : true,
                                                                rel: "noreferrer",
                                                                title: color.name,
                                                                className: classnames_default()({
                                                                    "product-list-tile__color-swatch gbh-data-layer": true,
                                                                    "selected-swatch": selectedColor.sku === color.sku
                                                                }),
                                                                onMouseEnter: ()=>{
                                                                    setHoverColor({
                                                                        sku: color.sku,
                                                                        customerFacingSKU: color.customerFacingSKU
                                                                    });
                                                                    badgeUpdate(color.sku);
                                                                },
                                                                onMouseLeave: ()=>{
                                                                    setHoverColor(Object.keys(selectedColor).length > 0 ? selectedColor : {
                                                                        sku: firstSwatchColor
                                                                    });
                                                                    badgeUpdate(Object.keys(selectedColor).length > 0 ? selectedColor.sku : firstSwatchColor);
                                                                },
                                                                onFocus: ()=>{
                                                                    setHoverColor({
                                                                        sku: color.sku,
                                                                        customerFacingSKU: color.customerFacingSKU
                                                                    });
                                                                    badgeUpdate(color.sku);
                                                                },
                                                                onKeyDown: (e)=>checkColorFocus(e, colors, i),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    role: "presentation",
                                                                    src: "".concat((general === null || general === void 0 ? void 0 : (ref = general.swatchUrl) === null || ref === void 0 ? void 0 : ref.toString().includes("PAWEB")) ? general === null || general === void 0 ? void 0 : general.swatchUrl.replace("PAWEB", general === null || general === void 0 ? void 0 : general.scene7AccountName) : general === null || general === void 0 ? void 0 : general.swatchUrl).concat(color.swatch).concat(width <= 768 ? "?$PLPSwatch_Mobile50$" : "?$PLPSwatch_Desk100$"),
                                                                    alt: color.name,
                                                                    onError: (e)=>colorSwatchDefaultImg(e)
                                                                })
                                                            }, i);
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: colors.length > colorCount && "+" + (colors.length - colorCount)
                                                        })
                                                    ]
                                                })
                                            }),
                                            !noBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-list-tile__shipping-status",
                                                children: availabilityLabel
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()({
                                                    "product-list-tile__info": true,
                                                    "mt-0": !colors.length
                                                }),
                                                children: productName && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    "aria-label": productName,
                                                    className: "product-list-tile__title",
                                                    children: productName
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: !isSample && finalPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    "aria-label": "".concat(texts.salePriceAria).concat(currencySign).concat(discountedPrice > 0 ? discountedPrice : finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0, " \n                                ").concat(isGrouped && (discountedPrice > 0 ? discountedPrice !== discountedMaxPrice : finalPrice !== maxPrice) ? " - " + currencySign + (discountedMaxPrice > 0 ? discountedMaxPrice : maxPrice) : ""),
                                                    className: "product-list-tile__price ".concat(!isGrouped && "product-list-tile_paddingtop"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                            value: discountedPrice > 0 ? discountedPrice : finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0,
                                                            displayType: "text",
                                                            thousandSeparator: true,
                                                            prefix: currencySign,
                                                            suffix: priceTag,
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true
                                                        }),
                                                        isGrouped && (discountedPrice > 0 ? discountedPrice !== discountedMaxPrice : finalPrice !== maxPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                            value: discountedMaxPrice > 0 ? discountedMaxPrice : maxPrice !== null && maxPrice !== void 0 ? maxPrice : 0,
                                                            displayType: "text",
                                                            thousandSeparator: true,
                                                            prefix: "- ".concat(currencySign),
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true
                                                        }),
                                                        discountedPrice !== finalPrice && discountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            "aria-label": "".concat(texts.originalPriceAria).concat(currencySign).concat(finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0).concat(isGrouped && finalPrice !== maxPrice ? " - " + currencySign + discountedMaxPrice : ""),
                                                            className: classnames_default()({
                                                                "product-list-tile__discount-price": true,
                                                                "pl-0 d-block": isGrouped && width <= 480 && rowCols === 2
                                                            }),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    value: finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    suffix: priceTag,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                }),
                                                                isGrouped && finalPrice !== maxPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    value: maxPrice,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: "- ".concat(currencySign),
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-list-tile__right-controls",
                                        onClick: (0,helper/* debounce */.DsO)(productTileClickHandler, 500),
                                        children: !isGrouped && !hideCompare && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            onClick: (e)=>e.stopPropagation(),
                                            className: "product-list-tile__compare ".concat(lib/* isTablet */.Em ? "product-list-tile__compare-tablet" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(core_Checkbox, {
                                                    id: "kf-checkbox-".concat(selSku !== "" && selSku !== undefined && (typeof selSku === "string" ? selSku : selSku === null || selSku === void 0 ? void 0 : selSku.sku)),
                                                    index: props.index,
                                                    value: texts.addToCompare,
                                                    aria: "".concat(description, " ").concat(texts.addToCompare),
                                                    checked: isChecked,
                                                    onChange: (e)=>{
                                                        return handleCompare(e, selSku !== "" && selSku !== undefined && (typeof selSku === "string" ? selSku : selSku === null || selSku === void 0 ? void 0 : selSku.sku));
                                                    },
                                                    disabled: isEnable
                                                }),
                                                errorMessage !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                    message: errorMessage
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            !props.favPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-tile__share",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        id: "kf-add-to-fav-".concat(props.index),
                        className: "product-tile__share-icon",
                        tabIndex: "0",
                        "aria-label": t("kf.plp.label.wishlist", {
                            product: productName
                        }),
                        "aria-hidden": width > 1024 ? onHover ? false : true : false,
                        onClick: handleFavorite,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            src: isFavorite ? wishlist_gray_filled/* default */.Z === null || wishlist_gray_filled/* default */.Z === void 0 ? void 0 : wishlist_gray_filled/* default.src */.Z.src : wish/* default */.Z === null || wish/* default */.Z === void 0 ? void 0 : wish/* default.src */.Z.src,
                            alt: texts.wishlist
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "product-tile__share-icon-plp gbh-data-layer",
                        tabIndex: "0",
                        "aria-label": t("kf.plp.label.share.aria", {
                            product: productName
                        }),
                        "aria-hidden": width > 1024 ? onHover ? false : true : false,
                        "data-gbh-data-layer": getEventInfo("share"),
                        "data-gbh-data-layer-custom": getProductInfo(),
                        onClick: handleShare,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            src: share/* default */.Z === null || share/* default */.Z === void 0 ? void 0 : share/* default.src */.Z.src,
                            alt: texts.share
                        })
                    })
                ]
            }),
            isPartsDiagramLinkVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-tile__wrapper__card__parts",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "#",
                    className: "product-parts__viewer",
                    onClick: handleOnClickPartsDiagramLink,
                    children: serviceParts
                })
            })
        ]
    });
};
/* harmony default export */ var v3 = (ProductTile);

;// CONCATENATED MODULE: ./components/ProductList/v1/ProductsPerPage.jsx


const ProductsPerPage_ProductsPerPage = (param)=>{
    let { data =[] , texts , page , onChange , setRows , totalResults , curRows =30 , pos ="top" , selectedTab  } = param;
    const getAnalyticsData = function() {
        let limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", all = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        limit = limit + "";
        let analyticsData = "";
        if (page === "search") {
            if (!all) {
                analyticsData = JSON.stringify({
                    eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: limit,
                    internalLinkPosition: "search results",
                    internalLinkType: "search results:pagination ".concat(pos),
                    internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            } else {
                analyticsData = JSON.stringify({
                    eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: texts.all,
                    internalLinkPosition: "search results",
                    internalLinkType: "search results:pagination ".concat(pos),
                    internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            }
        } else if (page === "technicalspecs") {
            let internalLinkName = texts.all;
            if (!all) {
                internalLinkName = limit;
            }
            analyticsData = JSON.stringify({
                eventAction: "technical specs:main content area​:pagination",
                eventName: "technical specs:main content area​:pagination",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName,
                internalLinkPosition: "tech spec",
                internalLinkType: "technical specs​:pagination ".concat(pos),
                internalLinkZoneName: "technical specs:main content area",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        } else if (page === "favorites") {
            if (!all) {
                analyticsData = JSON.stringify({
                    eventAction: "my account:favorites:".concat(selectedTab.toLowerCase(), "​:pagination"),
                    eventName: "my account:favorites:".concat(selectedTab.toLowerCase(), ":pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "".concat(limit),
                    internalLinkPosition: "favorites",
                    internalLinkType: "my account:pagination bottom",
                    internalLinkZoneName: "my account:favorites:".concat(selectedTab.toLowerCase()),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            } else {
                analyticsData = JSON.stringify({
                    eventAction: "my account:favorites:".concat(selectedTab.toLowerCase(), "​:pagination"),
                    eventName: "my account:favorites:".concat(selectedTab.toLowerCase(), "​:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "".concat(texts.all),
                    internalLinkPosition: "favorites",
                    internalLinkType: "my account:pagination bottom",
                    internalLinkZoneName: "my account:favorites:".concat(selectedTab.toLowerCase()),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            }
        } else if (page === "article") {
            analyticsData = JSON.stringify({
                eventAction: "support:help and faq:article list:pagination",
                eventName: "support:help and faq:article list:pagination",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: !all ? limit : texts.all,
                internalLinkPosition: "support:help and faq",
                internalLinkType: "support:help and faq:pagination " + pos,
                internalLinkZoneName: "support:help and faq:article list",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        } else if (page === "literature") {
            if (!all) {
                analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "press-release") {
            if (!all) {
                analyticsData = '{"eventAction":"press room:press releases:pagination","eventName":"press room:press releases:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"press room","internalLinkType":"press room:press releases:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"press room:press releases:pagination","eventName":"press room:press releases:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"press room","internalLinkType":"press room:press releases:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "press-kits") {
            if (!all) {
                analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else {
            let internalLinkZoneName = pos === "top" ? '"plp:sticky nav filter"' : '"plp:promo tiles"';
            if (!all) {
                analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        }
        return analyticsData;
    };
    const checkPaginationPosition = (limit)=>{
        onChange(limit);
    // setRows(true)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "products-per-page",
        children: totalResults > 30 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "disabled",
                    "aria-hidden": true,
                    children: texts.view
                }),
                data.map((limit, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        "aria-disabled": curRows === limit,
                        role: "button",
                        tabIndex: "0",
                        "aria-label": "".concat(texts.view, " ").concat(limit, " ").concat(texts.items),
                        className: (curRows === limit && "disabled") + " gbh-data-layer",
                        "data-gbh-data-layer": getAnalyticsData(limit),
                        onClick: ()=>checkPaginationPosition(limit),
                        children: limit
                    }, i)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    role: "button",
                    tabIndex: "0",
                    "aria-label": "".concat(texts.view, " ").concat(texts.all, " ").concat(texts.items),
                    className: (curRows === totalResults && "disabled") + " gbh-data-layer",
                    "data-gbh-data-layer": getAnalyticsData("", true),
                    onClick: ()=>onChange(totalResults),
                    children: texts.all
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ProductsPerPage = (ProductsPerPage_ProductsPerPage);

// EXTERNAL MODULE: ./public/icons/grid-off.svg
var grid_off = __webpack_require__(8909);
// EXTERNAL MODULE: ./public/icons/grid-on.svg
var grid_on = __webpack_require__(7520);
;// CONCATENATED MODULE: ./components/PromoBanner/v1/PromoBanner.jsx




const PromoBanner_PromoBanner = (props)=>{
    const { col , imageId ="promoImage" , promoData , promoInfo: data  } = props;
    const [promoImg, setPromoImg] = (0,react.useState)(Boolean(window.s7responsiveImage));
    (0,react.useEffect)(()=>{
        if (!promoImg) {
            (0,helper/* loadSmartcrop */.j6L)(setPromoImg);
        }
    }, [
        promoImg
    ]);
    (0,react.useEffect)(()=>{
        if (promoImg && data.imgUrl) {
            if (typeof window.s7responsiveImage === "function") {
                window.s7responsiveImage(document.getElementById(imageId));
            }
        }
    }, [
        promoImg,
        data.imgUrl
    ]);
    const sanitizeText = (text)=>text.replace(/<\/?[^>]+(>|$)/g, "");
    let eventInfo;
    if (window.location.pathname.includes("search")) {
        eventInfo = {
            eventAction: "search results:products:main content area:shop now",
            eventName: "search results:products:main content area:shop now",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "shop now",
            internalLinkPosition: "search",
            internalLinkType: "search results:internal campaign",
            internalLinkZoneName: "search results:products:main content area",
            internalLinkURL: window.location.origin + data.ctaLink,
            clickInternalLinks: "true"
        };
    } else {
        eventInfo = {
            eventAction: "plp shop now",
            eventName: "plp shop now",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "shop now",
            internalLinkPosition: "plp",
            internalLinkType: "plp:internal campaign",
            internalLinkZoneName: "plp:promo tiles",
            internalLinkURL: window.location.origin + data.ctaLink,
            clickInternalLinks: "true"
        };
    }
    const handlePromoBannerClick = ()=>{
        if (window.adobeDataLayer) {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const eventDetails = {
                event: "cmp:click",
                eventInfo,
                page
            };
            const { componentInfo  } = promoData;
            if (componentInfo) {
                eventDetails.component = [
                    {
                        componentInfo
                    }
                ];
            }
            window.adobeDataLayer.push(eventDetails);
        }
    };
    var _desc;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "kf-promo-banner ".concat(col === 2 || col === 3 ? "--fixed-height" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "kf-promo-banner__layout --col-".concat(col !== null && col !== void 0 ? col : 1, " ").concat(data.promostyle, " ").concat(data.gradientPosition, " ").concat(data.contentPosition, " ").concat(data.mobileGradientPosition),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "kf-promo-banner__image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        id: imageId,
                        className: "smart-crop-img",
                        src: data.imgUrl ? data.imgUrl : "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRA7",
                        "data-src": data.imgUrl,
                        "data-mode": "smartcrop",
                        alt: (_desc = data.desc) !== null && _desc !== void 0 ? _desc : ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "kf-promo-banner__info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "kf-promo-banner__desc",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(data.desc)
                        }),
                        data.ctaLink !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                role: "link",
                                customClass: "kf-promo-banner__cta",
                                type: "ghost",
                                size: "small",
                                to: data.ctaLink,
                                label: data.ctaLabel,
                                ariaLabel: data.ctaAriaLabel,
                                onClick: handlePromoBannerClick,
                                useDefaultClass: true
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var PromoBanner_v1_PromoBanner = (PromoBanner_PromoBanner);

;// CONCATENATED MODULE: ./components/ProductList/v1/PLPLoader.jsx


const PLPLoader = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container product-list__container product-list__header p0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row mb-60",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-8 col-xs-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "shimmer-loading__headerTitle shimmer"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-lg-4 col-xs-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__headpara mb20 width-320 shimmer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__headpara mb20 width-full shimmer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__headpara width-320 shimmer"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "shimmer-loading__headpara shimmer width-200"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "products__controls_shimmer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "shimmer-loading__para30 shimmer width-240"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "d-flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "products-per-page width-240",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sort width-90",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container product-list__container product-list__tiles p0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-list__filter borderNone",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "filter__inner-container shimmer height-300"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "filter__footer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "products-per-page width-240 mt60 mb20",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__headpara shimmer"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "products-per-page width-100",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__para shimmer"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-list__tile-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col px-1 product-list__tile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__image",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col px-1 product-list__tile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__image",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col px-1 product-list__tile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__image",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col px-1 product-list__tile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__image",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col px-1 product-list__tile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__image",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col px-1 product-list__tile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__image",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v1_PLPLoader = (PLPLoader);

// EXTERNAL MODULE: ./src/components/PromoBanner/v2/promoBannerHelper.js
var promoBannerHelper = __webpack_require__(84744);
// EXTERNAL MODULE: ./i18n/useProductListi18n.js
var useProductListi18n = __webpack_require__(32908);
;// CONCATENATED MODULE: ./components/ProductList/v1/ProductList.view.jsx






























const ProductList = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const { presetConfigs , xfHtml ="" , shippingTab  } = props;
    const [width] = (0,useWindowResize/* default */.Z)();
    const persona = (0,helper/* getUserPersona */.shu)();
    document.querySelector("title").setAttribute("aria-label", props.staticTexts.pageTitleAria);
    const { isLandscape , selectedFilterCount , facets , categoryName  } = props;
    const [categoryData, setCategoryData] = (0,react.useState)([]);
    const isCompactViewport = width < 1024;
    const isTouchOnlyViewport =  true && window.matchMedia("(hover: none) and (pointer: coarse)").matches;
    const [showFilter, setShowFilter] = (0,react.useState)(!(isCompactViewport || isTouchOnlyViewport));
    const [navSticky, setNavSticky] = (0,react.useState)(false);
    const { noResultsMssg  } = (0,useProductListi18n/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const [promoInfo, setPromoInfo] = (0,react.useState)({
        imgUrl: "",
        desc: "",
        ctaText: "",
        ctaLink: "",
        position: "",
        promostyle: ""
    });
    const [rowCols, setRowCols] = (0,react.useState)(width < 1024 ? 1 : 3);
    const filterClass = classnames_default()({
        "product-list__filter": true,
        "product-list__filter--hide": !showFilter,
        "product-list__filter--modal": showFilter
    });
    const filterButtonClass = classnames_default()({
        "product-list__filter-toggle-text": true,
        "product-list__filter-toggle-text--show": !showFilter
    });
    const tileClass = classnames_default()({
        "product-list__tile-col": true,
        "product-list__tile-col--full-width": !showFilter
    });
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const [swatchCount, setSwatchCount] = (0,react.useState)(width > 812 ? 7 : 5);
    const filterModalWindow = (0,react.useRef)(null);
    const previousCompactViewport = (0,react.useRef)(isCompactViewport);
    //calculate promo position
    const col = width < 990 && (lib/* isMobile */.tq || lib/* isTablet */.Em) || width < 480 ? {
        "one-column": "col-12",
        "two-column": "col-12",
        "three-column": "col-12"
    } : {
        "one-column": "col promo-col",
        "two-column": "col-8 promo-col",
        "three-column": "col-12 promo-col"
    };
    const colVal = {
        "one-column": 1,
        "two-column": 2,
        "three-column": 3
    };
    const row = lib/* isMobile */.tq ? props.promoPlacementMobile : props.promoPlacementDesktop;
    const position = lib/* isMobile */.tq && window.outerWidth < 1024 ? rowCols === 1 ? row - 1 : row * rowCols - 2 : row * rowCols - colVal[props.promoLayout];
    const executeScroll = ()=>{
        var ref;
        plpRef === null || plpRef === void 0 ? void 0 : (ref = plpRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    const plpRef = (0,react.useRef)(null);
    const [compareJsonPath, setCompareJsonPath] = (0,react.useState)("");
    const [general, setGeneral] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general ={}  } = await (0,constants_config/* getConfig */.i)();
            setGeneral(general);
            var ref;
            setCompareJsonPath((ref = general === null || general === void 0 ? void 0 : general.compareJsonPath) !== null && ref !== void 0 ? ref : "");
        };
        configFn();
    }, []);
    (0,react.useEffect)(()=>{
        if (previousCompactViewport.current !== isCompactViewport) {
            if (isCompactViewport) {
                setShowFilter(false);
            }
            previousCompactViewport.current = isCompactViewport;
        }
    }, [
        isCompactViewport
    ]);
    (0,react.useEffect)(()=>{
        (0,constants_api/* aemAxiosInstance */.Gb)({
            url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: compareJsonPath
            }
        }).then((res)=>{
            var ref;
            var ref1;
            setCategoryData((ref1 = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : []);
        }).catch((err)=>{
            console.log("Failed to get compare attributes JSON file", err);
        });
    }, [
        compareJsonPath
    ]);
    (0,react.useEffect)(()=>{
        window.addEventListener("resize", ()=>setSwatchCount(width > 812 ? 7 : 5));
        switch(true){
            case width > 1440:
                setRowCols(3);
                break;
            case width < 990 && (lib/* isMobile */.tq || lib/* isTablet */.Em) || width < 1440:
                setRowCols(2);
                break;
            default:
                setRowCols(3);
        }
        return ()=>{
            window.removeEventListener("resize", ()=>setSwatchCount(width > 812 ? 7 : 5));
        };
    }, [
        isLandscape,
        width
    ]);
    (0,react.useEffect)(()=>{
        if (showFilter && (lib/* isMobile */.tq || lib/* isTablet */.Em || width < 990)) {
            var ref;
            filterModalWindow === null || filterModalWindow === void 0 ? void 0 : (ref = filterModalWindow.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (!showFilter && (lib/* isMobile */.tq || lib/* isTablet */.Em || width < 990)) {
            var ref1;
            (ref1 = document.getElementById("showFilter")) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    }, [
        showFilter
    ]);
    (0,react.useEffect)(()=>{
        props.sendPositionToParent && props.sendPositionToParent(position);
    }, [
        position
    ]);
    (0,react.useEffect)(()=>{
        getXfData();
    }, [
        xfHtml
    ]);
    const setPromoJsonData = async function() {
        let jsonData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (jsonData) {
            var _ctaLink;
            const shortenedCtaLink = (0,helper/* getShortenedUrlwithGeneral */.vu1)((_ctaLink = jsonData.ctaLink) !== null && _ctaLink !== void 0 ? _ctaLink : "", general) || "/";
            var _imageUrl, _title, _ctaLinkText, _ctaLinkText1, _title1, _assetPath;
            const result = {
                imgUrl: (_imageUrl = jsonData.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "",
                desc: "".concat((_title = jsonData.title) !== null && _title !== void 0 ? _title : "").replaceAll("&nbsp;", " "),
                ctaText: (_ctaLinkText = jsonData.ctaLinkText) !== null && _ctaLinkText !== void 0 ? _ctaLinkText : "",
                ctaLink: shortenedCtaLink,
                ctaAriaLabel: "".concat((_ctaLinkText1 = jsonData.ctaLinkText) !== null && _ctaLinkText1 !== void 0 ? _ctaLinkText1 : "", " ").concat((0,helper/* sanitizeText */.oOy)((_title1 = jsonData.title) !== null && _title1 !== void 0 ? _title1 : "")),
                assetPath: (_assetPath = jsonData.assetPath) !== null && _assetPath !== void 0 ? _assetPath : "",
                position: position,
                promostyle: jsonData.style && jsonData.style[0] ? jsonData.style[0] : "",
                contentPosition: jsonData.contentPosition,
                gradientPosition: jsonData.gradientPosition,
                mobileGradientPosition: jsonData.mobileGradientPosition,
                ctaLabel: jsonData.ctaLabel
            };
            setPromoInfo(result);
            if (props.setPromoData) {
                props.setPromoData(result);
            }
        } else if (props.setPromoData) {
            props.setPromoData({
                position
            });
        }
    };
    const getXfData = async ()=>{
        var ref;
        let link = (ref = props.xfHtml) === null || ref === void 0 ? void 0 : ref.split(".html")[0];
        if (link) {
            try {
                const data = await (0,promoBannerHelper/* getPromoData */.G)(link);
                setPromoJsonData(data);
            } catch (error) {
                console.error(error);
            }
        }
    };
    function handleKeyPress(e) {
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusContent = filterModalWindow.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            props.onModalClose();
            if (lib/* isMobile */.tq) {
                setShowFilter(false);
            }
            document.body.classList.remove("scroll-lock");
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterModalWindow.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    }
    const handleBackToTop = ()=>{
        let resultElement = document.getElementById("product-listing__total");
        if (resultElement) {
            resultElement.focus();
        }
        window.scrollTo({
            top: 200,
            behavior: "smooth"
        });
    };
    const handleShippingStatusTab = (tabs, tab)=>{
        if (shippingTab === (tab === null || tab === void 0 ? void 0 : tab.tabNumber)) return;
        let payload = {
            plp: {
                shippingTab: tab === null || tab === void 0 ? void 0 : tab.tabNumber
            }
        };
        dispatch((0,asPlpSlice/* setShippingStatus */._p)(payload));
        (props === null || props === void 0 ? void 0 : props.getShippingStatus) && (props === null || props === void 0 ? void 0 : props.getShippingStatus(tabs, tab));
        executeScroll();
    };
    const handleSort = (sort)=>{
        props.onSort(sort);
        executeScroll();
    };
    if ((props === null || props === void 0 ? void 0 : props.totalResults) <= 0 && (props === null || props === void 0 ? void 0 : props.loading)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PLPLoader, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-list",
        ref: plpRef,
        id: "productListWrapperId",
        children: [
            props.isCurated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container kf-react-container product-list__header product-list__curated",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-8 col-xs-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                "aria-label": props.staticTexts.totalResults,
                                className: "product-list__total d-lg-block",
                                tabIndex: "0",
                                children: (props === null || props === void 0 ? void 0 : props.totalResults) > 0 && "".concat((props === null || props === void 0 ? void 0 : props.totalResults) || 0, " ").concat(props.staticTexts.results)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row d-block d-lg-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-list__grid-control",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    "aria-label": props.staticTexts.totalResults,
                                    className: "product-list__total",
                                    children: [
                                        (props === null || props === void 0 ? void 0 : props.totalResults) || 0,
                                        " ",
                                        props.staticTexts.results
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                onFixedToggle: ()=>setNavSticky(!navSticky),
                className: "product-listing__sticky-nav-wrap",
                stickyStyle: {
                    zIndex: 9,
                    left: 0
                },
                children: [
                    (props === null || props === void 0 ? void 0 : props.enableTabs) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-listing-tabs-mobile-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-listing-tabs",
                                role: "tablist",
                                "aria-label": "Product Filters",
                                children: props === null || props === void 0 ? void 0 : (ref = props.tabs) === null || ref === void 0 ? void 0 : ref.map((tab, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        role: "tab",
                                        "aria-selected": shippingTab === (tab === null || tab === void 0 ? void 0 : tab.tabNumber),
                                        className: "product-listing__order-button ".concat(shippingTab === (tab === null || tab === void 0 ? void 0 : tab.tabNumber) ? "active" : ""),
                                        onClick: ()=>{
                                            return handleShippingStatusTab(props === null || props === void 0 ? void 0 : props.tabs, tab);
                                        },
                                        children: tab === null || tab === void 0 ? void 0 : tab.tabName
                                    }, tab === null || tab === void 0 ? void 0 : tab.tabNumber);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container-fluid product-listing__sticky-nav ".concat(navSticky && "product-listing__sticky-nav--shadow"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-listing__row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container kf-react-plp-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-listing__row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-listing__col product-listing__controls",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "product-listing__total-tabs-wrapper",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                        id: "product-listing__total",
                                                        "aria-label": props.staticTexts.totalResults,
                                                        className: "product-listing__total",
                                                        "aria-live": "polite",
                                                        role: "status",
                                                        tabIndex: 0,
                                                        children: [
                                                            props.totalResults,
                                                            " ",
                                                            props.staticTexts.results
                                                        ]
                                                    }),
                                                    (props === null || props === void 0 ? void 0 : props.enableTabs) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-listing-tabs-desktop",
                                                        role: "tablist",
                                                        "aria-label": "Product Filters",
                                                        children: props === null || props === void 0 ? void 0 : (ref1 = props.tabs) === null || ref1 === void 0 ? void 0 : ref1.map((tab, index)=>{
                                                            const isSelected = shippingTab === tab.tabNumber;
                                                            const tabId = "product-tab-".concat(tab.tabNumber);
                                                            const panelId = "product-tabpanel-".concat(tab.tabNumber);
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                id: tabId,
                                                                role: "tab",
                                                                "aria-selected": isSelected,
                                                                tabIndex: isSelected ? 0 : -1,
                                                                className: "product-listing__order-button ".concat(isSelected ? "active" : ""),
                                                                onClick: ()=>{
                                                                    return handleShippingStatusTab(props === null || props === void 0 ? void 0 : props.tabs, tab);
                                                                },
                                                                "aria-controls": panelId,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "tab-content",
                                                                    children: tab.tabName
                                                                })
                                                            }, index);
                                                        })
                                                    }),
                                                    (props === null || props === void 0 ? void 0 : props.enableTabs) && (props === null || props === void 0 ? void 0 : (ref2 = props.tabs) === null || ref2 === void 0 ? void 0 : ref2.map((tab, index)=>{
                                                        const isSelected = shippingTab === tab.tabNumber;
                                                        const tabId = "product-tab-".concat(tab.tabNumber);
                                                        const panelId = "product-tabpanel-".concat(tab.tabNumber);
                                                        return isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            id: panelId,
                                                            role: "tabpanel",
                                                            "aria-labelledby": tabId,
                                                            tabIndex: 0,
                                                            className: "product-listing__tabpanel"
                                                        }, panelId);
                                                    }))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                className: "sorting-section",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "product-listing__fillter_sort",
                                                        onClick: ()=>setShowFilter(!showFilter),
                                                        children: props.staticTexts.filterSort
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        id: "showFilter",
                                                        "aria-haspopup": lib/* isTablet */.Em || lib/* isMobile */.tq,
                                                        "aria-expanded": lib/* isTablet */.Em || lib/* isMobile */.tq ? false : showFilter,
                                                        "aria-label": props.staticTexts.filters,
                                                        className: "product-listing__filter-toggle gbh-data-layer",
                                                        "data-gbh-data-layer": '{"eventAction":"plp ' + (showFilter ? "show" : "hide") + ' filter","eventName":"plp ' + (showFilter ? "show" : "hide") + ' filter","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + (showFilter ? "show" : "hide") + ' filters","internalLinkPosition":"plp","internalLinkType":"plp:' + (showFilter ? "show" : "hide") + '","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                                        onClick: ()=>setShowFilter(!showFilter),
                                                        children: [
                                                            width > 991 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                className: filterButtonClass,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        className: showFilter ? "show" : "hide",
                                                                        children: props.staticTexts.hideFilter
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        className: !showFilter ? "show" : "hide",
                                                                        children: props.staticTexts.showFilter
                                                                    })
                                                                ]
                                                            }) : "",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                                                className: "product-listing__filter-toggle-icon",
                                                                alt: "Toggle Filter"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-listing__grid-control",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "d-block d-sm-none",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                onClick: ()=>setRowCols(rowCols === 1 ? 2 : 1),
                                                                className: "product-listing__grid-control-icon",
                                                                src: rowCols > 1 ? grid_on/* default */.Z === null || grid_on/* default */.Z === void 0 ? void 0 : grid_on/* default.src */.Z.src : grid_off/* default */.Z === null || grid_off/* default */.Z === void 0 ? void 0 : grid_off/* default.src */.Z.src,
                                                                alt: ""
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Sort, {
                                                        tabIndex: "0",
                                                        data: props.sorts,
                                                        selectedSort: props.selectedSort,
                                                        texts: props.staticTexts,
                                                        onChange: handleSort
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container kf-react-container product-list__tiles",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                ((ref3 = props.data) === null || ref3 === void 0 ? void 0 : ref3.length) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: filterClass,
                                    "aria-modal": true,
                                    ref: filterModalWindow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-list__filter--sticky ".concat(props.isCurated ? " product-list__filter-curated" : ""),
                                        "aria-hidden": !showFilter,
                                        onKeyDown: handleKeyPress,
                                        children: facets && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Filter, {
                                            tabIndex: "0",
                                            texts: props.staticTexts,
                                            ...props,
                                            close: setShowFilter,
                                            displayShare: props.displayShare === "true" ? true : false,
                                            displayPrint: props.displayPrint === "true" ? true : false,
                                            selectedFilterCount: selectedFilterCount,
                                            handleScroll: executeScroll,
                                            showFilter: showFilter,
                                            addToUrl: true,
                                            sort: props.sorts,
                                            selectedSort: props.selectedSort,
                                            onSortChange: handleSort,
                                            showSort: width < 991,
                                            category: categoryName,
                                            clearShippingTabFilter: props === null || props === void 0 ? void 0 : props.clearShippingTabFilter,
                                            filterToURL: props === null || props === void 0 ? void 0 : props.filterToURL
                                        })
                                    })
                                }),
                                props.totalResults > 0 || (props === null || props === void 0 ? void 0 : props.loading) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: tileClass,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row row-cols-".concat(rowCols),
                                            children: props === null || props === void 0 ? void 0 : (ref4 = props.data) === null || ref4 === void 0 ? void 0 : ref4.map((product, i)=>{
                                                var ref, ref1;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col product-list__tile ".concat((props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.length) === 1 ? "product-single" : ""),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_lazyload_lib/* default */.ZP, {
                                                                className: "kf-lazyload-wrapper",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3, {
                                                                    rowCols: rowCols,
                                                                    tabIndex: "0",
                                                                    loading: props.loading,
                                                                    data: product,
                                                                    mapImageToColor: true,
                                                                    texts: props.staticTexts,
                                                                    lite: !isLandscape ? rowCols === 2 ? true : false : false,
                                                                    addToCompare: props.addToCompare,
                                                                    removeFromCompare: props.removeFromCompare,
                                                                    compareData: props.comparedProducts,
                                                                    isEnable: props.isEnable,
                                                                    defaultImage: props.defaultImageTag || constants.plpDefaultImageKey,
                                                                    hoverImage: props.hoverImageTag || constants.plpHoverImageKey,
                                                                    currencySign: props.currencySign,
                                                                    isGrouped: props.isGrouped,
                                                                    swatchCount: swatchCount,
                                                                    favorites: props.favorites,
                                                                    currFilters: props.currFilters,
                                                                    plpPage: true,
                                                                    favPage: false,
                                                                    index: i,
                                                                    presetConfigs: presetConfigs,
                                                                    categoryData: categoryData,
                                                                    saleInfo: product["Sale.".concat(persona, ".Details_ss")]
                                                                })
                                                            })
                                                        }),
                                                        (props === null || props === void 0 ? void 0 : props.xfHtml) && (i + 1) % position === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(col[props === null || props === void 0 ? void 0 : props.promoLayout], " product-list__tile"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoBanner_v1_PromoBanner, {
                                                                imageId: "promoImage" + i,
                                                                xfLink: props === null || props === void 0 ? void 0 : props.xfHtml,
                                                                col: colVal[props === null || props === void 0 ? void 0 : props.promoLayout],
                                                                position: i,
                                                                promoInfo: promoInfo,
                                                                promoData: props === null || props === void 0 ? void 0 : (ref1 = props.promoData) === null || ref1 === void 0 ? void 0 : ref1.find((itm)=>{
                                                                    return (itm === null || itm === void 0 ? void 0 : itm.position) === i;
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row gbh-data-layer",
                                            "data-gbh-data-layer": '{"eventAction":"plp load more","eventName":"plp load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"plp","internalLinkType":"plp:load more","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                            children: props.totalResults > props.curRows && props.totalResults > ((ref5 = props.data) === null || ref5 === void 0 ? void 0 : ref5.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                type: "load-more",
                                                role: "button",
                                                size: "small",
                                                customClass: "product-list__load-more",
                                                label: props.staticTexts.loadMore,
                                                onClick: props.onLoadMore,
                                                useDefaultClass: true,
                                                ariaLabel: "".concat(props.staticTexts.loadMore, " ").concat(props.categoryName, " products")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "product-list__back-to-top",
                                                children: [
                                                    lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-list__print-and-share",
                                                        children: [
                                                            props.displayPrint === "true" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                role: "button",
                                                                onClick: ()=>window.print(),
                                                                children: [
                                                                    props.staticTexts.print,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: print/* default */.Z === null || print/* default */.Z === void 0 ? void 0 : print/* default.src */.Z.src,
                                                                        alt: props.staticTexts.print
                                                                    })
                                                                ]
                                                            }),
                                                            props.displayShare === "true" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                role: "button",
                                                                onClick: ()=>setShowSocialLink(!showSocialLink),
                                                                children: [
                                                                    props.staticTexts.share,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: share/* default */.Z === null || share/* default */.Z === void 0 ? void 0 : share/* default.src */.Z.src,
                                                                        alt: props.staticTexts.share
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SocialShare/* default */.Z, {
                                                                showModal: showSocialLink,
                                                                id: "kf-product-list",
                                                                onClose: ()=>setShowSocialLink(false)
                                                            })
                                                        ]
                                                    }),
                                                    width > 1023 && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductsPerPage, {
                                                        pos: "bottom",
                                                        curRows: (props === null || props === void 0 ? void 0 : props.curRows) + (props === null || props === void 0 ? void 0 : props.start),
                                                        data: props.productsPerPage,
                                                        totalResults: props.totalResults,
                                                        texts: props.staticTexts,
                                                        onChange: props.onRows,
                                                        selectedTab: "products"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        role: "link",
                                                        className: "product-list__go-back gbh-data-layer",
                                                        "aria-label": props === null || props === void 0 ? void 0 : (ref6 = props.staticTexts) === null || ref6 === void 0 ? void 0 : ref6.backToResult,
                                                        "data-gbh-data-layer": '{"eventAction":"plp back to top","eventName":"plp back to top","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"back to top","internalLinkPosition":"plp","internalLinkType":"plp:navigation","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                                        onClick: handleBackToTop,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "product-list__go-back-text",
                                                                children: [
                                                                    props.staticTexts.backToTop,
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                className: "product-list__go-back-image",
                                                                "aria-hidden": "true",
                                                                src: back_top_arrow/* default */.Z === null || back_top_arrow/* default */.Z === void 0 ? void 0 : back_top_arrow/* default.src */.Z.src,
                                                                alt: props.staticTexts.backToTop
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: tileClass,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-listing__no-results",
                                        dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(noResultsMssg)
                                        }
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ProductList_view = ((0,lib/* withOrientationChange */.Qe)(ProductList));

// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./components/ProductList/v1/ProductList.jsx




















const ProductList_ProductList = (props)=>{
    const { data: componentProps = {}  } = props !== null && props !== void 0 ? props : {};
    const dispatch = (0,es/* useDispatch */.I0)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { plp  } = (0,es/* useSelector */.v9)(asPlpSlice/* selectPlpState */.O);
    const { favorites  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const compare = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    var ref;
    const favoritesState = (ref = favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) !== null && ref !== void 0 ? ref : [];
    const { isEnable  } = compare !== null && compare !== void 0 ? compare : {};
    const [rows, setRows] = (0,react.useState)(lib/* isMobile */.tq ? 30 : Number(sessionStorage.getItem("rows")) || 30);
    const [start, setStart] = (0,react.useState)(0);
    const [curFilterQueries, setCurFilterQueries] = (0,react.useState)([]);
    const [productsPerPage] = (0,react.useState)([
        30,
        60,
        90
    ]);
    const [xfHtml, setXfHtml] = (0,react.useState)("");
    const [urlTitle, setUrlTitle] = (0,react.useState)("");
    const [promoDataVal, setPromoData] = (0,react.useState)([]);
    const [position, setPosition] = (0,react.useState)(null);
    const { menu: { isOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    // Refs to store the previous values
    const prevSortRef = (0,react.useRef)({
        name: t("kf.plp.label.atoz"),
        query: "Non_Collapse_Title_s+asc"
    });
    const prevStartRef = (0,react.useRef)(0);
    const prevRowsRef = (0,react.useRef)(lib/* isMobile */.tq ? 30 : Number(sessionStorage.getItem("rows")) || 30);
    const [currentEvent, setCurrentEvent] = (0,react.useState)("");
    const [prevEvent, setPrevEvent] = (0,react.useState)("");
    const router = (0,next_router.useRouter)();
    const { material  } = router.query;
    const [locale, setLocale] = (0,react.useState)("");
    const [currencySign, setCurrencySign] = (0,react.useState)("");
    const [currencyCode, setCurrencyCode] = (0,react.useState)("");
    const [brandName, setBrandName] = (0,react.useState)("");
    const [lwAppName, setLwAppName] = (0,react.useState)("");
    const [language, setLanguage] = (0,react.useState)("");
    const [lwMarketParamValues, setLwMarketParamValues] = (0,react.useState)("");
    const [clearShippingTabFilter, setClearShippingTabFilter] = (0,react.useState)(false);
    const [currURL, setCurrURL] = (0,react.useState)("");
    const [categoryName, setCategoryName] = (0,react.useState)(componentProps.categoryName);
    const url = new URL(window.location.href);
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general ={} , internationalization ={} , marketParamValues ={}  } = await (0,constants_config/* getConfig */.i)();
            var ref;
            setLocale((ref = internationalization === null || internationalization === void 0 ? void 0 : internationalization.locale) !== null && ref !== void 0 ? ref : "");
            var ref1;
            setCurrencySign((ref1 = internationalization === null || internationalization === void 0 ? void 0 : internationalization.currencySign) !== null && ref1 !== void 0 ? ref1 : "");
            var ref2;
            setCurrencyCode((ref2 = internationalization === null || internationalization === void 0 ? void 0 : internationalization.currencyCode) !== null && ref2 !== void 0 ? ref2 : "");
            var ref3;
            setBrandName((ref3 = general === null || general === void 0 ? void 0 : general.siteName) !== null && ref3 !== void 0 ? ref3 : "");
            var ref4;
            setLwAppName((ref4 = general === null || general === void 0 ? void 0 : general.lwAppName) !== null && ref4 !== void 0 ? ref4 : "");
            var ref5;
            setLanguage((ref5 = internationalization === null || internationalization === void 0 ? void 0 : internationalization.language) !== null && ref5 !== void 0 ? ref5 : "en");
            setLwMarketParamValues(marketParamValues);
        };
        configFn();
        setSelectedSort({
            name: t("kf.plp.label.atoz"),
            query: "Non_Collapse_Title_s+asc"
        });
        const categoryParam = url.searchParams.get("categoryParam");
        const sort = url.searchParams.get("sortParam");
        if (window.location.pathname === constants.GENERIC_PLP_PAGE) {
            !(0,lodash.isEmpty)(categoryParam) ? setCategoryName(categoryParam) : null;
            if (sort) {
                setSelectedSort(sorts.find((item)=>item.name === sort));
            }
        }
        if (!window.location.search) {
            getProductsList([]);
        }
    }, []);
    (0,react.useEffect)(()=>{
        const onLoadFn = async ()=>{
            if (lwAppName && language) {
                //to scrollup the product list
                window.scrollTo(0, 0);
                let currFilters = [];
                try {
                    //get xF
                    if (componentProps.xfLink) {
                        setXfHtml(componentProps.xfLink);
                    }
                    //set props and fetch product data
                    fetchTitleFromUrl();
                    //Get filters from url params
                    let selectedTab = "";
                    const urlFilters = (0,helper/* getFacetsFromUrl */.bZU)(lwMarketParamValues);
                    if (urlFilters.length > 0) {
                        var ref, ref1, ref2;
                        const resp = await getFacets(categoryName);
                        var ref3;
                        const facetLabels = (0,helper/* getAsUniqueFilter */.B_)((ref3 = resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : (ref1 = ref.fusion) === null || ref1 === void 0 ? void 0 : ref1.facet_labels) !== null && ref3 !== void 0 ? ref3 : {});
                        var ref4;
                        const facetFields = (0,helper/* getAsUniqueFilter */.B_)((ref4 = resp === null || resp === void 0 ? void 0 : (ref2 = resp.data) === null || ref2 === void 0 ? void 0 : ref2.fusion["facet.field"]) !== null && ref4 !== void 0 ? ref4 : []);
                        urlFilters.forEach((f)=>{
                            let facetQuery = "";
                            if (f.facet === "Price_Range") {
                                facetQuery = "Price_Range";
                            } else if (f.facet === "Special_Order") {
                                var ref, ref1;
                                f.display = [
                                    "".concat((ref1 = f === null || f === void 0 ? void 0 : (ref = f.facet) === null || ref === void 0 ? void 0 : ref.replaceAll("_", " ")) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase())
                                ];
                                facetQuery = "SKUAnnSacksNonStock_b";
                                selectedTab = f.facet;
                            } else if (f.facet === "Ready_to_Ship") {
                                var ref2, ref3;
                                f.display = [
                                    "".concat((ref3 = f === null || f === void 0 ? void 0 : (ref2 = f.facet) === null || ref2 === void 0 ? void 0 : ref2.replaceAll("_", " ")) === null || ref3 === void 0 ? void 0 : ref3.toUpperCase())
                                ];
                                facetQuery = "-SKUAnnSacksNonStock_b";
                                selectedTab = f.facet;
                            } else {
                                facetQuery = Object.keys(facetLabels).find((key)=>facetLabels[key] === f.facet.replaceAll("_", " "));
                            }
                            if (Array.isArray(facetFields) && facetFields.find((f)=>f === facetQuery)) {
                                facetQuery = "**".concat(facetQuery);
                            }
                            if (facetQuery) {
                                f.facet = facetQuery;
                            }
                        });
                    }
                    if (componentProps === null || componentProps === void 0 ? void 0 : componentProps.tabs) {
                        dispatch((0,asPlpSlice/* setShippingStatus */._p)({
                            plp: {
                                shippingTab: getSelectedTabs(selectedTab)
                            }
                        }));
                    }
                    //Set pre-selected filters
                    if ((urlFilters === null || urlFilters === void 0 ? void 0 : urlFilters.length) === 0 && componentProps.attributeName !== "" && componentProps.attributevalue !== "") {
                        var ref5;
                        const resp1 = await getFacets(categoryName);
                        var ref6;
                        const facetFields1 = (0,helper/* getAsUniqueFilter */.B_)((ref6 = resp1 === null || resp1 === void 0 ? void 0 : (ref5 = resp1.data) === null || ref5 === void 0 ? void 0 : ref5.fusion["facet.field"]) !== null && ref6 !== void 0 ? ref6 : []);
                        let facetQuery = componentProps.attributeName;
                        if (facetFields1.find((f)=>f === facetQuery)) {
                            facetQuery = "**".concat(facetQuery);
                        }
                        currFilters.push({
                            facet: facetQuery,
                            value: [
                                componentProps.attributevalue.replace(/"/g, '\\"')
                            ],
                            display: [
                                componentProps.attributevalue
                            ]
                        });
                    }
                    currFilters = [
                        ...currFilters,
                        ...urlFilters
                    ];
                    if (currFilters.length > 0) {
                        getProductsList(currFilters, false);
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        };
        onLoadFn();
    }, [
        lwAppName,
        language
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        const sort = url.searchParams.get("sortParam");
        if (sort) {
            setSelectedSort(sorts.find((item)=>item.name === sort));
        } else {
            let sortitem = sorts.find((item)=>{
                var ref;
                return item.name === (props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.defaultSort);
            });
            setSelectedSort(sortitem || {
                name: t("kf.plp.label.atoz"),
                query: "Non_Collapse_Title_s+asc"
            });
        }
        isOpen && (dispatch((0,genericSlice/* closeMenu */.Wj)()), (ref = document.querySelector(".page", ".basicpage")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("gbh-of-scroll"), (ref2 = document.querySelector(".ann-sacks-main-menu.header-container.ann-sacks-tab-bar")) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.classList) === null || ref3 === void 0 ? void 0 : ref3.remove("ann-sacks-tab-menu", "button-format"));
    }, [
        material
    ]);
    (0,react.useEffect)(()=>{
        // This useeffect is used only to Reload PLP when auth token changes
        if (total > 0) {
            getProductsList([]);
        }
    }, [
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if (currURL !== window.location.pathname) {
            dispatch((0,asPlpSlice/* resetShippingStatus */.K$)());
            setCurrURL(window.location.pathname);
        }
    });
    (0,react.useEffect)(()=>{
        if (plp.loaded) {
            plpLoadedEvent();
        }
    }, [
        plp.loaded
    ]);
    const sanitizeText = (text)=>text.replace(/<\/?[^>]+(>|$)/g, "");
    // To get facet labels and to check if pre-selected filters are multi select facets
    const getFacets = async (category)=>{
        return await constants_api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: "id",
                fq: 'language_s:("'.concat(language, '")'),
                q: "*:*",
                rows: 0,
                profilename: "profile_".concat(lwAppName.toLowerCase(), "_PLP_").concat(category),
                collections: lwAppName.toLowerCase()
            }
        });
    };
    const setUrlParams = (filters)=>{
        let query = "";
        if (filters.length > 0) {
            filters.forEach((filter, i)=>{
                var ref;
                const values = [
                    ...filter.value
                ];
                if (values.length !== 0 && filter.facet === "Price_Range" ? true : facetLabels[(ref = filter.facet) === null || ref === void 0 ? void 0 : ref.replace(/^\*{2}/, "")]) {
                    var ref1, ref2;
                    var ref3;
                    query += "".concat(filter.facet === "Price_Range" ? filter.facet : (ref3 = (ref2 = facetLabels[(ref1 = filter.facet) === null || ref1 === void 0 ? void 0 : ref1.replace(/^\*{2}/, "")]) === null || ref2 === void 0 ? void 0 : ref2.replaceAll(" ", "_")) !== null && ref3 !== void 0 ? ref3 : filter.facet, "=").concat(filter.facet === "Price_Range" ? filter.value : encodeURIComponent(values)).concat(i !== filters.length - 1 ? "&" : "");
                } else if ((filter === null || filter === void 0 ? void 0 : filter.facet) === "SKUAnnSacksNonStock_b") {
                    query += "Special_Order=true".concat(i !== filters.length - 1 ? "&" : "");
                } else if ((filter === null || filter === void 0 ? void 0 : filter.facet) === "-SKUAnnSacksNonStock_b") {
                    query += "Ready_to_Ship=true".concat(i !== filters.length - 1 ? "&" : "");
                }
            });
            window.history.replaceState(window.location.pathname, document.title, query.toString().length === 0 ? window.location.pathname : "?".concat(query.toString()));
            if (props.resetTitle) props.resetTitle();
        } else {
            setClearShippingTabFilter(true);
        }
    };
    const getSelectedTabs = (uRLParam)=>{
        switch(uRLParam){
            case "Ready_to_Ship":
                var ref;
                return (ref = componentProps === null || componentProps === void 0 ? void 0 : componentProps.tabs[0]) === null || ref === void 0 ? void 0 : ref.tabNumber;
            case "Special_Order":
                var ref1;
                return (ref1 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.tabs[1]) === null || ref1 === void 0 ? void 0 : ref1.tabNumber;
            default:
                var ref2;
                return (ref2 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.tabs[2]) === null || ref2 === void 0 ? void 0 : ref2.tabNumber;
        }
    };
    const getShippingStatus = async (tabs, tab)=>{
        var ref, ref1;
        let filterLabel = "";
        let facetQuery = "";
        const inStockLWField = "-SKUAnnSacksNonStock_b";
        const nonStockLWField = "SKUAnnSacksNonStock_b";
        setClearShippingTabFilter(false);
        switch(tab === null || tab === void 0 ? void 0 : tab.tabName){
            case (ref = tabs[0]) === null || ref === void 0 ? void 0 : ref.tabName:
                facetQuery = inStockLWField; // this field might get chnage as per data
                filterLabel = tab === null || tab === void 0 ? void 0 : tab.tabName;
                break;
            case (ref1 = tabs[1]) === null || ref1 === void 0 ? void 0 : ref1.tabName:
                facetQuery = nonStockLWField; // this field might get chnage as per data
                filterLabel = tab === null || tab === void 0 ? void 0 : tab.tabName;
                break;
            default:
                break;
        }
        if (filterLabel && filterLabel !== "") {
            let tabFilter = {
                facet: facetQuery,
                value: [
                    true
                ],
                display: [
                    "".concat(filterLabel)
                ]
            };
            /* Need to keep this code till final confirmation from bussiness */ let isTabSelected = false;
            let queries = curFilterQueries === null || curFilterQueries === void 0 ? void 0 : curFilterQueries.filter((q)=>{
                if (!isTabSelected) {
                    isTabSelected = [
                        inStockLWField,
                        nonStockLWField
                    ].includes(q.facet);
                }
                return q.facet !== inStockLWField && q.facet !== nonStockLWField;
            });
            if (!isTabSelected) {
                setCurFilterQueries([
                    tabFilter
                ]);
                setUrlParams([
                    tabFilter
                ]);
                getProductsList([
                    tabFilter
                ], false);
            } else {
                queries.push(tabFilter);
                setCurFilterQueries(queries);
                setUrlParams(queries);
                getProductsList(queries, false);
            }
        /* Retain All Filters */ // let queries = curFilterQueries?.filter((q) => {
        //   if (facetQuery &&  inStockLWField === facetQuery ) {
        //     return q.facet !== nonStockLWField
        //   }
        //   if (facetQuery &&  nonStockLWField === facetQuery ) {
        //     return q.facet !== inStockLWField
        //   }
        //   return q;
        // });
        // queries.push(tabFilter);
        // setCurFilterQueries(queries);
        // setUrlParams(queries)
        // getProductsList(queries, false);
        } else {
            setCurFilterQueries([]);
            setClearShippingTabFilter(true);
            getProductsList([], false);
        }
    };
    const getProductsList = (queries, update)=>{
        let startVal = 0;
        //save queries to handle sorting
        if (queries) {
            setCurFilterQueries(queries);
        } else {
            queries = curFilterQueries;
            startVal = start;
        }
        if (!update) {
            setStart(0);
            setPromoData([]);
        }
        //build lucid work query and make http request
        let fq = [];
        const persona = (0,helper/* getUserPersona */.shu)();
        queries.forEach((q)=>{
            if ([
                "categoryParam",
                "sortParam"
            ].includes(q.facet)) return;
            let tag = '{!tag="'.concat(q.facet, '"}');
            if (!q.facet.match(/^\*{2}/)) {
                q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 && !q.facet.includes("saleAvailable_s") && !q.facet.includes("discountOff_s") || q.facet.indexOf("discountedPriceStartingAt") === 0 ? (plp === null || plp === void 0 ? void 0 : plp.grouped) ? fq.push(encodeURIComponent("".concat('{!tag="discountedPriceStartingAt.'.concat(persona, '_d"}') + "discountedPriceStartingAt.".concat(persona, "_d"), ":(").concat(q.value.join(" OR "), ")"))) : fq.push(encodeURIComponent("".concat('{!tag="priceList.'.concat(persona, '.finalPrice_d"}') + "priceList.".concat(persona, ".finalPrice_d"), ":(").concat(q.value.join(" OR "), ")"))) : fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")')));
                return;
            }
            q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 && !q.facet.includes("saleAvailable_s") && !q.facet.includes("discountOff_s") || q.facet.indexOf("discountedPriceStartingAt") === 0 ? (plp === null || plp === void 0 ? void 0 : plp.grouped) ? fq.push("".concat("discountedPriceStartingAt.".concat(persona, "_d").replace(/^\*{2}/, ""), ":(").concat(encodeURIComponent(q.value), ")")) : fq.push("".concat("priceList.".concat(persona, ".finalPrice_d").replace(/^\*{2}/, ""), ":(").concat(encodeURIComponent(q.value), ")")) : fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
        });
        let query = {
            fq,
            rows: rows,
            start: startVal
        };
        if (selectedSort) {
            var ref;
            if ((selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query) === "price+asc") {
                query.sort = "".concat((0,helper/* getPriceSortQuery */.YHw)(), "+asc");
            } else if ((selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query) === "price+desc") {
                query.sort = "".concat((0,helper/* getPriceSortQuery */.YHw)(), "+desc");
            } else if ((selectedSort === null || selectedSort === void 0 ? void 0 : (ref = selectedSort.query) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                query.sort = selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query;
            }
        }
        dispatch((0,asPlpSlice/* getProducts */.Xp)({
            query,
            update,
            category: categoryName
        }));
    };
    const handleSort = (query)=>{
        setSelectedSort(query);
        setStart(0);
    };
    const handleRows = (rows)=>{
        setRows(rows);
        setStart(0);
        setPrevEvent(currentEvent);
        setCurrentEvent("pagination");
        sessionStorage.setItem("rows", rows);
    };
    const handleLoadMore = ()=>{
        setStart(start + rows);
        setRows(30);
        setPrevEvent(currentEvent);
        setCurrentEvent("loadmore");
    };
    const fetchTitleFromUrl = ()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const title = urlParams.get("title");
        setUrlTitle(title ? title : "");
    };
    const plpLoadedEvent = ()=>{
        const { data  } = plp;
        if (!data || !data.length || parseInt(data.length / position) === 0 || !xfHtml) {
            addAnalyticsShowEvent();
        } else {
            // checking if all responses are recorded
            const requestedPromos = [];
            data.map((item, i)=>{
                if ((i + 1) % position === 0) {
                    requestedPromos.push(i);
                }
            });
            if (requestedPromos.length === 0) {
                addAnalyticsShowEvent();
            } else {
                setTimeout(()=>{
                    addAnalyticsShowEvent();
                }, 5000);
            }
        }
    };
    const getUniqueList = (arr, key)=>{
        return [
            ...new Map(arr.map((item)=>[
                    item[key],
                    item
                ])).values()
        ];
    };
    const addAnalyticsShowEvent = ()=>{
        let promoData = promoDataVal.filter((promo)=>promo && promo.ctaLink);
        promoData.sort((a, b)=>a.position - b.position);
        promoData = getUniqueList(promoData, "position");
        let slot = 1;
        const component = [];
        promoData.forEach((promoItem)=>{
            let title = promoItem.desc || "";
            if (title) {
                var ref;
                const div = document.createElement("div");
                div.innerHTML = title;
                // This contains HTML code so remove some bugs here.
                title = (ref = div.innerText || div.textContent || "") === null || ref === void 0 ? void 0 : ref.toLowerCase();
                title = title.replaceAll("\n", "");
            }
            promoItem.componentInfo = {
                componentID: "".concat(window.location.origin).concat(promoItem.ctaLink),
                componentMessage: "promo-".concat(slot++),
                componentName: title,
                componentLocation: "plp:promo tiles",
                componentType: "internal campaign"
            };
            component.push({
                componentInfo: promoItem.componentInfo
            });
        });
        setPromoData(promoData);
        if (!(0,helper/* isShowAnalyticsEventLoaded */.xJ2)()) {
            const page = window.pageObj || {};
            page.user = (0,helper/* getUserAnalyticsObject */.L7i)();
            const { data  } = plp;
            if (page.category) {
                page.category.room = data && data[0] && data[0].category1_s ? (0,helper/* sanitizeTextForAnalytics */.T68)(data[0].category1_s) : "n/a";
            } else {
                page.category = {
                    room: data && data[0] && data[0].category1_s ? (0,helper/* sanitizeTextForAnalytics */.T68)(data[0].category1_s) : "n/a"
                };
            }
            if ((!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
                page.component = component;
                window.pageObj = page;
                window.isShowAnalyticsEvent = true;
            } else {
                window.adobeDataLayer.push({
                    event: "cmp:show",
                    page: page,
                    component: component
                });
            }
        }
    };
    const sendPositionToParent = (position)=>{
        setPosition(position);
    };
    const setPromoDataFn = (promo)=>{
        const { data  } = plp;
        const promoDataNew = promoDataVal;
        if (promo && !promoDataVal.find((item)=>item.position === promo.position)) {
            // don't push duplicates
            promoDataNew.push(promo);
        }
        setPromoData(promoDataNew);
        // checking if all responses are recorded
        const requestedPromos = [];
        data.map((item, i)=>{
            if ((i + 1) % position === 0) {
                requestedPromos.push(i);
            }
        });
        if (requestedPromos.length === promoDataVal.length) {
            addAnalyticsShowEvent();
        }
    };
    let { data , total , facets , facetLabels , loading , colors , grouped  } = plp || {};
    data = (0,helper/* sanitizeDOMString */.TRt)(data);
    total = (0,helper/* sanitizeDOMString */.TRt)(total);
    facets = (0,helper/* sanitizeDOMString */.TRt)(facets);
    facetLabels = (0,helper/* sanitizeDOMString */.TRt)(facetLabels);
    loading = (0,helper/* sanitizeDOMString */.TRt)(loading);
    colors = (0,helper/* sanitizeDOMString */.TRt)(colors);
    grouped = (0,helper/* sanitizeDOMString */.TRt)(grouped);
    const sorts = [
        {
            name: t("kf.plp.label.featured"),
            query: ""
        },
        {
            name: t("kf.plp.label.newSort"),
            query: "RegionLaunchDate_dt+desc, Non_Collapse_Title_s+asc"
        },
        {
            name: t("kf.plp.label.priceDesc"),
            query: "price+desc"
        },
        {
            name: t("kf.plp.label.priceAsc"),
            query: "price+asc"
        },
        {
            name: t("kf.plp.label.atoz"),
            query: "".concat(grouped ? "Collapse_Title_s+asc" : "Non_Collapse_Title_s+asc")
        },
        {
            name: t("kf.plp.label.ztoa"),
            query: "".concat(grouped ? "Collapse_Title_s+desc" : "Non_Collapse_Title_s+desc")
        }
    ];
    const [selectedSort, setSelectedSort] = (0,react.useState)(url.searchParams.get("categoryParam") ? sorts.find((item)=>item.name === url.searchParams.get("categoryParam")) : sorts.find((item)=>{
        var ref;
        return item.name === (props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.defaultSort);
    }) || {
        name: t("kf.plp.label.atoz"),
        query: "Non_Collapse_Title_s+asc"
    });
    (0,react.useEffect)(()=>{
        var ref;
        // This useeffect is for sort change or perpage change to avoid this on page loading the below condition is added
        if (loading) {
            return;
        }
        // Check if either selectedSort or start has changed
        if ((selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name) !== ((ref = prevSortRef.current) === null || ref === void 0 ? void 0 : ref.name)) {
            getProductsList();
            // Update the previous values
            prevSortRef.current = selectedSort;
        } else if ((start !== prevStartRef.current || currentEvent !== prevEvent) && currentEvent === "loadmore") {
            getProductsList(null, true);
            // Update the previous values
            prevStartRef.current = start;
        } else if ((rows !== prevRowsRef.current || currentEvent !== prevEvent) && currentEvent === "pagination") {
            getProductsList();
            // Update the previous values
            prevRowsRef.current = rows;
        }
    }, [
        selectedSort,
        start,
        rows,
        currentEvent
    ]);
    const staticTexts = {
        expanded: t("kf.productTab.aria.expanded"),
        collapsed: t("kf.productTab.aria.collapsed"),
        totalCount: t("kf.plp.label.totalCount", {
            count: total
        }),
        hideFilterAria: t("kf.plp.label.hideFilterAria"),
        showFilterAria: t("kf.plp.label.showFilterAria"),
        clearAllAria: t("kf.plp.label.clearAllAria"),
        listWith: t("kf.plp.label.listWith"),
        items: t("kf.plp.label.items"),
        facetListAriaExpandOrCollapse: t("kf.plp.label.facetListAriaExpandOrCollapse"),
        showMoreFiltersAria: t("kf.plp.label.showMoreFiltersAria"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        sortBykey: t("kf.plp.label.sortBykey"),
        salePriceAria: t("kf.plp.label.salePriceAria"),
        originalPriceAria: t("kf.plp.label.originalPriceAria"),
        productDescription: t("kf.plp.label.productDescription"),
        colorsLinkAria: t("kf.plp.label.colorsLinkAria"),
        pageTitleAria: t("kf.plp.label.pageTitleAria", {
            categoryName: categoryName,
            brandName: brandName
        }),
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: t("kf.plp.label.showFilter"),
        hideFilter: t("kf.plp.label.hideFilter"),
        showFilterState: t("kf.plp.label.showFilterState"),
        hideFilterState: t("kf.plp.label.hideFilterState"),
        filters: t("kf.plp.label.filters"),
        filterSort: t("kf.plp.label.filterSort"),
        listviewFilter: t("kf.plp.label.listViewDeclare"),
        addToCompare: t("kf.plp.label.addToCompare"),
        colors: t("kf.plp.label.colors"),
        color: t("kf.plp.label.color"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        gridView: t("kf.plp.label.gridView"),
        columnView: t("kf.plp.label.columnView"),
        sort: t("kf.plp.label.sort"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        applyFilters: "Apply Filters",
        results: t("kf.plp.label.results"),
        annsacksResults: t("kf.plp.label.annsacksResults"),
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        backToResult: t("kf.plp.label.backToResult"),
        showMore: componentProps.isAnnsacksPlp ? t("annsacks.plp.label.showMore") : t("kf.plp.label.showMore"),
        showLess: componentProps.isAnnsacksPlp ? t("annsacks.plp.label.showLess") : t("kf.plp.label.showLess"),
        clearAll: t("kf.plp.label.clearAll"),
        priceRangeTitle: t("kf.plp.label.priceRangeTitle"),
        priceRangeDesc: t("kf.plp.label.priceRangeDesc"),
        to: t("kf.plp.label.to"),
        minText: t("kf.plp.label.minText"),
        maxText: t("kf.plp.label.maxText"),
        sameCategory: componentProps.sameCategory ? componentProps.sameCategory : t("kf.compare.validation.sameCategory"),
        sameVariants: t("kf.compare.validation.sameVariants"),
        maxProduct: componentProps.maxProduct ? componentProps.maxProduct : t("kf.compare.validation.maxProducts"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        errors: {
            validRange: t("kf.plp.error.validRange"),
            minGreaterThanMax: t("kf.plp.error.minGreaterThanMax"),
            maxGreaterThanZero: t("kf.plp.error.maxGreaterThanZero"),
            checkValid: t("kf.error.message.price")
        },
        ariaLabel: {
            columnViewSelected: t("kf.productTab.aria.columnViewSelected"),
            columnViewNotSelected: t("kf.productTab.aria.columnViewNotSelected"),
            gridViewSelected: t("kf.productTab.aria.gridViewSelected"),
            gridViewNotSelected: t("kf.productTab.aria.gridViewNotSelected")
        },
        startingAt: t("kf.plp.label.startingAt"),
        new: componentProps.newBadge ? componentProps.newBadge : t("kf.plp.label.new"),
        sale: componentProps.sale ? componentProps.sale : t("kf.plp.label.sale"),
        viewResults: t("kf.plp.label.viewResults"),
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        filterOpenAlert: t("kf.plp.ariaLabel.filterOpenAlert"),
        filterCloseAlert: t("kf.plp.ariaLabel.filterCloseAlert"),
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        perBox: t("annsacks.pdpProductSummary.label.perBox"),
        perEach: t("annsacks.pdpProductSummary.label.perEach"),
        perSF: t("annsacks.pdpProductSummary.label.perSF"),
        perLF: t("annsacks.pdpProductSummary.label.perLF")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList_view, {
        loading: loading,
        ...componentProps,
        buyingGuideDescription: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.buyingGuideDescription) ? sanitizeText(componentProps === null || componentProps === void 0 ? void 0 : componentProps.buyingGuideDescription) : "",
        plpDisplayDescription: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.plpDisplayDescription) ? sanitizeText(componentProps === null || componentProps === void 0 ? void 0 : componentProps.plpDisplayDescription) : "",
        curRows: rows,
        start: start,
        data: data,
        facets: facets !== null && facets !== void 0 ? facets : false,
        facetLabels: facetLabels,
        sorts: sorts,
        totalResults: total,
        onFilter: getProductsList,
        shippingTab: plp === null || plp === void 0 ? void 0 : plp.shippingTab,
        getShippingStatus: getShippingStatus,
        clearShippingTabFilter: clearShippingTabFilter,
        onSort: handleSort,
        selectedSort: selectedSort,
        onRows: handleRows,
        onLoadMore: handleLoadMore,
        staticTexts: staticTexts,
        currencySign: currencySign,
        displayShare: componentProps.type === "curated" ? componentProps.enableShare : componentProps.enableSharePlp,
        displayPrint: componentProps.type === "curated" ? componentProps.enablePrint : componentProps.enablePrintPlp,
        productsPerPage: productsPerPage,
        xfHtml: xfHtml,
        addToCompare: product/* addToCompareProduct */.dX,
        removeFromCompare: product/* removeFromCompareProduct */.Zj,
        comparedProducts: compare,
        colors: colors,
        currFilters: curFilterQueries,
        selectedFilterCount: curFilterQueries && (curFilterQueries === null || curFilterQueries === void 0 ? void 0 : curFilterQueries.reduce((acc, item)=>{
            return acc + item.value.length;
        }, 0)),
        urlTitle: urlTitle,
        isEnable: isEnable,
        resetTitle: fetchTitleFromUrl,
        isCurated: componentProps.type === "curated",
        isGrouped: grouped,
        favorites: favoritesState,
        setPromoData: setPromoDataFn,
        sendPositionToParent: sendPositionToParent,
        promoData: promoDataVal,
        categoryName: categoryName
    });
};
/* harmony default export */ var v1_ProductList = (ProductList_ProductList);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
var qs_lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);
;// CONCATENATED MODULE: ./src/components/InPageSearch/v1/analytics.js
const analytics_getEventInfo = function() {
    let linkUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", status = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", searchString = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var ref, ref1;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const title = (ref = page.category) === null || ref === void 0 ? void 0 : (ref1 = ref.subCategoryID) === null || ref1 === void 0 ? void 0 : ref1.replaceAll(" ", "-");
    const findAServicePart = title === "find-a-service-part";
    const eventAction = (findAServicePart ? "".concat(page.category.pageType, ":").concat(title, ":") : "support".concat(type, ":")) + "main content area:search";
    const internalLinkPosition = findAServicePart ? "".concat(page.category.pageType, ":").concat(title) : "support".concat(type);
    const internalLinkType = (findAServicePart ? "".concat(page.category.pageType, ":").concat(title, ":") : "support".concat(type, ":")) + "".concat(searchString);
    const internalLinkZoneName = (findAServicePart ? "".concat(page.category.pageType, ":").concat(title, ":") : "support".concat(type, ":")) + "main content area";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction,
        eventName: eventAction,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: status || "n/a",
        internalLinkName: "search",
        internalLinkPosition,
        internalLinkType,
        internalLinkURL: linkUrl || "n/a",
        internalLinkZoneName,
        searchTerm: searchString
    });
};

// EXTERNAL MODULE: ./src/components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(96005);
// EXTERNAL MODULE: ./src/components/InPageSearch/v1/index.module.scss
var InPageSearch_v1_index_module = __webpack_require__(65529);
var InPageSearch_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(InPageSearch_v1_index_module);
;// CONCATENATED MODULE: ./src/components/InPageSearch/v1/InPageSearch.view.jsx














const InPageSearchView = (props)=>{
    const { bgColor ="" , loading =false , partId ="" , isSkuSearch =false , productId ="" , searchString ="" , pdfPartsDiagram ="" , ctaLink ="" , ctaLabel ="" , type ="" , onChange =()=>{} , title ="" , placeholder ="" , lwAppName ="" , language ="en"  } = props;
    const [width] = (0,useWindowResize/* default */.Z)();
    const isDarkBg = bgColor === "bgDark";
    const [isShowModal, setIsShowModal] = (0,react.useState)(false);
    const [shortenedUrl, setShortenedUrl] = (0,react.useState)(ctaLink);
    (0,react.useEffect)(()=>{
        if (ctaLink) {
            (0,helper/* getShortenedUrl */.Ppy)(ctaLink).then((url)=>setShortenedUrl(url));
        }
    }, [
        ctaLink
    ]);
    const handleKeyPress = (event)=>{
        const { keyCode ="" , key =""  } = event;
        if (keyCode === constants["default"].KEYCODE.ENTER && key === constants["default"].KEY.ENTER) {
            if (searchString !== "" && searchString.length <= 3) {
                location.href = "".concat(shortenedUrl, "?keyword=").concat(searchString, "&service=true");
            } else {
                const fl = "id,sku_s,slug_s,ProductProductNo_s,ProductResource.PartsPDFFileName.resourceFullWebURL_ss";
                constants_api/* apim.get */.TH.get(constants.inPageSearchEndPoint, {
                    params: {
                        q: searchString,
                        fl,
                        fq: [
                            'Products:("ct")',
                            'language_s:("'.concat(language, '")')
                        ],
                        collections: lwAppName.toLowerCase(),
                        profilename: "profile_".concat(lwAppName.toLowerCase(), "_Search")
                    },
                    paramsSerializer: (params)=>{
                        return qs_lib_default().stringify(params, {
                            arrayFormat: "repeat",
                            encode: false
                        });
                    }
                }).then((res)=>{
                    const { data: { response: { numFound ="" , docs =[]  } = {} , fusion: { exactMatch =""  } = {}  } = {}  } = res;
                    if (numFound === 1 && exactMatch) {
                        const mResources = get_default()(docs[0], "ProductResource.InteractiveSVG.resourceName_ss", "");
                        const partId = Array.isArray(mResources) ? mResources[0] : mResources;
                        const productId = get_default()(docs[0], "ProductProductNo_s", "");
                        setIsShowModal(Boolean(partId) && Boolean(productId));
                    } else {
                        location.href = "".concat(shortenedUrl, "?keyword=").concat(searchString, "&service=true");
                    }
                }).catch((err)=>console.log("error occured in fetch search term", err));
            }
        }
    };
    const handleOnClick = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        if (Boolean(partId) && Boolean(productId)) {
            setIsShowModal(true);
        }
        if (pdfPartsDiagram && pdfPartsDiagram[0]) {
            handlePDFDownload(event, pdfPartsDiagram ? pdfPartsDiagram[0] : "");
        }
    };
    const handlePDFDownload = (e, link)=>{
        e.stopPropagation();
        try {
            window.open(link.trim(), "_blank");
        } catch (err) {
            console.log(err);
        }
    };
    const onCloseModal = ()=>{
        setIsShowModal(false);
    };
    const getButton = ()=>{
        if (isSkuSearch) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InPageSearch_v1_index_module_default()) === null || (InPageSearch_v1_index_module_default()) === void 0 ? void 0 : (InPageSearch_v1_index_module_default()).inPageSearchWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "kf-react-button button gbh-data-layer large ".concat(isDarkBg ? "secondary" : "ghost", " ").concat(loading ? "disabled" : " ", " ").concat(searchString && searchString !== null && searchString.length > 0 ? "--active" : "--inactive"),
                    "data-gbh-data-layer": analytics_getEventInfo("".concat(ctaLink, "?keyword=").concat(searchString), "success"),
                    onClick: handleOnClick,
                    children: ctaLabel
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                label: ctaLabel,
                type: isDarkBg ? "secondary" : "ghost",
                to: "".concat(shortenedUrl, "?keyword=").concat(searchString, "&service=true"),
                className: "gbh-data-layer ".concat(loading ? "disabled" : " ", " ").concat(searchString && searchString !== null && searchString.length > 0 ? "--active" : "--inactive"),
                "data-gbh-data-layer": analytics_getEventInfo("".concat(ctaLink, "?keyword=").concat(searchString), "error", type, searchString)
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "in-page-search",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("inpage-search kf-react-container", isDarkBg && "inpage-search--dark"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row inpage-search-section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("col-12 inpage-search__title", isDarkBg && "inpage-search__title--dark"),
                            children: (0,helper/* sanitizeText */.oOy)(title)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-12 inpage-search__header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()("inpage-search__header-section", !isDarkBg && "inpage-search__header-section--light"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inpage-search__search-filed",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "inpage-search__search-control",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    autoComplete: "off",
                                                    type: "text",
                                                    className: classnames_default()("inpage-search__search-control", isDarkBg && "inpage-search__search-control--dark"),
                                                    id: "inpage-search__search-control",
                                                    placeholder: placeholder,
                                                    "aria-labelledby": "searchBox",
                                                    onChange: (e)=>onChange(e.target.value),
                                                    onKeyUp: (e)=>handleKeyPress(e)
                                                })
                                            })
                                        }),
                                        width > 480 && searchString && searchString !== null && searchString.length > 0 && getButton(),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                                            productId: productId,
                                            partId: partId,
                                            showModal: isShowModal,
                                            page: "search",
                                            onClose: onCloseModal
                                        })
                                    ]
                                }),
                                width <= 480 && getButton()
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var InPageSearch_view = ((0,lib/* withOrientationChange */.Qe)(InPageSearchView));

;// CONCATENATED MODULE: ./src/components/InPageSearch/v1/InPageSearch.jsx









const InPageSearch = (props)=>{
    const { data: searchProps = {}  } = props;
    const [lwAppName, setLwAppName] = (0,react.useState)("");
    const [language, setLanguage] = (0,react.useState)("en");
    const [searchString, setSearchString] = (0,react.useState)("");
    const [{ loading , partId , productId  }, setState] = (0,react.useState)({
        loading: false,
        partId: "",
        productId: ""
    });
    const [isSkuSearch, setIsSkuSearch] = (0,react.useState)(false);
    const [pdfPartsDiagram, setPdfPartsDiagram] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            const { general: { lwAppName =""  } = {} , internationalization: { language ="en"  } = {}  } = config !== null && config !== void 0 ? config : {};
            setLwAppName(lwAppName);
            setLanguage(language);
        });
    }, []);
    const handleChange = (0,helper/* debounce */.DsO)((searchTerm)=>{
        setSearchString(searchTerm.trim());
    });
    (0,react.useEffect)(()=>{
        if (lwAppName && searchString) {
            getData(searchString);
        }
    }, [
        searchString,
        lwAppName
    ]);
    const getData = (searchString)=>{
        if (searchString.length >= 3) {
            setState((prevState)=>({
                    ...prevState,
                    loading: true
                }));
            const fl = "id,sku_s,slug_s,ProductProductNo_s,ProductResource.PartsPDFFileName.resourceFullWebURL_ss";
            constants_api/* apim.get */.TH.get(constants.inPageSearchEndPoint, {
                params: {
                    q: searchString,
                    fl,
                    fq: [
                        'Products:("ct")',
                        'language_s:("'.concat(language, '")')
                    ],
                    collections: lwAppName.toLowerCase(),
                    profilename: "profile_".concat(lwAppName.toLowerCase(), "_Search")
                },
                paramsSerializer: (params)=>{
                    return qs_lib_default().stringify(params, {
                        arrayFormat: "repeat",
                        encode: false
                    });
                }
            }).then((res)=>{
                const { data: { response: { numFound ="" , docs =[]  } = {} , fusion: { exactMatch =""  } = {}  } = {}  } = res;
                if (numFound === 1 && exactMatch) {
                    const mResources = get_default()(docs[0], "ProductResource.InteractiveSVG.resourceName_ss", "");
                    const pdfPartsDiagram = get_default()(docs[0], "ProductResource.PartsPDFFileName.resourceFullWebURL_ss", "");
                    const partId = Array.isArray(mResources) ? mResources[0] : mResources;
                    const productId = get_default()(docs[0], "ProductProductNo_s", "");
                    setState((prevState)=>({
                            ...prevState,
                            partId: partId !== null && partId !== void 0 ? partId : "",
                            productId,
                            loading: false
                        }));
                    setPdfPartsDiagram(pdfPartsDiagram);
                    const isSkuSearch = Boolean(partId) && Boolean(productId) || Boolean(pdfPartsDiagram) && Boolean(pdfPartsDiagram[0]);
                    setIsSkuSearch(isSkuSearch);
                } else {
                    setIsSkuSearch(false);
                    setState((prevState)=>({
                            ...prevState,
                            loading: false
                        }));
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InPageSearch_view, {
        loading: loading,
        partId: partId,
        isSkuSearch: isSkuSearch,
        productId: productId,
        searchString: searchString,
        pdfPartsDiagram: pdfPartsDiagram,
        onChange: handleChange,
        lwAppName: lwAppName,
        language: language,
        ...searchProps
    });
};
/* harmony default export */ var v1_InPageSearch = (InPageSearch);

// EXTERNAL MODULE: ./src/components/ProductDetail/v3/ProductAccordion/index.jsx + 1 modules
var ProductAccordion = __webpack_require__(22644);
;// CONCATENATED MODULE: ./src/components/Default/Title/index.jsx


const Title = (param)=>{
    let { data ={}  } = param;
    const { appliedCssClassNames ="" , text =""  } = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "title ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-title",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: "cmp-title__text",
                children: [
                    text,
                    " "
                ]
            })
        })
    });
};
/* harmony default export */ var Default_Title = (Title);

// EXTERNAL MODULE: ./src/components/Shared/UpsellInstallServices/ProductCardForUpsell/index.jsx + 3 modules
var ProductCardForUpsell = __webpack_require__(8381);
;// CONCATENATED MODULE: ./components/List/v1/List.jsx




const ListComponent = (param)=>{
    let { data ={}  } = param;
    const { siteMapHeading ="" , options =[]  } = data;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const toggleAccordion = ()=>{
        var ref;
        setIsOpen(!isOpen);
        if ((ref = ".sitemap-container-list .cmp-container .list .list-inner .cmp-list__heading") === null || ref === void 0 ? void 0 : ref.includes("active")) {
            document.querySelectorAll(".sitemap-container-list .cmp-container .list .list-inner .cmp-list").css("display", "block");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "list",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "list-inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "cmp-list__heading ".concat(isOpen ? "active" : ""),
                    onClick: toggleAccordion,
                    dangerouslySetInnerHTML: {
                        __html: browser_default().sanitize(siteMapHeading)
                    }
                }),
                options === null || options === void 0 ? void 0 : options.map((opt, index)=>{
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        children: !isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "cmp-list",
                            children: opt === null || opt === void 0 ? void 0 : (ref = opt.subHeaderItem) === null || ref === void 0 ? void 0 : ref.map((subH, subIndex)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                    className: "cmp-page-name",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: subH === null || subH === void 0 ? void 0 : subH.subPageLink,
                                        target: (subH === null || subH === void 0 ? void 0 : subH.isNewTab) ? "_blank" : undefined,
                                        rel: (subH === null || subH === void 0 ? void 0 : subH.subPageLinkRef) ? "noreferrer" : undefined,
                                        children: subH === null || subH === void 0 ? void 0 : subH.subDisplayName
                                    })
                                }, "inner_".concat(subIndex));
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "cmp-list ".concat(lib/* isMobile */.tq && isOpen ? "active-block" : ""),
                            children: opt === null || opt === void 0 ? void 0 : (ref1 = opt.subHeaderItem) === null || ref1 === void 0 ? void 0 : ref1.map((subH, subIndex)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "cmp-page-name",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: subH === null || subH === void 0 ? void 0 : subH.subPageLink,
                                            target: (subH === null || subH === void 0 ? void 0 : subH.isNewTab) ? "_blank" : undefined,
                                            rel: (subH === null || subH === void 0 ? void 0 : subH.subPageLinkRef) ? "noreferrer" : undefined,
                                            children: subH === null || subH === void 0 ? void 0 : subH.subDisplayName
                                        })
                                    }, "inner_".concat(subIndex))
                                });
                            })
                        })
                    }, "outer_".concat(index));
                })
            ]
        })
    });
};
/* harmony default export */ var List = (ListComponent);

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-window-size.mjs
var use_window_size = __webpack_require__(81962);
;// CONCATENATED MODULE: ./components/ManualProductSlider/analytics.js

const FALLBACK_PAGE_TYPE = "page";
const FALLBACK_ZONE = "manual slider";
const getPageType = ()=>{
    var ref, ref1;
    if (false) {}
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    return ((page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType) || (page === null || page === void 0 ? void 0 : (ref1 = page.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.contentType) || (window === null || window === void 0 ? void 0 : window.eventPageType) || FALLBACK_PAGE_TYPE).toString().toLowerCase();
};
const normalizeText = (text)=>{
    return (text || "").toString().trim().toLowerCase();
};
const getAnalyticsUrl = (link)=>{
    if ( false || !link) {
        return "n/a";
    }
    const cleanedLink = (0,helper/* removeAndCleanLink */.xEh)(link);
    if (/^https?:\/\//i.test(cleanedLink)) {
        return cleanedLink;
    }
    if (cleanedLink.startsWith("#")) {
        return "".concat(window.location.origin).concat(window.location.pathname).concat(cleanedLink);
    }
    return "".concat(window.location.origin).concat(cleanedLink.startsWith("/") ? "" : "/").concat(cleanedLink);
};
const getClickInternalLinks = (link)=>{
    if ( false || !link) {
        return "true";
    }
    const cleanedLink = (0,helper/* removeAndCleanLink */.xEh)(link);
    if (cleanedLink.startsWith("/") || cleanedLink.startsWith("#")) {
        return "true";
    }
    if (!/^https?:\/\//i.test(cleanedLink)) {
        return "true";
    }
    return cleanedLink.includes(window.location.hostname) ? "true" : "false";
};
const getManualSliderContainerAnalytics = (sliderTitle)=>{
    const pageType = getPageType();
    const normalizedTitle = normalizeText(sliderTitle) || "rm";
    return JSON.stringify({
        eventName: "".concat(pageType, ":carousel:interaction"),
        eventAction: "".concat(pageType, ":carousel:interaction"),
        internalLinkName: "carousel:".concat(normalizedTitle),
        internalLinkType: "".concat(pageType, ":manual slider"),
        internalLinkZoneName: "".concat(pageType, ":carousel"),
        clickInternalLinks: "true",
        eventType: "carousel",
        internalLinkURL: "n/a",
        internalLinkPosition: "".concat(pageType, ":carousel")
    });
};
const getManualSliderControlAnalytics = (param)=>{
    let { sliderTitle , controlName  } = param;
    const pageType = getPageType();
    const normalizedSliderTitle = normalizeText(sliderTitle) || "rm";
    const normalizedControlName = normalizeText(controlName) || "rm";
    return JSON.stringify({
        eventName: "".concat(pageType, ":carousel:interaction"),
        eventAction: "".concat(pageType, ":carousel:interaction"),
        internalLinkName: "carousel:".concat(normalizedControlName),
        internalLinkType: "".concat(pageType, ":manual slider"),
        internalLinkZoneName: "".concat(pageType, ":").concat(normalizedSliderTitle),
        clickInternalLinks: "true",
        eventType: "carousel",
        internalLinkURL: "n/a",
        internalLinkPosition: "".concat(pageType, ":carousel")
    });
};
const getManualSliderLinkAnalytics = (param)=>{
    let { link , linkName , sliderTitle  } = param;
    const pageType = getPageType();
    const normalizedLinkName = normalizeText(linkName) || "rm";
    const normalizedSliderTitle = normalizeText(sliderTitle) || FALLBACK_ZONE;
    return JSON.stringify({
        clickInternalLinks: getClickInternalLinks(link),
        internalLinkPosition: "".concat(pageType, ":").concat(FALLBACK_ZONE),
        internalLinkZoneName: "".concat(pageType, ":").concat(normalizedSliderTitle),
        internalLinkURL: getAnalyticsUrl(link),
        internalLinkName: normalizedLinkName,
        eventName: "".concat(pageType, ":").concat(normalizedSliderTitle, ":").concat(normalizedLinkName),
        internalLinkType: "".concat(pageType, ":manual slider"),
        eventType: "teaser",
        eventAction: "".concat(pageType, ":").concat(normalizedSliderTitle, ":").concat(normalizedLinkName),
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
};

;// CONCATENATED MODULE: ./components/ManualProductSlider/ManualSlider.jsx
"use client";















const ACCESSIBLE_FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
const ManualSlider = (param)=>{
    let { data  } = param;
    var ref;
    const [general, setGeneral] = (0,react.useState)();
    const { width  } = (0,use_window_size/* useWindowSize */.i)();
    const slickRef = (0,react.useRef)(null);
    const sliderContainerRef = (0,react.useRef)(null);
    const shouldFocusActiveSlideRef = (0,react.useRef)(false);
    const [isTabOrMobile, setIsTabOrMobile] = (0,react.useState)(width < 1024);
    const headingId = (0,react.useId)();
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const [finalProducts, setFinalProducts] = (0,react.useState)([]);
    const [activeSlideAnnouncement, setActiveSlideAnnouncement] = (0,react.useState)("");
    const { emptyCarouselListMsg  } = i18n_useCarouselSlicki18n();
    const isManualSlider = [
        "manualProducts",
        "dynamicProducts"
    ].includes(data === null || data === void 0 ? void 0 : data.productType) || false;
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general  } = await (0,constants_config/* getConfig */.i)();
            setGeneral(general);
        };
        configFn();
    }, []);
    (0,react.useEffect)(()=>{
        setIsTabOrMobile(width < 1024);
    }, [
        width
    ]);
    const eyeBrowText = data === null || data === void 0 ? void 0 : data.eyeBrowText;
    const headerText = (0,helper/* sanitizeText */.oOy)(data === null || data === void 0 ? void 0 : data.headline);
    const bodyText = (0,helper/* sanitizeText */.oOy)(data === null || data === void 0 ? void 0 : data.description);
    const ctaText = isManualSlider ? data === null || data === void 0 ? void 0 : data.moduleCTAText : null;
    const ctaUrl = isManualSlider ? data === null || data === void 0 ? void 0 : data.moduleCtaUrl : null;
    const newTab = (data === null || data === void 0 ? void 0 : data.newTab) || false;
    const headerAlignment = isManualSlider ? "left" : "center";
    const showNavDots = (data === null || data === void 0 ? void 0 : data.navDotsEnabled) || false;
    const productSliderItems = (data === null || data === void 0 ? void 0 : data.products) || [];
    const dynamicProductSliderItems = (data === null || data === void 0 ? void 0 : (ref = data.dynamicFeatureProductDetails) === null || ref === void 0 ? void 0 : ref.productSkuId) || [];
    const sliderType = (data === null || data === void 0 ? void 0 : data.products) ? "manual" : "dynamic";
    const getShowArrowIndication = (defaultValue)=>{
        return (data === null || data === void 0 ? void 0 : data.showArrowIndication) === undefined ? defaultValue : data.showArrowIndication === true;
    };
    const showArrowIndication = getShowArrowIndication(false);
    const hasManualSliderItems = productSliderItems.length > 0;
    const hasDynamicSliderConfig = dynamicProductSliderItems.length > 0;
    const hasDynamicSliderItems = finalProducts.length > 0;
    const totalSlides = hasManualSliderItems ? productSliderItems.length : finalProducts.length;
    const sliderLabel = headerText || eyeBrowText || "Product slider";
    const getSlideNumber = (slideIndex)=>{
        if (totalSlides === 0 || Number.isNaN(slideIndex)) {
            return null;
        }
        return (slideIndex % totalSlides + totalSlides) % totalSlides + 1;
    };
    const getSlideAnnouncement = (slideNumber)=>slideNumber ? "Slide ".concat(slideNumber, " of ").concat(totalSlides) : "";
    const moduleCtaUrl = (0,helper/* getShortenedUrlwithGeneral */.vu1)(ctaUrl, general);
    const moduleCtaAnalytics = getManualSliderLinkAnalytics({
        link: moduleCtaUrl,
        linkName: ctaText || "learn more",
        sliderTitle: sliderLabel
    });
    (0,react.useEffect)(()=>{
        if ((dynamicProductSliderItems === null || dynamicProductSliderItems === void 0 ? void 0 : dynamicProductSliderItems.length) > 0) {
            let skuids = dynamicProductSliderItems;
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                if (Object.keys(config).length > 0) {
                    const language = get_default()(config, "internationalization.language", "en");
                    const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
                    let data = await (0,helper/* fetchFromSkuIds */.BTY)(skuids, lwAppName, language);
                    if (data) {
                        const productData = get_default()(data, "response.docs", {});
                        let availableSkus = productData.map((product)=>product.sku_s);
                        let availableSkus1 = skuids.filter((sku)=>availableSkus.includes(sku));
                        let filteredItemOrder = availableSkus1.map((sku)=>productData.find((product)=>product.sku_s === sku));
                        const productDataWithUrls = await Promise.all(filteredItemOrder.map(async (item)=>{
                            const pdpUrl = await (0,helper/* getPDPUrl */.ir5)(item === null || item === void 0 ? void 0 : item.Product_Category, item === null || item === void 0 ? void 0 : item.slug_s);
                            return {
                                ...item,
                                manualSliderPdpUrl: pdpUrl
                            };
                        }));
                        setFinalProducts(productDataWithUrls);
                        if (slickRef) {
                            var ref;
                            (ref = slickRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(0);
                        }
                    }
                }
            });
        }
    }, [
        dynamicProductSliderItems,
        isAuth
    ]);
    const updateSlideAccessibility = ()=>{
        const sliderNode = sliderContainerRef.current;
        if (!sliderNode) {
            return;
        }
        const slides = sliderNode.querySelectorAll(".slick-slide");
        slides.forEach((slide)=>{
            const isActive = slide.classList.contains("slick-active");
            const slideNumber = getSlideNumber(Number(slide.getAttribute("data-index")));
            slide.setAttribute("role", "group");
            slide.setAttribute("aria-roledescription", "slide");
            slide.setAttribute("aria-label", getSlideAnnouncement(slideNumber) || sliderLabel);
            slide.setAttribute("aria-hidden", isActive ? "false" : "true");
            slide.setAttribute("aria-current", isActive ? "true" : "false");
            slide.querySelectorAll(ACCESSIBLE_FOCUSABLE_SELECTOR).forEach((element)=>{
                if (isActive) {
                    element.removeAttribute("tabindex");
                } else {
                    element.setAttribute("tabindex", "-1");
                }
            });
        });
    };
    const handleSlideFocus = (event)=>{
        var ref;
        const slideNode = event.target.closest(".slick-slide");
        const slideIndex = Number(slideNode === null || slideNode === void 0 ? void 0 : slideNode.getAttribute("data-index"));
        if (!slideNode || slideNode.classList.contains("slick-active") || Number.isNaN(slideIndex)) {
            return;
        }
        (ref = slickRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(slideIndex);
        window.requestAnimationFrame(()=>{
            event.target.focus();
        });
    };
    const focusFirstInteractiveElementInActiveSlide = ()=>{
        const sliderNode = sliderContainerRef.current;
        if (!sliderNode) {
            return;
        }
        const activeSlide = sliderNode.querySelector(".slick-slide.slick-active");
        const firstFocusableElement = activeSlide === null || activeSlide === void 0 ? void 0 : activeSlide.querySelector(ACCESSIBLE_FOCUSABLE_SELECTOR);
        if (firstFocusableElement instanceof HTMLElement) {
            firstFocusableElement.focus();
        } else if (activeSlide instanceof HTMLElement) {
            activeSlide.setAttribute("tabindex", "-1");
            activeSlide.focus();
        }
    };
    const handleSliderKeyDownCapture = (event)=>{
        if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") {
            return;
        }
        const paginationButton = event.target.closest(".slick-dots li button");
        if (paginationButton) {
            shouldFocusActiveSlideRef.current = true;
        }
    };
    const settings = singleSliderSettings({
        showArrowIndication
    });
    const slickSettings = {
        ...settings,
        accessibility: true,
        autoplay: false,
        autoplaySpeed: 5000,
        infinite: false,
        slidesToShow: Math.min(hasManualSliderItems ? productSliderItems.length : finalProducts.length, width >= 1600 ? 4 : width >= 1024 ? 3 : width >= 561 ? 2 : 1),
        slidesToScroll: 1,
        arrows: showArrowIndication,
        prevArrow: settings.prevArrow ? /*#__PURE__*/ react.cloneElement(settings.prevArrow, {
            label: "Previous slide"
        }) : undefined,
        nextArrow: settings.nextArrow ? /*#__PURE__*/ react.cloneElement(settings.nextArrow, {
            label: "Next slide"
        }) : undefined,
        dots: showNavDots,
        centerMode: false,
        pauseOnFocus: true,
        pauseOnHover: true,
        appendDots: (dots)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
                className: "slick-dots",
                "aria-label": "".concat(sliderLabel, " pagination"),
                children: react.Children.map(dots, (dot, idx)=>{
                    var ref, ref1;
                    const isActive = typeof (dot === null || dot === void 0 ? void 0 : (ref = dot.props) === null || ref === void 0 ? void 0 : ref.className) === "string" && dot.props.className.includes("slick-active");
                    const child = dot === null || dot === void 0 ? void 0 : (ref1 = dot.props) === null || ref1 === void 0 ? void 0 : ref1.children;
                    const inner = /*#__PURE__*/ react.isValidElement(child) ? /*#__PURE__*/ react.cloneElement(child, {
                        "aria-label": "Go to slide ".concat(idx + 1),
                        "aria-current": isActive ? "true" : "false",
                        className: "".concat(child.props.className || "", " gbh-data-layer").trim(),
                        "data-gbh-data-layer": getManualSliderControlAnalytics({
                            sliderTitle: sliderLabel,
                            controlName: "slide ".concat(idx + 1)
                        }),
                        type: "button"
                    }) : child;
                    return /*#__PURE__*/ react.cloneElement(dot, {
                        children: inner
                    });
                })
            });
        },
        afterChange: (currentSlide)=>{
            window.requestAnimationFrame(()=>{
                setActiveSlideAnnouncement(getSlideAnnouncement(getSlideNumber(currentSlide)));
                updateSlideAccessibility();
                if (shouldFocusActiveSlideRef.current) {
                    focusFirstInteractiveElementInActiveSlide();
                    shouldFocusActiveSlideRef.current = false;
                }
            });
        }
    };
    (0,react.useEffect)(()=>{
        setActiveSlideAnnouncement(getSlideAnnouncement(totalSlides > 0 ? 1 : null));
    }, [
        totalSlides
    ]);
    (0,react.useEffect)(()=>{
        if (false) {}
        const timer = window.setTimeout(updateSlideAccessibility, 0);
        return ()=>window.clearTimeout(timer);
    }, [
        productSliderItems.length,
        finalProducts.length,
        width,
        showNavDots
    ]);
    const getManualSliderItems = productSliderItems === null || productSliderItems === void 0 ? void 0 : productSliderItems.map((element, i)=>{
        const cardTitle = (0,helper/* sanitizeText */.oOy)(element.cardTitle);
        const cardDescription = (0,helper/* sanitizeText */.oOy)(element.cardDescription);
        const imageAltText = element.imageAltText || cardTitle || "Slide ".concat(i + 1);
        const cardEyeBrowText = element.eyeBrowText || "";
        const cardCtaUrl = (0,helper/* getShortenedUrlwithGeneral */.vu1)(element.cardCtaUrl, general);
        const imageCtaUrl = (0,helper/* getShortenedUrlwithGeneral */.vu1)(element.imageCtaUrl, general);
        const imageLinkLabel = cardTitle ? "".concat(cardTitle, " image") : "Open slide ".concat(i + 1);
        const ctaLabel = element.cardCTAText && cardTitle ? "".concat((0,helper/* sanitizeText */.oOy)(element.cardCTAText), ": ").concat(cardTitle) : (0,helper/* sanitizeText */.oOy)(element.cardCTAText);
        const imageAnalytics = getManualSliderLinkAnalytics({
            link: imageCtaUrl,
            linkName: imageLinkLabel,
            sliderTitle: sliderLabel
        });
        const ctaAnalytics = getManualSliderLinkAnalytics({
            link: cardCtaUrl,
            linkName: (0,helper/* sanitizeText */.oOy)(element.cardCTAText) || cardTitle || "slide ".concat(i + 1),
            sliderTitle: sliderLabel
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "manual-slider-gallery-item-card",
            onFocusCapture: handleSlideFocus,
            children: [
                 true && (element.imageCtaUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    className: "manual-slider-image-link gbh-data-layer",
                    href: imageCtaUrl,
                    target: element.newTab ? "_blank" : "_self",
                    "aria-label": imageLinkLabel,
                    rel: "noreferrer",
                    "data-gbh-data-layer": imageAnalytics,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                        className: "slider-image",
                        imgUrl: element.image,
                        alt: imageAltText,
                        role: "img"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                    className: "slider-image",
                    imgUrl: element.image,
                    alt: imageAltText,
                    role: "img"
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "manual-slider-gallery-content",
                    children: [
                        element.subTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "item-subtitle",
                            children: element.subTitle
                        }) : "",
                        cardEyeBrowText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "item-eyeBrowText",
                            children: cardEyeBrowText
                        }) : "",
                        cardTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "item-cardtitle",
                            children: cardTitle
                        }) : "",
                        cardDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "item-description",
                            children: cardDescription
                        }) : "",
                        element.cardCTAText && element.cardCtaUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "item-cta-url",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                className: "learn-more gbh-data-layer",
                                href: cardCtaUrl,
                                target: element.newTab ? "_blank" : "_self",
                                "aria-label": ctaLabel,
                                rel: "noreferrer",
                                "data-gbh-data-layer": ctaAnalytics,
                                children: (0,helper/* sanitizeText */.oOy)(element.cardCTAText)
                            })
                        }) : ""
                    ]
                })
            ]
        }, "".concat(cardTitle || "manual-slide", "-").concat(i));
    });
    const getDynamicSliderItems = finalProducts === null || finalProducts === void 0 ? void 0 : finalProducts.map((element, index)=>{
        var ref, ref1;
        const productName = (0,helper/* sanitizeText */.oOy)(element === null || element === void 0 ? void 0 : element.ProductBrandName_s) || (0,helper/* sanitizeText */.oOy)(element === null || element === void 0 ? void 0 : element.productName_s) || (0,helper/* sanitizeText */.oOy)(element === null || element === void 0 ? void 0 : element.title_s) || "product ".concat(index + 1);
        const productAnalytics = getManualSliderLinkAnalytics({
            link: element === null || element === void 0 ? void 0 : element.manualSliderPdpUrl,
            linkName: productName,
            sliderTitle: sliderLabel
        });
        var ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCard, {
                    data: {
                        ...element,
                        type: "productSku",
                        productSkuId: element === null || element === void 0 ? void 0 : element.sku_s,
                        presetConfigs: data === null || data === void 0 ? void 0 : (ref = data.dynamicFeatureProductDetails) === null || ref === void 0 ? void 0 : ref.presetConfigs,
                        plpPresetConfigs: data === null || data === void 0 ? void 0 : (ref1 = data.dynamicFeatureProductDetails) === null || ref1 === void 0 ? void 0 : ref1.plpPresetConfigs
                    },
                    product: element,
                    showEmptyPlaceholder: true,
                    singleSku: true,
                    analyticsData: productAnalytics,
                    newTab: newTab
                })
            })
        }, (ref2 = element === null || element === void 0 ? void 0 : element.id) !== null && ref2 !== void 0 ? ref2 : "cpm-carousel-".concat(index, "-").concat((0,helper/* getRandom */.sZz)()));
    });
    const renderMobileCTA = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "manual-slider-cta-mobile",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            className: "cmp-teaser__action-link gbh-secondary-button active manual-slider-cta-text gbh-data-layer",
            href: moduleCtaUrl,
            target: newTab ? "_blank" : "_self",
            "aria-label": ctaText,
            rel: "noreferrer",
            "data-gbh-data-layer": moduleCtaAnalytics,
            children: ctaText
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "manual-slider",
        role: "region",
        "aria-label": !headerText ? sliderLabel : undefined,
        "aria-labelledby": headerText ? headingId : undefined,
        "aria-roledescription": "carousel",
        ref: sliderContainerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                "aria-live": "polite",
                "aria-atomic": "true",
                children: activeSlideAnnouncement
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(sliderType, "-slider-header"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(sliderType, "-slider-header-").concat(headerAlignment),
                        children: [
                            eyeBrowText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(sliderType, "-slider-eyebrow-text"),
                                children: eyeBrowText
                            }),
                            headerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "".concat(sliderType, "-slider-header-text"),
                                id: headingId,
                                children: headerText
                            }),
                            bodyText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(sliderType, "-slider-body-text"),
                                children: bodyText
                            })
                        ]
                    }),
                    headerAlignment === "left" && !isTabOrMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(sliderType, "-slider-header-right"),
                        children: ctaText && ctaUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            className: "cmp-teaser__action-link gbh-secondary-button active manual-slider-cta-text gbh-data-layer",
                            href: moduleCtaUrl,
                            target: newTab ? "_blank" : "_self",
                            "aria-label": ctaText,
                            rel: "noreferrer",
                            "data-gbh-data-layer": moduleCtaAnalytics,
                            children: ctaText
                        }) : null
                    }) : null
                ]
            }),
            hasManualSliderItems && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "manual-slider-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "manual-slider-items",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onKeyDownCapture: handleSliderKeyDownCapture,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                    ...slickSettings,
                                    ref: slickRef,
                                    children: hasManualSliderItems ? getManualSliderItems : null
                                }, "manual-slider-gallery")
                            })
                        })
                    }),
                    headerAlignment === "left" && ctaText && ctaUrl && isTabOrMobile ? renderMobileCTA : null
                ]
            }),
            hasDynamicSliderConfig && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dynamic-slider-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dynamic-slider-items",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onKeyDownCapture: handleSliderKeyDownCapture,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    !hasDynamicSliderItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-carousel__description",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: emptyCarouselListMsg
                                        })
                                    }),
                                    hasDynamicSliderItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                        ...slickSettings,
                                        ref: slickRef,
                                        children: getDynamicSliderItems
                                    }, "dynamic-slider-gallery")
                                ]
                            })
                        })
                    }),
                    headerAlignment === "left" && ctaText && ctaUrl && isTabOrMobile ? renderMobileCTA : null
                ]
            })
        ]
    });
};
/* harmony default export */ var ManualProductSlider_ManualSlider = (ManualSlider);

;// CONCATENATED MODULE: ./components/AemGrid.jsx











































const AemGrid = (props)=>{
    var ref, ref1;
    const { data ={} , itemKey ="" , count =0 , eventHandler ={} , fullData ={} , containerId ="" , ...extraProps } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { changePassword =()=>{} , contactUs =()=>{} , technicalSpecifications =()=>{}  } = extraProps;
    (0,react.useEffect)(()=>{
        if ((0,utils/* isAuthModal */.S)(data)) {
            dispatch((0,authSlice/* setAuthModalStaticText */.vu)(data));
        }
        if ((0,utils/* isCompareProducts */.Be)(data)) {
            dispatch((0,genericSlice/* setCompareproductsStaticText */.rA)(data));
        }
        if ((0,utils/* isNewsLetter */.C_)(data)) {
            dispatch((0,genericSlice/* setSubscribeModalContent */.ml)(data));
        }
        if ((0,utils/* isSiteWideWarning */.yd)(data)) {
            dispatch((0,genericSlice/* setSitewideWarningContent */.FV)(data));
        }
        if ((0,utils/* isNewsLetterSignUp */.f5)(data)) {
            dispatch((0,genericSlice/* setSitewideNewsLetterContent */._r)(data));
        }
        if ((0,utils/* isToaster */.bu)(data)) {
            dispatch((0,genericSlice/* setToastContent */.Ji)(data));
        }
        if ((0,utils/* isStoreFilter */.Ov)(data)) {
            dispatch((0,locationSlice/* setStoreFilter */.Ey)(data));
        }
    }, [
        data
    ]);
    if ((0,utils/* isVideo */.Wv)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Video, {
            data: data
        });
    }
    if ((0,utils/* isButton */.iK)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            data: data,
            label: data.text,
            className: data.appliedCssClassNames
        });
    }
    if ((0,utils/* isSpacer */.MW)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Spacer, {
            data: data
        });
    }
    if ((0,utils/* isManualProductSlider */.NX)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ManualProductSlider_ManualSlider, {
            data: data
        });
    }
    if ((0,utils/* isAemForm */.np)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default_AemForm, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isManualPDP */.r9)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ManualPdp, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isManualPDP_TABS */.Nf)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AsProductTabDetail, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isProductcard */.po)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCard, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isBlogCarousel */.Y9)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_BlogCarousel, {
            data: data
        });
    }
    if ((0,utils/* isBlogListing */.bP)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogList, {
            data: data
        });
    }
    if ((0,utils/* isAsProductList */.r1)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductList, {
            data: data
        });
    }
    if ((0,utils/* isCarousel */.C2)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Carousel, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isPromoBanner */.e7)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PromoBanner, {
            data: data
        });
    }
    if ((0,utils/* isTitle */.Wt)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default_Title, {
            data: data
        });
    }
    if ((0,utils/* isSlick */.bd)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CarouselSlick, {
            fullData: fullData,
            data: data
        });
    }
    if ((0,utils/* isTeaserV2 */.wX)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_Teaser, {
            data: data
        });
    }
    if ((0,utils/* isTeaser */.j$)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isProductCardV4 */.LV)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardForUpsell/* default */.Z, {
            authData: data
        }) : null;
    }
    if ((0,utils/* isProductcardV3 */.DN)(data)) {
        const { skewId ="" , presetConfigs =""  } = data;
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "productcard-v3 productcard",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductCard/* default */.Z, {
                authorData: {
                    skewId,
                    presetConfigs
                },
                fullData: fullData
            })
        }) : null;
    }
    if ((0,utils/* isText */.Gs)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Text, {
            data: data
        });
    }
    if ((0,utils/* isTab */.wR)(data) && data["appliedCssClassNames"]) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default_Tab, {
            data: data
        });
    }
    if ((0,utils/* isBrandHeader */.cD)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandHeader, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isHeaderNav */.ZS)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNav, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isEmbed */.P2)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Embed, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isFooter */.cl)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Footer, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isLogoHeader */.mp)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_LogoHeader, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isBrandNav */.P4)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandNav, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isImage */.Or)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Image, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isCartLanding */.l1)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.landing && extraProps.landing(data);
        } else {
            return extraProps && extraProps.landingFiller && extraProps.landingFiller(data);
        }
    }
    if ((0,utils/* isInPageSearch */.L8)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_InPageSearch, {
            data: data
        }) : null;
    }
    if ((0,utils/* isLeadGeneration */.iP)(data)) {
        return extraProps && extraProps.leadGeneration && extraProps.leadGeneration(data);
    }
    if ((0,utils/* isInspirationLanding */.ej)(data)) {
        return extraProps && extraProps.inspirationLanding && extraProps.inspirationLanding(data);
    }
    if ((0,utils/* isInspirationDetail */.M$)(data)) {
        return extraProps && extraProps.inspirationDetail && extraProps.inspirationDetail(data);
    }
    if ((0,utils/* isPressLanding */.GX)(data) && !isSsr) {
        return extraProps && extraProps.pressReleaseLanding && extraProps.pressReleaseLanding(data);
    }
    if ((0,utils/* isTradeMembership */.NG)(data)) {
        return extraProps && extraProps.tradeMembership && extraProps.tradeMembership(data);
    }
    if ((0,utils/* isCheckoutLanding */.Ar)(data) && !isSsr) {
        return extraProps && extraProps.checkoutView && extraProps.checkoutView(data);
    }
    if ((0,utils/* isOrderConfirmation */.Uq)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderConfirmation && extraProps.orderConfirmation(data);
        } else {
            return extraProps && extraProps.orderConfirmationTagFiller && extraProps.orderConfirmationTagFiller();
        }
    }
    if ((0,utils/* isOrderStatus */.K0)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderStatus && extraProps.orderStatus(data);
        } else {
            return extraProps && extraProps.orderStatusFiller && extraProps.orderStatusFiller();
        }
    }
    if ((0,utils/* isOrderHistory */._$)(data) && !isSsr) {
        return extraProps && extraProps.orderHistory && extraProps.orderHistory(data);
    }
    if ((0,utils/* isOrderDetails */.pv)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderDetails && extraProps.orderDetails(data);
        } else {
            return extraProps && extraProps.orderDetailsFiller && extraProps.orderDetailsFiller(data);
        }
    }
    if ((0,utils/* isPairsWellWth */.oC)(data) && !isSsr) {
        return extraProps && extraProps.pairsWellWith && extraProps.pairsWellWith(data);
    }
    if ((0,utils/* isSharedCart */.sL)(data) && !isSsr) {
        return extraProps && extraProps.sharedCart && extraProps.sharedCart(data);
    }
    if ((0,utils/* isBreadcrumb */.Z3)(data)) {
        return extraProps && extraProps.breadCrumb && extraProps.breadCrumb(data, fullData);
    }
    if ((0,utils/* isProductList */.Hx)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.productList && extraProps.productList(data, eventHandler);
        } else {
            return extraProps && extraProps.productListFiller && extraProps.productListFiller(data);
        }
    }
    if ((0,utils/* isSearch */.N)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.searchComponent && extraProps.searchComponent(data, eventHandler);
        } else {
            return extraProps && extraProps.searchFiller && extraProps.searchFiller(data);
        }
    }
    if ((0,utils/* isHelpSupport */.zK)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_HelpSupport, {
            data: data
        });
    }
    if ((0,utils/* isAccountSettings */.mg)(data) && !isSsr) {
        return extraProps && extraProps.accountSettings && extraProps.accountSettings(data);
    }
    if ((0,utils/* isMyservice */.U4)(data) && !isSsr) {
        return extraProps && extraProps.myServices && extraProps.myServices(data);
    }
    if ((0,utils/* isMyFavorites */.we)(data) && !isSsr) {
        return extraProps && extraProps.myFavorites && extraProps.myFavorites(data);
    }
    if ((0,utils/* isMyproducts */.Dx)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.myProducts && extraProps.myProducts(data);
        } else {
            return extraProps && extraProps.myProductsFiller && extraProps.myProductsFiller();
        }
    }
    if ((0,utils/* isLiterature */.ek)(data) && !isSsr) {
        return extraProps && extraProps.literature && extraProps.literature(data);
    }
    if ((0,utils/* isProductDetails */.jS)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.productDetail && extraProps.productDetail(data, extraProps === null || extraProps === void 0 ? void 0 : extraProps.slug, extraProps === null || extraProps === void 0 ? void 0 : extraProps.skuId, extraProps === null || extraProps === void 0 ? void 0 : extraProps.type);
        } else {
            return extraProps && extraProps.productDetailFiller && extraProps.productDetailFiller(data);
        }
    }
    if ((0,utils/* isProductAccordion */.eq)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion/* default */.Z, {
            data: data
        });
    }
    if ((0,utils/* isProductAccordion */.eq)(data) && !isSsr) {
        return extraProps && extraProps.productAccordion && extraProps.productAccordion(data);
    }
    if ((0,utils/* isProductExfPdp */.V6)(data) && !isSsr) {
        return extraProps && extraProps.productExf && extraProps.productExf(data);
    }
    if ((0,utils/* isProductReview */.s3)(data) && !isSsr) {
        return extraProps && extraProps.review && extraProps.review(data);
    }
    if ((0,utils/* isRegisterOffline */.hn)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.offlineProducts && extraProps.offlineProducts(data);
        } else {
            return extraProps && extraProps.offlineProducts && extraProps.offlineProductsFiller();
        }
    }
    if ((0,utils/* isRegisterOnline */.L)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.onlineProducts && extraProps.onlineProducts(data);
        } else {
            return extraProps && extraProps.onlineProducts && extraProps.offlineProductsFiller();
        }
    }
    if ((0,utils/* isKnowledgeArticle */.Mc)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.knowledgeArticle && extraProps.knowledgeArticle(data);
        } else {
            return extraProps && extraProps.knowledgeArticleFiller && extraProps.knowledgeArticleFiller();
        }
    }
    if ((0,utils/* isBrowseAllStores */.MN)(data) && !isSsr) {
        return extraProps && extraProps.browseAllStores && extraProps.browseAllStores(data);
    }
    if ((0,utils/* isFindAStoreLandingV2 */.wG)(data) && !isSsr) {
        return extraProps && extraProps.findashowroom && extraProps.findashowroom(data);
    }
    if ((0,utils/* isContactUs */.OL)(data) && !isSsr) {
        return contactUs(data);
    }
    if ((0,utils/* isFindingModelNumber */.iL)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindingModelNumber, {
            data: data
        });
    }
    if ((0,utils/* isChangePassword */.Si)(data)) {
        if (!isSsr) {
            return changePassword(data);
        } else {
            return "Loading...";
        }
    }
    if ((0,utils/* isProductTabDetails */.u_)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.productTabDetails && extraProps.productTabDetails(data);
        }
    }
    if ((0,utils/* isProductDetails */.jS)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.productDetail && extraProps.productDetail(data, extraProps === null || extraProps === void 0 ? void 0 : extraProps.slug, extraProps === null || extraProps === void 0 ? void 0 : extraProps.skuId);
        } else {
            return extraProps && extraProps.productDetailFiller && extraProps.productDetailFiller(data);
        }
    }
    if ((0,utils/* isTechnicalSpec */.HR)(data)) {
        return technicalSpecifications && technicalSpecifications(data);
    }
    if ((0,utils/* isList */.nq)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
            data: data
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                condition: (data === null || data === void 0 ? void 0 : data[":itemsOrder"]) && (data === null || data === void 0 ? void 0 : (ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.length) === 1 && (data === null || data === void 0 ? void 0 : (ref1 = data[":itemsOrder"]) === null || ref1 === void 0 ? void 0 : ref1.includes("text")) && !(0,utils/* isTeaserContainer */.xW)(data),
                wrapper: (children)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: data === null || data === void 0 ? void 0 : data.gridClassNames,
                        children: children
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGridColumn, {
                    data: data,
                    itemKey: itemKey,
                    count: count,
                    eventHandler: eventHandler,
                    containerId: containerId,
                    ...extraProps
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "fb-pixel",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "\n        !function(f,b,e,v,n,t,s)\n        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n        n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n        n.queue=[];t=b.createElement(e);t.async=!0;\n        t.src=v;s=b.getElementsByTagName(e)[0];\n        s.parentNode.insertBefore(t,s)}(window,document,'script',\n        'https://connect.facebook.net/en_US/fbevents.js');\n        fbq('init', '682865165183330');\n        fbq('track', 'PageView');\n        "
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    height: "1",
                    width: "1",
                    src: "https://www.facebook.com/tr?id=682865165183330&ev=PageView &noscript=1"
                })
            })
        ]
    });
};
/* harmony default export */ var components_AemGrid = (AemGrid);


/***/ }),

/***/ 10884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3939);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27514);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88751);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47956);








const GlobalPageFooter = (props)=>{
    const { footer , footerScripting  } = props;
    const [scripts, setScripts] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const { pageIsInteractive  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .selectGenericState */ .Px);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const pageLevelDetails = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getPageLevelScriptsAndStyles */ .ptY)(footerScripting);
        setScripts(pageLevelDetails["pageScripts"]);
    }, [
        footerScripting
    ]);
    // useEffect(() => {
    //   getScriptsAndStyles(footer)         //  AS-11462
    // }, [footer])
    const eventHandler = {
        store: {},
        callbacks: {
            setGlobalScripts: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setGlobalScripts */ .n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setGlobalStyles */ .cw)(item));
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        children: [
            pageIsInteractive && (scripts === null || scripts === void 0 ? void 0 : scripts.map((script, i)=>{
                if (script.src) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: script.src,
                    type: script.type,
                    integrity: script.integrity,
                    id: "footerscript-".concat(i)
                }, "footerscript-".concat(i));
                if (!script.src && script.innerHTML) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                    id: "footerscript-".concat(i),
                    children: "".concat(script.innerHTML)
                }, "footerscript-".concat(i));
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                data: footer,
                count: 0,
                eventHandler: eventHandler,
                fragment: _constants_index__WEBPACK_IMPORTED_MODULE_7__.FRAGMENT_TYPES.FOOTER
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GlobalPageFooter);


/***/ }),

/***/ 82660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GlobalPage_GlobalPageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(51857);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/utils.js


const checkSingleNonEmptyLevelThreeNavMulti = (data)=>{
    let nonEmptyLevelThreeNavMultiIndex = -1;
    let nonEmptyLevelThreeNavMultiCount = 0;
    for(let i = 0; i < data.length; i++){
        for (const levelTwoNavMulti of data[i].levelTwoNavMulti){
            if (levelTwoNavMulti.levelThreeNavMulti.length >= 1) {
                nonEmptyLevelThreeNavMultiCount++;
                if (nonEmptyLevelThreeNavMultiCount > 1) {
                    return -1 // More than one non-empty levelThreeNavMulti found
                    ;
                } else {
                    nonEmptyLevelThreeNavMultiIndex = i;
                }
            }
        }
    }
    return nonEmptyLevelThreeNavMultiIndex;
};
const modifyHref = (link)=>{
    return link === null || link === void 0 ? void 0 : link.split(constants.previewContentPrefix).join("").replace(".html", "");
};
const closestAnchorHref = (e)=>{
    return !e.target.closest("a").getAttribute("href");
};
const pureText = (text)=>{
    var ref;
    return (ref = getPureText(text)) === null || ref === void 0 ? void 0 : ref.trim();
};
const pureTextWithoutSpace = (text)=>{
    const pureTextTitle = getPureText(text).trim().toLowerCase();
    return pureTextTitle.split(" ").join("-").replace("&amp;-", "").replace("&-", "");
};

// EXTERNAL MODULE: ./utils/textUtils.js
var textUtils = __webpack_require__(89299);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./components/DesignSystem/utils/navigationHelper.js
/**
 * Helper functions for navigation mapping
 */ /**
 * Recursively searches an object tree to find an item by name
 * @param {Object} obj - Object tree to search
 * @param {string} name - Name to search for
 * @return {Object|null} Found item or null
 */ 



const findItemByName = (obj, name)=>{
    // Check if obj is null/undefined first
    if (!obj) return {};
    // If we have :items, check them first
    if (obj[":items"]) {
        // Look through each key in :items
        for (const key of Object.keys(obj[":items"])){
            // If key contains our search name
            if (key.includes(name)) {
                return obj[":items"][key];
            }
            // If this item has nested :items, recurse into them
            const result = findItemByName(obj[":items"][key], name);
            if (result) return result;
        }
    }
    // Return empty object instead of null to allow safe property access
    return null;
};
const hasHeaderItems = (header)=>{
    if (header[":items"]) {
        for (const key of Object.keys(header[":items"])){
            if (header[":items"][key][":items"] && Object.keys(header[":items"][key][":items"]).length > 0) {
                return true;
            }
        }
    }
    return false;
};
/**
 * Extracts menu items from a navigation object
 * @param {Object} obj - Navigation object
 * @return {Array} Array of menu items
 */ function getMenuItems(obj) {
    const result = [];
    // Check if object has itemsOrder
    if (obj === null || !obj[":itemsOrder"]) return result;
    // Iterate through itemsOrder
    for (const itemKey of obj[":itemsOrder"]){
        const item = obj[":items"][itemKey];
        // For each item, check its :items
        // if (item[":items"]) {
        // Look for keys containing globalnavigation_v3
        for (const key of Object.keys(item === null || item === void 0 ? void 0 : item[":items"])){
            if (key.includes("globalnavigation")) {
                var _appliedCssClassNames;
                result.push({
                    ...item[":items"][key],
                    appliedCssClassNames: (_appliedCssClassNames = item.appliedCssClassNames) !== null && _appliedCssClassNames !== void 0 ? _appliedCssClassNames : ""
                });
            } else {
                result.push({});
            }
        }
    }
    return result;
}
const checkForBusinessLevelOneArray = (obj)=>{
    if (!(obj === null || obj === void 0 ? void 0 : obj.levelOneNavMulti)) return false;
    return obj.levelOneNavMulti.some((levelOne)=>{
        if (!(levelOne === null || levelOne === void 0 ? void 0 : levelOne.levelTwoNavMulti)) return false;
        // Check if all levelTwo items have empty levelThreeNavMulti arrays
        return levelOne.levelTwoNavMulti.every((levelTwo)=>{
            var ref;
            return (levelTwo === null || levelTwo === void 0 ? void 0 : (ref = levelTwo.levelThreeNavMulti) === null || ref === void 0 ? void 0 : ref.length) === 0;
        });
    });
};
const transformArray = (obj, tabTitle)=>{
    var ref;
    const res = [];
    (ref = obj["levelOneNavMulti"]) === null || ref === void 0 ? void 0 : ref.forEach((item)=>{
        var ref;
        const levelTwoArray = [];
        item === null || item === void 0 ? void 0 : (ref = item.levelTwoNavMulti) === null || ref === void 0 ? void 0 : ref.forEach((levelTwo)=>{
            var ref, ref1, ref2, ref3;
            levelTwoArray.push({
                title: {
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                            clickInternalLinks: modifyHref(levelTwo.groupLink) ? "true" : "false",
                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle)).toLowerCase(),
                            internalLinkURL: levelTwo.groupLink ? (ref = "".concat(levelTwo.groupLink.indexOf("http") === -1 ?  true && window.location.origin : "").concat(modifyHref(levelTwo.groupLink))) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "n/a"
                        })
                    },
                    text: (0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle),
                    href: modifyHref(levelTwo.groupLink),
                    target: levelTwo.newTabGroup ? "_blank" : "_self"
                },
                isCTA: (ref1 = levelTwo.groupTitle) === null || ref1 === void 0 ? void 0 : ref1.includes("carrot-icon"),
                items: ((ref2 = levelTwo.levelThreeNavMulti) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? (ref3 = levelTwo.levelThreeNavMulti) === null || ref3 === void 0 ? void 0 : ref3.map((levelThree)=>{
                    var ref;
                    return {
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: modifyHref(levelThree.link) ? "true" : "false",
                                internalLinkName: (ref = "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle), " > ").concat((0,textUtils/* sanitizeText */.o)(levelThree.label))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                internalLinkURL: levelThree.link ? "".concat(levelThree.link.indexOf("http") === -1 ?  true && window.location.origin : "").concat(modifyHref(levelThree.link)).toLowerCase() : "n/a"
                            })
                        },
                        text: (0,textUtils/* sanitizeText */.o)(levelThree.label),
                        href: modifyHref(levelThree.link),
                        target: levelThree.newTab ? "_blank" : "_self"
                    };
                }) : undefined
            });
        });
        res.push(levelTwoArray);
    });
    return res;
};
const transformBusinessArray = (obj, tabTitle)=>{
    var ref;
    const res = [];
    (ref = obj["levelOneNavMulti"]) === null || ref === void 0 ? void 0 : ref.forEach((item)=>{
        // Check if this levelOne item has all empty levelThreeNavMulti arrays
        if (checkForBusinessLevelOneArray({
            levelOneNavMulti: [
                item
            ]
        })) {
            var ref;
            // If true, create a simplified structure with just titles and links
            const simplifiedStructure = {
                items: ((ref = item.levelTwoNavMulti) === null || ref === void 0 ? void 0 : ref.map((levelTwo)=>{
                    var ref, ref1;
                    return {
                        title: {
                            text: (0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle),
                            href: modifyHref(levelTwo.groupLink),
                            trackingAttributes: {
                                "data-datalayer-id": "kds-element-navigation",
                                "data-datalayer-data": JSON.stringify({
                                    clickInternalLinks: modifyHref(levelTwo.groupLink) ? "true" : "false",
                                    internalLinkName: (ref = "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                    internalLinkURL: levelTwo.groupLink ? (ref1 = "".concat(levelTwo.groupLink.indexOf("http") === -1 ?  true && window.location.origin : "").concat(modifyHref(levelTwo.groupLink))) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase() : "n/a"
                                })
                            }
                        },
                        newTabGroup: levelTwo.newTabGroup
                    };
                })) || []
            };
            res.push(simplifiedStructure);
        } else {
            var ref1;
            // If false, keep the existing structure with tracking attributes
            const levelTwoArray = [];
            item === null || item === void 0 ? void 0 : (ref1 = item.levelTwoNavMulti) === null || ref1 === void 0 ? void 0 : ref1.forEach((levelTwo)=>{
                var ref, ref1, ref2, ref3;
                levelTwoArray.push({
                    title: {
                        text: (0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle),
                        href: modifyHref(levelTwo.groupLink),
                        target: levelTwo.newTabGroup ? "_blank" : "_self",
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: modifyHref(levelTwo.groupLink) ? "true" : "false",
                                internalLinkName: (ref = "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                internalLinkURL: levelTwo.groupLink ? (ref1 = "".concat(levelTwo.groupLink.indexOf("http") === -1 ?  true && window.location.origin : "").concat(modifyHref(levelTwo.groupLink))) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase() : "n/a"
                            })
                        }
                    },
                    items: ((ref2 = levelTwo.levelThreeNavMulti) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? (ref3 = levelTwo.levelThreeNavMulti) === null || ref3 === void 0 ? void 0 : ref3.map((levelThree)=>{
                        var ref;
                        return {
                            text: (0,textUtils/* sanitizeText */.o)(levelThree.label),
                            href: modifyHref(levelThree.link),
                            target: levelThree.newTab ? "_blank" : "_self",
                            trackingAttributes: {
                                "data-datalayer-id": "kds-element-navigation",
                                "data-datalayer-data": JSON.stringify({
                                    clickInternalLinks: modifyHref(levelThree.link) ? "true" : "false",
                                    internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle), " > ").concat((0,textUtils/* sanitizeText */.o)(levelThree.label)).toLowerCase(),
                                    internalLinkURL: levelThree.link ? (ref = "".concat(levelThree.link.indexOf("http") === -1 ?  true && window.location.origin : "").concat(modifyHref(levelThree.link))) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "n/a"
                                })
                            }
                        };
                    }) : undefined
                });
            });
            res.push(levelTwoArray);
        }
    });
    return res;
};
/**
 * Gets panel titles from a navigation object
 * @param {Object} obj - Navigation object
 * @return {Array<string>} Array of panel titles
 */ function getPanelTitles(obj) {
    // Check if object has required properties
    if (obj === null || !obj[":itemsOrder"] || !obj[":items"]) return [];
    // Get an array of titles
    const titles = obj[":itemsOrder"].map((key)=>{
        const item = obj[":items"][key];
        return item["cq:panelTitle"] || "";
    });
    return titles;
}
//new function - non stock nav
function getTabTitles(obj) {
    // Check if object has required properties
    if (obj === null || !obj[":itemsOrder"] || !obj[":items"]) return [];
    // Get an array of titles
    const titles = obj[":itemsOrder"].map((key)=>{
        const item = obj[":items"][key];
        return item["cq:panelTitle"] || "";
    });
    return titles;
}
function getTabDetails(obj) {
    // Check if object has required properties
    if (obj === null || !obj[":itemsOrder"] || !obj[":items"]) return [];
    // Get all menu items once
    const tabMenuItems = getMenuItems(obj);
    // Get an array of tab detail objects
    const titles = obj[":itemsOrder"].map((key, index)=>{
        var ref, ref1, ref2, ref3;
        const item = obj[":items"][key];
        // Find tabs and recursively get tab details if they exist
        const tabsObj = findItemByName(item, "tabs");
        const tabTitles = tabsObj && tabsObj[":itemsOrder"] ? getTabDetails(tabsObj) : [];
        // Get the menu item for this index if it exists
        const menuItem = tabMenuItems[index];
        // Get imageOrientation from menuItem (from AEM JSON)
        const imageOrientation = (menuItem === null || menuItem === void 0 ? void 0 : menuItem.imageOrientation) || "portrait";
        // Transform the menu item if it exists
        const menuItemTransformed = menuItem ? transformArray(menuItem, menuItem["cq:panelTitle"]) : [];
        // Build images array with null checks
        const tabTitle = item["cq:panelTitle"] || "";
        const images = [];
        if (menuItem === null || menuItem === void 0 ? void 0 : (ref = menuItem.firstImagesblock) === null || ref === void 0 ? void 0 : ref.firstImageFileReference) {
            var ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            images.push({
                image: {
                    src: menuItem.firstImagesblock.firstImageFileReference || "",
                    alt: menuItem.firstImagesblock.altText || "",
                    "data-mode": "smartcrop",
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                            clickInternalLinks: modifyHref(menuItem.firstImagesblock.ctaLink) ? "true" : "false",
                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)((menuItem === null || menuItem === void 0 ? void 0 : (ref4 = menuItem.firstImagesblock) === null || ref4 === void 0 ? void 0 : ref4.firstImageTitle) || ""), " > img_").concat((menuItem === null || menuItem === void 0 ? void 0 : (ref5 = menuItem.firstImagesblock) === null || ref5 === void 0 ? void 0 : ref5.ctaLabel) || "").toLowerCase(),
                            internalLinkURL: modifyHref(menuItem.firstImagesblock.ctaLink) ? "".concat(((ref6 = modifyHref(menuItem.firstImagesblock.ctaLink)) === null || ref6 === void 0 ? void 0 : ref6.indexOf("http")) === -1 ?  true && window.location.origin : "").concat(modifyHref(menuItem.firstImagesblock.ctaLink)) : "n/a"
                        })
                    }
                },
                imageOrientation,
                caption: {
                    text: (menuItem === null || menuItem === void 0 ? void 0 : (ref7 = menuItem.firstImagesblock) === null || ref7 === void 0 ? void 0 : ref7.firstImageTitle) ? (0,textUtils/* sanitizeText */.o)(menuItem.firstImagesblock.firstImageTitle) : ""
                },
                multiCTA: Array.isArray(menuItem === null || menuItem === void 0 ? void 0 : menuItem.multiCTA) ? menuItem.multiCTA.map((elem)=>{
                    var ref;
                    return {
                        text: (0,textUtils/* sanitizeText */.o)((elem === null || elem === void 0 ? void 0 : elem.ctaLabel) || ""),
                        href: modifyHref(elem === null || elem === void 0 ? void 0 : elem.ctaLink),
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: modifyHref(menuItem.firstImagesblock.ctaLink) ? "true" : "false",
                                internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)((elem === null || elem === void 0 ? void 0 : elem.ctaLabel) || "")).toLowerCase(),
                                internalLinkURL: modifyHref(elem === null || elem === void 0 ? void 0 : elem.ctaLink) ? "".concat(((ref = modifyHref(elem.ctaLink)) === null || ref === void 0 ? void 0 : ref.indexOf("http")) === -1 ?  true && window.location.origin : "").concat(modifyHref(elem.ctaLink)) : "n/a"
                            })
                        }
                    };
                }) : [],
                CTA: (menuItem === null || menuItem === void 0 ? void 0 : (ref8 = menuItem.firstImagesblock) === null || ref8 === void 0 ? void 0 : ref8.ctaLabel) ? {
                    text: menuItem.firstImagesblock.ctaLabel,
                    href: modifyHref(menuItem.firstImagesblock.ctaLink),
                    target: menuItem.firstImagesblock.ctaNewTab ? "_blank" : undefined,
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                            clickInternalLinks: modifyHref(menuItem.firstImagesblock.ctaLink) ? "true" : "false",
                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)((menuItem === null || menuItem === void 0 ? void 0 : (ref9 = menuItem.firstImagesblock) === null || ref9 === void 0 ? void 0 : ref9.firstImageTitle) || ""), " > img_").concat((menuItem === null || menuItem === void 0 ? void 0 : (ref10 = menuItem.firstImagesblock) === null || ref10 === void 0 ? void 0 : ref10.ctaLabel) || "").toLowerCase(),
                            internalLinkURL: modifyHref(menuItem.firstImagesblock.ctaLink) ? "".concat(((ref11 = modifyHref(menuItem.firstImagesblock.ctaLink)) === null || ref11 === void 0 ? void 0 : ref11.indexOf("http")) === -1 ?  true && window.location.origin : "").concat(modifyHref(menuItem.firstImagesblock.ctaLink)) : "n/a"
                        })
                    }
                } : undefined
            });
        }
        if (menuItem === null || menuItem === void 0 ? void 0 : (ref1 = menuItem.secondImagesblock) === null || ref1 === void 0 ? void 0 : ref1.secondImageFileReference) {
            var ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
            images.push({
                image: {
                    src: menuItem.secondImagesblock.secondImageFileReference || "",
                    alt: menuItem.secondImagesblock.altText || "",
                    "data-mode": "smartcrop",
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                            clickInternalLinks: modifyHref(menuItem.secondImagesblock.ctaLink) ? "true" : "false",
                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)((menuItem === null || menuItem === void 0 ? void 0 : (ref12 = menuItem.secondImagesblock) === null || ref12 === void 0 ? void 0 : ref12.secondImageTitle) || ""), " > img_").concat((menuItem === null || menuItem === void 0 ? void 0 : (ref13 = menuItem.secondImagesblock) === null || ref13 === void 0 ? void 0 : ref13.ctaLabel) || "").toLowerCase(),
                            internalLinkURL: modifyHref(menuItem.secondImagesblock.ctaLink) ? "".concat(((ref14 = modifyHref(menuItem.secondImagesblock.ctaLink)) === null || ref14 === void 0 ? void 0 : ref14.indexOf("http")) === -1 ?  true && window.location.origin : "").concat(modifyHref(menuItem.secondImagesblock.ctaLink)) : "n/a"
                        })
                    }
                },
                imageOrientation,
                caption: {
                    text: (menuItem === null || menuItem === void 0 ? void 0 : (ref15 = menuItem.secondImagesblock) === null || ref15 === void 0 ? void 0 : ref15.secondImageTitle) ? (0,textUtils/* sanitizeText */.o)(menuItem.secondImagesblock.secondImageTitle) : ""
                },
                CTA: (menuItem === null || menuItem === void 0 ? void 0 : (ref16 = menuItem.secondImagesblock) === null || ref16 === void 0 ? void 0 : ref16.ctaLabel) ? {
                    text: menuItem.secondImagesblock.ctaLabel,
                    href: modifyHref(menuItem.secondImagesblock.ctaLink),
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                            clickInternalLinks: modifyHref(menuItem.secondImagesblock.ctaLink) ? "true" : "false",
                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)((menuItem === null || menuItem === void 0 ? void 0 : (ref17 = menuItem.secondImagesblock) === null || ref17 === void 0 ? void 0 : ref17.secondImageTitle) || ""), " > img_").concat((menuItem === null || menuItem === void 0 ? void 0 : (ref18 = menuItem.secondImagesblock) === null || ref18 === void 0 ? void 0 : ref18.ctaLabel) || "").toLowerCase(),
                            internalLinkURL: modifyHref(menuItem.secondImagesblock.ctaLink) ? "".concat(((ref19 = modifyHref(menuItem.secondImagesblock.ctaLink)) === null || ref19 === void 0 ? void 0 : ref19.indexOf("http")) === -1 ?  true && window.location.origin : "").concat(modifyHref(menuItem.secondImagesblock.ctaLink)) : "n/a"
                        })
                    }
                } : undefined
            });
        }
        return {
            title: item["cq:panelTitle"] || "",
            tabs: tabTitles,
            menuItems: menuItemTransformed,
            images,
            parentLink: (0,helper/* removeAndCleanLink */.xEh)((ref2 = item[":items"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.globalnavigation) === null || ref3 === void 0 ? void 0 : ref3.parentLink)
        };
    });
    return titles;
}

;// CONCATENATED MODULE: ./components/DesignSystem/utils/promoBannerhelper.js
/**
 * Recursively searches an object tree to find an item by containerId name
 * @param {Object} obj - Object tree to search
 * @param {string} name - Name to search for containerId
 * @return {Object|null} Found item or null
 */ let resObject = null;
function findItemByContainerId(obj, name) {
    // If we have :items, check them first
    if (obj[":items"]) {
        // Look through each key in :items
        for (const key of Object.keys(obj[":items"])){
            var ref;
            // If item containerId matches with name
            if (((ref = obj[":items"][key]) === null || ref === void 0 ? void 0 : ref.containerId) && obj[":items"][key].containerId === name) {
                resObject = obj[":items"][key];
            }
            // If this item has nested :items, recurse into them
            if (resObject) {
                return resObject;
            }
            const result = findItemByContainerId(obj[":items"][key], name);
            if (result) return result;
        }
    }
    return null;
}
/**
 * Extracts and formats promo banner content and CTAs from a container(navigation object).
 *
 * @param {Object} container - The container/navigation object containing promo data.
 * @param {string} name - The name or containerId to locate the promo details.
 * @param {Function} setPromoModal - Callback to trigger modal display for a promo.
 * @return {Array<Object>} - An array of formatted promo banner objects.
 */ function extractPromoBanners(container, name, setPromoModal) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    // Find item by containerId
    resObject = null;
    const promoDetails = findItemByContainerId(container[":items"].root, name);
    if (!promoDetails || !resObject) {
        return [];
    }
    // Extract promo banner items
    const promoBanners = (ref = promoDetails || resObject) === null || ref === void 0 ? void 0 : (ref1 = ref[":items"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1["carousel_slick"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["carouselComponentProperties"]) === null || ref3 === void 0 ? void 0 : ref3[":items"];
    if (!promoBanners) {
        return [];
    }
    const appliedCssClassNames = (ref4 = promoDetails || resObject) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[":items"]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5["carousel_slick"]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6["carouselComponentProperties"]) === null || ref7 === void 0 ? void 0 : ref7.appliedCssClassNames;
    // Format the response
    return Object.values(promoBanners).map((banner)=>{
        var ref;
        const content = ((ref = banner.description) === null || ref === void 0 ? void 0 : ref.replace(/<[^>]*>/g, "").trim()) || "";
        const CTAs = (banner.actionItems || []).map((item)=>{
            var ref;
            let ctaObj = {
                text: item.text,
                href: item.ctaLink || item.authoredLink
            };
            if (item.enablePopup && banner.actionsEnabled) {
                // open popup
                ctaObj = {
                    text: item.text,
                    onClick: ()=>{
                        setPromoModal({
                            show: true,
                            modalContent: {
                                banner: banner,
                                item: item
                            }
                        });
                    }
                };
            } else if (item.isNewTab && !item.enablePopup) {
                // open in new tab
                ctaObj = {
                    text: item.text,
                    onClick: ()=>window.open(item.ctaLink, "_blank")
                };
            }
            ctaObj.trackingAttributes = {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: item.enablePopup ? "true" : "false",
                    eventAction: item.text,
                    eventName: item.text,
                    internalLinkName: item.text,
                    internalLinkPosition:  true ? "".concat(window.eventPageType, ":promo banner") : 0,
                    internalLinkType: item.enablePopup ? "navigation" : ":",
                    internalLinkURL: item.enablePopup ? "n/a" : item.ctaLink && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref = item.ctaLink) === null || ref === void 0 ? void 0 : ref.split("/content/annsacks/us/en").join("").replace(".html", "")) : "n/a",
                    internalLinkZoneName:  true ? "".concat(window.eventPageType, ":promo details") : 0,
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    eventType: "promo banner"
                })
            };
            return ctaObj;
        });
        return {
            content,
            CTAs,
            appliedCssClassNames
        };
    });
}

;// CONCATENATED MODULE: ./components/DesignSystem/utils/languageMenuHelper.js


const LANGUAGE_PROPERTY_MAPPINGS = [
    {
        nameKey: "languageOne",
        abbreviationKey: "languageOneAbbreviation",
        linkKey: "languageOneLink"
    },
    {
        nameKey: "languageTwo",
        abbreviationKey: "languageTwoAbbreviation",
        linkKey: "languageTwoLink"
    },
    {
        nameKey: "languageThree",
        abbreviationKey: "languageThreeAbbreviation",
        linkKey: "languageThreeLink"
    }
];
const createLanguageObject = (language, abbreviation, link, width)=>{
    if (!language) return null;
    const sanitizedLink = (0,helper/* removeAndCleanLink */.xEh)(link);
    return {
        text: width < 1024 ? language : abbreviation,
        href: sanitizedLink,
        trackingAttributes: {
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": JSON.stringify({
                clickInternalLinks: "true",
                eventAction: "language selector",
                eventName: "language selector",
                eventType: "language selector",
                internalLinkName: "language select:".concat(abbreviation.toLowerCase()),
                internalLinkPosition: "languageselector",
                internalLinkType: "homepage:navigation",
                internalLinkURL: sanitizedLink,
                internalLinkZoneName: "home:global header"
            })
        }
    };
};
const mapRegion = function() {
    let regionName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], currentCountry = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", width = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return {
        name: regionName,
        countries: items.map((item)=>{
            if (!item.countryName && !item.country) return null;
            const country = {
                name: item.countryName || item.country
            };
            const languages = LANGUAGE_PROPERTY_MAPPINGS.map((param)=>{
                let { nameKey , abbreviationKey , linkKey  } = param;
                return createLanguageObject(item[nameKey], item[abbreviationKey], item[linkKey], width);
            }).filter(Boolean);
            if (item.countryLink) {
                country.href = (0,helper/* removeAndCleanLink */.xEh)(item.countryLink);
                country.trackingAttributes = {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: "true",
                        eventAction: "country selector",
                        eventName: "country selector",
                        eventType: "country selector",
                        internalLinkName: "country select:".concat(item.country.toLowerCase()),
                        internalLinkPosition: "global header",
                        internalLinkType: "homepage:navigation",
                        internalLinkURL: "n/a",
                        internalLinkZoneName: "home:global header"
                    })
                };
            }
            if (item.countryName === currentCountry) country.isCurrentCountry = true;
            if (languages.length) country.languages = languages;
            return country;
        }).filter(Boolean),
        trackingAttributes: {
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": JSON.stringify({
                clickInternalLinks: "true",
                eventAction: "country select:".concat(regionName.toLowerCase()),
                eventName: "country select:".concat(regionName.toLowerCase()),
                eventType: "navigation",
                internalLinkName: regionName.toLowerCase(),
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkURL: "n/a",
                internalLinkZoneName: "global header"
            })
        }
    };
};
const getLanguageMenu = (container, width)=>{
    let secondLanguageCTA = {};
    const { country ="" , language ="" , enableLanguageSwitcher , languageLabel ="" , languageUrl =""  } = container || {};
    const currentCountry = "United States" || 0;
    const currentLanguage = language || "EN";
    const countrySelector = findItemByName(container, "countryselector");
    if (!countrySelector) {
        return {
            regions: [],
            languageMenuTitle: undefined,
            languageMenuDescription: undefined,
            currentCountry,
            currentLanguage,
            secondLanguageCTA
        };
    }
    const regionMappings = [
        {
            key: "americasItems",
            name: "Americas"
        },
        {
            key: "africaItems",
            name: "Africa"
        },
        {
            key: "asiaItems",
            name: "Asia"
        },
        {
            key: "oceaniaItems",
            name: "Australasia"
        },
        {
            key: "middleEastItems",
            name: "Middle East"
        },
        {
            key: "europeItems",
            name: "Europe"
        }
    ];
    const regions = regionMappings.filter((region)=>countrySelector[region.key]).map((region)=>mapRegion(region.name, countrySelector[region.key], currentCountry, width));
    if (enableLanguageSwitcher) {
        secondLanguageCTA = {
            text: languageLabel,
            href: (0,helper/* removeAndCleanLink */.xEh)(languageUrl)
        };
    }
    return {
        regions,
        languageMenuTitle: countrySelector.title,
        languageMenuDescription: countrySelector.description,
        currentCountry,
        currentLanguage,
        secondLanguageCTA
    };
};

;// CONCATENATED MODULE: ./components/DesignSystem/utils/brandSwitcherHelper.js
/**
 * Gets panel titles from a navigation object
 * @param {Object} obj - Navigation object
 * @return {Array<string>} Array of panel titles
 */ function getBrandTitles(obj) {
    if (!obj) return null;
    // Check if object has required properties
    if (!obj[":itemsOrder"] || !obj[":items"]) return obj["items"];
    // Get an array of titles
    const titles = obj[":itemsOrder"].map((key)=>{
        const item = obj[":items"][key];
        return item["brand_switcher"] || "";
    });
    return titles;
}
/**
 * Generates an array of brand objects from the given input object.
 *
 * @param {Object} obj - The input object containing brand information.
 * @return {Array} An array of brand objects with text, href, target, and isActive properties.
 */ function getBrandsArray(obj) {
    const brandSwitcherArray = getBrandTitles(obj) || [];
    const brandArray = brandSwitcherArray.map((item)=>{
        var ref, ref1;
        if (!item) return {
            text: "",
            href: "",
            target: "_self",
            isActive: false
        };
        return {
            text: (item === null || item === void 0 ? void 0 : item.brandName) || "",
            href: (item === null || item === void 0 ? void 0 : item.link) || "",
            target: (item === null || item === void 0 ? void 0 : item.linkToNewTab) === "true" ? "_blank" : "_self",
            isActive: (item === null || item === void 0 ? void 0 : item.highlight) || false,
            trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks:  true && (item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.includes(window.location.hostname.split(".").slice(1).join("."))),
                    eventAction: "brand sync",
                    eventName: "brand sync",
                    eventType: "click",
                    internalLinkName: "brand sync:".concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                    internalLinkPosition: "global header",
                    internalLinkType: "global header:navigation",
                    internalLinkURL: item === null || item === void 0 ? void 0 : item.link,
                    internalLinkZoneName:  true ? "".concat(window === null || window === void 0 ? void 0 : window.eventPageType, ":global header") : 0
                })
            }
        };
    }).filter((item)=>item.text || item.href) // Filter out empty items
    ;
    return brandArray;
}

;// CONCATENATED MODULE: ./components/DesignSystem/utils/utilityHeaderHelper.js

/**
 * Extracts links from an HTML string and modifies the href.
 *
 * @param {string} htmlString - The HTML string to extract links from.
 * @return {Array} An array of link objects with modified href and text.
 */ function extractLinks(htmlString) {
    const linkRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"(?:[^>]*)>(.*?)<\/a>/g;
    const links = [];
    let match;
    while((match = linkRegex.exec(htmlString)) !== null){
        var ref, ref1, ref2, ref3, ref4;
        links.push({
            component: "a",
            href: modifyHref(match[1].replace("/link", "/modified/link")),
            text: match[2] || "",
            trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: "true",
                    eventAction: "my account:".concat((ref = match[2]) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
                    eventName: "my account:".concat((ref1 = match[2]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    eventType: "global header",
                    internalLinkName: (ref2 = match[2]) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(),
                    internalLinkPosition: "global header:".concat((ref3 = match[2]) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()),
                    internalLinkType: "global header:navigation",
                    internalLinkURL: match[1] && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref4 = match[1]) === null || ref4 === void 0 ? void 0 : ref4.split("/content/annsacks/us/en").join("").replace(".html", "")) : "n/a",
                    internalLinkZoneName: "global header"
                })
            }
        });
    }
    return links;
}
/**
 * Returns the cart badge CTA object if the cartLandingPagePath exists and canadaCheck is false, otherwise undefined.
 *
 * @param {string} cartLandingPagePath - The cart landing page URL.
 * @param {number} cartCount - The number of items in the cart.
 * @param {boolean} canadaCheck - If true, the cart icon should not be shown.
 * @return {CartBadgeCTA|undefined} The cart badge CTA object or undefined.
 */ function getCartBadgeCTA() {
    let cartLandingPagePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", cartCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, canadaCheck = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (canadaCheck) return null;
    return {
        href: cartLandingPagePath,
        digit: cartCount > 0 && cartCount < 999 ? cartCount : null,
        trackingAttributes: {
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": JSON.stringify({
                clickInternalLinks: "true",
                eventAction: "cart icon",
                eventMsg: "n/a",
                eventName: "cart icon",
                eventStatus: "n/a",
                eventType: "global header",
                internalLinkName: "cart icon",
                internalLinkPosition: "global header",
                internalLinkType: "global header:navigation",
                internalLinkURL: cartLandingPagePath,
                internalLinkZoneName: "global header"
            })
        }
    };
}

// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/constant.js
var constant = __webpack_require__(59187);
;// CONCATENATED MODULE: ./components/DesignSystem/mappers/navigationV2Mapper.js









const mapMainMenuProps = function() {
    let container = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i18n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, lineItems = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, textLineItems = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, firstName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", isAuth = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, logIndata = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, logOutdata = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {}, onclicksignIN = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : ()=>{}, onClickCreateAccount = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : ()=>{}, onClickSignOut = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : ()=>{}, favClickHandler = arguments.length > 11 && arguments[11] !== void 0 ? arguments[11] : ()=>{}, cartCount = arguments.length > 12 && arguments[12] !== void 0 ? arguments[12] : 0, themeType = arguments.length > 13 && arguments[13] !== void 0 ? arguments[13] : "light", handleSearchClick = arguments.length > 14 && arguments[14] !== void 0 ? arguments[14] : ()=>{}, showBackground = arguments.length > 15 && arguments[15] !== void 0 ? arguments[15] : false, favoritesPage = arguments.length > 16 && arguments[16] !== void 0 ? arguments[16] : [], favoritesPagePath = arguments.length > 17 && arguments[17] !== void 0 ? arguments[17] : "", cartLandingPagePath = arguments.length > 18 && arguments[18] !== void 0 ? arguments[18] : "", path = arguments.length > 19 && arguments[19] !== void 0 ? arguments[19] : "", setPromoModal = arguments.length > 20 && arguments[20] !== void 0 ? arguments[20] : ()=>{}, canadaCheck = arguments.length > 21 && arguments[21] !== void 0 ? arguments[21] : false, transitionDelay = arguments.length > 22 && arguments[22] !== void 0 ? arguments[22] : "", searchHeader = arguments.length > 23 && arguments[23] !== void 0 ? arguments[23] : "Search", language = arguments.length > 24 && arguments[24] !== void 0 ? arguments[24] : "en", isSaveProductToList = arguments.length > 25 && arguments[25] !== void 0 ? arguments[25] : false, width = arguments.length > 26 && arguments[26] !== void 0 ? arguments[26] : 0;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    const titlesArray = getPanelTitles(findItemByName(container, "tabs"));
    const tabsArray = getTabDetails(findItemByName(container, "tabs"));
    const menuItemsArray = getMenuItems(findItemByName(container, "tabs"));
    const logoData = findItemByName(container, "image");
    const { languageMenuTitle ="" , languageMenuDescription ="" , regions =[] , currentCountry ="" , currentLanguage ="" , secondLanguageCTA ={}  } = getLanguageMenu(findItemByName(container, "utilitynavheader"), width) || {};
    const formattedResponse = extractPromoBanners(container, "promo-details", setPromoModal);
    const brandSwitcherArray = getBrandsArray(findItemByName(container, "brand_switcher"));
    const loggedInCtaArray = extractLinks(logIndata);
    const loggedOutCtaArray = extractLinks(logOutdata);
    const cartBadgeCTA = getCartBadgeCTA(cartLandingPagePath, cartCount, canadaCheck);
    const dataLayerTitle = "find a showroom";
    var ref28;
    const findStoreLabel = (ref28 = (ref = findItemByName(container, "store")) === null || ref === void 0 ? void 0 : ref.findStore) !== null && ref28 !== void 0 ? ref28 : "Find a Showroom";
    let buttonCTA = null;
    function findButtonCTA(obj) {
        if (!obj || typeof obj !== "object") return null;
        for(const key in obj){
            var ref;
            if (key === "button_269119861" && ((ref = obj[key]) === null || ref === void 0 ? void 0 : ref.text)) {
                return {
                    text: obj[key].text,
                    href: obj[key].link,
                    target: obj[key].ctaNewTab ? "_blank" : undefined
                };
            }
            if (typeof obj[key] === "object") {
                const found = findButtonCTA(obj[key]);
                if (found) return found;
            }
        }
        return null;
    }
    buttonCTA = findButtonCTA(container);
    let designerTradeCTA = null;
    function findDesignerTradeCTA(obj) {
        if (!obj || typeof obj !== "object") return null;
        for(const key in obj){
            var ref, ref1;
            if (key === "button" && ((ref = obj[key]) === null || ref === void 0 ? void 0 : ref.text) && ((ref1 = obj[key]) === null || ref1 === void 0 ? void 0 : ref1.link)) {
                return {
                    text: obj[key].text,
                    href: obj[key].link,
                    target: obj[key].ctaNewTab ? "_blank" : undefined
                };
            }
            if (typeof obj[key] === "object") {
                const found = findDesignerTradeCTA(obj[key]);
                if (found) return found;
            }
        }
        return null;
    }
    designerTradeCTA = findDesignerTradeCTA(container);
    return {
        promoBanner: {
            mod: formattedResponse.length > 0 ? "slate" : "",
            type: formattedResponse.length > 0 ? "promo" : "",
            content: formattedResponse.length > 0 ? formattedResponse : []
        },
        mainNavigation: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? {
            mod: "white",
            brandCTA: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? {
                brand: "Ann Sacks",
                href: "/",
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: (logoData === null || logoData === void 0 ? void 0 : logoData.link) ? "true" : "false",
                        eventAction: "header kohler logo",
                        eventName: "header kohler logo",
                        internalLinkName: "header kohler logo",
                        internalLinkPosition: "global header",
                        internalLinkType: "global header:navigation",
                        internalLinkURL: (logoData === null || logoData === void 0 ? void 0 : logoData.link) && "object" !== "undefined" ? "".concat(window.location.origin).concat(logoData === null || logoData === void 0 ? void 0 : (ref1 = logoData.link) === null || ref1 === void 0 ? void 0 : ref1.split("/content/annsacks/us/en").join("").replace(".html", "")) : "n/a",
                        internalLinkZoneName: "global header"
                    })
                }
            } : {},
            showBackground: showBackground,
            menuItems: menuItemsArray.map((item, index)=>{
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                const tabTitle = titlesArray[index];
                const tabList = tabsArray.find((tab)=>tab.title === tabTitle) || {};
                // Get imageOrientation from AEM JSON
                const imageOrientation = (item === null || item === void 0 ? void 0 : item.imageOrientation) || "landscape";
                return {
                    text: tabTitle,
                    mod: "white",
                    tabList: tabList === null || tabList === void 0 ? void 0 : tabList.tabs,
                    CTALists: (item === null || item === void 0 ? void 0 : item.navigationMenuType) !== "business" ? transformArray(item, titlesArray[index]) : transformBusinessArray(item, titlesArray[index]),
                    ...((ref = item.firstImagesblock) === null || ref === void 0 ? void 0 : ref.firstImageFileReference) && {
                        images: [
                            {
                                image: {
                                    src: item.firstImagesblock.firstImageFileReference || "",
                                    alt: item.firstImagesblock.altText || "",
                                    "data-mode": "smartcrop",
                                    trackingAttributes: {
                                        "data-datalayer-id": "kds-element-navigation",
                                        "data-datalayer-data": JSON.stringify({
                                            clickInternalLinks: modifyHref(item.firstImagesblock.ctaLink) ? "true" : "false",
                                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(item === null || item === void 0 ? void 0 : (ref1 = item.firstImagesblock) === null || ref1 === void 0 ? void 0 : ref1.firstImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref2 = item.firstImagesblock) === null || ref2 === void 0 ? void 0 : ref2.ctaLabel).toLowerCase(),
                                            internalLinkURL: modifyHref(item.firstImagesblock.ctaLink) ? "".concat(modifyHref(item.firstImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat(modifyHref(item.firstImagesblock.ctaLink)) : "n/a"
                                        })
                                    }
                                },
                                imageOrientation,
                                caption: {
                                    text: item.firstImagesblock.firstImageTitle ? (0,textUtils/* sanitizeText */.o)(item.firstImagesblock.firstImageTitle) : ""
                                },
                                multiCTA: item.multiCTA.map((elem, index)=>{
                                    var ref;
                                    return {
                                        text: (0,textUtils/* sanitizeText */.o)(elem.ctaLabel),
                                        href: modifyHref(elem.ctaLink),
                                        trackingAttributes: {
                                            "data-datalayer-id": "kds-element-navigation",
                                            "data-datalayer-data": JSON.stringify({
                                                clickInternalLinks: modifyHref(item.firstImagesblock.ctaLink) ? "true" : "false",
                                                internalLinkName: (ref = "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(elem.ctaLabel))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                                internalLinkURL: modifyHref(elem.ctaLink) ? "".concat(modifyHref(elem.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat(modifyHref(elem.ctaLink)) : "n/a"
                                            })
                                        }
                                    };
                                }),
                                CTA: item.firstImagesblock.ctaLabel ? {
                                    text: item.firstImagesblock.ctaLabel,
                                    href: modifyHref(item.firstImagesblock.ctaLink),
                                    target: item.firstImagesblock.ctaNewTab ? "_blank" : undefined,
                                    trackingAttributes: {
                                        "data-datalayer-id": "kds-element-navigation",
                                        "data-datalayer-data": JSON.stringify({
                                            clickInternalLinks: modifyHref(item.firstImagesblock.ctaLink) ? "true" : "false",
                                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(item === null || item === void 0 ? void 0 : (ref3 = item.firstImagesblock) === null || ref3 === void 0 ? void 0 : ref3.firstImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref4 = item.firstImagesblock) === null || ref4 === void 0 ? void 0 : ref4.ctaLabel).toLowerCase(),
                                            internalLinkURL: modifyHref(item.firstImagesblock.ctaLink) ? "".concat(modifyHref(item.firstImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat(modifyHref(item.firstImagesblock.ctaLink)) : "n/a"
                                        })
                                    }
                                } : undefined
                            },
                            ...((ref5 = item.secondImagesblock) === null || ref5 === void 0 ? void 0 : ref5.secondImageFileReference) ? [
                                {
                                    image: {
                                        src: item.secondImagesblock.secondImageFileReference || "",
                                        alt: item.secondImagesblock.altText || "",
                                        "data-mode": "smartcrop",
                                        trackingAttributes: {
                                            "data-datalayer-id": "kds-element-navigation",
                                            "data-datalayer-data": JSON.stringify({
                                                clickInternalLinks: modifyHref(item.secondImagesblock.ctaLink) ? "true" : "false",
                                                internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(item === null || item === void 0 ? void 0 : (ref6 = item.secondImagesblock) === null || ref6 === void 0 ? void 0 : ref6.secondImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref7 = item.secondImagesblock) === null || ref7 === void 0 ? void 0 : ref7.ctaLabel).toLowerCase(),
                                                internalLinkURL: modifyHref(item.secondImagesblock.ctaLink) ? "".concat(modifyHref(item.secondImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat(modifyHref(item.secondImagesblock.ctaLink)) : "n/a"
                                            })
                                        }
                                    },
                                    imageOrientation,
                                    caption: {
                                        text: item.secondImagesblock.secondImageTitle ? (0,textUtils/* sanitizeText */.o)(item.secondImagesblock.secondImageTitle) : ""
                                    },
                                    CTA: item.secondImagesblock.ctaLabel ? {
                                        text: item.secondImagesblock.ctaLabel,
                                        href: modifyHref(item.secondImagesblock.ctaLink),
                                        target: item.secondImagesblock.ctaNewTab ? "_blank" : undefined,
                                        trackingAttributes: {
                                            "data-datalayer-id": "kds-element-navigation",
                                            "data-datalayer-data": JSON.stringify({
                                                clickInternalLinks: modifyHref(item.secondImagesblock.ctaLink) ? "true" : "false",
                                                internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(item === null || item === void 0 ? void 0 : (ref8 = item.secondImagesblock) === null || ref8 === void 0 ? void 0 : ref8.secondImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref9 = item.secondImagesblock) === null || ref9 === void 0 ? void 0 : ref9.ctaLabel).toLowerCase(),
                                                internalLinkURL: modifyHref(item.secondImagesblock.ctaLink) ? "".concat(modifyHref(item.secondImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat(modifyHref(item.secondImagesblock.ctaLink)) : "n/a"
                                            })
                                        }
                                    } : undefined
                                }
                            ] : []
                        ]
                    }
                };
            }),
            showMenuDelay: parseInt(transitionDelay) || 0,
            menuCTA: {
                onClick: ()=>(0,helper/* removeMavenoidChat */.N9B)()
            },
            closeCTA: {
                onClick: ()=>(0,helper/* addMavenoidChat */.dVG)()
            },
            variant: "v2.1",
            searchText: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? searchHeader : "",
            searchCTA: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? {
                onClick: ()=>{
                    handleSearchClick();
                },
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        eventAction: "internal search:open",
                        eventName: "internal search:open",
                        eventType: "navigation",
                        eventMsg: "n/a",
                        eventStatus: "n/a",
                        internalLinkName: "open",
                        internalLinkPosition: "global header: internal search",
                        internalLinkType: "internal search:navigation",
                        internalLinkZoneName: "search:search box",
                        internalLinkURL: "n/a",
                        clickInternalLinks: "true"
                    })
                }
            } : {},
            buttonCTA,
            designerTradeCTA
        } : undefined,
        utilityBar: {
            mod: "black",
            ...path === "/checkout" ? {} : {
                languagePicker: {
                    languagePickerCTA: {
                        onClick: ()=>{},
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: "true",
                                eventAction: "country select",
                                eventName: "country select",
                                eventType: "click",
                                internalLinkName: "".concat(currentCountry.toLowerCase(), " - ").concat(currentLanguage.toLowerCase()),
                                internalLinkPosition: "global header",
                                internalLinkType: "global header : navigation",
                                internalLinkURL: "n/a",
                                internalLinkZoneName: "home:global header"
                            })
                        }
                    },
                    location: currentCountry,
                    currentLanguage: currentLanguage,
                    secondLanguageCTA: Object.keys(secondLanguageCTA).length === 0 ? undefined : secondLanguageCTA
                },
                isLoggedIn: isAuth,
                userName: "".concat(firstName),
                userCTA: {
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": !isAuth ? JSON.stringify({
                            clickInternalLinks: "true",
                            eventAction: "sign in start",
                            eventMsg: "n/a",
                            eventName: "sign in start",
                            eventStatus: "n/a",
                            eventType: "global header",
                            internalLinkName: "sign in start",
                            internalLinkPosition: "global header:sign in start",
                            internalLinkType: "global header:navigation",
                            internalLinkURL: "n/a",
                            internalLinkZoneName: "global header"
                        }) : JSON.stringify({
                            clickInternalLinks: "true",
                            eventAction: "global header:your kohler account",
                            eventMsg: "n/a",
                            eventName: "global header:your kohler account",
                            eventStatus: "n/a",
                            eventType: "navigation",
                            internalLinkName: "your kohler account",
                            internalLinkPosition: "global header:my account",
                            internalLinkType: "global header: welcome back to your kohler",
                            internalLinkURL: "n/a",
                            internalLinkZoneName: "global header"
                        })
                    }
                },
                userCTAMobile: {
                    signInCTA: {
                        text: i18n.signIn,
                        onClick: ()=>{
                            onclicksignIN();
                        },
                        component: "button"
                    },
                    signUpCTA: {
                        text: i18n.createAccount,
                        onClick: ()=>{
                            onClickCreateAccount();
                        },
                        component: "button"
                    },
                    accountCTA: {
                        text: "".concat(language === "fr" ? "Bonjour" : "Hi", ", ").concat(firstName),
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: "true",
                                eventAction: "global header:your kohler account",
                                eventMsg: "n/a",
                                eventName: "global header:your kohler account",
                                eventStatus: "n/a",
                                eventType: "navigation",
                                internalLinkName: "your kohler account",
                                internalLinkPosition: "global header:my account",
                                internalLinkType: "global header: welcome back to your kohler",
                                internalLinkURL: "n/a",
                                internalLinkZoneName: "global header"
                            })
                        }
                    }
                },
                ...isAuth ? {} : {
                    utilityLinksMobile: [
                        {
                            text: ((ref2 = loggedOutCtaArray[0]) === null || ref2 === void 0 ? void 0 : ref2.text) || "",
                            href: ((ref3 = loggedOutCtaArray[0]) === null || ref3 === void 0 ? void 0 : ref3.href) || "",
                            component: "a",
                            trackingAttributes: {
                                "data-datalayer-id": "kds-element-navigation",
                                "data-datalayer-data": JSON.stringify({
                                    clickInternalLinks: "true",
                                    eventAction: "my account:".concat((ref4 = loggedOutCtaArray[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.text) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()),
                                    eventName: "my account:".concat((ref6 = loggedOutCtaArray[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.text) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase()),
                                    eventMsg: "n/a",
                                    eventStatus: "n/a",
                                    eventType: "global header",
                                    internalLinkName: (ref8 = loggedOutCtaArray[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.text) === null || ref9 === void 0 ? void 0 : ref9.toLowerCase(),
                                    internalLinkPosition: "global header:".concat((ref10 = loggedOutCtaArray[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.text) === null || ref11 === void 0 ? void 0 : ref11.toLowerCase()),
                                    internalLinkType: "global header:navigation",
                                    internalLinkURL: ((ref12 = loggedOutCtaArray[0]) === null || ref12 === void 0 ? void 0 : ref12.href) && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref13 = loggedOutCtaArray[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.href) === null || ref14 === void 0 ? void 0 : ref14.split("/content/annsacks/us/en").join("").replace(".html", "")) : "n/a",
                                    internalLinkZoneName: "global header"
                                })
                            }
                        }
                    ]
                },
                locationPickerCTA: {
                    text: findStoreLabel,
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                            eventAction: dataLayerTitle,
                            eventMsg: "n/a",
                            eventName: dataLayerTitle,
                            eventStatus: "n/a",
                            eventType: "".concat(constant/* GLOBAL_HEADER_TEXT */.A),
                            internalLinkName: dataLayerTitle,
                            internalLinkPosition: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":").concat(dataLayerTitle),
                            internalLinkType: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":navigation"),
                            internalLinkZoneName: "".concat(constant/* GLOBAL_HEADER_TEXT */.A),
                            internalLinkURL: "n/a",
                            clickInternalLinks: "true"
                        })
                    }
                },
                favoritesCTA: {
                    text: language === "fr" ? isSaveProductToList ? "Mes Listes" : "Favoris" : isSaveProductToList ? "My List" : "Favorites",
                    onClick: (e)=>favClickHandler(e, favoritesPagePath),
                    isFilled: isAuth && (lineItems && lineItems.length > 0 || textLineItems && textLineItems.length > 0 || favoritesPage && favoritesPage.length > 0) ? true : false,
                    component: "a",
                    href: isAuth ? favoritesPagePath : ""
                }
            },
            cartBadgeCTA: cartBadgeCTA,
            brands: path === "/checkout" ? [
                {
                    text: "KOHLER",
                    href: "https://www.kohler.com",
                    target: "_blank",
                    isActive: "true"
                }
            ] : brandSwitcherArray
        },
        languageMenu: {
            mod: "black",
            heading: {
                text: languageMenuTitle
            },
            copy: {
                text: (0,textUtils/* sanitizeText */.o)(languageMenuDescription)
            },
            currentCounty: currentCountry,
            regions: regions
        },
        ...path === "/checkout" ? {} : {
            loginMenu: {
                mod: "white",
                headingSignIn: {
                    text: "".concat(i18n.welcome, " ").concat(firstName, "!")
                },
                headingSignOut: {
                    text: i18n.title
                },
                isLoggedIn: isAuth,
                userName: "".concat(firstName),
                loggedOutCTAs: [
                    {
                        text: i18n.signIn,
                        onClick: ()=>{
                            onclicksignIN();
                        },
                        component: "button"
                    },
                    {
                        text: i18n.createAccount,
                        onClick: ()=>{
                            onClickCreateAccount();
                        },
                        component: "button"
                    },
                    {
                        text: ((ref15 = loggedOutCtaArray[0]) === null || ref15 === void 0 ? void 0 : ref15.text) || "",
                        href: ((ref16 = loggedOutCtaArray[0]) === null || ref16 === void 0 ? void 0 : ref16.href) || "",
                        component: "a",
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: "true",
                                eventAction: "my account:".concat((ref17 = loggedOutCtaArray[0]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.text) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase()),
                                eventName: "my account:".concat((ref19 = loggedOutCtaArray[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.text) === null || ref20 === void 0 ? void 0 : ref20.toLowerCase()),
                                eventMsg: "n/a",
                                eventStatus: "n/a",
                                eventType: "global header",
                                internalLinkName: (ref21 = loggedOutCtaArray[0]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.text) === null || ref22 === void 0 ? void 0 : ref22.toLowerCase(),
                                internalLinkPosition: "global header:".concat((ref23 = loggedOutCtaArray[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.text) === null || ref24 === void 0 ? void 0 : ref24.toLowerCase()),
                                internalLinkType: "global header:navigation",
                                internalLinkURL: ((ref25 = loggedOutCtaArray[0]) === null || ref25 === void 0 ? void 0 : ref25.href) && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref26 = loggedOutCtaArray[0]) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.href) === null || ref27 === void 0 ? void 0 : ref27.split("/content/annsacks/us/en").join("").replace(".html", "")) : "n/a",
                                internalLinkZoneName: "global header"
                            })
                        }
                    }
                ],
                loggedInCTAs: loggedInCtaArray,
                signOutCTA: {
                    text: i18n.logout,
                    onClick: ()=>{
                        onClickSignOut();
                    },
                    component: "button"
                }
            }
        }
    };
};

// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/use-merged-ref.mjs
var use_merged_ref = __webpack_require__(37390);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(29050);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/index.hook.jsx

const useStickyNavigation = function(mainMenuHeight) {
    let isAlwaysSticky = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const [showStickyNav, setShowStickyNav] = (0,react.useState)(false);
    const [isSticky, setIsSticky] = (0,react.useState)(false);
    const [lastScrollY, setLastScrollY] = (0,react.useState)(0);
    const [scrollDelta, setScrollDelta] = (0,react.useState)(0);
    const [hasHiddenOnce, setHasHiddenOnce] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>{
            const scrollY = window.scrollY;
            const isScrollingUp = scrollY < lastScrollY;
            const hasScrolledPastThreshold = scrollY > window.innerHeight * 0.25;
            const hasScrolledPastMainMenu = scrollY > mainMenuHeight + (isAlwaysSticky ? 0 : 120);
            if (!isAlwaysSticky) {
                if (!isScrollingUp) {
                    setScrollDelta((prev)=>prev + (scrollY - lastScrollY));
                } else {
                    setScrollDelta(0);
                }
            }
            if (hasScrolledPastMainMenu) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
            if (isAlwaysSticky) {
                setShowStickyNav(true);
            }
            if (scrollDelta > 100 && !isAlwaysSticky) {
                setShowStickyNav(false);
                setHasHiddenOnce(true);
            }
            if (isScrollingUp && hasScrolledPastThreshold && hasHiddenOnce && !isAlwaysSticky) {
                setShowStickyNav(true);
            }
            setLastScrollY(scrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, [
        lastScrollY,
        mainMenuHeight,
        scrollDelta,
        hasHiddenOnce
    ]);
    return {
        showStickyNav,
        isSticky
    };
};

// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/index.module.scss
var index_module = __webpack_require__(26564);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs + 1 modules
var Grid = __webpack_require__(82931);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs + 1 modules
var GridColumn = __webpack_require__(60216);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(83815);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/BrandLogo.mjs + 14 modules
var BrandLogo = __webpack_require__(15506);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CartBadge/CartBadge.mjs + 11 modules
var CartBadge = __webpack_require__(52386);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(87338);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.mjs + 2 modules
var Link = __webpack_require__(13684);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(95408);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/MenuIcon.mjs
var MenuIcon = __webpack_require__(28056);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/SearchIcon.mjs
var SearchIcon = __webpack_require__(90905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FavoriteNavFilledIcon.mjs
var FavoriteNavFilledIcon = __webpack_require__(89176);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FavoriteNavIcon.mjs
var FavoriteNavIcon = __webpack_require__(32633);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowDownIcon.mjs
var ArrowDownIcon = __webpack_require__(53832);
// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/MainNavigationBar/NavigationItem/index.module.scss
var NavigationItem_index_module = __webpack_require__(46980);
var NavigationItem_index_module_default = /*#__PURE__*/__webpack_require__.n(NavigationItem_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/MainNavigationBar/NavigationItem/index.jsx





const NavigationItem = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    const { text , isSelected , className , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
        component: "a",
        size: "label-medium-m",
        className: (0,clsx/* default */.Z)(className, isSelected ? (NavigationItem_index_module_default()).navigationItemSelected : (NavigationItem_index_module_default()).navigationItem),
        style: {
            color: isSelected ? "var(--Primary-Charcoal, #212121)" : "var(--Primary-Carbon, #5D5D5D)"
        },
        ref: ref,
        ...rest,
        children: text
    });
});

// EXTERNAL MODULE: ./components/DesignSystem/TabbedNavigationHorizontal/index.module.scss
var TabbedNavigationHorizontal_index_module = __webpack_require__(23926);
var TabbedNavigationHorizontal_index_module_default = /*#__PURE__*/__webpack_require__.n(TabbedNavigationHorizontal_index_module);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowRightBoldIcon.mjs
var ArrowRightBoldIcon = __webpack_require__(98372);
;// CONCATENATED MODULE: ./components/DesignSystem/TabbedNavigationHorizontal/index.jsx





const isMobile = ()=> true && window.innerWidth < 1024;
const TabbedNavigationHorizontal = (param)=>{
    let { tabs =[] , align ="left" , onTabChange , defaultActiveTab  } = param;
    var ref, ref1;
    const [activeTab, setActiveTab] = (0,react.useState)(defaultActiveTab || ((ref = tabs[0]) === null || ref === void 0 ? void 0 : ref.id) || ((ref1 = tabs[0]) === null || ref1 === void 0 ? void 0 : ref1.text));
    const [underlineStyle, setUnderlineStyle] = (0,react.useState)({});
    const tabsRef = (0,react.useRef)([]);
    const [mobile, setMobile] = (0,react.useState)(isMobile());
    (0,react.useEffect)(()=>{
        const handleResize = ()=>setMobile(isMobile());
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    (0,react.useEffect)(()=>{
        const index = tabs.findIndex((tab)=>(tab.id || tab.text) === activeTab);
        if (index !== -1 && tabsRef.current[index]) {
            const el = tabsRef.current[index];
            setUnderlineStyle({
                left: el.offsetLeft,
                width: el.offsetWidth
            });
        }
    }, [
        activeTab,
        tabs
    ]);
    // On hover, set active tab and call onTabChange
    const handleTabHover = (tab, index)=>{
        setActiveTab(tab.id || tab.text);
        if (onTabChange) onTabChange(tab);
    };
    // On click, allow default navigation for <a>
    const handleTabClick = (tab, index, event)=>{
        if (!tab.parentLink) {
            setActiveTab(tab.id || tab.text);
            if (onTabChange) onTabChange(tab);
        }
    // else: let <a> navigate as normal
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TabbedNavigationHorizontal_index_module_default()).tabNavigationHorizontalBg,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)((TabbedNavigationHorizontal_index_module_default()).tabNavigationHorizontal, align === "center" && (TabbedNavigationHorizontal_index_module_default()).tabNavigationHorizontalCenter),
            children: [
                tabs.map((tab, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            tab.parentLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                ref: (el)=>tabsRef.current[index] = el,
                                className: (0,clsx/* default */.Z)((TabbedNavigationHorizontal_index_module_default()).tabItem, activeTab === (tab.id || tab.text) && (TabbedNavigationHorizontal_index_module_default()).active),
                                href: tab.parentLink,
                                tabIndex: 0,
                                style: {
                                    textDecoration: "none"
                                },
                                onMouseEnter: ()=>handleTabHover(tab, index),
                                onFocus: ()=>handleTabHover(tab, index),
                                onClick: (e)=>handleTabClick(tab, index, e),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: tab.text
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                                        size: "xSmall",
                                        withBoundingBox: false,
                                        className: (TabbedNavigationHorizontal_index_module_default()).mobileOnlyArrow
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                ref: (el)=>tabsRef.current[index] = el,
                                className: (0,clsx/* default */.Z)((TabbedNavigationHorizontal_index_module_default()).tabItem, activeTab === (tab.id || tab.text) && (TabbedNavigationHorizontal_index_module_default()).active),
                                onMouseEnter: ()=>handleTabHover(tab, index),
                                onFocus: ()=>handleTabHover(tab, index),
                                onClick: (e)=>handleTabClick(tab, index, e),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: tab.text
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                                        size: "xSmall",
                                        withBoundingBox: false,
                                        className: (TabbedNavigationHorizontal_index_module_default()).mobileOnlyArrow
                                    })
                                ]
                            }),
                            mobile && index < tabs.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (TabbedNavigationHorizontal_index_module_default()).menuItemDivider
                            })
                        ]
                    }, tab.id || tab.text)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (0,clsx/* default */.Z)((TabbedNavigationHorizontal_index_module_default()).underline, !underlineStyle.width && (TabbedNavigationHorizontal_index_module_default()).underlineNoTransition),
                    style: underlineStyle
                })
            ]
        })
    });
};
/* harmony default export */ var DesignSystem_TabbedNavigationHorizontal = (TabbedNavigationHorizontal);

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowLeftIcon.mjs
var ArrowLeftIcon = __webpack_require__(29185);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CloseIcon.mjs
var CloseIcon = __webpack_require__(51315);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ExternalLinkIcon.mjs
var ExternalLinkIcon = __webpack_require__(89336);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowDownBoldIcon.mjs
var ArrowDownBoldIcon = __webpack_require__(98952);
// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuCategory/index.module.scss
var OverlayMenuCategory_index_module = __webpack_require__(16789);
var OverlayMenuCategory_index_module_default = /*#__PURE__*/__webpack_require__.n(OverlayMenuCategory_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuCategory/index.jsx






const OverlayMenuCategory = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , title , links , showArrow =true , isExternal , opened =false , onToggle , isCTA =false , ...rest } = props;
    const isOpen = opened;
    const hasNoLinks = !links || links.length === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        ref: ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-category-root", (OverlayMenuCategory_index_module_default()).overlayMenuCategory, isOpen && (OverlayMenuCategory_index_module_default()).overlayMenuCategoryOpen, isCTA && (OverlayMenuCategory_index_module_default()).overlayMenuCategoryCTA),
        component: "div",
        ...rest,
        children: [
            title && (!isCTA ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        component: hasNoLinks ? "a" : "button",
                        target: hasNoLinks && isExternal ? "_blank" : undefined,
                        ...(0,helpers/* omitText */.rW)(title),
                        onClick: !links ? title.onClick : ()=>{
                            if (onToggle) onToggle();
                        },
                        className: (0,clsx/* default */.Z)((OverlayMenuCategory_index_module_default()).overlayMenuCategoryTitle, hasNoLinks ? (OverlayMenuCategory_index_module_default()).overlayMenuCategoryTitleLink : undefined, title.className),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                component: "span",
                                size: "navigation-m",
                                textColor: "var(--Primary-Charcoal, #212121);",
                                className: (OverlayMenuCategory_index_module_default()).overlayMenuCategoryTitleText,
                                children: [
                                    title.text,
                                    " ",
                                    !showArrow && hasNoLinks && isExternal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLinkIcon/* ExternalLinkIcon */.h, {
                                        size: "small",
                                        withBoundingBox: false
                                    })
                                ]
                            }),
                            showArrow && !hasNoLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownBoldIcon/* ArrowDownBoldIcon */.T, {
                                size: "xSmall",
                                withBoundingBox: false,
                                className: (0,clsx/* default */.Z)((OverlayMenuCategory_index_module_default()).iconTransitionArrowClosed, isOpen && (OverlayMenuCategory_index_module_default()).iconTransitionArrowOpen, (OverlayMenuCategory_index_module_default()).arrowDownIcon)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OverlayMenuCategory_index_module_default()).overlayMenuCategoryDivider
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                size: "small",
                underline: false,
                rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                    size: "small",
                    withBoundingBox: false
                }),
                ...(0,helpers/* omitText */.rW)(title),
                children: title.text
            })),
            (isOpen || !title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                component: "ul",
                direction: "column",
                gap: 15,
                className: (OverlayMenuCategory_index_module_default()).overlayMenuCategoryLinks,
                children: !hasNoLinks && (links === null || links === void 0 ? void 0 : links.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        component: "li",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            component: "a",
                            size: "navigation-s",
                            textColor: "var(--content-action-default)",
                            ...(0,helpers/* omitText */.rW)(link),
                            className: (OverlayMenuCategory_index_module_default()).overlayMenuCategoryLinksLink,
                            children: link.text
                        })
                    }, link.href)))
            })
        ]
    });
});

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-window-size.mjs
var use_window_size = __webpack_require__(81962);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.mjs + 2 modules
var AspectRatioKeeper = __webpack_require__(13534);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.mjs + 4 modules
var Image = __webpack_require__(71998);
// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuImage/index.module.scss
var OverlayMenuImage_index_module = __webpack_require__(52638);
var OverlayMenuImage_index_module_default = /*#__PURE__*/__webpack_require__.n(OverlayMenuImage_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuImage/index.utils.js
const kohlerUSSmartCropImageSize = {
    1: {
        portrait: {
            general: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            },
            business: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        },
        landscape: {
            general: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            },
            business: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        }
    },
    2: {
        portrait: {
            general: {
                1600: "340px",
                1440: "305px",
                1023: "250px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            },
            business: {
                1600: "340px",
                1440: "280px",
                1023: "240px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        },
        landscape: {
            business: {
                1920: "440px",
                1600: "415px",
                1440: "335px",
                1023: "303px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        }
    }
};
function getSmartCropWidth(param) {
    let { screenWidth , imagesLength , isSmartCrop , imageOrientation , isBusinessTab  } = param;
    var ref, ref1;
    if (!isSmartCrop) return undefined;
    const layoutTier = imagesLength;
    const context = isBusinessTab ? "business" : "general";
    const orientation = imageOrientation === "portrait" ? "portrait" : "landscape";
    const breakpoints = (ref = kohlerUSSmartCropImageSize[layoutTier]) === null || ref === void 0 ? void 0 : (ref1 = ref[orientation]) === null || ref1 === void 0 ? void 0 : ref1[context];
    if (!breakpoints) return undefined;
    const sortedKeys = Object.keys(breakpoints).map(Number).sort((a, b)=>a - b);
    let selected;
    for (const bp of sortedKeys){
        if (screenWidth >= bp) {
            selected = breakpoints[bp];
        } else {
            break;
        }
    }
    return selected;
}

;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuImage/index.jsx
"use client";







const OverlayMenuImage = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , CTA , imagesLength =1 , caption , image , multiCTA , imageOrientation ="landscape" , href , isBusinessTab =true , ...rest } = props;
    const isSmartCrop = (image === null || image === void 0 ? void 0 : image["data-mode"]) === "smartcrop";
    const { width: screenWidth  } = (0,use_window_size/* useWindowSize */.i)();
    const resolvedWidth = getSmartCropWidth({
        screenWidth,
        imagesLength,
        isSmartCrop,
        imageOrientation,
        isBusinessTab
    });
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        direction: "column",
        gap: 40,
        ref: ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-image-wrapper", (OverlayMenuImage_index_module_default()).overlayMenuImageWrapper),
        width: resolvedWidth,
        ...rest,
        children: [
            multiCTA && multiCTA.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                component: "ul",
                direction: "column",
                gap: 20,
                children: multiCTA === null || multiCTA === void 0 ? void 0 : multiCTA.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                        component: "li",
                        className: (OverlayMenuImage_index_module_default()).overlayMenuCategoryLinksLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            ...(0,helpers/* omitText */.rW)(item),
                            underline: false,
                            rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                                withBoundingBox: false,
                                size: "xSmall"
                            }),
                            className: (OverlayMenuImage_index_module_default()).overlayMenuCategoryLinksLink,
                            size: "small",
                            textColor: "var(--content-primary)",
                            children: item.text
                        })
                    }, item.text))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                className: (0,clsx/* default */.Z)("kohler-overlay-menu-image", (OverlayMenuImage_index_module_default()).overlayMenuImage, !isSmartCrop && (OverlayMenuImage_index_module_default()).overlayMenuImageWidth),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectRatioKeeper/* AspectRatioKeeper */.y, {
                        component: "a",
                        href: (ref2 = (ref1 = CTA === null || CTA === void 0 ? void 0 : CTA.href) !== null && ref1 !== void 0 ? ref1 : href) !== null && ref2 !== void 0 ? ref2 : undefined,
                        // aspectRatio={isSmartCrop ? 'none' : '4:3'}
                        aspectRatio: "4:3",
                        // aspectRatio={isSmartCrop ? 'none' : imageOrientation === 'landscape' ? '5:4' : '3:4'}
                        target: CTA === null || CTA === void 0 ? void 0 : CTA.target,
                        rel: (CTA === null || CTA === void 0 ? void 0 : CTA.target) === "_blank" ? "noopener noreferrer" : undefined,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            ...image
                        })
                    }),
                    (caption || CTA) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        direction: "column",
                        gap: 5,
                        children: [
                            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                size: "label-regular-s",
                                textColor: "var(--content-secondary)",
                                component: /*#__PURE__*/ (0,react.isValidElement)(caption.text) ? "div" : caption.component || "p",
                                ...(0,helpers/* omitText */.rW)(caption),
                                children: caption.text
                            }),
                            CTA && CTA.text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                underline: false,
                                rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                                    withBoundingBox: false,
                                    size: "xSmall"
                                }),
                                className: (OverlayMenuImage_index_module_default()).overlayMenuImageCTA,
                                size: "small",
                                textColor: "var(--Primary-Charcoal)",
                                ...(0,helpers/* omitText */.rW)(CTA),
                                target: CTA.target,
                                rel: CTA.target === "_blank" ? "noopener noreferrer" : undefined,
                                children: CTA.text
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuItem/index.module.scss
var OverlayMenuItem_index_module = __webpack_require__(77738);
var OverlayMenuItem_index_module_default = /*#__PURE__*/__webpack_require__.n(OverlayMenuItem_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuItem/index.jsx






const OverlayMenuItem = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { className , title , showArrow =true , component ="button" , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        ref: ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-item", (OverlayMenuItem_index_module_default()).overlayMenuItem),
        component: component,
        type: component === "button" ? "button" : undefined,
        textColor: "var(--content-primary)",
        ...rest,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                component: "span",
                size: "navigation-m",
                textColor: "var(--content-primary)",
                children: title
            }),
            showArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                size: "xSmall",
                withBoundingBox: false
            })
        ]
    });
});

// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuLinks/index.module.scss
var OverlayMenuLinks_index_module = __webpack_require__(77023);
var OverlayMenuLinks_index_module_default = /*#__PURE__*/__webpack_require__.n(OverlayMenuLinks_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuLinks/index.jsx






// import { omitTextAndTabGroup } from './OverlayMenuLinks.utils';
const OverlayMenuLinks = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , title , items , CTAs , size ="small" , isCTA =false , newTabGroup =false , ...rest } = props;
    const isSmall = size === "small";
    const titleID = (0,react.useId)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        ref: ref,
        direction: "column",
        align: "flex-start",
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-links", (OverlayMenuLinks_index_module_default()).overlayMenuLinks, isSmall && !(items === null || items === void 0 ? void 0 : items.length) && (title === null || title === void 0 ? void 0 : title.href) && (OverlayMenuLinks_index_module_default()).overlayMenuLinksNoMargin),
        ...rest,
        children: [
            title && (!isCTA ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                    component: (title === null || title === void 0 ? void 0 : title.href) ? "a" : "span",
                    className: (0,clsx/* default */.Z)((OverlayMenuLinks_index_module_default()).liVBY, (title === null || title === void 0 ? void 0 : title.href) && (OverlayMenuLinks_index_module_default()).overlayMenuCategoryLinksTitleLink, newTabGroup && (OverlayMenuLinks_index_module_default()).overlayMenuCategoryLinksTitleLinkCTA),
                    id: "".concat(title.text, "-").concat(titleID),
                    target: (title === null || title === void 0 ? void 0 : title.href) ? newTabGroup ? "_blank" : undefined : undefined,
                    ...(0,helpers/* omitText */.rW)(title),
                    children: [
                        title.text,
                        newTabGroup && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLinkIcon/* ExternalLinkIcon */.h, {
                            size: "small",
                            withBoundingBox: false
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                size: "small",
                underline: false,
                rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                    size: "small",
                    withBoundingBox: false
                }),
                ...(0,helpers/* omitText */.rW)(title),
                children: title.text
            })),
            (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                component: "ul",
                direction: "column",
                gap: 15,
                "aria-labelledby": title && "".concat(title.text, "-").concat(titleID),
                className: (OverlayMenuLinks_index_module_default()).overlayMenuLinksList,
                children: items.map((item)=>{
                    if ("href" in item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                            component: "li",
                            className: (OverlayMenuLinks_index_module_default()).overlayMenuCategoryLinksLink,
                            children: [
                                isSmall && item.target !== "_blank" && !item.newTabGroup && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    component: "a",
                                    size: "navigation-overlay-item-s",
                                    textColor: "var(--content-action-default)",
                                    // {...omitTextAndTabGroup(item)}
                                    href: item.href,
                                    target: item.target,
                                    rel: item.target === "_blank" ? "noopener noreferrer" : undefined,
                                    className: (OverlayMenuLinks_index_module_default()).overlayMenuCategoryLinksLink,
                                    children: item.text
                                }),
                                (!isSmall || item.target === "_blank" || item.newTabGroup) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    size: "medium",
                                    rightIcon: undefined,
                                    href: item.href,
                                    target: item.target,
                                    rel: item.target === "_blank" ? "noopener noreferrer" : undefined,
                                    underline: false,
                                    className: (OverlayMenuLinks_index_module_default()).overlayMenuCategoryLinksLinkComponent,
                                    children: item.text
                                })
                            ]
                        }, item.text || item.href);
                    } else {
                        var ref;
                        var ref1;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenuLinks, {
                            component: "li",
                            ...item
                        }, "group-".concat((ref1 = (ref = item.title) === null || ref === void 0 ? void 0 : ref.text) !== null && ref1 !== void 0 ? ref1 : Math.random()));
                    }
                })
            }),
            CTAs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                component: "ul",
                direction: "column",
                gap: isSmall ? 10 : 2,
                marginTop: isSmall ? 10 : 2,
                className: (OverlayMenuLinks_index_module_default()).overlayMenuLinksList,
                children: CTAs.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        component: "li",
                        className: (OverlayMenuLinks_index_module_default()).overlayMenuCategoryLinksCTA,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            size: isSmall ? "small" : "medium",
                            underline: false,
                            rightIcon: isSmall ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                                size: "small",
                                withBoundingBox: false
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLinkIcon/* ExternalLinkIcon */.h, {
                                withBoundingBox: false
                            }),
                            ...(0,helpers/* omitText */.rW)(link),
                            children: link.text
                        })
                    }, link.href))
            })
        ]
    });
});

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Tab/Tab.mjs + 2 modules
var Tab = __webpack_require__(35384);
// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuTabs/index.module.scss
var OverlayMenuTabs_index_module = __webpack_require__(34504);
var OverlayMenuTabs_index_module_default = /*#__PURE__*/__webpack_require__.n(OverlayMenuTabs_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenuTabs/index.jsx






const OverlayMenuTabs = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , title , CTAs , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        ref: ref,
        direction: "column",
        gap: 10,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-tabs", (OverlayMenuTabs_index_module_default()).overlayMenuTabs),
        ...rest,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                component: "span",
                size: "label-medium-m",
                textColor: "var(--Primary-Carbon, #5D5D5D);",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                component: "ul",
                direction: "column",
                gap: 0,
                children: CTAs === null || CTAs === void 0 ? void 0 : CTAs.map((link)=>{
                    const { hasChildrenList , ...linkProps } = link;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        component: "li",
                        children: hasChildrenList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* Tab */.O, {
                            variant: "vertical",
                            id: link.text,
                            textColor: "var(--content-action-default)",
                            type: "button",
                            ...linkProps
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            underline: false,
                            rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                                withBoundingBox: false,
                                size: "xSmall"
                            }),
                            className: (OverlayMenuTabs_index_module_default()).overlayMenuImageCTA,
                            size: "small",
                            href: link.href,
                            children: link.text
                        })
                    }, link.text);
                })
            })
        ]
    });
});

// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenu/index.module.scss
var OverlayMenu_index_module = __webpack_require__(59658);
var OverlayMenu_index_module_default = /*#__PURE__*/__webpack_require__.n(OverlayMenu_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenu/index.utils.js
const isILink = (item)=>"href" in item;
function getSanitizedLanguagePickerCTA(config) {
    const { location , languagePickerCTA , currentLanguage , secondLanguageCTA , ...rest } = config;
    return {
        ...rest
    };
}
function countCTAListsWithItems(data) {
    return (data.CTALists || []).reduce((count, group)=>{
        const groups = Array.isArray(group) ? group : [
            group
        ];
        const hasItems = groups.some((g)=>Array.isArray(g.items) && g.items.length > 0);
        return hasItems ? count + 1 : count;
    }, 0);
}

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/UserIcon.mjs
var UserIcon = __webpack_require__(3423);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/LocationIcon.mjs
var LocationIcon = __webpack_require__(11242);
// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/LoginMenu/index.module.scss
var LoginMenu_index_module = __webpack_require__(58933);
var LoginMenu_index_module_default = /*#__PURE__*/__webpack_require__.n(LoginMenu_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/LoginMenu/index.jsx
"use client";






const LoginMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    var ref1;
    const { className , headingSignIn , headingSignOut , loggedInCTAs , loggedOutCTAs , signOutCTA , isLoggedIn , setIsOpenMobileMenu , setMenuType , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(className, "kohler-login-menu-root", (LoginMenu_index_module_default()).loginMenu);
    const { width  } = (0,use_window_size/* useWindowSize */.i)();
    const isSmallerScreen = width < 1024;
    const closeMenu = (0,react.useCallback)(()=>{
        setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
        if (setIsOpenMobileMenu) {
            setIsOpenMobileMenu(false);
        }
    }, [
        setIsOpenMobileMenu,
        setMenuType
    ]);
    (0,react.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === "Escape") {
                closeMenu();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        closeMenu
    ]);
    const handleBackdropClick = (e)=>{
        if (e.target === e.currentTarget) {
            closeMenu();
        }
    };
    const handleLoggedOutCTAClick = ()=>{
        closeMenu();
    };
    var _component, _component1, _component2, _component3, _component4, _component5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LoginMenu_index_module_default()).loginMenuBackdrop,
        onClick: handleBackdropClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            id: "login-menu",
            component: "div",
            ref: ref,
            className: classNames,
            ...rest,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                className: (0,clsx/* default */.Z)("center-grid", (LoginMenu_index_module_default()).loginMenuGridGap),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        className: (LoginMenu_index_module_default()).loginMenuMobileClose,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                component: "button",
                                type: "button",
                                onClick: closeMenu,
                                className: (LoginMenu_index_module_default()).loginMenuMobileCloseIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {
                                    withBoundingBox: false,
                                    size: "medium"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                size: "label-regular-m",
                                component: "button",
                                type: "button",
                                textColor: "var(--content-secondary)",
                                className: (LoginMenu_index_module_default()).loginMenuMobileBackText,
                                onClick: closeMenu,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
                                        withBoundingBox: false,
                                        size: "small"
                                    }),
                                    " Menu"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        className: (LoginMenu_index_module_default()).loginMenuContent,
                        children: [
                            isLoggedIn && headingSignIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                size: "navigation-overlay-title",
                                textColor: "var(--Primary-White, #FFF);",
                                className: (LoginMenu_index_module_default()).loginMenuHeading,
                                children: headingSignIn.text
                            }),
                            !isLoggedIn && headingSignOut && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                size: "navigation-overlay-title",
                                textColor: "var(--Primary-White, #FFF);",
                                className: (LoginMenu_index_module_default()).loginMenuHeading,
                                children: headingSignOut.text
                            })
                        ]
                    }),
                    (loggedInCTAs || loggedOutCTAs) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        className: (LoginMenu_index_module_default()).loginMenuContentList,
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        wrap: "nowrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                className: (LoginMenu_index_module_default()).loginMenuContentListGroup,
                                children: isLoggedIn && loggedInCTAs && loggedInCTAs.slice(0, 2).map((CTA)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        component: "href" in CTA && (CTA === null || CTA === void 0 ? void 0 : CTA.href) ? (_component = CTA.component) !== null && _component !== void 0 ? _component : "a" : (_component1 = CTA.component) !== null && _component1 !== void 0 ? _component1 : "button",
                                        ...(0,helpers/* omitText */.rW)(CTA),
                                        size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
                                        textColor: "var(--Primary-White, #FFF)",
                                        className: (LoginMenu_index_module_default()).loginMenuContentListItem,
                                        children: CTA.text
                                    }, CTA.text);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                className: !isLoggedIn ? (0,clsx/* default */.Z)((LoginMenu_index_module_default()).loginMenuContentListRightGroup, (LoginMenu_index_module_default()).loginMenuContentListRightGroupLoggedOut) : (LoginMenu_index_module_default()).loginMenuContentListRightGroup,
                                alignItems: "flex-start",
                                style: !isLoggedIn ? {
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "0",
                                    marginLeft: "0"
                                } : undefined,
                                children: [
                                    isLoggedIn && loggedInCTAs && loggedInCTAs[2] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        component: "href" in loggedInCTAs[2] && ((ref1 = loggedInCTAs[2]) === null || ref1 === void 0 ? void 0 : ref1.href) ? (_component2 = loggedInCTAs[2].component) !== null && _component2 !== void 0 ? _component2 : "a" : (_component3 = loggedInCTAs[2].component) !== null && _component3 !== void 0 ? _component3 : "button",
                                        ...(0,helpers/* omitText */.rW)(loggedInCTAs[2]),
                                        size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
                                        textColor: "var(--Primary-White, #FFF)",
                                        className: (LoginMenu_index_module_default()).loginMenuContentListItem,
                                        children: loggedInCTAs[2].text
                                    }),
                                    !isLoggedIn && loggedOutCTAs && loggedOutCTAs.map((CTA)=>{
                                        var _component, _component1;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            style: {
                                                listStyle: "none",
                                                margin: 0,
                                                padding: 0
                                            },
                                            onClick: handleLoggedOutCTAClick,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                component: "href" in CTA && (CTA === null || CTA === void 0 ? void 0 : CTA.href) ? (_component = CTA.component) !== null && _component !== void 0 ? _component : "a" : (_component1 = CTA.component) !== null && _component1 !== void 0 ? _component1 : "button",
                                                ...(0,helpers/* omitText */.rW)(CTA),
                                                size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
                                                textColor: "var(--Primary-White, #FFF) ",
                                                className: (0,clsx/* default */.Z)((LoginMenu_index_module_default()).loginMenuContentListItem, !isLoggedIn && (LoginMenu_index_module_default()).loginMenuContentListItemLoggedOut),
                                                children: CTA.text
                                            })
                                        }, CTA.text);
                                    }),
                                    isLoggedIn && signOutCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        component: "href" in signOutCTA && (signOutCTA === null || signOutCTA === void 0 ? void 0 : signOutCTA.href) ? (_component4 = signOutCTA.component) !== null && _component4 !== void 0 ? _component4 : "a" : (_component5 = signOutCTA.component) !== null && _component5 !== void 0 ? _component5 : "button",
                                        ...(0,helpers/* omitText */.rW)(signOutCTA),
                                        size: isSmallerScreen ? "label-regular-l" : "label-regular-m",
                                        textColor: "var(--Primary-White, #FFF)",
                                        className: (LoginMenu_index_module_default()).loginMenuContentListItem,
                                        children: signOutCTA.text || "Sign Out"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
});

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.mjs + 16 modules
var Checkbox = __webpack_require__(65072);
// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/StoreMenu/index.module.scss
var StoreMenu_index_module = __webpack_require__(40400);
var StoreMenu_index_module_default = /*#__PURE__*/__webpack_require__.n(StoreMenu_index_module);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs + 2 modules
var Button = __webpack_require__(46718);
// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/StoreMenu/ZipCodeInputField/index.module.scss
var ZipCodeInputField_index_module = __webpack_require__(42830);
var ZipCodeInputField_index_module_default = /*#__PURE__*/__webpack_require__.n(ZipCodeInputField_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/StoreMenu/ZipCodeInputField/index.jsx
"use client";





const ZipCodeInputField = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { handleSubmit , onSubmit , id ="zipcode-input" , label ="Zip Code" , placeholder , CTA , className , inputValue , onInputChange , ...rest } = props;
    const [value, setValue] = (0,react.useState)(null);
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: "waitlist-form",
        onSubmit: (event)=>{
            event.preventDefault();
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event);
            const target = event.target;
            handleSubmit(target.elements[0].value || "");
        },
        onInvalid: (e)=>{
            e.preventDefault();
        },
        ...rest,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: ref,
            className: (0,clsx/* default */.Z)((ZipCodeInputField_index_module_default()).inputContainer, "kohler-input-field-wrapper", className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    size: "h4",
                    component: "input",
                    id: id,
                    type: "text",
                    className: (0,clsx/* default */.Z)((ZipCodeInputField_index_module_default()).input),
                    placeholder: placeholder || label,
                    ref: ref,
                    "aria-label": rest["aria-label"],
                    autoCapitalize: "off",
                    autoCorrect: "off",
                    maxLength: 75,
                    min: 0,
                    value: (ref1 = inputValue !== null && inputValue !== void 0 ? inputValue : value) !== null && ref1 !== void 0 ? ref1 : "",
                    onChange: (e)=>{
                        if (typeof onInputChange === "function") {
                            onInputChange(e);
                        } else {
                            const newValue = e.target.value;
                            setValue(newValue.length === 0 ? null : newValue);
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    variant: "primary",
                    size: "small",
                    type: "submit",
                    disabled: !inputValue && !value,
                    className: (ZipCodeInputField_index_module_default()).inputFieldButton,
                    ...(0,helpers/* omitText */.rW)(CTA || {}),
                    children: (CTA === null || CTA === void 0 ? void 0 : CTA.text) || "Submit"
                })
            ]
        })
    });
});

// EXTERNAL MODULE: ./src/components/core/Modal/ZipCodeInfoModal.jsx
var ZipCodeInfoModal = __webpack_require__(4801);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/StoreMenu/index.jsx
"use client";








const StoreMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , heading , CTAs , eyebrow , subheading , storeInfo , zipCodeInput , setStoreCTA , setMenuType , setIsOpenMobileMenu , infoModal , infoModalErrror , setInfoModal , staticTexts , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(className, "kohler-store-menu-root", (StoreMenu_index_module_default()).storeMenu);
    // Desktop backdrop click handler
    const handleBackdropClick = (e)=>{
        if (e.target === e.currentTarget) {
            setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
            if (setIsOpenMobileMenu) setIsOpenMobileMenu(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            infoModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                handleModalClose: ()=>setInfoModal(false),
                show: infoModal,
                data: infoModalErrror,
                labelledBy: "Geo-Location-error-message",
                className: "message-modal",
                staticTexts: staticTexts,
                dataLayerPosition: "global header"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (StoreMenu_index_module_default()).storeMenuBackdrop,
                onClick: handleBackdropClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    id: "store-menu",
                    component: "div",
                    ref: ref,
                    className: classNames,
                    ...rest,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                        className: (0,clsx/* default */.Z)("center-grid", (StoreMenu_index_module_default()).storeMenuMainGrid),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                className: (StoreMenu_index_module_default()).storeMenuMobileClose,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        component: "button",
                                        type: "button",
                                        onClick: ()=>{
                                            setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
                                            if (setIsOpenMobileMenu) {
                                                setIsOpenMobileMenu(false);
                                            }
                                        },
                                        className: (StoreMenu_index_module_default()).storeMenuMobileCloseIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {
                                            withBoundingBox: false,
                                            size: "medium"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                        size: "label-regular-m",
                                        component: "button",
                                        type: "button",
                                        textColor: "var(--content-secondary)",
                                        className: (StoreMenu_index_module_default()).storeMenuMobileBackText,
                                        onClick: ()=>{
                                            return setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
                                                withBoundingBox: false,
                                                size: "small"
                                            }),
                                            " Menu"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                className: (0,clsx/* default */.Z)((StoreMenu_index_module_default()).storeMenuMainContent, !storeInfo && (StoreMenu_index_module_default()).storeMenuMainFullContent),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                        className: (StoreMenu_index_module_default()).storeMenuContentHeading,
                                        children: [
                                            eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                size: "label-medium-m",
                                                textColor: "var(--content-primary)",
                                                component: /*#__PURE__*/ (0,react.isValidElement)(eyebrow.text) ? "div" : eyebrow.component || "p",
                                                className: (StoreMenu_index_module_default()).storeMenuEyebrow,
                                                children: eyebrow.text
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                size: "navigation-overlay-title",
                                                textColor: "var(--content-primary)",
                                                className: (StoreMenu_index_module_default()).storeMenuHeadingCustom,
                                                children: heading.text
                                            }),
                                            subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                size: "label-regular-m",
                                                textColor: "var(--content-primary)",
                                                component: /*#__PURE__*/ (0,react.isValidElement)(subheading.text) ? "div" : subheading.component || "p",
                                                className: (StoreMenu_index_module_default()).storeMenuSubheadingCustom,
                                                children: subheading.text
                                            })
                                        ]
                                    }),
                                    storeInfo && (setStoreCTA === null || setStoreCTA === void 0 ? void 0 : setStoreCTA.checked) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                        className: (StoreMenu_index_module_default()).storeMenuContentInfoContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                className: (StoreMenu_index_module_default()).storeMenuContentInfo,
                                                size: "label-regular-m",
                                                component: "div",
                                                children: storeInfo
                                            }),
                                            setStoreCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                                                ...setStoreCTA
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                className: (StoreMenu_index_module_default()).storeMenuZipContainer,
                                children: [
                                    zipCodeInput.eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        size: "label-medium-m",
                                        className: (StoreMenu_index_module_default()).storeMenuContentZipContainerEyebrow,
                                        component: /*#__PURE__*/ (0,react.isValidElement)(zipCodeInput.eyebrow.text) ? "div" : zipCodeInput.eyebrow.component || "p",
                                        children: zipCodeInput.eyebrow.text
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInputField, {
                                        ...zipCodeInput
                                    }),
                                    CTAs && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: (StoreMenu_index_module_default()).storeMenuContentList,
                                        children: CTAs.map((CTA)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    component: CTA.component || "a",
                                                    ...(0,helpers/* omitText */.rW)(CTA),
                                                    className: (0,clsx/* default */.Z)((StoreMenu_index_module_default()).storeMenuContentListItemLink),
                                                    size: "label-regular-m",
                                                    children: CTA.text
                                                })
                                            }, CTA.text);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
});

// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/UtilityBarMobile/index.module.scss
var UtilityBarMobile_index_module = __webpack_require__(23243);
var UtilityBarMobile_index_module_default = /*#__PURE__*/__webpack_require__.n(UtilityBarMobile_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/UtilityBarMobile/index.jsx








const omitFavoritesCTA = (favoritesCTA)=>{
    const { isFilled =false , ...omitFavoritesCTA } = favoritesCTA;
    return {
        isFilled,
        omitFavoritesCTA
    };
};
const UtilityBarMobile = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { utilityLinks , className , requestAppointmentCTA , ...rest } = props;
    const { userCTA , locationPickerCTA , favoritesCTA , userName , isLoggedIn , utilityLinksMobile , menuType , storeMenu , loginMenu , setIsOpenMobileMenu , setMenuType , userCTAMobile  } = utilityLinks || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
        className: (0,clsx/* clsx */.W)((UtilityBarMobile_index_module_default()).utilityBarOverlayMobile, className),
        ref: ref,
        ...rest,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            direction: "column",
            gap: 20,
            paddingTop: 20,
            paddingBottom: 20,
            children: [
                userCTA && !userCTAMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    component: "button",
                    type: "button",
                    textColor: "var(--content-primary)",
                    "aria-label": isLoggedIn ? "user sign in" : "profile",
                    ...userCTA,
                    onClick: (e)=>{
                        var ref;
                        userCTA === null || userCTA === void 0 ? void 0 : (ref = userCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(userCTA, e);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        gap: 5,
                        align: "center",
                        component: "span",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon/* UserIcon */.t, {
                                withBoundingBox: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                size: "navigation-s",
                                component: "span",
                                textColor: "var(--content-primary)",
                                children: userCTA.text ? userCTA.text : isLoggedIn && userName ? "Hi, ".concat(userName) : "Sign in / Create Account"
                            })
                        ]
                    })
                }),
                userCTAMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                            textColor: "var(--content-primary)",
                            className: (UtilityBarMobile_index_module_default()).userCTAMobileWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                    gap: 5,
                                    align: "center",
                                    component: "button",
                                    type: "button",
                                    onClick: (e)=>{
                                        var ref;
                                        const userCTAOnClick = userCTAMobile === null || userCTAMobile === void 0 ? void 0 : (ref = userCTAMobile.signInCTA) === null || ref === void 0 ? void 0 : ref.onClick;
                                        if (!userCTAOnClick) {
                                            var ref1;
                                            userCTA === null || userCTA === void 0 ? void 0 : (ref1 = userCTA.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(userCTA, e);
                                        } else {
                                            userCTAOnClick(e);
                                        }
                                    },
                                    ...(0,helpers/* omitText */.rW)(userCTAMobile.signInCTA),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon/* UserIcon */.t, {
                                            withBoundingBox: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            size: "navigation-s",
                                            component: "div",
                                            textColor: "var(--content-primary)",
                                            children: userCTAMobile.signInCTA.text || "Sign in"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    size: "navigation-s",
                                    component: "span",
                                    textColor: "var(--content-primary)",
                                    children: "/"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    size: "navigation-s",
                                    component: "button",
                                    type: "button",
                                    textColor: "var(--content-primary)",
                                    onClick: (e)=>{
                                        var ref;
                                        const userCTAOnClick = userCTAMobile === null || userCTAMobile === void 0 ? void 0 : (ref = userCTAMobile.signUpCTA) === null || ref === void 0 ? void 0 : ref.onClick;
                                        if (!userCTAOnClick) {
                                            var ref1;
                                            userCTA === null || userCTA === void 0 ? void 0 : (ref1 = userCTA.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(userCTA, e);
                                        } else {
                                            userCTAOnClick(e);
                                        }
                                    },
                                    ...(0,helpers/* omitText */.rW)(userCTAMobile.signUpCTA),
                                    children: userCTAMobile.signUpCTA.text || "Create Account"
                                })
                            ]
                        }),
                        isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            component: "button",
                            type: "button",
                            textColor: "var(--content-primary)",
                            ...userCTAMobile.accountCTA,
                            onClick: (e)=>{
                                var ref;
                                const userCTAOnClick = userCTAMobile === null || userCTAMobile === void 0 ? void 0 : (ref = userCTAMobile.accountCTA) === null || ref === void 0 ? void 0 : ref.onClick;
                                if (!userCTAOnClick) {
                                    var ref1;
                                    userCTA === null || userCTA === void 0 ? void 0 : (ref1 = userCTA.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(userCTA, e);
                                } else {
                                    userCTAOnClick(e);
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                gap: 5,
                                align: "center",
                                component: "span",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon/* UserIcon */.t, {
                                        withBoundingBox: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        size: "navigation-s",
                                        component: "span",
                                        textColor: "var(--content-primary)",
                                        children: userCTAMobile.accountCTA.text || "Hi, ".concat(userName)
                                    })
                                ]
                            })
                        }),
                        menuType && loginMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            display: menuType !== "user" ? "none" : undefined,
                            className: (UtilityBarMobile_index_module_default()).menuPositionWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginMenu, {
                                ...loginMenu,
                                setMenuType: setMenuType,
                                setIsOpenMobileMenu: setIsOpenMobileMenu
                            })
                        })
                    ]
                }),
                locationPickerCTA && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            gap: 5,
                            align: "center",
                            component: "button",
                            ...locationPickerCTA,
                            onClick: (e)=>{
                                var ref;
                                locationPickerCTA === null || locationPickerCTA === void 0 ? void 0 : (ref = locationPickerCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(locationPickerCTA, e);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationIcon/* LocationIcon */._, {
                                    withBoundingBox: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    size: "navigation-s",
                                    component: "span",
                                    textColor: "var(--content-primary)",
                                    children: locationPickerCTA.text || "Find a Store"
                                })
                            ]
                        }),
                        menuType && storeMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            display: menuType !== "store" ? "none" : undefined,
                            className: (UtilityBarMobile_index_module_default()).menuPositionWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreMenu, {
                                ...storeMenu,
                                setMenuType: setMenuType,
                                setIsOpenMobileMenu: setIsOpenMobileMenu
                            })
                        })
                    ]
                }),
                requestAppointmentCTA && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    component: requestAppointmentCTA.href ? "a" : "button",
                    href: requestAppointmentCTA.href,
                    target: requestAppointmentCTA.target,
                    align: "center",
                    gap: 5,
                    "aria-label": "request appointment",
                    textColor: "var(--content-primary)",
                    ...(0,helpers/* omitText */.rW)(requestAppointmentCTA),
                    className: (UtilityBarMobile_index_module_default()).requestAppointmentCTA,
                    style: {
                        justifyContent: "flex-start"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "30",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M7.58105 0.207107C7.82651 0.207107 8.03066 0.383982 8.073 0.617231L8.08105 0.707107L8.08105 14.4564C8.08105 14.7325 7.8572 14.9564 7.58105 14.9564C7.33559 14.9564 7.13145 14.7795 7.08911 14.5463L7.08105 14.4564L7.08105 0.707107C7.08105 0.430964 7.30491 0.207107 7.58105 0.207107Z",
                                        fill: "white"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M14.956 7.58179C14.956 7.33633 14.7791 7.13218 14.5459 7.08984L14.456 7.08179L0.706681 7.08179C0.430539 7.08179 0.206682 7.30565 0.206682 7.58179C0.206681 7.82725 0.383556 8.0314 0.616805 8.07373L0.706681 8.08179L14.456 8.08179C14.7321 8.08179 14.956 7.85793 14.956 7.58179Z",
                                        fill: "white"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            size: "navigation-s",
                            component: "span",
                            textColor: "var(--content-primary)",
                            children: requestAppointmentCTA.text || "Request Appointment"
                        })
                    ]
                })
            ]
        })
    });
});

;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/OverlayMenu/index.jsx















const OverlayMenu = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const { className , CTALists , images , mainMenuItems , setIsOpenMobileMenu , isMoreOverlay , utilityLinks , buttonCTA , closeCTA , tabList , ...rest } = props;
    const [selectedTab, setSelectedTab] = (0,react.useState)(null);
    const [selectedMobileMenuItem, setSelectedMobileMenuItem] = (0,react.useState)(null);
    const [selectedMoreTab, setSelectedMoreTab] = (0,react.useState)(isMoreOverlay && mainMenuItems ? mainMenuItems[0] : null);
    const [CTAListsData, setCTAListsData] = (0,react.useState)((tabList === null || tabList === void 0 ? void 0 : tabList.length) > 0 ? (ref = tabList === null || tabList === void 0 ? void 0 : tabList.find((tab)=>{
        var ref;
        return tab.title === (tabList === null || tabList === void 0 ? void 0 : (ref = tabList[0]) === null || ref === void 0 ? void 0 : ref.title);
    })) === null || ref === void 0 ? void 0 : ref.menuItems : CTALists !== null && CTALists !== void 0 ? CTALists : []);
    const [openCategoryIndex, setOpenCategoryIndex] = (0,react.useState)(null);
    const menueprops = {
        align: "left",
        initialSelectedTab: (tabList === null || tabList === void 0 ? void 0 : (ref1 = tabList[0]) === null || ref1 === void 0 ? void 0 : ref1.title) || null,
        tabs: tabList === null || tabList === void 0 ? void 0 : tabList.map((tab, index)=>({
                text: tab.title,
                id: "label-".concat(index + 1),
                parentLink: tab.parentLink
            }))
    };
    const CTAListsMobile = mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.find((val)=>val.text === selectedMobileMenuItem);
    (0,react.useEffect)(()=>{
        var ref;
        setSelectedTab((tabList === null || tabList === void 0 ? void 0 : (ref = tabList[0]) === null || ref === void 0 ? void 0 : ref.title) || null);
    }, [
        tabList
    ]);
    (0,react.useEffect)(()=>{
        if (isMoreOverlay) {
            setSelectedMoreTab(mainMenuItems ? mainMenuItems[0] : null);
        }
    }, [
        isMoreOverlay,
        mainMenuItems
    ]);
    (0,react.useEffect)(()=>{
        const data = tabList === null || tabList === void 0 ? void 0 : tabList.find((tab)=>tab.title === selectedTab);
        setCTAListsData((data === null || data === void 0 ? void 0 : data.menuItems) || CTALists);
    }, [
        selectedTab,
        tabList,
        CTALists
    ]);
    // Find the selected tab object in tabList for desktop images
    const selectedTabData = tabList === null || tabList === void 0 ? void 0 : tabList.find((tab)=>tab.title === selectedTab);
    // Determine which images to show (tab images or fallback to top-level images)
    const imagesToShow = (selectedTabData === null || selectedTabData === void 0 ? void 0 : (ref2 = selectedTabData.images) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && selectedTabData.images || (images === null || images === void 0 ? void 0 : images.length) > 0 && images || [];
    let shopAllLinkMobile = null;
    if (CTAListsMobile) {
        if (selectedTab && CTAListsMobile.tabList) {
            // Find the selected tab object
            const tabData = CTAListsMobile.tabList.find((tab)=>tab.title === selectedTab);
            if (tabData && tabData.menuItems) {
                const flatMenuItems = tabData.menuItems.flat();
                shopAllLinkMobile = flatMenuItems.flatMap((item)=>item.items || []).find((link)=>link.text && link.text.toLowerCase().includes("shop all") || link.label && link.label.toLowerCase().includes("shop all"));
            }
        }
        // Fallback: if no tab selected or no Shop All in tab, check main menu item's CTALists
        if (!shopAllLinkMobile) {
            const allLinks = (CTAListsMobile.CTALists || []).flatMap((list)=>Array.isArray(list) ? list.flatMap((l)=>l.items || []) : list.items || []);
            shopAllLinkMobile = allLinks.find((link)=>link.text && link.text.toLowerCase().includes("shop all") || link.label && link.label.toLowerCase().includes("shop all"));
        }
    }
    // MOBILE: If a tab is selected, show its submenu categories as accordions
    const renderMobileTabContent = ()=>{
        var ref, ref1, ref2;
        if (!CTAListsMobile || !selectedTab) return null;
        // Find the selected tab object in tabList
        const tabData = (ref = CTAListsMobile.tabList) === null || ref === void 0 ? void 0 : ref.find((tab)=>tab.title === selectedTab);
        if (!tabData || !tabData.menuItems || tabData.menuItems.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
            size: "navigation-m",
            textColor: "var(--content-secondary)",
            style: {
                padding: "24px",
                textAlign: "center"
            },
            children: "No menu items found."
        });
        const flatMenuItems = tabData.menuItems.flat();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    className: (OverlayMenu_index_module_default()).overlayMenuLinkLevelOneMobile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            component: "button",
                            type: "button",
                            onClick: ()=>setSelectedTab(null),
                            className: closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
                                size: "small",
                                withBoundingBox: true,
                                className: (OverlayMenu_index_module_default()).arrowLeftIcon
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                            size: "navigation-overlay-item-s",
                            textColor: "var(--content-primary)",
                            width: "100%",
                            className: (OverlayMenu_index_module_default()).overlayMenuMobileTitle,
                            children: [
                                CTAListsMobile.text,
                                " / ",
                                selectedTab
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            component: "button",
                            type: "button",
                            ...closeCTA,
                            onClick: ()=>setIsOpenMobileMenu && setIsOpenMobileMenu(false),
                            className: (0,clsx/* default */.Z)((OverlayMenu_index_module_default()).overlayMenuLinkCloseButtonMobile, closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {
                                size: "medium",
                                withBoundingBox: false
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                    direction: "column",
                    gap: 20,
                    children: flatMenuItems.map((item, idx)=>{
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(OverlayMenuCategory, {
                            title: item.title,
                            links: ((ref = item.items) === null || ref === void 0 ? void 0 : ref.filter(isILink)) || [],
                            className: (OverlayMenu_index_module_default()).overlayMenuCategoryTitle,
                            opened: openCategoryIndex === idx,
                            onToggle: ()=>setOpenCategoryIndex(openCategoryIndex === idx ? null : idx)
                        }, item.id || item.text || idx);
                    })
                }),
                (((ref1 = tabData.images) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 || (images === null || images === void 0 ? void 0 : images.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                    className: (OverlayMenu_index_module_default()).overlayMenuMobileImages,
                    children: (((ref2 = tabData.images) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? tabData.images : images || []).map((image)=>{
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(OverlayMenuImage, {
                            imagesLength: (((ref = tabData.images) === null || ref === void 0 ? void 0 : ref.length) > 0 ? tabData.images : images || []).length,
                            isBusinessTab: ![
                                "Bathroom",
                                "Collection",
                                "Kitchen",
                                "Lighting",
                                "Wellness"
                            ].includes((rest === null || rest === void 0 ? void 0 : rest.text) || ""),
                            ...image
                        }, image.image.src);
                    })
                }),
                tabData.buttonCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    type: tabData.buttonCTA.onClick ? "button" : undefined,
                    component: tabData.buttonCTA.href ? "a" : "button",
                    size: "navigation-l",
                    textColor: "var(--content-primary)",
                    ...(0,helpers/* omitText */.rW)(tabData.buttonCTA),
                    children: tabData.buttonCTA.text
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-root", (OverlayMenu_index_module_default()).overlayMenu),
        ...rest,
        children: [
            (tabList === null || tabList === void 0 ? void 0 : tabList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignSystem_TabbedNavigationHorizontal, {
                ...menueprops,
                onTabChange: (tab)=>{
                    setSelectedTab(tab.text);
                    setOpenCategoryIndex(null);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                className: (OverlayMenu_index_module_default()).overlayMenuLinkGridMainMobileWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridColumn/* GridColumn */.C, {
                        className: (OverlayMenu_index_module_default()).overlayMenuLinkGridWrapper,
                        children: [
                            (CTALists || isMoreOverlay && mainMenuItems) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                className: (OverlayMenu_index_module_default()).overlayMenuLinkGridLists,
                                children: [
                                    isMoreOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenuTabs, {
                                        className: (OverlayMenu_index_module_default()).overlayMenuLinkGrid,
                                        CTAs: mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.map((mainMenuItem)=>{
                                            return {
                                                text: mainMenuItem.text,
                                                href: mainMenuItem.href,
                                                onClick: ()=>setSelectedMoreTab(mainMenuItem),
                                                isSelected: (selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.text) === mainMenuItem.text,
                                                hasChildrenList: !!mainMenuItem.CTALists
                                            };
                                        })
                                    }),
                                    (ref3 = (selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.CTALists) || CTAListsData) === null || ref3 === void 0 ? void 0 : ref3.map((CTAList, index)=>{
                                        if (Array.isArray(CTAList)) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                                direction: "column",
                                                gap: "40px",
                                                children: CTAList.map((overlayMenuLinkGroup, idx)=>{
                                                    var ref;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(OverlayMenuLinks, {
                                                        className: (OverlayMenu_index_module_default()).overlayMenuLinkGrid,
                                                        ...overlayMenuLinkGroup
                                                    }, (overlayMenuLinkGroup === null || overlayMenuLinkGroup === void 0 ? void 0 : (ref = overlayMenuLinkGroup.title) === null || ref === void 0 ? void 0 : ref.text) + "overlay-menu-".concat(idx));
                                                })
                                            }, "select-more-tab-cta-index-".concat(index));
                                        } else {
                                            var ref;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    isMoreOverlay && index % 3 === 0 && index !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                        className: (OverlayMenu_index_module_default()).overlayMenuLinkGrid
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenuLinks, {
                                                        className: (OverlayMenu_index_module_default()).overlayMenuLinkGrid,
                                                        ...CTAList
                                                    })
                                                ]
                                            }, (CTAList === null || CTAList === void 0 ? void 0 : (ref = CTAList.title) === null || ref === void 0 ? void 0 : ref.text) + "overlay-menu-".concat(index));
                                        }
                                    })
                                ]
                            }),
                            imagesToShow.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                gap: 30,
                                children: imagesToShow.map((image)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(OverlayMenuImage, {
                                        imagesLength: imagesToShow.length,
                                        isBusinessTab: ![
                                            "Bathroom",
                                            "Collection",
                                            "Kitchen",
                                            "Lighting",
                                            "Wellness"
                                        ].includes((rest === null || rest === void 0 ? void 0 : rest.text) || ""),
                                        ...image
                                    }, image.image.src);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridColumn/* GridColumn */.C, {
                        className: (OverlayMenu_index_module_default()).overlayMenuLinkGridMobileWrapper,
                        children: [
                            mainMenuItems && !selectedMobileMenuItem && !selectedTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        component: "button",
                                        type: "button",
                                        ...closeCTA,
                                        onClick: (e)=>{
                                            if (setIsOpenMobileMenu) setIsOpenMobileMenu(false);
                                            if (closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.onClick) closeCTA.onClick(e);
                                        },
                                        className: (0,clsx/* default */.Z)((OverlayMenu_index_module_default()).overlayMenuLinkCloseButtonMobile, closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {
                                            size: "medium",
                                            withBoundingBox: false
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                        className: (OverlayMenu_index_module_default()).overlayMenuLinkGridListsMobile,
                                        children: mainMenuItems.map((mainMenuItem, index)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenuItem, {
                                                        title: mainMenuItem.text,
                                                        component: mainMenuItem.CTALists ? "button" : "a",
                                                        href: mainMenuItem.CTALists ? undefined : mainMenuItem.href,
                                                        onClick: mainMenuItem.CTALists ? (e)=>{
                                                            var ref;
                                                            setSelectedMobileMenuItem(mainMenuItem.text);
                                                            setOpenCategoryIndex(null);
                                                            (ref = mainMenuItem.onClick) === null || ref === void 0 ? void 0 : ref.call(mainMenuItem, e);
                                                        } : undefined,
                                                        className: mainMenuItem.className
                                                    }),
                                                    index < mainMenuItems.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (OverlayMenu_index_module_default()).menuItemDivider
                                                    })
                                                ]
                                            }, "".concat(mainMenuItem.text, "-mobile-").concat(index));
                                        })
                                    })
                                ]
                            }),
                            CTAListsMobile && selectedMobileMenuItem && !selectedTab && ((ref4 = CTAListsMobile.tabList) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                        className: (OverlayMenu_index_module_default()).overlayMenuLinkLevelOneMobile,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                component: "button",
                                                type: "button",
                                                onClick: ()=>setSelectedMobileMenuItem(null),
                                                className: closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
                                                    size: "small",
                                                    withBoundingBox: true,
                                                    className: (OverlayMenu_index_module_default()).arrowLeftIcon
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                size: "navigation-overlay-item-s",
                                                textColor: "var(--Primary-Charcoal,#212121))",
                                                width: "100%",
                                                className: (OverlayMenu_index_module_default()).overlayMenuMobileTitle,
                                                children: selectedMobileMenuItem
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                component: "button",
                                                type: "button",
                                                ...closeCTA,
                                                onClick: ()=>setIsOpenMobileMenu && setIsOpenMobileMenu(false),
                                                className: (0,clsx/* default */.Z)((OverlayMenu_index_module_default()).overlayMenuLinkCloseButtonMobile, closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {
                                                    size: "medium",
                                                    withBoundingBox: false
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignSystem_TabbedNavigationHorizontal, {
                                        tabs: CTAListsMobile.tabList.map((tab, idx)=>({
                                                text: tab.title,
                                                id: "tab-".concat(idx),
                                                parentLink: tab.parentLink
                                            })),
                                        align: "left",
                                        defaultActiveTab: CTAListsMobile.tabList[0].title,
                                        onTabChange: (tab)=>{
                                            setSelectedTab(tab.text);
                                            setOpenCategoryIndex(null);
                                        }
                                    })
                                ]
                            }),
                            CTAListsMobile && selectedTab && renderMobileTabContent(),
                            CTAListsMobile && selectedMobileMenuItem && !((ref5 = CTAListsMobile.tabList) === null || ref5 === void 0 ? void 0 : ref5.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                        className: (OverlayMenu_index_module_default()).overlayMenuLinkLevelOneMobile,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                component: "button",
                                                type: "button",
                                                onClick: ()=>setSelectedMobileMenuItem(null),
                                                className: closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className,
                                                "aria-label": "Back",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
                                                    size: "small",
                                                    withBoundingBox: true,
                                                    className: (OverlayMenu_index_module_default()).arrowLeftIcon
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                className: (OverlayMenu_index_module_default()).overlayMenuTitleText,
                                                size: "navigation-overlay-item-s",
                                                textColor: "var(--Primary-Charcoal, #212121);",
                                                width: "100%",
                                                font: "lato-regular",
                                                children: selectedMobileMenuItem
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                component: "button",
                                                type: "button",
                                                ...closeCTA,
                                                onClick: ()=>setIsOpenMobileMenu && setIsOpenMobileMenu(false),
                                                className: (0,clsx/* default */.Z)((OverlayMenu_index_module_default()).overlayMenuLinkCloseButtonMobile, closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className),
                                                "aria-label": "Close",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {
                                                    size: "medium",
                                                    withBoundingBox: false
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                        direction: "column",
                                        gap: 20,
                                        children: (ref6 = CTAListsMobile.CTALists) === null || ref6 === void 0 ? void 0 : ref6.map((CTAList, index)=>{
                                            var ref, ref1, ref2, ref3, ref4;
                                            if (Array.isArray(CTAList)) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                                    direction: "column",
                                                    children: CTAList.map((CTAs, subIndex)=>{
                                                        var ref, ref1;
                                                        const flatIndex = index * 100 + subIndex;
                                                        const hasItems = (ref = CTAs.items) === null || ref === void 0 ? void 0 : ref.filter(isILink);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: CTAs.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenuCategory, {
                                                                title: CTAs.title,
                                                                isCTA: CTAs.isCTA,
                                                                links: hasItems || [],
                                                                opened: hasItems ? openCategoryIndex === flatIndex : undefined,
                                                                onToggle: hasItems ? ()=>setOpenCategoryIndex(openCategoryIndex === flatIndex ? null : flatIndex) : undefined,
                                                                className: CTAs.className
                                                            })
                                                        }, (CTAs === null || CTAs === void 0 ? void 0 : (ref1 = CTAs.title) === null || ref1 === void 0 ? void 0 : ref1.text) + "overlay-category-".concat(subIndex));
                                                    })
                                                }, "cta-list-array-".concat(index));
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: CTAList.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenuCategory, {
                                                    title: CTAList.title,
                                                    isCTA: CTAList.isCTA,
                                                    links: ((ref = CTAList.items) === null || ref === void 0 ? void 0 : ref.filter(isILink)) || [],
                                                    opened: ((ref1 = CTAList.items) === null || ref1 === void 0 ? void 0 : ref1.filter(isILink)) && openCategoryIndex === index,
                                                    onToggle: ((ref2 = CTAList.items) === null || ref2 === void 0 ? void 0 : ref2.filter(isILink)) ? ()=>setOpenCategoryIndex(openCategoryIndex === index ? null : index) : undefined,
                                                    className: CTAList.className
                                                }) : (ref3 = CTAList.items) === null || ref3 === void 0 ? void 0 : ref3.map((CTAs, idx)=>{
                                                    var ref, ref1, ref2;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: CTAs.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenuCategory, {
                                                            title: CTAs.title,
                                                            links: (ref = CTAs.items) === null || ref === void 0 ? void 0 : ref.filter(isILink),
                                                            showArrow: false,
                                                            isExternal: CTAs.newTabGroup || ((ref1 = CTAs.title) === null || ref1 === void 0 ? void 0 : ref1.target) === "_blank"
                                                        })
                                                    }, "".concat((CTAs === null || CTAs === void 0 ? void 0 : (ref2 = CTAs.title) === null || ref2 === void 0 ? void 0 : ref2.text) || "no-title", "-overlay-category-").concat(idx));
                                                })
                                            }, (CTAList === null || CTAList === void 0 ? void 0 : (ref4 = CTAList.title) === null || ref4 === void 0 ? void 0 : ref4.text) || "overlay-category-".concat(index));
                                        })
                                    }),
                                    ((ref7 = CTAListsMobile.images) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                        className: (OverlayMenu_index_module_default()).overlayMenuMobileImages,
                                        children: CTAListsMobile.images.map((image)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenuImage, {
                                                imagesLength: CTAListsMobile.images.length,
                                                isBusinessTab: ![
                                                    "Bathroom",
                                                    "Collection",
                                                    "Kitchen",
                                                    "Lighting",
                                                    "Wellness"
                                                ].includes(CTAListsMobile.text || ""),
                                                ...image
                                            }, image.image.src))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            shopAllLinkMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)((OverlayMenu_index_module_default()).shopAllCTA, (OverlayMenu_index_module_default()).shopAllCTAFixed),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: shopAllLinkMobile.href || shopAllLinkMobile.link,
                    target: shopAllLinkMobile.target,
                    className: (OverlayMenu_index_module_default()).shopAllCTA,
                    ...(0,helpers/* omitText */.rW)(shopAllLinkMobile),
                    children: shopAllLinkMobile.text || shopAllLinkMobile.label
                })
            }),
            mainMenuItems && !selectedMobileMenuItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityBarMobile, {
                utilityLinks: utilityLinks,
                requestAppointmentCTA: buttonCTA
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/MainNavigationBar/index.hooks.jsx


const useResponsiveNav = (menuItems)=>{
    var ref;
    const [visibleItems, setVisibleItems] = (0,react.useState)(menuItems);
    const [overflowItems, setOverflowItems] = (0,react.useState)([]);
    const [isMoreOpen, setIsMoreOpen] = (0,react.useState)(false);
    const navRef = (0,react.useRef)(null);
    const containerRef = (0,react.useRef)(null);
    const moreButtonRef = (0,react.useRef)(null);
    const resizeTimeoutRef = (0,react.useRef)(null);
    const itemWidthsRef = (0,react.useRef)({});
    const windowSize = (0,use_window_size/* useWindowSize */.i)();
    const measureItemWidths = (0,react.useCallback)(()=>{
        if (!navRef.current) return;
        const newWidths = {};
        navRef.current.childNodes.forEach((node)=>{
            const element = node;
            if (element.id) {
                newWidths[element.id] = element.offsetWidth;
            }
        });
        itemWidthsRef.current = newWidths;
    }, []);
    const calculateVisibility = (0,react.useCallback)(()=>{
        var ref;
        if (!navRef.current || !containerRef.current) return;
        const containerWidth = containerRef.current.clientWidth;
        const moreButtonWidth = ((ref = moreButtonRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) ? moreButtonRef.current.offsetWidth + 15 : 70;
        let totalWidth = 0;
        const newVisibleItems = [];
        const newOverflowItems = [];
        for (const item of menuItems){
            const itemWidth = itemWidthsRef.current[item.text] || 0;
            totalWidth += itemWidth;
            if (totalWidth < containerWidth - moreButtonWidth) {
                newVisibleItems.push(item);
            } else {
                newOverflowItems.push(item);
            }
        }
        setVisibleItems(newVisibleItems);
        setOverflowItems(newOverflowItems);
    }, [
        menuItems
    ]);
    (0,react.useEffect)(()=>{
        if (resizeTimeoutRef.current) clearTimeout(resizeTimeoutRef.current);
        resizeTimeoutRef.current = setTimeout(()=>{
            measureItemWidths();
            calculateVisibility();
        }, 200);
        return ()=>{
            if (resizeTimeoutRef.current) clearTimeout(resizeTimeoutRef.current);
        };
    }, [
        windowSize.width,
        measureItemWidths,
        calculateVisibility,
        (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    return {
        visibleItems,
        overflowItems,
        isMoreOpen,
        setIsMoreOpen,
        navRef,
        containerRef,
        moreButtonRef
    };
};
/* harmony default export */ var index_hooks = (useResponsiveNav);

// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/MainNavigationBar/index.module.scss
var MainNavigationBar_index_module = __webpack_require__(69472);
var MainNavigationBar_index_module_default = /*#__PURE__*/__webpack_require__.n(MainNavigationBar_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/MainNavigationBar/index.utils.js

const mainNavigationBarVariantClasses = {
    "v2.1": index_hooks.mainNavGlobal,
    universal: index_hooks.mainNavUniversal
};

;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/MainNavigationBar/index.jsx
"use client";










const MainNavigationBar = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    const { brandCTA , menuItems , showShadow , showDesktopActions =true , searchCTA , menuCTA , searchText ="Search" , buttonCTA , designerTradeCTA , variant ="universal" , utilityLinks , showBackground =false , mod , openMobileMenu , closeCTA , setIsOpenMobileMenu , isStatic , style , showMenuDelay , transitionDuration , isAlwaysSticky , ...rest } = props;
    const isUniversal = variant === "universal";
    const { brand: brandType , ...brandCTAProps } = brandCTA;
    const [activeMenu, setActiveMenu] = (0,react.useState)(null);
    const hoverTimeoutRef = (0,react.useRef)(null);
    const { visibleItems , overflowItems , isMoreOpen , setIsMoreOpen , navRef , containerRef , moreButtonRef  } = index_hooks(menuItems);
    //handle hover enter/leave for menu item and dropdown
    const handleMenuMouseEnter = (navText)=>{
        if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
        setActiveMenu(navText);
    };
    const handleMenuMouseLeave = ()=>{
        hoverTimeoutRef.current = setTimeout(()=>{
            setActiveMenu(null);
        }, 100); // 100ms delay for hover gap fix
    };
    const isMobile =  true ? window.innerWidth < 1024 : 0;
    const isTablet =  true ? window.innerWidth >= 768 && window.innerWidth < 1024 : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).mainNav, showShadow && (MainNavigationBar_index_module_default()).mainNavShadow, mainNavigationBarVariantClasses[variant], showBackground && (MainNavigationBar_index_module_default()).mainNavBackground, (isStatic || showBackground) && (MainNavigationBar_index_module_default()).mainNavRelative, "kohler-main-navigation-bar-root"),
        ref: ref,
        style: {
            "--transition-overlay-duration": typeof transitionDuration === "number" ? "".concat(transitionDuration, "ms") : undefined,
            ...style
        },
        mod: mod,
        ...rest,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridColumn/* GridColumn */.C, {
                children: [
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        className: (MainNavigationBar_index_module_default()).mainNavMobileRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                className: (MainNavigationBar_index_module_default()).leftGroup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        component: "button",
                                        type: "button",
                                        "aria-label": "open menu",
                                        ...menuCTA,
                                        className: (0,clsx/* default */.Z)(isUniversal ? (MainNavigationBar_index_module_default()).menuIconUniversal : (MainNavigationBar_index_module_default()).menuIconVTwo, menuCTA === null || menuCTA === void 0 ? void 0 : menuCTA.className),
                                        onClick: (e)=>{
                                            if (setIsOpenMobileMenu) setIsOpenMobileMenu(true);
                                            if (menuCTA === null || menuCTA === void 0 ? void 0 : menuCTA.onClick) menuCTA.onClick(e);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon/* MenuIcon */.O, {
                                            size: "medium",
                                            withBoundingBox: false
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        component: "a",
                                        className: (MainNavigationBar_index_module_default()).brandLogo,
                                        "aria-label": "".concat(brandType, " logo"),
                                        ...brandCTAProps,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandLogo/* BrandLogo */.O, {
                                            brand: brandType
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    flex: 1
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                className: (MainNavigationBar_index_module_default()).utilitiesMobile,
                                gap: 15,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        component: "button",
                                        type: "button",
                                        "aria-label": searchText,
                                        ...searchCTA,
                                        className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).utilitiesSearchMobile, searchCTA === null || searchCTA === void 0 ? void 0 : searchCTA.className),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* SearchIcon */.W, {
                                            className: (MainNavigationBar_index_module_default()).utilitiesSearchIcon,
                                            withBoundingBox: false
                                        })
                                    }),
                                    (utilityLinks === null || utilityLinks === void 0 ? void 0 : utilityLinks.favoritesCTA) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        component: "a",
                                        display: "flex",
                                        "aria-label": "see favorites",
                                        textColor: "var(--content-primary)",
                                        ...utilityLinks.favoritesCTA,
                                        children: utilityLinks.favoritesCTA.isFilled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteNavFilledIcon/* FavoriteNavFilledIcon */.t, {
                                            withBoundingBox: false
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteNavIcon/* FavoriteNavIcon */.z, {
                                            withBoundingBox: false
                                        })
                                    }),
                                    (utilityLinks === null || utilityLinks === void 0 ? void 0 : utilityLinks.cartBadgeCTA) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartBadge/* CartBadge */.H, {
                                        component: "a",
                                        "aria-label": "see shopping cart",
                                        ...utilityLinks.cartBadgeCTA,
                                        className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).utilityLink, utilityLinks.className)
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        className: isUniversal ? (MainNavigationBar_index_module_default()).mainNavWrapperUniversal : (MainNavigationBar_index_module_default()).mainNavWrapperDefault,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                component: "button",
                                type: "button",
                                "aria-label": "open menu",
                                ...menuCTA,
                                className: (0,clsx/* default */.Z)(isUniversal ? (MainNavigationBar_index_module_default()).menuIconUniversal : (MainNavigationBar_index_module_default()).menuIconVTwo, menuCTA === null || menuCTA === void 0 ? void 0 : menuCTA.className),
                                onClick: (e)=>{
                                    if (setIsOpenMobileMenu) setIsOpenMobileMenu(true);
                                    if (menuCTA === null || menuCTA === void 0 ? void 0 : menuCTA.onClick) menuCTA.onClick(e);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon/* MenuIcon */.O, {
                                    size: "medium",
                                    withBoundingBox: false
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                className: (0,clsx/* default */.Z)(isUniversal ? (MainNavigationBar_index_module_default()).menuItemsUniversal : (MainNavigationBar_index_module_default()).menuItemsVTwo, (MainNavigationBar_index_module_default()).menuItems),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        component: "a",
                                        className: (MainNavigationBar_index_module_default()).brandLogo,
                                        "aria-label": "".concat(brandType, " logo"),
                                        ...brandCTAProps,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandLogo/* BrandLogo */.O, {
                                            brand: brandType
                                        })
                                    }),
                                    menuItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        ref: containerRef,
                                        className: (MainNavigationBar_index_module_default()).menuLinksWrapper,
                                        component: "nav",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                            className: (0,clsx/* default */.Z)(isUniversal ? (MainNavigationBar_index_module_default()).menuLinksUniversal : (MainNavigationBar_index_module_default()).menuLinksVTwo, (MainNavigationBar_index_module_default()).menuLinks),
                                            component: "ul",
                                            ref: navRef,
                                            role: "menubar",
                                            children: [
                                                visibleItems.map((navItem, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                                                component: "li",
                                                                id: navItem.text || "nav-item-".concat(navItem.text),
                                                                className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).navigationItemWrapper),
                                                                onMouseEnter: ()=>handleMenuMouseEnter(navItem.text),
                                                                onMouseLeave: handleMenuMouseLeave,
                                                                tabIndex: 0,
                                                                role: "menuitem",
                                                                "aria-haspopup": !!navItem.CTALists,
                                                                "aria-expanded": activeMenu === navItem.text,
                                                                onKeyDown: (e)=>{
                                                                    if ((e.key === "Enter" || e.key === " ") && navItem.CTALists) {
                                                                        e.preventDefault();
                                                                        const navText = navItem.text;
                                                                        setActiveMenu((prev)=>prev === navText ? null : navText);
                                                                    }
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem, {
                                                                        text: navItem.text,
                                                                        isSelected: activeMenu === navItem.text,
                                                                        href: navItem.href,
                                                                        onClick: navItem.onClick,
                                                                        variant: variant,
                                                                        className: (0,clsx/* default */.Z)(isUniversal ? (MainNavigationBar_index_module_default()).navItemUniversal : (MainNavigationBar_index_module_default()).navItemVTwo, (MainNavigationBar_index_module_default()).navItem, activeMenu === navItem.text && isUniversal && (MainNavigationBar_index_module_default()).navItemUnderline, activeMenu === navItem.text && !isUniversal && (MainNavigationBar_index_module_default()).navItemUnderlineV2)
                                                                    }),
                                                                    navItem.CTALists && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                                        className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).navigationOverlayMenuWrapper, activeMenu === navItem.text ? (MainNavigationBar_index_module_default()).navigationOverlayMenuVisible : (MainNavigationBar_index_module_default()).navigationOverlayMenuHidden),
                                                                        ...activeMenu !== navItem.text && {
                                                                            inert: "true",
                                                                            tabIndex: -1
                                                                        },
                                                                        "aria-hidden": activeMenu !== navItem.text,
                                                                        onMouseEnter: ()=>handleMenuMouseEnter(navItem.text),
                                                                        onMouseLeave: handleMenuMouseLeave,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenu, {
                                                                            mod: "white",
                                                                            ...navItem
                                                                        })
                                                                    })
                                                                ]
                                                            }, navItem.text),
                                                            idx === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (MainNavigationBar_index_module_default()).menuItemDivider
                                                            })
                                                        ]
                                                    }, navItem.text)),
                                                overflowItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                                    component: "li",
                                                    ref: moreButtonRef,
                                                    className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).navigationItemWrapper, (MainNavigationBar_index_module_default()).moreButton),
                                                    onMouseEnter: ()=>setIsMoreOpen(true),
                                                    onMouseLeave: ()=>setIsMoreOpen(false),
                                                    role: "menuitem",
                                                    "aria-haspopup": true,
                                                    "aria-expanded": isMoreOpen,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem, {
                                                            className: (0,clsx/* default */.Z)(isUniversal ? (MainNavigationBar_index_module_default()).navItemUniversal : (MainNavigationBar_index_module_default()).navItemVTwo, (MainNavigationBar_index_module_default()).navItem),
                                                            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                                gap: 5,
                                                                align: "center",
                                                                children: [
                                                                    "More ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownIcon/* ArrowDownIcon */.v, {
                                                                        size: "xSmall",
                                                                        withBoundingBox: false,
                                                                        style: {
                                                                            flexShrink: 0
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            variant: variant
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                            className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).navigationOverlayMenuWrapper, isMoreOpen ? (MainNavigationBar_index_module_default()).navigationOverlayMenuVisible : (MainNavigationBar_index_module_default()).navigationOverlayMenuHidden),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenu, {
                                                                mod: "white",
                                                                isMoreOverlay: true,
                                                                mainMenuItems: overflowItems
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            (showDesktopActions || buttonCTA) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).utilities, isUniversal ? (MainNavigationBar_index_module_default()).utilitiesUniversalGap : (MainNavigationBar_index_module_default()).utilitiesDefaultGap),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                        className: (MainNavigationBar_index_module_default()).appointmentSearchIcons,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                            className: (MainNavigationBar_index_module_default()).desktopIconsButtons,
                                            children: [
                                                !isTablet && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                    className: (MainNavigationBar_index_module_default()).orderRequest,
                                                    children: [
                                                        designerTradeCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            className: (MainNavigationBar_index_module_default()).designerTradeText,
                                                            component: "a",
                                                            href: designerTradeCTA.href,
                                                            target: designerTradeCTA.target,
                                                            children: designerTradeCTA.text
                                                        }),
                                                        !isMobile && buttonCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                            className: (MainNavigationBar_index_module_default()).requestAppointmentCTA,
                                                            href: buttonCTA.href,
                                                            target: buttonCTA.target,
                                                            ...(0,helpers/* omitText */.rW)(buttonCTA),
                                                            children: buttonCTA.text
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                                    component: "button",
                                                    id: "desktopSearchBtn",
                                                    type: "button",
                                                    "aria-label": searchText,
                                                    ...searchCTA,
                                                    className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).utilitiesSearch, searchCTA === null || searchCTA === void 0 ? void 0 : searchCTA.className),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            size: "paragraph-small",
                                                            component: "span",
                                                            children: searchText
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* SearchIcon */.W, {
                                                            className: (MainNavigationBar_index_module_default()).utilitiesSearchIcon,
                                                            withBoundingBox: false
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                        className: (MainNavigationBar_index_module_default()).utilitiesMobile,
                                        gap: 15,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                component: "button",
                                                type: "button",
                                                "aria-label": searchText,
                                                ...searchCTA,
                                                className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).utilitiesSearchMobile, searchCTA === null || searchCTA === void 0 ? void 0 : searchCTA.className),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* SearchIcon */.W, {
                                                    className: (MainNavigationBar_index_module_default()).utilitiesSearchIcon,
                                                    withBoundingBox: false
                                                })
                                            }),
                                            (utilityLinks === null || utilityLinks === void 0 ? void 0 : utilityLinks.cartBadgeCTA) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartBadge/* CartBadge */.H, {
                                                component: "a",
                                                "aria-label": "see shopping cart",
                                                ...utilityLinks.cartBadgeCTA,
                                                className: (0,clsx/* default */.Z)((MainNavigationBar_index_module_default()).utilityLink, utilityLinks.className)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isMobile && openMobileMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayMenu, {
                        mainMenuItems: menuItems,
                        className: (MainNavigationBar_index_module_default()).mobileOverlayMenu,
                        setIsOpenMobileMenu: setIsOpenMobileMenu,
                        utilityLinks: utilityLinks,
                        buttonCTA: buttonCTA,
                        closeCTA: closeCTA
                    })
                ]
            })
        })
    });
});

// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/UtilityLinks/subcomponents/LanguagePicker/LocationPickButton/index.module.scss
var LocationPickButton_index_module = __webpack_require__(2394);
var LocationPickButton_index_module_default = /*#__PURE__*/__webpack_require__.n(LocationPickButton_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/UtilityLinks/subcomponents/LanguagePicker/LocationPickButton/index.jsx






const LocationPickButton = (props)=>{
    const { text , className , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
        component: "button",
        type: "button",
        size: "overline",
        className: (0,clsx/* default */.Z)((LocationPickButton_index_module_default()).locationPickButtonContainer, className),
        ...rest,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationIcon/* LocationIcon */._, {
                withBoundingBox: false
            }),
            " ",
            text
        ]
    });
};

// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/UtilityLinks/index.module.scss
var UtilityLinks_index_module = __webpack_require__(54659);
var UtilityLinks_index_module_default = /*#__PURE__*/__webpack_require__.n(UtilityLinks_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/UtilityLinks/index.jsx
"use client";









const UtilityLinks_omitFavoritesCTA = (favoritesCTA)=>{
    const { isFilled =false , ...omitFavoritesCTA } = favoritesCTA;
    return {
        isFilled,
        omitFavoritesCTA
    };
};
const UtilityLinks = (param)=>{
    let { isLoggedIn =false , locationPickerCTA , languagePicker , favoritesCTA , cartBadgeCTA , userName , userCTA , utilityLinksMobile , userCTAMobile , menuType , storeMenu , loginMenu , languageMenu , setMenuType , setIsOpenMobileMenu , className , ...rest } = param;
    (0,react.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === "Escape") {
                setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
                if (setIsOpenMobileMenu) {
                    setIsOpenMobileMenu(false);
                }
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        setMenuType,
        setIsOpenMobileMenu
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)((UtilityLinks_index_module_default()).utilityLinks, className),
        ...rest,
        children: [
            (locationPickerCTA || languagePicker) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                align: "center",
                gap: 25,
                paddingLeft: 25,
                children: [
                    locationPickerCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationPickButton, {
                        "aria-expanded": menuType === "store",
                        "aria-controls": "store-menu",
                        "aria-activedescendant": menuType === "store" ? "store-menu" : undefined,
                        ...locationPickerCTA
                    }),
                    menuType && storeMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        display: menuType !== "store" ? "none" : undefined,
                        className: (UtilityLinks_index_module_default()).menuPositionWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreMenu, {
                            ...storeMenu,
                            setMenuType: setMenuType,
                            setIsOpenMobileMenu: setIsOpenMobileMenu
                        })
                    })
                ]
            }),
            (locationPickerCTA || languagePicker) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (UtilityLinks_index_module_default()).divider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                className: (UtilityLinks_index_module_default()).utilityLink,
                gap: 15,
                align: "center",
                children: [
                    userCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        component: "button",
                        type: "button",
                        display: "flex",
                        textColor: "var(--content-primary)",
                        "aria-label": isLoggedIn ? "user sign in" : "profile",
                        "aria-expanded": menuType === "user",
                        "aria-controls": "login-menu",
                        ...(0,helpers/* omitText */.rW)(userCTA),
                        children: isLoggedIn && userName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                            size: "label-medium-xs",
                            textColor: "var(--content-primary)",
                            className: (UtilityLinks_index_module_default()).userNameText,
                            children: [
                                "Hi, ",
                                userName
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon/* UserIcon */.t, {
                            withBoundingBox: false
                        })
                    }),
                    menuType && loginMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        display: menuType !== "user" ? "none" : undefined,
                        className: (UtilityLinks_index_module_default()).menuPositionWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginMenu, {
                            ...loginMenu,
                            setMenuType: setMenuType,
                            setIsOpenMobileMenu: setIsOpenMobileMenu
                        })
                    }),
                    favoritesCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        component: "a",
                        display: "flex",
                        "aria-label": "see favorites",
                        textColor: "var(--content-primary)",
                        ...UtilityLinks_omitFavoritesCTA(favoritesCTA).omitFavoritesCTA,
                        children: UtilityLinks_omitFavoritesCTA(favoritesCTA).isFilled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteNavFilledIcon/* FavoriteNavFilledIcon */.t, {
                            withBoundingBox: false
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteNavIcon/* FavoriteNavIcon */.z, {
                            withBoundingBox: false
                        })
                    }),
                    cartBadgeCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartBadge/* CartBadge */.H, {
                        display: "flex",
                        textColor: "var(--content-primary)",
                        component: "a",
                        "aria-label": "see cart",
                        withBoundingBox: false,
                        ...cartBadgeCTA
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/UtilityBar/index.module.scss
var UtilityBar_index_module = __webpack_require__(47272);
var UtilityBar_index_module_default = /*#__PURE__*/__webpack_require__.n(UtilityBar_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/UtilityBar/index.jsx






const UtilityBar = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    const { brands , mod , loginMenu , storeMenu , languageMenu , menuType , setMenuType , favoritesCTA , cartBadgeCTA , userCTA , isLoggedIn , languagePicker , locationPickerCTA , userName , utilityLinksMobile , userCTAMobile , setIsOpenMobileMenu , ...rest } = props;
    const utilityLinks = {
        favoritesCTA,
        cartBadgeCTA,
        userCTA,
        isLoggedIn,
        languagePicker,
        locationPickerCTA,
        userName,
        utilityLinksMobile,
        userCTAMobile
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        className: (UtilityBar_index_module_default()).utilityBar,
        mod: mod,
        ref: ref,
        ...rest,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridColumn/* GridColumn */.C, {
                className: (UtilityBar_index_module_default()).utilityBarContent,
                children: [
                    brands && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                        component: "ul",
                        className: (UtilityBar_index_module_default()).utilityBrands,
                        children: brands.map((brand)=>{
                            const { isActive , ...brandProps } = brand;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                component: "li",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    size: "navigation-brand-switcher",
                                    component: "a",
                                    target: "_blank",
                                    ...(0,helpers/* omitText */.rW)(brandProps),
                                    className: (0,clsx/* default */.Z)((UtilityBar_index_module_default()).utilityBrand, isActive && (UtilityBar_index_module_default()).utilityBrandActive),
                                    children: brand.text
                                })
                            }, brand.text);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityLinks, {
                        ...utilityLinks,
                        menuType: menuType,
                        className: (UtilityBar_index_module_default()).utilityLinksWrapper,
                        loginMenu: loginMenu,
                        storeMenu: storeMenu,
                        languageMenu: languageMenu,
                        setIsOpenMobileMenu: setIsOpenMobileMenu,
                        setMenuType: setMenuType
                    })
                ]
            })
        })
    });
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(5702);
// EXTERNAL MODULE: ./src/store/features/productListSlice.js
var productListSlice = __webpack_require__(42286);
// EXTERNAL MODULE: ./src/store/features/searchSlice.js
var searchSlice = __webpack_require__(54127);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./src/components/Default/DynamicSearch/v1/analytics.js

const handleSearchAnalyticsEvent = (status, message, internalLinkURL, eventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName)=>{
    if (!internalLinkURL) internalLinkURL = redirectUrl;
    const eventInfo = getEventInfoObj(status, message, internalLinkURL, eventType, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
    sessionStorage.setItem("searches", eventInfo.searchCount);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const getEventInfoObj = (status, message, internalLinkURL, eventType, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName)=>{
    const currDate = new Date();
    const contentType = window.adobeDataLayer && window.adobeDataLayer.getState ? window.adobeDataLayer.getState("page.pageInfo.contentType") || window.adobeDataLayer.getState("page.category.primaryCategory") : "";
    const pageName = contentType ? contentType.split("-")[0] : "";
    const autoSearch = !internalLinkURL ? true : false;
    const searchSuggestedTerm = [];
    if (!analyticsEventData.searchString) {
        analyticsEventData.searchString = searchString;
    }
    if (!analyticsEventData.searchTotal) {
        analyticsEventData.searchTotal = searchTotal;
    }
    if (!analyticsEventData.topSuggestedData) {
        analyticsEventData.topSuggestedData = topSuggestedData;
    }
    const searchSuggestions = searchHistory && searchHistory.length ? searchHistory : analyticsEventData.topSuggestedData && analyticsEventData.topSuggestedData.length ? analyticsEventData.topSuggestedData : [];
    if (searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.length) {
        searchSuggestions.slice(0, 5).map((item)=>{
            searchSuggestedTerm.push((0,helper/* sanitizeTextForAnalytics */.T68)(item.productName_s || item.keyWord));
        });
    }
    const eventInfo = {
        eventName: "internal ".concat(autoSearch ? "automatic " : "", "search"),
        eventAction: "internal ".concat(autoSearch ? "automatic " : "", "search"),
        internalLinkName: "internal search icon",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "global header",
        internalLinkURL: internalLinkURL ? (internalLinkURL.indexOf("http") === -1 ? window.location.origin : "") + internalLinkURL : "n/a",
        internalLinkPosition: "global header",
        eventMsg: status !== "success" ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a",
        eventStatus: status || "n/a",
        searchTerm: analyticsEventData.searchString,
        searchContentType: pageName ? pageName + " page" : "n/a",
        searchSuggestedTerm: searchSuggestedTerm.join("|") || "n/a",
        searchCount: sessionStorage.getItem("searches") ? Number(sessionStorage.getItem("searches")) + 1 : 1,
        searchResult: analyticsEventData.searchTotal,
        internalZoneName: "search:search box",
        pageURL: window.location.href,
        referrer: document.referrer || "n/a",
        previousPage: document.referrer || "n/a",
        timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0],
        contentType: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()
    };
    if (eventType === null || eventType === void 0 ? void 0 : eventType.type) {
        eventType.term = (0,helper/* sanitizeTextForAnalytics */.T68)(eventType.term);
        eventType.type = (0,helper/* sanitizeTextForAnalytics */.T68)(eventType.type);
        eventInfo.eventName = "search:" + eventType.type + ":search term";
        eventInfo.eventAction = "search:" + eventType.type + ":search term";
        eventInfo.internalLinkZoneName = "search:" + eventType.type;
        if (eventType.type === "our top suggestions") {
            var ref;
            eventInfo.searchTerm = (ref = analyticsEventData.searchString) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            eventInfo.searchSuggestedTerm = eventType.term;
        } else {
            eventInfo.searchTerm = eventType.term;
        }
        eventInfo.internalLinkName = eventType.term;
        eventInfo.internalZoneName = "search:" + eventType.type;
    }
    analyticsEventData = {};
    return eventInfo;
};


// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/DesignSystem/Mainmenu/subcomponents/PromoBanner/index.module.scss
var PromoBanner_index_module = __webpack_require__(4333);
var PromoBanner_index_module_default = /*#__PURE__*/__webpack_require__.n(PromoBanner_index_module);
;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/subcomponents/PromoBanner/promoBanner.jsx






function PromoBanner(param) {
    let { promoBanner  } = param;
    var ref;
    const [general, setGeneral] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general  } = await (0,constants_config/* getConfig */.i)();
            setGeneral(general);
        };
        configFn();
    }, []);
    const getColorClass = (appliedCssClassNames)=>{
        if (appliedCssClassNames.includes("bg-warm-gray-medium")) {
            return (PromoBanner_index_module_default()) === null || (PromoBanner_index_module_default()) === void 0 ? void 0 : (PromoBanner_index_module_default()).bannerGrey;
        }
        if (appliedCssClassNames.includes("bg-medium-plumb")) {
            return (PromoBanner_index_module_default()) === null || (PromoBanner_index_module_default()) === void 0 ? void 0 : (PromoBanner_index_module_default()).bannerPlumb;
        }
        if (appliedCssClassNames.includes("bg-dark-blue-two")) {
            return (PromoBanner_index_module_default()) === null || (PromoBanner_index_module_default()) === void 0 ? void 0 : (PromoBanner_index_module_default()).bannerBlue;
        }
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PromoBanner_index_module_default()).promoBanner,
        children: promoBanner === null || promoBanner === void 0 ? void 0 : (ref = promoBanner.content) === null || ref === void 0 ? void 0 : ref.map((banner, index1)=>{
            let colorClass = getColorClass(banner.appliedCssClassNames);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((PromoBanner_index_module_default()).promoBannerMain, " ").concat(colorClass),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PromoBanner_index_module_default()).promoBannerContent,
                        children: banner.content
                    }),
                    banner.CTAs && banner.CTAs.map((item, index2)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (0,helper/* getShortenedUrlwithGeneral */.vu1)(item.href, general),
                            className: (PromoBanner_index_module_default()).promoBannerLink,
                            children: item.text
                        }, index2))
                ]
            }, index1);
        })
    });
}
/* harmony default export */ var PromoBanner_promoBanner = (PromoBanner);

;// CONCATENATED MODULE: ./components/DesignSystem/Mainmenu/index.jsx
"use client";






// import { MainNavigationBar, MessageBanner, UtilityBar } from './subcomponents';
















const SearchPanel = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(5531), __webpack_require__.e(7866), __webpack_require__.e(4267), __webpack_require__.e(6159)]).then(__webpack_require__.bind(__webpack_require__, 85574)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(85574)
            ]
    }
});
const MainMenu = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    var ref1, ref2;
    const { className , infoBanner , globalBanner , mainNavigation , utilityBar , promoBanner , storeMenu , loginMenu , languageMenu , mod , style , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)((index_module_default()).mainMenu, className, "kohler-main-menu-root");
    const [menuType, setMenuType] = (0,react.useState)(null);
    const [mainMenuHeight, setMainMenuHeight] = (0,react.useState)(0);
    const [openMobileMenu, setOpenMobileMenu] = (0,react.useState)(false);
    const mainMenuWrapperRef = (0,react.useRef)(null);
    const mainNavigationRef = (0,react.useRef)(null);
    const composeMainMenuWrapperRef = (0,use_merged_ref/* useMergedRef */.Yx)(mainMenuWrapperRef, ref);
    const { showStickyNav , isSticky  } = useStickyNavigation(mainMenuHeight, mainNavigation === null || mainNavigation === void 0 ? void 0 : mainNavigation.isAlwaysSticky);
    const [firstStickyApplied, setFirstStickyApplied] = (0,react.useState)(false);
    // --- SearchPanel state and logic (copied from UtilityWidgets.jsx) ---
    const dispatch = (0,es/* useDispatch */.I0)();
    const persona = (0,helper/* getUserPersona */.shu)();
    const currencySign = (0,react.useRef)("");
    const currencyCode = (0,react.useRef)("");
    const searchPagePath = (0,react.useRef)("");
    const knowledgeArticleUrl = (0,react.useRef)("");
    const [showSearch, setShowSearch] = (0,react.useState)(false);
    const [selectedData, setSelectedData] = (0,react.useState)({});
    const [searchString, setSearchString] = (0,react.useState)("");
    var ref3;
    const [searchHistory, setSearchHistory] = (0,react.useState)( true ? (ref3 = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref3 !== void 0 ? ref3 : [] : 0);
    const [brandName, setBrandName] = (0,react.useState)("kohler");
    const [searchTotal, setSearchTotal] = (0,react.useState)(0);
    const [topSuggestedData, setTopSuggestedData] = (0,react.useState)("");
    const [isCTAClicked, setIsCTAClicked] = (0,react.useState)(false);
    const [redirectUrl, setRedirectUrl] = (0,react.useState)("");
    const [category, setCategory] = (0,react.useState)("");
    const [tilesData, setTilesData] = (0,react.useState)([]);
    const [productsLoaded, setProductsLoaded] = (0,react.useState)(false);
    const [xfLink, setXfLink] = (0,react.useState)("");
    const [promoLayout, setPromoLayout] = (0,react.useState)("one-column");
    const [isGlobalConfigBlank, setIsGlobalConfigBlank] = (0,react.useState)(true);
    const [fusionFullCatalogResponse, setFusioFullCatalognResponse] = (0,react.useState)([]);
    const [isSterling, setIsSterling] = (0,react.useState)(false);
    const [redirectTileToKohelerPLP, setRedirectTileToKohelerPLP] = (0,react.useState)("");
    const selectedFavoritesState = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { favorites  } = selectedFavoritesState || {};
    const { lineItems =[]  } = favorites || {};
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const [presetConfigs, setPresetConfigs] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (showSearch) {
            var ref;
            setSearchHistory( true ? (ref = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [] : 0);
        }
    }, [
        showSearch
    ]);
    (0,react.useEffect)(()=>{
        if (isGlobalConfigBlank) {
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                let blankConfig = false;
                if (!(config && Object.keys(config).length > 1)) {
                    blankConfig = true;
                    setIsGlobalConfigBlank(true);
                }
                let presetConfigs = await get_default()(config, "presetConfigs.search", "");
                setPresetConfigs(JSON.stringify(presetConfigs));
                if (!blankConfig) {
                    setIsGlobalConfigBlank(false);
                    const vbrandName = await get_default()(config, "general.siteName", "");
                    if (vbrandName) {
                        setBrandName(vbrandName);
                    }
                    currencySign.current = get_default()(config, "internationalization.currencySign", "");
                    currencyCode.current = await get_default()(config, "internationalization.currencyCode", "");
                    knowledgeArticleUrl.current = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.knowledgeArticlePath", ""));
                    searchPagePath.current = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.searchPagePath", ""));
                    setRedirectTileToKohelerPLP(await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.searchPagePath", "")));
                }
            }).catch((error)=>{
                console.log(error);
            });
        }
    }, [
        isGlobalConfigBlank
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if ((ref = props.data) === null || ref === void 0 ? void 0 : ref.presetConfigs) {
            dispatch((0,searchSlice/* setSearchPresetConfig */.xp)(props.data.presetConfigs));
        }
    }, [
        (ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.presetConfigs,
        dispatch
    ]);
    const trackSearchSubmission = (searchTerm, status, message, internalLinkURL, analyticsEventType)=>{
        handleSearchAnalyticsEvent(status, message, internalLinkURL, analyticsEventType, internalLinkURL, {}, searchTerm, searchTotal, topSuggestedData, searchHistory, brandName);
    };
    const handleRedirect = (searchTerm, isAnalyticsClick, analyticsEventType, isserachButton, topSuggestedData)=>{
        setProductsLoaded(false);
        setIsCTAClicked(true);
        if (redirectUrl) {
            if (isAnalyticsClick) {
                trackSearchSubmission(searchTerm, "success", null, redirectUrl, analyticsEventType);
            }
            window.location.href = redirectUrl;
            setRedirectUrl("");
        } else {
            var ref;
            let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
            history = history.filter((item)=>item.keyWord.toLowerCase() !== searchTerm.toLowerCase());
            history.unshift({
                keyWord: searchTerm,
                id: Date.now()
            });
            window.localStorage.setItem("keyWordList", JSON.stringify(history));
            Promise.all([
                dispatch((0,productListSlice/* profileBrandSearch */.R$)([
                    searchTerm.trim(),
                    brandName.toLowerCase(),
                    "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                    1,
                    ""
                ]))
            ]).then(async (res)=>{
                if (res[0].payload) {
                    let redirectUrl = "";
                    // redirect if redirect URL is configured in LW for search keyword
                    if (res[0].payload.fusion && res[0].payload.fusion.redirect && res[0].payload.fusion.redirect[0]) {
                        redirectUrl = res[0].payload.fusion.redirect[0];
                        if (isAnalyticsClick) {
                            trackSearchSubmission(searchTerm, "success", null, redirectUrl, analyticsEventType);
                        }
                        window.location.href = redirectUrl;
                    } else if (res[0].payload.response.numFound === 1 && res[0].payload.fusion.exactMatch) {
                        const d = res[0].payload.response.docs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "skuId=".concat(d.sku_s) : "";
                            const pdpUrl = await (0,helper/* getPDPUrl */.ir5)(d.Product_Category, d.slug_s);
                            redirectUrl = (0,utils/* getPdpRedirectUrl */.Om)(pdpUrl, param);
                        } else if (d.url_s) {
                            redirectUrl = d.url_s;
                        }
                        if (isAnalyticsClick) {
                            trackSearchSubmission(searchTerm, "success", null, redirectUrl, analyticsEventType);
                        }
                        window.location.href = redirectUrl;
                    } else {
                        redirectUrl = (0,helper/* sanitizeUrl */.Nmg)(window.location.origin + (0,helper/* removeAndCleanLink */.xEh)(searchPagePath.current) + "?keyword=".concat(encodeURIComponent(searchTerm.trim())));
                        if (isAnalyticsClick) {
                            trackSearchSubmission(searchTerm, "success", null, redirectUrl, analyticsEventType);
                        }
                        window.location.href = redirectUrl;
                    }
                }
            }).catch((err)=>{
                console.log("Error occured while fetching Search data", err);
                if (isAnalyticsClick) {
                    trackSearchSubmission(searchTerm, "failure", "error occured while fetching search data", redirectUrl, analyticsEventType);
                }
                setProductsLoaded(true);
            });
        }
    };
    const handleDelete = (id)=>{
        var ref;
        let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
        history = history.filter((item)=>item.id !== id);
        window.localStorage.setItem("keyWordList", JSON.stringify(history));
        setSearchHistory(history);
    };
    const handleClearAll = ()=>{
        localStorage.removeItem("keyWordList");
        setSearchHistory([]);
    };
    const handleChange = (searchTerm)=>{
        setProductsLoaded(false);
        setSearchString(searchTerm.trim());
    };
    (0,react.useEffect)(()=>{
        if (brandName) {
            if (searchString.length >= 3) {
                getSearchResult(searchString);
            } else {
                setSearchTotal(0);
            }
            setProductsLoaded(false);
        }
    }, [
        searchString,
        brandName
    ]);
    const getSearchResult = (0,react.useCallback)(lodash_debounce_default()((searchString)=>getData(searchString), 2000), [
        brandName
    ]);
    const getData = (searchStr)=>{
        if (redirectUrl) setRedirectUrl("");
        if (!isCTAClicked && searchStr.length >= 3) {
            Promise.all([
                dispatch((0,productListSlice/* profileBrandSearch */.R$)([
                    searchStr.trim(),
                    brandName.toLowerCase(),
                    "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                    1,
                    ""
                ])),
                dispatch((0,productListSlice/* profileBrandTypeahead */.zw)([
                    searchStr.trim(),
                    brandName.toLowerCase()
                ]))
            ]).then(async (res)=>{
                if (res[0].payload && res[1].payload) {
                    let redirectUrl = "";
                    if (res[0].payload.fusion && res[0].payload.fusion.redirect && res[0].payload.fusion.redirect[0]) {
                        window.location.href = res[0].payload.fusion.redirect[0];
                    } else if (res[0].payload.response.numFound === 1 && res[0].payload.fusion.exactMatch) {
                        const d = res[0].payload.response.docs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "skuId=".concat(d.sku_s) : "";
                            const pdpUrl = await (0,helper/* getPDPUrl */.ir5)(d.Product_Category, d.slug_s);
                            redirectUrl = (0,utils/* getPdpRedirectUrl */.Om)(pdpUrl, param);
                        } else if (d.url_s) {
                            redirectUrl = d.url_s;
                        }
                    }
                    if (!res[0].payload.fusion.redirect) {
                        let groups = [
                            {
                                key: "products",
                                fq: 'Products:("ct")',
                                count: get_default()(res[0].payload, "facet_counts.facet_fields.Products[1]", 0)
                            },
                            {
                                key: "technical",
                                fq: 'Technical:("ct")',
                                count: get_default()(res[0].payload, "facet_counts.facet_fields.Technical[1]", 0)
                            },
                            {
                                key: "inspiration",
                                fq: 'Inspiration:("Inspiration")',
                                count: get_default()(res[0].payload, "facet_counts.facet_fields.Inspiration[1]", 0)
                            },
                            {
                                key: "resource",
                                fq: 'Resource:("Resource")',
                                count: get_default()(res[0].payload, "facet_counts.facet_fields.Resource[1]", 0)
                            },
                            {
                                key: "help",
                                fq: 'Help:("sf")',
                                count: get_default()(res[0].payload, "facet_counts.facet_fields.Help[1]", 0)
                            }
                        ];
                        let total = 0;
                        const selected = groups.find((group)=>group.count > 0);
                        if (res[0].payload.fusion.exactMatch) {
                            total = res[0].payload.response.numFound;
                        } else {
                            groups.forEach((group)=>total += group.count);
                        }
                        setSearchTotal(total);
                        setRedirectUrl(redirectUrl);
                        const fullCatalogResponse = get_default()(res[0].payload, "fusion.full_catalog_Response", []);
                        if (fullCatalogResponse.length > 0) {
                            setIsSterling(true);
                            setSearchTotal(1);
                        }
                        setFusioFullCatalognResponse(fullCatalogResponse);
                        const responseDocs = get_default()(res[1].payload, "response.docs", []);
                        setTopSuggestedData(fullCatalogResponse.length > 0 ? fullCatalogResponse : responseDocs);
                        setSelectedData(selected);
                    }
                }
            }).catch((err)=>{
                setProductsLoaded(true);
                console.error("Error occured while fetching Search data", err);
            });
        } else {
            setSearchTotal(0);
            setCategory("");
            setTilesData([]);
            setRedirectUrl("");
            setTopSuggestedData([]);
        }
    };
    (0,react.useEffect)(()=>{
        if (searchTotal > 0 && selectedData.key) {
            getTilesData(selectedData);
        }
    }, [
        searchTotal,
        selectedData
    ]);
    const getTilesData = (selected)=>{
        const fl = [
            "id",
            "sku_s",
            "slug_s",
            "metaTitle_s",
            "productName_s",
            "masterSKU_s",
            "Product_Category",
            "ProductBrandName_s",
            "productImages.url_ss",
            "displayPriceStartingAt_s",
            "SKUColorSwatchFilename_ss",
            "ProductDescriptionProductShort_s",
            "url_s",
            "title_s",
            "pageTitle_s",
            "eyeBrowText_s",
            "templateType_s",
            "thumbNailImage_s",
            "searchDescription_s",
            "priceList.".concat(persona, ".price_d"),
            "priceList.".concat(persona, ".finalPrice_d"),
            "priceList.".concat(persona, ".discountedPrice_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "Color.SKU.Details_ss",
            "Color.".concat(persona, ".Details_ss"),
            "ProductIsExclusive_s",
            "RegionReleaseforShipment_dt",
            "RegionLaunchDate_dt",
            "productImages.labelWithUrl_ss",
            "variantList.sku_ss",
            "RegionOnBackOrder_s",
            "RegionBrandName_s",
            "ctId_s",
            "pdp_url_s",
            "Sale.".concat(persona, ".Details_ss"),
            "RegionAltUOM_s",
            "ItemCharacteristic.TYPE.CharacteristicDescription_s",
            "ItemCharacteristic.TYPE.CharacteristicTypeDescriptionKey_s",
            "ItemCharacteristic.TYPE.CharacteristicDescriptionUpperCase_s"
        ];
        setXfLink("");
        setPromoLayout("one-column");
        setCategory("");
        setTilesData([]);
        dispatch(selected.key === "parts" ? (0,productListSlice/* profileServicePartsSearch */.n7)([
            searchString.trim(),
            fl.join(","),
            6
        ]) : (0,productListSlice/* profileBrandSearch */.R$)([
            searchString.trim(),
            brandName.toLowerCase(),
            fl.join(","),
            6,
            selected.fq
        ])).then((res)=>{
            var ref;
            if (res.payload && ((ref = res.payload.response) === null || ref === void 0 ? void 0 : ref.docs)) {
                var ref1;
                setCategory(selected.key);
                setTilesData((ref1 = res.payload.response) === null || ref1 === void 0 ? void 0 : ref1.docs);
                if ((fusionFullCatalogResponse === null || fusionFullCatalogResponse === void 0 ? void 0 : fusionFullCatalogResponse.length) > 0) {
                    setTilesData(fusionFullCatalogResponse);
                }
                if (res.payload.fusion && res.payload.fusion.experiment_fragments && res.payload.fusion.experiment_fragments !== undefined) {
                    var ref2, ref3, ref4, ref5;
                    var ref6;
                    setPromoLayout((ref6 = (ref3 = (ref2 = res.payload.fusion) === null || ref2 === void 0 ? void 0 : ref2.experiment_fragments[0]) === null || ref3 === void 0 ? void 0 : ref3.promoLayout_s) !== null && ref6 !== void 0 ? ref6 : "one-column");
                    var ref7;
                    setXfLink((ref7 = (ref5 = (ref4 = res.payload.fusion) === null || ref4 === void 0 ? void 0 : ref4.experiment_fragments[0]) === null || ref5 === void 0 ? void 0 : ref5.url_s) !== null && ref7 !== void 0 ? ref7 : "");
                }
            }
            setProductsLoaded(true);
        });
    };
    const bodyRef = (0,react.useRef)( true ? document.body : 0);
    const htmlRef = (0,react.useRef)( true ? document.getElementsByTagName("html")[0] : 0);
    const handleToggle = ()=>{
        setSearchString("");
        setSearchTotal(0);
        const classNames = [
            "searchbar-open",
            "scroll-lock"
        ];
        classNames.map((className)=>{
            var ref, ref1;
            return bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        classNames.map((className)=>{
            var ref, ref1;
            return htmlRef === null || htmlRef === void 0 ? void 0 : (ref = htmlRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        setShowSearch(!showSearch);
    };
    // --- End SearchPanel logic ---
    (0,react.useEffect)(()=>{
        if (isSticky && !firstStickyApplied) {
            setFirstStickyApplied(true);
        } else if (!isSticky && firstStickyApplied) {
            setFirstStickyApplied(false);
        }
    }, [
        isSticky,
        firstStickyApplied
    ]);
    const disableTransition = isSticky && !firstStickyApplied;
    const typedUtilityBar = {
        ...utilityBar,
        storeMenu,
        loginMenu,
        languageMenu,
        menuType,
        setMenuType,
        setIsOpenMobileMenu: setOpenMobileMenu
    };
    if (typedUtilityBar) {
        if (typedUtilityBar.languagePicker && languageMenu) {
            var ref4, ref5;
            const originalOnClick = utilityBar === null || utilityBar === void 0 ? void 0 : (ref4 = utilityBar.languagePicker) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.languagePickerCTA) === null || ref5 === void 0 ? void 0 : ref5.onClick;
            typedUtilityBar.languagePicker.languagePickerCTA.onClick = (e)=>{
                if (originalOnClick) originalOnClick(e);
                setMenuType(menuType === "language" ? null : "language");
            };
        }
        if (typedUtilityBar.locationPickerCTA && storeMenu) {
            var ref6;
            const originalOnClick1 = utilityBar === null || utilityBar === void 0 ? void 0 : (ref6 = utilityBar.locationPickerCTA) === null || ref6 === void 0 ? void 0 : ref6.onClick;
            typedUtilityBar.locationPickerCTA.onClick = (e)=>{
                if (originalOnClick1) originalOnClick1(e);
                setMenuType(menuType === "store" ? null : "store");
            };
        }
        if (typedUtilityBar && loginMenu) {
            var ref7;
            const originalOnClick2 = utilityBar === null || utilityBar === void 0 ? void 0 : (ref7 = utilityBar.userCTA) === null || ref7 === void 0 ? void 0 : ref7.onClick;
            typedUtilityBar.userCTA = (utilityBar === null || utilityBar === void 0 ? void 0 : utilityBar.userCTA) || {};
            typedUtilityBar.userCTA.onClick = (e)=>{
                if (originalOnClick2) originalOnClick2(e);
                setMenuType(menuType === "user" ? null : "user");
            };
        }
    }
    (0,react.useEffect)(()=>{
        if (mainMenuWrapperRef.current) {
            setMainMenuHeight(mainMenuWrapperRef.current.clientHeight);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (mainNavigationRef.current) {
            const height = mainNavigationRef.current.clientHeight;
            document.body.style.setProperty("--main-menu-height", "".concat(showStickyNav ? height : 0, "px"));
        }
    }, [
        showStickyNav
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        component: "header",
        ref: composeMainMenuWrapperRef,
        ...rest,
        className: classNames,
        mod: mod,
        style: {
            "--main-menu-height": "".concat(mainMenuHeight, "px"),
            ...style
        },
        children: [
            typedUtilityBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityBar, {
                ...typedUtilityBar,
                menuType: menuType,
                setMenuType: setMenuType,
                storeMenu: storeMenu,
                languageMenu: languageMenu,
                loginMenu: loginMenu,
                setIsOpenMobileMenu: setOpenMobileMenu
            }),
            promoBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoBanner_promoBanner, {
                promoBanner: promoBanner
            }),
            mainNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: (0,clsx/* default */.Z)((index_module_default()).mainNavigationBarWrapper, {
                    [(index_module_default()).fixedNav]: isSticky,
                    [(index_module_default()).showSticky]: showStickyNav,
                    [(index_module_default()).showBackgroundRelative]: mainNavigation.showBackground || mainNavigation.isStatic
                }),
                style: disableTransition ? {
                    transitionDuration: "0s"
                } : undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainNavigationBar, {
                    ...mainNavigation,
                    searchCTA: {
                        ...mainNavigation.searchCTA,
                        onClick: handleToggle
                    },
                    searchText: "Search",
                    utilityLinks: typedUtilityBar,
                    setIsOpenMobileMenu: setOpenMobileMenu,
                    openMobileMenu: openMobileMenu,
                    ref: mainNavigationRef,
                    showBackground: isSticky || mainNavigation.showBackground
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "utilitywidgets",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "utility-widgets",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "search-widget",
                        children: showSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPanel, {
                            showSearchBar: showSearch,
                            onToggle: handleToggle,
                            onRedirect: handleRedirect,
                            onChange: handleChange,
                            searchString: searchString,
                            brand: brandName,
                            searchTotal: searchTotal,
                            topSuggestedData: topSuggestedData,
                            searchHistory: searchHistory,
                            xfLink: xfLink,
                            category: category,
                            removeFromCompare: product/* removeFromCompareProduct */.Zj,
                            addToCompare: product/* addToCompareProduct */.dX,
                            tilesData: tilesData,
                            productsLoaded: productsLoaded,
                            promoLayout: promoLayout,
                            favorites: (ref2 = (0,helper/* getFavouraties */.MqV)()) === null || ref2 === void 0 ? void 0 : ref2.lineItems,
                            comparedProducts: (0,helper/* getCompareData */.p2C)(),
                            currencySign: currencySign.current,
                            knowledgeArticleUrl: knowledgeArticleUrl.current,
                            presetConfigs: "".concat(presetConfigs),
                            onDelete: handleDelete,
                            onClearAll: handleClearAll,
                            isSterling: isSterling,
                            sterlingData: fusionFullCatalogResponse,
                            parent: "Utility Widgets",
                            searchPagePath: redirectTileToKohelerPLP
                        })
                    })
                })
            })
        ]
    });
});
/* harmony default export */ var Mainmenu = (MainMenu);

// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.jsx
var UtilityWidgets = __webpack_require__(55938);
// EXTERNAL MODULE: ./src/i18n/useAuthUtilityNavi18n.js
var useAuthUtilityNavi18n = __webpack_require__(1056);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/cart.js
var cart = __webpack_require__(87292);
// EXTERNAL MODULE: ./src/utils/location.js
var utils_location = __webpack_require__(78800);
// EXTERNAL MODULE: ./src/components/FindStoreUtilNav/analytics.js
var analytics = __webpack_require__(38224);
// EXTERNAL MODULE: ./src/components/FindStoreUtilNav/v1/localization.js
var localization = __webpack_require__(50288);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(67421);
// EXTERNAL MODULE: ./src/store/features/locationSlice.js
var locationSlice = __webpack_require__(13644);
// EXTERNAL MODULE: ./src/components/FindStore/v1/api.js
var v1_api = __webpack_require__(75058);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/i18n/useFindStorei18n.js
var useFindStorei18n = __webpack_require__(95511);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/index.js
var HeaderNavTabs_analytics = __webpack_require__(24897);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./i18n/useFindashowroomi18n.js
var useFindashowroomi18n = __webpack_require__(75185);
;// CONCATENATED MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx





































const configInitialState = {
    browseAllStoreUrl: "",
    brand: "",
    findStores: ""
};
const GlobalPageHeader = (props)=>{
    var ref;
    const { header ={} , templateName ="" , themeType ="" , title ="" , description ="" , globalScripting ="" , isPdp =false , imageUrl ="" , email ="" , phone ="" , fullUrl ="" , siteName ="" , breadCrumb =[]  } = props;
    const { pageIsInteractive , featureFlags ={} , globalConfig: { internationalization: { language ="en"  } = {} , general: { cartLandingPagePath ="" , signInFragment ="" , signUpFragment ="" , navigationHoverTiming ="" , siteName: BrandName = ""  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { utilityStoreDetails , utilityData , myStoreId  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const initialState = {
        userCity: "",
        utilityLocation: "",
        utilityData: {},
        utilityStoreDetails: {},
        findStores: "",
        reverseGeo: "",
        myStoreId: typeof Window !== "undefined" ? localStorage.getItem("myStoreId") : 0,
        siteName: "",
        findStoreUrl: "",
        utilityStoreDetailsUrl: ""
    };
    const { data: authorData = {}  } = props;
    const staticTexts = (0,useFindashowroomi18n/* default */.Z)({
        authorData
    });
    const bodyRef = (0,react.useRef)(null);
    const htmlRef = (0,react.useRef)(null);
    const [metas, setMetas] = (0,react.useState)([]);
    const [styles, setStyles] = (0,react.useState)([]);
    const [scripts, setScripts] = (0,react.useState)([]);
    const [links, setLinks] = (0,react.useState)([]);
    const [logIndata, setLogIndata] = (0,react.useState)([]);
    const [logOutdata, setLogOutdata] = (0,react.useState)([]);
    const [favoritesPagePath, setFavoritesPagePath] = (0,react.useState)("/");
    const [favoritesPage, setFavoritesPage] = (0,react.useState)([]);
    const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false  } = featureFlags;
    const { favorites ={} , saveToListLineItems ={}  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { lineItems =[] , textLineItems  } = favorites || {};
    const i18n = (0,useAuthUtilityNavi18n/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const cartCount = (0,cart/* getCartCount */.c0)();
    const { user: { firstName =null  } = {} , isAuth =false  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const onclicksignIN = function() {
        let datalayershow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
        if (datalayershow) {
            (0,HeaderNavTabs_analytics/* newdatalayerforSignIn */.UY)();
        }
    };
    const onClickCreateAccount = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: 1
        }));
        (0,HeaderNavTabs_analytics/* newdataLayerForCreateAccount */.Lz)();
    };
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [myListsPagePath, setMyListsPagePath] = (0,react.useState)("/");
    const [configState, setConfigState] = (0,react.useState)(configInitialState);
    // for search panel
    const [showSearchBar, setShowSearchBar] = (0,react.useState)(false);
    const { t  } = (0,dist_es/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const [state, setState] = (0,react.useState)(initialState);
    const [zipCodeValue, setZipcodeValue] = (0,react.useState)("");
    const [infoModalErrror, setInfoModalErrror] = (0,react.useState)({});
    const [infoModal, setInfoModal] = (0,react.useState)();
    const [browseAllStoreUrl, setbrowseAllStoreUrl] = (0,react.useState)("");
    const [myStoreUrl, setMyStoreUrl] = (0,react.useState)("/");
    const [optionList, setOptionList] = (0,react.useState)([]);
    const [canadaCheck, setCanadaCheck] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (state.utilityStoreDetailsUrl !== "") setUtilityStoreDetailsUrl();
    }, [
        state.utilityStoreDetailsUrl
    ]);
    (0,react.useEffect)(()=>{
        setInitalState();
        const toasterData = findItemByName(header, "toaster") || {};
        if (!isEmpty_default()(toasterData)) dispatch((0,genericSlice/* setToastContent */.Ji)({
            ...toasterData
        }));
    }, []);
    const handleGlobalClick = (e)=>{
        const target = e.target.closest('[data-datalayer-id="kds-element-navigation"]');
        if (target) {
            var ref, ref1;
            const rawEventInfo = JSON.parse((target === null || target === void 0 ? void 0 : (ref = target.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref["data-datalayer-data"]) === null || ref1 === void 0 ? void 0 : ref1.nodeValue) || "{}");
            const page = window.pageObj || {};
            const commonEventInfo = {
                eventAction: rawEventInfo.eventAction || "main dropdown menu",
                eventType: rawEventInfo.eventType || "global header",
                eventName: rawEventInfo.eventName || "main dropdown menu",
                internalLinkPosition: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkPosition) || "global header",
                internalLinkZoneName: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkZoneName) || "global header",
                internalLinkType: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkType) || "global header:navigation"
            };
            const getProductInfo = ()=>{
                if ((rawEventInfo.internalLinkPosition || "").includes("teaser")) {
                    const productInfo = {
                        productCategory: "n/a",
                        productCollectionsName: "n/a",
                        productRoom: "n/a"
                    };
                    return productInfo;
                }
            };
            const isproductInfo = getProductInfo();
            let eventInfo = {};
            eventInfo = {
                ...rawEventInfo,
                ...commonEventInfo
            };
            if (isproductInfo) {
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    page,
                    eventInfo,
                    productInfo: isproductInfo
                });
            } else {
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    page,
                    eventInfo
                });
            }
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("click", handleGlobalClick);
        return ()=>document.removeEventListener("click", handleGlobalClick);
    }, []);
    const setInitalState = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        getFindStoreUrl(config).then((url)=>{
            setState({
                ...state,
                findStores: get_default()(config, "apiEndPointData.findStores", ""),
                reverseGeo: get_default()(config, "apiEndPointData.reverseGeo", ""),
                siteName: get_default()(config, "general.siteName", ""),
                cartLandingPagePath: get_default()(config, "general.cartLandingPagePath", ""),
                signInFragment: get_default()(config, "general.signInFragment", ""),
                signUpFragment: get_default()(config, "general.signUpFragment", ""),
                siteName: get_default()(config, "general.siteName", ""),
                utilityStoreDetailsUrl: get_default()(config, "general.storeDetailsServletPath"),
                findStoreUrl: url
            });
        });
    };
    const getFindStoreUrl = async (config)=>{
        const findStoreUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.findStorePagePath", ""));
        return findStoreUrl;
    };
    const setUtilityStoreDetailsUrl = async ()=>{
        const utilityStoreDetails = await (0,utils_location/* getUtilityStoreDetails */.BO)(state);
        dispatch((0,locationSlice/* setUtilityStoreDetails */.Hm)(utilityStoreDetails));
        setState({
            ...state,
            utilityStoreDetails
        });
    };
    const redirect = (zipCodeValue)=>{
        const asPath = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue);
        window.location.href = asPath;
    };
    const handleZipCodeUpdate = (value)=>{
        setZipcodeValue(value);
    };
    const getGeoLocation = ()=>{
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            setZipcodeValue(getLocation.zipcode ? Number(getLocation.zipcode) : undefined);
            (0,analytics/* headerFindStoreUseLocationAnalytics */.P)({
                eventStatus: "success"
            });
        }).catch((param)=>{
            let { cause  } = param;
            setInfoModalErrror({
                title: (cause === null || cause === void 0 ? void 0 : cause.title) || constants.GEOLOCATION_ERROR_TITLE,
                // message: GEOLOCATION_ERROR_TITLE,
                ctaLink: cause === null || cause === void 0 ? void 0 : cause.ctaLink,
                ctaLabel: cause === null || cause === void 0 ? void 0 : cause.ctaLabel
            });
            setInfoModal(true);
            var ref;
            (0,analytics/* headerFindStoreUseLocationAnalytics */.P)({
                errorMessage: (ref = cause === null || cause === void 0 ? void 0 : cause.message) !== null && ref !== void 0 ? ref : "",
                staticTexts,
                eventStatus: "failure"
            });
        });
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            if (config === null || config === void 0 ? void 0 : config.general) {
                const { general  } = config || {};
                var _allStoresPagePath;
                const url = await (0,utils_location/* getShortenedUrl */.Pp)((_allStoresPagePath = general.allStoresPagePath) !== null && _allStoresPagePath !== void 0 ? _allStoresPagePath : "/");
                const findStores = get_default()(config, "apiEndPointData.findStores", "");
                const brand = get_default()(config, "general.siteName", "");
                setConfigState({
                    browseAllStoreUrl: url,
                    findStores,
                    brand
                });
                localStorage.getItem("currentZipCode") && setZipcodeValue(localStorage.getItem("currentZipCode"));
                setbrowseAllStoreUrl(url);
            }
        }).catch((err)=>console.log(err));
    }, []);
    (0,react.useEffect)(()=>{
        if (myStoreId === 0) {
            nearestStoreAddress();
        } else {
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        }
    }, [
        zipCodeValue,
        myStoreId
    ]);
    (0,react.useEffect)(()=>{
        if (zipCodeValue.length > 2) {
            fetchListOfCities();
        }
    }, [
        zipCodeValue
    ]);
    const fetchListOfCities = async ()=>{
        const { findStores , brand  } = configState;
        const responseData = await (0,helper/* getCityList */.vzx)(findStores, brand, zipCodeValue);
        const { data: { d: { results =[]  } = {}  } = {}  } = responseData;
        const cities = results.map((city)=>city.Locality);
        setOptionList([
            ...new Set(cities)
        ]);
    };
    const nearestStoreAddress = async ()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const findStores = get_default()(config, "apiEndPointData.findStores", "");
            const brand = get_default()(config, "general.siteName", "");
            if (!findStores || (zipCodeValue === null || zipCodeValue === void 0 ? void 0 : zipCodeValue.length) < 3) return;
            const nearestStore = await (0,v1_api/* getFindAStoresResult */.R)(findStores, zipCodeValue, brand, 100, 1, "kohler store", 1);
            if (nearestStore !== undefined) {
                var ref;
                var ref1;
                const nearestStoreData = (ref1 = nearestStore === null || nearestStore === void 0 ? void 0 : (ref = nearestStore.data) === null || ref === void 0 ? void 0 : ref.info[0]) !== null && ref1 !== void 0 ? ref1 : {};
                var ref2;
                const utilityData = {
                    ...nearestStoreData,
                    EntityID: (ref2 = nearestStoreData === null || nearestStoreData === void 0 ? void 0 : nearestStoreData.BPnumber) !== null && ref2 !== void 0 ? ref2 : null
                };
                dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
            } else {
                const utilityData1 = {};
                dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData1));
            }
        }).catch((err)=>console.log(err));
    };
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(utilityStoreDetails) && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber)) {
            (0,utils_location/* getShortenedUrl */.Pp)(utilityStoreDetails[utilityData.BPnumber]).then((myStoreUrl)=>{
                setMyStoreUrl(myStoreUrl);
            });
        }
    }, [
        utilityStoreDetails,
        utilityData
    ]);
    const handleUtilityStoreCheck = (entity)=>{
        localStorage.setItem("myStoreId", entity);
        dispatch((0,locationSlice/* setMyStore */.h9)(entity));
        setState({
            ...state,
            myStoreId: entity
        });
        if (entity === 0) {
            dispatch((0,locationSlice/* setStoreAddress */.wf)({}));
        }
    };
    const pageUrl = fullUrl || ( true ? window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href : 0);
    (0,react.useEffect)(()=>{
        const { pageLevelDetails =[]  } = (0,helper/* getPageLevelScriptsAndStyles */.ptY)(globalScripting);
        setMetas(pageLevelDetails["metaList"]);
        setStyles(pageLevelDetails["stylesList"]);
        setScripts(pageLevelDetails["pageScripts"]);
        setLinks(pageLevelDetails["linkList"]);
    }, [
        globalScripting
    ]);
    (0,react.useEffect)(()=>{
        if (true) {
            bodyRef.current = document.body;
            htmlRef.current = document.getElementsByTagName("html")[0];
        }
    }, []);
    const handleSearchClick = ()=>{
        var ref;
        showSearchBar ? (0,helper/* addMavenoidChat */.dVG)() : lib/* isMobile */.tq ? (0,helper/* removeMavenoidChat */.N9B)() : (0,helper/* addMavenoidChat */.dVG)();
        const classNames = [
            "searchbar-open",
            "scroll-lock"
        ];
        classNames.forEach((className)=>{
            var ref, ref1;
            return bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        classNames.forEach((className)=>{
            var ref, ref1;
            return htmlRef === null || htmlRef === void 0 ? void 0 : (ref = htmlRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        setShowSearchBar(!showSearchBar);
        const page = window.pageObj || {};
        const previousPageNameForSearch = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
        sessionStorage.setItem("previousPageNameForSearch", previousPageNameForSearch);
    };
    (0,react.useEffect)(()=>{
        if (isSaveProductToList) {
            setFavoritesPagePath("/".concat(language).concat(constants.MY_LISTS_PAGE_PATH));
        } else {
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                const myFavPath = get_default()(config, "general.myFavoritesPagePath", "");
                setFavoritesPagePath(await (0,utils_location/* getShortenedUrl */.Pp)(myFavPath !== null && myFavPath !== void 0 ? myFavPath : "/"));
            });
        }
    }, [
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* getFavorites */._l)()).unwrap().then((rsp)=>{
                if (rsp && rsp !== null) {
                    setFavoritesPage(rsp.lineItems);
                } else {
                    setFavoritesPage([]);
                }
            });
        }
    }, [
        isAuth,
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if ((favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.length) > 0) {
            setFavoritesPage(favorites === null || favorites === void 0 ? void 0 : favorites.lineItems);
        } else {
            setFavoritesPage([]);
        }
    }, [
        favorites
    ]);
    (0,react.useEffect)(()=>{
        if (Object.keys(saveToListLineItems).length && isAuth) {
            setFavoritesPage(Object.keys(saveToListLineItems));
        } else {
            setFavoritesPage([]);
        }
    }, [
        Object.keys(saveToListLineItems).length
    ]);
    const onClickSignOut = ()=>{
        dispatch((0,authSlice/* logout */.kS)());
        (0,HeaderNavTabs_analytics/* dataLayerForSignOut */.Sv)();
    };
    const setPromoModal = (data)=>{
        dispatch((0,genericSlice/* showPromoModal */.Wv)(data));
    };
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            window.loginFavouriteCallback = null;
            setLoginFavouriteCallback(null);
            window.location.href = myListsPagePath;
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    const getNavMobileData = async ()=>{
        if (state === null || state === void 0 ? void 0 : state.signInFragment) {
            const result = await (0,api/* aemAxiosInstance */.Gb)({
                url: "".concat(constants.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(state.signInFragment),
                method: "GET"
            });
            const logIndata = result.data.commonTopics;
            setLogIndata(logIndata);
        }
        if (state === null || state === void 0 ? void 0 : state.signUpFragment) {
            const signupdata = await (0,api/* aemAxiosInstance */.Gb)({
                url: "".concat(constants.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(state.signUpFragment),
                method: "GET"
            });
            const loggedOutData = signupdata.data.commonTopics;
            setLogOutdata(loggedOutData);
        }
    };
    const favClickHandler = function(e) {
        let path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        (0,HeaderNavTabs_analytics/* dataLayerForUtilityClicks */.ue)("favorites", false, favoritesPagePath);
        if (!isAuth) {
            window.loginFavouriteCallback = ()=>{
                setLoginFavouriteCallback(e);
            };
            if (path) setMyListsPagePath(path);
            onclicksignIN(false);
            e.stopPropagation();
            e.preventDefault();
        } else if (path && isAuth) {
            router.push(path);
        }
    };
    const fragmentList = (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.contentFragmentListConfig) || {};
    (0,react.useEffect)(()=>{
        getNavMobileData();
    }, [
        state
    ]);
    const [width] = (0,useWindowResize/* default */.Z)();
    const navigationProps = mapMainMenuProps(header, // mockNavigationData,// Use mockNavigationData for navigationProps
    i18n, lineItems, textLineItems, firstName, isAuth, logIndata, logOutdata, onclicksignIN, onClickCreateAccount, onClickSignOut, favClickHandler, cartCount, (themeType === null || themeType === void 0 ? void 0 : themeType.includes("light")) ? "light" : "dark", handleSearchClick, !(themeType === null || themeType === void 0 ? void 0 : themeType.includes("transparent")), favoritesPage, favoritesPagePath, state.cartLandingPagePath, router.asPath, setPromoModal, canadaCheck, navigationHoverTiming, staticTexts.searchHeader, language, isSaveProductToList, width);
    const getStoreAnalytics = (action)=>{
        var ref;
        const href = utilityStoreDetails && utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] ? utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] : "/";
        const internalLinkName = action === "unset as my store" ? "unset as preferred store" : "store details";
        return JSON.stringify({
            eventAction: "find a store:utility nav:" + action,
            eventName: "find a store:utility nav:" + action,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:" + ((ref = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName) + ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine) + (!isEmpty_default()(utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) : "") + ", " + (0,helper/* formatPhoneNumber */.unW)(utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone)) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL:  true ? action === "view store details" ? href.indexOf("http") === -1 ? window.location.origin + href : href : "n/a" : 0,
            clickInternalLinks: "true"
        });
    };
    const viewStoreAnalytics = getStoreAnalytics("view store details");
    const unsetMyStoreAnalytics = getStoreAnalytics("unset as my store");
    const storeMenu = {
        mod: "charcoal",
        eyebrow: {
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? myStoreId !== 0 ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myStore : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.closestStore : "",
                    " "
                ]
            })
        },
        heading: {
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.locationDescription,
                    " "
                ]
            })
        },
        subheading: {
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? "" : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.zipCodeContent,
                    " "
                ]
            })
        },
        storeInfo: !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: utilityData === null || utilityData === void 0 ? void 0 : utilityData.OpenUntil
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine
                        }),
                        !isEmpty_default()(utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (utilityData === null || utilityData === void 0 ? void 0 : utilityData.Locality) + ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AdminDistrict) + " " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.PostalCode)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: (0,helper/* formatPhoneNumber */.unW)(utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone)
                }),
                myStoreUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "store-a",
                    href: myStoreUrl,
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": viewStoreAnalytics,
                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.storeDetail
                })
            ]
        }) : undefined,
        setStoreCTA: {
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "myStoreLabel",
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? myStoreId === (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID) ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myStore : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.setAsMyStore : "",
                    " "
                ]
            }),
            onChange: (e)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    children: [
                        " ",
                        !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? handleUtilityStoreCheck(e.target.checked ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID : 0) : "",
                        " "
                    ]
                });
            },
            checked: myStoreId === (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID),
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": unsetMyStoreAnalytics
        },
        zipCodeInput: {
            eyebrow: !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? {
                text: (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.NotYourStore) + "?"
            } : undefined,
            optionList: optionList,
            label: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.enterCityStateZip,
            inputValue: zipCodeValue,
            onInputChange: (e)=>{
                handleZipCodeUpdate(e.target.value);
            },
            handleSubmit: (zipCode)=>{
                redirect(zipCode);
            },
            CTA: {
                text: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.submit,
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        eventAction: "find a store:utility nav:submit",
                        eventName: "find a store:utility nav:submit",
                        eventType: "navigation",
                        eventMsg: "n/a",
                        eventStatus: "success",
                        internalLinkName: "submit",
                        internalLinkPosition: "find a store",
                        internalLinkType: "find a store:".concat(zipCodeValue !== null && zipCodeValue !== void 0 ? zipCodeValue : ""),
                        internalLinkZoneName: "find a store:utility nav",
                        internalLinkURL: "n/a",
                        clickInternalLinks: "true"
                    })
                }
            }
        },
        CTAs: [
            {
                text: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.userMyLocation,
                onClick: ()=>{
                    getGeoLocation();
                },
                component: "button"
            },
            {
                text: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.viewAllStore,
                href: browseAllStoreUrl,
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        eventAction: "find a store:utility nav:view all stores",
                        eventName: "find a store:utility nav:view all stores",
                        eventType: "navigation",
                        eventMsg: "n/a",
                        eventStatus: "n/a",
                        internalLinkName: "view all stores",
                        internalLinkPosition: "global header:find a store",
                        internalLinkType: "find a store:navigation",
                        internalLinkZoneName: "find a store:utility nav",
                        internalLinkURL:  true ? "".concat(window.location.origin).concat(browseAllStoreUrl) : 0,
                        clickInternalLinks: "true"
                    })
                },
                component: "a"
            }
        ],
        infoModal,
        infoModalErrror,
        setInfoModal,
        staticTexts
    };
    (0,react.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            document.querySelectorAll(".kohler-main-menu-root").forEach((root)=>{
                root.querySelectorAll("button").forEach((btn)=>{
                    btn.classList.add("af-icon-button");
                });
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }) : null,
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }) : null,
                    description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }) : null,
                    templateName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: templateName
                    }) : null,
                    metas === null || metas === void 0 ? void 0 : metas.map((meta, i)=>{
                        if (meta.name && meta.content) return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: meta.name,
                            content: meta.content
                        }, "meta-".concat(i));
                    }),
                    styles === null || styles === void 0 ? void 0 : styles.map((style, i)=>{
                        if (typeof style === "string") return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: (0,jsx_runtime.jsx)((style_default()), {
                                id: style.__hash,
                                children: style
                            })
                        }, "pagestyle-".concat(i));
                    }),
                    links === null || links === void 0 ? void 0 : links.map((link, i)=>{
                        if (typeof link !== "string") return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: link.rel,
                            href: link.href
                        }, "pageLinks-".concat(i));
                    }),
                    (breadCrumb === null || breadCrumb === void 0 ? void 0 : breadCrumb.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/breadcrumb+json",
                        dangerouslySetInnerHTML: {
                            __html: DOMPurify.sanitize(JSON.stringify(breadCrumb))
                        }
                    }, "structured-data-breadcrumb") : null
                ]
            }),
            pageIsInteractive && (scripts === null || scripts === void 0 ? void 0 : scripts.map((script, i)=>{
                if (script.src) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: script.src,
                    type: script.type,
                    integrity: script.integrity,
                    id: "headscript-".concat(i)
                }, "headscript-".concat(i));
                if (!script.src && script.innerHTML) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "headscript-".concat(i),
                    children: "".concat(script.innerHTML)
                }, "headscript-".concat(i));
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mainmenu, {
                ...navigationProps,
                storeMenu: storeMenu
            })
        ]
    });
};
/* harmony default export */ var GlobalPage_GlobalPageHeader = (GlobalPageHeader);


/***/ }),

/***/ 59187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ GLOBAL_HEADER_TEXT; },
/* harmony export */   "WC": function() { return /* binding */ MEGA_MENU; }
/* harmony export */ });
/* unused harmony exports MAIN_MENU, GLOBAL_NAVIGATION */
const GLOBAL_HEADER_TEXT = "global header";
const MAIN_MENU = "main dropdown menu";
const MEGA_MENU = "mega menu navigation";
const GLOBAL_NAVIGATION = "global navigation";


/***/ }),

/***/ 24897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lz": function() { return /* binding */ newdataLayerForCreateAccount; },
/* harmony export */   "Sv": function() { return /* binding */ dataLayerForSignOut; },
/* harmony export */   "UY": function() { return /* binding */ newdatalayerforSignIn; },
/* harmony export */   "hJ": function() { return /* binding */ addAnalyticsOnClose; },
/* harmony export */   "ue": function() { return /* binding */ dataLayerForUtilityClicks; }
/* harmony export */ });
/* unused harmony exports servicesAnalyticsClick, l1DatalayerclickMobile, backClickForMobile, closeButtonDatalayer, hamburgerMenuDatalayer, onclickForSignedFun */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27514);
/* harmony import */ var _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59187);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47956);




const addAnalyticsOnClose = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "main dropdown menu:products:close",
        eventMsg: "n/a",
        eventName: "main dropdown menu:products:close",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "products > close",
        internalLinkPosition: "global header:products",
        internalLinkType: "global header:navigation",
        internalLinkURL: "".concat(window.origin).concat(location.pathname),
        internalLinkZoneName: "main dropdown menu:products"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const servicesAnalyticsClick = (data)=>{
    var ref;
    const { text ="" , link ="" , Leveltwo ="" , L1 ="" , imgcheck =""  } = data;
    const textcont = text ? makingTextDatalayerReady(text) : "";
    const l2DatalayerReady = Leveltwo ? makingTextDatalayerReady(Leveltwo) : "";
    const l1DatalayerReady = L1 ? makingTextDatalayerReady(L1) : "";
    const url = link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat(removeAndCleanLink(link)) : "n/a";
    let internallink;
    if (L1) {
        internallink = "".concat(l1DatalayerReady, " > ").concat(l2DatalayerReady, " > ").concat(imgcheck ? "img_".concat(textcont) : textcont);
    } else if (imgcheck) {
        internallink = "".concat(l2DatalayerReady, " > img_").concat(textcont);
    } else {
        internallink = "".concat(l2DatalayerReady, " > ").concat(textcont);
    }
    const eventInfo = {
        clickInternalLinks: (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) || url === null ? "true" : "false",
        eventAction: MAIN_MENU,
        eventName: MAIN_MENU,
        eventType: GLOBAL_HEADER_TEXT,
        internalLinkName: (ref = getPureText(internallink)) === null || ref === void 0 ? void 0 : ref.replace(PURE_DATA_FOR_STRING_REGEX, ""),
        internalLinkPosition: GLOBAL_HEADER_TEXT,
        internalLinkType: "".concat(GLOBAL_HEADER_TEXT, ":navigation"),
        internalLinkURL: url,
        internalLinkZoneName: GLOBAL_HEADER_TEXT
    };
    pushAnalyticsObjToDataLayer(eventInfo, "cmp:click");
};
const l1DatalayerclickMobile = function() {
    let L1Name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageNameDatalayer = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: MAIN_MENU,
        eventName: MAIN_MENU,
        eventType: GLOBAL_NAVIGATION,
        internalLinkName: L1Name === null || L1Name === void 0 ? void 0 : L1Name.toLowerCase(),
        internalLinkPosition: GLOBAL_HEADER_TEXT,
        internalLinkType: "".concat(GLOBAL_HEADER_TEXT, ":").concat(MEGA_MENU),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageNameDatalayer, ":").concat(GLOBAL_HEADER_TEXT)
    };
    pushAnalyticsObjToDataLayer(eventInfo, "cmp:click");
};
const backClickForMobile = function() {
    let L1Name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(GLOBAL_HEADER_TEXT, ":back"),
        eventName: "".concat(GLOBAL_HEADER_TEXT, ":back"),
        eventType: "navigation",
        internalLinkName: "".concat(L1Name.toLowerCase(), " > back"),
        internalLinkPosition: "".concat(GLOBAL_HEADER_TEXT, ":").concat(L1Name.toLowerCase()),
        internalLinkType: "".concat(GLOBAL_HEADER_TEXT, ":").concat(MEGA_MENU),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(MAIN_MENU, ":").concat(L1Name.toLowerCase())
    };
    pushAnalyticsObjToDataLayer(eventInfo, "cmp:click");
};
const closeButtonDatalayer = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "products";
    addMavenoidChat();
    data = data ? data : "products";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(MAIN_MENU, ":").concat(data.toLowerCase(), ":close"),
        eventName: "".concat(MAIN_MENU, ":").concat(data.toLowerCase(), ":close"),
        eventType: "navigation",
        internalLinkName: "".concat(data.toLowerCase(), " > close"),
        internalLinkPosition: "".concat(GLOBAL_HEADER_TEXT, ":products"),
        internalLinkType: "".concat(GLOBAL_HEADER_TEXT, ":").concat(MEGA_MENU),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(MAIN_MENU, ":products")
    };
    pushAnalyticsObjToDataLayer(eventInfo, "cmp:click");
};
const hamburgerMenuDatalayer = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "hamburger menu open",
        eventName: "hamburger menu open",
        eventType: GLOBAL_NAVIGATION,
        internalLinkName: "hamburger menu open",
        internalLinkPosition: GLOBAL_HEADER_TEXT,
        internalLinkType: "".concat(GLOBAL_HEADER_TEXT, ":open"),
        internalLinkURL: "n/a",
        internalLinkZoneName: GLOBAL_HEADER_TEXT
    };
    pushAnalyticsObjToDataLayer(eventInfo, "cmp:click");
};
const newdatalayerforSignIn = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            eventType: "navigation",
            internalLinkName: "sign in start",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    } else {
        const eventInfo1 = {
            eventName: "my account:sign in",
            eventAction: "my account:sign in",
            internalLinkName: "sign in interaction",
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in"),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo1, "cmp:click");
    }
};
const newdataLayerForCreateAccount = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            eventType: "navigation",
            internalLinkName: "create account",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    } else {
        const eventInfo1 = {
            eventName: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.MY_ACCOUNT_MODAL, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT),
            eventAction: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.MY_ACCOUNT_MODAL, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT),
            internalLinkName: _constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT,
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo1, "cmp:click");
    }
};
const onclickForSignedFun = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(GLOBAL_HEADER_TEXT, ":your kohler account"),
            eventName: "".concat(GLOBAL_HEADER_TEXT, ":your kohler account"),
            eventType: "navigation",
            internalLinkName: "your kohler account",
            internalLinkPosition: "".concat(GLOBAL_HEADER_TEXT, ":my account"),
            internalLinkType: "".concat(GLOBAL_HEADER_TEXT, ":").concat(MEGA_MENU),
            internalLinkURL: "n/a",
            internalLinkZoneName: GLOBAL_HEADER_TEXT
        };
        pushAnalyticsObjToDataLayer(eventInfo, "cmp:click");
    }
};
const dataLayerForUtilityClicks = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", themeChange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var ref;
    const dataLayerTitle = title === null || title === void 0 ? void 0 : title.toLowerCase();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageNameDatalayer = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            eventType: "navigation",
            internalLinkName: "".concat(dataLayerTitle),
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .removeAndCleanLink */ .xEh)(url)) : "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    } else if (dataLayerTitle === "find a store") {
        const eventInfo1 = {
            eventAction: dataLayerTitle,
            eventName: dataLayerTitle,
            eventType: dataLayerTitle,
            internalLinkName: dataLayerTitle,
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: "".concat(pageNameDatalayer).concat(pageNameDatalayer ? ":" : "").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo1, "cmp:click");
    } else {
        dataLayerTitle === "favorites";
        const eventInfo2 = {
            eventName: "wishlist icon",
            eventAction: "wishlist icon",
            internalLinkName: "wishlist",
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .removeAndCleanLink */ .xEh)(url)) : "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, " wishlist"),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo2, "cmp:click");
    }
};
const dataLayerForSignOut = ()=>{
    const eventInfo = {
        eventName: "my account:sign out",
        eventAction: "my account:sign out",
        internalLinkName: "sign out",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "navigation",
        internalLinkURL: window.location.origin + "/en",
        internalLinkPosition: "global header sign out",
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};


/***/ }),

/***/ 55938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72433);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47956);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5702);
/* harmony import */ var _components_Shared_MiniCart_v1_MiniCart__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99878);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91296);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(36064);
/* harmony import */ var _components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _components_Default_DynamicSearch_v1_SearchPanel_localization__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(55631);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27514);
/* harmony import */ var _store_features_productListSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42286);
/* harmony import */ var _store_features_searchSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54127);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2693);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29843);
/* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(20558);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7154);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_19__);






















const SearchPanel = next_dynamic__WEBPACK_IMPORTED_MODULE_14___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5531), __webpack_require__.e(7866), __webpack_require__.e(4267), __webpack_require__.e(6159)]).then(__webpack_require__.bind(__webpack_require__, 85574)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(85574)
            ]
    }
});
const UtilityWidgets = (props)=>{
    var ref;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const { searchHeader =""  } = (0,_components_Default_DynamicSearch_v1_SearchPanel_localization__WEBPACK_IMPORTED_MODULE_20__/* .getTranslations */ .F)(t);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_19__.useRouter)();
    let analyticsEventData = {};
    const { columnClassNames , data , eventHandler , id =""  } = props;
    const { isAuth  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__/* .selectAuthState */ ._9);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getUserPersona */ .shu)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)();
    const currencySign = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const currencyCode = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const searchPagePath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const knowledgeArticleUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const [showSearchBar, setShowSearchBar] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [selectedData, setSelectedData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [searchString, setSearchString] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    var ref1;
    const [searchHistory, setSearchHistory] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((ref1 = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref1 !== void 0 ? ref1 : []);
    const [brandName, setBrandName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("kohler");
    const [searchTotal, setSearchTotal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [topSuggestedData, setTopSuggestedData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isCTAClicked, setIsCTAClicked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [redirectUrl, setRedirectUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [category, setCategory] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [tilesData, setTilesData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [productsLoaded, setProductsLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [xfLink, setXfLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [promoLayout, setPromoLayout] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("one-column");
    const [isGlobalConfigBlank, setIsGlobalConfigBlank] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [fusionFullCatalogResponse, setFusioFullCatalognResponse] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [isSterling, setIsSterling] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [redirectTileToKohelerPLP, setRedirectTileToKohelerPLP] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const selectedFavoritesState = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_8__/* .selectFavoritesState */ .Qx);
    const { favorites  } = selectedFavoritesState || {};
    const { lineItems =[]  } = favorites || {};
    const [presetConfigs, setPresetConfigs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showSearchBar) {
            var ref;
            setSearchHistory((ref = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : []);
        }
    }, [
        showSearchBar
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isGlobalConfigBlank) {
            (0,_constants_config__WEBPACK_IMPORTED_MODULE_5__/* .getConfig */ .i)().then(async (config)=>{
                let blankConfig = false;
                if (!(config && Object.keys(config).length > 1)) {
                    blankConfig = true;
                    setIsGlobalConfigBlank(true);
                }
                let presetConfigs = await lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(config, "presetConfigs.search", "");
                setPresetConfigs(JSON.stringify(presetConfigs));
                if (!blankConfig) {
                    setIsGlobalConfigBlank(false);
                    const vbrandName = await lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(config, "general.siteName", "");
                    if (vbrandName) {
                        setBrandName(vbrandName);
                    }
                    currencySign.current = lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(config, "internationalization.currencySign", "");
                    currencyCode.current = await lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(config, "internationalization.currencyCode", "");
                    knowledgeArticleUrl.current = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(config, "general.knowledgeArticlePath", ""));
                    searchPagePath.current = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(config, "general.searchPagePath", ""));
                    setRedirectTileToKohelerPLP(await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(config, "general.searchPagePath", "")));
                }
            }).catch((error)=>{
                console.log(error);
            });
        }
    }, [
        isSsr,
        isGlobalConfigBlank
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (data.presetConfigs) {
            dispatch((0,_store_features_searchSlice__WEBPACK_IMPORTED_MODULE_13__/* .setSearchPresetConfig */ .xp)(data.presetConfigs));
        }
    }, [
        data.presetConfigs
    ]);
    const getEventInfoObj = (searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData)=>{
        var ref;
        const currDate = new Date();
        const contentType = window.adobeDataLayer && window.adobeDataLayer.getState ? window.adobeDataLayer.getState("page.pageInfo.contentType") || window.adobeDataLayer.getState("page.category.primaryCategory") : "";
        const pageName = contentType ? contentType.split("-")[0] : "";
        const autoSearch = !internalLinkURL ? true : false;
        const searchSuggestedTerm = [];
        if (!analyticsEventData.searchString) {
            analyticsEventData.searchString = searchString;
        }
        if (!analyticsEventData.searchTotal) {
            analyticsEventData.searchTotal = searchTotal;
        }
        if (!analyticsEventData.topSuggestedData) {
            analyticsEventData.topSuggestedData = topSuggestedData;
        }
        const searchSuggestions = searchHistory && searchHistory.length ? searchHistory : analyticsEventData.topSuggestedData && analyticsEventData.topSuggestedData.length ? analyticsEventData.topSuggestedData : [];
        if (searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.length) {
            searchSuggestions.slice(0, 5).map((item)=>{
                searchSuggestedTerm.push((0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .sanitizeTextForAnalytics */ .T68)(item.productName_s || item.keyWord));
            });
        }
        const eventseachName = isserachButton ? "internal search" : "internal ".concat(autoSearch ? "automatic " : "", "search");
        const names = topSuggestedData ? topSuggestedData === null || topSuggestedData === void 0 ? void 0 : topSuggestedData.filter((obj)=>"productName_s" in obj).map(function(obj) {
            return obj["productName_s"];
        }) : null;
        const topsuggestions = names ? (ref = names === null || names === void 0 ? void 0 : names.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase() : null;
        const eventInfo = {
            eventName: eventseachName,
            eventAction: eventseachName,
            internalLinkName: "internal search icon",
            internalLinkType: "global header:navigation",
            internalLinkZoneName: "global header",
            clickInternalLinks: "true",
            eventType: "global header",
            internalLinkURL: internalLinkURL ? (internalLinkURL.indexOf("http") === -1 ? window.location.origin : "") + internalLinkURL : "n/a",
            internalLinkPosition: "global header",
            eventMsg: status !== "success" ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a",
            eventStatus: status || "n/a",
            searchTerm: analyticsEventData.searchString,
            searchContentType: pageName ? pageName + " page" : "n/a",
            searchSuggestedTerm: topsuggestions ? topsuggestions : "n/a",
            searchCount: sessionStorage.getItem("searches") ? Number(sessionStorage.getItem("searches")) + 1 : 1,
            searchResult: analyticsEventData.searchTotal,
            internalZoneName: "search:search box",
            pageURL: window.location.href,
            referrer: document.referrer || "n/a",
            previousPage: document.referrer || "n/a",
            timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0],
            contentType: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()
        };
        if (eventType === null || eventType === void 0 ? void 0 : eventType.type) {
            eventType.term = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .sanitizeTextForAnalytics */ .T68)(eventType.term);
            eventType.type = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .sanitizeTextForAnalytics */ .T68)(eventType.type);
            eventInfo.eventName = "search:" + eventType.type + ":search term";
            eventInfo.eventAction = "search:" + eventType.type + ":search term";
            eventInfo.internalLinkZoneName = "search:" + eventType.type;
            if (eventType.type === "top suggestions") {
                var ref1;
                eventInfo.searchTerm = (ref1 = analyticsEventData.searchString) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                eventInfo.searchSuggestedTerm = eventType.term;
            } else {
                eventInfo.searchTerm = eventType.term;
            }
            eventInfo.internalLinkName = eventType.term;
            eventInfo.internalZoneName = "search:" + eventType.type;
        }
        analyticsEventData = {};
        return eventInfo;
    };
    const handleSearchAnalyticsEvent = (searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData)=>{
        if (!internalLinkURL) internalLinkURL = redirectUrl;
        const eventInfo = getEventInfoObj(searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData);
        sessionStorage.setItem("searches", eventInfo.searchCount);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const handleRedirect = (searchTerm, isAnalyticsClick, analyticsEventType, isserachButton, topSuggestedData)=>{
        setProductsLoaded(false);
        setIsCTAClicked(true);
        if (redirectUrl) {
            isAnalyticsClick && handleSearchAnalyticsEvent(searchTerm, "success", null, null, analyticsEventType);
            window.location.href = redirectUrl;
            setRedirectUrl("");
        } else {
            var ref;
            let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
            history = history.filter((item)=>item.keyWord.toLowerCase() !== searchTerm.toLowerCase());
            history.unshift({
                keyWord: searchTerm,
                id: Date.now()
            });
            window.localStorage.setItem("keyWordList", JSON.stringify(history));
            Promise.all([
                dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_12__/* .profileBrandSearch */ .R$)([
                    searchTerm.trim(),
                    brandName.toLowerCase(),
                    "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                    1,
                    ""
                ]))
            ]).then(async (res)=>{
                if (res[0].payload) {
                    let redirectUrl = "";
                    // redirect if redirect URL is configured in LW for search keyword
                    if (res[0].payload.fusion && res[0].payload.fusion.redirect && res[0].payload.fusion.redirect[0]) {
                        redirectUrl = res[0].payload.fusion.redirect[0];
                        isAnalyticsClick && searchTerm !== searchString && // do not fire same events for unchanged search string
                        handleSearchAnalyticsEvent(searchTerm, "success", null, redirectUrl, analyticsEventType);
                        window.location.href = redirectUrl;
                    } else if (res[0].payload.response.numFound === 1 && res[0].payload.fusion.exactMatch) {
                        const d = res[0].payload.response.docs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "skuId=".concat(d.sku_s) : "";
                            const pdpUrl = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getPDPUrl */ .ir5)(d.Product_Category, d.slug_s);
                            redirectUrl = (0,_utils___WEBPACK_IMPORTED_MODULE_17__/* .getPdpRedirectUrl */ .Om)(pdpUrl, param);
                        } else if (d.url_s) {
                            redirectUrl = d.url_s;
                        }
                        isAnalyticsClick && searchTerm !== searchString && // do not fire same events for unchanged search string
                        handleSearchAnalyticsEvent(searchTerm, "success", null, redirectUrl, analyticsEventType);
                        window.location.href = redirectUrl;
                    } else {
                        redirectUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .sanitizeUrl */ .Nmg)(window.location.origin + (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .removeAndCleanLink */ .xEh)(searchPagePath.current) + "?keyword=".concat(searchTerm.trim()));
                        if (isAnalyticsClick) {
                            searchTerm !== searchString // do not fire same events for unchanged search string
                             ? handleSearchAnalyticsEvent(searchTerm, "success", null, redirectUrl, analyticsEventType) : handleSearchAnalyticsEvent(searchTerm, "success", null, redirectUrl, analyticsEventType, isserachButton, topSuggestedData);
                        }
                        window.location.href = redirectUrl;
                    }
                }
            // setProductsLoaded(true)
            }).catch((err)=>{
                console.log("Error occured while fetching Search data", err);
                isAnalyticsClick && handleSearchAnalyticsEvent(searchTerm, "failure", "error occured while fetching search data", null, analyticsEventType);
                setProductsLoaded(true);
            });
        }
    };
    const handleDelete = (id)=>{
        var ref;
        let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
        history = history.filter((item)=>item.id !== id);
        window.localStorage.setItem("keyWordList", JSON.stringify(history));
        setSearchHistory(history);
    };
    const handleClearAll = ()=>{
        localStorage.removeItem("keyWordList");
        setSearchHistory([]);
    };
    const handleChange = (searchTerm)=>{
        setProductsLoaded(false);
        setSearchString(searchTerm.trim());
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (brandName) {
            if (searchString.length >= 3) {
                getSearchResult(searchString);
            } else {
                setSearchTotal(0);
            }
            setProductsLoaded(false);
        }
    }, [
        searchString,
        brandName
    ]);
    const getSearchResult = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_10___default()((searchString)=>getData(searchString), 2000), [
        brandName
    ]);
    const getData = (searchStr)=>{
        const { disableParts  } = data;
        if (redirectUrl) setRedirectUrl("");
        if (!isCTAClicked && searchStr.length >= 3) {
            Promise.all([
                dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_12__/* .profileBrandSearch */ .R$)([
                    searchStr.trim(),
                    brandName.toLowerCase(),
                    "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                    1,
                    ""
                ])),
                dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_12__/* .profileBrandTypeahead */ .zw)([
                    searchStr.trim(),
                    brandName.toLowerCase()
                ]))
            ]).then(async (res)=>{
                if (res[0].payload && res[1].payload) {
                    let redirectUrl = "";
                    // redirect if redirect URL is configured in LW for search keyword
                    if (res[0].payload.fusion && res[0].payload.fusion.redirect && res[0].payload.fusion.redirect[0]) {
                        handleSearchAnalyticsEvent(searchStr, "success", null, res[0].payload.fusion.redirect[0]);
                        window.location.href = res[0].payload.fusion.redirect[0];
                    } else if (res[0].payload.response.numFound === 1 && res[0].payload.fusion.exactMatch) {
                        const d = res[0].payload.response.docs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "skuId=".concat(d.sku_s) : "";
                            const pdpUrl = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getPDPUrl */ .ir5)(d.Product_Category, d.slug_s);
                            redirectUrl = (0,_utils___WEBPACK_IMPORTED_MODULE_17__/* .getPdpRedirectUrl */ .Om)(pdpUrl, param);
                        } else if (d.url_s) {
                            redirectUrl = d.url_s;
                        }
                    }
                    // get parts PDP URL if only 1 result
                    if (!res[0].payload.fusion.redirect) {
                        let groups = [
                            {
                                key: "products",
                                fq: 'Products:("ct")',
                                count: lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(res[0].payload, "facet_counts.facet_fields.Products[1]", 0)
                            },
                            {
                                key: "technical",
                                fq: 'Technical:("ct")',
                                count: lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(res[0].payload, "facet_counts.facet_fields.Technical[1]", 0)
                            },
                            {
                                key: "inspiration",
                                fq: 'Inspiration:("Inspiration")',
                                count: lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(res[0].payload, "facet_counts.facet_fields.Inspiration[1]", 0)
                            },
                            {
                                key: "resource",
                                fq: 'Resource:("Resource")',
                                count: lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(res[0].payload, "facet_counts.facet_fields.Resource[1]", 0)
                            },
                            {
                                key: "help",
                                fq: 'Help:("sf")',
                                count: lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(res[0].payload, "facet_counts.facet_fields.Help[1]", 0)
                            }
                        ];
                        if (disableParts || (brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()) === (_constants__WEBPACK_IMPORTED_MODULE_6__.annSacksConstants === null || _constants__WEBPACK_IMPORTED_MODULE_6__.annSacksConstants === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_6__.annSacksConstants.asBrandName)) {
                            groups = groups.filter((arr)=>{
                                return arr.key !== "parts";
                            });
                        }
                        // Calculating the total results
                        let total = 0;
                        const selected = groups.find((group)=>group.count > 0);
                        if (res[0].payload.fusion.exactMatch) {
                            total = res[0].payload.response.numFound;
                        } else {
                            groups.forEach((group)=>total += group.count);
                        }
                        analyticsEventData.searchTotal = total;
                        analyticsEventData.redirectUrl = redirectUrl;
                        analyticsEventData.topSuggestedData = lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(res[1].payload, "response.docs", []);
                        analyticsEventData.selectedData = selected;
                        analyticsEventData.searchString = searchStr.trim();
                        setSearchTotal(total);
                        setRedirectUrl(redirectUrl);
                        const fullCatalogResponse = lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(res[0].payload, "fusion.full_catalog_Response", []);
                        if (fullCatalogResponse.length > 0) {
                            setIsSterling(true);
                            setSearchTotal(1);
                        }
                        setFusioFullCatalognResponse(fullCatalogResponse);
                        const responseDocs = lodash_get__WEBPACK_IMPORTED_MODULE_7___default()(res[1].payload, "response.docs", []);
                        setTopSuggestedData(fullCatalogResponse.length > 0 ? fullCatalogResponse : responseDocs);
                        handleSearchAnalyticsEvent(searchStr, "success");
                        setSelectedData(selected);
                    }
                }
            }).catch((err)=>{
                setProductsLoaded(true);
                console.error("Error occured while fetching Search data", err);
            });
        } else {
            setSearchTotal(0);
            setCategory("");
            setTilesData([]);
            setRedirectUrl("");
            setTopSuggestedData([]);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (searchTotal > 0 && selectedData.key) {
            getTilesData(selectedData);
        }
    }, [
        searchTotal,
        selectedData
    ]);
    const getTilesData = (selected)=>{
        const fl = [
            "id",
            "sku_s",
            "slug_s",
            "metaTitle_s",
            "productName_s",
            "masterSKU_s",
            "Product_Category",
            "ProductBrandName_s",
            "productImages.url_ss",
            "displayPriceStartingAt_s",
            "SKUColorSwatchFilename_ss",
            "ProductDescriptionProductShort_s",
            "url_s",
            "title_s",
            "pageTitle_s",
            "eyeBrowText_s",
            "templateType_s",
            "thumbNailImage_s",
            "searchDescription_s",
            "priceList.".concat(persona, ".price_d"),
            "priceList.".concat(persona, ".finalPrice_d"),
            "priceList.".concat(persona, ".discountedPrice_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "Color.SKU.Details_ss",
            "Color.".concat(persona, ".Details_ss"),
            "ProductIsExclusive_s",
            "RegionReleaseforShipment_dt",
            "RegionLaunchDate_dt",
            "productImages.labelWithUrl_ss",
            "variantList.sku_ss",
            "RegionOnBackOrder_s",
            "RegionBrandName_s",
            "ctId_s",
            "pdp_url_s"
        ];
        setXfLink("");
        setPromoLayout("one-column");
        setCategory("");
        setTilesData([]);
        dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_12__/* .profileBrandSearch */ .R$)([
            searchString.trim(),
            brandName.toLowerCase(),
            fl.join(","),
            6,
            selected.fq
        ])).then((res)=>{
            var ref;
            if (res.payload && ((ref = res.payload.response) === null || ref === void 0 ? void 0 : ref.docs)) {
                var ref1;
                setCategory(selected.key);
                setTilesData((ref1 = res.payload.response) === null || ref1 === void 0 ? void 0 : ref1.docs);
                if ((fusionFullCatalogResponse === null || fusionFullCatalogResponse === void 0 ? void 0 : fusionFullCatalogResponse.length) > 0) {
                    setTilesData(fusionFullCatalogResponse);
                }
                if (res.payload.fusion && res.payload.fusion.experiment_fragments && res.payload.fusion.experiment_fragments !== undefined) {
                    var ref2, ref3, ref4, ref5;
                    var ref6;
                    setPromoLayout((ref6 = (ref3 = (ref2 = res.payload.fusion) === null || ref2 === void 0 ? void 0 : ref2.experiment_fragments[0]) === null || ref3 === void 0 ? void 0 : ref3.promoLayout_s) !== null && ref6 !== void 0 ? ref6 : "one-column");
                    var ref7;
                    setXfLink((ref7 = (ref5 = (ref4 = res.payload.fusion) === null || ref4 === void 0 ? void 0 : ref4.experiment_fragments[0]) === null || ref5 === void 0 ? void 0 : ref5.url_s) !== null && ref7 !== void 0 ? ref7 : "");
                }
            }
            setProductsLoaded(true);
        });
    };
    const bodyRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(document.body);
    const htmlRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(document.getElementsByTagName("html")[0]);
    const handleToggle = ()=>{
        setSearchString("");
        setSearchTotal(0);
        const classNames = [
            "searchbar-open",
            "scroll-lock"
        ];
        classNames.map((className)=>{
            var ref, ref1;
            return bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        classNames.map((className)=>{
            var ref, ref1;
            return htmlRef === null || htmlRef === void 0 ? void 0 : (ref = htmlRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        setShowSearchBar(!showSearchBar);
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        isAuth ? router.push("/en/my-account/my-favorites") : dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__/* .setAuthModalVisibility */ .LY)({
            show: true
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_21___default().utilityWidgetsWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "utilitywidgets ".concat(columnClassNames ? columnClassNames : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                role: "list",
                className: "utility-widgets",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "listitem",
                        className: "search-widget",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    id: id,
                                    className: "search-button gbh-data-layer bg-transparent",
                                    tabIndex: "0",
                                    role: "button",
                                    "aria-label": "Search",
                                    "data-gbh-data-layer": '{"eventAction":"internal search","eventName":"internal search","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"internal search magnifying glass button","internalLinkPosition":"global header","internalLinkType":"global navigation","internalLinkZoneName":"global header","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                    onClick: handleToggle,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "search-text",
                                            children: searchHeader
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "search-icon",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                role: "presentation",
                                                src: "data:image/svg+xml;base64,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",
                                                alt: "search-icon"
                                            })
                                        })
                                    ]
                                }),
                                showSearchBar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchPanel, {
                                    showSearchBar: showSearchBar,
                                    onToggle: handleToggle,
                                    onRedirect: handleRedirect,
                                    onChange: handleChange,
                                    searchString: searchString,
                                    brand: brandName,
                                    searchTotal: searchTotal,
                                    topSuggestedData: topSuggestedData,
                                    searchHistory: searchHistory,
                                    xfLink: xfLink,
                                    category: category,
                                    removeFromCompare: _utils_product__WEBPACK_IMPORTED_MODULE_16__/* .removeFromCompareProduct */ .Zj,
                                    addToCompare: _utils_product__WEBPACK_IMPORTED_MODULE_16__/* .addToCompareProduct */ .dX,
                                    tilesData: tilesData,
                                    productsLoaded: productsLoaded,
                                    promoLayout: promoLayout,
                                    favorites: (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getFavouraties */ .MqV)()) === null || ref === void 0 ? void 0 : ref.lineItems,
                                    comparedProducts: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getCompareData */ .p2C)(),
                                    currencySign: currencySign.current,
                                    knowledgeArticleUrl: knowledgeArticleUrl.current,
                                    presetConfigs: "".concat(presetConfigs),
                                    onDelete: handleDelete,
                                    onClearAll: handleClearAll,
                                    isSterling: isSterling,
                                    sterlingData: fusionFullCatalogResponse,
                                    parent: "Utility Widgets",
                                    searchPagePath: redirectTileToKohelerPLP
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "listitem",
                        className: "wishlist-widget d-lg-none",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "#",
                            "aria-label": "View your wishlist",
                            className: "gbh-data-layer",
                            onClick: handleLogin,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                "aria-hidden": "true",
                                alt: "Wishlist",
                                src: lineItems && lineItems.length > 0 ? _constants__WEBPACK_IMPORTED_MODULE_6__.FULL_FAVORITE_BASE64 : _constants__WEBPACK_IMPORTED_MODULE_6__.EMPTY_FAVORITE_BASE64
                            })
                        })
                    }),
                    !(data === null || data === void 0 ? void 0 : data.disableMiniCart) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "listitem",
                        className: "cart-indicator-widget d-lg-none",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_MiniCart_v1_MiniCart__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            source: "from mobile",
                            eventHandler: eventHandler
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UtilityWidgets);


/***/ }),

/***/ 24636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_SocialShare; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useSocialSharei18n.js

const useSocialSharei18n = (shareCartNum, brandName)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        email: t("kf.share.label.email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: shareCartNum
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandName: brandName,
                siteKey: siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText"),
        shareCartDesc: t("kf.cart.label.shareCartDesc"),
        shareCart: t("kf.cart.label.shareCart"),
        mailSubject: t("kf.share.label.emailSubject"),
        downloadSpecs: t("kf.cart.label.downloadSpecs")
    };
    return i18n;
};
/* harmony default export */ var i18n_useSocialSharei18n = (useSocialSharei18n);

// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./components/SocialShare/v1/SocialShare.jsx







const SocialShare = (props)=>{
    const { url ="" , showModal , componentProp: { assetUrl ="" , url: compUrl = "" , internallinkposition , internallinktype , internallinkzonename , eventaction , eventname  } = {} , componentProp , id , sharedCartNum , onClose , mailBody , mailSubject , analyticData: analyticPropData , iframeId , shareBtn , shareRef , productName =""  } = props;
    const [sites, setSites] = (0,react.useState)([]);
    const [general, setGeneral] = (0,react.useState)(null);
    const [origin, setOrigin] = (0,react.useState)(null);
    const [href, setHref] = (0,react.useState)(null);
    const [socialMediaConfigs, setSocialMediaConfigs] = (0,react.useState)({});
    const emailBtnRef = (0,react.useRef)(null);
    const copyBtnRef = (0,react.useRef)(null);
    const shareBoxRef = (0,react.useRef)(null);
    const brandName = (0,react.useRef)("");
    const shareCartUrl = (0,react.useRef)("");
    const socialShareCopyIconPath = (0,react.useRef)("");
    const socialShareEmailIconPath = (0,react.useRef)("");
    (0,react.useEffect)(()=>{
        var ref;
        const sanitizedUrl = (0,helper/* sanitizeUrl */.Nmg)(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
        const pageUrl = new URL(sanitizedUrl);
        setOrigin(pageUrl === null || pageUrl === void 0 ? void 0 : pageUrl.origin);
        setHref(pageUrl === null || pageUrl === void 0 ? void 0 : pageUrl.href);
        (0,config/* getConfig */.i)().then(async (config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
            const socialMediaConfigs = get_default()(config, "socialMediaConfig", {});
            setSocialMediaConfigs(socialMediaConfigs);
            brandName.current = get_default()(config, "general?.siteName", "");
            socialShareCopyIconPath.current = get_default()(config, "general.socialShareCopyIconPath", "");
            socialShareEmailIconPath.current = get_default()(config, "general.socialShareEmailIconPath", "");
            shareCartUrl.current = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.shareCartPagePath", ""));
        });
    }, []);
    // get component social share link url
    const getLink = ()=>{
        var ref;
        const sanitizedUrl = (0,helper/* sanitizeUrl */.Nmg)(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
        const pageUrl = new URL(sanitizedUrl);
        const isFullUrl = /^https?:\/\//i;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = (0,helper/* getShortenedUrlwithGeneral */.vu1)(compUrl, general);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else {
            let resURL = (pageUrl === null || pageUrl === void 0 ? void 0 : pageUrl.href) ? (0,helper/* sanitizeUrl */.Nmg)(pageUrl === null || pageUrl === void 0 ? void 0 : pageUrl.href) : (0,helper/* sanitizeUrl */.Nmg)(href);
            return resURL;
        }
    };
    const link = getLink();
    const staticText = i18n_useSocialSharei18n(sharedCartNum, brandName);
    const [copyIcon, setCopyIcon] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        var ref;
        let siteList = [];
        socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : (ref = socialMediaConfigs.myArrayList) === null || ref === void 0 ? void 0 : ref.forEach((socialMediaConfig)=>{
            if (!isEmpty_default()(socialMediaConfig) && socialMediaConfig.name) {
                var _name, _iconPath;
                const site = {
                    key: (_name = socialMediaConfig.name) !== null && _name !== void 0 ? _name : "",
                    icon: (_iconPath = socialMediaConfig.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                };
                var _redirectUrl;
                const url = (_redirectUrl = socialMediaConfig.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                if (socialMediaConfig.name.toLowerCase().includes("twitter")) {
                    siteList.push({
                        ...site,
                        url: encodeURI(url + link + "&text=".concat(document.title))
                    });
                } else if (socialMediaConfig.name.toLowerCase().includes("pinterest")) {
                    siteList.push({
                        ...site,
                        url: url + link
                    });
                } else {
                    siteList.push({
                        ...site,
                        url: url + link
                    });
                }
            }
        });
        if (siteList.length) {
            siteList = siteList.filter((site)=>!site.key.toLowerCase().includes("instagram"));
        }
        setSites(siteList);
    }, [
        socialMediaConfigs
    ]);
    const emailLink = (e)=>{
        e.stopPropagation();
        addDataLayer("email a friend", "n/a");
    };
    const socialLinks = (e)=>{
        const target = e.target;
        const nodeUrl = target.hostname.replace(/(^www\.)/, "");
        if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
            e.stopPropagation();
            e.preventDefault();
            if (window.handleShowModal) window.handleShowModal(target.href, target);
        } else if (target.href) {
            window.open(target.href);
        }
        const key = target.siteKey || nodeUrl || target.hostname;
        try {
            addDataLayer(key.split(".com")[0], target.href);
        } catch (err) {
            console.log(err);
        }
    };
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        showModal
    ]);
    const analyticData = analyticPropData || {
        internalLinkPosition: internallinkposition || "n/a",
        internalLinkType: internallinktype || "n/a",
        internalLinkZoneName: internallinkzonename || "n/a",
        eventAction: eventaction || "n/a",
        eventName: eventname || "n/a"
    };
    const handleClick = (e)=>{
        var ref;
        const selELement = iframeId ? document.getElementById(iframeId).contentDocument.getElementById(id) : document.getElementById(id);
        if (showModal && !(selELement === null || selELement === void 0 ? void 0 : selELement.contains(e.target)) && !(shareBtn === null || shareBtn === void 0 ? void 0 : (ref = shareBtn.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
            onClose();
        }
        if ((componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) && window.shareSrcElement !== null && window.shareSrcElement !== undefined && !shareRef.current.contains(e.target)) {
            const shareElems = [
                ...document.getElementsByClassName("share-cmp")
            ];
            shareElems.forEach((el)=>{
                el.style.display = "none";
            });
            window.shareSrcElement = null;
        }
        return true;
    };
    const handleClose = (e)=>{
        if (e.keyCode === 27) {
            onClose();
            shareBtn.current.focus();
        }
    };
    (0,react.useEffect)(()=>{
        const selELement = iframeId ? document.getElementById(iframeId).contentDocument : document;
        if (showModal) {
            selELement.addEventListener("click", handleClick);
            selELement.addEventListener("keydown", handleClose);
            return ()=>{
                selELement.removeEventListener("click", handleClick);
                selELement.removeEventListener("keydown", handleClose);
            };
        }
        if ((componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) && showModal) {
            document.addEventListener("click", handleClick);
        }
    }, [
        showModal
    ]);
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        navigator.clipboard.writeText(link);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
        addDataLayer("copy link", link !== null && link !== void 0 ? link : "n/a");
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const addDataLayer = (siteKey, link)=>{
        const { eventAction ="n/a" , eventName ="n/a" , eventType ="informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , custom  } = analyticData;
        const eventInfo = {
            eventAction,
            eventName,
            eventType,
            eventMsg,
            eventStatus,
            internalLinkName: siteKey,
            internalLinkPosition,
            internalLinkType,
            internalLinkZoneName,
            internalLinkURL: link || internalLinkURL || "n/a",
            clickInternalLinks: siteKey === "copy link" || siteKey === "email a friend" ? "true" : "false"
        };
        if (window.dataLayerEventType) {
            eventInfo.internalLinkType = window.dataLayerEventType;
        }
        if (window.dataLayerEventZoneName) {
            eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
            if (eventAction === "n/a") {
                eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
                eventInfo.eventName = window.dataLayerEventZoneName + ":share";
            }
        }
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        let productInfo;
        if (custom) {
            try {
                productInfo = JSON.parse(custom).productInfo;
            // eslint-disable-next-line no-empty
            } catch (e) {}
        }
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    return (showModal !== null && showModal !== void 0 ? showModal : componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "social-share",
        id: id,
        ref: shareRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "social-share__box",
            ref: shareBoxRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "social-share__sites",
                    children: sharedCartNum && sharedCartNum ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "social-share__shared-cart-number",
                        children: staticText.yourSharedCartNumber
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        children: sites.map((site, i)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    id: "kf-social-links-".concat(i),
                                    rel: "noreferrer",
                                    href: site.url,
                                    className: "kf-social-links",
                                    "aria-label": "".concat(site.key, " ").concat(staticText.openNewTabText),
                                    target: "_blank",
                                    "data-link-type": "social media",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        "aria-hidden": "true",
                                        src: site === null || site === void 0 ? void 0 : site.icon,
                                        alt: site.key,
                                        className: "social-share__".concat(site.key)
                                    })
                                })
                            }, i);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "social-share__actions",
                    role: "list",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                tabIndex: "0",
                                role: "button",
                                ref: copyBtnRef,
                                className: "social-share__cta",
                                "aria-label": "".concat(copyIcon ? staticText.copyLinkIndication : staticText.copyLink, " for ").concat(productName),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "social-share__copy-link-icon",
                                        "aria-hidden": true,
                                        src: socialShareCopyIconPath.current,
                                        role: "presentation",
                                        alt: ""
                                    }),
                                    copyIcon ? staticText.copyLinkIndication : staticText.copyLink
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "social-share__cta social-share__email",
                                "aria-label": "".concat(staticText.email, " ").concat(staticText.openNewTabText),
                                onKeyDown: ()=>onClose(),
                                ref: emailBtnRef,
                                href: (0,helper/* sanitizeUrl */.Nmg)("mailto:?body=".concat((mailBody ? mailBody : "") + link).concat(mailSubject ? "&subject=" + mailSubject : "")),
                                target: "_blank",
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: socialShareEmailIconPath.current,
                                        role: "presentation",
                                        alt: ""
                                    }),
                                    staticText.email
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var v1_SocialShare = (SocialShare);


/***/ }),

/***/ 36130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87099);
/* harmony import */ var _components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const AutoSuggestion = (param)=>{
    let { id , borderValue , placeholderLabel , prefix , suffix , optionList , ariaLabel , selectedValue , iconAnalyticsdata , handleSelect , handleChange , onEnterKeyPress , allowSubmitOnEnter  } = param;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getInputVal = (item)=>{
        handleChange(item);
        setIsOpen(true);
    };
    const onKeyDown = (e)=>{
        if (e.key === "Enter" && allowSubmitOnEnter) {
            onEnterKeyPress();
        }
    };
    const getSuggestionVal = (item)=>{
        handleSelect(item);
        setIsOpen(false);
    };
    document.addEventListener("click", function(e) {
        var ref;
        if (setIsOpen && !((ref = document.getElementById("".concat(id, "-wrapper"))) === null || ref === void 0 ? void 0 : ref.contains(e.target))) setIsOpen(false);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().autoSuggetionWrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "auto-suggestion",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "auto-suggestion__input-container ".concat(borderValue === "bottom" ? "auto-suggestion__border-bottom" : "auto-suggestion__border-all"),
                        children: [
                            prefix !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "auto-suggestion__input-field-prefix",
                                children: prefix
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "text",
                                className: "auto-suggestion__input",
                                placeholder: placeholderLabel,
                                value: selectedValue,
                                onChange: (e)=>getInputVal(e.target.value),
                                "aria-label": ariaLabel,
                                onKeyDown: (e)=>onKeyDown(e),
                                onBlur: ()=>setIsOpen(false)
                            }),
                            suffix !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "auto-suggestion__input-field-suffix " + (iconAnalyticsdata ? "gbh-data-layer" : ""),
                                "data-gbh-data-layer": iconAnalyticsdata || null,
                                children: suffix
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "auto-suggestion__dropdown ".concat(isOpen ? " active" : ""),
                        children: (optionList === null || optionList === void 0 ? void 0 : optionList.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "auto-suggestion__dropdown-items",
                            children: optionList.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    onMouseDown: ()=>getSuggestionVal(item),
                                    className: "auto-suggestion__dropdown-item",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "auto-suggestion__dropdown-item-value",
                                        children: item
                                    })
                                }, i))
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AutoSuggestion);


/***/ }),

/***/ 27221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_Highlight_Highlight__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(293);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57333);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27514);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47956);
/* harmony import */ var _components_productCard_v1_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41740);
/* harmony import */ var _kohler_dsm_library_kohler_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81962);










const ProductCardView = (param)=>{
    let { i18n , product , currencySign , presetConfigs , swatchUrl , parent , title , brandName , skuId , general , analyticsData , newTab =false  } = param;
    var ref;
    const { COMPONENT  } = _constants_index__WEBPACK_IMPORTED_MODULE_6__["default"];
    const [productCardWidth, setProductCardWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [pdpNavigationURL, setPdpNavigationURL] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const productCardRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const presetConfigObject = presetConfigs ? JSON.parse(presetConfigs) : {};
    const { width  } = (0,_kohler_dsm_library_kohler_core__WEBPACK_IMPORTED_MODULE_8__/* .useWindowSize */ .i)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setProductCardWidth(productCardRef.current.clientWidth);
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getPDPUrl */ .ir5)(product === null || product === void 0 ? void 0 : product.productCategory, product === null || product === void 0 ? void 0 : product.slug).then((ret)=>skuId ? setPdpNavigationURL("".concat(ret, "?skuId=").concat(skuId)) : setPdpNavigationURL(ret));
    }, [
        product
    ]);
    const formatUrl = (uUrl, iWidth)=>{
        if (!uUrl.includes("data:image")) {
            var ref;
            const sUrlPath = (ref = uUrl.split("?")[0]) === null || ref === void 0 ? void 0 : ref.split("/");
            const sUrlId = sUrlPath[sUrlPath.length - 1];
            let sPreset = "";
            if (iWidth <= 167) {
                var ref1;
                sPreset = (ref1 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobileLandscape) !== null && ref1 !== void 0 ? ref1 : "";
            } else if (iWidth <= 458) {
                var ref2;
                sPreset = (ref2 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.Desktop) !== null && ref2 !== void 0 ? ref2 : "";
            } else {
                var ref3;
                sPreset = (ref3 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobilePortrait) !== null && ref3 !== void 0 ? ref3 : "";
            }
            if (parent === COMPONENT.PAIRS_WELL_WITH) {
                return "".concat(swatchUrl).concat(presetConfigObject.PotraitCategory, "?&product_src=is{PAWEB/").concat(sUrlId, "}&").concat(sPreset);
            }
            return "".concat(swatchUrl).concat(presetConfigObject.PotraitCategory, "?$product_src=is{PAWEB/").concat(sUrlId, "}&?").concat(sPreset);
        }
        return uUrl;
    };
    const getProductName = ()=>{
        if (!parent && title) {
            return title;
        }
        return brandName || product.name || product.description;
    };
    var _price;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: productCardRef,
        className: "product-card",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            prefetch: false,
            href: pdpNavigationURL,
            target: newTab ? "_blank" : "_self",
            "aria-label": "".concat(product.name, " ").concat(currencySign + product.price, " ").concat((ref = product.colors) === null || ref === void 0 ? void 0 : ref.length, " ").concat(i18n.ariaLabelColor),
            className: "product-card__link gbh-data-layer",
            "data-gbh-clickable": "true",
            "data-gbh-data-layer": analyticsData,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-card__img-container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(presetConfigs) ? formatUrl(product.images, productCardWidth) : product.images,
                        className: "product-card__img",
                        alt: ""
                    })
                }),
                !(product === null || product === void 0 ? void 0 : product.noBadge_b) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-card__details",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "product-card__left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__shipping-status",
                            children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getAvailabilityLabel */ .F3C)(product.stockBadge, general)
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "product-card__left",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    className: "product-card__name".concat(!parent ? " default" : ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Highlight_Highlight__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        text: getProductName()
                                    })
                                }),
                                product.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "product-card-desc",
                                    children: product.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "product-card__right",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "product-card__price".concat(!parent ? " default" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_9__/* .NumericFormat */ .h3, {
                                            value: product.discountedPrice > 0 ? product.discountedPrice : product.price,
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "product-card__price-unit",
                                            children: " ".concat(product.priceType)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: product.discountedPrice !== product.price && product.discountedPrice > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "product-card__discount-price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_9__/* .NumericFormat */ .h3, {
                                            value: (_price = product.price) !== null && _price !== void 0 ? _price : 0,
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                width > 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-card__details",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "product-card__left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__color-text",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: product.colors.length > 1 ? "".concat(product.colors.length, " ").concat(i18n.recentlyViewedColors) : "1 ".concat(i18n.recentlyViewedColor)
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCardView);


/***/ }),

/***/ 75185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27514);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72433);


const useFindashowroomi18n = (dataProps)=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const i18n = {
        backToTop: t("kf.plp.label.backToTop"),
        readArticleText: t("kf.plp.label.readArticle"),
        loadMore: t("kf.plp.label.loadMore"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        items: t("kf.plp.label.items"),
        mostPopular: t("kf.plp.label.mostPopular"),
        userMyLocation: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.userMyLocation) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.userMyLocation : t("kf.findstore.label.userMyLocation"),
        kohlerStores: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.kohlerStores) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.kohlerStores : t("kf.findstore.label.kohlerStores"),
        showrooms: t("kf.findstore.label.showrooms"),
        kohlerStore: t("kf.findstore.label.kohlerStore"),
        annsacksShowroom: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.annsacksShowroom) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.annsacksShowroom : t("kf.findstore.label.annsacksShowroom"),
        ctaLink: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.ctaLink) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.ctaLink : "",
        ctaLabel: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.ctaLabel) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.ctaLabel : t("kf.findstore.label.browseAllStore"),
        isNewTab: dataProps === null || dataProps === void 0 ? void 0 : dataProps.isNewTab,
        partsDealer: t("kf.findstore.label.partsDealer"),
        homeCenter: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.homeCenter) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.homeCenter : t("kf.findStore.label.homeCenter"),
        genuinePartsDealers: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.tabTitleTab3) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.tabTitleTab3 : t("kf.findstore.label.genuinePartsDealers"),
        kohler: t("kf.findStoreUtilNav.label.kohler"),
        annSacks: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.annSacks) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.annSacks : t("kf.findstore.label.annSacks"),
        annSacksText: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.annSacksText) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.annSacksText : t("kf.findstore.label.annSacksText"),
        countryPlaceholder: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.searchPlaceholder) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.searchPlaceholder : t("kf.findstore.label.countryPlaceholder"),
        locationErrormessage: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.subCopy) ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oOy)(dataProps === null || dataProps === void 0 ? void 0 : dataProps.subCopy) : t("kf.findstore.label.locationErrormessage"),
        clearAll: t("kf.plp.label.clearAll"),
        viewList: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.viewList) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.viewList : t("kf.findstore.label.viewList"),
        viewMap: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.viewMap) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.viewMap : t("kf.findstore.label.viewMap"),
        applyFilters: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.applyFilters) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.applyFilters : t("kf.findstore.label.applyFilters"),
        filters: t("kf.plp.label.filters"),
        filterSort: t("kf.plp.label.filterSort"),
        viewStoreDetail: t("kf.findStoreUtilNav.label.viewStoreDetail"),
        storeDetail: t("kf.findStoreUtilNav.label.storeDetail"),
        viewShowroomDetails: t("kf.findStoreUtilNav.label.viewShowroomDetails"),
        miles: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.miles) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.miles : t("kf.findstore.label.miles"),
        away: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.away) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.away : t("kf.findstore.label.away"),
        browseAllStore: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.browseAllStore) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.browseAllStore : t("kf.findstore.label.browseAllStore"),
        setAsMyStore: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.preferredStoreLabel) || t("kf.findStoreUtilNav.label.setAsMystore"),
        setAsMyShowroom: t("kf.findStoreUtilNav.label.setAsMyShowroom"),
        home: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.home) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.home : t("kf.findstore.label.home"),
        findStore: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.findstore) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.findstore : t("kf.findstore.label.findstore"),
        kohlerStoreImgAlt: t("kf.findstore.label.kohlerStoreImgAlt"),
        annsacksShowroomImgAlt: t("kf.findstore.label.annsacksShowroomImgAlt"),
        viewResults: t("kf.plp.label.viewResults"),
        view: t("kf.plp.label.view"),
        results: t("kf.plp.label.results"),
        filterImgAlt: t("kf.findstore.label.filterImgAlt"),
        myStore: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.preferredStoreLabel) || t("kf.findStoreUtilNav.label.myStore"),
        retailStore: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.retailStore) ? dataProps === null || dataProps === void 0 ? void 0 : dataProps.retailStore : t("kf.findstore.label.retailStore"),
        retailMobileText: t("kf.findstore.label.retailMobileText"),
        MessageZipcode: t("kf.findStoreUtilNav.MessageZipcode"),
        messageTitleZipcode: t("kf.findStoreUtilNav.messageTitleZipcode"),
        continue: t("kf.checkout.label.continue"),
        expanded: t("kf.productTab.aria.expanded"),
        collapsed: t("kf.productTab.aria.collapsed"),
        searchHeader: t("kf.findstore.label.searchHeader"),
        locationDescription: t("kf.findStoreUtilNav.label.locationDescription"),
        zipCodeContent: t("kf.findStoreUtilNav.label.zipCodeContent"),
        NotYourStore: t("kf.findStoreUtilNav.label.NotYourStore"),
        enterCityStateZip: t("kf.findStoreUtilNav.label.enterStateCityZipCode"),
        submit: t("kf.findStoreUtilNav.label.submit") !== "kf.findStoreUtilNav.label.submit" ? t("kf.findStoreUtilNav.label.submit") : "Submit",
        viewAllStore: t("kf.findStoreUtilNav.label.viewAllStore"),
        storeDetail: t("kf.findStoreUtilNav.label.storeDetail"),
        setAsMyStore: t("kf.findStoreUtilNav.label.setAsMystore"),
        myStore: t("kf.findStoreUtilNav.label.myStore"),
        closestStore: t("kf.findStoreUtilNav.label.closestStore"),
        ariaLabel: {
            enterZipcode: t("kf.findStoreUtilNav.aria.label.enterZipCode"),
            showFilter: t("kf.findstore.aria.label.showFilter"),
            hideFilter: t("kf.findstore.aria.label.hideFilter"),
            browseAll: t("kf.findstore.aria.label.browseAll"),
            contact: (phone)=>t("kf.findStore.aria.label.contact", {
                    phone
                }),
            mapMarker: t("kf.findstore.aria.label.mapMarker"),
            mapGuidelines: t("kf.findstore.aria.label.mapGuidelines"),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page")
        },
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            })
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useFindashowroomi18n);


/***/ }),

/***/ 32908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72433);

const useProductListi18n = ()=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        noResultsMssg: t("kf.plp.label.noResultsMssg")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useProductListi18n);


/***/ }),

/***/ 55631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        searchBrand: t("kf.search.label.searchBrand"),
        popularSearchText: t("kf.search.label.popularSearch"),
        topProductResults: (category)=>category !== "products" ? t("kf.search.label.topResults") : t("kf.search.label.topProductResults"),
        recentSearches: t("kf.search.label.recentSearch"),
        clearAll: t("kf.search.label.clearAll"),
        see: t("kf.search.label.see"),
        all: t("kf.search.label.all"),
        resultText: t("kf.search.label.resultsCaps"),
        searchCTA: t("kf.search.label.searchCTA"),
        top: t("kf.search.label.top"),
        product: t("kf.search.label.products"),
        topResult: t("kf.search.label.topResults"),
        saleText: t("kf.search.label.topResults"),
        colors: t("kf.search.label.colors"),
        color: t("kf.search.label.color"),
        brand: t("kf.search.label.brand"),
        new: t("kf.search.label.new"),
        sale: t("kf.search.label.sale"),
        topSuggestions: t("kf.search.label.topSuggestions"),
        yourSearch: t("kf.search.label.yourSearch"),
        seeAll: t("kf.search.label.seeAll"),
        results: t("kf.search.label.resultsCaps"),
        searchHeader: t("kf.search.label.searchHeader"),
        resultsCaps: t("kf.search.label.resultsCaps"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        favRemoveSuccessMsg: t("kf.favorites.removeItem"),
        favRemoveErrorMsg: t("kf.favorites.removeItemError"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: t("kf.compare.validation.maxProducts"),
        addToCompare: t("kf.plp.label.addToCompare"),
        onSale: t("kf.plp.label.onSale"),
        ariaLabel: {
            close: t("kf.search.aria.label.close"),
            delete: (keyword)=>t("kf.search.aria.label.delete", {
                    keyword
                }),
            continue: t("kf.global.aria.label.continue"),
            addToCompare: (product)=>t("kf.plp.label.aria.addToCompare", {
                    product
                })
        },
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        globalHome: t("kf.global.label.home"),
        perBox: t("annsacks.pdpProductSummary.label.perBox"),
        perEach: t("annsacks.pdpProductSummary.label.perEach"),
        perSF: t("annsacks.pdpProductSummary.label.perSF"),
        perLF: t("annsacks.pdpProductSummary.label.perLF")
    };
};


/***/ }),

/***/ 82423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": function() { return /* binding */ getStoreEventInfo; },
/* harmony export */   "CS": function() { return /* binding */ zipCodeInfoModalContinueAnalytics; },
/* harmony export */   "DO": function() { return /* binding */ addFindAStoreAnalytics; },
/* harmony export */   "HS": function() { return /* binding */ locationMessageNavigationAnalytics; },
/* harmony export */   "LX": function() { return /* binding */ setStoreAnalytics; },
/* harmony export */   "OQ": function() { return /* binding */ addAnalyticsData; },
/* harmony export */   "Us": function() { return /* binding */ getFilterEventInfo; },
/* harmony export */   "X1": function() { return /* binding */ addAnalyticsEvent; },
/* harmony export */   "dm": function() { return /* binding */ getEventClearFilterInfo; },
/* harmony export */   "hE": function() { return /* binding */ getEventStoreFilterInfo; },
/* harmony export */   "pm": function() { return /* binding */ findAStoreLoadMoreAnalytics; },
/* harmony export */   "rt": function() { return /* binding */ getEventStorePhoneInfo; },
/* harmony export */   "wo": function() { return /* binding */ addFilterExpandCollapseAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27514);

const pageType = "find a store";
const addFindAStoreAnalytics = (params)=>{
    const { total , errorMessage , status , action , authorData , staticTexts , searchTerm , geolocationEvent  } = params;
    const errMsg = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(authorData.locationErrormessage ? authorData.locationErrormessage : staticTexts.locationErrormessage);
    let eventAction = "find a store:landing:location info:store search";
    let eventName = "find a store:landing:location info:store search";
    const eventStatus = status === "success" && total ? "success" : "failure";
    let internalLinkName = "store search";
    let internalLinkZoneName = "find a store:landing:location info:filters";
    if (geolocationEvent) {
        eventAction = "find a store:utility nav​:view store details:use my location";
        eventName = "find a store:utility nav​:view store details:use my location";
        internalLinkName = "use my location";
        internalLinkZoneName = "find a store:utility nav";
    }
    const currDate = new Date();
    const eventInfo = {
        searchCount: sessionStorage.getItem("findStores") ? Number(sessionStorage.getItem("findStores")) + 1 : 1,
        searchResult: total,
        internalLinkName,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:navigation",
        searchType: isNaN(searchTerm) || geolocationEvent ? "location" : "zipcode",
        searchTerm: searchTerm,
        eventAction,
        eventName,
        eventType: "navigation",
        clickInternalLinks: "true",
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName,
        eventMsg: status === "success" && total ? "n/a" : errorMessage || errMsg || "n/a",
        eventStatus,
        pageName: "find a store result",
        pageURL: window.location.href,
        referrer: document.referrer || "n/a",
        previousPage: document.referrer || "n/a",
        timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0]
    };
    if (action === "cmp:show" && !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .isShowAnalyticsEventLoaded */ .xJ2)() || action !== "cmp:show") {
        sessionStorage.setItem("findStores", eventInfo.searchCount);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const event = !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .isShowAnalyticsEventLoaded */ .xJ2)() ? "cmp:show" : action;
        const page = event === "cmp:show" ? window.pageObj : getState && getState("page") || {};
        if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .navigationType */ .UsO)() !== 1 && event === "cmp:show" || event === "cmp:click") {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, event, page);
        }
        delete window.pageObj;
    }
};
const findAStoreLoadMoreAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:load more results",
        eventMsg: "n/a",
        eventName: "find a store:landing:location info:load more results",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "load more results",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:load more results",
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:location info"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const getFilterEventInfo = (showFilter)=>{
    const type = showFilter ? "show filter" : "hide filter";
    const internalLinkType = "find a store:".concat(showFilter ? "show" : "hide");
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:".concat(type),
        eventName: "find a store:landing:location info:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(type, "s"),
        internalLinkPosition: "find a store",
        internalLinkType,
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:filters"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const getStoreEventInfo = (type, internalLinkName, link)=>{
    return JSON.stringify({
        eventAction: "find a store:landing:location info:" + type,
        eventName: "find a store:landing:location info:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName ? internalLinkName.toLowerCase() : type,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:navigation",
        internalLinkZoneName: "find a store:landing:location info",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    });
};
const getEventStoreFilterInfo = (data, type, link)=>{
    let internalLinkName;
    let internalLinkType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(data.LocationName);
    const internalLinkTypeForFindStore = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getInternalLinkTypeForFindStore */ .dhb)(data.LocationName, data.Locality, data.StateLong);
    if (type === "store name") {
        internalLinkName = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(data.LocationName);
        internalLinkType = "find a store:".concat(internalLinkTypeForFindStore);
    } else if (type === "store contact number") {
        internalLinkName = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .formatPhoneNumber */ .unW)(data.Phone);
        internalLinkType = "find a store:navigation";
    } else if (type === "set as preferred store" || type === "unset as preferred store") {
        internalLinkType = "find a store:".concat(internalLinkTypeForFindStore);
    }
    return JSON.stringify({
        eventAction: "find a store:landing:location info:".concat(type),
        eventName: "find a store:landing:location info:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName || type,
        internalLinkPosition: "find a store",
        internalLinkType,
        internalLinkZoneName: "find a store:landing:location info​",
        internalLinkURL: link ? (type !== "store contact number" && link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    });
};
const getEventStorePhoneInfo = (PhoneNumber, tabTitle, link)=>{
    const internalLinkPhoneType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .formatPhoneNumber */ .unW)(PhoneNumber);
    const eventInfo = {
        eventAction: "find a store:landing:location info:".concat(internalLinkPhoneType),
        eventName: "find a store:landing:location info:".concat(internalLinkPhoneType),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkPhoneType,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(tabTitle === null || tabTitle === void 0 ? void 0 : tabTitle.toLowerCase()),
        internalLinkZoneName: "find a store:landing:location info​",
        internalLinkURL: internalLinkPhoneType === null ? link || "n/a" : "tel:".concat(PhoneNumber),
        clickInternalLinks: "true"
    };
    window === null || window === void 0 ? void 0 : window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo
    });
};
const addAnalyticsData = (curFilters, isChecked, obj, isFilterCancel)=>{
    const { facet , value: label  } = obj;
    const filterLabel = label || obj.display;
    const appliedOrRemoved = isFilterCancel ? "cancel" : isChecked ? "applied" : "removed";
    const eventInfo = {
        eventAction: "find a store:landing:filters:".concat(appliedOrRemoved),
        eventName: "find a store:landing:filters:".concat(appliedOrRemoved),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(filterLabel === null || filterLabel === void 0 ? void 0 : filterLabel.toLowerCase(), ":").concat(appliedOrRemoved),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(facet === null || facet === void 0 ? void 0 : facet.toLowerCase()),
        filterArray: "".concat((facet === null || facet === void 0 ? void 0 : facet.toLowerCase()) + ":" + (filterLabel === null || filterLabel === void 0 ? void 0 : filterLabel.toLowerCase())),
        internalLinkZoneName: "find a store:landing:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    let filterArray = "";
    if (curFilters.length > 0) {
        curFilters.forEach((facetObj)=>{
            facetObj.value.forEach((facetValue)=>{
                filterArray += facetObj.facet.toLowerCase() + ":" + facetValue.toLowerCase() + "|";
            });
        });
    }
    eventInfo.filterArray = filterArray === null || filterArray === void 0 ? void 0 : filterArray.slice(0, -1);
    if (window.adobeDataLayer) {
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    }
};
const addFilterExpandCollapseAnalytics = (facet, formatFacetName, collapse)=>{
    const collapseOrExpand = collapse[facet] ? "expand" : "collapse";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:filters:".concat(collapseOrExpand),
        eventName: "find a store:landing:filters:".concat(collapseOrExpand),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(collapseOrExpand),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(formatFacetName === null || formatFacetName === void 0 ? void 0 : formatFacetName.toLowerCase()),
        internalLinkURL: "n/a",
        internalLinkZoneName: "find a store:landing:filters​"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const getEventClearFilterInfo = ()=>{
    return JSON.stringify({
        eventAction: "find a store:landing:filters:clear all",
        eventName: "find a store:landing:filters:clear all",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "clear all",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:filters",
        internalLinkZoneName: "find a store:landing:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const addAnalyticsEvent = function(action) {
    let isForLocateMe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const type = isForLocateMe ? "" : "zoom ";
    const linkType = isForLocateMe ? "navigation" : "zoom";
    const eventInfo = {
        eventAction: "find a store:landing:map:".concat(type).concat(action),
        eventName: "find a store:landing:map:".concat(type).concat(action),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(type).concat(action),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(linkType),
        internalLinkZoneName: "find a store:landing:map",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const setStoreAnalytics = (checked, locationName)=>{
    const type = checked ? "set as preferred store" : "unset as preferred store";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:".concat(type),
        eventMsg: "n/a",
        eventName: "find a store:landing:location info:".concat(type),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: type,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(locationName === null || locationName === void 0 ? void 0 : locationName.toLowerCase()),
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:location info"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const zipCodeInfoModalContinueAnalytics = (ctaLabel, dataLayerPosition)=>{
    const label = ctaLabel === null || ctaLabel === void 0 ? void 0 : ctaLabel.toLowerCase();
    let eventName = "find a store:utility nav:view store details:".concat(label);
    let internalLinkPosition = "find a store";
    let internalLinkType = "find a store:navigation";
    let internalLinkZoneName = "find a store:modal:cant access your location";
    if (dataLayerPosition === "global header") {
        eventName = "find a store:utility nav:use my location:".concat(label);
        internalLinkPosition = "global header:find a store";
    }
    if (dataLayerPosition === "find a pro") {
        eventName = "find a pro:see local professionals:use my location:".concat(label);
        internalLinkPosition = "find a pro";
        internalLinkType = "find a pro:use my location";
        internalLinkZoneName = "find a pro:see local professionals";
    }
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: eventName,
        eventMsg: "n/a",
        eventName,
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(label),
        internalLinkPosition,
        internalLinkType,
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const locationMessageNavigationAnalytics = (param)=>{
    let { link ="" , label ="" , zone =""  } = param;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(zone, ":").concat(label),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(zone, ":").concat(label),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: label,
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkURL: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getAnalyticsUrl */ .Uho)(link),
        internalLinkZoneName: "".concat(pageType, ":").concat(zone)
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};


/***/ }),

/***/ 75058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getFindAStoresResult; },
/* harmony export */   "T": function() { return /* binding */ getAutoSuggestionsInputBased; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);

const getFindAStoresResult = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", address = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", brand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", disMiles = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 100, maxStorePerPage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 10, locationType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", page = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1, sku = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
    const params = {
        address,
        brand: brand.toLowerCase(),
        disMiles,
        maxItemPerPage: maxStorePerPage,
        locationType: locationType.toLowerCase(),
        page
    };
    if (sku) params["sku"] = sku;
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url, {
        params
    });
};
const getAutoSuggestionsInputBased = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", brand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", input = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url, {
        params: {
            $format: "json",
            brand: brand.toLowerCase(),
            $select: "Locality",
            $filter: "StartsWith(Locality,'".concat(input, "') eq true")
        }
    });
};


/***/ }),

/***/ 38224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ headerFindStoreUseLocationAnalytics; },
/* harmony export */   "c": function() { return /* binding */ addFindStoreAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27514);

const addFindStoreAnalytics = (zipCodeValue, zipCodeError)=>{
    const { show , message  } = zipCodeError;
    const eventMsg = show ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a";
    const eventStatus = show ? "failure" : "success";
    const eventInfo = {
        eventAction: "find a store:utility nav:submit",
        eventName: "find a store:utility nav:submit",
        eventType: "navigation",
        eventMsg,
        eventStatus,
        internalLinkName: "submit",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(zipCodeValue !== null && zipCodeValue !== void 0 ? zipCodeValue : ""),
        internalLinkZoneName: "find a store:utility nav",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const headerFindStoreUseLocationAnalytics = (param)=>{
    let { errorMessage ="" , staticTexts ={} , eventStatus =""  } = param;
    const eventMsg = errorMessage ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(errorMessage ? errorMessage : staticTexts.locationErrormessage) : "n/a";
    const eventInfo = {
        eventAction: "find a store:utility nav:use my location",
        eventName: "find a store:utility nav:use my location",
        eventType: "navigation",
        eventMsg,
        eventStatus,
        internalLinkName: "use my location",
        internalLinkPosition: "global header:find a store",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};



/***/ }),

/***/ 50288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        useLocation: t("kf.findStoreUtilNav.label.useLocation"),
        viewAllStore: t("kf.findStoreUtilNav.label.viewAllStore"),
        submit: t("kf.global.label.submit"),
        findStore: t("kf.findStoreUtilNav.label.findStore"),
        closestStore: t("kf.findStoreUtilNav.label.closestStore"),
        kohlerText: t("kf.findStoreUtilNav.label.kohler"),
        signStore: t("kf.findStoreUtilNav.label.signStore"),
        NotYourStore: t("kf.findStoreUtilNav.label.NotYourStore"),
        viewStoreDetail: t("kf.findStoreUtilNav.label.viewStoreDetail"),
        storeDetail: t("kf.findStoreUtilNav.label.storeDetail"),
        setAsMyStore: t("kf.findStoreUtilNav.label.setAsMystore"),
        myStore: t("kf.findStoreUtilNav.label.myStore"),
        myStoreText: t("kf.findStoreUtilNav.label.myStoreText"),
        locationDescription: t("kf.findStoreUtilNav.label.locationDescription"),
        zipCodeContent: t("kf.findStoreUtilNav.label.zipCodeContent"),
        closeAlt: t("kf.findStoreUtilNav.label.closeAlt"),
        menu: t("kf.findStoreUtilNav.label.menu"),
        leftArrow: t("kf.findStoreUtilNav.label.leftArrow"),
        enterZipCode: t("kf.findStoreUtilNav.label.enterZipCode"),
        zipcode: t("kf.findStoreUtilNav.zipcode"),
        validZipcode: t("kf.findStoreUtilNav.validZipcode"),
        MessageZipcode: t("kf.findStoreUtilNav.MessageZipcode"),
        infoModalTitle: t("kf.findStoreUtilNav.messageTitleZipcode"),
        zipcodeEmptyError: t("kf.findStoreUtilNav.zipcodeEmptyError"),
        continue: t("kf.checkout.label.continue"),
        ariaLabel: {
            enterZipCode: t("kf.findStoreUtilNav.aria.label.enterZipCode"),
            submit: t("kf.findStoreUtilNav.aria.label.submit")
        },
        enterCityStateZip: t("kf.findStoreUtilNav.label.countryPlaceholder")
    };
};


/***/ }),

/***/ 91960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ entityToCharacter; },
/* harmony export */   "f": function() { return /* binding */ redirectionToContentPage; }
/* harmony export */ });
const entityToCharacter = (str)=>{
    return str === null || str === void 0 ? void 0 : str.replace(/&amp;/g, "&");
};
const redirectionToContentPage = ()=>{
    if (window.location.href.includes("#")) {
        const hashString = window.location.href.split("#");
        if (hashString) {
            const cleanUrl = window.location.href.split("#")[0];
            window.history.replaceState(null, "", cleanUrl);
        }
    }
    window.scrollTo({
        top: 1,
        behavior: "smooth"
    });
};



/***/ }),

/***/ 96005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2583);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_ProductSocialShare__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11059);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27514);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20558);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88751);












const PartsViewer = (param)=>{
    let { page ="" , i18n ={} , productId ="" , partId ="" , analyticsCustomData =null , onClose , showModal =false  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const [svgViewerPath, setSvgViewerPath] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [currencySign, setCurrencySign] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [general, setGeneral] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [plpServletPath, setPlpServletPath] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [salesChannelConfig, setSalesChannelConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)().then(async (config)=>{
            const svgViewerPath = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "general.svgViewerPath", ""));
            var ref;
            setSalesChannelConfig((ref = config === null || config === void 0 ? void 0 : config.salesChannelConfig) !== null && ref !== void 0 ? ref : {});
            const currencySign = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "internationalization.currencySign", "");
            setCurrencySign(currencySign);
            setSvgViewerPath(svgViewerPath);
            setGeneral(config.general);
            setPlpServletPath(config.plpServletPath);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showModal) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .preventBodyScroll */ .MVu)(true);
        }
    }, [
        showModal
    ]);
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getUserPersona */ .shu)();
    const [showShare, setShowShare] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getPDPUrlForViewer = (category, slug)=>{
        const pdpdUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getPDPUrlWithConfig */ .Upy)(category, slug, plpServletPath, general);
        return pdpdUrl;
    };
    const addToCartTrigger = async (data)=>{
        const actions = [];
        data.forEach((product)=>{
            var ref;
            const fields = {
                salesChannel: (ref = salesChannelConfig[product === null || product === void 0 ? void 0 : product.brand]) !== null && ref !== void 0 ? ref : "KOUS"
            };
            actions.push({
                action: product.isBundle ? "addbundle" : "addLineItem",
                sku: product.sku,
                quantity: product.quantity,
                custom: {
                    type: {
                        key: "lineItemShipping"
                    },
                    fields: fields
                }
            });
        });
        const reqData = {};
        reqData["actions"] = actions;
        const cartObj = dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__/* .searchPlp */ .tK)(reqData)).unwrap().then((res)=>{
            const respVal = {};
            respVal.status = 200;
            return respVal;
        }).catch((err)=>{
            const respVal = {};
            respVal.status = 500;
            return respVal;
        }) || {};
        return cartObj;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (currencySign !== "" && persona && plpServletPath && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(general)) {
            var ref;
            window.partViewer = {
                atc: addToCartTrigger,
                getPDPUrl: getPDPUrlForViewer,
                persona,
                currencySign,
                setShowShare
            };
            (ref = iframeRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            return ()=>(0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .preventBodyScroll */ .MVu)(false);
        }
    }, [
        currencySign,
        persona,
        general
    ]);
    const filename = (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .getExtention */ .fN)(partId) ? partId : partId + ".svg";
    const closeModal = ()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .preventBodyScroll */ .MVu)(false);
        onClose();
    };
    const getPartDiagramCloseEventInfo = JSON.stringify({
        eventAction: page + ":modal:interactive parts diagram:close",
        eventName: page + ":modal:interactive parts diagram:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: page + ":close",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_6__["default"], {
        showModal: showModal,
        onModalClose: closeModal,
        closeButtonAnalytics: getPartDiagramCloseEventInfo,
        analyticsCustomData: analyticsCustomData || null,
        children: [
            svgViewerPath && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                id: "svg-viewer-iframe",
                ref: iframeRef,
                allowFullScreen: true,
                scrolling: "auto",
                src: "".concat(svgViewerPath, "?productId=").concat(productId, "&filename=").concat(filename, "&diagram=0&origin=").concat(window.location.href)
            }),
            showShare && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PartSocialShare, {
                showShare: showShare,
                setShowShare: setShowShare,
                iframeId: "svg-viewer-iframe",
                i18n: i18n,
                iframeRef: iframeRef.current
            })
        ]
    });
};
const PartSocialShare = (param)=>{
    let { showShare , setShowShare , iframeId , i18n , iframeRef  } = param;
    return /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_ProductSocialShare_v1_ProductSocialShare__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        showModal: showShare,
        id: "social-share-iframe",
        onClose: ()=>setShowShare(false),
        iframeId: iframeId,
        iframeRef: iframeRef,
        disableInstagram: true,
        mailSubject: i18n.mailSubject,
        mailBody: i18n.mailBody
    }), iframeRef.contentDocument.getElementById("social-share-gbh"));
};
/* harmony default export */ __webpack_exports__["Z"] = (PartsViewer);


/***/ }),

/***/ 22644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v3_ProductAccordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/core/Collapsible/index.js
var Collapsible = __webpack_require__(73394);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
// EXTERNAL MODULE: ./public/icons/arrow-down.svg
var arrow_down = __webpack_require__(32873);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/ProductAccordion/ProductAccordion.view.js







const getStableAccordionId = (prefix, value)=>"".concat(prefix, "-").concat(value).replace(/[^a-zA-Z0-9_-]/g, "-");
const Accordion = (props)=>{
    const { isOpen =false , contentOverflow =false , trigger =false , handleOpen =()=>{} , handleClose =()=>{} , containerElementProps , isArrow =false , items , itemsOrder , id , titleKey , componentPosition , componentLinkType , accordionProperties: { expandedItems  } = {}  } = props;
    const getDefaultOpenItems = ()=>Array.isArray(expandedItems) ? expandedItems : isOpen ? [
            ...itemsOrder || []
        ] : [];
    const [openItems, setOpenItems] = (0,react.useState)(getDefaultOpenItems);
    const [general, setGeneral] = (0,react.useState)(null);
    const accordiumObject = (0,react.useRef)(null);
    const pageType = window.eventPageType;
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(function() {
            let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        setOpenItems(getDefaultOpenItems());
    }, [
        expandedItems,
        isOpen,
        itemsOrder
    ]);
    const CollapsibleHeader = (param)=>{
        let { title , open =false  } = param;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("h2", {
            className: "cmp-accordion__header",
            "aria-label": title,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "cmp-accordion__button ".concat(open ? "cmp-accordion__button--expanded" : ""),
                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(componentPosition ? componentPosition : "accordion", '",\n        "internalLinkZoneName":"n/a","internalLinkURL":"n/a","internalLinkName":"').concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '",\n        "eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '",\n        "internalLinkType":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentLinkType ? componentLinkType : "navigation", '",\n        "eventType":"accordion",\n        "eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '"}'),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "cmp-accordion__title",
                        children: title
                    }),
                    !isArrow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-2"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "down-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_down/* default.src */.Z.src,
                                    alt: "Arrow Down"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "up-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_up/* default.src */.Z.src,
                                    alt: "Arrow Up"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    const CollapsibleInnerText = (param)=>{
        let { gridColumnClassName , faqText , isExpanded , title  } = param;
        const finalText = (0,helper/* sanitizeInnerHtml */.KD0)((0,helper/* getShortenedUrlwithGeneral */.vu1)(faqText, general));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-accordian-title": title,
            className: "cmp-accordion__panel".concat(isExpanded ? " cmp-accordion__panel--expanded" : " cmp-accordion__panel--hidden"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text ".concat(gridColumnClassName),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-text",
                    children: finalText
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        ref: accordiumObject,
        className: "cmp-accordion",
        "data-placeholder-text": "false",
        children: itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((item)=>{
            const title = items[item][titleKey];
            const itemId = getStableAccordionId("accordion-item", "".concat(id, "-").concat(item));
            const triggerId = getStableAccordionId("collapsible-trigger", "".concat(id, "-").concat(item));
            const contentId = getStableAccordionId("collapsible-content", "".concat(id, "-").concat(item));
            let gridColumnClassName = items[item]["appliedCssClassNames"];
            let faqText = items[item]["text"];
            if (!faqText) {
                faqText = "";
                const itemsOrderArr = items[item][":itemsOrder"];
                if (itemsOrderArr) {
                    itemsOrderArr.forEach((itemTx)=>{
                        faqText = "".concat(faqText).concat(items[item][":items"][itemTx]["text"]);
                        gridColumnClassName = "".concat(items[item][":items"][itemTx]["appliedCssClassNames"]);
                    });
                }
            }
            const isItemExpanded = openItems.includes(item);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-cmp-hook-accordion": "item",
                    className: "cmp-accordion__item",
                    id: itemId,
                    "data-cmp-data-layer": '{"'.concat(itemId, '":{"@type":"kohler-us/components/accordion/item","dc:title":"').concat(title, '"}}'),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* default */.Z, {
                        open: isItemExpanded,
                        onTriggerOpening: ()=>{
                            setOpenItems((prevItems)=>prevItems.includes(item) ? prevItems : [
                                    ...prevItems,
                                    item
                                ]);
                            handleOpen(item);
                        },
                        onTriggerClosing: ()=>{
                            setOpenItems((prevItems)=>prevItems.filter((prevItem)=>prevItem !== item));
                            handleClose(item);
                        },
                        containerElementProps: containerElementProps,
                        overflowWhenOpen: contentOverflow ? contentOverflow : "hidden",
                        openedClassName: "collapsible--open",
                        triggerOpenedClassName: "collapsible__trigger--open",
                        trigger: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title
                        }),
                        triggerWhenOpen: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title,
                            open: true
                        }),
                        transitionTime: 400,
                        easing: "ease-in-out",
                        tabIndex: "0",
                        triggerElementProps: {
                            id: triggerId
                        },
                        contentElementId: contentId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleInnerText, {
                            gridColumnClassName: gridColumnClassName,
                            faqText: faqText,
                            isExpanded: isItemExpanded,
                            title: title
                        })
                    })
                })
            }, itemId);
        })
    });
};
/* harmony default export */ var ProductAccordion_view = (Accordion);

;// CONCATENATED MODULE: ./src/components/ProductDetail/v3/ProductAccordion/index.jsx


const ProductAccordion = (props)=>{
    const { data: { accordionProperties ={} , componentLinkType =""  }  } = props;
    const { [":itemsOrder"]: itemsOrder , [":items"]: items , id  } = accordionProperties;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "accordion  ".concat(accordionProperties === null || accordionProperties === void 0 ? void 0 : accordionProperties.appliedCssClassNames, " productAccordionView"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion_view, {
            accordionProperties: accordionProperties,
            componentLinkType: componentLinkType,
            items: items,
            itemsOrder: itemsOrder,
            id: id,
            textKey: "text",
            titleKey: "cq:panelTitle"
        })
    });
};
/* harmony default export */ var v3_ProductAccordion = (ProductAccordion);


/***/ }),

/***/ 93575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15803);
/* harmony import */ var _components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27514);




const ProductsPerPage = (param)=>{
    let { data =[] , texts , page , onChange , totalResults , curRows =30 , pos ="top" , selectedTab  } = param;
    const getAnalyticsData = function() {
        let limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", all = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        limit = limit + "";
        let analyticsData = "";
        if (page === "search") {
            if (!all) {
                analyticsData = JSON.stringify({
                    eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: limit,
                    internalLinkPosition: "search results",
                    internalLinkType: "search results:pagination ".concat(pos),
                    internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            } else {
                analyticsData = JSON.stringify({
                    eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: texts.all,
                    internalLinkPosition: "search results",
                    internalLinkType: "search results:pagination ".concat(pos),
                    internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            }
        } else if (page === "technicalspecs") {
            if (!all) {
                analyticsData = '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' + pos + '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' + pos + '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "favorites") {
            if (!all) {
                analyticsData = JSON.stringify({
                    eventAction: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventName: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "".concat(limit),
                    internalLinkPosition: "favorites",
                    internalLinkType: "my account:pagination bottom",
                    internalLinkZoneName: "my account:favorites:".concat(selectedTab),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            } else {
                analyticsData = JSON.stringify({
                    eventAction: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventName: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "".concat(texts.all),
                    internalLinkPosition: "favorites",
                    internalLinkType: "my account:pagination bottom",
                    internalLinkZoneName: "my account:favorites:".concat(selectedTab),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            }
        } else if (page === "article") {
            analyticsData = JSON.stringify({
                eventAction: "support:help and faq:article list:pagination",
                eventName: "support:help and faq:article list:pagination",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: !all ? limit : texts.all,
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:pagination " + pos,
                internalLinkZoneName: "support:help and faq:article list",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        } else if (page === "literature") {
            if (!all) {
                analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "press-release") {
            if (!all) {
                analyticsData = '{"eventAction":"press room:press releases:pagination","eventName":"press room:press releases:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"press room","internalLinkType":"press room:press releases:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"press room:press releases:pagination","eventName":"press room:press releases:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"press room","internalLinkType":"press room:press releases:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "press-kits") {
            if (!all) {
                analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "blog") {
            const pageCount = !all ? limit : "all";
            const category = selectedTab ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(selectedTab) : "";
            const linkName = "view ".concat(pageCount);
            const blogCategory = category && category === "how tos" ? "how to's" : category;
            const linkUrl = "";
            const eventInfo = {
                clickInternalLinks: "true",
                eventAction: "blog listing:".concat(blogCategory, ":main content area:pagination"),
                eventName: "blog listing:".concat(blogCategory, ":main content area:pagination"),
                eventType: "navigation",
                internalLinkName: linkName ? linkName : "pagination",
                internalLinkPosition: "blogs listing",
                internalLinkType: "blog listing:navigation",
                internalLinkZoneName: "blog listing:".concat(blogCategory, ":main content area"),
                internalLinkURL: linkUrl ? linkUrl.indexOf("http") === -1 ? window.location.origin + linkUrl : linkUrl : "n/a"
            };
            analyticsData = JSON.stringify(eventInfo);
        } else {
            const internalLinkZoneName = pos === "top" ? '"plp:sticky nav filter"' : '"plp:promo tiles"';
            if (!all) {
                analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        }
        return analyticsData;
    };
    const checkPaginationPosition = (limit)=>{
        onChange(limit);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().productPerPageWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "products-per-page",
            children: totalResults > 30 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                role: "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "disabled",
                        "aria-hidden": true,
                        children: texts.view
                    }),
                    data.map((limit, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            "aria-disabled": curRows === limit,
                            role: "button",
                            tabIndex: "0",
                            "aria-label": "".concat(texts.view, " ").concat(limit, " ").concat(texts.items),
                            className: (curRows === limit && "disabled") + " gbh-data-layer",
                            "data-gbh-data-layer": getAnalyticsData(limit),
                            onClick: ()=>checkPaginationPosition(limit),
                            children: limit
                        }, i)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        role: "button",
                        tabIndex: "0",
                        "aria-label": "".concat(texts.view, " ").concat(texts.all, " ").concat(texts.items),
                        className: (curRows === totalResults && "disabled") + " gbh-data-layer",
                        "data-gbh-data-layer": getAnalyticsData("", true),
                        onClick: ()=>onChange(totalResults),
                        children: texts.all
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductsPerPage);


/***/ }),

/***/ 84744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getPromoData; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47956);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20558);




const getPromoData = async (link)=>{
    const finalData = (0,_constants_api__WEBPACK_IMPORTED_MODULE_0__/* .aemAxiosInstance */ .Gb)({
        url: _constants__WEBPACK_IMPORTED_MODULE_1__.GLOBAL_CONFIGURATION_ENDPOINT,
        params: {
            path: link + ".model.json"
        }
    }).then((res)=>{
        const dat = (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .recursiveDataFunction */ .Qe)(res === null || res === void 0 ? void 0 : res.data, _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === null || _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PROMOBANNER);
        return dat[0];
    }).catch((err)=>{
        console.log("Failed to get compare attributes JSON file", err);
    });
    return finalData;
};


/***/ }),

/***/ 82706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const GlobalPageLayout = (param)=>{
    let { header =null , footer =null , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            header,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                id: "main-content",
                tabIndex: "-1",
                children: children
            }),
            footer
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GlobalPageLayout);


/***/ }),

/***/ 99878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_MiniCart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/utils/cart.js
var cart = __webpack_require__(87292);
;// CONCATENATED MODULE: ./public/icons/cart-icon.svg
/* harmony default export */ var cart_icon = ({"src":"/_next/static/media/cart-icon.9accb288.svg","height":25,"width":25});
// EXTERNAL MODULE: ./public/icons/cart-icon-empty.svg
var cart_icon_empty = __webpack_require__(27644);
;// CONCATENATED MODULE: ./public/icons/cart-gray.svg
/* harmony default export */ var cart_gray = ({"src":"/_next/static/media/cart-gray.abab88ab.svg","height":20,"width":25});
;// CONCATENATED MODULE: ./public/icons/cart-filled.svg
/* harmony default export */ var cart_filled = ({"src":"/_next/static/media/cart-filled.4aa11106.svg","height":20,"width":25});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
;// CONCATENATED MODULE: ./src/components/Shared/MiniCart/v1/MiniCart.jsx










const MiniCart = (param)=>{
    let { eventHandler: { store: { cartCount , ariaLabel  } , callbacks: { onClick  }  } , checkoutPage  } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const getWidth = window.outerWidth === 0 ? window.innerWidth : lib/* isSafari */.G6 ? window.innerWidth : window.outerWidth;
    const [isMobile, setIsMobile] = (0,react.useState)((getWidth || width) <= 1200);
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        !checkoutPage ? setIsMobile((getWidth && width) <= 1200) : setIsMobile(false);
    }, [
        getWidth,
        width,
        checkoutPage
    ]);
    (0,react.useEffect)(()=>{
        (0,cart/* getCartLandingPagePath */.dZ)().then((res)=>{
            setCartUrl(res);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-indicator ".concat(cartCount > 0 && "cart-indicator__with-count"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: cartUrl,
            "aria-label": ariaLabel,
            role: "link",
            className: "gbh-data-layer",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat(cartUrl, '","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"cart icon","eventName":"cart icon","internalLinkType":"homepage:navigation","eventType":"global header","eventAction":"cart icon"}'),
            children: cartCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-indicator__count ".concat(cartCount < 100 && "cart-indicator__count--center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: isMobile ? cart_filled === null || cart_filled === void 0 ? void 0 : cart_filled.src : cart_icon === null || cart_icon === void 0 ? void 0 : cart_icon.src,
                        alt: "Cart"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: cartCount
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: isMobile ? cart_gray === null || cart_gray === void 0 ? void 0 : cart_gray.src : cart_icon_empty/* default.src */.Z.src,
                alt: "Cart"
            })
        })
    });
};
const checkForRerender = (prevProps, nextProps)=>{
    return nextProps.eventHandler.store.cartCount === prevProps.eventHandler.store.cartCount;
};
/* harmony default export */ var v1_MiniCart = (/*#__PURE__*/(0,react.memo)(MiniCart, checkForRerender));


/***/ }),

/***/ 81506:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const newsLetterBody = function(sBrandName, sEmailAddress) {
    let language = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en", additionalValues = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    const aValues = {
        AnnSacks: {
            "Subscribe Ann Sacks": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Ann Sacks"
        },
        Sterling: {
            "Subscribe Sterling Plumbing": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Sterling"
        },
        Kohler: {
            "Subscribe Kohler Kitchen and Bath": "TRUE",
            "Subscribe Kohler KB Website Interaction": "TRUE",
            "Kitchen Bath Recent Source": "Website Footer Email Signup_Kohler"
        },
        "kohler-canada": {
            "Subscribe Kohler Canada": "TRUE",
            "Kitchen Bath Recent Source": "Website Footer Email Signup_Canada_English",
            LanguagePref: language
        },
        Kallista: {
            "Subscribe Kallista": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Kallista"
        },
        Robern: {
            "Subscribe Sterling Plumbing": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Sterling"
        }
    };
    if (aValues[sBrandName]) {
        aValues[sBrandName]["EmailAddress"] = sEmailAddress;
        aValues[sBrandName]["Date Updated"] = new Date().toISOString();
    }
    if (additionalValues) {
        aValues[sBrandName] = {
            ...aValues[sBrandName],
            ...additionalValues
        };
    }
    const body = {
        keys: {
            SubscriberKey: sEmailAddress
        },
        values: aValues[sBrandName] || []
    };
    return [
        body
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (newsLetterBody);


/***/ }),

/***/ 11059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72433);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27514);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34147);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7__);








const ProductSocialShare = (props)=>{
    const { id ="" , url ="" , componentProp: { assetUrl ="" , url: compUrl = "" , showModal: componentPropShowModal = false  } = {} , disableInstagram =false , showModal =false , onClose =()=>{} , mailBody ="" , mailSubject ="" , isBundleProduct =""  } = props;
    const [sites, setSites] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const origin = window.location.origin;
    const emailBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const copyBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const shareBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const socialShareCopyIconPath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const socialShareEmailIconPath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const [config, setConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const brandName = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const { general ={} , socialMediaConfig: socialMediaConfigs = {}  } = config;
    const { hostUrl =""  } = general;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)().then(async (configData)=>{
            setConfig(configData);
            brandName.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(configData, "general.siteName", "");
            socialShareCopyIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(configData, "general.socialShareCopyIconPath", "");
            socialShareEmailIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(configData, "general.socialShareEmailIconPath", "");
        });
    }, []);
    // get component social share link url
    /**
   *
   * @return  {string} the the url
   */ const getLink = ()=>{
        const isFullUrl = /^https?:\/\//i;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getShortenedUrlwithGeneral */ .vu1)(compUrl, general);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else {
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeUrl */ .Nmg)(window.location.href);
        }
    };
    const link = getLink();
    const brandNameCurrent = brandName.current;
    const i18n = {
        email: t("kf.share.label.email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: props.sharedCartNum
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandNameCurrent,
                siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText")
    };
    const [copyIcon, setCopyIcon] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (socialMediaConfigs.myArrayList) {
            let siteList = [];
            socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : socialMediaConfigs.myArrayList.forEach((socialMediaConfig)=>{
                if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(socialMediaConfig) && socialMediaConfig.name) {
                    var _name, _iconPath;
                    const site = {
                        key: (_name = socialMediaConfig.name) !== null && _name !== void 0 ? _name : "",
                        icon: (_iconPath = socialMediaConfig.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                    };
                    var _redirectUrl;
                    const url = (_redirectUrl = socialMediaConfig.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                    if (socialMediaConfig.name.toLowerCase().includes("twitter")) {
                        siteList.push({
                            ...site,
                            url: encodeURI(url + link + "&text=".concat(document.title))
                        });
                    } else if (socialMediaConfig.name.toLowerCase().includes("pinterest")) {
                        if (props.asset) siteList.push({
                            ...site,
                            url: url + "".concat(origin, "&media=").concat(props.asset.url, "&is_video=").concat(props.asset.isVideo, "$description=").concat(props.asset.description)
                        });
                    } else {
                        siteList.push({
                            ...site,
                            url: url + link
                        });
                    }
                }
            });
            if (disableInstagram && siteList.length) {
                siteList = siteList.filter((site)=>!site.key.toLowerCase().includes("instagram"));
            }
            setSites(siteList);
        }
    }, [
        socialMediaConfigs
    ]);
    const emailLink = (e)=>{
        e.stopPropagation();
        addDataLayer("email a friend", "n/a");
    };
    /**
   *
   * @param {string} e
   */ function socialLinks(e) {
        if (e.target && e.target.hostname && e.target.href) {
            const target = e.target;
            const nodeUrl = target.hostname.replace(/(^www\.)/, "");
            if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
                e.stopPropagation();
                e.preventDefault();
                if (window.handleShowModal) window.handleShowModal(target.href, target);
            } else if (target.href) {
                window.open(target.href);
            }
            const key = target.siteKey || nodeUrl || target.hostname;
            try {
                addDataLayer(key.split(".com")[0], target.href);
            // eslint-disable-next-line no-empty
            } catch (ee) {}
        }
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        props.showModal
    ]);
    const { internallinkposition , internallinktype , internallinkzonename  } = props.componentProp || {};
    const analyticData = props.analyticData || {
        internalLinkPosition: internallinkposition || "n/a",
        internalLinkType: internallinktype || "n/a",
        internalLinkZoneName: internallinkzonename || "n/a"
    };
    const shareRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const handleClick = (e)=>{
        var ref;
        const selELement = props.iframeId ? document.getElementById(props.iframeId).contentDocument.getElementById(props.id) : document.getElementById(props.id);
        if (props.showModal && !(selELement === null || selELement === void 0 ? void 0 : selELement.contains(e.target))) props.onClose();
        if (((ref = props.componentProp) === null || ref === void 0 ? void 0 : ref.showModal) && window.shareSrcElement !== null && window.shareSrcElement !== undefined && !shareRef.current.contains(e.target)) {
            const shareElems = [
                ...document.getElementsByClassName("share-cmp")
            ];
            shareElems.forEach((el)=>{
                el.style.display = "none";
            });
            window.shareSrcElement = null;
        }
        return true;
    };
    const handleClose = (e)=>{
        if (e.keyCode === 27) {
            props.onClose();
            props.shareBtn.current.focus();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        const selELement = props.iframeId ? document.getElementById(props.iframeId).contentDocument : document;
        if (props.showModal) {
            selELement.addEventListener("click", handleClick);
            selELement.addEventListener("keydown", handleClose);
            return ()=>{
                selELement.removeEventListener("click", handleClick);
                selELement.removeEventListener("keydown", handleClose);
            };
        }
        if (((ref = props.componentProp) === null || ref === void 0 ? void 0 : ref.showModal) && props.showModal) {
            document.addEventListener("click", handleClick);
        }
    }, [
        props.showModal
    ]);
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        navigator.clipboard.writeText(link);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
        addDataLayer("copy link", link !== null && link !== void 0 ? link : "n/a");
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const addDataLayer = (siteKey, link)=>{
        const { eventAction ="n/a" , eventName ="n/a" , eventType ="informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , custom  } = analyticData;
        let eventInfo = {
            eventAction,
            eventName,
            eventType,
            eventMsg,
            eventStatus,
            internalLinkName: siteKey,
            internalLinkPosition,
            internalLinkType,
            internalLinkZoneName,
            internalLinkURL: link || internalLinkURL || "n/a",
            clickInternalLinks: siteKey === "copy link" || siteKey === "email a friend" ? "true" : "false"
        };
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const { pageInfo: { contentType  } , productInfo  } = page;
        const isPdp = contentType === "pdp";
        if (isPdp) {
            eventInfo = {
                eventAction: "pdp:product details:share",
                eventName: "pdp:product details:share",
                eventType: "informative",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: siteKey,
                internalLinkPosition: "pdp".concat(isBundleProduct ? ":bundle" : ""),
                internalLinkType: "pdp:".concat(internalLinkType.split(":")[1] || ""),
                internalLinkZoneName: "pdp:".concat(internalLinkZoneName.split(":")[1] || ""),
                internalLinkURL: link || internalLinkURL || "n/a",
                clickInternalLinks: "true"
            };
        }
        if (window.dataLayerEventType && !isPdp) {
            eventInfo.internalLinkType = window.dataLayerEventType;
        }
        if (window.dataLayerEventZoneName && !isPdp) {
            eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
            if (eventAction === "n/a") {
                eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
                eventInfo.eventName = window.dataLayerEventZoneName + ":share";
            }
        }
        const dataLayerObj = {
            event: "cmp:click",
            page,
            eventInfo
        };
        if (isPdp) {
            dataLayerObj["productInfo"] = productInfo;
        }
        let customProductInfo;
        if (custom) {
            try {
                customProductInfo = JSON.parse(custom).productInfo;
                dataLayerObj["productInfo"] = customProductInfo;
            } catch (e) {
                console.error(e);
            }
        }
        window.adobeDataLayer.push(dataLayerObj);
    };
    const { linksCTA =()=>{} , openNewTabText ="" , copyLinkIndication ="" , copyLink: staticTextcopyLink = "" , email =""  } = i18n;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7___default().socialShareWrapper),
        children: (showModal !== null && showModal !== void 0 ? showModal : componentPropShowModal) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "social-share",
            id: id,
            ref: shareRef,
            "data-testid": id,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "social-share__box",
                ref: shareBoxRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "social-share__sites",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            role: "list",
                            children: sites.map((param, i)=>{
                                let { url ="" , key ="" , icon =""  } = param;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        id: "kf-social-links-".concat(i),
                                        rel: "noreferrer",
                                        href: url,
                                        className: "kf-social-links",
                                        "aria-label": "".concat(linksCTA(key), " ").concat(openNewTabText),
                                        target: "_blank",
                                        "data-link-type": "social media",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            "aria-hidden": "true",
                                            src: "".concat(hostUrl).concat(icon),
                                            alt: key,
                                            className: "social-share__".concat(key)
                                        })
                                    })
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "social-share__actions",
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    tabIndex: "0",
                                    role: "button",
                                    ref: copyBtnRef,
                                    className: "social-share__cta",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: "social-share__copy-link-icon",
                                            "aria-hidden": true,
                                            src: "".concat(hostUrl).concat(socialShareCopyIconPath.current),
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        copyIcon ? copyLinkIndication : staticTextcopyLink
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    className: "social-share__cta social-share__email",
                                    "aria-label": "".concat(email, " ").concat(openNewTabText),
                                    onKeyDown: ()=>onClose(),
                                    ref: emailBtnRef,
                                    href: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeUrl */ .Nmg)("mailto:?body=".concat(mailBody + link).concat(mailSubject ? "&subject=" + mailSubject : "")),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "".concat(hostUrl).concat(socialShareEmailIconPath.current),
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        email
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductSocialShare);


/***/ }),

/***/ 8381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UpsellInstallServices_ProductCardForUpsell; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./src/components/Shared/UpsellInstallServices/ProductCardForUpsell/index.module.scss
var index_module = __webpack_require__(70209);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
;// CONCATENATED MODULE: ./src/components/Shared/UpsellInstallServices/ProductCardForUpsell/analytics/constant.js
const UPSELL = "upsell product";
const ADD_TO_CART = "add to cart";
const PREVIEW = "preview";

;// CONCATENATED MODULE: ./src/components/Shared/UpsellInstallServices/ProductCardForUpsell/analytics/index.js

const addAnalyticsForAddToCart = (item, productPrice, discountedPrice, productImageUrl)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageload, " ").concat(PREVIEW, ":").concat(UPSELL, ":").concat(ADD_TO_CART),
        eventMsg: "n/a",
        eventName: "".concat(pageload, " ").concat(PREVIEW, ":").concat(UPSELL, ":").concat(ADD_TO_CART),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: ADD_TO_CART,
        internalLinkPosition: "".concat(pageload, " ").concat(PREVIEW, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(ADD_TO_CART),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, " ").concat(PREVIEW, ":our best sellers")
    };
    pushAnalyticsObjToDataLayer(eventInfo, item, productPrice, discountedPrice, productImageUrl);
};
const getproductInfo = (item, productPrice, discountedPrice, productImageUrl)=>{
    const { CustomerFacingBrand_s: brandName = "" , sku_s: skuID = "" , ProductBrandName_s: name = "" , ProductDescriptionProductShort_s: desc = "" , Product_Category: category = ""  } = item;
    const productInfo = {
        description: desc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((productPrice - 0).toFixed(2)) : 0,
        globalOffer: "n/a",
        globalDiscount: Number(discountedPrice.toFixed(2)),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountedPrice ? "discounted price" : "regular price",
        productBasePrice: Number(productPrice),
        productCategory: category,
        productColor: "default",
        productCoupondiscount: "n/a",
        productCouponCode: "n/a",
        productID: skuID,
        productName: name || desc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "service" || 0,
        productSalePrice: Number(productPrice),
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: name,
        quantity: 1,
        defaultImageName: productImageUrl,
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: category,
        productBrand: brandName,
        itemType: "service" || 0
    };
    return productInfo;
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, item = arguments.length > 1 ? arguments[1] : void 0, productPrice = arguments.length > 2 ? arguments[2] : void 0, discountedPrice = arguments.length > 3 ? arguments[3] : void 0, productImageUrl = arguments.length > 4 ? arguments[4] : void 0;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const productInfo = getproductInfo(item, productPrice, discountedPrice, productImageUrl);
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};

// EXTERNAL MODULE: ./src/components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(88611);
;// CONCATENATED MODULE: ./src/components/Shared/UpsellInstallServices/ProductCardForUpsell/ProductCard.jsx









const ProductCard = (param)=>{
    let { persona ="GST" , currencySign ="$" , brand ="kohler" , presetConfigs ="" , rowCols =0 , swatchUrl: baseUrl = "" , outOfStockTitle ="" , addToCart =()=>{} , ...item } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [pdpUrl, setPdpUrl] = (0,react.useState)("");
    const [loading, setLoading] = (0,react.useState)(false);
    const { sku_s: skuId = "" , quantity: productQuantity = 0 , ProductBrandName_s: name = "" , productName_s: productName = "" , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0 , ["productImages.labelWithUrl_ss"]: labledImages = [] , Product_Category: productCategory = "" , slug_s: slug = ""  } = item;
    (0,react.useEffect)(()=>{
        (0,helper/* getPDPUrl */.ir5)(productCategory, slug).then((url)=>setPdpUrl(url));
    }, []);
    const price = Number(productPrice).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    const productPresetConfigs = presetConfigs ? JSON.parse(presetConfigs) : {};
    let imgId = "";
    if (labledImages.length) {
        var ref, ref1;
        const index = labledImages.map((item)=>{
            var ref;
            return ((ref = item.split("|")) === null || ref === void 0 ? void 0 : ref.length) ? item.split("|")[0] : "";
        }).indexOf(skuId);
        const assetId = ((ref1 = (ref = labledImages[index]) === null || ref === void 0 ? void 0 : ref.split("|")) === null || ref1 === void 0 ? void 0 : ref1.length) ? labledImages[index].split("|")[1] : "";
        imgId = assetId;
    }
    const handleAddToCartCb = ()=>{
        setLoading(false);
    };
    const handleAddToCart = async (e)=>{
        var ref, ref1;
        e.preventDefault();
        setLoading(true);
        const itemsProjectionApiResponse = await (0,shareCartHelper/* getProductsBySku */.uX)([
            skuId
        ]);
        var ref2;
        const variants = (ref2 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref = itemsProjectionApiResponse[0]) === null || ref === void 0 ? void 0 : ref.variants) !== null && ref2 !== void 0 ? ref2 : [];
        var ref3;
        variants.push((ref3 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref1 = itemsProjectionApiResponse[0]) === null || ref1 === void 0 ? void 0 : ref1.masterVariant) !== null && ref3 !== void 0 ? ref3 : {});
        let isComboSku = false;
        for(let i = 0; i < variants.length; i++){
            if (skuId === variants[i].sku) {
                var ref4;
                isComboSku = ((ref4 = variants[i]) === null || ref4 === void 0 ? void 0 : ref4.attributes.find((attr)=>attr.name === "ComboSKU")) ? true : false;
            }
        }
        const payload = [
            {
                sku: skuId,
                quantity: 1,
                brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase(),
                isBundle: isComboSku
            }
        ];
        addToCart(payload, handleAddToCartCb);
        addAnalyticsForAddToCart(item, productPrice, discountedPrice, productImageUrl);
    };
    const productImageUrl = (0,utils/* getPresetUrl */.v$)(width, rowCols, baseUrl, imgId, productPresetConfigs);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).curatedProduct,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "curated-product-recommendation__card-list",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "".concat(pdpUrl).concat(skuId ? "?skuId=" + skuId : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "curated-product-recommendation__product-card",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "curated-product-recommendation__img",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: productImageUrl,
                                alt: name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "curated-product-recommendation__product-name",
                            children: name || productName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "curated-product-recommendation__product-sku",
                            children: skuId
                        }),
                        discountedPrice > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "curated-product-recommendation__discounted-price",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "price-with-discount",
                                    children: "".concat(currencySign).concat(discountedPrice)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "original-price",
                                    children: "".concat(currencySign).concat(price)
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "curated-product-recommendation__product-price",
                            children: "".concat(currencySign).concat(price)
                        }),
                        !productQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "curated-product-recommendation__out-of-stock",
                            children: outOfStockTitle
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "curated-product-recommendation__add-to-cart",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                role: "button",
                                label: "Add To Cart",
                                size: "small",
                                type: "primary",
                                flexible: true,
                                onClick: handleAddToCart,
                                loading: loading
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var ProductCardForUpsell_ProductCard = (/*#__PURE__*/(0,react.memo)(ProductCard));

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/components/Shared/UpsellInstallServices/api.js
var api = __webpack_require__(47936);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/utils/addTocart.js
var addTocart = __webpack_require__(84003);
// EXTERNAL MODULE: ./src/store/features/cartSlice.js
var cartSlice = __webpack_require__(64925);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./src/components/Shared/UpsellInstallServices/ProductCardForUpsell/index.jsx















const ProductCardForUpsell = (param)=>{
    let { authData ={}  } = param;
    const { skuIds =[] , presetConfigs ="" , swatchUrl ="" , outOfStockTitle =""  } = authData;
    const [width] = (0,useWindowResize/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const rowCols = (0,utils/* getRowCols */.n)(width, lib/* isMobile */.tq, lib/* isTablet */.Em);
    const persona = (0,helper/* getUserPersona */.shu)();
    const [recommendedProductData, setRecommendedProductData] = (0,react.useState)([]);
    const [currency, setCurrencySign] = (0,react.useState)("$");
    const [brand, setBrand] = (0,react.useState)("kohler");
    const callToFetchRecommendedProductData = ()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            if (!isEmpty_default()(config)) {
                const { general: { lwAppName ="" , siteName ="kohler"  } = {} , internationalization: { currencySign ="$"  } = {}  } = config;
                if (skuIds.length) getRecommendedProductData({
                    lwAppName,
                    currencySign,
                    siteName
                });
            }
        });
    };
    (0,react.useEffect)(()=>{
        if (persona) callToFetchRecommendedProductData();
    }, [
        persona
    ]);
    const getRecommendedProductData = (param)=>{
        let { lwAppName ="" , currencySign ="$" , siteName ="kohler"  } = param;
        (0,api/* getProductDataFromSkuIds */.fh)(persona, skuIds, lwAppName).then(async (res)=>{
            const skuidString = skuIds.join(",");
            if (!isEmpty_default()(res) && skuidString) {
                const { data: { response: { docs =[]  } = {}  } = {}  } = res;
                var ref;
                const { data: { results: productInventory = []  } = {}  } = (ref = await (0,api/* getProductInventory */.o)(skuidString)) !== null && ref !== void 0 ? ref : {};
                const updatedDocs = [];
                docs.forEach((item)=>{
                    const matchItem = productInventory.find((product)=>product.sku === item.sku_s);
                    if (matchItem) {
                        updatedDocs.push({
                            ...item,
                            quantity: matchItem === null || matchItem === void 0 ? void 0 : matchItem.availableQuantity
                        });
                    }
                });
                setCurrencySign(currencySign);
                setBrand(siteName);
                setRecommendedProductData(updatedDocs);
            }
        });
    };
    const handleAddToCart = async function() {
        let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
        const payload = await (0,addTocart/* addToCartItem */.q)([
            ...items
        ]);
        const body = {
            actions: payload
        };
        dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
            dispatch((0,genericSlice/* showPreviewCart */.z0)());
            const { payload ={}  } = res;
            if (!isEmpty_default()(payload)) {
                dispatch((0,cartSlice/* setCart */.RV)(payload));
            }
            cb();
        }).catch((err)=>{
            cb();
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).curatedProduct,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "curated-product-recommendation",
            children: recommendedProductData.map((item)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardForUpsell_ProductCard, {
                        addToCart: handleAddToCart,
                        ...item,
                        persona: persona,
                        currencySign: currency,
                        brand: brand,
                        presetConfigs: presetConfigs,
                        rowCols: rowCols,
                        swatchUrl: swatchUrl,
                        outOfStockTitle: outOfStockTitle
                    })
                }, item.id);
            })
        })
    });
};
/* harmony default export */ var UpsellInstallServices_ProductCardForUpsell = (ProductCardForUpsell);


/***/ }),

/***/ 47936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q3": function() { return /* binding */ getListOfRequiredSkus; },
/* harmony export */   "X_": function() { return /* binding */ getZipCodes; },
/* harmony export */   "fh": function() { return /* binding */ getProductDataFromSkuIds; },
/* harmony export */   "o": function() { return /* binding */ getProductInventory; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47956);




const getListOfParamsToFetch = (persona)=>{
    const fl = [
        "id",
        "slug_s",
        "productName_s",
        "masterSKU_s",
        "sku_s",
        "Product_Category",
        "ProductBrandName_s",
        "productImages.url_ss",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "Color.SKU.Details_ss",
        "ProductWebFeatures_ss",
        "ProductWebFeatures_s",
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "title_s",
        "ProductNarrativeDescription_s",
        "priceList.".concat(persona, ".finalPrice_d"),
        "CustomerFacingBrand_s",
        "RegionBrandName_s",
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".price_d"),
        "CrossSellRecommendationSKUList_ss",
        "productImages.labelWithUrl_ss"
    ];
    return fl.join(",");
};
const getProductDataFromSkuIds = async function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST", skus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], lwAppName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var ref;
    if (!skus.length) return;
    const fl = getListOfParamsToFetch(persona);
    const fq = "sku_s:(".concat(skus.map((ele)=>'"'.concat(ele, '"')).join(" "), ")");
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const brand = lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase();
    var ref2;
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("/search/plp", {
        params: {
            fl,
            q: "*:*",
            fq: [
                fq,
                'language_s:("'.concat(language, '")')
            ],
            collections: brand,
            profilename: "profile_".concat(brand, "_Full_Catalog"),
            rows: (ref2 = skus === null || skus === void 0 ? void 0 : skus.length) !== null && ref2 !== void 0 ? ref2 : 10
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_3___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
};
const getZipCodes = async (jsonFileUrl)=>await (0,_constants_api__WEBPACK_IMPORTED_MODULE_0__/* .aemAxiosInstance */ .Gb)({
        url: _constants__WEBPACK_IMPORTED_MODULE_2__.GLOBAL_CONFIGURATION_ENDPOINT,
        params: {
            path: jsonFileUrl
        }
    });
const getListOfRequiredSkus = async function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST", slug = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", sku = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", lwAppName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var ref;
    const fl = getListOfParamsToFetch(persona);
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const fq = 'sku_s:("'.concat(sku, '")');
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("search/pdp/".concat(slug), {
        fl,
        q: "*:*",
        fq: "".concat(fq, ' AND language_s:("').concat(language, '")'),
        collections: lwAppName,
        profilename: "profile_".concat(lwAppName, "_General")
    });
};
const getProductInventory = function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.getStockEndPoint, "/?sku=").concat(skus));
};



/***/ }),

/***/ 31720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ addAnalyticsEventForImageTitle; },
/* harmony export */   "I8": function() { return /* binding */ dataLayershopTheRoomPlusButton; },
/* harmony export */   "Xc": function() { return /* binding */ addAnalyticsEventForFavouriteAddRemove; },
/* harmony export */   "dv": function() { return /* binding */ shopRoomhandleProductClick; },
/* harmony export */   "i2": function() { return /* binding */ addAnalyticsEventForPrevNext; },
/* harmony export */   "vf": function() { return /* binding */ closeButtonAnalytics; }
/* harmony export */ });
/* unused harmony export addAnalyticsEventForProductInfo */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24701);


const pushToAdobeDataLayer = (eventInfo, productInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        ...productInfo ? {
            productInfo
        } : {},
        page
    });
};
const dataLayershopTheRoomPlusButton = (cardTitle, url)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room:".concat(cardTitle.toLowerCase(), ":room detail card modal open"),
        eventName: "shop the room:".concat(cardTitle.toLowerCase(), ":room detail card modal open"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "room detail card modal open",
        internalLinkPosition: "shop the room",
        internalLinkType: "shop the room:".concat(cardTitle.toLowerCase(), ":room detail card modal open"),
        internalLinkZoneName: "shop the room:all rooms",
        internalLinkURL: url
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForPrevNext = (navigationType)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal:".concat(navigationType.toLowerCase(), " arrow"),
        eventName: "shop the room: room detail card modal:".concat(navigationType.toLowerCase(), " arrow"),
        eventType: "carousel",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(navigationType.toLowerCase(), " arrow"),
        internalLinkPosition: "shop the room: room detail card modal:carousel",
        internalLinkType: "shop the room: room detail card modal:classic glam room details",
        internalLinkZoneName: "shop the room: room detail card modal: shop products in this room",
        internalLinkURL: "n/a"
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForImageTitle = (cardTitle, url)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal:".concat(cardTitle.toLowerCase()),
        eventName: "shop the room: room detail card modal:".concat(cardTitle.toLowerCase()),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(cardTitle.toLowerCase()),
        internalLinkPosition: "room detail card modal",
        internalLinkType: "shop the room: room detail card modal:".concat(cardTitle.toLowerCase()),
        internalLinkZoneName: "shop the room: room detail card modal",
        internalLinkURL: url
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForFavouriteAddRemove = (favouriteType, productInfo)=>{
    const favoriteText = favouriteType ? "add" : "remove";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal: favorite ".concat(favoriteText.toLowerCase()),
        eventMsg: "your item has been ".concat(favoriteText.toLowerCase(), " to your Favorites"),
        eventName: "shop the room: room detail card modal: favorite ".concat(favoriteText.toLowerCase()),
        eventType: "wishlist save",
        eventStatus: "sucess",
        internalLinkName: "favorite ".concat(favoriteText.toLowerCase()),
        internalLinkPosition: "shop the room: room detail card modal",
        internalLinkType: "shop the room: room detail card modal: favorite",
        internalLinkZoneName: "shop the room: room detail card modal",
        internalLinkURL: "n/a"
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeButtonAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal:close button",
        eventName: "shop the room: room detail card modal:close button",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "shop the room: room detail card modal",
        internalLinkType: "shop the room: room detail card modal :close",
        internalLinkZoneName: "shop the room: room detail card modal:navigation",
        internalLinkURL: "n/a"
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForProductInfo = (eventInfo, productInfo)=>{
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const shopRoomhandleProductClick = (productInfoParams)=>{
    const { productData , sku , url , cart , config , description , persona  } = productInfoParams;
    const productInfo = (0,_components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_1__/* .getProductInfo */ .C)(productData, sku, false, cart, config, description, persona);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal: product navigation",
        eventMsg: "n/a",
        eventName: "shop the room: room detail card modal: product navigation",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "RegionBrandName_s", ""),
        internalLinkPosition: "shop the room: room detail card modal",
        internalLinkType: "shop the room: room detail card modal: navigation",
        internalLinkURL: url,
        internalLinkZoneName: "shop the room: room detail card modal"
    };
    addAnalyticsEventForProductInfo(eventInfo, productInfo);
};



/***/ }),

/***/ 738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27514);
/* harmony import */ var _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66773);
/* harmony import */ var _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91883);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19514);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72433);
/* harmony import */ var _utils_location__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78800);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20558);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9473);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64925);














const SocialShare = (param)=>{
    let { cartId , analyticEventData , specFiles , mobileView =false , componentProp: { assetUrl ="" , url: compUrl = ""  } = {} , enableDownload =true , videoComp =false  } = param;
    // *****
    const [shareCart, setShareCart] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        show: false,
        id: "",
        url: ""
    });
    const [copyIcon, setCopyIcon] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [link, setLink] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [downloading, setDownloading] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const url = shareCart.url || "";
    const [sites, setSites] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_11__/* .useDispatch */ .I0)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$G)();
    const origin = window.location.origin;
    const brandName = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const [socialMediaConfigs, setSocialMediaConfigs] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({});
    const emailBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const copyBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const shareBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const shareCartUrl = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const socialShareCopyIconPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const socialShareEmailIconPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const hostUrlPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_5__/* .getConfig */ .i)().then(async (config)=>{
            const socialMediaConfigs = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "socialMediaConfig", {});
            setSocialMediaConfigs(socialMediaConfigs);
            brandName.current = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general?.siteName", "");
            const { general: { hostUrl =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            hostUrlPath.current = hostUrl;
            socialShareCopyIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general.socialShareCopyIconPath", "");
            socialShareEmailIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general.socialShareEmailIconPath", "");
            shareCartUrl.current = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Pp)(lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general.shareCartPagePath", ""));
        });
        getLink().then((urlLink)=>{
            setLink(urlLink);
        });
    }, []);
    const handleShareCart = ()=>{
        setShareCart({
            ...shareCart,
            show: !shareCart.show
        });
        addDataLayer("share cart", link);
    };
    const handleShareCartCopyLink = (isCopyLink)=>{
        const payload = {
            cartId: cartId
        };
        if (videoComp) {
            navigator.clipboard.writeText(assetUrl);
            addDataLayer("copy link", assetUrl !== null && assetUrl !== void 0 ? assetUrl : "n/a");
        } else {
            return dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_12__/* .shareCart */ .Vp)(payload)).unwrap().then((res)=>{
                if (res === null || res === void 0 ? void 0 : res.sharedCartId) {
                    const shareUrl = window.location.origin + shareCartUrl.current + "?share-id=".concat(res.sharedCartId);
                    if (isCopyLink) {
                        setShareCart({
                            ...shareCart,
                            id: res.sharedCartId,
                            url: shareUrl
                        });
                        navigator.clipboard.writeText(shareUrl);
                        addDataLayer("copy link", shareUrl !== null && shareUrl !== void 0 ? shareUrl : "n/a");
                    }
                    return shareUrl;
                }
            });
        }
    };
    // get component social share link url
    const getLink = async ()=>{
        const isFullUrl = /^https?:\/\//i;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Pp)(compUrl);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else {
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeUrl */ .Nmg)(window.location.href);
        }
    };
    const i18n = {
        email: t("kf.share.label.email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: shareCart.id
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandName,
                siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText"),
        shareCartDesc: t("kf.cart.label.shareCartDesc"),
        shareCart: t("kf.cart.label.shareCart"),
        mailSubject: t("kf.share.label.emailSubject"),
        downloadSpecs: t("kf.cart.label.downloadSpecs")
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        var ref;
        const siteList = [];
        socialMediaConfigs && (socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : (ref = socialMediaConfigs.myArrayList) === null || ref === void 0 ? void 0 : ref.forEach((socialMediaConfig)=>{
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7___default()(socialMediaConfig) && socialMediaConfig.name) {
                var _name, _iconPath;
                const site = {
                    key: (_name = socialMediaConfig.name) !== null && _name !== void 0 ? _name : "",
                    icon: (_iconPath = socialMediaConfig.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                };
                var _redirectUrl;
                const url = (_redirectUrl = socialMediaConfig.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                if (socialMediaConfig.name.toLowerCase().includes("twitter")) {
                    siteList.push({
                        ...site,
                        url: encodeURI(url + link + "&text=".concat(document.title))
                    });
                } else if (socialMediaConfig.name.toLowerCase().includes("pinterest")) {
                // if (props.asset)
                //   siteList.push({
                //     ...site,
                //     url:
                //       url +
                //       `${origin}&media=${props.asset.url}&is_video=${props.asset.isVideo}$description=${props.asset.description}`,
                //   })
                } else {
                    siteList.push({
                        ...site,
                        url: url + link
                    });
                }
            }
        }));
        setSites(siteList);
    }, [
        socialMediaConfigs
    ]);
    const emailLink = async (e)=>{
        const link = await handleShareCartCopyLink();
        const cartLink = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeUrl */ .Nmg)("mailto:?body=".concat("" + link).concat(i18n.mailSubject && "&subject=" + i18n.mailSubject));
        window.open(cartLink, "_blank");
        e.stopPropagation();
        addDataLayer("email a friend", "n/a");
    };
    const socialLinks = (e)=>{
        const target = e.target;
        const nodeUrl = target.hostname.replace(/(^www\.)/, "");
        if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
            e.stopPropagation();
            e.preventDefault();
            if (window.handleShowModal) window.handleShowModal(target.href, target);
        } else if (target.href) {
            window.open(target.href);
        }
        const key = target.siteKey || nodeUrl || target.hostname;
        try {
            addDataLayer(key.split(".com")[0], target.href);
        // eslint-disable-next-line no-empty
        } catch (ee) {}
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        shareCart.show
    ]);
    const analyticData = analyticEventData || {
        internalLinkPosition: "n/a",
        internalLinkType: "n/a",
        internalLinkZoneName: "n/a"
    };
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        handleShareCartCopyLink(true);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const handleDownload = async ()=>{
        setDownloading(true);
        await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .handleZipDownload */ .G12)(specFiles);
        setDownloading(false);
    };
    const addDataLayer = (siteKey, link)=>{
        var ref;
        const { eventAction ="n/a" , eventName ="n/a" , eventType =siteKey === "share cart" ? "navigation" : "informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , videoId ="" , videoName =""  } = analyticData;
        const eventInfo = {
            eventAction,
            eventName,
            eventType,
            eventMsg,
            eventStatus,
            internalLinkName: siteKey,
            internalLinkPosition,
            internalLinkType,
            internalLinkZoneName,
            internalLinkURL: link || internalLinkURL || "n/a",
            clickInternalLinks: siteKey === "copy link" || siteKey === "email a friend" || siteKey === "share cart" ? "true" : "false"
        };
        if (videoId) eventInfo.videoId = videoId;
        if (videoName) eventInfo.videoName = videoName;
        if (window.dataLayerEventType) {
            eventInfo.internalLinkType = window.dataLayerEventType;
        }
        if (window.dataLayerEventZoneName) {
            eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
            if (eventAction === "n/a") {
                eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
                eventInfo.eventName = window.dataLayerEventZoneName + ":share";
            }
        }
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        if ((ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.length) {
            const { page: { cart ={}  } = {}  } = window.adobeDataLayer[0];
            page.cart = cart;
        }
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_index__WEBPACK_IMPORTED_MODULE_10__/* .ConditionalWrapper */ .M2, {
            condition: enableDownload,
            wrapper: (children)=>{
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "download-specs".concat(mobileView ? "--mobile" : " d-none d-lg-block"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeInnerHtml */ .KD0)(i18n.shareCartDesc)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "download-specs".concat(mobileView ? "--mobile" : "", "__cta"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    role: "button",
                                    tabIndex: "0",
                                    onClick: ()=>handleShareCart(),
                                    name: "socialShareModelClose",
                                    children: [
                                        i18n.shareCart,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z === null || _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                                            role: "presentation",
                                            alt: ""
                                        })
                                    ]
                                }),
                                (specFiles === null || specFiles === void 0 ? void 0 : specFiles.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    role: "button",
                                    tabIndex: "0",
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": '{"eventAction":"cart:landing page:download specs","eventName":"cart:landing page:download specs","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"download specs","internalLinkPosition":"cart","internalLinkType":"cart:download","internalLinkZoneName":"cart:landing page:order summary","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                    onClick: handleDownload,
                                    children: [
                                        i18n.downloadSpecs,
                                        downloading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "loading-spinner"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        }),
                        children
                    ]
                });
            },
            children: shareCart.show || !enableDownload ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "social-share",
                id: "kf-order-summary",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "social-share__box",
                    ref: shareBoxRef,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "social-share__sites",
                            children: shareCart.id && !videoComp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "social-share__shared-cart-number",
                                children: i18n.yourSharedCartNumber
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                role: "list",
                                children: sites.map((site, i)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        role: "listitem",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            id: "kf-social-links-".concat(i),
                                            rel: "noreferrer",
                                            href: site.url,
                                            className: "kf-social-links",
                                            "aria-label": "".concat(i18n.linksCTA(site.key), " ").concat(i18n.openNewTabText),
                                            target: "_blank",
                                            "data-link-type": "social media",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                "aria-hidden": "true",
                                                src: "".concat("https://annsacks.kohler.com").concat(site.icon),
                                                alt: site.key,
                                                className: "social-share__".concat(site.key)
                                            })
                                        })
                                    }, i);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "social-share__actions",
                            role: "list",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        tabIndex: "0",
                                        role: "button",
                                        ref: copyBtnRef,
                                        className: "social-share__cta",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: "social-share__copy-link-icon",
                                                "aria-hidden": true,
                                                src: "".concat(hostUrlPath.current).concat(socialShareCopyIconPath.current),
                                                role: "presentation",
                                                alt: ""
                                            }),
                                            copyIcon ? i18n.copyLinkIndication : i18n.copyLink
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "social-share__cta social-share__email",
                                        "aria-label": "".concat(i18n.email, " ").concat(i18n.openNewTabText),
                                        onKeyDown: handleShareCart,
                                        ref: emailBtnRef,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "".concat(hostUrlPath.current).concat(socialShareEmailIconPath.current),
                                                role: "presentation",
                                                alt: ""
                                            }),
                                            i18n.email
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : null
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialShare);


/***/ }),

/***/ 85721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27514);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91296);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_5__);
/**
 * It is Quantity Selector
 *  @returns {number} the QuantitySelector
 */ 





/**
 * It returns updated Value
 * @param {props} props is the only param.
 * @return {number} the updated Value in the cart
 */ function QuantitySelector(props) {
    const { isPDPQuantitySelector , source , doNotRequiredAnalyticsData , productData , productInfoData  } = props;
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.value);
    const [focusControl, setFocusControl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [siteName, setSiteName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const product = productData && (productData.name || productData.desc) ? productData : {};
    const minusButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const addButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const qtyInput = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!props.loading && value !== props.value) {
            setValue(props.value);
        } else if (!props.loading && value === props.value && value !== 1 && focusControl) {
            focusControl.current.focus();
        }
    }, [
        props.value,
        props.loading
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)().then((config)=>{
            setSiteName(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.siteName", ""));
        });
    }, []);
    /**
   * @param {val} val The first number.
   * @param {action} action The second number.
   */ const handleChange = (val, action)=>{
        if (val === "" || parseInt(val) < 1000) {
            if (props.isAddToCart) {
                props.onLoading();
            }
            if (!action) {
                setFocusControl(qtyInput);
            } else {
                setFocusControl(action === "add" ? addButton : minusButton);
            }
            let fieldValue = val.toString().replace(/\D/, "");
            if (fieldValue.charAt(0) === "0") {
                fieldValue = fieldValue.length === 1 ? 0 : fieldValue.substring(1);
            }
            fieldValue = fieldValue === "" ? value : Number(fieldValue);
            // if (!window.oldValue && window.oldValue !== 0) {
            window.oldValue = Number(props.value);
            // }
            setValue(fieldValue);
            delayedChange(fieldValue, action);
        }
    };
    const handleAddAnalytics = (action, val)=>{
        var ref, ref1, ref2, ref3, ref4;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        if (source !== "cart-preview" && (page === null || page === void 0 ? void 0 : (ref = page.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            // this is flow of cart page only
            let updatedSku;
            let pdpTypeBundle;
            page.cart.item.forEach((prod)=>{
                var ref, ref1, ref2, ref3, ref4, ref5;
                const productId = (ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                if (productId === ((ref2 = product.customerFacingSKU) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || productId === ((ref3 = product.sku) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || ((ref4 = props.productData) === null || ref4 === void 0 ? void 0 : ref4.isBundleParent) && ((ref5 = props.productData) === null || ref5 === void 0 ? void 0 : ref5.sku)) {
                    var ref6, ref7;
                    if (((ref6 = props.productData) === null || ref6 === void 0 ? void 0 : ref6.isBundleParent) && ((ref7 = props.productData) === null || ref7 === void 0 ? void 0 : ref7.sku)) {
                        var ref8;
                        updatedSku = (ref8 = props.productData) === null || ref8 === void 0 ? void 0 : ref8.sku;
                        pdpTypeBundle = "bundle";
                    } else {
                        const iQty = prod.productInfo.quantity;
                        prod.productInfo = {
                            ...prod.productInfo,
                            quantity: val,
                            initialQuantity: iQty !== null && iQty !== void 0 ? iQty : Number(value)
                        };
                        prod.quantity = val;
                        updatedSku = productId;
                        pdpTypeBundle = prod.productInfo.pdpType;
                    }
                }
            });
            if (pdpTypeBundle === "bundle") {
                var ref5;
                var ref6;
                productInfoData.productInfo = {
                    ...productInfoData.productInfo,
                    quantity: val,
                    initialQuantity: (ref6 = Number((ref5 = productInfoData.productInfo) === null || ref5 === void 0 ? void 0 : ref5.quantity)) !== null && ref6 !== void 0 ? ref6 : Number(value)
                };
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo: eventInfo(action),
                    ...productInfoData,
                    page
                });
            } else {
                page.eventInfo = eventInfo(action);
                page.updatedSku = updatedSku;
                window.pageObj = page;
            }
        // wait till api is updating cart details
        } else if (source === "cart-preview" && (page === null || page === void 0 ? void 0 : (ref2 = page.cart) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.length)) {
            var ref7, ref8;
            // This is flow of cart preview updates
            let customPI;
            if (page === null || page === void 0 ? void 0 : (ref7 = page.cart) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.item) === null || ref8 === void 0 ? void 0 : ref8.length) {
                // update this one too to get updated page state in analytics
                page.cart.item.forEach((prod)=>{
                    var ref, ref1, ref2, ref3;
                    const productId = (ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                    if (productId === ((ref2 = product.customerFacingSKU) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || productId === ((ref3 = product.sku) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase())) {
                        const iQty = prod.productInfo.quantity;
                        prod.productInfo = {
                            ...prod.productInfo,
                            quantity: val,
                            initialQuantity: iQty !== null && iQty !== void 0 ? iQty : Number(value)
                        };
                        prod.quantity = val;
                        customPI = prod.productInfo;
                    }
                });
            }
            if (!doNotRequiredAnalyticsData) {
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo: eventInfo(action),
                    productInfo: customPI !== null && customPI !== void 0 ? customPI : productInfo(val),
                    page
                });
            }
        }
        if (source !== "cart-preview" && page && !(window === null || window === void 0 ? void 0 : (ref4 = window.pageObj) === null || ref4 === void 0 ? void 0 : ref4.updatedSku)) {
            page.updatedSku = (productData === null || productData === void 0 ? void 0 : productData.customerFacingSKU) || "true";
            window.pageObj = page;
        }
    };
    const productInfo = (val)=>{
        const customerFacingSKUId = product.customerFacingSKU || product.sku;
        const itemType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getCartItemType */ .Nth)(product.category, product.businessUnitName);
        const discountPriceProduct = Number(product.discountPrice);
        var _productSaleable, _oldValue;
        return {
            productBrand: siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(),
            description: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.desc) || "n/a",
            frequency: "n/a",
            globalPromotionPrice: discountPriceProduct ? discountPriceProduct : Number(product.unitPrice),
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            priceState: product.discountPercent > 0 || product.discountAmount > 0 ? "percentOff|" + product.discountPercent : "regular price",
            productBasePrice: Number(product.unitPrice) || "n/a",
            productCategory: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.category) || "n/a",
            productColor: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.color) || "n/a",
            productCoupondiscount: "n/a",
            productID: customerFacingSKUId || "n/a",
            productName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.name) || "n/a",
            productPartnerBuyNow: false,
            productRoom: (props === null || props === void 0 ? void 0 : props.isBundleParent) || (productData === null || productData === void 0 ? void 0 : productData.pdpType) === "bundle" ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(productData.category) : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.productRoom || (itemType === "service" ? itemType : "non-catalog")) || "n/a",
            productSalePrice: Number(product.discountPrice) ? Number(product.discountPrice) : Number(product.unitPrice),
            productSaleable: (_productSaleable = product.productSaleable) !== null && _productSaleable !== void 0 ? _productSaleable : "true",
            productStatus: product.availableQty >= val || product.stock >= val ? "in stock" : "out of stock",
            productSuperSku: product.superSku ? true : false,
            productTileName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.name) || "n/a",
            quantity: val,
            initialQuantity: (_oldValue = window.oldValue) !== null && _oldValue !== void 0 ? _oldValue : Number(value),
            defaultImageName: product.image || "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: (props === null || props === void 0 ? void 0 : props.isBundleParent) || (productData === null || productData === void 0 ? void 0 : productData.pdpType) === "bundle" ? "bundle" : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .pdpTypeFormat */ .V4r)({
                businessUnitName: props.businessUnitName,
                ProductIsRetail: props.ProductIsRetail,
                discontinuedProductb: props.discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: props.ProductRequiredAccessoriesGroupsList,
                superSku: props.superSku
            }),
            productFindingMethod: "n/a",
            productCollectionsName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.productCollectionsName || product.category) || "n/a",
            itemType
        };
    };
    const eventInfo = (action)=>{
        return {
            eventAction: "cart preview:cart update:".concat(action).concat(isPDPQuantitySelector ? " quantity" : ""),
            eventName: "cart preview:cart update:".concat(action).concat(isPDPQuantitySelector ? " quantity" : ""),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "cart update",
            internalLinkPosition: "cart".concat((props === null || props === void 0 ? void 0 : props.isBundleParent) || (productData === null || productData === void 0 ? void 0 : productData.pdpType) === "bundle" ? ":bundle" : ""),
            internalLinkType: "cart:".concat(action === "add" ? "addition" : action === "subtract" ? "removal" : "update"),
            internalLinkZoneName: "cart:preview",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    };
    const delayedChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default()((val, action)=>{
        if (val) {
            if (!action) {
                var _oldValue;
                const oldVal = (_oldValue = window.oldValue) !== null && _oldValue !== void 0 ? _oldValue : value;
                if (val > oldVal) {
                    action = "add";
                } else if (val < oldVal) {
                    action = "subtract";
                }
            }
            handleAddAnalytics(action, val);
            props.onChange(parseInt(val), action);
        }
    }, 1000), [
        props.onChange
    ]);
    /**
   * input value updates her
   */ const handleBlur = ()=>{
        if (!value || parseInt(value) === 0) setValue(props.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "quantity-selector no-print ".concat(props.size === "small" ? "small" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: minusButton,
                onClick: ()=>handleChange(parseInt(value) - 1, "subtract"),
                "aria-disabled": props.loading || !value || value === 1,
                disabled: props.loading || !value || value === 1,
                "data-testid": "decrement-button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "plus",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "line-1 line"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ref: qtyInput,
                type: "number",
                className: "quantity-selector__count",
                value: parseInt(value),
                onBlur: ()=>handleBlur(),
                onChange: (e)=>handleChange(e.target.value),
                disabled: props.loading,
                "data-testid": "quantity-input"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: addButton,
                onClick: ()=>handleChange(parseInt(value) + 1, "add"),
                "aria-disabled": props.loading,
                disabled: props.loading,
                "data-testid": "increment-button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: "plus",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line-1 line"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (QuantitySelector);


/***/ }),

/***/ 96702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useSmartCrop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83839);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7154);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);





const DynamicImage = (param)=>{
    let { imgUrl ="" , alt ="" , className ="" , uniqueId ="" , urlModifiers ="" , priority =false , ...restProps } = param;
    const smartCrop = (0,_hooks_useSmartCrop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const cropedImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const imgPlaceholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const isScene7Img = imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("scene7");
    const [bgColorImage, setBgColorImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [imageUrl, setImageUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(imgUrl);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isSsr && smartCrop.scriptStatus && isScene7Img && window.s7responsiveImage) {
            smartCrop.applySmartCrop(cropedImage.current);
        }
    }, [
        smartCrop.scriptStatus,
        imgUrl,
        window.s7responsiveImage,
        uniqueId,
        isSsr
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (urlModifiers && imgUrl) {
            setBgColorImage((imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("?")) ? "".concat(imgUrl, "&").concat(urlModifiers) : "".concat(imgUrl, "?").concat(urlModifiers));
        }
    }, [
        imgUrl,
        urlModifiers
    ]);
    const getDefaultImgUrl = ()=>{
        setImageUrl(imgPlaceholder);
    };
    const DEFAULT_IMG_PLACEHOLDER = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9IiM5OTk5OTkiIC8+PC9zdmc+";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: cropedImage,
        src: imgPlaceholder,
        "data-src": urlModifiers ? bgColorImage : imgUrl,
        // onError={e => getDefaultImgUrl(e)}
        // src={urlModifiers ? bgColorImage : imageUrl}
        // data-src={imgPlaceholder}
        "data-mode": "smartcrop",
        alt: alt,
        // blurDataURL={DEFAULT_IMG_PLACEHOLDER}
        // placeholder="blur"
        // height={1000}
        // width={1000}
        // priority
        className: className,
        role: "presentation",
        ...restProps
    }, uniqueId);
};
/* harmony default export */ __webpack_exports__["default"] = (DynamicImage);


/***/ }),

/***/ 4801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27514);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2583);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82476);
/* harmony import */ var _components_FindStore_v1_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82423);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47956);








const ZipCodeInfoModal = (props)=>{
    const { staticTexts: { infoModalTitle ="" , messageZipcode ="" , continue: continueCtaLabel = ""  } = {} , data: { ctaLabel ="" , title ="" , message =""  } = {} , dataLayerPosition =""  } = props;
    const handleModalClose = (e)=>{
        if (props.data.ctaLink) {
            window.open(props.data.ctaLink);
        } else {
            var ref;
            props.handleModalClose();
            let label = ctaLabel ? ctaLabel : continueCtaLabel;
            if ((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.nodeName) === _constants__WEBPACK_IMPORTED_MODULE_6__.NODE_NAMES.IMG) {
                label = "close";
            }
            (0,_components_FindStore_v1_analytics__WEBPACK_IMPORTED_MODULE_5__/* .zipCodeInfoModalContinueAnalytics */ .CS)(label, dataLayerPosition);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__["default"], {
        showModal: props.show,
        className: props.className,
        onModalClose: handleModalClose,
        labelledBy: props.labelledBy,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "taxware-down-title",
                className: "taxware-down__title",
                children: title ? title : infoModalTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "taxware-down__desc",
                children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeInnerHtml */ .KD0)(message ? message : messageZipcode)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                tag: "button",
                customClass: "taxware-down__cta",
                role: "button",
                onClick: handleModalClose,
                flexible: true,
                label: ctaLabel ? ctaLabel : continueCtaLabel,
                useDefaultClass: true
            })
        ]
    });
};
_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__["default"].propTypes = {
    labelledBy: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    data: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
/* harmony default export */ __webpack_exports__["Z"] = (ZipCodeInfoModal);


/***/ }),

/***/ 94593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




const RadioButton = (param)=>{
    let { onKeydown , analyticsData , id ="" , name ="" , value =undefined , checked =undefined , onClick =()=>{}  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        onKeyDown: onKeydown,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
            radio: true
        }),
        htmlFor: id,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "radio",
                className: "radio__input " + (analyticsData ? "gbh-data-layer" : ""),
                "data-gbh-data-layer": analyticsData,
                name: name,
                id: id,
                checked: checked,
                onClick: onClick,
                onChange: onClick,
                "aria-checked": checked,
                "aria-label": value
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "radio__custom"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: value
            })
        ]
    });
};
RadioButton.propTypes = {
    id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string) || (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 15740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReCaptcha_ReCaptcha; },
  "L": function() { return /* binding */ validateRecaptcha; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/core/ReCaptcha/analytics.js

const getInternalLinkURLS = (url)=>{
    return (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) ? "true" : "false";
};
const setLinkAnalytics = function(linkUrl, type, getAnalyticsData) {
    let eventType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "navigation";
    if (!getAnalyticsData) return null;
    const { pageTitle ="n/a" , internalLinkPosition ="n/a" , internalLinkTypeWithType =null , internalLinkType =null , addNoFooterInAttr =false  } = getAnalyticsData;
    if (typeof type !== "string") {
        var ref;
        // this is html content
        const div = document.createElement("div");
        div.innerHTML = type;
        // This contains HTML code so remove some bugs here.
        type = (ref = div.innerText || div.textContent || "") === null || ref === void 0 ? void 0 : ref.toLowerCase();
        type = type.replaceAll("\n", "");
    } else {
        type = type.toLowerCase();
    }
    const eventAction = getAnalyticsData.pageTitle ? getAnalyticsData.pageTitle + ((getAnalyticsData === null || getAnalyticsData === void 0 ? void 0 : getAnalyticsData.addNoFooterInAttr) ? "" : ":form:footer") + ":" + type : "n/a";
    var ref1;
    const eventInfo = {
        clickInternalLinks: getInternalLinkURLS(linkUrl),
        eventAction: eventAction,
        eventName: eventAction,
        eventType,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type || "n/a",
        internalLinkPosition: internalLinkPosition !== null && internalLinkPosition !== void 0 ? internalLinkPosition : "n/a",
        internalLinkType: internalLinkTypeWithType ? internalLinkTypeWithType + ":" + type : internalLinkType !== null && internalLinkType !== void 0 ? internalLinkType : "n/a",
        internalLinkURL: linkUrl ? (linkUrl.indexOf("http") === -1 ? window.location.origin : "") + linkUrl : "n/a",
        internalLinkZoneName: (ref1 = (getAnalyticsData === null || getAnalyticsData === void 0 ? void 0 : getAnalyticsData.pageTitle) + ((getAnalyticsData === null || getAnalyticsData === void 0 ? void 0 : getAnalyticsData.addNoFooterInAttr) ? "" : ":form:footer")) !== null && ref1 !== void 0 ? ref1 : "n/a"
    };
    addAnalyticsForRecaptchLinks(eventInfo, "cmp:click");
};
const addAnalyticsForRecaptchLinks = function(eventInfo) {
    let event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cmp:click";
    const page = (0,helper/* getPageInfo */.UMn)();
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


// EXTERNAL MODULE: ./src/components/core/ReCaptcha/Recaptcha.module.scss
var Recaptcha_module = __webpack_require__(63898);
var Recaptcha_module_default = /*#__PURE__*/__webpack_require__.n(Recaptcha_module);
;// CONCATENATED MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx
/* eslint-disable no-undef */ 









let promiseResolve;
let promiseReject;
const validateRecaptcha = ()=>{
    return new Promise((resolve, reject)=>{
        (0,config/* getConfig */.i)().then((CONFIG)=>{
            try {
                const { isDisableRecaptcha  } = CONFIG.general;
                if (isDisableRecaptcha) {
                    return resolve({
                        success: isDisableRecaptcha
                    });
                }
                const { captcha: { captchaSiteKeyV3 , captchaThreshold  } , general: { siteName  }  } = CONFIG;
                promiseResolve = resolve;
                promiseReject = reject;
                grecaptcha.ready(()=>{
                    grecaptcha.reset();
                    grecaptcha.execute(captchaSiteKeyV3).then(async (token)=>{
                        try {
                            const { data  } = await (0,api/* aemAxiosInstance */.Gb)({
                                url: "/bin/kohler/google/captchaAuth?type=V3&access_token=".concat(token, "&brandName=").concat(siteName.toLowerCase()),
                                method: "GET"
                            });
                            if (data.score < captchaThreshold) {
                                grecaptcha.reset();
                                grecaptcha.execute();
                            } else {
                                return resolve(data);
                            }
                        } catch (error) {
                            reject(error);
                        }
                    }).catch((err1)=>reject(err1));
                });
            } catch (error) {
                reject(error);
            }
        });
    });
};
const ReCaptcha = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [links, setLinks] = (0,react.useState)({});
    const [state, setState] = (0,react.useState)({});
    const [i18n, seti18n] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const { legalPageLinks  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const getTranslations = (t)=>{
        return {
            protectedByGoogle: t("kf.associatemembership.label.protectedByGoogle"),
            privacyPolicyGoogle: t("kf.associatemembership.label.privacyPolicyGoogle"),
            privacyPolicy: t("kf.contactus.label.privacyPolicy"),
            termsOfService: t("kf.contactus.label.termsOfService"),
            and: t("kf.contactus.message.and"),
            apply: t("kf.contactus.message.apply")
        };
    };
    (0,react.useEffect)(()=>{
        seti18n(getTranslations(t));
        (0,config/* getConfig */.i)().then((config)=>{
            const { captcha: { captchaSiteKeyV2 , captchaSiteKeyV3  } , general: { siteName  }  } = config;
            setState({
                captchaSiteKeyV2,
                captchaSiteKeyV3,
                siteName
            });
        });
    }, []);
    (0,react.useEffect)(()=>{
        const { captchaSiteKeyV2 , captchaSiteKeyV3 , siteName  } = state;
        if (captchaSiteKeyV2 && captchaSiteKeyV3 && siteName) {
            loadRecaptcha();
            getLegalPages();
        }
    }, [
        state.captchaSiteKeyV2,
        state.captchaSiteKeyV3,
        state.siteName
    ]);
    (0,react.useEffect)(()=>{
        if (legalPageLinks) {
            const { googlePrivacyPolicy , googleTermsOfService  } = legalPageLinks;
            setLinks({
                googlePrivacyPolicy,
                googleTermsOfService
            });
        }
    }, [
        legalPageLinks
    ]);
    const getLegalPages = async ()=>{
        dispatch((0,genericSlice/* getLegalPageLinks */.go)());
    };
    const loadRecaptcha = ()=>{
        const { captchaSiteKeyV2 , captchaSiteKeyV3  } = state;
        const scriptExist = document.getElementById("recaptcha-key");
        if (!scriptExist) {
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js?render=".concat(captchaSiteKeyV3);
            script.id = "recaptcha-key";
            script.onload = function onload() {
                grecaptcha.ready(()=>{
                    grecaptcha.render("recaptcha-container", {
                        sitekey: captchaSiteKeyV2,
                        callback: (t)=>verifyToken(t)
                    });
                });
            };
            document.body.appendChild(script);
        } else {
            grecaptcha.ready(()=>{
                grecaptcha.render("recaptcha-container", {
                    sitekey: captchaSiteKeyV2,
                    callback: (t)=>verifyToken(t)
                });
            });
        }
    };
    const verifyToken = async (token)=>{
        const CONFIG = await (0,config/* getConfig */.i)();
        const { isDisableRecaptcha  } = CONFIG.general;
        if (isDisableRecaptcha) {
            promiseResolve({
                success: isDisableRecaptcha
            });
        }
        try {
            const { data  } = await (0,api/* aemAxiosInstance */.Gb)({
                url: "/bin/kohler/google/captchaAuth?type=V2&access_token=".concat(token, "&brandName=").concat(state.siteName.toLowerCase()),
                method: "GET"
            });
            promiseResolve(data);
        } catch (error) {
            promiseReject(err);
        }
    };
    const { getAnalyticsData ={} , isPopupNeededBeforeRedirection =true  } = props;
    const { googlePrivacyPolicy ="n/a" , googleTermsOfService ="n/a"  } = links;
    const { privacyPolicyGoogle ="" , termsOfService =""  } = i18n;
    const handleClickOfLinks = (e, text, url)=>{
        const eventType = isPopupNeededBeforeRedirection ? "navigation" : "informative";
        if (props.addReviewRegistrationEventInfo) {
            const eventReviewInfo = props.addReviewRegistrationEventInfo(text, url, "false");
            addAnalyticsForRecaptchLinks(eventReviewInfo);
        } else {
            setLinkAnalytics(url, text, getAnalyticsData, eventType);
        }
        if (isPopupNeededBeforeRedirection) (0,helper/* getSiteWideModal */.Ure)(e, url);
        else window.open(url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Recaptcha_module_default()).reCatichWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "recaptcha-container",
                    className: "g-recaptcha",
                    "data-size": "invisible"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-20 mb-20 recaptcha-links",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(i18n.protectedByGoogle, " ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gpolicies",
                            href: "#",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: (e)=>handleClickOfLinks(e, privacyPolicyGoogle, googlePrivacyPolicy),
                            children: privacyPolicyGoogle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                i18n.and,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gpolicies",
                            href: "#",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: (e)=>handleClickOfLinks(e, termsOfService, googleTermsOfService),
                            children: termsOfService
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                i18n.apply
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ReCaptcha_ReCaptcha = (ReCaptcha);


/***/ }),

/***/ 97729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36513);




const SmartCropImage = (param)=>{
    let { url , altText , smartCrop ={} , handleImgeClick =()=>{}  } = param;
    let s7Image;
    if (true) {
        s7Image = window.s7responsiveImage;
    }
    const pressImg = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const imgPlaceholder = url !== null && url !== void 0 ? url : "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (smartCrop.scriptStatus) {
            smartCrop.applySmartCrop(pressImg.current);
        }
    }, [
        smartCrop.scriptStatus,
        url,
        s7Image
    ]);
    const checkImg = (e)=>{
        e.persist();
        const ele = e.target;
        if (ele.src !== _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z && ele.src === imgPlaceholder) {
            axios__WEBPACK_IMPORTED_MODULE_2___default().head(ele.dataset.src).then((res)=>{
                if (!res) handleImgErr(e);
            }).catch(()=>handleImgErr(e));
        }
    };
    const handleImgErr = (e)=>e.target.src = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: pressImg,
        src: url ? imgPlaceholder : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
        "data-src": url,
        "data-mode": "smartcrop",
        onLoad: checkImg,
        onError: handleImgErr,
        alt: altText,
        onClick: handleImgeClick
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SmartCropImage);


/***/ }),

/***/ 41740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ag": function() { return /* binding */ getMoreInCollectionSlider; },
/* harmony export */   "__": function() { return /* binding */ callDesignServicesAddToCartAnalytics; },
/* harmony export */   "gA": function() { return /* binding */ callInstallServiceAddToCartAnalytics; }
/* harmony export */ });
/* unused harmony export getMoreInCollectionsInfo */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27514);
/**
 *
 * @param {Object} resInfo
 * @param {Object} productInfo
 * Kohler Data Layer Tech Spec 2021 - Batch 5 - Installation Services v1
 * Requirement#12 Add to Cart button
 */ 
const callInstallServiceAddToCartAnalytics = (param)=>{
    let { resInfo , productInfo , cartID , eventInfoObj  } = param;
    var ref;
    const { status , message ="n/a"  } = resInfo;
    const isStatus = status === 200;
    const eventInfo = eventInfoObj !== null && eventInfoObj !== void 0 ? eventInfoObj : {
        eventAction: "installer services:already have a product purchase a kohler installation service:add to cart",
        eventName: "installer services:already have a product purchase a kohler installation service:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: "installer services",
        internalLinkType: "installer services:in-person",
        internalLinkZoneName: "installer services:already have a product purchase a kohler installation service",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    page.cart = {
        cartID
    };
    (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const callDesignServicesAddToCartAnalytics = (resInfo, productInfo, serviceName, cartID)=>{
    const { status , message ="n/a"  } = resInfo;
    const isStatus = status === 200;
    const eventInfo = {
        eventAction: serviceName + ":virtual bathroom design service:add to cart",
        eventName: serviceName + ":virtual bathroom design service:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: serviceName,
        internalLinkType: serviceName + ":add to cart",
        internalLinkZoneName: serviceName + ":virtual bathroom design service",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    page.cart = {
        cartID
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const getMoreInCollectionsInfo = function(title, needsJSON) {
    let pdpNavigationURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", product = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const primaryCategory = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.primaryCategory;
    const type = (title === null || title === void 0 ? void 0 : title.toLowerCase()) === "recently viewed";
    const eventAction = "".concat(primaryCategory, ":").concat(sanitizeTextForAnalytics(title !== null && title !== void 0 ? title : ""), ":product navigation");
    const internalLinkURL = ((pdpNavigationURL === null || pdpNavigationURL === void 0 ? void 0 : pdpNavigationURL.indexOf("http")) === -1 ? window.location.origin : "") + pdpNavigationURL;
    const internalLinkZoneName = "".concat(primaryCategory, ":").concat(sanitizeTextForAnalytics(title !== null && title !== void 0 ? title : ""), ":preview");
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventNavigation: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(sanitizeTextForAnalytics(product === null || product === void 0 ? void 0 : product.name), " "),
        internalLinkPosition: primaryCategory,
        internalLinkType: "".concat(primaryCategory, ":navigation"),
        internalLinkURL,
        internalLinkZoneName,
        clickInternalLinks: "true"
    };
    if (type) {
        eventInfo.eventAction = "pdp:recently viewed:product navigation";
        eventInfo.eventName = "pdp:recently viewed:product navigation";
        eventInfo.internalLinkPosition = "pdp";
        eventInfo.internalLinkType = "pdp:navigation";
        eventInfo.internalLinkZoneName = "pdp:recently:viewed:preview";
    }
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const getMoreInCollectionSlider = (title)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const primaryCategory = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.primaryCategory;
    const eventAction = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(title !== null && title !== void 0 ? title : ""), ":product slider");
    const internalLinkZoneName = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(title !== null && title !== void 0 ? title : ""), ":preview");
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventNavigation: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "slider",
        internalLinkPosition: primaryCategory,
        internalLinkType: "".concat(primaryCategory, ":navigation"),
        internalLinkURL: "n/a",
        internalLinkZoneName,
        clickInternalLinks: "true"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};


/***/ }),

/***/ 15011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ productCardAddToCart; }
/* harmony export */ });
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19514);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64925);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88751);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20366);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87292);





const productCardAddToCart = async (items, showPreview, message, cb)=>{
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)();
    var ref;
    const salesChannels = (ref = CONFIG === null || CONFIG === void 0 ? void 0 : CONFIG.salesChannelConfig) !== null && ref !== void 0 ? ref : {};
    const actions = [];
    let userZipCode;
    items.forEach((product)=>{
        var _brand;
        const fields = {
            salesChannel: (_brand = salesChannels[product.brand]) !== null && _brand !== void 0 ? _brand : "KOUS"
        };
        if (product.backorder) fields.isBackOrderable = true;
        actions.push({
            action: product.isBundle ? "addbundle" : "addLineItem",
            sku: product.sku,
            quantity: product.quantity,
            custom: product.additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[product.brand],
                    roomInfo: product.additionalInfo.roomInfo,
                    customQuantity: product.additionalInfo.customQuantity,
                    overage: product.additionalInfo.overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: fields
            }
        });
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
    });
    const body = {
        actions: actions
    };
    if (userZipCode) {
        body.servicesku = true;
        body.zipCode = userZipCode;
    }
    _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
        if (res) {
            _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
            const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)(quantityLineItems);
            _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
            cb && cb({
                status: 200,
                message: "success"
            });
            if (message) {
                _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showToast */ .CF)(message));
            }
            if (showPreview) _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showPreviewCart */ .z0)());
        }
    });
};


/***/ }),

/***/ 79349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72433);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18216);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73350);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27514);
/* harmony import */ var _components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24701);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20558);
/* harmony import */ var _components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31720);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5702);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64925);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2693);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(88751);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36513);
/* harmony import */ var _public_icons_wish_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29875);
/* harmony import */ var _public_icons_wishlist_gray_filled_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(62084);
/* harmony import */ var _components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(14382);
/* harmony import */ var _components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21__);






















const ProductCard = (props)=>{
    const { authorData: { skewId ="" , presetConfigs ="{}"  } , isDefaultProductCard =true , isFavoriteIcon =false , selectedProduct ="" , hotspotClicked =false , toasterVar =false  } = props;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const { toaster  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .selectGenericState */ .Px);
    const { cart  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_14__/* .selectCartState */ .xw);
    const { favorites  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__/* .selectFavoritesState */ .Qx);
    const { isAuth  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__/* .selectAuthState */ ._9);
    const [presetConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(JSON.parse(presetConfigs));
    const myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [favFilled, setFavFilled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [productData, setState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        isLoading: false,
        image: "",
        isFavorite: false
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (selectedProduct === skewId) myRef === null || myRef === void 0 ? void 0 : (ref = myRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
    }, [
        selectedProduct,
        skewId,
        myRef,
        hotspotClicked
    ]);
    const [config, setConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [swatchUrl, setSwatchUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [toasterContent, setToasterContent] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const [pdpUrl, setPdpUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const staticTexts = {
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error")
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)().then((config)=>{
            setConfig(config);
            const swatchUrl = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.swatchUrl", "");
            setSwatchUrl(swatchUrl);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (skewId && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(config)) {
            const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getUserPersona */ .shu)();
            const brandName = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.siteName", "");
            const fl = [
                "id",
                "slug_s",
                "productName_s",
                "masterSKU_s",
                "Product_Category",
                "ProductBrandName_s",
                "productImages.url_ss",
                "SKUColorSwatchFilename_ss",
                "ProductDescriptionProductShort_s",
                "priceList.".concat(persona, ".price_d"),
                "priceList.".concat(persona, ".finalPrice_d"),
                "priceList.".concat(persona, ".discountedPrice_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "Color.SKU.Details_ss",
                "ProductWebFeatures_ss",
                "ProductWebFeatures_s",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "Color.TPR.Details_ss",
                "RegionBrandName_s",
                "metaTitle_s",
                "ctId_s",
                "CustomerFacingBrand_s"
            ];
            setState({
                ...productData,
                isLoading: true
            });
            try {
                var ref;
                var ref1;
                const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
                _constants_api__WEBPACK_IMPORTED_MODULE_7__/* .apim.get */ .TH.get("/search/plp", {
                    params: {
                        fl: fl.join(","),
                        q: "*:*",
                        fq: [
                            'sku_s:("'.concat(skewId, '")'),
                            'language_s:("'.concat(language, '")')
                        ],
                        collections: brandName.toLowerCase(),
                        profilename: "profile_".concat(brandName.toLowerCase(), "_General")
                    },
                    paramsSerializer: (params)=>{
                        return qs__WEBPACK_IMPORTED_MODULE_20___default().stringify(params, {
                            arrayFormat: "repeat",
                            encode: false
                        });
                    }
                }).then((res)=>{
                    if (res && res.data) {
                        var ref;
                        const productData = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(res.data, "response.docs[0]", {});
                        let imageId = "";
                        if (skewId.includes("-")) {
                            const skewIdPart = skewId.split("-");
                            const selectedVariant = skewIdPart.at(-1);
                            const imageData = productData["Color.TPR.Details_ss"].find((str)=>str.includes("-".concat(selectedVariant))).split("/");
                            imageId = imageData[imageData.length - 1];
                        }
                        const favoriteItem = favorites === null || favorites === void 0 ? void 0 : (ref = favorites.lineItems) === null || ref === void 0 ? void 0 : ref.find((favorite)=>favorite.variant.sku === skewId);
                        const isFavorite = favoriteItem ? true : false;
                        setFavFilled(isFavorite);
                        setState({
                            ...productData,
                            isLoading: false,
                            imageId,
                            currencySign: lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "internationalization.currencySign", ""),
                            isFavorite
                        });
                    } else {
                        // eslint-disable-next-line no-console
                        console.error("Error occured while fetching product data");
                    }
                });
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("Error occured while fetching product data", err);
            }
        }
    }, [
        config,
        favorites,
        isAuth
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            handleFavorite(loginFavouriteCallback);
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setToasterMessage();
    }, [
        toaster
    ]);
    const setToasterMessage = async ()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
            const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
            setToasterContent({
                successMessage: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Ppy)(successMessage),
                unfavoriteSuccessMessage: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Ppy)(unfavoriteSuccessMessage)
            });
        }
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__/* .setAuthModalVisibility */ .LY)({
            show: true
        }));
    };
    const handleFavorite = (e)=>{
        window.preActiveElement = e.target;
        e.stopPropagation();
        e.preventDefault();
        if (productData.isFavorite) {
            var ref;
            const favProduct = favorites === null || favorites === void 0 ? void 0 : (ref = favorites.lineItems) === null || ref === void 0 ? void 0 : ref.find((fav)=>fav.variant.sku === skewId);
            if (favProduct) {
                if (!isAuth) {
                    handleLogin(e);
                } else {
                    dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__/* .removeItems */ .Er)({
                        ids: [
                            favProduct.id
                        ]
                    })).unwrap().then(()=>{
                        const productInfo = (0,_components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_10__/* .getProductInfo */ .C)(productData, skewId, false, cart, config, description, persona);
                        (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsEventForFavouriteAddRemove */ .Xc)(false, productInfo);
                        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                            message: toasterContent.unfavoriteSuccessMessage || staticTexts.removeItem,
                            isVisible: true
                        }));
                    }).catch((err)=>{
                        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                            message: staticTexts.removeItemError,
                            isVisible: true
                        }));
                    });
                }
            }
        } else {
            if (!isAuth) {
                handleLogin(e);
            } else {
                dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__/* .addProduct */ .gK)(skewId)).unwrap().then(()=>{
                    const productInfo = (0,_components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_10__/* .getProductInfo */ .C)(productData, skewId, false, cart, config, description, persona);
                    (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsEventForFavouriteAddRemove */ .Xc)(true, productInfo);
                    dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                        message: toasterContent.successMessage || staticTexts.favSuccessMsg,
                        isVisible: true
                    }));
                }).catch((err)=>{
                    dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                        message: staticTexts.favErrorMsg,
                        isVisible: true
                    }));
                });
            }
        }
    };
    const getDescriptionWithElipsis = (isMobile, description)=>{
        const length = isMobile ? 41 : 45;
        if (description.length >= length) {
            if (description.charAt(length) === " ") {
                description = description.slice(0, length) + "...";
            } else {
                description = description.slice(0, length).split(" ");
                description.pop();
                description = description.join(" ") + "...";
            }
        }
        return description;
    };
    const productCategory = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "Product_Category", "");
    const slug = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "slug_s", "");
    const name = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "productName_s", "").split(" ").slice(" ")[0];
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getUserPersona */ .shu)();
    var _currencySign;
    const currencySign = (_currencySign = productData.currencySign) !== null && _currencySign !== void 0 ? _currencySign : "";
    const price = Number(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "priceList.".concat(persona, ".price_d"), 0)).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    let description = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "ProductDescriptionProductShort_s", "");
    const isMobile =  true ? window.matchMedia("(max-width: 1038px)").matches : 0;
    description = getDescriptionWithElipsis(isMobile, description);
    const reginalBrandName = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "RegionBrandName_s", "");
    const productBrand = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "CustomerFacingBrand_s", "");
    const { imageId =""  } = productData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(productData) && slug) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getPDPUrl */ .ir5)(productCategory, slug).then((url)=>setPdpUrl(url));
        }
    }, [
        productData,
        slug
    ]);
    if (productData.isLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "product-card-loader__container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "filter__inner-container shimmer height-300"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "filter__footer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "products-per-page width-240 mt60 mb20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "shimmer-loading__headpara shimmer"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "products-per-page width-100",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "shimmer-loading__para shimmer"
                            })
                        })
                    ]
                })
            ]
        });
    }
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: myRef,
        className: (_components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().productCardWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "inspired-selling-module__card-container",
            style: {
                border: skewId === selectedProduct ? "3px solid var(--Gray-Gray300, #CDCDCD)" : "",
                boxShadow: skewId === selectedProduct ? "0px 0px 20px 0px rgba(0, 0, 0, 0.40)" : "",
                width: toasterVar ? "165px" : "100%"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                onClick: ()=>(0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__/* .shopRoomhandleProductClick */ .dv)({
                        productData: productData,
                        sku: skewId,
                        url: "".concat(pdpUrl).concat(skewId ? "?skuId=" + skewId : "", "}"),
                        cart: cart,
                        config: config,
                        description: description,
                        persona: persona
                    }),
                href: "".concat(pdpUrl).concat(skewId ? "?skuId=" + skewId : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "inspired-selling-module__card",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "image__container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: "product-card__image",
                                    alt: "",
                                    src: (ref = (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .getPresetUrl */ .v$)(width, 0, swatchUrl, imageId, presetConfig)) !== null && ref !== void 0 ? ref : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z,
                                    onError: (e)=>e.target.src = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z
                                })
                            }),
                            isFavoriteIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-tile__share",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    id: "kf-add-to-fav-".concat(skewId),
                                    className: "product-tile__share-icon",
                                    tabIndex: "0",
                                    onClick: handleFavorite,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        role: "presentation",
                                        src: favFilled ? _public_icons_wishlist_gray_filled_svg__WEBPACK_IMPORTED_MODULE_19__/* ["default"].src */ .Z.src : _public_icons_wish_svg__WEBPACK_IMPORTED_MODULE_18__/* ["default"].src */ .Z.src,
                                        alt: ""
                                    })
                                })
                            }) : null
                        ]
                    }),
                    isDefaultProductCard ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-text__container",
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card-details__container",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "card-details__card-title-container",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            style: {
                                                color: toaster ? "#494949" : ""
                                            },
                                            children: name
                                        })
                                    }),
                                    !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "card-details__card-price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "".concat(currencySign).concat(price)
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "card-details-descriprion__container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: description
                                })
                            }),
                            isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "card-details__card-price",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "".concat(currencySign).concat(price)
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "shop-the-room-card-details",
                        style: {
                            color: toasterVar ? "#494949" : ""
                        },
                        children: [
                            !toasterVar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "brand-name",
                                style: {
                                    color: toasterVar ? "#494949" : ""
                                },
                                children: productBrand
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "regional-brand-name",
                                style: {
                                    color: toasterVar ? "#494949" : ""
                                },
                                children: reginalBrandName
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "short-description",
                                style: {
                                    color: toasterVar ? "#494949" : "",
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    webkitLineClamp: "2",
                                    webkitBoxOrient: "vertical"
                                },
                                children: description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "price",
                                style: {
                                    color: toasterVar ? "#494949" : ""
                                },
                                children: "".concat(currencySign).concat(price)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCard);


/***/ }),

/***/ 24701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getProductInfo; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27514);


const getProductInfo = function(productData, sku) {
    let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, cart = arguments.length > 3 ? arguments[3] : void 0, config = arguments.length > 4 ? arguments[4] : void 0, description = arguments.length > 5 ? arguments[5] : void 0, persona = arguments.length > 6 ? arguments[6] : void 0;
    var ref;
    const { productCouponCode , productCoupondiscount  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentSkuCouponDiscounts */ .mPk)({
        cart: cart,
        sku: sku
    });
    const colorDetails = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "Color.SKU.Details_ss", []);
    var ref1;
    const colorDetail = (ref1 = colorDetails.find((colorDetail)=>colorDetail.includes(sku))) !== null && ref1 !== void 0 ? ref1 : "|";
    const color = colorDetail.split("|")[0];
    const productInfo = {
        productInfo: {
            productBrand: (ref = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(config, "general.siteName", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            description: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(description) || "n/a").toLowerCase(),
            globalPromotionPrice: Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "priceList.".concat(persona, ".discountedPrice_d"), 0)).toFixed(2),
            productBasePrice: Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "priceList.".concat(persona, ".price_d"), 0)).toFixed(2),
            productCategory: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(productData["Product_Category"]) || "n/a").toLowerCase(),
            productColor: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(color) || "n/a").toLowerCase(),
            productName: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "productName_s", "")) || "n/a").toLowerCase(),
            productFindingMethod: "n/a",
            productCouponCode: productCouponCode.join("|") || "n/a",
            productCoupondiscount: productCoupondiscount,
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            quantity: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a"
        }
    };
    if (needsJSON) {
        return productInfo.productInfo;
    }
    return productInfo;
};


/***/ }),

/***/ 83839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7154);


const useSmartCrop = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const [scriptStatus, setScriptStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!isSsr && window.s7responsiveImage ? true : false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!isSsr) {
            loadSmartcrop();
        }
    }, [
        isSsr
    ]);
    const loadSmartcrop = ()=>{
        const scriptExist = document.querySelectorAll("script#smartcrop-react");
        if (scriptExist.length === 0 && !window.s7responsiveImage) {
            const script = document.createElement("script");
            script.src = "/js/responsive-images.js";
            script.id = "smartcrop-react";
            script.onload = function onload() {
                setScriptStatus(true);
            };
            document.body.appendChild(script);
        } else {
            setScriptStatus(true);
        }
    };
    const applySmartCrop = (ele)=>{
        window.s7responsiveImage && window.s7responsiveImage(ele);
    };
    return {
        scriptStatus,
        applySmartCrop
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSmartCrop);


/***/ }),

/***/ 1056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72433);

const useAuthUtilityNavi18n = ()=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        signIn: t("Sign In"),
        createAccount: t("Create Account"),
        hi: t("kf.auth.label.hi"),
        title: t("kf.auth.label.bannerMssg"),
        welcome: t("kf.auth.label.welcome"),
        logout: t("kf.auth.label.logout"),
        rightArrowAlt: t("kf.auth.label.rightArrowAlt"),
        leftArrowAlt: t("kf.auth.label.rightArrowAlt"),
        menu: t("kf.auth.label.menu"),
        expanded: t("kf.auth.label.expanded"),
        collapsed: t("kf.auth.label.collapsed"),
        user: t("kf.auth.label.user")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuthUtilityNavi18n);


/***/ }),

/***/ 95511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72433);

const useFindStorei18n = (param)=>{
    let { authorData  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        userMyLocation: authorData.userMyLocation ? authorData.userMyLocation : t("kf.findstore.label.userMyLocation"),
        kohlerStores: authorData.kohlerStores ? authorData.kohlerStores : t("kf.findstore.label.kohlerStores"),
        showrooms: authorData.showrooms ? authorData.showrooms : t("kf.findstore.label.showrooms"),
        showroom: authorData.showroom ? authorData.showroom : t("kf.findstore.label.showrooms"),
        kohlerStore: authorData.kohlerStore ? authorData.kohlerStore : t("kf.findstore.label.kohlerStore"),
        annsacksShowroom: authorData.annsacksShowroom ? authorData.annsacksShowroom : t("kf.findstore.label.annsacksShowroom"),
        partsDealer: authorData.partsDealer ? authorData.partsDealer : t("kf.findstore.label.partsDealer"),
        homeCenter: authorData.homeCenter ? authorData.homeCenter : t("kf.findStore.label.homeCenter"),
        genuinePartsDealers: authorData.genuinePartsDealers ? authorData.genuinePartsDealers : t("kf.findstore.label.genuinePartsDealers"),
        kohler: t("kf.findStoreUtilNav.label.kohler"),
        annSacks: authorData.annSacks ? authorData.annSacks : t("kf.findstore.label.annSacks"),
        annSacksText: authorData.annSacksText ? authorData.annSacksText : t("kf.findstore.label.annSacksText"),
        countryPlaceholder: authorData.countryPlaceholder ? authorData.countryPlaceholder : t("kf.findstore.label.countryPlaceholder"),
        locationErrormessage: authorData.locationErrormessage ? authorData.locationErrormessage : t("kf.findstore.label.locationErrormessage"),
        clearAll: t("kf.plp.label.clearAll"),
        viewList: authorData.viewList ? authorData.viewList : t("kf.findstore.label.viewList"),
        viewMap: authorData.viewMap ? authorData.viewMap : t("kf.findstore.label.viewMap"),
        applyFilters: authorData.applyFilters ? authorData.applyFilters : t("kf.findstore.label.applyFilters"),
        filters: t("kf.plp.label.filters"),
        viewStoreDetail: t("kf.findStoreUtilNav.label.viewStoreDetail"),
        storeDetail: t("kf.findStoreUtilNav.label.storeDetail"),
        miles: authorData.miles ? authorData.miles : t("kf.findstore.label.miles"),
        away: authorData.away ? authorData.away : t("kf.findstore.label.away"),
        browseAllStore: authorData.browseAllStore ? authorData.browseAllStore : t("kf.findstore.label.browseAllStore"),
        setAsMyStore: t("kf.findStoreUtilNav.label.setAsMystore"),
        home: authorData.home ? authorData.home : t("kf.findstore.label.home"),
        findStore: authorData.findstore ? authorData.findstore : t("kf.findstore.label.findstore"),
        kohlerStoreImgAlt: t("kf.findstore.label.kohlerStoreImgAlt"),
        viewResults: t("kf.plp.label.viewResults"),
        view: t("kf.plp.label.view"),
        results: t("kf.plp.label.results"),
        filterImgAlt: t("kf.findstore.label.filterImgAlt"),
        myStore: t("kf.findStoreUtilNav.label.myStore"),
        retailStore: authorData.retailStore ? authorData.retailStore : t("kf.findstore.label.retailStore"),
        retailMobileText: t("kf.findstore.label.retailMobileText"),
        infoModalTitle: t("kf.findStoreUtilNav.messageTitleZipcode"),
        ariaLabel: {
            enterZipcode: t("kf.findStoreUtilNav.aria.label.enterZipCode"),
            showFilter: t("kf.findstore.aria.label.showFilter"),
            hideFilter: t("kf.findstore.aria.label.hideFilter"),
            browseAll: t("kf.findstore.aria.label.browseAll"),
            contact: (phone)=>t("kf.findStore.aria.label.contact", {
                    phone
                }),
            mapMarker: t("kf.findstore.aria.label.mapMarker"),
            mapGuidelines: t("kf.findstore.aria.label.mapGuidelines"),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page")
        },
        messageZipcode: t("kf.findStoreUtilNav.MessageZipcode"),
        continue: t("kf.checkout.label.continue"),
        expanded: t("kf.productTab.aria.expanded"),
        collapsed: t("kf.productTab.aria.collapsed"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            })
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useFindStorei18n);


/***/ }),

/***/ 31090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72433);

const useSearchi18n = (param)=>{
    let { componentProp  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        searchPlaceHolder: t("kf.technical.label.searchPlaceHolder"),
        for: t("kf.search.label.for"),
        searchInstead: t("kf.search.label.searchInstead"),
        showing: t("kf.search.label.showing"),
        results: t("kf.search.label.results"),
        resultsCaps: t("kf.search.label.resultsCaps"),
        addToCart: t("kf.compare.label.addToCart"),
        products: t("kf.search.label.products"),
        parts: t("kf.search.label.parts"),
        technical: t("kf.search.label.technical"),
        inspiration: t("kf.search.label.inspiration"),
        resource: t("kf.search.label.resource"),
        help: t("kf.search.label.help"),
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: t("kf.plp.label.showFilter"),
        hideFilter: t("kf.plp.label.hideFilter"),
        filters: t("kf.plp.label.filters"),
        filterSort: t("kf.plp.label.filterSort"),
        addToCompare: t("kf.plp.label.addToCompare"),
        colors: t("kf.plp.label.colors"),
        color: t("kf.plp.label.color"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        sort: t("kf.plp.label.sort"),
        applyFilters: "Apply Filters",
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        showMore: t("kf.plp.label.showMore"),
        showLess: t("kf.plp.label.showLess"),
        clearAll: t("kf.plp.label.clearAll"),
        priceRangeTitle: t("kf.plp.label.priceRangeTitle"),
        priceRangeDesc: t("kf.plp.label.priceRangeDesc"),
        to: t("kf.plp.label.to"),
        minText: t("kf.plp.label.minText"),
        maxText: t("kf.plp.label.maxText"),
        bestSellers: t("kf.plp.label.bestSellers"),
        featured: t("kf.plp.label.featured"),
        onSale: t("kf.plp.label.onSale"),
        relevancy: t("kf.plp.label.relevancy"),
        date: t("kf.plp.label.date"),
        priceDesc: t("kf.plp.label.priceDesc"),
        priceAsc: t("kf.plp.label.priceAsc"),
        atoz: t("kf.plp.label.atoz"),
        ztoa: t("kf.plp.label.ztoa"),
        gridView: t("kf.plp.label.gridView"),
        columnView: t("kf.plp.label.columnView"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: t("kf.compare.validation.maxProducts"),
        errors: {
            validRange: t("kf.plp.error.validRange"),
            minGreaterThanMax: t("kf.plp.error.minGreaterThanMax"),
            maxGreaterThanZero: t("kf.plp.error.maxGreaterThanZero"),
            checkValid: t("kf.error.message.price")
        },
        new: t("kf.plp.label.new"),
        sale: t("kf.plp.label.sale"),
        category: t("kf.technical.label.category"),
        collection: t("kf.technical.label.collection"),
        certifications: t("kf.technical.label.certifications"),
        designFiles: t("kf.technical.label.designFiles"),
        technicalInfo: t("kf.pdp.label.specs"),
        installationSupport: t("kf.pdp.label.installationSupport"),
        addToFolder: t("kf.technical.label.addToFolder"),
        selectAll: t("kf.technical.label.selectAll"),
        download: t("kf.technical.label.download"),
        downloading: t("kf.technical.label.downloading"),
        hideDiscontinued: t("kf.plp.label.hideDiscontinued"),
        file: t("kf.technical.label.file"),
        files: t("kf.technical.label.files"),
        specsSheet: t("kf.technical.label.specsSheet"),
        envDeclaration: t("kf.technical.label.envDeclaration"),
        installationGuide: t("kf.technical.label.installationGuide"),
        userGuide: t("kf.technical.label.userGuide"),
        homeOwnerGuide: t("kf.technical.label.homeOwnerGuide"),
        declareLabel: t("kf.technical.label.declareLabel"),
        tearSheet: t("kf.technical.label.tearSheet"),
        quickReference: t("kf.technical.label.quickReference"),
        warranty: t("kf.technical.label.warranty"),
        serviceParts: t("kf.technical.label.serviceParts"),
        suggestions: t("kf.search.label.suggestions"),
        checkSpelling: t("kf.search.label.checkSpelling"),
        simplerWord: t("kf.search.label.simplerWord"),
        searchSimilar: t("kf.search.label.searchSimilar"),
        popularSearch: t("kf.search.label.trendingSearch"),
        commonTopics: t("kf.search.label.commonTopics"),
        noResults: t("kf.search.label.noResults"),
        loading: t("kf.search.label.loading"),
        twoDplan: t("kf.technical.label.twoDplan"),
        twoDside: t("kf.technical.label.twoDside"),
        twoDfront: t("kf.technical.label.twoDfront"),
        threeDfile: t("kf.technical.label.threeDfile"),
        bimFile: t("kf.technical.label.bimFile"),
        cutoutTemplate: t("kf.technical.label.cutoutTemplate"),
        viewResults: t("kf.plp.label.viewResults"),
        popularSearchText: t("kf.search.label.trendingSearch"),
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        searchBrand: t("kf.search.label.searchBrand"),
        brand: t("kf.search.label.brand"),
        items: t("kf.plp.label.items"),
        etc: t("kf.plp.label.etc"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        discontinuedText: t("kf.pdp.label.discontinuedTxt"),
        partsDiagram: t("kf.pdp.label.partsDiagram"),
        guides: t("kf.technical.label.guides"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        ariaLabel: {
            tabs: (count, tabName)=>t("kf.search.aria.label.tabs", {
                    count,
                    tabName
                }),
            loadMore: t("kf.search.aria.label.loadMore"),
            loadMoreArticles: t("kf.search.aria.label.loadMoreArticles"),
            close: t("kf.search.aria.label.clear"),
            addToCompare: (product)=>t("kf.plp.label.aria.addToCompare", {
                    product
                }),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page"),
            columnViewSelected: t("kf.productTab.aria.columnViewSelected"),
            columnViewNotSelected: t("kf.productTab.aria.columnViewNotSelected"),
            gridViewSelected: t("kf.productTab.aria.gridViewSelected"),
            gridViewNotSelected: t("kf.productTab.aria.gridViewNotSelected"),
            breadcrumb: t("kf.pdp.label.aria.breadcrumb")
        },
        home: t("kf.technical.label.home"),
        searchResults: t("kf.technical.label.searchResults"),
        searchText: t("kf.search.label.searchText"),
        searchNoResultErrorMessage: (componentProp === null || componentProp === void 0 ? void 0 : componentProp.searchFilterErrorMsg) ? componentProp === null || componentProp === void 0 ? void 0 : componentProp.searchFilterErrorMsg : t("kf.search.label.noResultsMssg"),
        noResults: t("kf.search.label.noResults"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            }),
        arialLabelPrint: (val)=>t("kf.plp.label.aria.print", {
                val: val
            }),
        ariaLabelShare: (val)=>t("kf.plp.label.aria.share", {
                val: "".concat(val, " page")
            }),
        favorites: t("kf.account.label.favorites"),
        removeItem: t("kf.favorites.removeItem"),
        downloadSuccess: t("kf.PressRoom.label.downloadSuccess"),
        downloadFailure: t("kf.PressRoom.label.downloadFailure"),
        perBox: t("annsacks.pdpProductSummary.label.perBox"),
        perEach: t("annsacks.pdpProductSummary.label.perEach"),
        perSF: t("annsacks.pdpProductSummary.label.perSF"),
        perLF: t("annsacks.pdpProductSummary.label.perLF")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSearchi18n);


/***/ }),

/***/ 89299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ sanitizeText; }
/* harmony export */ });
const sanitizeText = (text)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    if (!text) return "";
    return (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = text === null || text === void 0 ? void 0 : text.replace(/<[^>]*>/g, "") // Remove HTML tags
    ) === null || ref === void 0 ? void 0 : ref.replace(/&amp;/g, "&") // Convert &amp; to &
    ) === null || ref1 === void 0 ? void 0 : ref1.replace(/&lt;/g, "<") // Convert &lt; to <
    ) === null || ref2 === void 0 ? void 0 : ref2.replace(/&gt;/g, ">") // Convert &gt; to >
    ) === null || ref3 === void 0 ? void 0 : ref3.replace(/&quot;/g, '"') // Convert &quot; to "
    ) === null || ref4 === void 0 ? void 0 : ref4.replace(/&#039;/g, "'") // Convert &#039; to '
    ) === null || ref5 === void 0 ? void 0 : ref5.replace(/&#39;/g, "'") // Convert &#39; to '
    ) === null || ref6 === void 0 ? void 0 : ref6.trim();
};


/***/ }),

/***/ 26564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainMenu":"Mainmenu_mainMenu__PCspr","mainNavigationBarWrapper":"Mainmenu_mainNavigationBarWrapper__4HQPa","showBackgroundRelative":"Mainmenu_showBackgroundRelative__i_TBd","fixedNav":"Mainmenu_fixedNav__C9_Wc","showSticky":"Mainmenu_showSticky__382RG"};

/***/ }),

/***/ 58933:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loginMenu":"LoginMenu_loginMenu__j9pXC","loginMenuContent":"LoginMenu_loginMenuContent__kGinp","loginMenuContentList":"LoginMenu_loginMenuContentList__t9_Cy","loginMenuContentListLastItem":"LoginMenu_loginMenuContentListLastItem__nkHvv","loginMenuMobileClose":"LoginMenu_loginMenuMobileClose__dcfJJ","loginMenuMobileBackText":"LoginMenu_loginMenuMobileBackText__qLqD_","loginMenuMobileCloseIcon":"LoginMenu_loginMenuMobileCloseIcon__iOo54","loginMenuGridGap":"LoginMenu_loginMenuGridGap__9DN5d","loginMenuHeading":"LoginMenu_loginMenuHeading__JvqOV","loginMenuContentListItem":"LoginMenu_loginMenuContentListItem__gBXcz","loginMenuContentListGroup":"LoginMenu_loginMenuContentListGroup__GjWS7","loginMenuContentListRightGroup":"LoginMenu_loginMenuContentListRightGroup__YH2hP","loginMenuContentListRightGroupLoggedOut":"LoginMenu_loginMenuContentListRightGroupLoggedOut__lhO3S","loginMenuContentListItemLoggedOut":"LoginMenu_loginMenuContentListItemLoggedOut__iKZWq","loginMenuBackdrop":"LoginMenu_loginMenuBackdrop__qZJeW"};

/***/ }),

/***/ 46980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigationItemUnselected":"NavigationItem_navigationItemUnselected__Lcbc3","navigationItemSelectedDefault":"NavigationItem_navigationItemSelectedDefault__f32j0","navigationItemDefault":"NavigationItem_navigationItemDefault__kvjYv","navigationItemUniversal":"NavigationItem_navigationItemUniversal__WulGk","navigationItemSelectedUniversal":"NavigationItem_navigationItemSelectedUniversal__0puOT","navigationItem":"NavigationItem_navigationItem__7p4ZG","navigationItemSelected":"NavigationItem_navigationItemSelected__8zWBK"};

/***/ }),

/***/ 69472:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainNavGlobal":"MainNavigationBar_mainNavGlobal___h2Jb","mainNavUniversal":"MainNavigationBar_mainNavUniversal__om7n9","navItemUniversal":"MainNavigationBar_navItemUniversal__5QdBZ","mainNav":"MainNavigationBar_mainNav__wabw3","utilities":"MainNavigationBar_utilities__q8cHD","brandLogo":"MainNavigationBar_brandLogo__AE_uD","navItem":"MainNavigationBar_navItem__a9BkT","mainNavBackground":"MainNavigationBar_mainNavBackground__0_pc7","mainNavRelative":"MainNavigationBar_mainNavRelative__0hTCT","mainNavAtTop":"MainNavigationBar_mainNavAtTop__BQiCE","mainNavNotAtTop":"MainNavigationBar_mainNavNotAtTop__gJ0HY","mainNavVisible":"MainNavigationBar_mainNavVisible___7Bys","mainNavFixed":"MainNavigationBar_mainNavFixed__11IQ7","mainNavShadow":"MainNavigationBar_mainNavShadow__Sst0v","mainNavWrapperDefault":"MainNavigationBar_mainNavWrapperDefault__CFyx_","mainNavWrapperUniversal":"MainNavigationBar_mainNavWrapperUniversal__I5Itn","menuItemsVTwo":"MainNavigationBar_menuItemsVTwo__vJrPF","menuItems":"MainNavigationBar_menuItems__Rmewz","menuItemsUniversal":"MainNavigationBar_menuItemsUniversal__0hk_w","mainNavMobileRow":"MainNavigationBar_mainNavMobileRow__RNhrJ","leftGroup":"MainNavigationBar_leftGroup__YD2H_","menuIconUniversal":"MainNavigationBar_menuIconUniversal__D56g1","menuIconVTwo":"MainNavigationBar_menuIconVTwo__mmhs3","menuIconGlobal":"MainNavigationBar_menuIconGlobal__5T_iu","menuIconUniversalUS":"MainNavigationBar_menuIconUniversalUS__28omU","menuLinks":"MainNavigationBar_menuLinks__TOpmd","menuLinksWrapper":"MainNavigationBar_menuLinksWrapper__UAIsd","menuLinksUniversal":"MainNavigationBar_menuLinksUniversal__7qEu1","utilitiesDefaultGap":"MainNavigationBar_utilitiesDefaultGap__M0EPI","utilitiesUniversalGap":"MainNavigationBar_utilitiesUniversalGap__OsmmE","buttonCTA":"MainNavigationBar_buttonCTA__BVUUO","utilitiesMobile":"MainNavigationBar_utilitiesMobile__bUZ3c","utilitiesSearch":"MainNavigationBar_utilitiesSearch__gm_at","utilitiesSearchMobile":"MainNavigationBar_utilitiesSearchMobile__jMP7Z","utilitiesSearchIcon":"MainNavigationBar_utilitiesSearchIcon__U7iMg","cartBadge":"MainNavigationBar_cartBadge__mdhwg","navigationOverlayMenuWrapper":"MainNavigationBar_navigationOverlayMenuWrapper__2m3y8","navigationItemWrapper":"MainNavigationBar_navigationItemWrapper__Jlbif","navigationOverlayMenuVisible":"MainNavigationBar_navigationOverlayMenuVisible__tem1l","mobileOverlayMenu":"MainNavigationBar_mobileOverlayMenu___YKO2","navItemUnderline":"MainNavigationBar_navItemUnderline__zjwgW","appointmentSearchIcons":"MainNavigationBar_appointmentSearchIcons__9Bs9h","desktopIconsButtons":"MainNavigationBar_desktopIconsButtons__g_iFO","orderRequest":"MainNavigationBar_orderRequest__14OPx","designerTradeText":"MainNavigationBar_designerTradeText__TiXL7","requestAppointmentCTA":"MainNavigationBar_requestAppointmentCTA__5O1JY","searchWrapper":"MainNavigationBar_searchWrapper__doEy2","searchText":"MainNavigationBar_searchText__tu9so","searchIcon":"MainNavigationBar_searchIcon__ayMCk","menuItemDivider":"MainNavigationBar_menuItemDivider__YgQeb","navItemUnderlineV2":"MainNavigationBar_navItemUnderlineV2__sPJbz"};

/***/ }),

/***/ 59658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlayMenu":"OverlayMenu_overlayMenu__YFw8B","overlayMenuCategoryTitle":"OverlayMenu_overlayMenuCategoryTitle__DdhrB","overlayMenuLinkGridMainMobileWrapper":"OverlayMenu_overlayMenuLinkGridMainMobileWrapper__4cWrt","overlayMenuLinkGridWrapper":"OverlayMenu_overlayMenuLinkGridWrapper__JIw6N","overlayMenuLinkGridMobileWrapper":"OverlayMenu_overlayMenuLinkGridMobileWrapper__PHxJz","overlayMenuLinkGridListsMobile":"OverlayMenu_overlayMenuLinkGridListsMobile__EOEK1","overlayMenuLinkGridLists":"OverlayMenu_overlayMenuLinkGridLists__yBQFV","overlayMenuLinkGrid":"OverlayMenu_overlayMenuLinkGrid__gPN29","overlayMenuMobileImages":"OverlayMenu_overlayMenuMobileImages__aLQtm","overlayMenuLinkCloseButtonMobile":"OverlayMenu_overlayMenuLinkCloseButtonMobile__rTQfP","overlayMenuLinkLevelOneMobile":"OverlayMenu_overlayMenuLinkLevelOneMobile__TeOyu","arrowLeftIcon":"OverlayMenu_arrowLeftIcon__rYsFX","demo":"OverlayMenu_demo__q8XfC","underline":"OverlayMenu_underline__uc99l","underlineNoTransition":"OverlayMenu_underlineNoTransition__FFUU6","TabbedNavigationHorizontal_tabNavigationHorizontal__RwfC5":"OverlayMenu_TabbedNavigationHorizontal_tabNavigationHorizontal__RwfC5__EhIJr","menuItemDivider":"OverlayMenu_menuItemDivider__ZNSst","overlayMenuTitleText":"OverlayMenu_overlayMenuTitleText__XK9Th","p":"OverlayMenu_p__qNf2_","overlayMenuMobileTitle":"OverlayMenu_overlayMenuMobileTitle__pP0sc","shopAllCTA":"OverlayMenu_shopAllCTA__MdPIA","shopAllCTAFixed":"OverlayMenu_shopAllCTAFixed__dZSou"};

/***/ }),

/***/ 16789:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlayMenuCategory":"OverlayMenuCategory_overlayMenuCategory__yvZZf","overlayMenuCategoryCTA":"OverlayMenuCategory_overlayMenuCategoryCTA__keYTa","overlayMenuCategoryTitle":"OverlayMenuCategory_overlayMenuCategoryTitle__7KXlJ","overlayMenuCategoryOpen":"OverlayMenuCategory_overlayMenuCategoryOpen__mj8U7","overlayMenuCategoryLinks":"OverlayMenuCategory_overlayMenuCategoryLinks__aFk0f","overlayMenuCategoryLinksLink":"OverlayMenuCategory_overlayMenuCategoryLinksLink__RODVr","iconTransitionArrowClosed":"OverlayMenuCategory_iconTransitionArrowClosed__umwp2","iconTransitionArrowOpen":"OverlayMenuCategory_iconTransitionArrowOpen__4MzYv","overlayMenuCategoryTitleLink":"OverlayMenuCategory_overlayMenuCategoryTitleLink__BifbD","arrowDownIcon":"OverlayMenuCategory_arrowDownIcon__on_R_","overlayMenuCategoryDivider":"OverlayMenuCategory_overlayMenuCategoryDivider__8Rz58","overlayMenuCategoryTitleText":"OverlayMenuCategory_overlayMenuCategoryTitleText___i1rA"};

/***/ }),

/***/ 52638:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlayMenuImage":"OverlayMenuImage_overlayMenuImage__PVGd6","overlayMenuImageCTA":"OverlayMenuImage_overlayMenuImageCTA__HzxVH","overlayMenuImageWidth":"OverlayMenuImage_overlayMenuImageWidth__2fANG"};

/***/ }),

/***/ 77738:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlayMenuItem":"OverlayMenuItem_overlayMenuItem__vtU7O"};

/***/ }),

/***/ 77023:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlayMenuLinks":"OverlayMenuLinks_overlayMenuLinks__0VuCC","overlayMenuCategoryLinksCTA":"OverlayMenuLinks_overlayMenuCategoryLinksCTA__NJ3FO","overlayMenuLinksNoMargin":"OverlayMenuLinks_overlayMenuLinksNoMargin__9i0xq","overlayMenuCategoryLinksLink":"OverlayMenuLinks_overlayMenuCategoryLinksLink__mP_Wa","overlayMenuLinksList":"OverlayMenuLinks_overlayMenuLinksList__QDcTV","overlayMenuCategoryLinksTitleLink":"OverlayMenuLinks_overlayMenuCategoryLinksTitleLink__1aWIp","overlayMenuCategoryLinksTitleLinkCTA":"OverlayMenuLinks_overlayMenuCategoryLinksTitleLinkCTA___ekQO","overlayMenuCategoryLinksLinkComponent":"OverlayMenuLinks_overlayMenuCategoryLinksLinkComponent__uBaeV","liVBY":"OverlayMenuLinks_liVBY__nSRQb","dsm-typography-span-paragraph-medium":"OverlayMenuLinks_dsm-typography-span-paragraph-medium__4EukN"};

/***/ }),

/***/ 34504:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlayMenuTabs":"OverlayMenuTabs_overlayMenuTabs__9qkY1"};

/***/ }),

/***/ 4333:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promoBanner":"PromoBanner_promoBanner__ksdBT","promoBannerMain":"PromoBanner_promoBannerMain__E3Qql","promoBannerContent":"PromoBanner_promoBannerContent__2UoWJ","promoBannerLink":"PromoBanner_promoBannerLink__D9r1t","bannerGrey":"PromoBanner_bannerGrey__VjB09","bannerBlue":"PromoBanner_bannerBlue__xuURs","bannerPlumb":"PromoBanner_bannerPlumb__jQtWR"};

/***/ }),

/***/ 42830:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"ZipCodeInputField_inputContainer__fPnBm","inputFieldButton":"ZipCodeInputField_inputFieldButton__0zyP6","input":"ZipCodeInputField_input__eZoHG"};

/***/ }),

/***/ 40400:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storeMenu":"StoreMenu_storeMenu__oXfzC","storeMenuMainGrid":"StoreMenu_storeMenuMainGrid__NAMmE","storeMenuMainContent":"StoreMenu_storeMenuMainContent__hOlaI","storeMenuMainFullContent":"StoreMenu_storeMenuMainFullContent__7KquB","storeMenuContentHeading":"StoreMenu_storeMenuContentHeading___2Jr1","storeMenuContentInfoContainer":"StoreMenu_storeMenuContentInfoContainer__2ljXW","storeMenuContentInfo":"StoreMenu_storeMenuContentInfo__HfdVq","storeMenuZipContainer":"StoreMenu_storeMenuZipContainer__Pk0Rh","storeMenuContentZipContainerEyebrow":"StoreMenu_storeMenuContentZipContainerEyebrow__EDph9","storeMenuContentList":"StoreMenu_storeMenuContentList__TOsOe","storeMenuContentListItemLink":"StoreMenu_storeMenuContentListItemLink__PrPu9","storeMenuMobileClose":"StoreMenu_storeMenuMobileClose__fkkDM","storeMenuMobileBackText":"StoreMenu_storeMenuMobileBackText__92rcg","storeMenuMobileCloseIcon":"StoreMenu_storeMenuMobileCloseIcon__rpBM4","storeMenuHeadingCustom":"StoreMenu_storeMenuHeadingCustom__CSN6K","storeMenuSubheadingCustom":"StoreMenu_storeMenuSubheadingCustom__vRXml","storeMenuEyebrow":"StoreMenu_storeMenuEyebrow__b97io","storeMenuBackdrop":"StoreMenu_storeMenuBackdrop__n5bOR","dsm-typography-label-label-regular-m":"StoreMenu_dsm-typography-label-label-regular-m__BbhLx"};

/***/ }),

/***/ 47272:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"utilityBar":"UtilityBar_utilityBar__oWA6X","utilityBarContent":"UtilityBar_utilityBarContent__UsPN7","utilityBrands":"UtilityBar_utilityBrands__w4laL","utilityBrand":"UtilityBar_utilityBrand__5FwZg","utilityBrandActive":"UtilityBar_utilityBrandActive__QyWXD","menuPositionOverlay":"UtilityBar_menuPositionOverlay__JdNF2","utilityLinksWrapper":"UtilityBar_utilityLinksWrapper__KAj25"};

/***/ }),

/***/ 23243:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"utilityBarOverlayMobile":"UtilityBarMobile_utilityBarOverlayMobile__0xxeG","userCTAMobileWrapper":"UtilityBarMobile_userCTAMobileWrapper___mRjs","menuPositionWrapper":"UtilityBarMobile_menuPositionWrapper__4ovsX"};

/***/ }),

/***/ 54659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"utilityLinks":"UtilityLinks_utilityLinks__QoElK","divider":"UtilityLinks_divider__5L7Us","menuPositionWrapper":"UtilityLinks_menuPositionWrapper__uNaqm","userNameText":"UtilityLinks_userNameText__qZcZJ"};

/***/ }),

/***/ 2394:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"locationPickButtonContainer":"LocationPickButton_locationPickButtonContainer__cKlLo"};

/***/ }),

/***/ 23926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabNavigationHorizontalBg":"TabbedNavigationHorizontal_tabNavigationHorizontalBg__JhuBF","tabNavigationHorizontal":"TabbedNavigationHorizontal_tabNavigationHorizontal__TQG_y","tabNavigationHorizontalCenter":"TabbedNavigationHorizontal_tabNavigationHorizontalCenter__I5wpH","tabItem":"TabbedNavigationHorizontal_tabItem__5zpxB","active":"TabbedNavigationHorizontal_active__b7l2c","underline":"TabbedNavigationHorizontal_underline___zY0x","underlineNoTransition":"TabbedNavigationHorizontal_underlineNoTransition__f4_80","mobileOnlyArrow":"TabbedNavigationHorizontal_mobileOnlyArrow__WTbm3","TabbedNavigationHorizontal_mobileOnlyArrow__nV7i7":"TabbedNavigationHorizontal_TabbedNavigationHorizontal_mobileOnlyArrow__nV7i7__TwpmR","menuItemDivider":"TabbedNavigationHorizontal_menuItemDivider__4PrjB"};

/***/ }),

/***/ 62156:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authUtilityNavWrapper":"AuthUtilityNav_authUtilityNavWrapper__K8BC8"};

/***/ }),

/***/ 76610:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promoBannerWrapper":"v1_promoBannerWrapper__wP_GU"};

/***/ }),

/***/ 43457:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"findAStoreUtilNavWrapper":"v1_findAStoreUtilNavWrapper__EbIjf","findstore-util-nav__container":"v1_findstore-util-nav__container__uQEN8","findstore-util-nav__link-container":"v1_findstore-util-nav__link-container__rJ_dL"};

/***/ }),

/***/ 18476:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"helpSupportWrapper":"v1_helpSupportWrapper__ZxlFZ"};

/***/ }),

/***/ 65529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inPageSearchWrapper":"v1_inPageSearchWrapper__iTzIz"};

/***/ }),

/***/ 15803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productPerPageWrapper":"ProductsPerPage_productPerPageWrapper___0U26"};

/***/ }),

/***/ 12133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerNavV3Wrapper":"HeaderNavTabs_headerNavV3Wrapper__iEJ1d"};

/***/ }),

/***/ 59980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewsletterFooter_wrapper__UxaGs","gbh-footer-news-letter":"NewsletterFooter_gbh-footer-news-letter__zgOPB","form-group":"NewsletterFooter_form-group__b_jnx","form-control":"NewsletterFooter_form-control__7BiD_","btn":"NewsletterFooter_btn__njzYd","fadeInDown":"NewsletterFooter_fadeInDown__d9zoK"};

/***/ }),

/***/ 34147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"socialShareWrapper":"socialShare_socialShareWrapper__r_m5b"};

/***/ }),

/***/ 70209:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"curatedProduct":"ProductCardForUpsell_curatedProduct__nCbP5"};

/***/ }),

/***/ 36064:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"utilityWidgetsWrapper":"UtilityWidgets_utilityWidgetsWrapper__UNcYr"};

/***/ }),

/***/ 24707:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"additionalFooterWrapper":"Shared_additionalFooterWrapper__Dk6ah","mainFooterWrapper":"Shared_mainFooterWrapper___kAyp","utilityNavHeaderWrapper":"Shared_utilityNavHeaderWrapper__8gG45"};

/***/ }),

/***/ 87099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"autoSuggetionWrapper":"v1_autoSuggetionWrapper__lk1ed"};

/***/ }),

/***/ 63898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reCatichWrapper":"Recaptcha_reCatichWrapper__4F7Lw"};

/***/ }),

/***/ 49696:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productCardWrapper":"v1_productCardWrapper__Mtggq"};

/***/ }),

/***/ 14382:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productCardWrapper":"v3_productCardWrapper___9OHF"};

/***/ })

}]);